// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.
import { deModuleTips } from './de-extras.js';
export const de = {
    login: {
        title: '[[TOK_0]] ComplianceOne',
        subtitle: 'Melden Sie sich bei Ihrem Konto an',
        email: 'E-Mail',
        password: 'Passwort',
        sign_in: 'Anmelden',
        signing_in: 'Anmeldung läuft...',
        mfa_code: 'MFA-Code',
        mfa_placeholder: '6-stelligen Code eingeben',
        mfa_instruction: 'Geben Sie den 6-stelligen Code aus Ihrer Authentifizierungs-App ein.',
        verify: 'Bestätigen',
        verifying: 'Wird bestätigt...',
        forgot_password: 'Passwort vergessen?',
        account_locked: 'Das Konto ist gesperrt. Bitte versuchen Sie es später erneut.',
        account_deactivated: 'Das Konto wurde deaktiviert. Kontaktieren Sie Ihren Administrator.',
        invalid_mfa: 'Ungültiger MFA-Code. Bitte versuchen Sie es erneut.',
        invalid_credentials: 'Ungültige E-Mail oder ungültiges Passwort.',
        login_failed: 'Anmeldung fehlgeschlagen',
        session_expired: 'Ihre Sitzung ist abgelaufen. Bitte laden Sie die Seite neu und versuchen Sie es erneut.',
    },
    auth: {
        forgot_password: {
            title: 'Passwort vergessen',
            subtitle: 'Geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen einen Link zum Zurücksetzen Ihres Passworts.',
            send: 'Link zum Zurücksetzen senden',
            sending: 'Wird gesendet...',
            success: 'Falls diese E-Mail-Adresse existiert, wurde ein Link zum Zurücksetzen des Passworts gesendet.',
            back_to_login: 'Zurück zur Anmeldung',
        },
        reset_password: {
            title: 'Passwort zurücksetzen',
            subtitle: 'Geben Sie unten Ihr neues Passwort ein.',
            new_password: 'Neues Passwort',
            confirm_password: 'Passwort bestätigen',
            reset: 'Passwort zurücksetzen',
            resetting: 'Wird zurückgesetzt...',
            success: 'Ihr Passwort wurde erfolgreich zurückgesetzt.',
            go_to_login: 'Zur Anmeldung',
            password_mismatch: 'Die Passwörter stimmen nicht überein.',
            invalid_token: 'Ungültiger oder fehlender Zurücksetzungstoken. Bitte fordern Sie einen neuen Link zum Zurücksetzen des Passworts an.',
            requirements_title: 'Passwortanforderungen:',
            password_requirements: 'Das Passwort muss die folgenden Anforderungen erfüllen:',
            rules: {
                min_length: 'Mindestens 12 Zeichen',
                uppercase: 'Mindestens ein Großbuchstabe',
                lowercase: 'Mindestens ein Kleinbuchstabe',
                digit: 'Mindestens eine Ziffer',
                special: 'Mindestens ein Sonderzeichen',
            },
        },
        verify_email: {
            title: 'E-Mail-Verifizierung',
            verifying: 'Ihre E-Mail-Adresse wird verifiziert...',
            success: 'Ihre E-Mail-Adresse wurde erfolgreich verifiziert.',
            invalid_token: 'Ungültiger oder fehlender Verifizierungstoken.',
            failed: 'E-Mail-Verifizierung fehlgeschlagen. Der Token ist möglicherweise ungültig oder abgelaufen.',
            go_to_login: 'Zur Anmeldung',
        },
        offline: {
            title: 'Sie sind offline',
            message: 'Es scheint, als hätten Sie Ihre Internetverbindung verloren. Bitte überprüfen Sie Ihre Netzwerkverbindung und versuchen Sie es erneut.',
        },
    },
    intake: {
        title: 'Auskunftsersuchen',
        subtitle: 'Reichen Sie ein Auskunftsersuchen bei unserer Organisation ein',
        fields: {
            full_name: 'Vollständiger Name',
            email: 'E-Mail-Adresse',
            phone: 'Telefonnummer (optional)',
            request_type: 'Art des Ersuchens',
            description: 'Beschreiben Sie Ihr Ersuchen',
            preferred_language: 'Bevorzugte Sprache',
            consent: 'Ich willige in die Verarbeitung dieses Ersuchens ein',
        },
        submit: 'Ersuchen einreichen',
        validation: {
            name_required: 'Der vollständige Name ist erforderlich',
            email_required: 'Eine gültige E-Mail-Adresse ist erforderlich',
            type_required: 'Bitte wählen Sie eine Art des Ersuchens',
            description_required: 'Bitte beschreiben Sie Ihr Ersuchen',
            consent_required: 'Sie müssen der Verarbeitung zustimmen, um fortzufahren',
        },
        error_title: 'Fehler',
        config_load_error: 'Konfiguration konnte nicht geladen werden. Bitte überprüfen Sie die URL.',
        organization_label: 'Organisation',
        customer_reference: 'Kundenreferenznummer',
        country: 'Land / Rechtsgebiet',
        preferred_channel: 'Bevorzugter Antwortkanal',
        channels: {
            email: 'E-Mail',
            postal: 'Post',
            phone: 'Telefon',
            portal: 'Portalbereich',
        },
        confirmation: {
            title: 'Ersuchen eingegangen',
            message: 'Ihr Ersuchen wurde erfolgreich erfasst. Ihre Referenznummer lautet:',
            next_steps: 'Wir werden Ihr Ersuchen so schnell wie möglich gemäß den geltenden Gesetzen bearbeiten. Die voraussichtliche Bearbeitungszeit beträgt 30 Werktage.',
        },
    },
    request_types: {
        access: 'Auskunft (DSAR)',
        deletion: 'Löschung',
        correction: 'Berichtigung / Aktualisierung',
        objection: 'Widerspruch',
        portability: 'Datenübertragbarkeit',
        restriction: 'Einschränkung der Verarbeitung',
        consent_withdrawal: 'Widerruf der Einwilligung',
    },
    statuses: {
        new: 'Neu',
        in_review: 'In Prüfung',
        waiting_on_requester: 'Warten auf Antragsteller',
        waiting_on_internal_data: 'Warten auf interne Daten',
        approved: 'Genehmigt',
        closed: 'Geschlossen',
        rejected: 'Abgelehnt',
    },
    admin: {
        nav: {
            rights_requests: 'Auskunftsersuchen',
            templates: 'Vorlagen',
            response_templates: 'Antwortvorlagen',
            data_mapping: 'Datenverzeichnis',
            governance: 'Steuerung',
            consent: 'Einwilligung',
            assessments: 'Bewertungen',
            classification: 'Klassifizierung',
            monitoring: 'Überwachung',
            incidents: 'Vorfälle',
            onboarding: 'Einführung',
            connectors: 'Konnektoren',
            vendor_risk: 'Dienstleisterrisiko',
            deletion_orchestration: 'Löschorchestrierung',
            discovery: 'Datenerkennung',
            incident_ops: 'Vorfallmanagement',
            program_governance: 'Programmsteuerung',
            access_accountability: 'Zugriffskontrolle',
            consent_properties: 'Einwilligungseigenschaften',
            localization: 'Lokalisierung',
            partner_workspace: 'Partner-Arbeitsbereich',
            audit_trail: 'Prüfpfad',
            forseti: 'Forseti',
            settings: 'Einstellungen',
            help_center: 'Hilfezentrum',
            dashboard: 'Übersicht',
            platform: 'Plattform',
            integrations: 'Integrationen',
            cmp_dsar_sync: 'CMP-DSAR-Synchronisierung',
            cmp_integration: 'CMP-Integration',
            purpose_mapping: 'Zweckzuordnung',
            webhook_config: 'Webhook-Konfiguration',
            bulk_sync: 'Massenabgleich',
            privacy_scanner: 'Datenschutz-Scanner',
            privacy_monitoring: 'Datenschutzüberwachung',
            real_time_scanner: 'Echtzeit-Scanner',
            compliance_forms: 'Compliance-Formulare',
            forms_dashboard: 'Formularübersicht',
            form_templates: 'Vorlagen',
            form_catalog: 'Formularkatalog',
            pack_catalog: 'Paketkatalog',
            org_groups: 'Organisationsgruppen',
            consolidation: 'Konsolidierung',
            organizations: 'Organisationen',
            org_list: 'Alle Organisationen',
            intake_configs: 'Eingangskonfigurationen',
            task_management: 'Aufgabenverwaltung',
            unified_audit: 'Gesamtprüfung',
            evidence_packs: 'Nachweispakete',
            audit_periods: 'Prüfungszeiträume',
            regulatory_updates: 'Regulatorische Aktualisierungen',
            departments: 'Abteilungen',
        },
        sidebar_category_data_privacy_rights: 'Datenschutz & Rechte',
        sidebar_category_vendor_third_party: 'Lieferanten- & Drittanbieter-Management',
        sidebar_category_risk_assessment: 'Risiko & Bewertung',
        sidebar_category_operations_automation: 'Betrieb & Automatisierung',
        sidebar_category_task_workflow: 'Aufgaben- & Workflow-Management',
        sidebar_groups: {
            consent_cmp_webhooks: '[[TOK_0]] & Webhooks',
            data_mapping_ropa: 'Verarbeitungsverzeichnis',
            data_mapping_classification: 'Klassifizierung',
            data_mapping_governance: 'Regierungsführung',
            access_live_monitoring: 'Echtzeit-Überwachung',
            access_reviews_investigations: 'Prüfungen & Untersuchungen',
            access_evidence_policies: 'Nachweise & Richtlinien',
            classification_taxonomies: 'Taxonomien & Labels',
            classification_workflow: 'Arbeitsablauf',
            classification_insights: 'Auswertungen',
            connectors_runtime: 'Laufzeit',
            connectors_due_diligence: 'Sorgfaltsprüfung',
            connectors_coverage: 'Abdeckung',
            cp_definitions: 'Definitionen',
            cp_lifecycle: 'Lebenszyklus',
            cp_quality: 'Qualität & Nachweise',
            deletion_execution: 'Ausführung',
            deletion_vendors: 'Dienstleister',
            deletion_evidence: 'Nachweise & Integration',
            discovery_rules: 'Regeln & Vorlagen',
            discovery_scanning: 'Scannen',
            discovery_review: 'Prüf-Workflow',
            discovery_insights: 'Auswertungen',
            governance_oversight: 'Aufsicht',
            governance_reporting: 'Berichtswesen',
            governance_vendors: 'Dienstleister & Drittlandtransfers',
            governance_lifecycle: 'Lebenszyklus',
            incident_ops_dashboards: 'Dashboards',
            incident_ops_sla: 'SLA-Konfiguration',
            incident_ops_playbooks: 'Spielbücher',
            incident_ops_vendor_regulator: 'Dienstleister & Aufsichtsbehörde',
            incident_ops_evidence: 'Nachweise & Prüfung',
            incidents_workload: 'Arbeitslast',
            incidents_regulatory: 'Regulatorisch',
            incidents_reporting: 'Berichtswesen',
            localization_content: 'Inhalte',
            localization_regulatory: 'Regulatorisch',
            localization_observability: 'Beobachtbarkeit',
            monitoring_metrics: 'Kennzahlen',
            monitoring_programs: 'Programme',
            monitoring_tasks: 'Aufgaben',
            monitoring_controls: 'Kontrollen',
            org_entities: 'Entitäten',
            org_config: 'Konfiguration',
            org_frameworks: 'Rahmenwerke & Rollup',
            partner_overview: 'Übersicht',
            partner_partners: 'Partner',
            partner_delivery: 'Lieferung',
            partner_support: 'Unterstützung',
            platform_identity: 'Identität & Rollen',
            platform_access_control: 'Zugriffssteuerung',
            platform_auth_session: 'Authentifizierung & Sitzung',
            platform_access_reviews: 'Zugriffsprüfungen',
            platform_files: 'Dateien',
            platform_notifications: 'Benachrichtigungen',
            platform_module_config: 'Modulkonfiguration',
            platform_ops: 'Betrieb & Logs',
            pg_health: 'Programmzustand',
            pg_maturity: 'Reifegrad',
            pg_audit: 'Audit & Nachweise',
            pg_obligations: 'Pflichten',
            pg_documents: 'Dokumente',
            vr_overview: 'Übersicht',
            vr_onboarding: 'Onboarding',
            vr_assessment: 'Bewertung',
            vr_oversight: 'Aufsicht',
        },
        tickets: {
            title: 'Auskunftsersuchen',
            create: 'Ersuchen erstellen',
            filters: 'Filtern',
            search_placeholder: 'Search tickets...',
            export_csv: 'Exportieren [[TOK_0]]',
            exporting: 'Exportieren...',
            bulk_export_failed: 'Der Massenexport ist fehlgeschlagen',
            bulk_export: {
                label: 'Exportieren',
                format: {
                    pdf: '[[TOK_0]] Zusammenfassung',
                    zip: 'ZIP (Beweispakete pro Fall)',
                    csv: '[[TOK_0]]',
                },
                warning_over_50: 'Dadurch werden etwa [[TOK_1]] Kartonpackungen generiert – dies kann mehrere Minuten dauern. Weitermachen?',
                blocked_over_500: 'Schränken Sie den Filter auf 500 oder weniger Fälle ein, bevor Sie ZIP exportieren (aktuell: [[TOK_1]]).',
                success: 'Massenexport im Dateibrowser gespeichert ([[TOK_1]] Fälle)',
                failed: 'Der Massenexport ist fehlgeschlagen',
                continue: 'Weiter',
                cancel: 'Abbrechen',
            },
            no_results: 'Keine Ersuchen gefunden',
            ticket_id: 'Ticket-ID',
            request_type: 'Antragsart',
            requester: 'Antragsteller',
            source: 'Quelle',
            all_sources: 'Alle Quellen',
            assigned_to: 'Zugewiesen an',
            created: 'Erstellt',
            load_error: 'Fehler beim Laden der Fälle. Bitte versuchen Sie es erneut.',
            case_creation_failed: 'Fallerstellung fehlgeschlagen',
            business_unit: 'Geschäftseinheit',
            reference: 'Referenz',
            sla: {
                title: 'SLA-Status',
                on_track: '{days} Tage verbleibend',
                approaching: 'Frist nähert sich',
                overdue: '{days} Tage überfällig',
                ack_overdue: '{hours}h über Bestätigungsfrist',
                ack_warning: 'Bestätigung bald fällig',
                closed: 'Geschlossen',
                completed_in: 'Abgeschlossen in {days} Tagen',
            },
        },
        templates: {
            title: 'Antwortvorlagen',
            new: 'Neue Vorlage',
            edit: 'Vorlage bearbeiten',
            all_types: 'Alle Typen',
            all_locales: 'Alle Sprachen',
            type_access: 'Auskunft/DSAR',
            type_deletion: 'Löschung',
            type_correction: 'Berichtigung',
            type_objection: 'Widerspruch',
            type_portability: 'Datenübertragbarkeit',
            type_other: 'Sonstiges',
            type_restriction: 'Einschränkung',
            type_all: 'Alle',
            locale_en: 'Englisch',
            locale_vi: 'Vietnamesisch',
            locale_all: 'Beide',
            name: 'Bezeichnung',
            request_type: 'Antragsart',
            locale: 'Sprache',
            subject: 'Betreff',
            body: 'Text',
            name_placeholder: 'Vorlagenname...',
            subject_placeholder: 'E-Mail-/Briefbetreff...',
            body_placeholder: 'Vorlagentext. Verwenden Sie {{requester_name}}, {{ticket_id}}, {{request_type}}, {{org_name}}, {{response_date}} als Platzhalter.',
            available_placeholders: 'Verfügbare Platzhalter:',
            create_template: 'Vorlage erstellen',
            preview: 'Vorschau',
            close_preview: 'Vorschau schließen',
            default_badge: 'Standard',
            no_templates: 'Keine Vorlagen gefunden',
            confirm_delete: 'Diese Vorlage löschen?',
            load_error: 'Fehler beim Laden der Vorlagen. Bitte versuchen Sie es erneut.',
            create_error: 'Fehler beim Erstellen der Vorlage',
            update_error: 'Fehler beim Aktualisieren der Vorlage',
            delete_error: 'Fehler beim Löschen der Vorlage',
            preview_error: 'Fehler bei der Vorschau der Vorlage',
            response_templates_badge: 'Antwortvorlagen',
            browse_form_templates: 'Compliance-Formularvorlagen durchsuchen',
            templates_loaded: 'Vorlagen geladen',
            sample_organization: 'Beispielorganisation',
        },
        detail: {
            requester_info: 'Antragstellerinformationen',
            status: 'Zustand',
            assignment: 'Zuweisung',
            notes: 'Notizen',
            audit_trail: 'Prüfpfad',
            add_note: 'Notiz hinzufügen',
            case_not_found: 'Fall nicht gefunden',
            load_error: 'Fehler beim Laden des Falls. Bitte versuchen Sie es erneut.',
            note_error: 'Fehler beim Hinzufügen der Notiz. Bitte versuchen Sie es erneut.',
            submitted_from: 'Eingereicht von',
            via_cmp: 'über AesirX CMP',
            cmp_ticket: 'CMP-Ticket:',
            select_template: 'Vorlage auswählen',
            direction_inbound: '[[TOK_0]] → GRC',
            direction_outbound: 'GRC → [[TOK_0]]',
            tabs: {
                details: 'Einzelheiten',
                evidence: 'Nachweise',
                communications: 'Kommunikation',
                escalations: 'Eskalationen',
                audit_trail: 'Prüfpfad',
                fulfillment: 'Erfüllung',
                response: 'Antwort',
                extension: 'Verlängerung',
            },
            requester: {
                name: 'Bezeichnung',
                email: 'E-Mail',
                phone: 'Telefon',
                language: 'Sprache',
                source: 'Quelle',
                customer_ref: 'Kundenreferenz',
                country: 'Land',
                preferred_channel: 'Bevorzugter Kanal',
            },
            sla: {
                title: 'SLA',
                on_track: 'Im Plan',
                due_soon: 'Bald fällig',
                overdue: 'Überfällig',
                days_remaining: 'Tage verbleibend',
                due_date: 'Fälligkeitsdatum',
                breached: 'Verletzt',
                paused: 'Pausiert',
                total_paused_days: 'Pausierte Tage gesamt',
                days_elapsed: 'Verstrichene Tage',
                progress: 'Fortschritt',
            },
            identity: {
                title: 'Identitätsprüfung',
                verified: 'Verifiziert',
                not_verified: 'Nicht verifiziert',
                method: 'Methode',
                notes: 'Notizen',
                verified_by: 'Verifiziert von',
                verified_at: 'Verifiziert am',
                warning: 'Identität noch nicht verifiziert.',
                verify_button: 'Identität verifizieren',
                select_method: '-- Auswählen --',
                methods: {
                    email_confirmation: 'E-Mail-Bestätigung',
                    id_document: 'Ausweisdokument',
                    phone_call: 'Telefonanruf',
                    in_person: 'Persönlich',
                    other: 'Sonstiges',
                },
            },
            closure: {
                reason: 'Abschlussgrund',
                summary: 'Abschlusszusammenfassung',
                summary_placeholder: 'Zusammenfassung der Bearbeitung des Ersuchens...',
                reason_required: 'Abschlusszusammenfassung und Grund sind erforderlich',
                response_not_sent: 'Eine formelle Antwort muss an die betroffene Person gesendet werden, bevor der Fall geschlossen werden kann',
                reasons: {
                    fulfilled: 'Erfüllt',
                    partially_fulfilled: 'Teilweise erfüllt',
                    unfounded: 'Unbegründet',
                    excessive: 'Übermäßig',
                    withdrawn: 'Zurückgezogen',
                    duplicate: 'Duplikat',
                    identity_unverified: 'Identität nicht verifiziert',
                },
            },
            export_title: 'Exportieren',
            export_pdf: 'PDF exportieren',
            export_zip: 'ZIP exportieren',
            case_file_pdf: 'Exportieren [[TOK_0]] (Falldatei)',
            evidence_pack_zip: 'ZIP exportieren (Beweispaket)',
            cross_border_warning: 'Grenzüberschreitende Übertragung festgestellt – grenzüberschreitendes Dossier erforderlich',
            breach: {
                flag_btn: 'Als verletzungsverursachend kennzeichnen',
                modal: {
                    title: 'Kennzeichnen Sie den Fall als verletzungsverursachend',
                    type_label: 'Art des Verstoßes',
                    type: {
                        misdirected_response: 'Fehlgeleitete Antwort',
                        unauthorised_disclosure: 'Unbefugte Offenlegung',
                        identity_mismatch: 'Identitätskonflikt',
                        other: 'Andere',
                    },
                    description: 'Beschreibung (optional)',
                    description_placeholder: 'Was ist passiert? (maximal 1000 Zeichen)',
                    confirm: 'Markieren Sie und starten Sie die 72-Stunden-Ablageuhr',
                    cancel: 'Abbrechen',
                    flagging: 'Melden...',
                },
                banner: {
                    title: 'Verstoß gemeldet: [[TOK_1]]',
                    detected_at: 'Erkannt am [[TOK_1]]',
                    filing_deadline: '72h [[TOK_2]] Einreichungsfrist: in [[TOK_1]] Stunden',
                    overdue: '72 Stunden [[TOK_0]] Einreichungsfrist: ÜBERFÄLLIG',
                },
                toasts: {
                    flagged: 'Fall wurde als verletzungsverursachend gekennzeichnet – 72-Stunden-Uhr gestartet',
                    flag_failed: 'Der Fall konnte nicht als verletzungsverursachend gekennzeichnet werden',
                },
            },
            export: {
                generating: 'Generiert... bitte warten',
                success: 'Im Dateibrowser gespeicherter Export',
                failed: 'Der Export ist fehlgeschlagen. Überprüfen Sie das Audit-Protokoll',
            },
            no_notes: 'Noch keine Notizen',
            assign_placeholder: 'Benutzer-ID zur Zuweisung...',
            reassign: 'Neu zuweisen',
            evidence: {
                checklist_title: 'Nachweis-Checkliste',
                complete_pct: '% abgeschlossen',
                no_checklist: 'Keine Checklisten-Elemente',
                attachments: 'Anhänge',
                upload_attachment: 'Anhang hochladen',
                upload_button: 'Hochladen',
                uploading: 'Wird hochgeladen...',
                attachment_uploaded: 'Anhang erfolgreich hochgeladen',
                upload_error: 'Hochladen fehlgeschlagen',
                category: 'Kategorie',
                categories: {
                    identity_proof: 'Identitätsnachweis',
                    correspondence: 'Korrespondenz',
                    internal_data: 'Interne Daten',
                    legal: 'Rechtlich',
                    other: 'Sonstige',
                },
                no_attachments: 'Keine Anhänge',
                references_title: 'Nachweisreferenzen',
                no_references: 'Keine Referenzen',
                add_reference: 'Referenz hinzufügen',
                ref_type: 'Typ',
                ref_value: 'Wert',
                ref_desc: 'Beschreibung',
                ref_value_placeholder: 'URL, E-Mail-ID oder Referenz...',
                ref_desc_placeholder: 'Beschreibung...',
                ref_types: {
                    url: 'URL',
                    email_id: 'E-Mail-ID',
                    crm_record: 'CRM-Datensatz',
                    ticket_ref: 'Ticket-Referenz',
                    other: 'Sonstiges',
                },
            },
            communications: {
                title: 'Kommunikation',
                add: 'Nachricht hinzufügen',
                no_records: 'Keine Kommunikation erfasst',
                direction: 'Richtung',
                channel: 'Kanal',
                visibility: 'Sichtbarkeit',
                subject: 'Betreff',
                body: 'Text',
                send: 'Senden',
                inbound: 'Eingehend',
                outbound: 'Ausgehend',
                internal: 'Intern',
                external: 'Extern',
                tab_all: 'All',
                tab_internal: 'Intern',
                tab_external: 'Extern',
                subject_placeholder: 'Betreff (optional)',
                body_placeholder: 'Nachrichtentext...',
                channels: {
                    email: 'E-Mail',
                    portal: 'Portalbereich',
                    phone: 'Telefon',
                    postal: 'Post',
                    in_person: 'Persönlich',
                },
                apply_template: 'Vorlage Anwenden',
                select_template: 'Vorlage auswählen...',
                no_templates: 'Keine Vorlagen verfügbar',
                template_applied: 'Vorlage auf Antwort angewendet.',
                template_apply_error: 'Vorlage konnte nicht angewendet werden.',
            },
            escalations: {
                title: 'Eskalationsverlauf',
                no_events: 'Keine Eskalationsereignisse',
                tier: 'Stufe',
                threshold: 'Schwellenwert',
                action: 'Aktion',
                target: 'Ziel',
                triggered_at: 'Ausgelöst am',
            },
            cmp_sync: {
                title: 'AesirX CMP-Synchronisierung',
                sync_status: 'Synchronisierungsstatus',
                last_synced: 'Zuletzt synchronisiert',
                not_synced: 'Nicht synchronisiert',
                resync: 'Jetzt synchronisieren',
                syncing: 'Synchronisierung...',
                sync_history: 'Synchronisierungsverlauf (Letzte 10)',
                direction: 'Richtung',
                time: 'Zeit',
                retries: 'Wiederholungen',
                error_col: 'Fehler',
            },
            audit: {
                filter_event_placeholder: 'Nach Ereignistyp filtern...',
                filter_actor_placeholder: 'Nach Akteur filtern...',
            },
            fulfillment: {
                title: 'Abteilungserfüllung',
                assign_departments: 'Abteilungen zuweisen',
                department: 'Abteilung',
                assignee: 'Zugewiesene Person',
                deadline: 'Frist',
                evidence_count: 'Nachweise',
                signoff: 'Abzeichnung',
                signed_off: 'Abgezeichnet',
                pending_signoff: 'Ausstehend',
                start_button: 'Starten',
                complete_button: 'Als erledigt markieren',
                signoff_button: 'Abmelden',
                no_tasks: 'Noch keine Erfüllungsaufgaben zugewiesen.',
                tasks_table: 'Erfüllungsaufgaben',
                progress_label: 'Erfüllungsfortschritt',
                overdue: 'überfällig',
                assigned_success: 'Abteilungserfüllungsaufgabe erfolgreich zugewiesen.',
                assign_error: 'Erfüllungsaufgabe konnte nicht zugewiesen werden.',
                signoff_success: 'Abteilungsabzeichnung erfasst.',
                signoff_error: 'Abzeichnung konnte nicht erfasst werden.',
                identity_required: 'Identity verification required before fulfillment actions.',
                remove_task: 'Remove Task',
                remove_success: 'Fulfillment task removed successfully.',
                add_evidence_btn: 'Beweise hinzufügen',
                evidence_uploaded: 'Beweise hochgeladen und verknüpft',
                evidence_upload_error: 'Hochladen fehlgeschlagen',
                suggest_data_stores: 'Datenspeicher vorschlagen',
                suggest_error: 'Datenspeichervorschläge konnten nicht geladen werden.',
                suggest_stores_title: 'Empfohlene Datenspeicher',
                suggest_stores_none: 'Für diesen Fall gibt es keinen Datenspeicher. Konfigurieren Sie Systeme in Data Mapping, um Vorschläge zu verbessern.',
                suggest_stores_add: 'Zum Fall hinzufügen',
                suggest_stores_added: 'Datenspeicher zum Fall hinzugefügt',
                no_departments_title: 'Keine Abteilungen konfiguriert',
                no_departments_body: 'Mit Abteilungen können Sie DSR-Erfüllungsaufgaben an eine Funktion weiterleiten (Datenschutz, Recht, Personalwesen, IT-Betrieb). Installieren Sie Beispielabteilungen oder bitten Sie Ihren Administrator, Abteilungen in den Organisationseinstellungen zu konfigurieren.',
                no_departments_cta: 'Beispieldaten installieren',
                department_placeholder: 'Abteilungsname...',
                assignee_placeholder: 'Benutzer-ID zum Zuweisen...',
                assign_button: 'Zuweisen',
                status_pending: 'Ausstehend',
                status_in_progress: 'In Bearbeitung',
                status_completed: 'Abgeschlossen',
                status_verified: 'Überprüft',
                confirm_approve: 'Möchten Sie diese Verlängerung wirklich genehmigen?',
                confirm_deny: 'Möchten Sie diese Verlängerung wirklich ablehnen?',
            },
            response: {
                title: 'Antwortgenerierung',
                select_template: 'Antwortvorlage',
                choose_template: 'Vorlage auswählen...',
                generate: 'Antwort generieren',
                preview: 'Antwortvorschau',
                send: 'Antwort senden',
                delivery_method: {
                    label: 'Zustellmethode',
                    email: 'E-Mail',
                    portal: 'Portal',
                    postal: 'Post',
                    in_person: 'Persönlich',
                },
                recipient: {
                    email: 'Empfänger-E-Mail',
                    portal: 'Portalbenutzer-ID',
                    address: 'Postanschrift',
                },
                auto_generate_btn: 'Antwort generieren und senden',
                auto_generate_success: 'Antwort generiert und übermittelt',
                auto_generate_missing_recipient: 'Bitte geben Sie vor dem Absenden einen Empfänger an.',
                auto_fields: 'Automatisch ausgefüllte Felder',
                case_id: 'Fall-ID',
                requester_name: 'Name des Antragstellers',
                rights_type: 'Rechtstyp',
                history: 'Gesendete Antworten',
                generated_at: 'Generiert',
                confirmation: 'Bestätigung',
                sent_label: 'Gesendet',
                draft_label: 'Entwurf',
                generated_success: 'Antwort erfolgreich generiert.',
                generate_error: 'Antwort konnte nicht generiert werden.',
                sent_success: 'Antwort erfolgreich gesendet.',
                send_error: 'Antwort konnte nicht gesendet werden.',
                load_error: 'Antwortvorlagen konnten nicht geladen werden.',
                pdf_title: 'Antwortschreiben an betroffene Person',
                download_pdf: 'PDF herunterladen',
                download_all: 'Alle herunterladen',
                download_error: 'Antwort konnte nicht heruntergeladen werden',
            },
            extension: {
                title: 'Fristverlängerungen',
                acknowledgment_deadline: 'Bestätigungsfrist',
                fulfillment_deadline: 'Erfüllungsfrist',
                request_extension: 'Verlängerung beantragen',
                reason: 'Begründung',
                reason_placeholder: 'Begründung für die Beantragung zusätzlicher Zeit...',
                additional_days: 'Zusätzliche Tage',
                submit_request: 'Verlängerungsantrag einreichen',
                history: 'Verlängerungshistorie',
                requested_at: 'Beantragt',
                approve: 'Genehmigen',
                deny: 'Ablehnen',
                request_success: 'Verlängerungsantrag eingereicht.',
                request_error: 'Verlängerungsantrag konnte nicht eingereicht werden.',
                approved_success: 'Verlängerung genehmigt.',
                denied_success: 'Verlängerung abgelehnt.',
                decision_error: 'Verlängerungsentscheidung konnte nicht verarbeitet werden.',
                status_pending: 'Ausstehend',
                status_approved: 'Genehmigt',
                status_denied: 'Abgelehnt',
                confirm_approve: 'Möchten Sie diese Verlängerungsanfrage wirklich genehmigen?',
                confirm_deny: 'Möchten Sie diese Verlängerungsanfrage wirklich ablehnen?',
                decided_by: 'Entschieden von',
            },
        },
        audit: {
            export_csv: 'CSV exportieren',
            exporting: 'Wird exportiert...',
            search_placeholder: 'Prüfdetails durchsuchen...',
            filter_by_actor: 'Nach Akteur filtern...',
            all_event_types: 'Alle Ereignistypen',
            seq: '#',
            timestamp: 'Zeitstempel',
            event: 'Ereignis',
            case_col: 'Fall',
            actor: 'Akteur',
            summary: 'Zusammenfassung',
            no_events: 'Keine Prüfereignisse gefunden',
            export_success: 'Audit-Trail erfolgreich exportiert.',
            export_error: 'Fehler beim CSV-Export',
            load_error: 'Fehler beim Laden des Prüfpfads. Bitte versuchen Sie es erneut.',
            announce_loaded: 'Prüfpfad geladen',
            start_date: 'Startdatum',
            end_date: 'Enddatum',
            per_page: '{count} / Seite',
            unknown: 'Unbekannt',
            source_filter: {
                label: 'Quelle',
                all: 'Alle',
                module: 'Modul',
                forseti: 'Forseti',
                aria_label: 'Audit-Ereignisse nach Quelle filtern',
            },
            event_types: {
                case_created: 'Fall erstellt',
                status_changed: 'Status geändert',
                case_assigned: 'Fall zugewiesen',
                note_added: 'Notiz hinzugefügt',
                attachment_added: 'Anhang hinzugefügt',
                attachment_deleted: 'Anhang gelöscht',
                reference_added: 'Referenz hinzugefügt',
                checklist_updated: 'Checkliste aktualisiert',
                identity_verified: 'Identität verifiziert',
                closure_summary_added: 'Abschlusszusammenfassung',
                approval_granted: 'Genehmigung erteilt',
                template_applied: 'Vorlage angewendet',
                export_generated: 'Export erstellt',
                sla_warning: 'SLA-Warnung',
                sla_overdue: 'SLA überfällig',
            },
            unified_audit: {
                title: 'Gesamtprüfprotokoll',
                module_filter: 'Modul',
                framework_filter: 'Rahmenwerk',
                select_framework: 'Rahmenwerk auswählen...',
                entity_type_filter: 'Entitätstyp',
                action_filter: 'Aktion',
                actor_filter: 'Akteur',
                select_actor: 'Akteur auswählen...',
                search_filter: 'Suche',
                search_placeholder: 'Audit-Ereignisse durchsuchen...',
                filters_heading: 'Filter',
                date_range: 'Zeitraum',
                no_events_found: 'Keine Prüfereignisse gefunden.',
                event_count: 'Anzahl Ereignisse',
                action: 'Aktion',
                actor: 'Akteur',
                date_range_start: 'Anfang des Datumsbereichs',
                date_range_end: 'Ende des Datumsbereichs',
                filtering_events: 'Audit-Ereignisse werden gefiltert',
                framework_codes: 'Rahmenwerk-Codes',
                entity_type_col: 'Entitätstyp',
                aria_table: 'Vereinheitlichte Audit-Ereignisse',
                page_of: 'Seite {page} von {total}',
                entity_types: {
                    user: 'Benutzer',
                    case: 'Fall',
                    incident: 'Vorfall',
                    assessment: 'Bewertung',
                    vendor: 'Anbieter',
                    consent: 'Zustimmung',
                    policy: 'Politik',
                    data_map: 'Datenkarte',
                },
                actions: {
                    create: 'Erstellen',
                    update: 'Aktualisieren',
                    delete: 'Löschen',
                    view: 'Ansicht',
                    export: 'Exportieren',
                    status_change: 'Statusänderung',
                },
            },
            evidence_packs: {
                title: 'Prüfungsnachweispakete',
                assemble_pack: 'Nachweispaket zusammenstellen',
                framework: 'Rahmenwerk',
                select_framework: 'Rahmenwerk auswählen...',
                framework_code_label: 'Framework-Code',
                entity_types: 'Entitätstypen',
                select_entity_types: 'Entitätstypen auswählen...',
                period: 'Zeitraum',
                period_start: 'Beginn des Zeitraums',
                period_end: 'Ende des Zeitraums',
                completeness: 'Vollständigkeit',
                no_packs_found: 'Keine Nachweispakete gefunden.',
                verify: 'Überprüfen',
                export_pack: 'Exportieren',
                exporting: 'Wird exportiert...',
                pack_assembled: 'Beweispaket zusammengestellt',
                pack_exported: 'Beweispaket exportiert',
                aria_table: 'Audit-Bewispakete',
                aria_export_pack: 'Paket exportieren',
                export_format: 'Exportformat',
                export_in_progress: 'Export wird durchgeführt...',
                status_draft: 'Entwurf',
                status_assembled: 'Zusammengestellt',
                status_verified: 'Überprüft',
                status_submitted: 'Eingereicht',
                entity_type_labels: {
                    user: 'Benutzer',
                    case: 'Fall',
                    incident: 'Vorfall',
                    assessment: 'Bewertung',
                    vendor: 'Anbieter',
                    consent: 'Zustimmung',
                    policy: 'Politik',
                    data_map: 'Datenkarte',
                },
                template_id: 'Vorlagen-ID',
                csv_headers: {
                    module: 'Modul',
                    action: 'Aktion',
                    actor_id: 'Schauspieler',
                    entity_type: 'Entitätstyp',
                    entity_id: 'Entitäts-ID',
                    summary: 'Zusammenfassung',
                    timestamp: 'Zeitstempel',
                    framework_code: 'Rahmen',
                },
                export_header_framework: 'Evidenzpaket — Rahmenwerk: {framework}',
                export_header_period: 'Zeitraum: {start} bis {end}',
                export_header_completeness: 'Vollständigkeit: {score}%',
                export_header_status: 'Status: [[TOK_1]]',
            },
            audit_periods: {
                title: 'Prüfungszeiträume',
                create_period: 'Prüfungszeitraum erstellen',
                framework_code_label: 'Framework-Code',
                select_framework: 'Rahmenwerk auswählen...',
                period_label: 'Zeitraumbezeichnung',
                period_start: 'Beginn des Zeitraums',
                period_end: 'Ende des Zeitraums',
                start: 'Starten',
                end: 'Ende',
                framework: 'Rahmen',
                retention_days: 'Aufbewahrungstage',
                no_periods_found: 'Keine Prüfungszeiträume gefunden.',
                period_created: 'Audit-Zeitraum erstellt',
                aria_table: 'Audit-Zeiträume',
                suggested_boundaries: 'Vorgeschlagene Grenzen',
                suggested_boundaries_info: 'Vorgeschlagene Periodengrenzen werden aus dem regulatorischen Berichtszyklus jedes Rahmenwerks abgeleitet. Passen Sie diese nach Bedarf für Ihre Organisation an.',
                reporting_cycle: 'Berichtszyklus',
                suggested_start: 'Vorgeschlagener Beginn',
                suggested_end: 'Vorgeschlagenes Ende',
                suggested_next: 'Empfohlene nächste Periode',
                cycle_monthly: 'Monatlich',
                cycle_quarterly: 'Vierteljährlich',
                cycle_semi_annual: 'Halbjährlich',
                cycle_annual: 'Jährlich',
                cycle_custom: 'Benutzerdefiniert',
                period_deleted: 'Prüfzeitraum gelöscht',
            },
        },
        create_case: {
            customer_ref: 'Kundenreferenz',
            country: 'Land / Rechtsordnung',
            preferred_channel: 'Bevorzugter Kanal',
            channels: {
                email: 'E-Mail',
                postal: 'Post',
                phone: 'Telefon',
                portal: 'Portalbereich',
            },
            source: 'Quelle',
            sources: {
                admin_manual: 'Admin-Handbuch',
                public_form: 'Öffentliche Form',
                cmp_gateway: '[[TOK_0]] Gateway',
                aesirx_cmp: '[[TOK_1]] [[TOK_0]]',
                phone_received: 'Telefon erhalten',
                postal_received: 'Posteingang erhalten',
                email_received: 'E-Mail erhalten',
                in_person: 'Persönlich',
                legacy_import: 'Legacy-Import',
            },
            required_fields: 'Antragsart, Name und E-Mail sind erforderlich',
            create_error: 'Fehler beim Erstellen des Falls',
        },
        settings: {
            title: 'Einstellungen',
            request_types: 'Antragsarten',
            request_types_desc: 'Konfigurieren Sie, welche Antragsarten für das öffentliche Eingangsformular aktiviert sind.',
            notifications: 'Benachrichtigungen',
            ticket_numbering: 'Ticket-Nummerierung',
            ticket_format: 'Aktuelles Format',
            ticket_prefix: 'Präfix',
            ticket_prefix_note: 'nicht konfigurierbar in Sprint 1.0.0',
            sla_deadlines: 'SLA-Fristen',
            sla_desc: 'Legen Sie die maximale Antwortzeit (in Kalendertagen) für jede Antragsart fest. Fälle, die sich dem Schwellenwert nähern, werden mit Warnungen angezeigt.',
            days: 'Tage',
            warning_threshold: 'Warnschwelle',
            escalation_label: 'Automatische Eskalation bei SLA-Verletzung aktivieren',
            save_sla: 'SLA-Konfiguration speichern',
            saving: 'Speichern...',
            saved: 'Erfolgreich gespeichert',
            announce_loaded: 'Einstellungen geladen',
            email_on_creation: 'E-Mail-Benachrichtigung bei Ticket-Erstellung',
            send_confirmation: 'Bestätigungs-E-Mail an Antragsteller senden',
            users: 'Benutzer',
            roles: 'Rollen',
            api_keys: '[[TOK_0]] Schlüssel',
            mfa: 'MFA',
            sessions: 'Sitzungen',
            webhooks: 'Webhooks',
            modules: 'Module',
            deadline_labels: {
                access: 'Auskunft (DSAR)',
                deletion: 'Löschung',
                correction: 'Berichtigung',
                portability: 'Datenübertragbarkeit',
                objection: 'Widerspruch',
                restriction: 'Einschränkung',
                consent_withdrawal: 'Widerruf der Einwilligung',
            },
        },
        section_assignments: {
            title: 'Abschnittszuweisungen',
            assign_section: 'Abschnitt zuweisen',
            section_ref: 'Abschnittsreferenz',
            section_label: 'Abschnittsbezeichnung',
            department_id: 'Abteilung',
            assignee_id: 'Zugewiesene Person',
            mandatory: 'Pflichtfeld',
            assign: 'Zuweisen',
            no_assignments: 'Keine Abschnittszuweisungen',
            status: 'Status',
            completion: 'Fertigstellung',
            mark_complete: 'Abschließen',
        },
        consolidation: {
            title: 'Konsolidierungsfortschritt',
            add_child: 'Unteraufgabe hinzufügen',
            child_task_id: 'Unteraufgaben-ID',
            department_id: 'Abteilung',
            link: 'Verknüpfung',
            overall_completion: 'Gesamtfertigstellung',
            departments_complete: 'Abgeschlossene Abteilungen',
            overdue: 'Überfällig',
            ready: 'Bereit',
            not_ready: 'Nicht bereit',
            master_status: 'Gesamtstatus',
            department_breakdown: 'Abteilungsübersicht',
            department: 'Abteilung',
            status: 'Status',
            completion: 'Fertigstellung',
            due_date: 'Fälligkeitsdatum',
            overdue_flag: 'Überfällig',
            child_tasks: 'Unteraufgaben',
            task: 'Aufgabe',
        },
        conflict_detection: {
            title: 'Konflikterkennung',
            unresolved: 'ungelöst',
            no_conflicts: 'Keine Konflikte erkannt',
            section: 'Abschnitt',
            field: 'Feld',
            dept_a: 'Abteilung A',
            value_a: 'Wert A',
            dept_b: 'Abteilung B',
            value_b: 'Wert B',
            severity: 'Schweregrad',
            status: 'Status',
            resolved: 'Gelöst',
            open: 'Offen',
            resolve: 'Lösen',
        },
        org_maturity: {
            title: 'Organisationsreife',
            departments: 'Abteilungen',
            department_hierarchy: 'Abteilungshierarchie',
            create_department: 'Abteilung erstellen',
            department_name: 'Abteilungsname',
            department_code: 'Code',
            level: 'Ebene',
            division: 'Bereich',
            department: 'Abteilung',
            team: 'Team',
            parent_department: 'Übergeordnete Abteilung',
            head_user: 'Abteilungsleiter',
            no_departments: 'Keine Abteilungen konfiguriert.',
            user_mappings: 'Benutzerzuordnungen',
            map_user: 'Benutzer zuordnen',
            user_id: 'Benutzer-ID',
            role: 'Rolle',
            no_users: 'Keine Benutzer dieser Abteilung zugeordnet.',
            remove: 'Entfernen',
            framework_assignments: 'Rahmenwerk-Zuweisungen',
            assign_framework: 'Rahmenwerk zuweisen',
            entity_id: 'Entitäts-ID',
            entity_type: 'Entitätstyp',
            framework_id: 'Rahmenwerk-ID',
            framework_code: 'Rahmenwerk-Code',
            no_assignments: 'Keine Rahmenwerk-Zuweisungen.',
            compliance_rollup: 'Compliance-Zusammenfassung',
            entity_name: 'Entität',
            total_assessments: 'Bewertungen gesamt',
            completed: 'Abgeschlossen',
            completion_pct: 'Abschluss %',
            open_gaps: 'Offene Lücken',
            critical_gaps: 'Kritisch',
            compliance_score: 'Punktzahl',
            no_rollup: 'Keine Daten zur Compliance-Zusammenfassung verfügbar.',
            entity_summary: 'Compliance-Zusammenfassung der Entität',
            frameworks_assigned: 'Rahmenwerke',
            overall_score: 'Gesamtpunktzahl',
            load_departments_error: 'Fehler beim Laden der Abteilungen',
            load_users_error: 'Fehler beim Laden der Benutzer',
            department_created: 'Abteilung erstellt',
            department_created_announce: 'Abteilung erstellt',
            create_department_error: 'Fehler beim Erstellen der Abteilung',
            user_mapped: 'Benutzer zugeordnet',
            user_mapped_announce: 'Benutzer der Abteilung zugeordnet',
            map_user_error: 'Fehler beim Zuordnen des Benutzers',
            user_removed: 'Benutzer entfernt',
            load_rollup_error: 'Fehler beim Laden der Zusammenfassung',
            load_assignments_error: 'Fehler beim Laden der Zuweisungen',
            framework_assigned: 'Framework zugewiesen',
            framework_assigned_announce: 'Framework der Entität zugewiesen',
            assign_framework_error: 'Fehler beim Zuweisen des Rahmenwerks',
            assignment_removed: 'Zuweisung entfernt',
            enter_entity_id_placeholder: 'Entitäts-ID eingeben um Zuweisungen anzuzeigen',
            entity_type_organization: 'Organisation',
            entity_type_department: 'Abteilung',
        },
        onboarding_maturity: {
            title: 'Onboarding-Reife',
            quick_starts: 'Schnellstarts',
            progress: 'Onboarding-Fortschritt',
            personas: 'Persona-Pfade',
            persona_onboarding: 'Persona-Onboarding',
            quick_start_scenarios: 'Schnellstart-Szenarien',
            start: 'Starten',
            restart: 'Neustart',
            estimated_minutes: 'Geschätzte Minuten',
            steps: 'Schritte',
            scenario: 'Szenario',
            no_scenarios: 'Keine Schnellstartszenarien verfügbar.',
            persona_id: 'Persona-ID',
            persona_label: 'Persona',
            role_description: 'Rollenbeschreibung',
            primary_modules: 'Primäre Module',
            recommended_tours: 'Empfohlene Touren',
            sample_data_modules: 'Beispieldatenmodule',
            quick_start_scenario: 'Schnellstart-Szenario',
            no_personas: 'Keine Persona-Pfade verfügbar.',
            framework_setup: 'Regulatorische Rahmenwerke',
            framework_code: 'Rahmencode',
            framework_name: 'Framework-Name',
            related_modules: 'Verwandte Module',
            persona_relevance: 'Relevante Personas',
            no_frameworks: 'Keine Framework-Setup-Optionen verfügbar.',
            tier_config: 'Konfiguration des Ebenenmoduls',
            tier: 'Stufe',
            available_modules: 'Verfügbare Module',
            module_count: 'Modulanzahl',
            overall_completion: 'Gesamtabschluss',
            wizard_completed: 'Assistent abgeschlossen',
            tours_completed: 'Touren abgeschlossen',
            quick_starts_completed: 'Schnellstarts abgeschlossen',
            selected_frameworks: 'Ausgewählte Frameworks',
            no_progress: 'Es sind keine Daten zum Onboarding-Fortschritt verfügbar.',
            detected_persona: 'Erkannte Persona',
            current_tier: 'Aktuelle Stufe',
            completion_pct: 'Abschluss',
            progress_page: {
                loaded: 'Fortschritt geladen',
                no_progress: 'Keine Onboarding-Fortschrittsdaten verfügbar.',
                overall: 'Gesamtfortschritt',
                detected_persona: 'Erkannte Persona',
                tier: 'Stufe',
                modules: 'Module',
                wizard: 'Assistent',
                completed: 'Abgeschlossen',
                pending: 'Ausstehend',
                tours: 'Rundgänge',
                quick_starts: 'Schnellstarts',
                frameworks: 'Ausgewählte Rahmenwerke',
                no_frameworks: 'Keine Rahmenwerke ausgewählt.',
                go_to_wizard: 'Einrichtungsassistenten abschließen',
                framework_selection: 'Rahmenwerk-Auswahl',
                framework_toggle: 'Rahmenwerke für Ihr Compliance-Programm aktivieren oder deaktivieren.',
                framework_updated: 'Rahmenwerk-Auswahl aktualisiert.',
                view_tours: 'Rundgänge anzeigen',
                view_quick_starts: 'Schnellstarts anzeigen',
            },
            persona_page: {
                description: 'Wählen Sie eine Persona, um empfohlene Module, Rundgänge und Schnellstartszenarien anzuzeigen.',
                no_personas: 'Keine Persona-Pfade verfügbar.',
                modules: 'Module',
                tours: 'Rundgänge',
                quick_start: 'Schnellstart',
                details: 'Einzelheiten',
                primary_modules: 'Primäre Module',
                recommended_tours: 'Empfohlene Rundgänge',
                framework_options: 'Regulatorische Rahmenwerke',
                no_frameworks: 'Keine Rahmenwerk-Einrichtungsoptionen verfügbar.',
                framework_code: 'Rahmenwerkkode',
                framework_label: 'Bezeichnung',
                region: 'Region',
                category: 'Kategorie',
                enabled: 'Aktiviert',
                disabled: 'Deaktiviert',
                tier_modules: 'Stufenmodulkonfiguration',
                tiers_loaded: 'Stufenkonfigurationen geladen',
                no_tier_config: 'Keine Stufenkonfiguration verfügbar.',
                view_tours: 'Modul-Rundgänge anzeigen',
                view_quick_start: 'Schnellstart beginnen',
                toggle_framework: 'Rahmenwerk umschalten',
                framework_updated: 'Rahmenwerk-Auswahl aktualisiert.',
                tier_desc_light: 'Grundlegende Datenschutz-Essentials — PDPL-Compliance-Grundlagen',
                tier_desc_standard: 'Vollständige Compliance-Suite — alle Module mit Workflows',
                tier_desc_enterprise: 'Erweiterte Governance und Automatisierung — Multi-Entität, Gruppenberichte',
                persona_highlight: 'Ihre Module',
                aria_go_to_module: '[[TOK_1]] – gehe zum Modul',
                aria_start_tour: 'Starten Sie [[TOK_1]]',
                aria_quick_start: 'Schnellstart: [[TOK_1]]',
                aria_help_article: 'Hilfeartikel: [[TOK_1]]',
                aria_view_framework: '[[TOK_2]][[TOK_3]] – Framework-Details anzeigen',
                aria_primary_for_persona: '[[TOK_1]] (primär für diese Persona)',
                primary_for_persona_suffix: ' (primär für diese Persona)',
                aria_view_in_persona_paths: '[[TOK_1]] – Ansicht in Persona-Pfaden',
                progress_of_total: '[[TOK_2]] von [[TOK_3]] abgeschlossen',
            },
            quick_starts_page: {
                description: 'Üben Sie gängige Arbeitsabläufe mit geführten Schnellstartszenarien.',
                no_scenarios: 'Keine Schnellstartszenarien verfügbar.',
                started: 'Schnellstart gestartet',
                status_completed: 'Abgeschlossen',
                status_in_progress: 'In Bearbeitung',
                status_not_started: 'Nicht gestartet',
                minutes: 'Min.',
                steps: 'Schritte',
                step: 'Schritt',
                restart: 'Neustart',
                start: 'Starten',
                go_to_module: 'Zum Modul gehen',
                next_step: 'Nächster Schritt',
                complete: 'Abschließen',
                reset: 'Zurücksetzen',
                step_of: 'von',
                action_navigate: 'Navigieren',
                action_form_fill: 'Formular ausfüllen',
                action_review: 'Überprüfen',
                action_confirm: 'Bestätigen',
                step_changed: 'Schritt {current} von {total}: {title}',
                completed_message: 'Schnellstart erfolgreich abgeschlossen!',
                reset_message: 'Schnellstart wurde zurückgesetzt.',
            },
            persona_p_vn_01_label: 'Unternehmen DPO',
            persona_p_vn_01_description: 'Datenschutzbeauftragter, der unternehmensweite Compliance-Programme verwaltet',
            persona_p_vn_02_label: 'Abteilungsinhaber',
            persona_p_vn_02_description: 'Abteilungsleiter, verantwortlich für die bereichsspezifische Compliance-Berichterstattung',
            persona_p_vn_03_label: 'E-Commerce-Compliance',
            persona_p_vn_03_description: 'Der Compliance-Beauftragte konzentrierte sich auf Datenschutz und Einwilligung im E-Commerce',
            persona_p_vn_04_label: 'Telekommunikation DPO',
            persona_p_vn_04_description: 'Telekommunikationssektor DPO verwaltet Teilnehmerdaten und meldet Vorfälle',
            persona_p_vn_05_label: 'Leiter der Daten-Governance',
            persona_p_vn_05_description: 'Hauptverantwortlicher für Datenzuordnung, Klassifizierung und Governance',
            persona_p_vn_06_label: 'Cybersicherheit und rechtliche Operationen',
            persona_p_vn_06_description: 'Cybersicherheitsbeauftragter, der die Reaktion auf Vorfälle und das Lieferantenrisiko verwaltet',
            persona_p_vn_07_label: 'AI Governance-Leiter',
            persona_p_vn_07_description: 'Leitet die Überwachung von AI System-Governance, Risikobewertungen und Klassifizierung',
            persona_p_vn_08_label: 'Grenzüberschreitender und Vendor-Gouverneur',
            persona_p_vn_08_description: 'Verantwortlicher für die Verwaltung grenzüberschreitender Überweisungen und die Lieferantenverwaltung',
            persona_p_vn_09_label: 'Leiter der Reaktion auf Sicherheitsverletzungen',
            persona_p_vn_09_description: 'Leiter der Koordinierung der Meldung von Verstößen und der Reaktion auf Vorfälle',
            persona_p_vn_10_label: 'Leiter der Internen Revision',
            persona_p_vn_10_description: 'Hauptverantwortlicher für Compliance-Audit und Programm-Governance-Überprüfung',
            persona_p_vn_11_label: 'HR- & Mitarbeiterdaten-Verantwortlicher',
            persona_p_vn_11_description: 'HR-Manager für Einwilligungsunterlagen von Mitarbeitern und interne DSARs',
            persona_p_vn_12_label: 'Compliance-Leiter multinationale Tochtergesellschaft',
            persona_p_vn_12_description: 'DSB in einer vietnamesischen Tochtergesellschaft eines ausländischen Unternehmens mit lokaler Compliance-Ebene',
            persona_p_vn_13_label: 'Compliance-Leiter Bildungswesen',
            persona_p_vn_13_description: 'Compliance-Leiter an einer ausländischen Schule für den Datenschutz von Schülern und Eltern',
            qs_hr_consent_title: 'Einwilligungsunterlagen von Mitarbeitern registrieren',
            qs_hr_consent_description: 'Durchlauf der Registrierung von Mitarbeitereinwilligungen und Erstellung eines Abdeckungsberichts.',
            qs_subsidiary_dpia_title: 'DSFA-Bewertung für Tochtergesellschaft erstellen',
            qs_subsidiary_dpia_description: 'Durchlauf der Erstellung einer DSFA für eine Verarbeitungstätigkeit der Tochtergesellschaft.',
            qs_student_consent_title: 'Einwilligungserfassung für Schüler einrichten',
            qs_student_consent_description: 'Durchlauf der Erstellung von Einwilligungsrichtlinien für Eltern/Erziehungsberechtigte für Schülerdaten.',
            persona_p_vn_14_label: 'Externer Rechtsberater',
            persona_p_vn_14_description: 'Senior-Partner einer Anwaltskanzlei, der mehrere Kundenorganisationen zu PDPL-Compliance berät',
            persona_p_vn_15_label: 'Betriebsleiter einer Anwaltskanzlei',
            persona_p_vn_15_description: 'Koordinator des Kundenengagements, der die Nachverfolgung der Lieferungen und die Terminkoordination verwaltet',
            persona_p_vn_16_label: 'Geschäftsinhaber / CEO',
            persona_p_vn_16_description: 'CEO oder GM, der rechtlich der Datenverantwortliche gemäß PDPL ist und für Compliance-Investitionen verantwortlich ist',
            qs_dpia_filing_title: 'Schließen Sie Ihre erste DPIA-Einreichung ab',
            qs_dept_compliance_title: 'Reichen Sie Ihren ersten Abteilungs-Compliance-Abschnitt ein',
            qs_ecommerce_consent_title: 'Konfigurieren Sie die Erfassung der E-Commerce-Einwilligung',
            qs_telecom_data_title: 'Richten Sie die Datenverarbeitung für Telekommunikationsteilnehmer ein',
            qs_data_flow_title: 'Ordnen Sie Ihren ersten Datenfluss zu',
            qs_incident_response_title: 'Konfigurieren Sie den Workflow zur Reaktion auf Vorfälle',
            qs_ai_risk_title: 'Führen Sie eine AI Systemrisikobewertung durch',
            qs_cross_border_title: 'Bewerten Sie einen grenzüberschreitenden Datentransfer',
            qs_breach_notification_title: 'Simulieren Sie einen Arbeitsablauf für die Meldung von Verstößen',
            qs_audit_trail_title: 'Überprüfen Sie einen Compliance-Audit-Trail',
            qs_legal_advisor_portfolio_title: 'Überprüfen Sie das Multi-Client-Compliance-Portfolio',
            qs_legal_advisor_portfolio_description: 'Überprüfen Sie den Compliance-Status mehrerer Kundenorganisationen.',
            qs_law_firm_ops_title: 'Verfolgen Sie den Lieferstatus des Kunden',
            qs_law_firm_ops_description: 'Überwachen Sie den Fortschritt der Beratungsleistungen und das Kundenengagement.',
            qs_ceo_dashboard_title: 'Sehen Sie sich das Compliance-Dashboard für Führungskräfte an',
            qs_ceo_dashboard_description: 'Überprüfen Sie den Compliance-Status und die Investitionskennzahlen auf hoher Ebene.',
        },
        rights_requests: {
            response_templates: {
                title: 'Antwortvorlagen',
                subtitle: 'Verwalten Sie die DSR-Antwortbriefvorlagen, die ResponseGenerator zum Verfassen von Antworten an betroffene Personen verwendet.',
                create_btn: 'Neue Vorlage',
                edit_btn: 'Vorlage bearbeiten',
                filter_right_type: 'Filtern Sie nach dem richtigen Typ',
                filter_locale: 'Nach Gebietsschema filtern',
                filter_status: 'Nach Status filtern',
                all_right_types: 'Alle richtigen Typen',
                any_right_type: 'Beliebig (gilt für alle Typen)',
                all_locales: 'Alle Orte',
                all_statuses: 'Alle',
                status_active: 'Aktiv',
                status_inactive: 'Inaktiv',
                empty_state: 'Keine Vorlage entspricht den aktuellen Filtern.',
                columns: {
                    template_id: 'Vorlagen-ID',
                    outcome: 'Ergebnis',
                    locale: 'Gebietsschema',
                    right_type: 'Richtiger Typ',
                    is_active: 'Status',
                    last_updated: 'Zuletzt aktualisiert',
                    actions: 'Aktionen',
                },
                actions: {
                    edit: 'Bearbeiten',
                    clone: 'Klon',
                    deactivate: 'Deaktivieren',
                    reactivate: 'Reaktivieren',
                    preview: 'Vorschau',
                },
                form: {
                    template_id: 'Vorlagen-ID',
                    template_id_help: 'Bezeichner in Kleinbuchstaben, z. B. dsr_access_fulfilled_vi',
                    outcome: 'Ergebnis',
                    locale: 'Gebietsschema',
                    right_type: 'Richtiger Typ',
                    subject: 'Betreff',
                    body: 'Körpervorlage',
                    body_help: 'Verwenden Sie Platzhalter wie [[TOK_3]], [[TOK_4]], [[TOK_5]]. Mindestens 15 Zeilen für mehrteilige Briefe.',
                    is_active: 'Aktiv',
                    official_form_id: 'Offizielle Formular-ID (optional)',
                },
                outcomes: {
                    fulfilled: 'Erfüllt',
                    partially_fulfilled: 'Teilweise erfüllt',
                    denied: 'Abgelehnt',
                },
                clone_modal_title: 'Klonvorlage',
                clone_target_locale: 'Zielgebietsschema',
                clone_help: 'Im Zielgebietsschema wird eine neue Vorlage erstellt, wobei diese Vorlage als Ausgangspunkt dient.',
                preview_modal_title: 'Vorlagenvorschau',
                preview_note: 'Die Vorschau verwendet Platzhalter für Demo-Fälle DSR-DEMO-0020. Echte Lieferung ersetzt Live-Falldaten.',
                preview_unavailable: 'Für die Vorschau ist ein vorhandener Fall erforderlich. Hängen Sie diese Vorlage an einen Fall an und verwenden Sie die Aktion „Antwortentwurf“ auf der Falldetailseite.',
                deactivate_confirm: 'Diese Vorlage deaktivieren? Es gilt weiterhin für bestehende Fälle, die darauf verweisen.',
                toasts: {
                    created: 'Vorlage erstellt',
                    updated: 'Vorlage aktualisiert',
                    deactivated: 'Vorlage deaktiviert',
                    reactivated: 'Vorlage reaktiviert',
                    cloned: 'Vorlage geklont',
                    load_error: 'Vorlagen konnten nicht geladen werden',
                    save_error: 'Vorlage konnte nicht gespeichert werden',
                    clone_error: 'Vorlage konnte nicht geklont werden',
                },
            },
        },
        organizations: {
            departments: {
                title: 'Abteilungen',
                subtitle: 'Verwalten Sie die Abteilungen, die DSR-Fälle, [[TOK_0]]-Aufgaben und Compliance-Workflows weiterleiten.',
                create_btn: 'Neue Abteilung',
                edit_btn: 'Abteilung bearbeiten',
                columns: {
                    name: 'Name',
                    description: 'Beschreibung',
                    active_cases: 'Aktive Fälle',
                    members: 'Mitglieder',
                    status: 'Status',
                    actions: 'Aktionen',
                },
                status_active: 'Aktiv',
                status_inactive: 'Inaktiv',
                form: {
                    name: 'Name',
                    description: 'Beschreibung',
                },
                actions: {
                    edit: 'Bearbeiten',
                    deactivate: 'Deaktivieren',
                    reactivate: 'Reaktivieren',
                    delete: 'Löschen',
                    manage_members: 'Mitglieder verwalten',
                },
                delete_modal_title: 'Abteilung löschen',
                delete_warning: 'Diese Abteilung hat noch aktive Fälle. Wählen Sie eine Abteilung aus, der Sie sie vor dem Löschen neu zuweisen möchten.',
                delete_no_cases: 'Diese Abteilung hat keine aktiven Fälle und kann bedenkenlos gelöscht werden.',
                reassign_prompt: 'Aktive Fälle neu zuweisen an:',
                reassign_none_available: 'Keine weiteren aktiven Abteilungen verfügbar. Erstellen Sie zunächst eine andere Abteilung.',
                member_section_title: 'Mitglieder',
                add_member: 'Mitglied hinzufügen',
                remove_member: 'Entfernen',
                member_role: 'Rolle',
                no_members: 'Dieser Abteilung sind keine Mitglieder zugeordnet.',
                toasts: {
                    created: 'Abteilung erstellt',
                    updated: 'Abteilung aktualisiert',
                    deactivated: 'Abteilung deaktiviert',
                    reactivated: 'Abteilung reaktiviert',
                    deleted: 'Abteilung gelöscht',
                    reassigned_count: '[[TOK_1]] Fall(e) neu zugewiesen',
                    member_added: 'Mitglied hinzugefügt',
                    member_removed: 'Mitglied entfernt',
                    load_error: 'Die Abteilungen konnten nicht geladen werden',
                    save_error: 'Die Abteilung konnte nicht gespeichert werden',
                    delete_error: 'Die Abteilung konnte nicht gelöscht werden',
                },
            },
            retention_policies: {
                title: 'Aufbewahrungsrichtlinien',
                subtitle: 'Konfigurieren Sie Aufbewahrungsfenster pro Zieltyp. Dokumente zur Identitätsprüfung verwenden dies, um zukünftige Uploads mit dem Stempel retention_expires_at zu versehen.',
                create_btn: 'Neue Richtlinie',
                edit_btn: 'Richtlinie bearbeiten',
                columns: {
                    target_type: 'Zieltyp',
                    retention_days: 'Aufbewahrung (Tage)',
                    owner: 'Versicherungsnehmer',
                    effective_from: 'Gültig ab',
                    last_reviewed: 'Zuletzt überprüft',
                    status: 'Status',
                    actions: 'Aktionen',
                },
                status_active: 'Aktiv',
                status_inactive: 'Inaktiv',
                form: {
                    target_type: 'Zieltyp',
                    target_type_help: 'Für welche Datenkategorie gilt das Aufbewahrungsfenster? Derzeit werden nur DSR-Dokumente zur Identitätsprüfung unterstützt.',
                    retention_days: 'Aufbewahrungszeitraum (Tage)',
                    retention_days_help: 'Zwischen 1 und 3650 Tagen (maximal 10 Jahre).',
                    owner: 'Versicherungsnehmer',
                    owner_help: 'Normalerweise das [[TOK_0]]. Verantwortlich für die Aufbewahrungsentscheidung gemäß DG-2.',
                    effective_from: 'Gültig ab',
                },
                target_types: {
                    dsr_identity_verification_document: 'DSR-Dokumente zur Identitätsprüfung',
                },
                deactivate_notice: 'Die Deaktivierung wirkt sich nicht auf bereits gestempelte Anhänge aus – lediglich zukünftige Uploads erhalten keine Aufbewahrungsfrist mehr.',
                deactivate_confirm: 'Diese Aufbewahrungsrichtlinie deaktivieren?',
                toasts: {
                    created: 'Aufbewahrungsrichtlinie erstellt',
                    updated: 'Aufbewahrungsrichtlinie aktualisiert',
                    deactivated: 'Aufbewahrungsrichtlinie deaktiviert',
                    load_error: 'Aufbewahrungsrichtlinien konnten nicht geladen werden',
                    save_error: 'Aufbewahrungsrichtlinie konnte nicht gespeichert werden',
                },
            },
        },
    },
    data_mapping: {
        nav: {
            systems: 'Systeme',
            categories: 'Datenkategorien',
            registry: 'Datenregister',
            purposes: 'Verarbeitungszwecke',
            retention: 'Aufbewahrung',
            flows: 'Datenflüsse',
            activities: 'Verarbeitungstätigkeiten',
            evidence: 'Nachweise',
            exports: 'Exporte',
            attestation: 'Bescheinigungszyklen',
            governance: 'Regierungsführung',
            review: 'Prüfaufgaben',
            inventory: 'Inventar',
            exceptions: 'Ausnahmen',
            history: 'Verlauf',
            ropa_completeness: 'ROPA Vollständigkeit',
        },
        ropa_completeness_autofix: {
            ask_button: 'Fragen Sie Forseti',
            drafting: 'Ausarbeitung…',
            accept: 'Akzeptiere',
            reject: 'Ablehnen',
            accepted: 'Akzeptiert – bewerben Sie sich über den Aktivitätseditor.',
            rejected: 'Abgelehnt.',
            needs_human_input: 'Forseti benötigt mehr Aktivitätskontext (z. B. einen dokumentierten Zweck), bevor er dieses Feld entwerfen kann.',
        },
        ropa_completeness: {
            title: 'ROPA-Vollständigkeitsbericht',
            subtitle: 'Feldbezogenes Hygieneaudit Ihrer Aufzeichnungen über Verarbeitungsaktivitäten, abhängig vom gesetzlichen Rahmen.',
            framework_label: 'Rahmen',
            kpi_total: 'Bewertete Aktivitäten',
            kpi_critical: 'Kritisch',
            kpi_high: 'Hoch',
            kpi_conditional: 'Bedingt',
            field_chart_heading: 'Fehlende Felder nach Häufigkeit',
            drilldown_heading: 'Aktivitäten mit Lücken',
            col_activity: 'Aktivität',
            col_field: 'Feld',
            col_severity: 'Schweregrad',
            col_condition: 'Zustand',
            col_action: 'Fix',
            action_fix: 'Fix',
            severity_critical: 'Kritisch',
            severity_high: 'Hoch',
            severity_conditional: 'Bedingt',
            severity_informational: 'Informativ',
            include_informational: 'Fügen Sie Informationen hinzu (ISO 27701)',
            export_csv: 'Herunterladen [[TOK_0]]',
            exporting: 'Exportieren...',
            loading: 'Wird geladen…',
            empty_state: 'Alle aktiven Aktivitäten verfügen über vollständige ROPA-Datensätze für dieses Framework.',
            error_fetch: 'Der Vollständigkeitsbericht konnte nicht geladen werden.',
            error_unsupported_framework: 'Dieses Framework wird nicht unterstützt.',
            error_framework_not_installed: 'Dieses Framework ist für Ihre Organisation nicht installiert.',
            no_misses_for_field: 'In diesem Feld fehlen keine Aktivitäten.',
            framework_PDPL: '[[TOK_0]] (Gesetz 91/2025 + Dekret 356)',
            framework_GDPR: '[[TOK_0]] Artikel 30',
            framework_DECREE_165: 'Dekret 165 (vietnamesisches Datengesetz)',
            framework_ISO_27701: 'ISO 27701 (informativ)',
        },
        registry: {
            page: {
                title: 'Datenregister',
                subtitle: 'Persönliche Datenelemente, die Ihre Organisation speichert, organisiert nach Datenkategorien.',
                empty_state: 'Noch keine Registrierungselemente. Fügen Sie einen Artikel manuell hinzu oder importieren Sie ihn aus einem Regulierungsregister.',
                empty_filter_state: 'Keine Artikel entsprechen Ihren Filtern.',
            },
            filter: {
                category: 'Kategorie',
                sensitivity: 'Empfindlichkeit',
                data_subject: 'Betroffene Person',
                status: 'Status',
                data_tier: 'Datenebene',
                cross_border: 'Grenzüberschreitend',
                has_owner: 'Hat Besitzer',
                has_form_source: 'Aus Formular importiert',
                search_placeholder: 'Suchen Sie nach Name, Beschreibung oder Feldkennung …',
                clear: 'Filter löschen',
                option_all: 'Alle',
            },
            col: {
                name: 'Name',
                category: 'Kategorie',
                sensitivity: 'Empfindlichkeit',
                data_subjects: 'Betroffene Personen',
                systems: 'Systeme',
                activities: 'Aktivitäten',
                owner: 'Besitzer',
                retention: 'Aufbewahrung',
                data_tier: 'Datenebene',
                status: 'Status',
                last_reviewed: 'Zuletzt überprüft',
                actions: 'Aktionen',
            },
            action: {
                add_manual: 'Artikel hinzufügen',
                add_from_form: 'Aus behördlichem Register hinzufügen',
                import_history: 'Importieren Sie vergangene Einsendungen',
                export: 'Exportieren',
                archive: 'Archiv',
                restore: 'Wiederherstellen',
                edit: 'Bearbeiten',
                assign_owner: 'Besitzer zuweisen',
                attach_evidence: 'Beweise beifügen',
                open_lineage: 'Offene Abstammung',
            },
            modal_editor: {
                section_identity: 'Identität',
                section_classification: 'Klassifizierung',
                section_subjects: 'Themen & Band',
                section_location: 'Standort & Transfer',
                section_systems: 'Systeme und Aktivitäten',
                section_retention: 'Aufbewahrung und Recht',
                section_governance: 'Regierungsführung',
                section_notes: 'Notizen',
                hint_inherited: '(geerbt von der Kategorie)',
                hint_overridden: '(überschrieben)',
                placeholder_field_identifiers: 'z. B. Kunden.primary_email, Hris.employee_id',
                validation_name_required: 'Name ist erforderlich',
                validation_category_required: 'Kategorie ist erforderlich',
                validation_data_subjects_required: 'Es ist mindestens ein Datensubjekttyp erforderlich',
                label_data_type: 'Datentyp',
                label_field_identifiers: 'Feldbezeichner (durch Kommas getrennt)',
                label_data_subject_types: 'Arten von Datensubjekten',
                label_volume_band: 'Lautstärkeband',
                label_storage_locations: 'Speicherorte (durch Kommas getrennt)',
                placeholder_storage_locations: 'ISO-3166 Codes oder Freitext (z. B. VN, Hetzner EU)',
                label_cross_border: 'Grenzüberschreitende Überweisung',
                label_source_systems: 'Quellsysteme',
                label_processing_activities: 'Verarbeitungstätigkeiten',
                label_collection_method: 'Sammelmethode',
                label_legal_basis: 'Rechtsgrundlage',
                label_purposes: 'Zwecke',
                hint_multi_select: 'Halten Sie die Befehls-/Strg-Taste gedrückt, um mehrere auszuwählen.',
                option_inherit_category: '— (von Kategorie erben)',
                option_dash: '—',
            },
            modal_import: {
                dry_run_heading: 'Vorschau importieren',
                label_to_create: 'Zu erschaffen',
                label_to_update: 'Zum Aktualisieren',
                label_skipped_archived: 'Übersprungen (archiviert)',
                label_conflicts: 'Konflikte',
                commit: 'Importieren',
                cancel: 'Abbrechen',
                conflict_row: '[[TOK_3]] – Ihre Bearbeitung beibehalten ([[TOK_4]]); Mapper gesucht [[TOK_5]].',
            },
            drawer: {
                section_category: 'Kategorie',
                section_systems: 'Quellsysteme',
                section_activities: 'Verarbeitungstätigkeiten',
                section_flows: 'Datenflüsse',
                section_retention: 'Effektive Aufbewahrung',
                section_governance: 'Regierungsführung',
                section_evidence: 'Beweise',
                section_audit: 'Aktueller Prüfpfad',
                section_source_form: 'Einreichung des Quellformulars',
                badge_inherited: 'Geerbt',
                badge_overridden: 'Überschrieben',
            },
            toast: {
                created: 'Registrierungselement erstellt.',
                updated: 'Registrierungselement aktualisiert.',
                archived: 'Registrierungselement archiviert.',
                imported: '[[TOK_1]] Elemente importiert.',
                conflict_warning: '[[TOK_1]] Feld(er) haben Ihre Änderungen beibehalten – siehe Konfliktliste.',
            },
        },
        systems: {
            title: 'Systeminventar',
            new: 'Neues System',
            edit: 'System bearbeiten',
            name: 'Bezeichnung',
            owner: 'Verantwortlicher',
            criticality: 'Kritikalität',
            dpa_status: 'AVV-Status',
            location: 'Standort',
            system_type: 'Systemtyp',
            metadata: 'Metadaten (JSON)',
            department: 'Abteilung',
            hosting_location: 'Hosting-Standort',
            hosting_provider: 'Hosting-Anbieter',
            data_residency_country: 'Land der Datenspeicherung',
            hosting: 'Hostingdienst',
            no_systems: 'Keine Systeme gefunden',
            confirm_archive: 'System „{name}" archivieren?',
            count: 'Systeme',
            count_one: 'System',
            type_internal: 'Intern',
            type_external: 'Extern',
            type_cloud_service: 'Cloud-Dienst',
            type_on_premise: 'Vor Ort',
            type_hybrid: 'Hybridtyp',
            status_active: 'Aktiv',
            status_decommissioning: 'Wird stillgelegt',
            status_decommissioned: 'Stillgelegt',
            status_planned: 'Geplant',
            dpa_not_required: 'Nicht erforderlich',
            dpa_required_missing: 'Erforderlich fehlend',
            dpa_in_progress: 'In Bearbeitung',
            dpa_signed: 'Unterzeichnet',
            all_criticalities: 'Alle Kritikalitätsstufen',
        },
        categories: {
            title: 'Datenkategorien',
            new: 'Neue Kategorie',
            edit: 'Kategorie bearbeiten',
            name: 'Bezeichnung',
            sensitivity: 'Sensitivität',
            tags: 'Schlagwörter',
            used_in: 'Verwendet in',
            examples: 'Beispiele',
            examples_hint: 'Beispiele (kommagetrennt)',
            default: 'Standard',
            all_sensitivities: 'Alle Sensitivitätsstufen',
            all_statuses: 'Alle Status',
            no_categories: 'Keine Kategorien gefunden',
            confirm_delete: 'Kategorie „{name}" löschen?',
            count: 'Kategorien',
            count_one: 'Kategorie',
            status_draft: 'Entwurf',
            status_proposed: 'Vorgeschlagen',
            status_under_review: 'In Prüfung',
            status_approved: 'Genehmigt',
            status_deprecated: 'Veraltet',
            status_updated: 'Kategoriestatus aktualisiert',
            propose: 'Vorschlagen',
            approve: 'Genehmigen',
            deprecate: 'Veraltung',
        },
        purposes: {
            title: 'Verarbeitungszwecke',
            new: 'Neuer Zweck',
            edit: 'Zweck bearbeiten',
            name: 'Bezeichnung',
            legal_basis: 'Rechtsgrundlage',
            retention_period: 'Aufbewahrungsfrist (Tage)',
            justification: 'Begründung des berechtigten Interesses',
            legal_basis_detail: 'Details zur Rechtsgrundlage',
            all_legal_bases: 'Alle Rechtsgrundlagen',
            no_purposes: 'Keine Zwecke gefunden',
            confirm_delete: '„{name}" löschen?',
            default: 'Standard',
            count: '{count} Zwecke',
            count_one: '{count} Zweck',
            basis_consent: 'Einwilligung',
            basis_contract: 'Vertrag',
            basis_legal_obligation: 'Rechtliche Verpflichtung',
            basis_vital_interest: 'Lebenswichtiges Interesse',
            basis_public_interest: 'Öffentliches Interesse',
            basis_legitimate_interest: 'Berechtigtes Interesse',
        },
        retention: {
            title: 'Aufbewahrungsrichtlinien',
            new: 'Neue Richtlinie',
            edit: 'Richtlinie bearbeiten',
            name: 'Bezeichnung',
            retention_days: 'Aufbewahrungstage',
            disposal_method: 'Entsorgungsmethode',
            data_categories: 'Datenkategorien',
            activities: 'Tätigkeiten',
            review_frequency: 'Überprüfungshäufigkeit',
            review_frequency_days: 'Überprüfungshäufigkeit (Tage)',
            no_policies: 'Keine Aufbewahrungsrichtlinien gefunden',
            confirm_delete: '„{name}" löschen?',
            count: '{count} Richtlinien',
            count_one: '{count} Richtlinie',
            days: 'Tage',
            disposal_deletion: 'Löschung',
            disposal_anonymization: 'Anonymisierung',
            disposal_archival: 'Archivierung',
            review_overdue: 'Überprüfung überfällig',
            review_status: 'Überprüfungsstatus',
            review_ok: 'Im Plan',
            department: 'Abteilung',
            all_departments: 'Alle Abteilungen',
        },
        flows: {
            view_tabs_aria: 'Datenfluss-Ansicht',
            view_list: 'Liste',
            view_map: 'Karte',
            title: 'Datenflüsse',
            new: 'Neuer Fluss',
            edit: 'Fluss bearbeiten',
            name: 'Bezeichnung',
            from_system: 'Quellsystem',
            to_system: 'Zielsystem',
            flow_type: 'Flusstyp',
            cross_border: 'Grenzüberschreitend',
            risk_level: 'Risikostufe',
            mechanism: 'Mechanismus',
            transfer_mechanism: 'Übertragungsmechanismus',
            frequency: 'Häufigkeit',
            source_country: 'Herkunftsland',
            destination_country: 'Zielland',
            transfer_safeguard: 'Übertragungsschutzmaßnahme',
            all_risk_levels: 'Alle Risikostufen',
            no_flows: 'Keine Datenflüsse gefunden',
            confirm_archive: '„{name}" archivieren?',
            count: '{count} Flüsse',
            count_one: '{count} Fluss',
            status_active: 'Aktiv',
            status_inactive: 'Inaktiv',
            status_under_review: 'In Überprüfung',
            mechanism_api: 'API',
            mechanism_file_transfer: 'Dateiübertragung',
            mechanism_database_replication: 'Datenbankreplikation',
            mechanism_manual: 'Manuell',
            mechanism_email: 'E-Mail',
            mechanism_other: 'Sonstiges',
            frequency_real_time: 'Echtzeit',
            frequency_hourly: 'Stündlich',
            frequency_daily: 'Täglich',
            frequency_weekly: 'Wöchentlich',
            frequency_monthly: 'Monatlich',
            frequency_on_demand: 'Auf Anfrage',
            frequency_one_time: 'Einmalig',
            safeguard_adequacy_decision: 'Angemessenheitsbeschluss',
            safeguard_standard_contractual_clauses: 'Standardvertragsklauseln',
            safeguard_binding_corporate_rules: 'Verbindliche interne Datenschutzvorschriften',
            safeguard_explicit_consent: 'Ausdrückliche Einwilligung',
            safeguard_legal_obligation: 'Rechtliche Verpflichtung',
            safeguard_none: 'Keine',
            safeguard_other: 'Sonstiges',
        },
        activities: {
            title: 'Verarbeitungstätigkeiten',
            new: 'Neue Tätigkeit',
            edit: 'Tätigkeit bearbeiten',
            activity_title: 'Titel',
            category: 'Kategorie',
            legal_basis: 'Rechtsgrundlage',
            dpa_required: 'AVV erforderlich',
            ropa_generated: 'VVT erstellt',
            version: 'Fassung',
            generate_ropa: 'VVT erstellen',
            controller: 'Verantwortlicher',
            controller_name: 'Name des Verantwortlichen',
            controller_contact: 'Kontakt des Verantwortlichen',
            legal_basis_detail: 'Details zur Rechtsgrundlage',
            organization_info: 'Organisationsinformationen (Anhang I)',
            org_address: 'Organisationsadresse',
            tax_code: 'Steuernummer',
            contact_person: 'Ansprechpartner',
            contact_email: 'Kontakt-E-Mail',
            contact_phone: 'Kontakttelefon',
            select_entity: 'Wählen Sie…',
            no_entities: 'Keine Artikel gefunden',
            dpo_name: 'Name des DSB',
            dpo_contact: 'Kontakt des DSB',
            processor_name: 'Name des Auftragsverarbeiters',
            processor_contact: 'Kontakt des Auftragsverarbeiters',
            data_subjects: 'Betroffene Personen',
            data_subjects_hint: 'Betroffene Personen (kommagetrennt)',
            recipients: 'Empfänger',
            recipients_hint: 'Empfänger (kommagetrennt)',
            security_measures: 'Sicherheitsmaßnahmen',
            dpia_reference: 'DSFA-Referenz',
            no_activities: 'Keine Verarbeitungstätigkeiten gefunden',
            confirm_archive: '„{name}" archivieren?',
            count: '{count} Tätigkeiten',
            count_one: '{count} Tätigkeit',
            ropa_success: 'VVT-Eintrag erstellt. Gehen Sie zu Exporte, um es herunterzuladen.',
            ropa_error: 'VVT konnte nicht erstellt werden',
            required_label: 'Erforderlich',
            status_draft: 'Entwurf',
            status_active: 'Aktiv',
            status_under_review: 'In Überprüfung',
            status_archived: 'Archiviert',
            decree_165_heading: 'Dekret 165 Datenebene (vietnamesisches Datengesetz)',
            decree_165_helper: 'Klassifizieren Sie die Daten, die diese Aktivität gemäß Vietnam-Dekret 165 verarbeitet. Reguläre Daten erhalten die grenzüberschreitende Grundregelung; Wichtige und zentrale Daten lösen zusätzliche Pflichten aus.',
            data_tier_label: 'Datenebene',
            data_tier_help: 'Das Dekret 165 klassifiziert Daten als regelmäßig, wichtig oder zentral. Weitere Informationen finden Sie im Hilfeartikel.',
            data_tier_column_header: 'Datenebene',
            data_tier_regular: 'Regelmäßig',
            data_tier_important: 'Wichtig',
            data_tier_core: 'Kern',
            transfer_mechanism_label: 'Grenzüberschreitender Übertragungsmechanismus',
            transfer_mechanism_placeholder: 'z.B. Standardvertragsklauseln, Angemessenheitsentscheidung',
            security_assessment_reference_label: 'Referenz zur Sicherheitsbewertung',
            security_assessment_reference_placeholder: 'z.B. [[TOK_0]]-SA-2026-001',
        },
        evidence: {
            title: 'Nachweisarchiv',
            new: 'Neuer Nachweis',
            edit: 'Nachweis bearbeiten',
            name: 'Bezeichnung',
            evidence_type: 'Nachweistyp',
            linked_entities: 'Verknüpfte Objekte',
            uploaded: 'Hochgeladen',
            expiry: 'Ablaufdatum',
            file_url: 'Datei-URL',
            source_mode_label: 'Nachweisquelle',
            source_mode_file: 'Datei hochladen',
            source_mode_url: 'Externe URL verknüpfen',
            attachment_label: 'Anhang',
            link_to: 'Nachweis verknüpfen mit',
            entity_type: 'Objekttyp',
            entity_id: 'Objekt-ID',
            no_evidence: 'Keine Nachweise gefunden',
            manage_links: 'Links verwalten',
            unlink: 'Verknüpfung aufheben',
            confirm_delete: 'Nachweis „{name}" löschen?',
            count: '{count} Einträge',
            count_one: '{count} Eintrag',
            type_document: 'Dokument',
            type_screenshot: 'Bildschirmfoto',
            type_policy: 'Richtlinie',
            type_contract: 'Vertrag',
            type_assessment: 'Bewertung',
            type_correspondence: 'Korrespondenz',
            type_other: 'Sonstiges',
            linked_type_system: 'System',
            linked_type_data_flow: 'Datenfluss',
            linked_type_processing_activity: 'Verarbeitungsaktivität',
            linked_type_data_category: 'Datenkategorie',
            linked_type_purpose: 'Zweck',
            linked_type_retention_policy: 'Aufbewahrungsrichtlinie',
            link_entity: 'Link zur Entität',
            link_success: 'Entität erfolgreich verknüpft',
            confirm_unlink: 'Sind Sie sicher, dass Sie die Verknüpfung dieser Entität aufheben möchten?',
            unlink_success: 'Die Verknüpfung der Entität wurde erfolgreich aufgehoben',
            no_linked_entities: 'Keine verknüpften Einheiten',
            select_entity: 'Wählen Sie…',
            no_entities: 'Keine Artikel',
        },
        exports: {
            title: 'Datenexporte',
            recent: 'Letzte Exporte',
            export_type: 'Exporttyp',
            format: 'Dateiformat',
            requested_by: 'Angefordert von',
            requested_at: 'Angefordert am',
            download: 'Herunterladen',
            csv_export: 'CSV-Export',
            csv_description: 'Daten im CSV-Format für die Tabellenkalkulationsanalyse herunterladen.',
            pdf_reports: 'PDF-Berichte',
            pdf_description: 'Formatierte Berichte für die Compliance-Dokumentation erstellen.',
            csv_systems: 'Systeminventar',
            csv_categories: 'Datenkategorien',
            csv_flows: 'Datenflüsse',
            csv_activities: 'Verarbeitungstätigkeiten',
            csv_cross_border: 'Grenzüberschreitende Flüsse',
            csv_retention_policies: 'Aufbewahrungsrichtlinien',
            csv_evidence: 'Beweisstücke',
            csv_governance_assignments: 'Governance-Aufgaben',
            pdf_ropa: 'VVT-Register',
            pdf_systems: 'Systembericht',
            pdf_cross_border: 'Grenzüberschreitender Bericht',
            pdf_flow_map: 'Flusszuordnungsdaten',
            export_failed: 'Export fehlgeschlagen',
            pdf_generated: 'PDF erfolgreich erstellt.',
            ropa: 'RoPA-Register',
            retention_policies: 'Aufbewahrungsrichtlinien',
            governance_assignments: 'Governance-Aufgaben',
            col_entity: 'Entität exportieren',
            col_description: 'Beschreibung',
            desc_ropa: 'Vollständiges ROPA-Register aller Verarbeitungsaktivitäten mit Rechtsgrundlage, [[TOK_0]]-Status und Kontrollen.',
            desc_systems: 'Systeminventur mit Eigentümer, Datenkategorie-Tags und Konformitätsstatus.',
            desc_activities: 'Einzelne Verarbeitungstätigkeiten mit Verantwortlicher, Rechtsgrundlage und [[TOK_0]]-Klassifizierung.',
            desc_categories: 'Datenkategorien und Vertraulichkeitsstufen, die bei Klassifizierungen und Prüfungen verwendet werden.',
            desc_purposes: 'Verarbeitungszwecke mit Rechtsgrundlagenangaben gemäß Dekret 13/2023 und Telekommunikationsgesetz 2023.',
            desc_flows: 'Datenflüsse zwischen Systemen, einschließlich interner und grenzüberschreitender Routen.',
            desc_cross_border: 'Nur grenzüberschreitende Ströme, mit Übertragungsmechanismus und Risikobewertung.',
            desc_retention_policies: 'Aufbewahrungsrichtlinien, Entsorgungsmethoden und Überprüfungsrhythmus.',
            desc_evidence: 'Den Verarbeitungstätigkeiten beigefügte Nachweise: Zertifikate, DPA-Verträge, [[TOK_0]]-Berichte.',
            desc_governance_assignments: 'Governance-Zuweisungen: Eigentümer, Genehmiger und ISO 27001-Referenzen.',
            unified_heading: 'Entitäten exportieren',
            unified_description: 'Exportieren Sie jede Datenzuordnungseinheit im Format [[TOK_0]], [[TOK_3]], [[TOK_2]] oder [[TOK_1]]. Alle Exporte werden im Dateibrowser gespeichert.',
            export_button_label: 'Exportieren',
            csv_download_success: 'CSV erfolgreich heruntergeladen.',
        },
        attestation: {
            title: 'Attestierungszyklen',
            create: 'Neuer Zyklus',
            name: 'Zyklusname',
            year: 'Jahr',
            deadline: 'Frist',
            scope: 'Umfang',
            status: 'Status',
            tasks: 'Abteilungsaufgaben',
            assign_tasks: 'Aufgaben zuweisen',
            department: 'Abteilung',
            assignee: 'Zugewiesener',
            progress: 'Fortschritt',
            stale_entries: 'Veraltete Einträge',
            detect_stale: 'Veraltete erkennen',
            export_bundle: 'Paket exportieren',
            no_cycles: 'Noch keine Attestierungszyklen.',
            create_success: 'Attestierungszyklus erstellt.',
            assign_success: 'Aufgaben zugewiesen.',
            complete_success: 'Aufgabe abgeschlossen.',
            stale_detected: 'Veraltete Einträge erkannt.',
            stale_systems: 'Veraltete Systeme',
            stale_flows: 'Veraltete Flüsse',
            no_stale: 'Keine veralteten Einträge erkannt.',
            stale_name: 'Name',
            stale_announcement: '{0} veraltete Systeme und {1} veraltete Flüsse gefunden',
            last_updated: 'Zuletzt aktualisiert',
            status_draft: 'Entwurf',
            status_active: 'Aktiv',
            status_completed: 'Abgeschlossen',
            task_status_pending: 'Ausstehend',
            task_status_in_progress: 'In Bearbeitung',
            task_status_completed: 'Abgeschlossen',
            scope_systems: 'Systeme',
            scope_flows: 'Datenflüsse',
            scope_activities: 'Aktivitäten',
            scope_categories: 'Kategorien',
            scope_purposes: 'Zwecke',
            scope_retention: 'Aufbewahrung',
        },
        governance: {
            title: 'Governance-Zuweisungen',
            assign: 'Eigentümerschaft zuweisen',
            entity_type: 'Entitätstyp',
            entity: 'Entität',
            role: 'Rolle',
            assigned_by: 'Zugewiesen von',
            assigned_at: 'Zugewiesen am',
            remove: 'Entfernen',
            no_assignments: 'Keine Governance-Zuweisungen.',
            assign_success: 'Eigentümerschaft zugewiesen.',
            remove_success: 'Zuweisung entfernt.',
            assignee: 'Zugewiesene Person',
            department: 'Abteilung',
            all_departments: 'Alle Abteilungen',
            roles: {
                data_owner: 'Dateneigentümer',
                data_steward: 'Datenverwalter',
                data_custodian: 'Datenhüter',
                informed: 'Informiert',
            },
            entity_types: {
                system: 'System',
                flow: 'Datenfluss',
                activity: 'Aktivität',
                category: 'Kategorie',
                purpose: 'Zweck',
                retention_policy: 'Aufbewahrungsrichtlinie',
            },
        },
        risk_assessment: {
            title: 'Risikobewertung',
            create: 'Neue Bewertung',
            safeguard_type: 'Schutzmaßnahmentyp',
            adequacy_status: 'Angemessenheitsstatus',
            risk_factors: 'Risikofaktoren',
            mitigations: 'Gegenmaßnahmen',
            reviewer: 'Prüfer',
            decision: 'Entscheidung',
            approve: 'Genehmigen',
            reject: 'Ablehnen',
            no_assessments: 'Keine Risikobewertungen.',
            create_success: 'Risikobewertung erstellt.',
            approve_success: 'Bewertung genehmigt.',
            reject_success: 'Bewertung abgelehnt.',
            one_per_line: 'Eins pro Zeile',
            safeguard_adequacy_decision: 'Angemessenheitsbeschluss',
            safeguard_standard_contractual_clauses: 'Standardvertragsklauseln',
            safeguard_binding_corporate_rules: 'Verbindliche Unternehmensregeln',
            safeguard_explicit_consent: 'Ausdrückliche Einwilligung',
            safeguard_legal_obligation: 'Rechtliche Verpflichtung',
            safeguard_none: 'Keine',
            safeguard_other: 'Sonstige',
            adequacy_adequate: 'Angemessen',
            adequacy_inadequate: 'Unzureichend',
            adequacy_under_review: 'In Prüfung',
            adequacy_not_assessed: 'Nicht bewertet',
            decision_approved: 'Genehmigt',
            decision_rejected: 'Abgelehnt',
        },
        review: {
            title: 'Prüfaufgaben',
            description: 'Prüfaufgaben werden automatisch erstellt, wenn eine Datenkategorie vorgeschlagen wird. Um eine neue Aufgabe zu erstellen, gehen Sie zu Datenkategorien und klicken Sie bei einer Entwurfskategorie auf Vorschlagen.',
            count: 'Prüfaufgaben',
            summary: 'Prüfungsübersicht',
            pending: 'Ausstehend',
            resolved_today: 'Heute gelöst',
            escalated: 'Eskaliert',
            overdue: 'Überfällig (>5 Tage)',
            all_statuses: 'Alle Status',
            status_pending: 'Ausstehend',
            status_resolved: 'Gelöst',
            status_escalated: 'Eskaliert',
            category_name: 'Kategorie',
            system_name: 'System',
            owner: 'Verantwortlicher',
            resolve: 'Lösen',
            resolve_task: 'Prüfaufgabe lösen',
            resolution: 'Lösung',
            resolution_approve: 'Genehmigen',
            resolution_modify: 'Ändern und genehmigen',
            resolution_reject: 'Ablehnen',
            resolution_escalate: 'Eskalieren',
            notes: 'Lösungshinweise',
            notes_required: 'Hinweise erforderlich (mind. 10 Zeichen) für Ändern, Ablehnen oder Eskalieren',
            resolved_success: 'Prüfaufgabe gelöst',
            bulk_approve: 'Massengenehmigung',
            bulk_reject: 'Massenablehnung',
            bulk_success: '{count} Aufgaben verarbeitet',
            no_tasks: 'Keine Prüfaufgaben gefunden',
        },
        inventory: {
            title: 'Klassifizierungsinventar',
            count: 'Systeme',
            summary: 'Inventarübersicht',
            total_systems: 'Systeme gesamt',
            total_labels: 'Bezeichnungen gesamt',
            system_name: 'System',
            label_count: 'Bezeichnungen',
            approved_count: 'Genehmigt',
            pending_count: 'Ausstehend',
            no_items: 'Keine Inventareinträge gefunden',
        },
        exceptions: {
            title: 'Klassifizierungsausnahmen',
            count: 'Ausnahmen',
            all_severities: 'Alle Schweregrade',
            all_statuses: 'Alle Status',
            system_name: 'System',
            severity_label: 'Schweregrad',
            status_open: 'Offen',
            status_resolved: 'Gelöst',
            status_accepted_risk: 'Akzeptiertes Risiko',
            resolve: 'Lösen',
            resolve_exception: 'Ausnahme lösen',
            resolution_type: 'Lösungstyp',
            notes: 'Hinweise',
            justification_required: 'Begründung erforderlich (mind. 10 Zeichen) für akzeptiertes Risiko',
            resolved_success: 'Ausnahme gelöst',
            no_exceptions: 'Keine Ausnahmen gefunden',
        },
        history: {
            title: 'Klassifizierungsverlauf',
            count: 'Ereignisse',
            actor: 'Akteur',
            action: 'Aktion',
            entity_type: 'Entitätstyp',
            changes: 'Änderungen',
            view_lineage: 'Herkunft anzeigen',
            lineage_title: 'Klassifizierungsherkunft',
            no_events: 'Keine Verlaufsereignisse gefunden',
            no_lineage: 'Keine Herkunftsdaten verfügbar',
            modified: 'Geändert',
            created: 'Erstellt',
            removed: 'Entfernt',
            action_created: 'Erstellt',
            action_updated: 'Aktualisiert',
            action_archived: 'Archiviert',
            action_approved: 'Genehmigt',
            action_deprecated: 'Veraltet',
            entity_label: 'Bezeichnung',
            entity_taxonomy: 'Taxonomie',
            entity_review_task: 'Prüfaufgabe',
            entity_exception: 'Ausnahme',
            before: 'Vorher',
            after: 'Nachher',
        },
    },
    governance: {
        audit_trail_title: 'Governance-Audit-Protokoll',
        audit_trail_subtitle: 'Übergreifender Audit-Stream für Governance-Aktionen — Freigaben, Playbook-Ausführungen, Nachweisverknüpfungen und mehr.',
        audit_trail_item_count: 'Audit-Ereignisse',
        audit_trail_fetch_error: 'Audit-Ereignisse konnten nicht geladen werden.',
        audit_trail_no_events: 'Keine Audit-Ereignisse für die aktuellen Filter gefunden.',
        audit_trail_entity_type: 'Entitätstyp',
        audit_trail_entity_id: 'Entitäts-ID',
        audit_trail_action: 'Aktion',
        audit_trail_actor: 'Akteur',
        audit_trail_timestamp: 'Zeitstempel',
        audit_trail_date_from: 'Von',
        audit_trail_date_to: 'Bis',
        audit_trail_no_rows_to_export: 'Keine Zeilen zum Exportieren.',
        nav: {
            vendors: 'Dienstleister',
            subprocessors: 'Unterauftragsverarbeiter',
            cross_border: 'Grenzüberschreitend',
            drift: 'Abweichungsmonitor',
            scores: 'Compliance-Bewertung',
            playbooks: 'Spielbücher',
            approvals: 'Genehmigungen',
            audit_trail: 'Audit-Trail',
            board_report: 'Vorstandsbericht',
            evidence: 'Nachweise',
            onboarding: 'Onboarding-Pipeline',
            dpa_reviews: 'DPA-Prüfungen',
            periodic_reviews: 'Periodische Prüfungen',
            offboarding: 'Offboarding',
        },
        vendors: {
            title: 'Dienstleisterverzeichnis',
            new: 'Neuer Dienstleister',
            edit: 'Dienstleister bearbeiten',
            name: 'Bezeichnung',
            jurisdiction: 'Rechtsordnung',
            dpa_status: 'AVV-Status',
            risk_level: 'Risikostufe',
            onboarding_status: 'Onboarding-Status',
            contact_email: 'Kontakt-E-Mail',
            contact_name: 'Kontaktname',
            contact_phone: 'Kontakttelefon',
            website: 'Webseite',
            services_csv: 'Dienstleistungen (kommagetrennt)',
            country: 'Land',
            country_placeholder: 'z.B. DE',
            last_reviewed: 'Zuletzt überprüft',
            offboard: 'Beenden',
            offboard_vendor: 'Dienstleister beenden',
            offboard_reason: 'Grund für Beendigung',
            no_vendors: 'Keine Dienstleister gefunden',
            vendor_count: '{count} Dienstleister',
            all_dpa_status: 'Alle AVV-Status',
            all_risk_levels: 'Alle Risikostufen',
            all_onboarding: 'Alle Onboarding-Status',
            fetch_error: 'Fehlgeschlagen. Bitte erneut versuchen.',
            save_error: 'Dienstleister konnte nicht gespeichert werden',
            offboard_error: 'Beendigung fehlgeschlagen',
        },
        vendor_types: {
            processor: 'Auftragsverarbeiter',
            sub_processor: 'Unterauftragsverarbeiter',
            controller: 'Verantwortlicher',
            joint_controller: 'Gemeinsam Verantwortlicher',
        },
        onboarding_statuses: {
            pending_review: 'Überprüfung Ausstehend',
            approved: 'Genehmigt',
            active: 'Aktiv',
            suspended: 'Ausgesetzt',
            offboarded: 'Beendet',
        },
        dpa_statuses: {
            not_required: 'Nicht Erforderlich',
            required_missing: 'Erforderlich Fehlend',
            draft: 'Entwurf',
            under_review: 'In Überprüfung',
            signed: 'Unterzeichnet',
            expired: 'Abgelaufen',
        },
        risk_levels: {
            critical: 'Kritisch',
            high: 'Hoch',
            medium: 'Mittel',
            low: 'Niedrig',
        },
        approval_statuses: {
            pending: 'Ausstehend',
            approved: 'Genehmigt',
            rejected: 'Abgelehnt',
            expired: 'Abgelaufen',
        },
        approval_action_types: {
            vendor_onboarding: 'Lieferantenanbindung',
            vendor_offboarding: 'Lieferantenabwicklung',
            cross_border_acceptance: 'Grenzüberschreitende Genehmigung',
            playbook_activation: 'Playbook-Aktivierung',
            drift_accept_risk: 'Abweichung Risiko Akzeptiert',
            activity_activation: 'Aktivitätsaktivierung',
        },
        drift_check_types: {
            dpa_expiry: 'DPA-Ablauf',
            dpa_missing: 'DPA Fehlend',
            review_overdue: 'Überprüfung Überfällig',
            cross_border_gap: 'Grenzüberschreitende Lücke',
            sub_processor_chain: 'Unterauftragsverarbeiterkette',
            risk_assessment_overdue: 'Risikobewertung Überfällig',
            retention_policy_missing: 'Aufbewahrungsrichtlinie Fehlend',
            evidence_expiring: 'Nachweis Läuft Ab',
        },
        drift_statuses: {
            open: 'Offen',
            acknowledged: 'Bestätigt',
            in_progress: 'In Bearbeitung',
            resolved: 'Gelöst',
            accepted_risk: 'Akzeptiertes Risiko',
        },
        drift_entity_types: {
            vendor: 'Lieferant',
            system: 'IT-System',
            data_flow: 'Datenfluss',
            processing_activity: 'Verarbeitungsaktivität',
            evidence_item: 'Nachweis',
        },
        playbook_statuses: {
            draft: 'Entwurf',
            active: 'Aktiv',
            archived: 'Archiviert',
        },
        playbook_action_types: {
            delete_data: 'Daten Löschen',
            verify_deletion: 'Löschung Verifizieren',
            notify_vendor: 'Lieferant Benachrichtigen',
            confirm_receipt: 'Empfang Bestätigen',
            document_evidence: 'Dokumentieren',
            other: 'Sonstiges',
        },
        playbook_target_types: {
            system: 'IT-System',
            vendor: 'Lieferant',
        },
        dpa_chain_statuses: {
            complete: 'Vollständig',
            incomplete: 'Unvollständig',
            unknown: 'Unbekannt',
        },
        sub_processor_statuses: {
            active: 'Aktiv',
            terminated: 'Beendet',
        },
        evidence_types: {
            dpa_agreement: 'DPA-Vereinbarung',
            risk_assessment: 'Risikobewertung',
            audit_report: 'Prüfbericht',
            certification: 'Zertifizierung',
            deletion_confirmation: 'Löschbestätigung',
            training_record: 'Schulungsnachweis',
            incident_report: 'Vorfallbericht',
            document: 'Dokument',
            screenshot: 'Bildschirmfoto',
            policy: 'Richtlinie',
            contract: 'Vertrag',
            assessment: 'Bewertung',
            correspondence: 'Korrespondenz',
            other: 'Sonstiges',
        },
        linkable_entity_types: {
            vendor: 'Lieferant',
            transfer_mechanism: 'Übertragungsmechanismus',
            playbook: 'Leitfaden',
            execution: 'Ausführung',
            system: 'IT-System',
            activity: 'Aktivität',
        },
        subprocessors: {
            title: 'Unterauftragsverarbeiter-Beziehungen',
            new: 'Neue Verknüpfung',
            vendor: 'Dienstleister',
            subprocessor: 'Unterauftragsverarbeiter',
            relationship_type: 'Beziehungstyp',
            countries: 'Länder',
            countries_csv: 'Länder (kommagetrennt)',
            dpa_chain: 'DPA-Kette',
            dpa_chain_status: 'DPA-Kettenstatus',
            no_processors: 'Keine Auftragsverarbeiter gefunden.',
            no_subprocessors: 'Keine Unterauftragsverarbeiter gefunden.',
            processor_vendor: 'Auftragsverarbeiter-Dienstleister',
            select_processor: 'Auftragsverarbeiter auswählen',
            select_vendor: 'Dienstleister auswählen',
            services: 'Dienstleistungen',
            sub_processor_vendor_id: 'Unterauftragsverarbeiter-ID',
            terminate: 'Beenden',
            confirm_terminate: 'Sind Sie sicher, dass Sie diese Beziehung beenden möchten?',
            create_error: 'Verknüpfung konnte nicht erstellt werden.',
            fetch_error: 'Unterauftragsverarbeiter konnten nicht abgerufen werden.',
            processor: 'Auftragsverarbeiter',
            services_csv: 'Dienstleistungen (kommagetrennt)',
            terminate_error: 'Beendigung fehlgeschlagen.',
            version_history_heading: 'Unterprozessor-Änderungsversionierung',
            change_tracking_note: 'Alle Änderungen der Unterauftragsverarbeiterbeziehung werden versioniert. Bei jeder Änderung wird der Vorher-/Nachher-Status für den Prüfpfad aufgezeichnet.',
            history_retention_note: 'Der Änderungsverlauf wird für den gesamten Datenaufbewahrungszeitraum aufbewahrt. Überprüfen Sie Änderungsprotokolle über die Detailansicht des Anbieters.',
            vendor_risk_cross_view_heading: 'Unterauftragsverarbeiter-Register (Vendor Risk)',
            vendor_risk_cross_view_source: 'Quelle: Vendor Risk Register',
            vendor_risk_cross_view_empty: 'Keine Einträge im Vendor Risk-Register.',
        },
        cross_border: {
            title: 'Grenzüberschreitender Steuerungsbericht',
            flows: 'Grenzüberschreitende Flüsse',
            transfers: 'Grenzüberschreitende Übermittlungen',
            detected_gaps: 'Erkannte Lücken',
            safeguards: 'Schutzmaßnahmen',
            cross_border_vendors: 'Grenzüberschreitende Dienstleister',
            destination: 'Ziel',
            no_cross_border_vendors: 'Keine grenzüberschreitenden Dienstleister gefunden.',
            no_safeguard: 'Keine Schutzmaßnahme',
            processing_locations: 'Verarbeitungsstandorte',
            export_error: 'Bericht konnte nicht exportiert werden.',
            export_pdf: 'PDF exportieren',
            export_success: 'Bericht erfolgreich exportiert.',
            exporting: 'Wird exportiert...',
            fetch_error: 'Grenzüberschreitende Daten konnten nicht abgerufen werden.',
            source: 'Quelle',
            pdpl_p2_heading: '[[TOK_0]]-P2 Einhaltung grenzüberschreitender Übermittlungen',
            dossier_prep_note: 'Dossiervorbereitung: Stellen Sie vor der Einreichung eine Folgenabschätzung, eine Rechtsgrundlage und eine Schutzdokumentation zusammen.',
            filing_tracking_note: 'Einreichungsverfolgung: Überwachen Sie den Einreichungsstatus bei der Behörde (PDPC) vom ersten Antrag bis zur Genehmigung.',
            supplement_loop_note: 'Ergänzungsschleife: Reagieren Sie auf Informationsanfragen der Behörde und reichen Sie bei Bedarf geänderte Dossiers erneut ein.',
            official_forms_note: 'Offizielle Formulare: Verwenden Sie Mau so 01a (Antrag), Mau so 01b (Ergänzende Informationen) und Mau so 09 (Übertragungsfolgenabschätzung) gemäß den [[TOK_0]]-P2-Vorschriften.',
            vendor_search_label: 'Anbietersuche',
            vendor_search_placeholder: 'Nach Anbieternamen suchen…',
            jurisdiction_filter_label: 'Gerichtsbarkeit',
            filings_section_heading: 'Grenzüberschreitende Einreichungen',
            filings_empty: 'Noch keine Einreichungen. Erstellen Sie eines, um ein Dossier zu erstellen.',
            filings_create_button: 'Neue Einreichung',
            filings_table_id: 'Anmelde-ID',
            filings_table_jurisdiction: 'Gerichtsstand',
            filings_table_type: 'Formulartyp',
            filings_table_status: 'Status',
            filings_table_updated: 'Aktualisiert',
            filings_table_open: 'Offen',
            filings_detail_title: 'Grenzüberschreitende Einreichung',
            filings_back_to_list: 'Zurück zu Cross-Border',
            filings_status_heading: 'Lebenszyklus',
            filings_evidence_heading: 'Beweise',
            filings_history_heading: 'Audit-Trail',
            filings_field_filing_id: 'Anmelde-ID',
            filings_field_jurisdiction: 'Gerichtsstand',
            filings_field_type: 'Formulartyp',
            filings_field_status: 'Status',
            filings_field_reference: 'Autoritätsreferenz',
            filings_field_mps_receipt: '[[TOK_0]] Quittung',
            filings_field_submitted_at: 'Eingereicht bei',
            filings_field_acknowledged_at: 'Bestätigt bei',
            filings_field_archived_at: 'Archiviert unter',
            filings_field_version: 'Version',
            filings_field_notes: 'Notizen',
            filings_action_advance: 'Vorabstatus',
            filings_action_reject: 'Ablehnen',
            filings_action_archive: 'Archiv',
            filings_action_submit: 'Mark eingereicht',
            filings_action_acknowledge: 'Mark bestätigte',
            filings_action_resume_draft: 'Lebenslauf als Entwurf',
            filings_status_draft: 'Entwurf',
            filings_status_assessed: 'Bewertet',
            filings_status_pending_review: 'Ausstehende Überprüfung',
            filings_status_ready_to_file: 'Bereit zur Einreichung',
            filings_status_submitted: 'Eingereicht',
            filings_status_acknowledged: 'Anerkannt',
            filings_status_rejected: 'Abgelehnt',
            filings_status_archived: 'Archiviert',
            filings_type_mau_01a: 'Mẫu 01a – Transferantrag',
            filings_type_mau_03a: 'Mẫu 03a – Ergänzungsdossier',
            filings_type_mau_09: 'Mẫu 09 – Abschätzung der Transferfolgen',
            filings_new_dialog_title: 'Neue grenzüberschreitende Anmeldung',
            filings_new_form_jurisdiction: 'Gerichtsstand (z. B. VN-[[TOK_0]])',
            filings_new_form_type: 'Formulartyp',
            filings_new_form_notes: 'Notizen (optional)',
            filings_new_submit: 'Erstellen',
            filings_new_cancel: 'Abbrechen',
            filings_reason_label: 'Grund',
            filings_reference_label: 'Referenznummer der Behörde',
            filings_mps_receipt_label: '[[TOK_0]] Belegreferenz',
            filings_create_error: 'Die Datei konnte nicht erstellt werden.',
            filings_create_success: 'Ablage erstellt.',
            filings_update_error: 'Die Einreichung konnte nicht aktualisiert werden.',
            filings_update_success: 'Einreichung aktualisiert.',
            filings_fetch_error: 'Die Einreichungen konnten nicht abgerufen werden.',
            filings_archive_confirm: 'Diese Einreichung archivieren? Dies kann nicht rückgängig gemacht werden.',
            filings_status_rejected_detour: 'Die Einreichung wurde nach Prüfung abgelehnt. Als Entwurf fortsetzen, um den Flow neu zu starten.',
            recent_exports_heading: 'Aktuelle Exporte',
            recent_exports_empty: 'Noch keine Exporte. Klicken Sie auf „[[TOK_0]] exportieren“, um einen zu generieren.',
        },
        drift: {
            title: 'Konfigurationsabweichungsmonitor',
            drift_type: 'Abweichungstyp',
            severity: 'Schweregrad',
            detected_at: 'Erkannt am',
            resolve: 'Beheben',
            all_check_types: 'Alle Prüfungstypen',
            all_entity_types: 'Alle Objekttypen',
            event_count: 'Ereignisanzahl',
            accept_risk: 'Risiko akzeptieren',
            acknowledge: 'Bestätigen',
            assign_error: 'Zuweisung fehlgeschlagen.',
            assign_event: 'Zuweisen',
            assigned: 'Zugewiesen',
            enter_resolution_notes: 'Lösungshinweise eingeben...',
            enter_user_id: 'Benutzer-ID eingeben...',
            entity: 'Objekt',
            fetch_error: 'Abweichungsereignisse konnten nicht abgerufen werden.',
            no_events: 'Keine Abweichungsereignisse gefunden.',
            resolution_notes: 'Lösungshinweise',
            update_status_error: 'Status konnte nicht aktualisiert werden.',
        },
        scores: {
            title: 'Compliance-Bewertungsübersicht',
            overall: 'Gesamt-Compliance-Bewertung',
            breakdown: 'Bewertung nach Modul',
            trend: 'Historischer Trend',
            module: 'Modul',
            score: 'Bewertung',
            grade: 'Note',
            calculated_at: 'Berechnet am',
            generate_board_report: 'Vorstandsbericht erstellen',
            lang_english: 'Englisch',
            lang_vietnamese: 'Vietnamesisch',
            fetch_error: 'Compliance-Bewertungen konnten nicht abgerufen werden.',
            generate_report: 'Bericht erstellen',
            generating: 'Wird erstellt...',
            recommendations: 'Empfehlungen',
            report_error: 'Bericht konnte nicht erstellt werden.',
            factor_owner_assigned: 'Eigentümer zugewiesen',
            factor_data_categories_linked: 'Datenkategorien verknüpft',
            factor_purposes_linked: 'Zwecke verknüpft',
            factor_data_flows_documented: 'Datenflüsse dokumentiert',
            factor_processing_activity_linked: 'Verarbeitungstätigkeit verknüpft',
            factor_dpa_status: 'DPA-Status',
            factor_retention_policy_linked: 'Aufbewahrungsrichtlinie verknüpft',
            factor_last_reviewed: 'Letzte Überprüfung innerhalb der Frist',
            factor_risk_assessment_current: 'Risikobewertung aktuell',
            factor_sub_processors_documented: 'Unterauftragsverarbeiter dokumentiert',
            factor_cross_border_safeguards: 'Grenzüberschreitende Schutzmaßnahmen',
            factor_contact_info_complete: 'Kontaktinformationen vollständig',
            factor_onboarding_approved: 'Onboarding genehmigt',
            factor_avg_system_score: 'Durchschnittlicher Systempunktwert',
            factor_avg_vendor_score: 'Durchschnittlicher Anbieterpunktwert',
            factor_processing_activity_coverage: 'Abdeckung der Verarbeitungstätigkeiten',
            factor_ropa_completeness: 'RoPA-Vollständigkeit',
            factor_open_drift_events: 'Offene Abweichungsereignisse',
        },
        playbooks: {
            title: 'Lösch-Playbooks',
            new: 'Neues Playbook',
            edit: 'Playbook bearbeiten',
            steps: 'Schritte',
            add_step: 'Schritt hinzufügen',
            remove_step: 'Schritt entfernen',
            data_categories_csv: 'Datenkategorien (kommagetrennt)',
            estimated_duration: 'Geschätzte Dauer',
            estimated_duration_label: 'Geschätzte Dauer',
            evidence_description: 'Nachweisbeschreibung',
            no_playbooks: 'Keine Playbooks gefunden.',
            playbook_count: 'Playbook-Anzahl',
            requires_evidence: 'Nachweis erforderlich',
            step_label: 'Schrittbezeichnung',
            target_name: 'Zielname',
            target_type: 'Zieltyp',
            action_type: 'Aktionstyp',
            archive_error: 'Archivierung fehlgeschlagen.',
            confirm_archive: 'Sind Sie sicher, dass Sie dieses Playbook archivieren möchten?',
            data_categories: 'Datenkategorien',
            days: 'Tage',
            fetch_error: 'Playbooks konnten nicht abgerufen werden.',
            sla_days: 'SLA (Tage)',
            target_id: 'Ziel-ID',
            template_class_heading: 'Vorlagenklassifizierung',
            official: 'Offiziell',
            internal: 'Intern',
            classification: 'Klassifizierung',
            official_note: 'Offiziell: behördlich vorgeschriebene Vorlagen, abgestimmt auf [[TOK_1]], [[TOK_0]] oder branchenspezifische Anforderungen.',
            internal_note: 'Intern: Organisationsspezifische Verfahren, die nicht aus regulatorischen Vorlagen abgeleitet sind.',
            active_executions_heading: 'Aktive Ausführungen',
            no_active_executions: 'Keine aktiven Ausführungen.',
            playbook_label: 'Spielbuch',
            ticket_id_label: 'Ticket',
            progress_label: 'Fortschritt',
            actions_label: 'Aktionen',
            view_steps_label: 'Schritte anzeigen',
            execution_detail_title: 'Ausführungsdetails',
            playbook_missing: 'Playbook nicht gefunden.',
            evidence_required_label: 'Nachweis erforderlich',
            upload_evidence_label: 'Nachweis hochladen',
            mark_complete_label: 'Als abgeschlossen markieren',
            evidence_required_toast: 'Bitte Nachweis anhängen, bevor Schritt abgeschlossen wird.',
            evidence_blocking_message: 'Eine Nachweisdatei anhängen, um fortzufahren.',
            step_completed_toast: 'Schritt abgeschlossen.',
            executions_fetch_error: 'Ausführungen konnten nicht geladen werden.',
            step_evidence_default_name: 'Nachweis für Ausführungsschritt',
            attached_evidence_label: 'Angehängte Nachweise',
        },
        approvals: {
            title: 'Genehmigungsworkflows',
            new: 'Neue Genehmigung',
            edit: 'Genehmigung bearbeiten',
            request_type: 'Antragsart',
            requester: 'Antragsteller',
            approve: 'Genehmigen',
            reject: 'Ablehnen',
            justification: 'Begründung',
            all_action_types: 'Alle Aktionstypen',
            decided_by: 'Entschieden von',
            no_approvals: 'Keine Genehmigungen gefunden.',
            approval_count: 'Genehmigungsanzahl',
            approval_notes_optional: 'Anmerkungen (optional)',
            approve_error: 'Genehmigung fehlgeschlagen.',
            approve_request: 'Antrag genehmigen',
            decision: 'Entscheidung',
            entity: 'Objekt',
            fetch_error: 'Genehmigungen konnten nicht abgerufen werden.',
            reject_error: 'Ablehnung fehlgeschlagen.',
            reject_request: 'Antrag ablehnen',
            rejection_notes_required: 'Ablehnungsbegründung erforderlich',
            rejection_notes_required_msg: 'Bitte geben Sie einen Grund für die Ablehnung an.',
            requested_at: 'Angefordert am',
            multi_step_heading: 'Mehrstufiger Genehmigungsworkflow',
            legal_review_note: 'Schritt 1 – Rechtliche Prüfung: Der Rechtsberater prüft die Anfrage auf Einhaltung gesetzlicher Vorschriften.',
            dpo_review_note: 'Schritt 2 – [[TOK_0]] Überprüfung: Der Datenschutzbeauftragte validiert die Auswirkungen auf den Datenschutz.',
            management_review_note: 'Schritt 3 – Genehmigung durch das Management: Die Geschäftsleitung erteilt die endgültige Genehmigung.',
            supporting_evidence_label: 'Unterstützender Nachweis (optional)',
            decision_evidence_name: 'Entscheidungsnachweis',
        },
        evidence: {
            title: 'Steuerungsnachweise',
            new: 'Neuer Nachweis',
            link_to: 'Verknüpfen mit',
            entity_id_placeholder: 'Objekt-ID',
            file_path_placeholder: '/pfad/zur/datei',
            evidence_label: 'Nachweisbezeichnung',
            file_path: 'Dateipfad',
            source_mode_label: 'Nachweisquelle',
            source_mode_file: 'Datei hochladen',
            source_mode_url: 'Externe URL verknüpfen',
            attachment_label: 'Anhang',
            item_count: 'Anzahl Einträge',
            link_button: 'Nachweis verknüpfen',
            confirm_delete: 'Sind Sie sicher, dass Sie diesen Nachweis löschen möchten?',
            enter_entity_id: 'Objekt-ID eingeben...',
            entity_id: 'Objekt-ID',
            entity_type: 'Objekttyp',
            expires: 'Läuft ab',
            expires_at: 'Läuft ab am',
            fetch_error: 'Nachweise konnten nicht abgerufen werden.',
            link_error: 'Nachweis konnte nicht verknüpft werden.',
            no_evidence: 'Keine Nachweise gefunden.',
            tags_csv: 'Tags (kommagetrennt)',
            uploaded: 'Hochgeladen',
            url: 'URL',
            framework_tag_heading: 'Mit Framework markierte Evidenz',
            framework_tag_note: 'Jeder Beweisdatensatz erfasst Framework-Code, Akteur und Zeitstempel. Filtern Sie nach Framework, um prüfungsrelevante Datensätze zu isolieren.',
            framework_code: 'Rahmencode',
            filter_by_framework: 'Nach Framework-Code filtern...',
            actor: 'Schauspieler',
        },
        certification: {
            not_applicable: 'Nicht zutreffend',
            not_certified: 'Nicht zertifiziert',
            pending: 'Ausstehend',
            certified: 'Zertifiziert',
            revoked: 'Widerrufen',
        },
        onboarding_pipeline: {
            title: 'Onboarding-Pipeline',
            new_workflow: 'Neuer Onboarding-Workflow',
            vendor_id: 'Lieferanten-ID',
            stages: 'Phasen',
            current_stage: 'Aktuelle Phase',
            advance: 'Phase vorantreiben',
            advance_success: 'Phase erfolgreich vorangetrieben',
            workflow_status: 'Workflow-Status',
            initiated: 'Eingeleitet',
            in_progress: 'In Bearbeitung',
            completed: 'Abgeschlossen',
            cancelled: 'Abgebrochen',
            no_workflows: 'Keine Onboarding-Workflows gefunden',
            stages_placeholder: 'Phase 1, Phase 2, Phase 3',
            assigned_to: 'Zugewiesen an',
            notes: 'Notizen',
            pdpl_lifecycle_heading: '[[TOK_0]] Lieferantenlebenszyklus – Onboarding',
            due_diligence_note: 'Vor der Einbindung eines Auftragsverarbeiters gemäß [[TOK_0]] ist eine Due-Diligence-Phase obligatorisch. Überprüfen Sie den Umfang der Datenverarbeitung, die Rechtsgrundlage und die Sicherheitsmaßnahmen.',
            contract_review_note: 'Bei der Vertragsprüfung müssen DPA-Klauseln, Beschränkungen der Datenaufbewahrung und Beschränkungen für Unterauftragsverarbeiter bestätigt werden.',
            create_dpa_review_cta: 'DPA-Prüfung erstellen',
            dpa_review_linked: 'DPA-Prüfung verknüpft',
        },
        dpa_review: {
            title: 'DPA-Prüfungen',
            new_review: 'Neue DPA-Prüfung',
            review_type: 'Prüfungstyp',
            findings: 'Ergebnisse',
            outcome: 'Ergebnis',
            complete_review: 'Prüfung abschließen',
            complete_success: 'Prüfung erfolgreich abgeschlossen',
            link_assessment: 'Sicherheitsbewertung verknüpfen',
            link_success: 'Bewertung erfolgreich verknüpft',
            assessment_id: 'Bewertungs-ID',
            combined_title: 'Kombinierte Bewertung',
            no_reviews: 'Keine DPA-Prüfungen gefunden',
            telecom_disclosure_heading: 'Offenlegungs-Governance im Telekommunikationsbereich',
            disclosure_trigger_note: 'Durch Offenlegung ausgelöste Überprüfungen erfassen Ereignisse zur Weitergabe von Daten von Telekommunikationsteilnehmern gemäß dem VN-Telekommunikationsgesetz.',
            telecom_t2_note: 'Vor der Offenlegung von Abonnentendaten an Behörden ist eine TELECOM-T2-Stufengenehmigung erforderlich.',
            quarterly_log_note: 'Nutzen Sie das vierteljährliche Protokoll, um alle Offenlegungsereignisse zu dokumentieren und einen kontinuierlichen Prüfpfad zu führen.',
        },
        periodic_review: {
            title: 'Periodische Prüfungen',
            new_review: 'Neue periodische Prüfung',
            review_type: 'Prüfungstyp',
            due_date: 'Fälligkeitsdatum',
            next_review: 'Nächster Prüfungstermin',
            trigger_reassessment: 'Neubewertung auslösen',
            reassessment_reason: 'Grund für Neubewertung',
            reassessment_success: 'Neubewertung erfolgreich ausgelöst',
            complete_success: 'Prüfung erfolgreich abgeschlossen',
            scheduled: 'Geplant',
            in_progress: 'In Bearbeitung',
            completed: 'Abgeschlossen',
            overdue: 'Überfällig',
            material_change: 'Wesentliche Änderung',
            no_reviews: 'Keine periodischen Prüfungen gefunden',
            mark_complete: 'Als abgeschlossen markieren',
            pdpl_periodic_heading: '[[TOK_0]] Lieferantenlebenszyklus – Regelmäßige Überprüfungen',
            scheduled_review_note: 'Regelmäßige Überprüfungen müssen mindestens einmal im Jahr für alle aktiven Auftragsverarbeiter angesetzt werden. Überfällige Überprüfungen lösen Compliance-Warnungen aus.',
            material_change_note: 'Wesentliche Änderungen in der Datenverarbeitung erfordern unabhängig vom Zeitplan eine sofortige Neubewertung.',
            overdue_badge: 'Überfällig',
            overdue_aria: 'Überfällige Prüfung',
            only_overdue_filter: 'Nur überfällige',
        },
        offboarding: {
            title: 'Lieferanten-Offboarding',
            initiate: 'Offboarding einleiten',
            initiate_success: 'Offboarding erfolgreich eingeleitet',
            reason: 'Offboarding-Grund',
            data_return_required: 'Datenrückgabe erforderlich',
            verify_data: 'Datenrückgabe überprüfen',
            verify_success: 'Datenrückgabe erfolgreich überprüft',
            sign_off: 'Abzeichnen',
            sign_off_success: 'Offboarding erfolgreich abgezeichnet',
            status_initiated: 'Eingeleitet',
            status_data_pending: 'Datenrückgabe ausstehend',
            status_data_verified: 'Datenrückgabe überprüft',
            status_completed: 'Abgeschlossen',
            status_cancelled: 'Abgebrochen',
            task_id: 'Aufgaben-ID',
            no_tasks: 'Keine Offboarding-Aufgaben gefunden',
            evidence_id: 'Nachweis-ID',
            pdpl_offboarding_heading: '[[TOK_0]] Lieferantenlebenszyklus – Offboarding und Löschung',
            deletion_capture_note: 'Beim Offboarding muss die Bestätigung der Datenlöschung vom Anbieter eingeholt werden. Überprüfen Sie die Datenrückgabe vor der Freigabe.',
            evidence_attachment_note: 'Fügen Sie Löschnachweise (Zertifikate, Screenshots, Lieferantenbestätigungen) bei, um den Offboarding-Datensatz zu vervollständigen.',
            verify_mode_label: 'Verifizierungsmethode',
            verify_mode_upload: 'Neue Datei hochladen',
            verify_mode_link: 'Vorhandenen Nachweis verknüpfen',
            verify_mode_none: 'Keine Daten zurückzugeben',
            upload_data_return_evidence: 'Nachweis für Datenrückgabe hochladen',
            no_data_justification_label: 'Begründung',
            no_data_justification_placeholder: 'Erkläre, warum keine Daten zurückzugeben sind',
            no_data_justification_hint: 'Mindestens 20 Zeichen',
            upload_required_toast: 'Bitte Datei anhängen, um fortzufahren',
            evidence_link_required_toast: 'Bitte Nachweis auswählen, um fortzufahren',
            no_data_justification_required_toast: 'Bitte Begründung mit mindestens 20 Zeichen',
            data_return_evidence_name: 'Nachweis für Datenrückgabe',
        },
        dpa_review_types: {
            initial: 'Erstbewertung',
            annual: 'Jährlich',
            renewal: 'Erneuerung',
            incident_triggered: 'Vorfallsbedingt',
        },
        periodic_review_types: {
            initial: 'Erstprüfung',
            annual: 'Jährlich',
            renewal: 'Erneuerung',
            incident_triggered: 'Vorfallsbedingt',
            material_change: 'Wesentliche Änderung',
            disclosure_triggered: 'Offenlegungsbedingt',
            quarterly_log: 'Quartalsbericht',
        },
        dpa_review_statuses: {
            pending: 'Ausstehend',
            in_progress: 'In Bearbeitung',
            completed: 'Abgeschlossen',
            cancelled: 'Storniert',
        },
        onboarding_stage_names: {
            due_diligence: 'Sorgfaltsprüfung',
            contract_review: 'Vertragsprüfung',
            security_assessment: 'Sicherheitsbewertung',
            data_mapping: 'Datenzuordnung',
            approval: 'Genehmigung',
            integration: 'Integration',
        },
        access_denied_title: 'Zugriff verweigert',
        access_denied: 'Sie haben keine Berechtigung, diese Seite anzuzeigen. Bitte kontaktieren Sie Ihren Administrator.',
    },
    consent: {
        nav: {
            policies: 'Richtlinien',
            purposes: 'Zweckkatalog',
            workflows: 'Arbeitsabläufe',
            snapshots: 'CMP-Snapshots',
            change_awareness: 'Änderungserkennung',
            audit: 'Einwilligungs-Audit',
        },
        gap_analysis: {
            nav_label: 'Lückenanalyse',
            page_title: 'Analyse der Einwilligungslücke',
            page_subtitle: 'Forseti prüft Ihre aktiven Einwilligungszwecke anhand der Anforderungen des installierten Frameworks ([[TOK_0]] Art.7 + Art.6 + Art.9, [[TOK_1]] Art.13 + Art.20, PIPL Art.13 + Art.29) und deckt Lücken mit Zitat + vorgeschlagener Abhilfe auf.',
            framework_picker_label: 'Rahmenwerke',
            org_flags_label: 'Organisationskontext',
            flag_withdrawal: 'Verfügt über einen dokumentierten globalen Auszahlungsmechanismus',
            flag_parental: 'Hat die Zustimmung der Eltern für unter 16-Jährige',
            flag_cross_border: 'Hat grenzüberschreitende Einreichungen registriert',
            run_label: 'Lauflückenanalyse',
            running_label: 'Laufen…',
            requires_advisor_label: 'Erfordert ai_advisor:Chat-Berechtigung.',
            results_heading: 'Lücken aufgetaucht ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]] Token',
            empty_label: 'Für die ausgewählten Frameworks wurden keine Lücken erkannt.',
            remediation_label: 'Empfohlene Abhilfe:',
            dismiss_label: 'Als nicht zutreffend ablehnen',
            resolve_label: 'Lösen',
            dismissed_label: 'Als nicht zutreffend abgewiesen',
            resolved_label: 'Gelöst',
        },
        import: {
            title: 'Einwilligungs-Workflows importieren',
            nav_title: 'Massenimport',
            description: 'Laden Sie eine CSV-Datei hoch, um Einwilligungs-Workflows in Massen zu importieren.',
            select_file: 'CSV-Datei auswählen',
            file_help: 'CSV mit Überschriften, die den Workflow-Feldern entsprechen.',
            required_columns_help: 'Erforderliche Spalten: Workflow-Typ, Betroffene Person, Kanal.',
            file_too_large: 'Datei zu groß. Maximale Größe ist 2MB.',
            preview: 'Vorschau',
            columns_detected: 'Erkannte Spalten: {count}',
            column_mapping: 'Spaltenzuordnung',
            import_button: 'Importieren',
            import_complete: 'Import abgeschlossen',
            import_error: 'Import fehlgeschlagen',
            result: 'Importergebnis',
            total: 'Gesamt',
            imported: 'Importiert',
            skipped: 'Übersprungen',
            failed: 'Fehlgeschlagen',
            errors: 'Fehler',
            error_row: 'Zeile',
            error_field: 'Feld',
            error_message: 'Nachricht',
            history: 'Importverlauf',
            no_history: 'Kein Importverlauf.',
            history_file: 'Dateiname',
            history_date: 'Datum',
            create_profiles_label: 'Profile für Betroffene Personen für neue Subjekte erstellen',
            create_profiles_help: 'Importe ohne passendes Profil erstellen automatisch eines. Deaktivieren, um nur Workflows zu importieren.',
            profiles_created: 'Profile erstellt',
            profiles_matched: 'Profile zugeordnet',
            subject_kind_help: 'Optionale Spalten: subject_kind, subject_email, subject_display_name, subject_phone, external_ref_key.',
            error_subject_invalid_email: 'Ungültige E-Mail-Adresse in Spalte subject_email.',
            error_subject_unknown_kind: 'Unbekannter Wert für subject_kind. Erwartet: email, visitor_uuid, employee_id, student_id, external_ref.',
            error_missing_external_ref_key: 'external_ref_key ist erforderlich, wenn subject_kind=external_ref',
        },
        policies: {
            title: 'Einwilligungsrichtlinien',
            new: 'Neue Richtlinie',
            edit: 'Richtlinie bearbeiten',
            name: 'Bezeichnung',
            version: 'Fassung',
            policy_text: 'Richtlinientext',
            publish: 'Veröffentlichen',
            versions: 'Versionen',
            hide_versions: 'Versionen ausblenden',
            submit_for_review: 'Zur Prüfung einreichen',
            suspend: 'Aussetzen',
            retire: 'Zurückziehen',
            jurisdictions: 'Rechtsordnungen',
            jurisdictions_csv: 'Rechtsordnungen (kommagetrennt)',
            approval_mode: 'Genehmigungsmodus',
            reviewer_ids: 'Prüfer-IDs (kommagetrennt)',
            tags_csv: 'Tags (kommagetrennt)',
            effective_date: 'Gültigkeitsdatum',
            review_date: 'Überprüfungsdatum',
            consent_model_statement: 'Einwilligungsmodell-Erklärung',
            consent_model_placeholder: 'Optionale Einwilligungsmodell-Erklärung...',
            default_settings: 'Standardeinstellungen (JSON)',
            changes: 'Änderungen',
            fetch_error: 'Fehler beim Abrufen der Einwilligungsrichtlinien. Bitte versuchen Sie es erneut.',
            save_error: 'Fehler beim Speichern der Einwilligungsrichtlinie. Bitte versuchen Sie es erneut.',
            submit_review_error: 'Fehler beim Einreichen der Richtlinie zur Prüfung. Bitte versuchen Sie es erneut.',
            activate_error: 'Fehler beim Aktivieren der Richtlinie. Bitte versuchen Sie es erneut.',
            suspend_error: 'Fehler beim Aussetzen der Richtlinie. Bitte versuchen Sie es erneut.',
            retire_error: 'Fehler beim Zurückziehen der Richtlinie. Bitte versuchen Sie es erneut.',
            submit_review_success: 'Richtlinie zur Überprüfung eingereicht.',
            activate_success: 'Richtlinie aktiviert.',
            suspend_success: 'Richtlinie ausgesetzt.',
            retire_success: 'Die Police wurde zurückgezogen.',
            versions_error: 'Fehler beim Abrufen der Richtlinienversionen. Bitte versuchen Sie es erneut.',
            invalid_json: 'Ungültiges JSON im Feld Standardeinstellungen. Bitte versuchen Sie es erneut.',
            page_title: 'Einwilligungsrichtlinien',
            version_updated: 'Aktualisiert',
            version_initial: 'Erste Version',
            json_format: '[[TOK_0]]-Format',
            sensitive: 'Empfindlich',
            flag_sensitive: 'Sensibel kennzeichnen',
            flag_sensitive_title: 'Markieren Sie die Richtlinie als vertraulich',
            require_enhanced_review: 'Erfordern eine erweiterte Überprüfung',
            enhanced_review_success: 'Erweiterte Überprüfungsanforderung aktiviert.',
            select_categories: 'Wählen Sie die anwendbaren [[TOK_0]] Kategorien sensibler Daten gemäß Artikel 2 aus:',
            no_policies: 'Keine Einwilligungsrichtlinien gefunden. Erstellen Sie Ihre erste Richtlinie, um zu beginnen.',
            approval_success: 'Richtlinie genehmigt.',
            reviewers_label: 'Prüfer',
            enhanced_review_title: 'Erweiterte Überprüfung erforderlich',
            enhanced_review_badge: 'Erweiterte Überprüfung erforderlich',
            enhanced_review_status_pending: 'Überprüfung ausstehend',
            enhanced_review_status_approved: 'Überprüfung genehmigt',
            enhanced_review_status_rejected: 'Überprüfung abgelehnt',
            enhanced_review_reviewed_by: 'Überprüft von',
            enhanced_review_notes: 'Überprüfungsnotizen',
            enhanced_review_approve: 'Überprüfung genehmigen',
            enhanced_review_reject: 'Überprüfung ablehnen',
            enhanced_review_notes_required: 'Überprüfungsnotizen sind erforderlich',
            enhanced_review_approved: 'Erweiterte Überprüfung genehmigt',
            enhanced_review_rejected: 'Erweiterte Überprüfung abgelehnt — Richtlinie auf Entwurf zurückgesetzt',
            enhanced_review_reset_to_draft: 'Erweiterte Überprüfung abgelehnt — Richtlinie auf Entwurf zurückgesetzt',
            enhanced_review_reject_warning: 'Die Ablehnung setzt diese Richtlinie auf den Status Entwurf zurück. Der DSB muss sie nach Behebung der Probleme erneut einreichen.',
            submitted_modal_title: 'Zur erweiterten Überprüfung eingereicht',
            submitted_modal_body: 'Diese Richtlinie wurde eingereicht. Ein Rechts-/Datenschutzprüfer muss sie genehmigen, bevor sie aktiviert werden kann.',
        },
        sensitive_categories: {
            health: 'Gesundheitsdaten',
            biometric: 'Biometrische Daten',
            political: 'Politische Meinungen',
            ethnic: 'Ethnische Herkunft',
            genetic: 'Genetische Daten',
            criminal: 'Strafregister',
        },
        purposes: {
            title: 'Zweckkatalog',
            new: 'Neuer Zweck',
            edit: 'Zweck bearbeiten',
            name: 'Bezeichnung',
            legal_basis: 'Rechtsgrundlage',
            retention_days: 'Aufbewahrungsfrist (Tage)',
            is_active: 'Aktiv',
            filter_by_category: 'Nach Kategorie filtern',
            policy_ids: 'Richtlinien-IDs (kommagetrennt)',
            ropa_activity_ids: 'ROPA-Tätigkeits-IDs (kommagetrennt)',
            policies: 'Richtlinien',
            deprecate: 'Veralten',
            fetch_error: 'Fehler beim Abrufen der Einwilligungszwecke. Bitte versuchen Sie es erneut.',
            save_error: 'Fehler beim Speichern des Einwilligungszwecks. Bitte versuchen Sie es erneut.',
            deprecate_error: 'Fehler beim Veralten des Einwilligungszwecks. Bitte versuchen Sie es erneut.',
            page_title: 'Zweckkatalog',
            no_purposes: 'Keine Einwilligungszwecke gefunden. Erstellen Sie Ihren ersten Zweck, um zu beginnen.',
            category_personal_data: 'Persönliche Daten',
            category_sensitive_data: 'Sensible Daten',
            category_health_data: 'Gesundheitsdaten',
            category_financial_data: 'Finanzdaten',
            category_biometric_data: 'Biometrische Daten',
            category_children_data: 'Kinderdaten',
            category_location_data: 'Standortdaten',
            category_communications_data: 'Kommunikationsdaten',
            category_other: 'Andere',
        },
        workflows: {
            title: 'Einwilligungs-Workflows',
            new: 'Neuer Workflow',
            edit: 'Workflow bearbeiten',
            workflow_type: 'Workflow-Typ',
            user_id: 'Benutzer-ID',
            purpose_id: 'Zweck-ID',
            purpose_ids_csv: 'Zweck-ID (kommagetrennt)',
            reason: 'Grund',
            process: 'Verarbeiten',
            data_subject_ref: 'Betroffenenreferenz',
            data_subject: 'Betroffene Person',
            channel: 'Kanal',
            policy_id: 'Richtlinien-ID',
            scope: 'Umfang',
            legal_grounds: 'Rechtsgrundlagen',
            assessment: 'Bewertung',
            select_outcome: 'Ergebnis auswählen',
            partially_approved: 'Teilweise genehmigt',
            denied: 'Abgelehnt',
            outcome_upheld: 'Bestätigt',
            outcome_pending: 'Ausstehend',
            outcome_denied: 'Abgelehnt',
            status_count: 'Statusanzahl',
            channel_filter: 'Nach Kanal filtern',
            add_action: '+ Aktion',
            by_type: 'Nach Typ',
            by_status: 'Nach Status',
            downstream_actions: 'Folgemaßnahmen',
            downstream_actions_for: 'Folgemaßnahmen für {subject} ({type})',
            add_downstream_action: 'Folgemaßnahme hinzufügen',
            assigned_to: 'Zugewiesen an',
            fetch_error: 'Fehler beim Abrufen der Einwilligungs-Workflows. Bitte versuchen Sie es erneut.',
            dashboard_error: 'Fehler beim Abrufen der Workflow-Übersicht. Bitte versuchen Sie es erneut.',
            save_error: 'Fehler beim Speichern des Einwilligungs-Workflows. Bitte versuchen Sie es erneut.',
            status_update_error: 'Fehler beim Aktualisieren des Workflow-Status. Bitte versuchen Sie es erneut.',
            assessment_error: 'Fehler beim Aktualisieren der Workflow-Bewertung. Bitte versuchen Sie es erneut.',
            add_action_error: 'Fehler beim Hinzufügen der Workflow-Aktion. Bitte versuchen Sie es erneut.',
            update_action_error: 'Fehler beim Aktualisieren der Workflow-Aktion. Bitte versuchen Sie es erneut.',
            type_refusal: 'Verweigerung',
            type_withdrawal: 'Widerruf',
            type_restriction: 'Einschränkung',
            type_objection: 'Widerspruch',
            status_received: 'Eingegangen',
            status_processing: 'In Bearbeitung',
            status_under_assessment: 'In Bewertung',
            status_implemented: 'Umgesetzt',
            evidence_button: 'Beweise',
            evidence_modal_title: 'Workflow-Beweise',
            no_evidence: 'Diesem Arbeitsablauf sind keine Beweise beigefügt.',
            upload_evidence_label: 'Laden Sie Workflow-Beweise hoch',
            completed_at: 'Abgeschlossen am',
            effective_date: 'Datum des Inkrafttretens',
            page_title: 'Einwilligungsworkflows',
            no_workflows: 'Keine Einwilligungs-Workflows gefunden. Workflows werden erstellt, wenn Betroffene ihre Rechte ausüben.',
            type_grant: 'Erteilung',
            propagation_none: 'Keine',
            propagation_pending: 'Ausstehend',
            propagation_pending_warning: 'Abschluss nicht möglich — Widerrufsweitergabe noch ausstehend',
            propagation_completed: 'Abgeschlossen',
            propagation_partial: 'Teilweise',
            propagation_incomplete_error: 'Workflow kann nicht abgeschlossen werden, solange die Widerrufsweitergabe noch aussteht',
            propagation_status: 'Weitergabestatus',
        },
        snapshots: {
            title: 'CMP-Snapshots',
            new: 'Neuer Snapshot',
            label: 'Bezeichnung',
            snapshot_date: 'Snapshot-Datum',
            purposes_count: 'Anzahl Zwecke',
            compare: 'Vergleichen',
            snapshot_data: 'Snapshot-Daten (JSON)',
            select_left: 'Linken Snapshot auswählen',
            select_right: 'Rechten Snapshot auswählen',
            comparison_results: 'Vergleichsergebnisse',
            field: 'Feld',
            left: 'Links',
            right: 'Rechts',
            close_comparison: 'Vergleich schließen',
            trigger: 'Auslöser',
            trigger_manual: 'Manuell',
            trigger_policy_approval: 'Richtliniengenehmigung',
            cmp_version: 'CMP-Version',
            policy_version_id: 'Richtlinienversions-ID',
            banner_config: 'Banner-Konfiguration (JSON)',
            active_purposes: 'Aktive Zwecke (JSON)',
            active_legal_bases: 'Aktive Rechtsgrundlagen (JSON)',
            domain_scope: 'Domain-Umfang',
            domain_scope_csv: 'Domain-Umfang (kommagetrennt)',
            raw_config: 'Rohkonfiguration (JSON)',
            checksum: 'Prüfsumme',
            created: 'Erstellt',
            fetch_error: 'Fehler beim Abrufen der CMP-Snapshots. Bitte versuchen Sie es erneut.',
            save_error: 'Fehler beim Speichern des CMP-Snapshots. Bitte versuchen Sie es erneut.',
            compare_error: 'Fehler beim Vergleichen der Snapshots. Bitte versuchen Sie es erneut.',
            page_title: 'Einwilligungs-Snapshots',
            json_format: '[[TOK_0]]-Format',
            json_array_format: '[[TOK_0]] Array-Format',
            manual_snapshot_note: 'Nur für Administratoren/Entwickler. Im normalen Betrieb werden Snapshots automatisch über den CMP-Webhook oder bei Richtliniengenehmigung erstellt. Fügen Sie den JSON direkt aus Ihrem CMP-Anbieter ein (z.B. OneTrust, Cookiebot).',
            banner_config_hint: 'Fügen Sie das Banner-Konfigurationsobjekt aus Ihrem CMP-Export ein.',
            active_purposes_hint: 'JSON-Array der aktiven Zweck-Objekte aus Ihrem CMP-Export.',
            active_legal_bases_hint: 'JSON-Array der aktiven Rechtsgrundlagen-Objekte aus Ihrem CMP-Export.',
            raw_config_hint: 'Vollständige rohe Konfigurations-JSON von Ihrem CMP. Andere JSON-Felder werden daraus extrahiert. Eine SHA-256-Prüfsumme wird automatisch berechnet.',
            changed_field: 'Geändertes Feld: ',
            no_snapshots: 'Keine CMP-Snapshots gefunden. Snapshots werden erstellt, wenn Richtlinien genehmigt oder manuell ausgelöst werden.',
            detail_title: 'Snapshot-Detail',
            view_snapshot_detail: 'Snapshot-Detail anzeigen',
            policy_version: 'Richtlinienversion',
            removed: 'Vorher',
            added: 'Nachher',
        },
        change_awareness: {
            title: 'Einwilligungsänderungserkennung',
            change_type: 'Änderungstyp',
            entity_type: 'Objekttyp',
            entity_id: 'Objekt-ID',
            detected_at: 'Erkannt am',
            acknowledge: 'Bestätigen',
            new_alert: 'Neue Warnung',
            new_alert_form: 'Neue Änderungserkennungswarnung',
            total_open: 'Gesamt offen',
            by_severity: 'Nach Schweregrad',
            snapshot_id: 'Snapshot-ID',
            update_status: 'Status aktualisieren',
            resolution_notes: 'Lösungshinweise',
            resolution_required: 'Lösungshinweise (erforderlich)',
            resolution_required_msg: 'Lösungshinweise sind bei der Behebung eines Elements erforderlich.',
            status_open: 'Offen',
            status_under_review: 'In Überprüfung',
            status_resolved: 'Behoben',
            status_accepted: 'Akzeptiert',
            severity_informational: 'Informativ',
            severity_requires_review: 'Überprüfung erforderlich',
            severity_policy_violation: 'Richtlinienverstoß',
            create_reconciliation: 'Abstimmungsaufgabe erstellen',
            reconciliation_created: 'Abstimmungsaufgabe erfolgreich erstellt.',
            reconciliation_error: 'Die Abgleichsaufgabe konnte nicht erstellt werden. Bitte versuchen Sie es erneut.',
            fetch_error: 'Fehler beim Abrufen der Änderungserkennungselemente. Bitte versuchen Sie es erneut.',
            dashboard_error: 'Fehler beim Abrufen der Änderungserkennungsübersicht. Bitte versuchen Sie es erneut.',
            create_error: 'Fehler beim Erstellen des Änderungserkennungselements. Bitte versuchen Sie es erneut.',
            status_update_error: 'Fehler beim Aktualisieren des Änderungserkennungsstatus. Bitte versuchen Sie es erneut.',
            page_title: 'Bewusstsein ändern',
            no_items: 'Keine Änderungsbewusstseinselemente gefunden. Elemente werden erstellt, wenn Änderungen in der Einwilligungskonfiguration erkannt werden.',
        },
        audit: {
            title: 'Einwilligungs-Prüfpfad',
            event_type: 'Ereignistyp',
            user_id: 'Benutzer-ID',
            timestamp: 'Zeitstempel',
            details: 'Einzelheiten',
            actor: 'Akteur',
            filter_by_entity_type: 'Nach Objekttyp filtern',
            filter_by_action: 'Nach Aktion filtern',
            fetch_error: 'Fehler beim Abrufen des Einwilligungs-Prüfpfads. Bitte versuchen Sie es erneut.',
            page_title: 'Einwilligungsprüfung',
            export_csv: 'Exportieren [[TOK_0]]',
            exporting: 'Exportieren…',
            export_success: 'Audit-Trail erfolgreich exportiert.',
            export_error: 'Der Export des Einwilligungs-Prüfprotokolls ist fehlgeschlagen. Bitte versuchen Sie es erneut.',
            no_entries: 'Keine Audit-Einträge gefunden. Audit-Ereignisse werden automatisch aufgezeichnet, wenn sich Einwilligungsdaten ändern.',
            entity_policy: 'Richtlinie',
            entity_purpose: 'Zweck',
            entity_workflow: 'Arbeitsablauf',
            entity_consent_record: 'Einwilligungsdatensatz',
            entity_change_awareness: 'Änderungsbewusstsein',
            entity_cmp_snapshot: 'CMP-Schnappschuss',
            action_created: 'Erstellt',
            action_updated: 'Aktualisiert',
            action_status_changed: 'Status geändert',
            action_drift_detected: 'Abweichung erkannt',
            action_snapshot_created: 'Schnappschuss erstellt',
            action_approval_submitted: 'Genehmigung eingereicht',
            action_archived: 'Archiviert',
            action_purpose_auto_mapped: 'Zweck automatisch zugeordnet',
            action_purpose_mapping_updated: 'Zweckzuordnung aktualisiert',
            action_webhook_configured: 'Webhook konfiguriert',
            entity_propagation: 'Vermehrung',
            entity_reconciliation: 'Versöhnung',
            action_propagation_confirmed: 'Ausbreitung bestätigt',
            action_propagation_failed: 'Die Weitergabe ist fehlgeschlagen',
            action_consent_captured: 'Einwilligung erfasst',
            action_reconciliation_created: 'Versöhnung erstellt',
            action_reconciliation_resolved: 'Versöhnung gelöst',
            action_submitted_for_review: 'Zur Überprüfung eingereicht',
            action_activated: 'Aktiviert',
            action_suspended: 'Ausgesetzt',
            action_retired: 'Außer Betrieb genommen',
            action_enhanced_review_required: 'Erweiterte Überprüfung erforderlich',
            action_enhanced_review_approved: 'Erweiterte Überprüfung genehmigt',
            action_enhanced_review_rejected: 'Erweiterte Überprüfung abgelehnt — Richtlinie auf Entwurf zurückgesetzt',
            action_consented: 'Zugestimmt',
            action_consented_customize: 'Einwilligung angepasst',
            action_revoked: 'Widerrufen',
            action_rejected: 'Abgelehnt',
        },
        web_records: {
            title: 'Aufzeichnungen zur Web-Einwilligung',
            page_title: 'Aufzeichnungen zur Web-Einwilligung',
            domain: 'Domäne',
            visitor_id: 'Besucherausweis',
            consent_action: 'Einwilligungsaktion',
            received_at: 'Erhalten am',
            admin_status: 'Admin-Status',
            revoke: 'Widerrufen',
            reject: 'Ablehnen',
            reason: 'Grund',
            reason_placeholder: 'Grund für diese Aktion (optional)',
            revoke_confirm: 'Diesen Einwilligungsdatensatz widerrufen?',
            reject_confirm: 'Diesen Einwilligungsdatensatz ablehnen?',
            override_success: 'Datensatzstatus erfolgreich aktualisiert.',
            override_error: 'Datensatzstatus konnte nicht aktualisiert werden.',
            no_records: 'Es wurden keine Web-Einwilligungsdatensätze gefunden.',
            fetch_error: 'Web-Zustimmungsdatensätze konnten nicht geladen werden.',
            filter_by_domain: 'Nach Domäne filtern',
            filter_by_action: 'Nach Aktion filtern',
            active: 'Aktiv',
        },
        legal_bases: {
            all: 'Alle Rechtsgrundlagen',
            consent: 'Einwilligung',
            legitimate_interest: 'Berechtigtes Interesse',
            contract: 'Vertrag',
            legal_obligation: 'Rechtliche Verpflichtung',
            vital_interest: 'Lebenswichtiges Interesse',
            public_interest: 'Öffentliches Interesse',
        },
        common_statuses: {
            suspended: 'Ausgesetzt',
            retired: 'Zurückgezogen',
            deprecated: 'Veraltet',
        },
        approval_modes: {
            all: 'Alle',
            any: 'Beliebig',
        },
        cmp_integration: {
            title: 'AesirX CMP-Integration',
            back_to_consent: 'Back zu Einwilligung',
            back_to_integration: 'Back zu Integration',
            webhook_status: 'Webhook-Status',
            events_received: 'Ereignisse Empfangen',
            web_consent_records: 'Web Einwilligung Datensätze',
            unmapped_purposes: 'Nicht zugeordnet Zwecke',
            integration_management: 'Integration Verwaltung',
            webhook_configuration: 'Webhook Konfiguration',
            webhook_config_desc: 'Konfigurieren der CMP Webhook endpoint und manage der HMAC secret.',
            purpose_mapping: 'Zweck Zuordnung',
            purpose_mapping_desc: 'Zuordnen CMP purpose identifiers zu GRC Einwilligung catalog purposes.',
            bulk_sync: 'Massen Synchronisierung',
            bulk_sync_desc: 'Importieren historical Einwilligung Daten und view Synchronisierung history.',
            consent_analytics: 'Web Einwilligung Analytics (Last 30 Days)',
            consent_grant_rate: 'Einwilligung Grant Rate',
            top_domain: 'Top Domäne',
            records: 'Datensätze',
            banner_interactions: 'Banner-Interaktionen',
            consent_actions: 'Einwilligungsaktionen',
            opt_in_trend: 'Einwilligung/Abmeldung-Trend',
            records_by_domain: 'Datensätze nach Domäne',
            date: 'Datum',
            grants: 'Gewährungen',
            denials: 'Ablehnungen',
            not_configured: 'Nicht Configured',
            load_error: 'Fehler beim load Integration Daten',
            webhook_not_configured: 'Webhook nicht konfiguriert.',
            webhook_not_configured_msg: 'Bitte {link} first.',
            configure_webhook_link: 'konfigurieren der Webhook',
            setup_wizard: 'Einrichten Wizard',
            step_configure_webhook: 'Konfigurieren Webhook',
            step_map_purposes: 'Zuordnen Zwecke',
            step_run_sync: 'Ausführen Erstmalig Massen Synchronisierung',
            step_verify_data: 'Verifizieren Daten in Dashboard',
            configure: 'Konfigurieren',
            view_dashboard: 'Ansehen Dashboard',
            syncing: 'Synchronisiere...',
            sync_now: 'Synchronisierung Now',
            sync_completed: 'Synchronisierung completed: {imported} imported, {skipped} skipped, {failed} fehlgeschlagen.',
            sync_failed: 'Synchronisierung fehlgeschlagen',
            last_sync_result: 'Letzter Synchronisierung Result',
            imported: 'Importiert',
            skipped: 'Übersprungen',
            errors: 'Fehler',
            index: 'Verzeichnis',
            error: 'Fehler',
            sync_history: 'Synchronisierung Verlauf',
            no_sync_jobs: 'No Synchronisierung jobs recorded yet.',
            load_sync_error: 'Fehler beim load Synchronisierung Daten',
            purpose_mapping_title: 'CMP Zweck Zuordnung',
            auto_mapping: 'Automatische Zuordnung...',
            auto_map_purposes: 'Auto-Map Zwecke',
            unmapped_warning: '[[TOK_1]] nicht zugeordnete(r) Zweck(e) – diese [[TOK_2]] Zwecke müssen GRC-Zwecken zugeordnet werden.',
            mapping_saved: 'Zuordnung saved.',
            mapping_deleted: 'Zuordnung deleted.',
            auto_map_complete: 'Auto-map abgeschlossen: {mapped} mapped, {unmatched} unmatched.',
            auto_map_failed: 'Auto-map fehlgeschlagen',
            save_mapping_error: 'Fehler beim save Zuordnung',
            delete_mapping_error: 'Fehler beim delete Zuordnung',
            load_data_error: 'Fehler beim load Daten',
            cmp_purpose: 'CMP Zweck',
            grc_purpose: 'GRC Zweck',
            select_grc_purpose: '-- Auswählen GRC Zweck --',
            auto_mapped: 'Automatisch zugeordnet',
            mapped: 'Zugeordnet',
            unmapped: 'Nicht zugeordnet',
            no_mappings: 'Keine Zweckzuordnungen gefunden. Zuordnungen werden automatisch erstellt, wenn Einwilligungsereignisse empfangen werden.',
            total_mappings: 'Gesamt: {count} mapping(s)',
            webhook_config_title: 'Webhook Konfiguration',
            current_configuration: 'Aktuell Konfiguration',
            setup_webhook: 'Einrichten Webhook',
            setup_webhook_desc: 'Konfigurieren der AesirX CMP Webhook zu receive Einwilligung Ereignisse.',
            allowed_domains: 'Erlaubt Domänen (one per line)',
            webhook_secret_warning: 'Webhook Geheimnis (save dieses now -- it will not be shown again):',
            last_event: 'Letzter Ereignis',
            none_received: 'Keine',
            update_domains: 'Aktualisieren Domänen',
            pause_webhook: 'Pausieren Webhook',
            resume_webhook: 'Fortsetzen Webhook',
            regenerate_secret: 'Regenerate Geheimnis',
            configuring: 'Konfiguriere...',
            create_webhook_config: 'Erstellen Webhook Konfiguration',
            webhook_endpoint: 'Webhook Endpunkt',
            webhook_endpoint_desc: 'Konfigurieren your AesirX CMP zu send Einwilligung Ereignisse zu:',
            webhook_signature_note: 'Einschließen der HMAC-SHA256 signature in der {header} header.',
            configured_success: 'Webhook erfolgreich konfiguriert.',
            config_updated: 'Konfiguration updated.',
            config_error: 'Fehler beim konfigurieren Webhook',
            update_error: 'Fehler beim update Konfiguration',
            toggle_error: 'Fehler beim toggle Webhook',
            deactivated: 'Webhook deaktiviert.',
            deactivate_error: 'Fehler beim deactivate Webhook',
            page_title: '[[TOK_0]] Integration',
            webhook_config_page_title: '[[TOK_0]] Webhook-Konfiguration',
            bulk_sync_page_title: 'Datensätze neu zuordnen',
            purpose_mapping_page_title: 'Zweckzuordnung',
            data_loaded: '[[TOK_0]] Integrationsdaten geladen',
            sync_all: 'Alle synchronisieren',
            sync_selected: 'Ausgewählte synchronisieren',
            sync_status: 'Synchronisierungsstatus',
            last_sync: 'Letzte Synchronisierung',
            no_records: 'Keine Datensätze gefunden.',
            sync_in_progress: 'Synchronisierung läuft...',
            sync_complete: 'Synchronisierung abgeschlossen.',
            sync_error: 'Synchronisierung fehlgeschlagen. Bitte versuchen Sie es erneut.',
            map_purpose: 'Zweck zuordnen',
            unmap: 'Zuordnung aufheben',
            mapping_status: 'Zuordnungsstatus',
            save_mapping: 'Zuordnung speichern',
            remap_unmapped_records: 'Nicht zugeordnete Datensätze neu zuordnen',
            remap_records: 'Datensätze neu zuordnen',
            add_mappings_first: 'Zuerst Zweckzuordnungen hinzufügen (Schritt 2)',
            remap_result: 'Ergebnis der Neuzuordnung',
            remap_result_desc: 'Verarbeitet alle Einwilligungsdatensätze mit nicht oder teilweise zugeordneten Zwecken.',
            total_processed: 'Insgesamt verarbeitet',
            newly_mapped: 'Neu kartiert',
            still_unmapped_label: 'Immer noch nicht zugeordnet',
            still_unmapped_msg: '[[TOK_2]] Datensätze haben noch nicht zugeordnete Zwecke. [[TOK_3]] und klicken Sie dann erneut auf Neu zuordnen.',
            add_more_mappings: 'Fügen Sie weitere Zuordnungen hinzu',
            remap_complete: 'Neuzuordnung abgeschlossen: [[TOK_2]] neu zugeordnet, [[TOK_3]] noch nicht zugeordnet.',
            add_mapping: 'Zuordnung hinzufügen',
            cmp_purpose_id_label: '[[TOK_0]] Zweck-ID *',
            cmp_purpose_id_required: '[[TOK_0]] Zweck-ID ist erforderlich',
            cmp_purpose_name_label: '[[TOK_0]] Zweckname',
            grc_purpose_label: 'GRC-Zweck',
        },
        propagation: {
            title: 'Widerrufsausbreitung',
            systems: 'Verknüpfte Systeme',
            status: 'Status',
            confirmed: 'Bestätigt',
            pending: 'Ausstehend',
            failed: 'Fehlgeschlagen',
            confirm: 'Widerruf bestätigen',
            fail: 'Als fehlgeschlagen markieren',
            failure_reason: 'Fehlergrund',
            can_close: 'Alle Systeme bestätigt — Workflow kann geschlossen werden',
            cannot_close: 'Warten auf Systembestätigungen',
            no_tasks: 'Keine Ausbreitungsaufgaben.',
            confirm_success: 'Systemwiderruf bestätigt.',
            fail_success: 'System als fehlgeschlagen markiert.',
            propagate_success: 'Widerruf an verknüpfte Systeme weitergeleitet.',
            propagate: 'An Systeme weitergeben',
            add_system: 'System hinzufügen',
            remove_system: 'Entfernen',
            system_id: 'System-ID',
            system_name: 'Systemname',
            owner_id: 'Besitzer-ID',
            propagate_error: 'Die Auszahlung konnte nicht verbreitet werden. Bitte versuchen Sie es erneut.',
            no_systems: 'Fügen Sie mindestens ein System hinzu.',
            page_title: 'Auszahlungsausbreitung',
            workflow_id: 'Wählen Sie Auszahlungsworkflow',
            system_id_hint: 'z.B. crm-001, erp-prod',
            owner_id_hint: 'Systemeigentümer',
            elapsed: 'Vergangen',
        },
        sensitive: {
            title: 'Richtlinien für sensible Daten',
            flag: 'Als sensibel markieren',
            categories: 'Sensible Kategorien',
            enhanced_review: 'Erweiterte Überprüfung erforderlich',
            enhanced_review_success: 'Erweiterte Überprüfung angefordert.',
            flag_success: 'Richtlinie als sensibel markiert.',
            no_sensitive: 'Keine Richtlinien für sensible Daten.',
        },
        reconciliation: {
            title: 'Abweichungsabstimmung',
            create: 'Neue Abstimmungsaufgabe',
            system: 'System',
            owner: 'Eigentümer',
            description: 'Beschreibung',
            resolution: 'Lösung',
            resolve: 'Lösen',
            update_grc: 'GRC aktualisieren',
            update_cmp: 'CMP aktualisieren',
            accept_difference: 'Unterschied akzeptieren',
            escalate: 'Eskalieren',
            resolution_notes: 'Lösungshinweise',
            no_tasks: 'Keine Abstimmungsaufgaben.',
            resolve_success: 'Abstimmungsaufgabe gelöst.',
            create_success: 'Abstimmungsaufgabe erstellt.',
            open: 'Offen',
            resolved: 'Gelöst',
            escalated: 'Eskaliert',
            dashboard_open: 'Offene Aufgaben',
            dashboard_resolved: 'Gelöste Aufgaben',
            dashboard_escalated: 'Eskalierte Aufgaben',
            page_title: 'Nichtübereinstimmungsabgleich',
            my_tasks: 'Meine Aufgaben',
            all_tasks: 'Alle Aufgaben',
            severity: 'Schweregrad',
        },
        sync: {
            title: 'CMP-Synchronisierung',
            direction: 'Richtung',
            cmp_to_grc: '[[TOK_0]] → GRC',
            grc_to_cmp: 'GRC → [[TOK_0]]',
            conflict: 'Konflikt',
            resolve_conflict: 'Konflikt lösen',
            no_events: 'Keine Synchronisierungsereignisse.',
            resolve_success: 'Synchronisierungskonflikt gelöst.',
            create_success: 'Synchronisierungsereignis aufgezeichnet.',
            page_title: '[[TOK_0]] Synchronisierung',
            detect_drift: 'Konflikte erkennen',
            detecting: 'Erkennen...',
            drift_result: '[[TOK_2]] Konflikte wurden bei [[TOK_3]] verglichenen Zweck(en) erkannt.',
            no_drift: 'Keine neuen Konflikte erkannt.',
            drift_error: 'Die Konflikterkennung konnte nicht ausgeführt werden.',
            resolve_modal_title: 'Konflikte lösen',
            resolve_field: 'Feld',
            resolve_grc_value: 'GRC-Wert',
            resolve_cmp_value: '[[TOK_0]] Wert',
            accept_cmp: 'Akzeptieren Sie den Wert [[TOK_0]].',
            accept_cmp_desc: 'Aktualisieren Sie GRC so, dass er mit dem [[TOK_0]] übereinstimmt – der [[TOK_1]]-Wert wird zum neuen GRC-Wert.',
            keep_grc: 'Behalten Sie den GRC-Wert bei',
            keep_grc_desc: 'Schließen Sie diesen Konflikt, ohne GRC zu ändern – benachrichtigen Sie den [[TOK_0]]-Eigentümer zur Ausrichtung.',
            resolve_applied: 'Konflikt gelöst. GRC-Zweck aktualisiert, um mit [[TOK_0]] übereinzustimmen.',
        },
    },
    assessments: {
        dossier_preflight: {
            advisory_notice: 'Dieser Bereitschaftsbericht ist lediglich beratend. Er genehmigt, erstellt, materialisiert, reicht oder versendet das Dossier nicht.',
            run_label: 'Vor dem Flug ausführen',
            running: 'Laufen vor dem Flug…',
            assemble_label: 'Paket automatisch zusammenstellen',
            assembling: 'Zusammenbau…',
            verdict_label: 'Urteil vor dem Flug',
            tokens_label: '≈ [[TOK_1]] Token',
            remediation_label: 'Sanierung',
            no_gaps: 'Es wurden keine Lücken vor dem Flug festgestellt. Die Ablage ist montagefertig.',
            override_label: 'Blockurteil außer Kraft setzen – die Versammlung wird mit einem Prüfstempel versehen.',
            accept_label: 'Bericht annehmen',
            reject_label: 'Bericht ablehnen',
            assembled_label: 'Einreichungspaket zusammengestellt',
            package_id_label: 'Paket-ID',
            package_filename_label: 'Dateiname',
            package_hash_label: 'Paket-Hash',
            evidence_count_label: '[[TOK_1]] Beweisstücke gebündelt',
            error_generic: 'Der Preflight konnte nicht ausgeführt oder das Paket nicht zusammengestellt werden. Versuchen Sie es erneut oder überprüfen Sie den Anmeldestatus.',
        },
        errors: {
            fetch: 'Fehler beim load assessments..',
            save: 'Fehler beim save Bewertung..',
            fetch_gap_report_failed: 'Fehler beim fetch Lücke report..',
            fetch_transfers_failed: 'Fehler beim fetch Übertragungen..',
            save_transfer_failed: 'Fehler beim save Übertragung..',
            submit_review_failed: 'Fehler beim submit für Überprüfung..',
            process_decision_failed: 'Fehler beim process Entscheidung..',
            deprecate_failed: 'Fehler beim deprecate..',
            evaluate_risk_failed: 'Fehler beim evaluate Risiko..',
            fetch_safeguards_failed: 'Fehler beim fetch Schutzmaßnahmen..',
            save_safeguard_failed: 'Fehler beim save Schutzmaßnahme..',
            update_safeguard_status_failed: 'Fehler beim update Schutzmaßnahme Status..',
        },
        nav: {
            dpias: 'DSFAs',
            transfers: 'Übermittlungsbewertungen',
            dashboard: 'Übersicht',
            gap_report: 'Lückenbericht',
        },
        risk_level_critical: 'Kritisches Risiko',
        risk_level_high: 'Hohes Risiko',
        risk_level_medium: 'Mittleres Risiko',
        risk_level_low: 'Niedriges Risiko',
        severity_critical: 'Kritischer Schweregrad',
        severity_high: 'Hoher Schweregrad',
        severity_medium: 'Mittlerer Schweregrad',
        severity_low: 'Niedriger Schweregrad',
        overdue: 'Überfällig',
        framework_filter_label: 'Rahmen',
        aria_filter_by_framework: 'Nach Framework filtern',
        dashboard: {
            title: 'Bewertungsübersicht',
            page_title: 'Bewertungs-Dashboard',
            announce_loaded: 'Bewertungs-Dashboard geladen',
            announce_chart_view: 'Diagrammansicht anzeigen',
            announce_table_view: 'Datentabellenansicht anzeigen',
            aria_metrics_table: 'Bewertungs-Dashboard-Kennzahlen',
            metric_col: 'Kennzahl',
            value_col: 'Wert',
            dpia_prefix: 'DSFA',
            transfer_prefix: 'Übermittlung',
            risk_prefix: 'Risiko',
            aria_dpias_by_status: 'DSFAs nach Status',
            aria_transfers_by_status: 'Übermittlungen nach Status',
            aria_top_risks: 'Top-Risiken',
            aria_top_risks_table: 'Top-Risiken über DSFAs',
            overdue_dpias_attention: '{count} überfällige DSFA-Bewertungen erfordern Aufmerksamkeit',
            no_overdue_dpias: 'Keine überfälligen DSFA-Bewertungen',
            overdue_transfers_attention: '{count} überfällige Übermittlungsbewertungen erfordern Aufmerksamkeit',
            no_overdue_transfers: 'Keine überfälligen Übermittlungsbewertungen',
            dpias_overview: 'DSFA-Übersicht',
            transfers_overview: 'Übermittlungsbewertungen – Übersicht',
            overdue_items: 'Überfällige Einträge',
            overdue_dpias: 'Überfällige DSFAs',
            overdue_transfers: 'Überfällige Übermittlungsbewertungen',
            count: 'Anzahl',
            no_data: 'No Daten available.',
            no_risks: 'Keine Risiken gefunden.',
            no_dashboard_data: 'No Dashboard Daten available.',
            fetch_error: 'Fehler beim fetch Dashboard Daten. Bitte versuchen Sie es erneut.',
        },
        dpias: {
            page_title: 'DSFAs',
            announce_submitted_for_review: 'DSFA zur Prüfung eingereicht',
            announce_deprecated: 'DSFA veraltet',
            announce_risks_loaded: '{count} Risiko(en) geladen',
            announce_mitigations_loaded: '{count} Maßnahme(n) geladen',
            announce_risk_deleted: 'Risiko gelöscht',
            announce_mitigation_status_updated: 'Maßnahmenstatus aktualisiert',
            aria_filter: 'DSFAs filtern',
            aria_filter_by_status: 'Nach Status filtern',
            aria_filter_by_lead: 'Nach Bewertungsleiter filtern',
            aria_table: 'Datenschutz-Folgenabschätzungen',
            announce_found: '{count} DSFA(s) gefunden',
            announce_decision: 'DSFA {decision}',
            mitigation_start: 'Starten',
            mitigation_mark_implemented: 'Als umgesetzt markieren',
            mitigation_verify: 'Verifizieren',
            title: 'Datenschutz-Folgenabschätzungen',
            new: 'Neue DSFA',
            edit: 'DSFA bearbeiten',
            dpia_title: 'Titel',
            activity: 'Tätigkeit',
            risk_score: 'Risikobewertung',
            risks: 'Risiken',
            mitigations: 'Maßnahmen',
            add_risk: 'Risiko hinzufügen',
            add_mitigation: 'Maßnahme hinzufügen',
            necessity: 'Erforderlichkeit / Verhältnismäßigkeit',
            likelihood: 'Eintrittswahrscheinlichkeit',
            impact: 'Auswirkung',
            severity_label: 'Schweregrad',
            purpose: 'Zweck',
            consultation_notes: 'Beratung Hinweise',
            dpo_opinion: 'DPO-Stellungnahme',
            processing_activity_ids: 'Verarbeitung Aktivität IDs (comma-separated)',
            system_ids: 'System-IDs (kommagetrennt)',
            vendor_ids: 'Anbieter IDs (comma-separated)',
            data_types: 'Daten Typen (comma-separated)',
            data_types_short: 'Daten Typen',
            data_subjects: 'Daten Subjects (comma-separated)',
            assessment_lead_id: 'Bewertung Leitung ID',
            assessment_lead: 'Bewertung Leitung',
            dpo_id: 'DSB-ID',
            reviewer_ids: 'Prüfer IDs (comma-separated)',
            approval_mode: 'Genehmigung Modus',
            approval_all: 'All',
            approval_any: 'Any',
            require_dpo_signoff: 'DPO-Abzeichnung erforderlich',
            review_date: 'Überprüfen Datum',
            submit_for_review: 'Absenden für Überprüfen',
            approve_reject: 'Genehmigen/Ablehnen',
            deprecate: 'Veralten',
            deprecated: 'Veraltet',
            hide_risks: 'Ausblenden Risiken',
            hide_mitigations: 'Ausblenden Maßnahmen',
            comments: 'Kommentare',
            submit_decision: 'Absenden Entscheidung',
            category_label: 'Kategorie',
            category_data_breach: 'Daten Verletzung',
            category_unauthorized_access: 'Unbefugt Zugriff',
            category_function_creep: 'Funktion Creep',
            category_re_identification: 'Re-Identifizierung',
            category_discrimination: 'Diskriminierung',
            category_surveillance: 'Überwachung',
            category_other: 'Andere',
            affected_rights: 'Betroffene Rechte (kommagetrennt)',
            no_risks: 'Keine Risiken gefunden.',
            no_mitigations: 'Keine Maßnahmen gefunden.',
            no_dpias: 'Keine DPIAs gefunden.',
            mitigation_type: 'Typ',
            mitigation_technical: 'Technisch',
            mitigation_organizational: 'Organisatorisch',
            mitigation_contractual: 'Vertraglich',
            risk_ids: 'Risiko IDs (comma-separated)',
            responsible_party: 'Verantwortlich Party',
            responsible_party_placeholder: 'Oder Name manuell eingeben',
            affected_rights_placeholder: 'Ausgewählte Rechte werden hier angezeigt',
            affected_rights_freetext_placeholder: 'Betroffene Rechte eingeben (kommagetrennt)',
            responsible: 'Verantwortlich',
            target_date: 'Ziel Datum',
            created: 'Erstellt',
            fetch_error: 'Fehler beim fetch DPIAs. Bitte versuchen Sie es erneut.',
            save_error: 'Fehler beim save DPIA. Bitte versuchen Sie es erneut.',
            submit_review_error: 'Fehler beim submit DPIA für Überprüfung. Bitte versuchen Sie es erneut.',
            decision_error: 'Fehler beim process Entscheidung. Bitte versuchen Sie es erneut.',
            deprecate_error: 'Fehler beim deprecate DPIA. Bitte versuchen Sie es erneut.',
            fetch_risks_error: 'Fehler beim fetch Risiken. Bitte versuchen Sie es erneut.',
            save_risk_error: 'Fehler beim save Risiko. Bitte versuchen Sie es erneut.',
            delete_risk_error: 'Fehler beim delete Risiko. Bitte versuchen Sie es erneut.',
            fetch_mitigations_error: 'Fehler beim fetch Maßnahmen. Bitte versuchen Sie es erneut.',
            save_mitigation_error: 'Fehler beim save Maßnahme. Bitte versuchen Sie es erneut.',
            update_mitigation_status_error: 'Fehler beim Aktualisieren des Maßnahmenstatus. Bitte versuchen Sie es erneut.',
            link_form_template: 'Vorlage für ein Link-Regulierungsformular',
            link_form_template_placeholder: 'Wählen Sie eine [[TOK_0]]-Formularvorlage aus (optional)',
            link_form_template_none: 'Keine',
            linked_form: 'Verknüpftes Formular',
            linked_form_creating: 'Verlinktes Formular wird erstellt...',
            linked_form_error: 'Die verknüpfte Formularinstanz konnte nicht erstellt werden. Das [[TOK_0]] wurde ohne verknüpftes Formular erstellt.',
            view_linked_form: 'Formular anzeigen',
            announce_created_with_form: '[[TOK_0]] mit verknüpfter Formularinstanz erstellt',
            creation_mode: '[[TOK_0]] Erstellungsmodus',
            mode_standard: 'Standard [[TOK_0]]',
            mode_template: 'Verwenden Sie die Vorlage für ein Regulierungsformular',
            select_form_template: 'Wählen Sie Formularvorlage aus',
            create_and_fill_form: 'Formular erstellen und ausfüllen',
            template_sections_title: 'Vorlagenabschnitte',
            field_singular: 'Feld',
            field_plural: 'Felder',
            no_sections: 'In dieser Vorlage wurden keine Abschnitte gefunden.',
            template_mode_hint: 'Nach der Erstellung werden Sie weitergeleitet, um das vollständige Regulierungsformular auszufüllen.',
            linked_dossier_filings: 'Verknüpfte Dossiereinreichungen',
            no_linked_dossier_filings: 'Keine Dossiereinreichungen mit dieser DSFA verknüpft.',
            view_dossier_filing: 'Einreichung anzeigen',
            hide_dossier_filings: 'Dossiereinreichungen ausblenden',
            supporting_evidence: 'Unterstützende Beweise',
            hide_supporting_evidence: 'Beweise verbergen',
            no_supporting_evidence: 'Keine unterstützenden Beweise beigefügt.',
            upload_supporting_evidence: 'Laden Sie unterstützende Beweise hoch',
            view_form_responses: 'Formularantworten anzeigen',
            regulatory_framework: 'Regulatorischer Rahmen',
            all_frameworks: 'Alle Rahmenwerke',
            no_templates_for_market: 'Keine Vorlagen für den ausgewählten Markt verfügbar. Bitte wählen Sie einen anderen Markt oder erstellen Sie eine Vorlage.',
        },
        transfers: {
            page_title: 'Datenübermittlungen',
            announce_found: '{count} Übermittlungsbewertung(en) gefunden',
            announce_submitted_for_review: 'Übermittlung zur Prüfung eingereicht',
            announce_deprecated: 'Übermittlung veraltet',
            announce_decision: 'Übermittlung {decision}',
            announce_risk_eval_completed: 'Risikobewertung abgeschlossen',
            announce_safeguard_status_updated: 'Schutzmaßnahmenstatus aktualisiert',
            announce_safeguards_loaded: '{count} Schutzmaßnahme(n) geladen',
            aria_filter: 'Übermittlungsbewertungen filtern',
            aria_filter_by_status: 'Nach Status filtern',
            aria_filter_by_mechanism: 'Nach Übermittlungsmechanismus filtern',
            aria_table: 'Datenübermittlungsbewertungen',
            title: 'Grenzüberschreitende Übermittlungsbewertungen',
            new: 'Neue Übermittlung',
            edit: 'Übermittlung bearbeiten',
            name: 'Bezeichnung',
            from_country: 'Herkunftsland',
            to_country: 'Zielland',
            safeguards: 'Schutzmaßnahmen',
            risk_level: 'Risikostufe',
            assessment_notes: 'Bewertungsnotizen',
            mechanism: 'Mechanismus',
            transfer_mechanism: 'Übertragung Mechanismus',
            transfer_mechanism_detail: 'Übertragung Mechanismus Detail',
            all_mechanisms: 'Alle Mechanisms',
            mechanism_adequacy_decision: 'Angemessenheit Entscheidung',
            mechanism_sccs: 'Standardvertragsklauseln',
            mechanism_bcrs: 'Verbindliche Unternehmensregeln',
            mechanism_consent: 'Einwilligung',
            mechanism_derogation: 'Ausnahmeregelung',
            mechanism_other: 'Andere',
            data_types: 'Daten Typen (comma-separated)',
            data_subjects: 'Daten Subjects (comma-separated)',
            purpose: 'Zweck',
            recipient_name: 'Empfänger Name',
            create_success: 'Übermittlungsbewertung erstellt.',
            update_success: 'Übermittlungsbewertung aktualisiert.',
            recipient_details: 'Empfängerdetails',
            recipient_details_placeholder: 'Rolle, Standort und Systeme des Empfängers sowie Details zur Weiterübermittlung',
            vendor_id: 'Anbieter ID',
            processing_activity_ids: 'Verarbeitung Aktivität IDs (comma-separated)',
            reviewer_ids: 'Prüfer IDs (comma-separated)',
            approval_mode: 'Genehmigung Modus',
            approval_all: 'All',
            approval_any: 'Any',
            require_dpo_signoff: 'DPO-Abzeichnung erforderlich',
            review_date: 'Überprüfen Datum',
            created: 'Erstellt',
            deprecated: 'Veraltet',
            submit_for_review: 'Absenden für Überprüfen',
            approve_reject: 'Genehmigen/Ablehnen',
            deprecate: 'Veralten',
            risk_eval: 'Risiko Eval',
            hide_safeguards: 'Ausblenden Schutzmaßnahmen',
            mechanism_proof: 'Mechanismusbeweis',
            hide_mechanism_proof: 'Mechanismusbeweis ausblenden',
            mechanism_proof_hint: 'Laden Sie den unterzeichneten Übertragungsmechanismus (SCCs, BCRs, Angemessenheitsentscheidung usw.) hoch, der diese Übertragungsbewertung belegt.',
            no_mechanism_proof: 'Kein Mechanismusnachweis beigefügt.',
            upload_mechanism_proof: 'Mechanismusbeweis hochladen',
            comments: 'Kommentare',
            submit_decision: 'Absenden Entscheidung',
            data_sensitivity: 'Daten Sensitivity (1-5)',
            country_risk: 'Land Risiko (1-5)',
            safeguard_adequacy: 'Schutzmaßnahme Angemessenheit (1-5)',
            volume_factor: 'Volumen Factor (1-5)',
            evaluate: 'Bewerten',
            add_safeguard: 'Hinzufügen Schutzmaßnahme',
            responsible_party: 'Verantwortlich Party',
            responsible_party_placeholder: 'Oder Name manuell eingeben',
            responsible: 'Verantwortlich',
            implementation_date: 'Implementierung Datum',
            implementation: 'Implementierung',
            expiry_date: 'Ablauf Datum',
            expiry: 'Ablauf',
            expire: 'Ablaufen',
            no_safeguards: 'Keine Schutzmaßnahmen gefunden.',
            no_transfers: 'Keine Übertragung assessments gefunden.',
            fetch_error: 'Fehler beim fetch Übertragung assessments. Bitte versuchen Sie es erneut.',
            save_error: 'Fehler beim save Übertragung Bewertung. Bitte versuchen Sie es erneut.',
            submit_review_error: 'Fehler beim submit für Überprüfung. Bitte versuchen Sie es erneut.',
            decision_error: 'Fehler beim process Entscheidung. Bitte versuchen Sie es erneut.',
            deprecate_error: 'Fehler beim deprecate Übertragung. Bitte versuchen Sie es erneut.',
            risk_eval_error: 'Fehler beim evaluate Risiko. Bitte versuchen Sie es erneut.',
            fetch_safeguards_error: 'Fehler beim fetch Schutzmaßnahmen. Bitte versuchen Sie es erneut.',
            save_safeguard_error: 'Fehler beim save Schutzmaßnahme. Bitte versuchen Sie es erneut.',
            update_safeguard_status_error: 'Fehler beim Aktualisieren des Schutzmaßnahmenstatus. Bitte versuchen Sie es erneut.',
            safeguard_type_encryption_in_transit: 'Verschlüsselung in Transit',
            safeguard_type_encryption_at_rest: 'Verschlüsselung bei Rest',
            safeguard_type_access_controls: 'Zugriff Kontrollen',
            safeguard_type_contractual_clauses: 'Vertraglich Klauseln',
            safeguard_type_data_minimization: 'Daten Minimization',
            safeguard_type_pseudonymization: 'Pseudonymisierung',
            safeguard_type_audit_rights: 'Prüfungsrechte',
            safeguard_type_breach_notification: 'Verletzung Benachrichtigung',
            safeguard_type_data_localization: 'Daten Lokalisierung',
            safeguard_type_other: 'Andere',
            activate: 'Aktivieren',
            all_statuses: 'Alle Status',
            any: 'Any',
            mechanism_detail: 'Mechanismus Detail',
            mechanisms: {
                adequacy_decision: 'Angemessenheit Entscheidung',
                sccs: 'Standardvertragsklauseln',
                bcr: 'BCR',
                bcrs: 'Verbindliche Unternehmensregeln',
                derogation: 'Ausnahmeregelung',
                consent: 'Einwilligung',
                other: 'Andere',
            },
            safeguard_types: {
                encryption_in_transit: 'Verschlüsselung bei der Übertragung',
                encryption_at_rest: 'Verschlüsselung im Ruhezustand',
                access_controls: 'Zugriffskontrollen',
                contractual_clauses: 'Vertragliche Klauseln',
                data_minimization: 'Datensparsamkeit',
                pseudonymization: 'Pseudonymisierung',
                audit_rights: 'Prüfungsrechte',
                breach_notification: 'Verletzungsmeldung',
                data_localization: 'Datenlokalisierung',
                other: 'Andere',
            },
        },
        gap_report: {
            page_title: 'Gap-Bericht für Bewertungen',
            announce_loaded: 'Gap-Bericht geladen. {count} Lücke(n) identifiziert',
            aria_activities_without_dpia: 'Aktivitäten ohne DSFA-Bewertung',
            aria_activities_unclassified: 'Aktivitäten mit nicht klassifiziertem DSFA-Erfordernis',
            activities_unclassified_section_title: 'Aktivitäten mit nicht klassifiziertem DSFA-Erfordernis',
            activities_unclassified_description: 'Diese Aktivitäten wurden nicht geprüft, ob eine DSFA gesetzlich erforderlich ist. Klassifizieren Sie jede einzelne, um den Hinweis zu entfernen.',
            activities_unclassified_empty: 'Alle aktiven Aktivitäten wurden klassifiziert.',
            aria_unmitigated_risks: 'Nicht behandelte hohe und kritische Risiken',
            aria_transfers_without_safeguards: 'Übermittlungen ohne ausreichende Schutzmaßnahmen',
            aria_expired_assessments: 'Abgelaufene Bewertungen die Erneuerung erfordern',
            title: 'Bewertungslückenbericht',
            no_dpia: 'Tätigkeiten ohne DSFA',
            no_assessment: 'Übermittlungen ohne Bewertung',
            unmitigated: 'DSFAs mit offenen Risiken',
            activity_id: 'Aktivität ID',
            dpia_id: 'DSFA-ID',
            assessment_id: 'Bewertung ID',
            expired_assessments: 'Abgelaufen Bewertungen',
            no_gaps_activities: 'Keine Lücken gefunden Alle activities have DPIAs..',
            no_unmitigated_risks: 'Keine unmitigated high/critical Risiken gefunden.',
            no_gaps_safeguards: 'Keine Lücken gefunden Alle Übertragungen have adequate Schutzmaßnahmen..',
            no_expired: 'Keine expired assessments gefunden.',
            no_report_data: 'No Lücke report Daten available.',
            fetch_error: 'Fehler beim fetch Lücke report. Bitte versuchen Sie es erneut.',
            no_expired_assessments: 'Keine abgelaufenen Bewertungen.',
            no_gaps_dpia: 'Keine DPIA Lücken gefunden.',
            no_data: 'No Daten available.',
        },
        dossier_filings: {
            page_title_detail: 'Dossiereinreichungsdetail',
            page_title_list: 'Dossiereinreichungsfälle',
            announce_filings_found: '{count} Einreichung(en) gefunden',
            announce_results: '{count} Ergebnisse',
            aria_filter_by_status: 'Nach Status filtern',
            title: 'Fälle zur Dossiereinreichung',
            nav_label: 'Dossier-Einreichungen',
            create: 'Erstellen Sie eine Dossier-Einreichung',
            form_type: 'Formulartyp',
            phu_luc_i_label: 'Mẫu số 02a (Standard [[TOK_0]], Dekret 356)',
            phu_luc_ii_label: 'Mẫu số 02b (Grenzüberschreitend / Hochrisiko [[TOK_0]], Dekret 356)',
            dpia_reference: '[[TOK_0]] Referenz',
            submitted_date: 'Datum der Einreichung',
            outcome: 'Ergebnis',
            parent_filing: 'Eltern',
            no_filings: 'Keine Dossiereinreichungen gefunden.',
            fetch_error: 'Dossiereinreichungen konnten nicht abgerufen werden. Bitte versuchen Sie es erneut.',
            save_error: 'Die Dossier-Einreichung konnte nicht erstellt werden. Bitte versuchen Sie es erneut.',
            created: 'Dossierablage erstellt.',
            loaded: 'Dossier-Einreichung geladen.',
            not_found: 'Dossier-Einreichung nicht gefunden.',
            back_to_list: 'Zurück zur Liste',
            section_assignments: 'Abschnittsaufgaben',
            assign_sections: 'Abschnitte zuweisen',
            section_id: 'Abschnitt',
            department: 'Abteilung',
            assignee: 'Bevollmächtigter',
            deadline: 'Frist',
            no_assignments: 'Noch keine Abschnittszuweisungen.',
            sections_assigned_msg: 'Abschnitte zugewiesen.',
            assign_error: 'Abschnitte konnten nicht zugewiesen werden. Bitte versuchen Sie es erneut.',
            lifecycle: 'Lebenszyklus der Einreichung',
            submission: 'Einreichungsdetails',
            submission_channel: 'Einreichungskanal',
            mps_portal: '[[TOK_0]] Portal',
            in_person: 'Persönlich',
            postal: 'Postalisch',
            confirmation_number: 'Bestätigungsnummer',
            submit_for_review: 'Zur Überprüfung einreichen',
            submitted_for_review: 'Zur internen Überprüfung eingereicht.',
            submit_review_error: 'Fehler beim Einreichen zur Überprüfung. Bitte versuchen Sie es erneut.',
            legal_signoff: 'Rechtliche Freigabe',
            legal_signoff_done: 'Die rechtliche Freigabe ist abgeschlossen.',
            legal_signoff_error: 'Die rechtliche Freigabe konnte nicht abgeschlossen werden. Bitte versuchen Sie es erneut.',
            approve: 'Genehmigen',
            approved_msg: 'Einreichung genehmigt.',
            approve_error: 'Die Einreichung konnte nicht genehmigt werden. Bitte versuchen Sie es erneut.',
            materialisation_status_column: 'Einreichungsartefakt',
            materialisation_na: 'Nicht zutreffend',
            materialisation_pending: 'Ausstehend',
            materialisation_success: 'Materialisiert',
            materialisation_failed: 'Fehlgeschlagen',
            materialisation_banner_title: 'Das Übermittlungsartefakt konnte nicht erstellt werden',
            materialisation_banner_body: 'Die Einreichung wurde genehmigt, der zugrunde liegende Dossierdatensatz konnte jedoch nicht erstellt werden. Der Export von Anschreiben und Einreichungen ist erst möglich, wenn Sie es erneut versuchen.',
            materialisation_retry_button: 'Versuchen Sie es noch einmal',
            materialisation_retry_count: 'Frühere Wiederholungsversuche:',
            materialisation_retry_success: 'Das Übermittlungsartefakt wurde erfolgreich umgesetzt.',
            materialisation_retry_announce: 'Der erneute Versuch war erfolgreich',
            filter_materialisation_failed: 'Nur Materialisierungsfehler anzeigen',
            column_title: 'Titel',
            column_form_type: 'Formular',
            submit_to_mps: 'Senden an [[TOK_0]]',
            submitted_to_mps_msg: 'Eingereicht an [[TOK_0]].',
            submit_mps_error: 'Übermittlung an [[TOK_0]] fehlgeschlagen. Bitte versuchen Sie es erneut.',
            supplement_request: 'Ergänzungsanfrage',
            supplement_requests: 'Ergänzungswünsche',
            supplement_response: 'Ergänzungsantwort',
            record_supplement: 'Antrag auf Ergänzung des Datensatzes',
            supplement_recorded: 'Ergänzungsanfrage erfasst.',
            supplement_error: 'Ergänzungsanfrage konnte nicht erfasst werden. Bitte versuchen Sie es erneut.',
            submit_supplement: 'Senden Sie eine ergänzende Antwort',
            supplement_submitted_msg: 'Ergänzungsantwort eingereicht.',
            supplement_submit_error: 'Die Ergänzungsantwort konnte nicht übermittelt werden. Bitte versuchen Sie es erneut.',
            response_status: 'Antwortstatus',
            response_notes: 'Antwortnotizen',
            resubmit: 'Erneut einreichen',
            resubmitted_msg: 'Dossier erneut eingereicht.',
            resubmit_error: 'Das erneute Einreichen des Dossiers ist fehlgeschlagen. Bitte versuchen Sie es erneut.',
            record_outcome: 'Ergebnis aufzeichnen',
            outcome_recorded: 'Ergebnis aufgezeichnet.',
            outcome_error: 'Das Ergebnis konnte nicht aufgezeichnet werden. Bitte versuchen Sie es erneut.',
            accepted: 'Akzeptiert',
            rejected: 'Abgelehnt',
            close: 'Schließen',
            closed_msg: 'Einreichung geschlossen.',
            close_error: 'Die Archivierung konnte nicht geschlossen werden. Bitte versuchen Sie es erneut.',
            change_filing: 'Änderungsablage erstellen',
            change_filing_created: 'Änderungsablage erstellt.',
            change_filing_error: 'Änderungsarchiv konnte nicht erstellt werden. Bitte versuchen Sie es erneut.',
            change_reason: 'Grund für die Änderung',
            filing_lineage: 'Abstammung einreichen',
            timers: 'Aktive Timer',
            timer_mps_review: '[[TOK_0]] Rezension',
            timer_supplement: 'Frist für Ergänzungen',
            timer_resubmission: 'Frist für die erneute Einreichung',
            timer_department: 'Frist der Abteilung',
            days_remaining: 'Tage verbleibend',
            days_overdue: 'Tage überfällig',
            cover_letter: 'Anschreiben',
            checklist: 'Checkliste',
            evidence_index: 'Beweisindex',
            status_draft: 'Entwurf',
            status_sections_assigned: 'Abschnitte zugewiesen',
            status_internal_review: 'Interne Prüfung',
            status_legal_signoff: 'Rechtliche Freigabe',
            status_approved: 'Genehmigt',
            status_submitted_to_mps: 'Eingereicht an [[TOK_0]]',
            status_supplement_requested: 'Ergänzung angefordert',
            status_supplement_submitted: 'Ergänzung eingereicht',
            status_resubmitted: 'Erneut eingereicht',
            status_accepted: 'Akzeptiert',
            status_rejected: 'Abgelehnt',
            status_closed: 'Geschlossen',
            linked_dpia: 'Verknüpfte DSFA',
            linked_dpia_none: 'Keine DSFA mit dieser Einreichung verknüpft.',
            view_linked_dpia: 'DSFA anzeigen',
            linked_dpia_label: 'Diese Dossiereinreichung ist mit folgender DSFA verknüpft:',
        },
        materialisation_health: {
            nav_label: 'Zustand des Einreichungsartefakts',
            page_title: 'Einreichung von Artefaktgesundheit',
            page_description: 'Erkennen und beheben Sie Probleme bei der Materialisierung von Dossiers. Listen sind auf Ihre Organisation beschränkt.',
            failed_title: 'Fehlgeschlagene Materialisierungen',
            failed_empty: 'Keine fehlgeschlagenen Materialisierungen – gut.',
            pending_title: 'Genehmigt, aber nicht umgesetzt',
            pending_empty: 'Alle genehmigten Anträge verfügen über ein Begleitdossier.',
            orphan_title: 'Verwaiste Dossiers',
            orphan_description: 'Durch Materialisierung erstellte Dossiers, auf die in keiner Akte mehr verwiesen wird – typischerweise der Verlierer eines gleichzeitigen Rennens. Zur Untersuchung gelistet; Die Bereinigung erfolgt manuell.',
            orphan_empty: 'Es wurden keine verwaisten Dossiers entdeckt.',
            materialise_button: 'Jetzt materialisieren',
            column_failure_reason: 'Fehlergrund',
            column_failed_at: 'Fehlgeschlagen bei',
            column_retries: 'Wiederholungen',
            column_approved_at: 'Genehmigt bei',
            column_dossier_id: 'Dossier-ID',
            column_source_filing_id: 'Quellenablage',
            column_dossier_type: 'Typ',
            column_created_at: 'Erstellt bei',
        },
    },
    classification: {
        access_denied_title: 'Zugriff verweigert',
        access_denied: 'Sie verfügen nicht über die erforderlichen Berechtigungen, um auf das Klassifizierungsmodul zuzugreifen. Kontaktieren Sie Ihren Administrator.',
        nav: {
            taxonomies: 'Taxonomien',
            labeling: 'Kennzeichnung',
            lifecycle: 'Lebenszyklus',
            gaps: 'Lückenbericht',
            exports: 'Exporte',
        },
        exports: {
            title: 'Klassifizierungsexporte',
            csv_section: 'CSV-Exporte',
            pdf_section: 'PDF-Berichte',
            inventory: 'Inventar',
            classification_register: 'Klassifizierungsregister',
            raci: 'RACI-Matrix',
            exceptions: 'Ausnahmen',
            evidence_pack: 'Nachweispaket',
            delta_report: 'Delta-Bericht',
            executive_summary: 'Zusammenfassung',
            exporting: 'Wird exportiert…',
            export_success: 'Export erfolgreich abgeschlossen.',
            export_error: 'Export fehlgeschlagen. Bitte versuchen Sie es erneut.',
            csv_download: 'CSV-Download bereit.',
            pdf_download: 'PDF-Erstellung gestartet.',
            no_data: 'Keine Daten zum Exportieren verfügbar.',
        },
        delta: {
            title: 'Delta-Details',
            added: 'Hinzugefügt',
            removed: 'Entfernt',
            changed: 'Geändert',
            added_count: 'Hinzugefügt ({count})',
            removed_count: 'Entfernt ({count})',
            changed_count: 'Geändert ({count})',
            object_id: 'Objekt-ID',
            object_type: 'Objekttyp',
            taxonomy: 'Taxonomie',
            level: 'Stufe',
            previous: 'Vorherig',
            current: 'Aktuell',
            no_records: 'Keine Einträge in diesem Abschnitt.',
            empty_section: 'Dieser Abschnitt ist leer.',
        },
        schedule: {
            title: 'Erkennungszyklus planen',
            enabled: 'Aktiviert',
            interval_days: 'Intervall (Tage)',
            interval_label: 'Alle N Tage ausführen',
            manual_only: 'Nur manuell',
            every_n_days: 'Alle {n} Tage',
            save: 'Zeitplan speichern',
            cancel: 'Abbrechen',
            schedule_updated: 'Zeitplan erfolgreich aktualisiert.',
        },
        taxonomies: {
            title: 'Klassifizierungstaxonomien',
            new: 'Neue Taxonomie',
            edit: 'Taxonomie bearbeiten',
            name: 'Bezeichnung',
            levels: 'Klassifizierungsstufen',
            seed_defaults: 'Initialisieren Standardwerte',
            scope: 'Geltungsbereich',
            scope_organization: 'Organisation',
            scope_module_specific: 'Modul Specific',
            deprecate: 'Veralten',
            hide_levels: 'Ausblenden Stufen',
            versions: 'Versionen',
            hide_versions: 'Ausblenden Versionen',
            add_level: 'Hinzufügen Stufe',
            new_level: 'Neu Stufe',
            edit_level: 'Bearbeiten Stufe',
            code: 'Kennung',
            label: 'Bezeichnung',
            color: 'Farbe',
            ordinal: 'Ordinalzahl',
            handling_requirements: 'Handhabung Anforderungen',
            version_history: 'Version Verlauf',
            changes: 'Änderungen',
            failed_fetch: 'Fehler beim fetch Taxonomien. Bitte versuchen Sie es erneut.',
            failed_save: 'Fehler beim save Taxonomie. Bitte versuchen Sie es erneut.',
            failed_activate: 'Fehler beim activate Taxonomie. Bitte versuchen Sie es erneut.',
            failed_deprecate: 'Fehler beim deprecate Taxonomie. Bitte versuchen Sie es erneut.',
            failed_seed: 'Fehler beim seed Standard Taxonomien. Bitte versuchen Sie es erneut.',
            failed_fetch_levels: 'Fehler beim fetch Taxonomie Stufen. Bitte versuchen Sie es erneut.',
            failed_save_level: 'Fehler beim save Taxonomie Stufe. Bitte versuchen Sie es erneut.',
            failed_delete_level: 'Fehler beim delete Taxonomie Stufe. Bitte versuchen Sie es erneut.',
            failed_fetch_versions: 'Fehler beim fetch Taxonomie Versionen. Bitte versuchen Sie es erneut.',
            loaded_count: '{count} Taxonomien geladen',
            defaults_seeded: 'Standard-Taxonomien initialisiert.',
            no_levels: 'Keine Klassifikationsstufen definiert — fügen Sie Stufen hinzu, um Ihre Klassifikationshierarchie aufzubauen.',
            no_versions: 'Noch keine Versionshistorie — Versionen werden erstellt, wenn eine aktive Taxonomie aktualisiert wird.',
        },
        labeling: {
            title: 'Datenkennzeichnung',
            new: 'Neue Kennzeichnung',
            edit: 'Kennzeichnung bearbeiten',
            entity_type: 'Objekttyp',
            entity_id: 'Objekt-ID',
            taxonomy: 'Taxonomie',
            classification_level: 'Klassifizierungsstufe',
            applied_by: 'Angewendet von',
            applied_at: 'Angewendet am',
            bulk_apply: 'Massenweise anwenden',
            bulk_remove: 'Massenweise entfernen',
            all_taxonomies: 'Alle Taxonomien',
            system: 'IT-System',
            dataset: 'Datensatz',
            level_code_placeholder: 'Stufe Code...',
            select_taxonomy: 'Auswählen Taxonomie...',
            select_level: 'Auswählen Stufe...',
            rationale: 'Begründung',
            review_date: 'Überprüfen Datum',
            review: 'Überprüfen',
            selected: 'ausgewählt',
            select_all_labels: 'Alle Bezeichnungen auswählen',
            loaded_count: '{count} Bezeichnungen geladen',
            hide_stale_labels: 'Ausblenden Stale Bezeichnungen',
            show_conflicts: 'Anzeigen Konflikte',
            hide_conflicts: 'Ausblenden Konflikte',
            label_conflicts: 'Bezeichnung Konflikte',
            conflict_reason: 'Konflikt Grund',
            labels: 'Bezeichnungen',
            failed_fetch: 'Fehler beim fetch Bezeichnungen. Bitte versuchen Sie es erneut.',
            failed_fetch_taxonomies: 'Fehler beim fetch Taxonomien. Bitte versuchen Sie es erneut.',
            failed_fetch_levels: 'Fehler beim fetch Taxonomie Stufen. Bitte versuchen Sie es erneut.',
            failed_save: 'Fehler beim save Bezeichnung. Bitte versuchen Sie es erneut.',
            failed_review: 'Fehler beim Überprüfung Bezeichnung. Bitte versuchen Sie es erneut.',
            failed_bulk: 'Fehler beim bulk Bezeichnung. Bitte versuchen Sie es erneut.',
            failed_stale: 'Fehler beim fetch stale Bezeichnungen. Bitte versuchen Sie es erneut.',
            failed_conflicts: 'Fehler beim fetch Bezeichnung conflicts. Bitte versuchen Sie es erneut.',
            review_permission_denied: 'Sie haben keine Berechtigung, dieses Label zu überprüfen.',
            review_not_found: 'Label nicht gefunden — es wurde möglicherweise gelöscht.',
            approve_selected: 'Ausgewählte genehmigen',
            reject_selected: 'Ausgewählte ablehnen',
            approved: 'Genehmigt',
            rejected: 'Abgelehnt',
            labels_count: 'Labels',
            failed_count: 'fehlgeschlagen',
            confirm_approve: 'Genehmigung bestätigen',
            confirm_reject: 'Ablehnung bestätigen',
            approve_n_labels: '{count} Labels genehmigen?',
            reject_n_labels: '{count} Labels ablehnen?',
            submit_for_review: 'Zur Überprüfung einreichen',
            approve: 'Genehmigen',
            reject: 'Ablehnen',
            parent_system: 'Uebergeordnetes System',
            parent_system_placeholder: 'System auswaehlen...',
            parent_system_help: 'Fuer Konflikterkennung verwendet.',
            dataset_level: 'Datensatzebene',
            parent_level: 'Uebergeordnete Ebene',
            bulk_created: '{created} Beschriftung(en) erstellt',
            bulk_skipped: '{skipped} uebersprungen',
            bulk_all_skipped: 'Alle {skipped} uebersprungen',
            ids_hint: 'IDs durch Kommas getrennt eingeben',
            delete_confirm: 'Beschriftung fuer "{id}" loeschen?',
        },
        lifecycle: {
            title: 'Datenlebenszyklus-Überwachung',
            new: 'Neuer Eintrag',
            current_stage: 'Aktuelle Phase',
            last_transition: 'Letzter Übergang',
            transition: 'Übergang',
            view_history: 'Verlauf anzeigen',
            stages: {
                creation: 'Erstellung',
                collection: 'Erhebung',
                processing: 'Verarbeitung',
                storage: 'Speicherung',
                retention: 'Aufbewahrung',
                disposal: 'Entsorgung',
                archived: 'Archiviert',
                active: 'Aktiv',
                pending_deletion: 'Ausstehend Deletion',
                deleted: 'Gelöscht',
                on_hold: 'On Zurückstellen',
            },
            all_stages: 'Alle Stufen',
            object_id: 'Objekt ID',
            object_type: 'Objekt Typ',
            policy_reference: 'Richtlinie Referenz',
            retention_period_days: 'Aufbewahrung Zeitraum (days)',
            retention_basis: 'Aufbewahrung Grundlage',
            deletion_method: 'Deletion Methode',
            deletion_secure_erase: 'Sicher Erase',
            deletion_anonymization: 'Anonymisierung',
            deletion_physical_destruction: 'Physisch Destruction',
            deletion_other: 'Andere',
            responsible_party: 'Verantwortlich Party',
            responsible_user_id: 'Verantwortlich Benutzer ID',
            retention_expiry: 'Aufbewahrung Ablauf',
            hold_reason: 'Zurückstellen Grund',
            hold: 'Zurückstellen',
            release: 'Freigabe',
            hide_events: 'Ausblenden Ereignisse',
            events_timeline: 'Ereignisse Zeitverlauf',
            add_event: 'Hinzufügen Ereignis',
            event_type: 'Ereignis Typ',
            create_event: 'Erstellen Ereignis',
            from_stage: 'Von Stufe',
            to_stage: 'Zu Stufe',
            actor: 'Akteur',
            reason_placeholder: 'Grund...',
            go: 'Go',
            show_expired_retentions: 'Anzeigen Abgelaufen Retentions',
            hide_expired_retentions: 'Ausblenden Abgelaufen Retentions',
            expired_retentions_alert: 'Abgelaufen Retentions Warnung',
            failed_fetch: 'Fehler beim fetch Lebenszyklus Datensätze. Bitte versuchen Sie es erneut.',
            failed_save: 'Fehler beim save Lebenszyklus Datensatz. Bitte versuchen Sie es erneut.',
            failed_transition: 'Fehler beim transition Lebenszyklus Stufe. Bitte versuchen Sie es erneut.',
            failed_hold: 'Fehler beim place Zurückstellung. Bitte versuchen Sie es erneut.',
            failed_release: 'Fehler beim release Zurückstellung. Bitte versuchen Sie es erneut.',
            failed_fetch_events: 'Fehler beim fetch Lebenszyklus Ereignisse. Bitte versuchen Sie es erneut.',
            failed_create_event: 'Fehler beim create Lebenszyklus Ereignis. Bitte versuchen Sie es erneut.',
            failed_expired: 'Fehler beim fetch expired retentions. Bitte versuchen Sie es erneut.',
            hold_reason_prompt: 'Eingeben Zurückstellung reason:',
            loaded_count: '{count} Lebenszyklus-Datensätze geladen',
            stage_transition_for: 'Phasenübergang für {id}',
            event_created: 'Erstellt',
            event_updated: 'Aktualisiert',
            event_approved: 'Genehmigt',
            event_deprecated: 'Veraltet',
            event_proposed: 'Vorgeschlagen',
            event_reviewed: 'Überprüft',
            event_archived: 'Archiviert',
            event_restored: 'Wiederhergestellt',
        },
        gap_report: {
            title: 'Klassifizierungslückenbericht',
            unlabeled: 'Nicht gekennzeichnete Daten',
            missing_lifecycle: 'Fehlender Lebenszyklus',
            stale_labels: 'Veraltete Kennzeichnungen',
            run_detection: 'Ausführen Lücke Erkennung',
            detecting: 'Erkenne...',
            detection_complete: 'Lücke detection abgeschlossen. {count} gap(s) detected.',
            detection_failed: 'Lücke detection fehlgeschlagen.',
            by_severity: 'By Schweregrad',
            by_gap_type: 'By Lücke Typ',
            all_gap_types: 'Alle Lücke Typen',
            conflicting_labels: 'Conflicting Bezeichnungen',
            expired_retention: 'Abgelaufen Aufbewahrung',
            missing_handling: 'Fehlend Handhabung',
            info: 'Infos',
            gap_type: 'Lücke Typ',
            object_id: 'Objekt ID',
            object_type: 'Objekt Typ',
            detected_at: 'Erkannt At',
            open: 'Offen',
            acknowledged: 'Bestätigt',
            remediated: 'Behoben',
            accepted: 'Akzeptiert',
            acknowledge: 'Bestätigen',
            remediate: 'Beheben',
            accept_risk: 'Akzeptieren Risiko',
            accept_risk_prompt: 'Eingeben Risiko acceptance Begründung:',
            failed_fetch: 'Fehler beim fetch Lücken. Bitte versuchen Sie es erneut.',
            failed_acknowledge: 'Fehler beim acknowledge Lücke. Bitte versuchen Sie es erneut.',
            failed_remediate: 'Fehler beim remediate Lücke. Bitte versuchen Sie es erneut.',
            failed_accept_risk: 'Fehler beim accept Lücke Risiko. Bitte versuchen Sie es erneut.',
            failed_detect: 'Fehler beim Durchlauf Lücke detection. Bitte versuchen Sie es erneut.',
            loaded_count: '{count} Klassifizierungslücken geladen',
            related_object_id: 'Zugehörige Objekt-ID',
            related_object_type: 'Zugehöriger Objekttyp',
            gap_types: {
                unlabeled_asset: 'Nicht beschriftetes Objekt',
                missing_lifecycle: 'Fehlender Lebenszyklus',
                expired_retention: 'Abgelaufene Aufbewahrung',
                extended_pending_deletion: 'Aussstehende Loeschung',
            },
        },
        label_workflow: {
            title: 'Etikett-Workflow',
            proposed: 'Vorgeschlagen',
            under_review: 'In Prüfung',
            approved: 'Genehmigt',
            deprecated: 'Veraltet',
            submit_review: 'Zur Prüfung einreichen',
            approve: 'Etikett genehmigen',
            deprecate: 'Als veraltet markieren',
            bulk_approve: 'Massengenehmigung',
            bulk_approve_success: 'Etiketten erfolgreich genehmigt.',
            submit_success: 'Etikett zur Prüfung eingereicht.',
            approve_success: 'Etikett genehmigt.',
            deprecate_success: 'Etikett als veraltet markiert.',
        },
        review_tasks: {
            title: 'Prüfaufgaben',
            create: 'Neue Prüfaufgabe',
            system: 'System',
            owner: 'Eigentümer',
            description: 'Beschreibung',
            resolution: 'Lösung',
            resolve: 'Lösen',
            approve: 'Genehmigen',
            modify: 'Ändern',
            reject: 'Ablehnen',
            escalate: 'Eskalieren',
            escalated: 'Eskalierte Aufgaben',
            no_tasks: 'Keine Prüfaufgaben.',
            resolve_success: 'Prüfaufgabe gelöst.',
            status_pending: 'Ausstehend',
            status_resolved: 'Gelöst',
            status_escalated: 'Eskaliert',
            notes: 'Notizen',
            create_success: 'Überprüfungsaufgabe erstellt.',
            no_tasks_detail: 'Noch keine Überprüfungsaufgaben — erstellen Sie eine Aufgabe, um Label-Überprüfungen an Systemverantwortliche zuzuweisen.',
            label_id: 'Label-ID',
            system_id: 'System-ID',
            system_name: 'Systemname',
            owner_id: 'Eigentümer-ID',
            resolution_col: 'Loesung',
            notes_col: 'Notizen',
        },
        exceptions: {
            title: 'Ausnahmewarteschlange',
            create: 'Neue Ausnahme',
            severity: 'Schweregrad',
            system: 'System',
            owner: 'Eigentümer',
            resolve: 'Lösen',
            no_exceptions: 'Keine Ausnahmen gefunden.',
            resolve_success: 'Ausnahme gelöst.',
            dashboard_open: 'Offene Ausnahmen',
            dashboard_resolved: 'Gelöste Ausnahmen',
            dashboard_total: 'Gesamt',
            dashboard_by_severity: 'Nach Schweregrad',
            status_open: 'Offen',
            status_resolved: 'Gelöst',
            status_accepted_risk: 'Akzeptiertes Risiko',
            create_success: 'Ausnahme erstellt.',
            no_exceptions_detail: 'Noch keine Ausnahmen — Ausnahmen werden aus schwerwiegenden Lücken erstellt, die besondere Behandlung erfordern.',
            gap_id: 'Lücken-ID',
            system_id: 'System-ID',
            system_name: 'Systemname',
            owner_id: 'Eigentümer-ID',
            resolution_notes: 'Lösungshinweise',
            resolution_notes_placeholder: 'Beschreiben Sie, wie diese Ausnahme gelöst wurde...',
        },
        enterprise_map: {
            title: 'Unternehmensdatenkarte',
            inventory: 'Dateninventar',
            total_systems: 'Systeme gesamt',
            total_labels: 'Etiketten gesamt',
            approved_count: 'Genehmigte Etiketten',
            proposed_count: 'Vorgeschlagene Etiketten',
            no_data: 'Keine Klassifizierungsdaten verfügbar.',
            no_approved_labels: 'Noch keine genehmigten Labels — Labels müssen überprüft und genehmigt werden, bevor sie auf der Datenkarte erscheinen.',
            loaded_count: 'Geladene Unternehmensdatenkarte',
        },
        discovery: {
            title: 'Entdeckungszyklen',
            create: 'Neuer Zyklus',
            cycle_name: 'Zyklusname',
            run_delta: 'Deltaerkennung ausführen',
            delta_success: 'Deltaerkennung abgeschlossen.',
            create_success: 'Entdeckungszyklus erstellt.',
            no_cycles: 'Keine Entdeckungszyklen.',
            status_created: 'Erstellt',
            status_scanning: 'Scannen',
            status_review: 'Rezension',
            status_approved: 'Genehmigt',
            status_published: 'Veröffentlicht',
            status_draft: 'Entwurf',
            running: 'Läuft',
            completed: 'Abgeschlossen',
            cancelled: 'Abgebrochen',
            delta_result_summary: '{added} hinzugefügt, {removed} entfernt, {changed} geänderte Labels gefunden.',
            delta_results: 'Delta-Ergebnisse',
            view_results: 'Ergebnisse anzeigen',
            scope_type: 'Bereichstyp',
            scope_type_all: 'Alle',
            scope_type_systems: 'Systeme',
            scope_type_datasets: 'Datensätze',
            scope_ids: 'Bereichs-IDs',
            scope_ids_placeholder: 'Geben Sie die IDs durch Kommas getrennt ein',
            cycle_explanation: 'Ein Erkennungszyklus scannt Ihre Dateninfrastruktur, um Datenbestände zu identifizieren, zu klassifizieren und zu verfolgen. Konfigurieren Sie den Bereich so, dass er auf bestimmte Systeme oder Datensätze abzielt.',
            empty_state_title: 'Noch keine Entdeckungszyklen',
            empty_state_description: 'Erstellen Sie Ihren ersten Erkennungszyklus, um mit dem Scannen und Klassifizieren Ihrer Datenbestände zu beginnen.',
            empty_state_cta: 'Erstellen Sie den ersten Zyklus',
            validation_name_required: 'Zyklusname ist erforderlich',
            validation_scope_type_required: 'Bereichstyp ist erforderlich',
            validation_scope_ids_required: 'Es ist mindestens eine Bereichs-ID erforderlich',
        },
        regulatory: {
            sensitivity_importance_info: 'Das Datenrecht (Gesetz [[TOK_0]], Anforderung 18e4bfd1) erfordert eine Klassifizierung sowohl nach Sensibilität als auch nach Wichtigkeit als separate Dimensionen. Erstellen Sie für jede Dimension eine Taxonomie, um diese Anforderung zu erfüllen.',
            handling_rules_info: 'Jede Klassifizierungsebene sollte je nach Bedarf Handhabungsregeln definieren. b89981ac („Handhabungsregeln nach Klassifizierungsstufe definieren“).',
            template_internal_ids_info: 'Alle Klassifizierungsvorlagen verwenden interne IDs (z. B. vn_data_law_data_classification_record). Es wird keine Vorlage als offizielles Ministeriumsformular vorgelegt.',
            ai_risk_tiers_info: 'Das [[TOK_0]]-Gesetz (Gesetz [[TOK_3]], Anforderung 3a87ad63) definiert vier [[TOK_1]] Systemrisikostufen: minimal, begrenzt, hoch und inakzeptabel. Erstellen Sie eine [[TOK_2]] Risikotaxonomie mit diesen Ebenen.',
            ai_risk_tier_minimal: 'Minimal',
            ai_risk_tier_limited: 'Begrenzt',
            ai_risk_tier_high: 'Hoch',
            ai_risk_tier_unacceptable: 'Inakzeptabel',
            ai_register_info: '[[TOK_0]]-Klassifizierungsdatensätze sollten mit einem [[TOK_1]]-Systemregistereintrag (Anforderung 0f4475d3) verknüpft sein, der Folgendes erfasst: Systemname, Eigentümer, Zweck, Bereitstellungskontext, Risikostufe, Anbieterbeteiligung.',
            ai_template_internal_info: '[[TOK_0]] Klassifizierungsvorlagen verwenden interne IDs (z. B. [[TOK_1]]-RISK-01). Es werden keine offiziellen [[TOK_2]]-Platzhalter-IDs ([[TOK_3]]-HC-01 bis [[TOK_4]]-HC-08) verwendet.',
            ai_audit_trail_info: '[[TOK_0]] Klassifizierungsänderungen erzeugen einen versionierten Prüfpfad gemäß UC-VN-06: Akteur, Zeitstempel, vorheriger Wert, neuer Wert und Begründung.',
            lifecycle_data_d1_info: 'Lebenszyklusübergänge sind den Schritten des Datengesetzverfahrens DATA-D1 zugeordnet: Katalogisieren, klassifizieren, Handhabungsregeln definieren, Beweise erfassen, Überprüfungen planen.',
            lifecycle_deletion_link_info: 'Ein klassifizierter Datenbestand, der das Ende seiner Lebensdauer erreicht, sollte über das Modul „Deletion Orchestration“ einen Löschplandatensatz auslösen.',
            lifecycle_evidence_info: 'Bei jeder Änderung des Lebenszyklusstatus (Entwurf, aktiv, in Prüfung, archiviert, gelöscht) werden Akteur, Zeitstempel und Begründung als Audit-Trail-Eintrag erfasst.',
            escalation_timers_info: 'UC-VN-10 Eskalationsfristen: 5 Werktage für die Überprüfung durch den Eigentümer, 48 Stunden für die Ausnahmeeskalation, 72 Stunden für risikoreiche/sensible Elemente.',
            escalation_owner_review: '5 Werktage',
            escalation_exception: '48 Stunden',
            escalation_high_risk: '72 Stunden',
            gap_risk_areas_info: 'Datengesetzanforderung. f6c3060a („Datenrisikobewertung“) erfordert eine Lückenanalyse in vier Risikobereichen: Datenschutz, Cybersicherheit, Zugangskontrolle und Betriebsrisiko.',
            gap_risk_area_privacy: 'Datenschutz',
            gap_risk_area_cybersecurity: 'Cybersicherheit',
            gap_risk_area_access: 'Zugriffskontrolle',
            gap_risk_area_operational: 'Betrieblich',
            gap_framework_filter_info: 'Filtern Sie Lücken nach Regulierungsrahmen (VN_DATA_LAW oder VN_AI_LAW_2026), um relevante Lücken für jeden Regulierungsbereich zu sehen.',
            framework_vn_data_law: 'VN Datengesetz',
            framework_vn_ai_law: 'VN KI-Gesetz 2026',
            enterprise_map_approved_info: 'Diese Datenkarte zeigt nur genehmigte Klassifizierungsdatensätze gemäß UC-VN-10 Workflow-Schritt 10 („Genehmigte Labels werden zur aktuellen Unternehmenswahrheit“). Entwurfs- und vorgeschlagene Aufzeichnungen sind ausgeschlossen.',
            exports_bundle_info: 'Zu den Exportpaketen gehören: Klassifizierungsregister, Handhabungsregeln, Eigentum/RACI und Beweispaket – entsprechend UC-VN-10 Exportanforderungen und DATA-EVD-01 Beweisblattformat.',
        },
    },
    monitoring: {
        no_permission_title: 'Unzureichende Berechtigungen',
        no_permission_message: 'Sie haben keine Berechtigung auf dieses Uberwachungsmodul zuzugreifen.',
        errors: {
            fetch: 'Fehler beim load..',
            save: 'Fehler beim save..',
            fetch_programs_failed: 'Fehler beim fetch Programme..',
            fetch_kpi_failed: 'Fehler beim fetch KPI Daten..',
            create_snapshot_failed: 'Fehler beim create Snapshot..',
            fetch_periods_failed: 'Fehler beim fetch Zeiträume..',
            create_period_failed: 'Fehler beim create Zeitraum..',
            auto_generate_failed: 'Fehler beim auto-generate Zeiträume..',
            start_period_failed: 'Fehler beim start Zeitraum..',
            close_period_failed: 'Fehler beim close Zeitraum..',
            save_program_failed: 'Fehler beim save Programm..',
            activate_program_failed: 'Fehler beim activate Programm..',
            pause_program_failed: 'Fehler beim pause Programm..',
            complete_program_failed: 'Fehler beim abgeschlossen Programm..',
            archive_program_failed: 'Fehler beim archive Programm..',
            fetch_ric_templates_failed: 'Fehler beim fetch RIC Vorlagen..',
            fetch_ric_cases_failed: 'Fehler beim fetch RIC cases..',
            create_ric_case_failed: 'Fehler beim create RIC case..',
            transition_ric_failed: 'Fehler beim transition RIC case..',
            add_follow_up_failed: 'Fehler beim add follow-up..',
            respond_follow_up_failed: 'Fehler beim respond zu follow-up..',
            link_evidence_failed: 'Fehler beim link Nachweis..',
            fetch_task_templates_failed: 'Fehler beim fetch Aufgabe Vorlagen..',
            save_task_template_failed: 'Fehler beim save Aufgabe Vorlage..',
            delete_task_template_failed: 'Fehler beim delete Aufgabe Vorlage..',
            delete_framework_link_failed: 'Fehler beim Löschen der Framework-Verknüpfung.',
            seed_defaults_failed: 'Fehler beim seed Standardwerte..',
            fetch_tasks_failed: 'Fehler beim fetch Aufgaben..',
            create_task_failed: 'Fehler beim create Aufgabe..',
            instantiate_tasks_failed: 'Fehler beim instantiate Aufgaben..',
            start_task_failed: 'Fehler beim start Aufgabe..',
            complete_task_failed: 'Fehler beim abgeschlossen Aufgabe..',
            defer_task_failed: 'Fehler beim defer Aufgabe..',
            block_task_failed: 'Fehler beim block Aufgabe..',
            override_complete_failed: 'Fehler beim override abgeschlossen..',
            assign_task_failed: 'Fehler beim assign Aufgabe..',
            update_checklist_failed: 'Fehler beim update checklist..',
        },
        nav: {
            programs: 'Programme',
            periods: 'Zeiträume',
            task_templates: 'Aufgabenvorlagen',
            tasks: 'Aufgaben',
            kpi: 'KPI-Übersicht',
            ric: 'Behördenanfragen',
            framework_link: 'Rahmenüberwachung',
            authority_readiness: 'Behördenbereitschaft',
            change_review: 'Änderungsüberprüfung',
            raci: 'RACI-Matrix',
        },
        programs: {
            page_title: 'Überwachungsprogramme',
            title: 'Überwachungsprogramme',
            new: 'Neues Programm',
            edit: 'Programm bearbeiten',
            name: 'Bezeichnung',
            scope: 'Umfang',
            frequency: 'Häufigkeit',
            owner: 'Verantwortlicher',
            activate: 'Aktivieren',
            pause: 'Pausieren',
            resume: 'Fortsetzen',
            complete: 'Abschließen',
            archive: 'Archivieren',
            custom_frequency_days: 'Benutzerdefiniert Häufigkeit (days)',
            select_user: 'Benutzer auswählen…',
            assign_training: 'Schulung zuweisen',
            linked_forms: 'Verknüpfte Formulare',
            linked_forms_none: 'Noch keine verknüpften Formulare',
            loaded_count: '{0} Programme geladen',
            scope_labels: {
                full: 'Vollständig',
                partial: 'Teilweise',
                targeted: 'Gezielt',
                consent: 'Einwilligung',
                dpia: 'DPIA',
                vendors: 'Lieferanten',
                classification: 'Klassifizierung',
                rights_requests: 'Betroffenenanfragen',
                data_mapping: 'Datenkartierung',
                transfers: 'Übertragungen',
                security_monitoring: 'Sicherheitsüberwachung',
                authority_response: 'Antwort der Behörde',
                evidence_preservation: 'Beweissicherung',
                localization_review: 'Überprüfung der Lokalisierung',
                ai_system_registration: '[[TOK_0]] Systemregistrierung',
                ai_pre_deployment: '[[TOK_0]] Bewertung vor der Bereitstellung',
                ai_transparency: '[[TOK_0]] Transparenzprüfung',
                ai_incident_review: '[[TOK_0]] Vorfallüberprüfung',
            },
            framework_cadence_info: 'Cybersecurity Law programs typically use continuous/monthly/quarterly cadences. AI Law programs typically use annual review cadences.',
        },
        periods: {
            page_title: 'Überwachungszeiträume',
            title: 'Prüfungszeiträume',
            new: 'Neuer Zeitraum',
            label: 'Zeitraumbezeichnung',
            start_date: 'Startdatum',
            end_date: 'Enddatum',
            reviewers: 'Prüfer',
            auto_generate: 'Zeiträume automatisch generieren',
            start: 'Starten',
            close: 'Schließen',
            change_digest: 'Änderungsübersicht',
            no_digest: 'Kein Digest verfügbar.',
            reviewers_count: 'Prüfer Anzahl',
            select_program: 'Auswählen Programm',
            select_program_prompt: 'Auswählen ein Programm zu view Zeiträume.',
            hide_digest: 'Ausblenden Digest',
            loaded_count: '{0} Zeiträume geladen',
            periods_auto_generated: 'Zeiträume automatisch generiert',
            label_placeholder: 'z.B. 2026-Q1',
        },
        task_templates: {
            page_title: 'Aufgabenvorlagen',
            title: 'Aufgabenvorlagen',
            new: 'Neue Vorlage',
            edit: 'Vorlage bearbeiten',
            category: 'Kategorie',
            priority: 'Priorität',
            checklist_items: 'Checklisten-Elemente',
            effort: 'Geschätzter Aufwand (Stunden)',
            pre_seeded: 'Vorgefüllt',
            seed_defaults: 'Standardwerte laden',
            add_checklist: 'Checklisten-Element hinzufügen',
            guidance: 'Hinweise',
            all_categories: 'Alle Kategorien',
            loaded_count: '{0} Aufgabenvorlagen geladen',
            defaults_seeded: 'Standard-Aufgabenvorlagen erstellt',
            checklist_item_label: 'Checklisten-Element {0}',
            remove_checklist_item: 'Checklisten-Element {0} entfernen',
            category_info: 'Categories cover PDPL compliance, Cybersecurity Law tasks, and AI Law tasks.',
        },
        tasks: {
            page_title: 'Prüfungsaufgaben',
            title: 'Prüfungsaufgaben',
            new: 'Neue Aufgabe',
            assigned_to: 'Zugewiesen an',
            due_date: 'Fälligkeitsdatum',
            checklist: 'Checkliste',
            start: 'Starten',
            complete: 'Abschließen',
            defer: 'Zurückstellen',
            block: 'Blockieren',
            override_complete: 'Abschluss erzwingen',
            link_evidence: 'Nachweis verknüpfen',
            direct_upload_label: 'Nachweisdatei hochladen',
            instantiate: 'Aus Vorlagen erstellen',
            defer_reason: 'Grund für die Zurückstellung',
            override_justification: 'Begründung für die Erzwingung',
            filter_assignee: 'Filtern nach assignee',
            select_period: 'Auswählen Zeitraum',
            select_program: 'Auswählen Programm',
            select_program_period_prompt: 'Auswählen ein Programm und Zeitraum zu view Aufgaben.',
            assign_placeholder: 'Zuweisen zu...',
            loaded_count: '{0} Aufgaben geladen',
            tasks_instantiated: 'Aufgaben aus Vorlagen erstellt',
            overdue: 'Überfällig',
            checklist_for: 'Checkliste für',
            manage_checklist: 'Checkliste verwalten',
            add_checklist_item: 'Element hinzufügen',
            checklist_item_label: 'Element',
            checklist_item_description: 'Beschreibung',
            remove_checklist_item: 'Element entfernen',
            save_checklist: 'Checkliste speichern',
            no_checklist_items: 'Noch keine Checklistenelemente.',
            confirm_delete_attachment: 'Möchten Sie diese Nachweisdatei wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
        },
        kpi: {
            page_title: 'KPI-Übersicht',
            title: 'KPI-Übersicht',
            kpi_name: 'KPI-Name',
            current_value: 'Aktueller Wert',
            target: 'Zielwert',
            trends: 'Entwicklungen',
            capture_snapshot: 'Erfassen Snapshot',
            select_program: 'Auswählen Programm',
            select_program_prompt: 'Auswählen ein Programm zu view KPIs.',
            snapshot: 'Momentaufnahme',
            kpi_labels: {
                on_track: 'On Verfolgen',
                at_risk: 'At Risiko',
                behind: 'Zurückliegend',
                rights_request_sla_rate: 'SLA-Rate für Betroffenenanfragen',
                vendor_review_currency: 'Lieferantenprüfung Aktualität',
                dpia_completion_rate: 'DPIA-Abschlussrate',
                classification_coverage: 'Klassifizierungsabdeckung',
                consent_policy_currency: 'Einwilligungsrichtlinie Aktualität',
                security_event_detection_rate: 'Erkennungsrate von Sicherheitsereignissen',
                evidence_preservation_compliance_rate: 'Compliance-Rate bei der Beweissicherung',
                authority_response_timeliness: 'Rechtzeitige Reaktion der Behörden',
                localization_readiness_score: 'Bewertung der Lokalisierungsbereitschaft',
                ai_register_completeness: '[[TOK_0]] Vollständigkeit des Systemregisters',
                pre_deployment_gate_pass_rate: 'Gate-Pass-Rate vor der Bereitstellung',
                transparency_disclosure_coverage: 'Abdeckung der Transparenzoffenlegung',
                ai_incident_readiness_score: '[[TOK_0]] Incident Readiness Score',
            },
            pdpl_kpi_info: 'The predefined KPI codes are PDPL-specific metrics. For Cybersecurity Law or AI Law monitoring, use framework-specific KPI codes.',
            cybersec_kpi_info: 'KPIs zum Cybersicherheitsrecht: Erkennungsrate von Sicherheitsereignissen, Compliance-Rate bei der Beweissicherung, Pünktlichkeit der behördlichen Reaktion, Bewertung der Lokalisierungsbereitschaft.',
            ai_law_kpi_info: '[[TOK_0]] Gesetzes-KPIs: [[TOK_1]] Systemregister-Vollständigkeit, Pre-Deployment-Gate-Pass-Rate, Transparenz-Offenlegungsabdeckung, [[TOK_2]] Incident Readiness Score.',
            no_data: 'No Daten available.',
            snapshot_date: 'Snapshot Datum',
            loaded_count: '{0} KPI-Momentaufnahmen geladen',
            snapshot_captured: 'KPI-Momentaufnahme erstellt',
            showing_chart: 'Diagrammansicht',
            showing_table: 'Datentabellenansicht',
            aria_current_values: 'KPI aktuelle Werte',
            kpi_label: 'KPI',
            actual: 'Ist',
            trend: 'Trend',
            notes: 'Anmerkungen',
            trend_up: 'Steigend',
            trend_down: 'Fallend',
            trend_stable: 'Stabil',
        },
        ric: {
            page_title: 'RIC-Fälle',
            title: 'Behördenanfragen',
            new: 'Neue Behördenanfrage',
            reference: 'Referenz',
            regulator: 'Aufsichtsbehörde',
            inquiry_type: 'Art der Anfrage',
            deadline: 'Antwortfrist',
            lead: 'Verantwortlicher',
            follow_ups: 'Nachverfolgungen',
            add_follow_up: 'Nachverfolgung hinzufügen',
            respond: 'Antworten',
            question: 'Frage',
            response: 'Antwort',
            asked_at: 'Gefragt am',
            no_follow_ups: 'Noch keine Nachverfolgungen.',
            received_date: 'Empfangen Datum',
            responded_at: 'Reagiert At',
            hide_follow_ups: 'Ausblenden Follow-ups',
            inquiry_types: {
                general: 'Allgemein',
                investigation: 'Untersuchung',
                audit: 'Prüfung',
                complaint: 'Beschwerde',
                general_audit: 'Allgemeine Prüfung',
                rights_requests_review: 'Prüfung der Betroffenenanfragen',
                cross_border_transfer_review: 'Prüfung grenzüberschreitender Übertragungen',
                vendor_governance_review: 'Prüfung der Lieferantensteuerung',
                consent_management_review: 'Prüfung des Einwilligungsmanagements',
                data_mapping_ropa_review: 'Prüfung der Datenkartierung / ROPA',
                incident_readiness_review: 'Prüfung der Vorfallbereitschaft',
                security_access_control_review: 'Prüfung von Sicherheit und Zugriffskontrolle',
                targeted_processing_review: 'Prüfung gezielter Verarbeitung',
                bank_readiness_pack: 'Bank-Bereitschaftspaket',
            },
            link_evidence: 'Verknüpfen Nachweis',
            loaded_count: '{0} RIC-Fälle geladen',
            to_follow_up: 'zur Nachverfolgungsfrage',
            overdue: 'Überfällig',
            overdue_indicator: 'Antwortfrist überschritten',
            template_info: 'RIC templates are internal platform templates. They are not official government-mandated forms.',
            status_labels: {
                received: 'Erhalten',
                in_triage: 'In Sichtung',
                evidence_gathering: 'Beweissammlung',
                response_drafting: 'Antwortentwurf',
                internal_review: 'Interne Prüfung',
                submitted: 'Eingereicht',
                follow_up: 'Nachverfolgung',
                closed: 'Geschlossen',
            },
        },
        framework_link: {
            title: 'Rahmenverknüpfte Überwachung',
            link_program: 'Programm mit Rahmen verknüpfen',
            framework_code: 'Rahmencode',
            select_framework: 'Rahmenwerk auswählen...',
            select_program: 'Programm auswählen...',
            readiness_score: 'Bereitschaftsbewertung',
            no_links: 'Keine rahmenverknüpften Programme gefunden',
            seed_defaults: 'Standardvorlagen erstellen',
            program_id: 'Programm-ID',
            program: 'Programm',
        },
        authority_readiness: {
            title: 'Behördenanfragenbereitschaft',
            create_entry: 'Neuer Bereitschaftseintrag',
            select_framework: 'Rahmenwerk auswählen...',
            framework_code: 'Rahmenwerk',
            readiness_status: 'Bereitschaftsstatus',
            readiness_package: 'Bereitschaftspaket',
            run_drill: 'Bereitschaftsübung durchführen',
            drill_success: 'Bereitschaftsübung erfasst',
            last_drill: 'Letzte Übung',
            never_drilled: 'Nie',
            no_readiness: 'Keine Behördenbereitschaftsdaten gefunden',
            entry_created: 'Bereitschaftseintrag erstellt',
            ready: 'Bereit',
            partial: 'Teilweise',
            not_ready: 'Nicht bereit',
            items: 'Elemente',
        },
        change_review: {
            title: 'Regulatorische Änderungsüberprüfung',
            new_review: 'Neue Änderungsüberprüfung',
            change_id: 'Änderungs-ID',
            select_change: 'Änderung auswählen...',
            select_framework: 'Rahmenwerk auswählen...',
            impact_assessment: 'Auswirkungsbewertung',
            decision: 'Entscheidung',
            no_action: 'Keine Maßnahme',
            internal_update: 'Interne Aktualisierung',
            authority_filing: 'Behördenmeldung',
            no_reviews: 'Keine Änderungsüberprüfungen gefunden',
            auto_cycle: 'Automatischer Überprüfungszyklus',
            cadence: 'Überprüfungsrhythmus',
            framework: 'Rahmenwerk',
        },
        export_csv: 'Exportieren [[TOK_0]]',
        exporting: 'Exportieren…',
        export_success: '[[TOK_0]] erfolgreich exportiert.',
        export_failed: '[[TOK_0]] Export fehlgeschlagen.',
        export_attestation_pack: 'Attestierungspaket exportieren',
        staleness: {
            badge_label: '[[TOK_1]] veraltete Elemente',
            days_since: '[[TOK_1]] Tage seit der letzten Aktualisierung',
            detail_title: 'Veraltete Gegenstände',
            accept_justification: 'Akzeptieren Sie mit Begründung',
            justification_label: 'Begründung',
            no_stale: 'Keine veralteten Artikel gefunden.',
            threshold_label: 'Verjährungsschwelle (Tage)',
            threshold_min: 'Mindestens 30 Tage',
            threshold_max: 'Maximal 730 Tage',
            threshold_saved: 'Schwellenwert für Veraltung aktualisiert.',
        },
        csv_columns: {
            name: 'Name',
            status: 'Status',
            owner: 'Besitzer',
            created_at: 'Erstellt am',
            updated_at: 'Aktualisiert am',
            scope: 'Umfang',
            frameworks: 'Rahmenwerke',
            period_label: 'Periodenbeschriftung',
            start_date: 'Startdatum',
            end_date: 'Enddatum',
            task_count: 'Aufgabenanzahl',
            completion_rate: 'Abschlussrate',
            title: 'Titel',
            assigned_to: 'Zugewiesen an',
            due_date: 'Fälligkeitsdatum',
            priority: 'Priorität',
            completed_at: 'Abgeschlossen am',
            kpi_code: '[[TOK_0]] Code',
            kpi_label: '[[TOK_0]] Beschriftung',
            target: 'Ziel',
            actual: 'Tatsächlich',
            trend: 'Trend',
            reference: 'Referenz',
            regulator: 'Regulator',
            inquiry_type: 'Anfragetyp',
            lead: 'Führen',
            received_date: 'Empfangsdatum',
            deadline: 'Frist',
            framework_code: 'Rahmencode',
            readiness_status: 'Bereitschaftsstatus',
            package_count: 'Paketanzahl',
            change_id: 'ID ändern',
            impact_assessment: 'Folgenabschätzung',
            decision: 'Entscheidung',
            program: 'Programm',
            readiness_score: 'Bereitschaftsbewertung',
            category: 'Kategorie',
            checklist_count: 'Anzahl der Checklisten',
            effort_hours: 'Aufwand (Stunden)',
            version: 'Version',
            department: 'Abteilung',
            function_area: 'Funktionsbereich',
            role: 'Rolle',
            assignee: 'Bevollmächtigter',
            frequency: 'Häufigkeit',
        },
        raci: {
            page_title: 'Governance RACI-Matrix',
            title: 'Governance RACI-Matrix',
            department: 'Abteilung',
            function_area: 'Funktionsbereich',
            responsible: 'Verantwortlich',
            accountable: 'Verantwortlich',
            consulted: 'Konsultiert',
            informed: 'Informiert',
            assign_role: 'RACI-Rolle zuweisen',
            select_program: 'Wählen Sie Programm',
            select_program_prompt: 'Wählen Sie ein Programm aus, um die RACI-Matrix anzuzeigen.',
            no_assignments: 'Keine RACI-Zuweisungen gefunden.',
            role_updated: 'RACI-Zuweisung aktualisiert.',
            role_labels: {
                R: 'Verantwortlich',
                A: 'Verantwortlich',
                C: 'Konsultiert',
                I: 'Informiert',
            },
            loaded_count: '[[TOK_1]] RACI-Zuweisungen geladen',
            single_accountability_warning: 'Pro Funktionsbereich ist nur eine verantwortliche Rolle (A) zulässig. Durch die Zuweisung einer neuen verantwortlichen Rolle wird die bestehende ersetzt.',
            cybersec_function_areas: 'Funktionsbereiche des Cybersicherheitsrechts: Reaktion auf Vorfälle, Beweissicherung, Zusammenarbeit mit Behörden, Überprüfung der Lokalisierung.',
            ai_law_function_areas: '[[TOK_0]] Rechtsfunktionsbereiche: Systemregistrierung, Bewertung vor der Bereitstellung, Transparenz, Behandlung von Vorfällen.',
            suggested_function_areas: 'Empfohlene Funktionsbereiche',
        },
        prior_cycle: {
            link_label: 'Link zum vorherigen Zyklus',
            select_prior: 'Vorherigen Zyklus auswählen…',
            linked: 'Jahr für Jahr',
            no_prior: 'Keine früheren Zyklen verfügbar.',
            linked_success: 'Vorheriger Zyklus verknüpft.',
        },
        digest_table: {
            module: 'Modul',
            entity_type: 'Entitätstyp',
            change_type: 'Typ ändern',
            description: 'Beschreibung',
            changed_at: 'Geändert am',
        },
        view_related_ric: 'Verwandte RIC-Fälle anzeigen',
        linked_program: 'Verknüpftes Programm',
        nav_raci: 'RACI-Matrix',
    },
    incidents: {
        authority_response_draft: {
            draft_label: 'Antwortentwurf',
            drafting: 'Ausarbeitung…',
            results_heading: 'Vorgefasste Antworten ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]] Token',
            counsel_label: 'Beratungsprüfung erforderlich:',
            counsel_default: 'Mindestens eine Antwort muss vor dem Absenden von einem Berater überprüft werden.',
            requires_counsel_label: 'Erfordert eine anwaltliche Überprüfung.',
            accept_label: 'Entwurf akzeptieren',
            reject_label: 'Entwurf ablehnen',
            error_generic: 'Die Antwort konnte nicht verfasst werden. Versuchen Sie es erneut oder verfeinern Sie den Anfragetext.',
        },
        breach_timeline: {
            compute_label: 'Berechnen Sie den Zeitplan für die Benachrichtigung bei Compute-Verstößen',
            computing: 'Computer…',
            results_heading: 'Fristen für die Meldung von Verstößen ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]] Token',
            handoff_label: 'Forseti schlägt vor:',
            empty_label: 'Keine anwendbaren Rahmenwerke für die betroffenen Gerichtsbarkeiten.',
            mandatory_label: 'Pflichtfelder:',
            draft_label: 'Notifizierungsentwurf',
            remaining_label: 'Noch [[TOK_1]]h',
            overdue_label: 'ÜBERFÄLLIG von',
            acknowledge_label: 'Bestätigung – extern erstellte Aufgaben',
            acknowledging: 'Anerkennung…',
            error_generic: 'Der Zeitrahmen für den Verstoß konnte nicht berechnet werden. Versuchen Sie es erneut.',
        },
        breach_determination: {
            confirmed_breach: 'Bestätigt Verletzung',
            suspected_breach: 'Verdächtig Verletzung',
            not_a_breach: 'Nicht ein Verletzung',
            pending: 'Ausstehend',
        },
        errors: {
            fetch: 'Fehler beim load Vorfälle..',
            save: 'Fehler beim save Vorfall..',
            fetch_failed: 'Fehler beim fetch Vorfälle..',
            save_failed: 'Fehler beim save Vorfall..',
            transition_failed: 'Fehler beim transition Vorfall..',
            close_failed: 'Fehler beim close Vorfall..',
            fetch_timeline_failed: 'Fehler beim fetch Zeitverlauf..',
            fetch_decisions_failed: 'Fehler beim fetch decisions..',
            triage_failed: 'Fehler beim update triage..',
            impact_update_failed: 'Fehler beim update impact Bewertung..',
            breach_update_failed: 'Fehler beim update breach Bewertung..',
            create_timeline_failed: 'Fehler beim create Zeitverlauf Eintrag..',
            create_decision_failed: 'Fehler beim create Entscheidung..',
            notification_update_failed: 'Fehler beim update Benachrichtigung..',
            fetch_tasks_failed: 'Fehler beim fetch Aufgaben..',
            create_task_failed: 'Fehler beim create Aufgabe..',
            update_task_status_failed: 'Fehler beim Aktualisieren des Aufgabenstatus.',
            update_checklist_failed: 'Fehler beim update checklist..',
            assign_task_failed: 'Fehler beim assign Aufgabe..',
            escalate_task_failed: 'Fehler beim escalate Aufgabe..',
            fetch_templates_failed: 'Fehler beim fetch Vorlagen..',
            permission_denied: 'Sie haben keine Berechtigung auf diesen Bereich zuzugreifen. Wenden Sie sich an Ihren Administrator.',
        },
        harm_likelihood: {
            unlikely: 'Unwahrscheinlich',
            possible: 'Möglich',
            likely: 'Wahrscheinlich',
            very_likely: 'Sehr Wahrscheinlich',
        },
        reported_via: {
            email: 'E-Mail',
            phone: 'Telefon',
            internal_system: 'Intern System',
            third_party: 'Dritt Party',
            automated_detection: 'Automatisiert Erkennung',
        },
        task_transition_labels: {
            start: 'Starten',
            complete: 'Abschließen',
            block: 'Blockieren',
            defer: 'Aufschieben',
        },
        transition_labels: {
            start: 'Starten',
            complete: 'Abschließen',
            block: 'Blockieren',
            defer: 'Aufschieben',
        },
        nav: {
            all: 'Alle Vorfälle',
            tasks: 'Reaktionsaufgaben',
            reports: 'Berichte',
            breach_notifications: 'Verletzungsmeldungen',
            supplements: 'Ergänzungen',
            remediation: 'Behebung',
            authority_requests: 'Behördenanfragen',
            disclosure_register: 'Offenlegungsregister',
        },
        list: {
            page_title: 'Vorfälle',
            title: 'Vorfälle',
            new: 'Neuer Vorfall',
            edit: 'Vorfall bearbeiten',
            incident_title: 'Titel',
            severity: 'Schweregrad',
            reported_at: 'Gemeldet am',
            reported_by: 'Gemeldet von',
            assigned_to: 'Zugewiesen an',
            view_detail: 'Details anzeigen',
            reference: 'Referenz',
            lead: 'Leitung',
            reported_via: 'Gemeldet Via',
            discovery_date: 'Erkennung Datum',
            hide_details: 'Ausblenden Details',
            close_incident: 'Schließen Vorfall',
            close_justification_prompt: 'Bitte provide ein Begründung für closing dieses Vorfall.',
            justification: 'Begründung',
            lead_id: 'Leitung ID',
            contact: 'Kontakt',
            category: 'Kategorie',
            not_assessed: 'Nicht assessed',
        },
        detail: {
            page_title: 'Details zum Vorfall',
            title: 'Vorfalldetails',
            tabs: {
                overview: 'Übersicht',
                triage: 'Sichtung',
                impact: 'Auswirkungsbewertung',
                breach: 'Datenschutzverletzungsbewertung',
                timeline: 'Zeitverlauf',
                decisions: 'Entscheidungen',
                evidence: 'Nachweise',
                audit_trail: 'Prüfpfad',
            },
            evidence_upload_label: 'Nachweisdatei anhängen',
            evidence_uploaded: 'Nachweis hochgeladen',
            evidence_deleted: 'Nachweis gelöscht',
            evidence_delete_error: 'Nachweis konnte nicht gelöscht werden',
            evidence_uploaded_at: 'Hochgeladen',
            evidence_empty: 'Keine Nachweisdateien an diesen Vorfall angehängt.',
            evidence_size: 'Größe',
            triage_notes: 'Triage-Notizen',
            initial_classification: 'Erstklassifizierung',
            individuals_affected: 'Anzahl betroffener Personen',
            data_categories: 'Betroffene Datenkategorien',
            systems_compromised: 'Kompromittierte Systeme',
            geographic_scope: 'Geografischer Umfang',
            breach_determination: 'Feststellung einer Datenschutzverletzung',
            notification_required: 'Meldung erforderlich',
            notification_deadline: 'Meldefrist',
            pdpc_reportable: 'Meldepflicht an Aufsichtsbehörde',
            add_timeline: 'Zeitverlaufseintrag hinzufügen',
            add_decision: 'Entscheidung hinzufügen',
            not_found: 'Vorfall not gefunden.',
            team_members: 'Team Mitglieder',
            checklist: 'Checkliste',
            completed: 'Abgeschlossen',
            impact_severity_score: 'Calculated Auswirkung Schweregrad Bewertung',
            records_affected: 'Datensätze Affected',
            potential_consequences: 'Potentiell Konsequenzen',
            harm_likelihood: 'Schaden Wahrscheinlichkeit',
            legal_basis: 'Rechtlich Grundlage',
            jurisdictions: 'Gerichtsbarkeiten',
            jurisdictions_comma: 'Gerichtsbarkeiten (comma-separated)',
            jurisdiction: 'Gerichtsbarkeit',
            authority_status: 'Behörde Status',
            subject_status: 'Betreff Status',
            authority_deadline: 'Behörde Frist',
            subject_deadline: 'Betreff Frist',
            mark_authority_done: 'Markieren Behörde Done',
            mark_subject_done: 'Markieren Betreff Done',
            not_assessed: 'Nicht assessed',
            event_type: 'Ereignis Typ',
            timestamp: 'Zeitstempel',
            actor: 'Akteur',
            no_timeline_events: 'No Zeitverlauf Ereignisse yet.',
            decision_type: 'Entscheidung Typ',
            decision: 'Entscheidung',
            rationale: 'Begründung',
            decision_made: 'Entscheidung Made',
            no_decisions: 'Noch keine Entscheidungen erfasst.',
            jurisdictions_comma_separated: 'VN, SG, EU',
            no_audit_events: 'Es wurden noch keine Audit-Ereignisse erfasst.',
            export_pdf: 'PDF exportieren',
            pdf_title: 'Vorfallzusammenfassung',
            description: 'Beschreibung',
            linked_records: 'Verknüpfte Datensätze',
        },
        tasks: {
            page_title: 'Aufgaben zur Reaktion auf Vorfälle',
            title: 'Vorfallreaktionsaufgaben',
            new: 'Neue Aufgabe',
            edit: 'Aufgabe bearbeiten',
            task_type: 'Aufgabentyp',
            assignee: 'Zugewiesene Person',
            due_date: 'Fälligkeitsdatum',
            dependencies: 'Abhängigkeiten',
            mark_complete: 'Als erledigt markieren',
            templates: 'Aufgabenvorlagen',
            select_incident: 'Vorfall auswählen',
            all_statuses: 'Alle Status',
            all_categories: 'Alle Kategorien',
            new_response_task: 'Neue Reaktionsaufgabe',
            category: 'Kategorie',
            priority: 'Priorität',
            depends_on: 'Abhängig von (kommagetrennte Aufgaben-IDs)',
            checklist_items: 'Checklisten-Elemente',
            remove: 'Entfernen',
            add: 'Hinzufügen',
            new_checklist_item: 'Neues Checklisten-Element',
            no_templates: 'Keine Vorlagen verfügbar.',
            assign_task: 'Aufgabe zuweisen',
            assign_to: 'Zuweisen an',
            assign: 'Zuweisen',
            select_incident_prompt: 'Bitte wählen Sie einen Vorfall aus, um dessen Reaktionsaufgaben anzuzeigen.',
            checklist: 'Checkliste',
            hide_checklist: 'Checkliste ausblenden',
            escalate: 'Eskalieren',
            escalations: 'Eskalationen',
            no_checklist_items: 'Keine Checklisten-Elemente.',
        },
        reports: {
            page_title: 'Vorfallberichte',
            title: 'Vorfallberichte',
            summary: 'Zusammenfassende Statistiken',
            by_severity: 'Nach Schweregrad',
            by_status: 'Nach Status',
            recent: 'Aktuelle Vorfälle',
            total_incidents: 'Vorfälle gesamt',
            open: 'Offen',
            closed: 'Geschlossen',
            export_csv: 'CSV exportieren',
            export_pdf: 'PDF exportieren',
            export_success: 'Bericht erfolgreich exportiert.',
            export_error: 'Bericht konnte nicht exportiert werden.',
            reference: 'Referenz',
            view_report: 'Bericht anzeigen',
        },
        statuses: {
            reported: 'Gemeldet',
            triage: 'Sichtung',
            contained: 'Eingedämmt',
            investigation: 'Untersuchung',
            remediation: 'Behebung',
            closed: 'Geschlossen',
            false_positive: 'Fehlalarm',
        },
        task_statuses: {
            pending: 'Ausstehend',
            in_progress: 'In Bearbeitung',
            completed: 'Abgeschlossen',
            blocked: 'Blockiert',
            cancelled: 'Abgebrochen',
        },
        severity: {
            low: 'Niedrig',
            medium: 'Mittel',
            high: 'Hoch',
            critical: 'Kritisch',
        },
        task_types: {
            containment: 'Eindämmung',
            investigation: 'Untersuchung',
            remediation: 'Behebung',
            communication: 'Kommunikation',
            documentation: 'Dokumentation',
            notification: 'Benachrichtigung',
        },
        categories: {
            data_breach: 'Daten Verletzung',
            unauthorized_access: 'Unbefugt Zugriff',
            data_loss: 'Daten Loss',
            system_compromise: 'Systemkompromittierung',
            malware: 'Schadsoftware',
            phishing: 'Phishing-Angriff',
            insider_threat: 'Insider-Bedrohung',
            other: 'Andere',
        },
        reported_via_options: {
            email: 'E-Mail',
            phone: 'Telefon',
            internal_system: 'Intern System',
            third_party: 'Dritt Party',
            automated_detection: 'Automatisiert Erkennung',
        },
        harm_likelihood_options: {
            unlikely: 'Unwahrscheinlich',
            possible: 'Möglich',
            likely: 'Wahrscheinlich',
            very_likely: 'Sehr Wahrscheinlich',
        },
        breach_determination_options: {
            confirmed_breach: 'Bestätigt Verletzung',
            suspected_breach: 'Verdächtig Verletzung',
            not_a_breach: 'Nicht ein Verletzung',
            pending: 'Ausstehend',
        },
        timeline_event_types: {
            detection: 'Erkennung',
            escalation: 'Eskalation',
            containment: 'Eindämmung',
            investigation_start: 'Untersuchung Starten',
            evidence_collected: 'Nachweis Collected',
            notification_sent: 'Benachrichtigung Sent',
            remediation_action: 'Behebung Aktion',
            status_change: 'Status Ändern',
            communication: 'Kommunikation',
            other: 'Andere',
        },
        decision_types: {
            containment: 'Eindämmung',
            notification: 'Benachrichtigung',
            remediation: 'Behebung',
            escalation: 'Eskalation',
            closure: 'Abschluss',
            other: 'Andere',
        },
        task_transitions: {
            start: 'Starten',
            complete: 'Abschließen',
            block: 'Blockieren',
            cancel: 'Abbrechen',
            unblock: 'Entsperren',
        },
        announce: {
            loaded: '[[TOK_1]] Vorfälle geladen',
            reports_loaded: '[[TOK_1]] Vorfallberichte geladen',
            tasks_loaded: '[[TOK_1]] Aufgaben geladen',
            created: 'Vorfall erfolgreich erstellt',
            updated: 'Vorfall erfolgreich aktualisiert',
            closed: 'Vorfall erfolgreich abgeschlossen',
            status_changed: 'Vorfallstatus geändert',
            triage_completed: 'Triage erfolgreich abgeschlossen',
            impact_updated: 'Folgenabschätzung aktualisiert',
            breach_updated: 'Bewertung des Verstoßes aktualisiert',
            timeline_added: 'Timeline-Ereignis hinzugefügt',
            decision_recorded: 'Entscheidung protokolliert',
            notification_updated: 'Benachrichtigungsstatus aktualisiert',
            task_created: 'Aufgabe erfolgreich erstellt',
            task_status_changed: 'Aufgabenstatus geändert',
            checklist_completed: 'Checklistenpunkt abgeschlossen',
            checklist_unchecked: 'Checklistenelement deaktiviert',
            task_assigned: 'Aufgabe erfolgreich zugewiesen',
            task_escalated: 'Aufgabe eskaliert',
            export_initiated: 'Export eingeleitet',
        },
        breach_notifications: {
            page_title: 'Benachrichtigungen über Verstöße',
            title: 'Benachrichtigungen über Verstöße',
            new_notification: 'Neue Benachrichtigung',
            no_notifications: 'Es wurden keine Benachrichtigungen über Verstöße gefunden',
            status: 'Status',
            submit_to_mps: 'Senden an [[TOK_0]]',
            decision: 'Entscheidung',
            decision_maker: 'Entscheidungsträger',
            notify: 'Benachrichtigen',
            do_not_notify: 'Nicht benachrichtigen',
            rationale: 'Begründung',
            filing_deadline: 'Anmeldeschluss',
            overdue: 'Überfällig',
            due_soon: 'Bald fällig',
            on_track: 'Im Zeitplan',
            legal_review: 'Rechtliche Überprüfung',
            incident_id: 'Vorfall-ID',
            notification_statuses: {
                assessment: 'Bewertung',
                decision_to_notify: 'Entscheidung zur Benachrichtigung',
                notification_drafted: 'Benachrichtigung erstellt',
                legal_review: 'Rechtliche Überprüfung',
                submitted_to_mps: 'Eingereicht an [[TOK_0]]',
                supplement_requested: 'Ergänzung angefordert',
                supplement_submitted: 'Ergänzung eingereicht',
                acknowledged: 'Anerkannt',
                closed: 'Geschlossen',
            },
        },
        supplements: {
            page_title: 'Ergänzungswünsche',
            title: 'Ergänzungswünsche',
            new_supplement: 'Neue Ergänzung',
            no_supplements: 'Keine Ergänzungswünsche gefunden',
            request_details: 'Details anfordern',
            response_package: 'Antwortpaket',
            submit_response: 'Antwort senden',
            deadline: 'Frist',
            notification_id: 'Benachrichtigungs-ID',
            enter_notification_id: 'Geben Sie eine Benachrichtigungs-ID ein, um Ergänzungen anzuzeigen.',
            supplement_statuses: {
                requested: 'Angefordert',
                drafting: 'Ausarbeitung',
                submitted: 'Eingereicht',
                accepted: 'Akzeptiert',
                rejected: 'Abgelehnt',
            },
        },
        remediation: {
            page_title: 'Abhilfemaßnahmen',
            title: 'Abhilfemaßnahmen',
            new_action: 'Neue Aktion',
            no_actions: 'Keine Abhilfemaßnahmen gefunden',
            description: 'Beschreibung',
            owner: 'Besitzer',
            department: 'Abteilung',
            deadline: 'Frist',
            statuses: {
                planned: 'Geplant',
                in_progress: 'In Bearbeitung',
                completed: 'Abgeschlossen',
                verified: 'Verifiziert',
            },
            verify: 'Überprüfen',
            incident_id: 'Vorfall-ID',
            enter_incident_id: 'Geben Sie eine Vorfall-ID ein, um Abhilfemaßnahmen anzuzeigen.',
            start: 'Starten',
            complete_action: 'Abschließen',
        },
        authority_requests: {
            page_title: 'Behördenanfragen',
            title: 'Behördenanfragen',
            new_request: 'Neue Anfrage',
            no_requests: 'Keine Autoritätsanfragen gefunden',
            authority_name: 'Name der Behörde',
            request_details: 'Details anfordern',
            response_package: 'Antwortpaket',
            submission_channel: 'Einreichungskanal',
            submit_response: 'Antwort senden',
            deadline: 'Frist',
            confirmation: 'Bestätigung',
            incident_id_optional: 'Vorfall-ID (optional)',
            response_context_label: 'Antwortkontext (für Materialisierung des Einreichungsdokuments)',
            response_context_none: '(Materialisierung überspringen)',
            response_context_supplement: 'Ergänzungsantwort',
            response_context_information: 'Antwort auf Auskunftsersuchen',
            response_context_inspection: 'Antwort auf Prüfung',
            materialisation_status_column: 'Einreichungsdokument',
            materialisation_pending: 'Ausstehend',
            materialisation_success: 'Materialisiert',
            materialisation_failed: 'Fehlgeschlagen',
            materialisation_retry_button: 'Wiederholen',
            ar_statuses: {
                received: 'Erhalten',
                verified: 'Verifiziert',
                assembling: 'Zusammenbau',
                submitted: 'Eingereicht',
                closed: 'Geschlossen',
            },
        },
        disclosure_register: {
            page_title: 'Offenlegungsregister',
            title: 'Offenlegungsregister',
            new_entry: 'Neuer Eintrag',
            no_entries: 'Keine Offenlegungsregistereinträge gefunden',
            disclosure_type: 'Offenlegungstyp',
            disclosure_date: 'Offenlegungsdatum',
            recipient: 'Empfänger',
            authority_name: 'Name der Behörde',
            channel: 'Kanal',
            content_summary: 'Inhaltszusammenfassung',
            incident_id_optional: 'Vorfall-ID (optional)',
        },
    },
    onboarding: {
        nav: {
            wizard: 'Einrichtungsassistent',
            tours: 'Modulführungen',
            sample_data: 'Beispieldaten',
        },
        wizard: {
            title: 'Einrichtungsassistent',
            welcome: 'Willkommen bei AesirX ComplianceOne',
            welcome_message: 'Lassen Sie uns Ihre Organisation einrichten. Dieser Assistent führt Sie durch die Erstkonfiguration.',
            setup_complete: 'Einrichtung abgeschlossen',
            skipped_message: 'Der Einrichtungsassistent wurde übersprungen. Sie können ihn jederzeit ausführen, um Ihre Organisation zu konfigurieren.',
            start_setup: 'Einrichtung starten',
            skip_wizard: 'Assistenten überspringen',
            go_to_admin: 'Gehen Sie zu Admin',
            skip_for_now: 'Vorerst überspringen',
            next_step: 'Nächster Schritt',
            previous_step: 'Vorheriger Schritt',
            finish_setup: 'Einrichtung abschließen',
            rerun: 'Einrichtungsassistenten erneut ausführen',
            step_label: 'Schritt {number}',
            validation_org_name_required: 'Organisationsname ist erforderlich.',
            validation_admin_email_required: 'Administrator-E-Mail ist erforderlich.',
            validation_admin_email_invalid: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
            validation_cmp_endpoint_required: 'CMP-Endpunkt ist erforderlich, wenn CMP aktiviert ist.',
            steps: {
                license_activation: 'Lizenzaktivierung',
                org_profile: 'Organisationsprofil',
                module_selection: 'Modulauswahl',
                cmp_integration: 'CMP-Integration',
                notification_preferences: 'Benachrichtigungen',
                review: 'Überprüfen & Bestätigen',
            },
            step_descriptions: {
                license_activation: 'Geben Sie Ihren Lizenzschlüssel ein, um Ihr Paket zu aktivieren und festzustellen, welche Module verfügbar sind.',
                org_profile: 'Richten Sie den Organisationsnamen, die Rechtsordnung, die Branche, die Größe und die bevorzugte Sprache ein.',
                module_selection: 'Wählen Sie aus, welche Compliance-Module für Ihre Organisation aktiviert werden sollen.',
                cmp_integration: 'Konfigurieren Sie die Integration der Consent Management Platform (optional).',
                notification_preferences: 'Konfigurieren Sie, wie Sie Benachrichtigungen über Compliance-Ereignisse erhalten.',
                review: 'Überprüfen Sie Ihre Konfiguration und schließen Sie die Einrichtung ab.',
            },
            license_step: {
                validate_button: 'Lizenz validieren',
                skip_warning: 'Der Modulzugriff ist auf die Standardpaketstufe beschränkt. Sie können eine Lizenz später unter Plattform > Lizenzeinstellungen aktivieren.',
            },
            module_descriptions: {
                rights_requests: 'Bearbeiten Sie Anfragen auf Zugang und Löschung von Personendaten.',
                data_mapping: 'Kartieren Sie Systeme, Datenflüsse und Verarbeitungsaktivitäten.',
                governance: 'Verwalten Sie Lieferanten-Compliance und Löschungsverfahren.',
                consent: 'Verwalten Sie Einwilligungsrichtlinien und Zweckkataloge.',
                consent_properties: 'Verwalten Sie Einwilligungen über mehrere digitale Eigenschaften hinweg.',
                assessments: 'Führen Sie Folgenabschätzungen und grenzüberschreitende Datenübermittlungen durch.',
                classification: 'Klassifizieren und kennzeichnen Sie Datenbestände mit Lebenszyklusverfolgung.',
                monitoring: 'Geplante Compliance-Überprüfungen und KPI-Verfolgung.',
                incidents: 'Melden und verwalten Sie Sicherheits- und Datenschutzvorfälle.',
                connectors: 'Verbinden Sie sich mit externen Systemen für automatisierten Datenaustausch.',
                vendor_risk: 'Bewerten Sie Lieferanten, verfolgen Sie Verträge und verwalten Sie Due Diligence.',
                deletion_orchestration: 'Koordinieren Sie Datenlöschung über Systeme und Lieferanten hinweg.',
                discovery: 'Entdecken und klassifizieren Sie Daten in Ihrer gesamten Infrastruktur.',
                incident_ops: 'Erweiterte Vorfallsplaybooks, SLA-Verfolgung und Eskalationen.',
                program_governance: 'Reifegradbeurteilungen, Managementberichte und Auditbereitschaft.',
                access_accountability: 'Überwachen Sie Benutzerzugriff, Sitzungen und Begründungsworkflows.',
                localization: 'Marktspezifische Compliance-Pakete und regulatorische Rahmenwerke.',
                partner_workspace: 'Partner- und Händlerarbeitsbereich.',
                privacy_scanner: 'Echtzeit-Datenschutzüberwachung digitaler Eigenschaften.',
                onboarding: 'Einrichtungsassistent, geführte Touren und Verwaltung von Beispieldaten.',
                compliance_forms: 'Interaktive Compliance-Vorlagen und Dokumentenerstellung.',
                audit_trail: 'Umfassende unveränderliche Auditprotokollierung und Aufbewahrung.',
                organizations: 'Multi-Organisations- und Gruppenverwaltung.',
                task_management: 'Einheitliche Aufgabenplanung, Workflow-Engine und Kalenderansichten.',
            },
            module_categories: {
                data_privacy_rights: 'Datenschutz und Rechte',
                vendor_third_party: 'Lieferanten- und Drittanbietermanagement',
                risk_assessment: 'Risiko & Bewertung',
                operations_automation: 'Betrieb und Automatisierung',
                platform_admin: 'Plattform und Verwaltung',
            },
            package_tier_label: 'Ihr Paket',
            package_module_unavailable: 'Nicht in Ihrem Paket enthalten',
            select_all: 'Alle auswählen',
            deselect_all: 'Alle abwählen',
            load_sample_data: 'Beispieldaten nach Einrichtung laden',
            load_sample_data_description: 'Installieren Sie realistische Demodaten (Lotus Financial Services), um die Plattform zu erkunden. Kann später unter Onboarding > Beispieldaten entfernt werden.',
            language_label: 'Bevorzugte Sprache',
            language_description: 'Wählen Sie die Standardsprache für Ihre Organisation.',
            admin_account_title: 'Administratorkonto',
            admin_account_created: 'Administratorkonto erstellt',
            admin_full_name: 'Vollständiger Name',
            admin_email: 'E-Mail-Adresse',
            admin_password: 'Passwort',
            admin_confirm_password: 'Passwort bestätigen',
            admin_show_password: 'Passwort anzeigen',
            admin_hide_password: 'Passwort verbergen',
            admin_name_placeholder: 'z.B. Jane Smith',
            admin_email_placeholder: 'admin@example.com',
            admin_password_placeholder: 'Mindestens 8 Zeichen',
            admin_password_confirm_placeholder: 'Passwort erneut eingeben',
            validation_admin_name_required: 'Administratorname ist erforderlich',
            validation_admin_password_required: 'Passwort ist erforderlich',
            validation_admin_password_min_length: 'Passwort muss mindestens 8 Zeichen lang sein',
            validation_passwords_mismatch: 'Passwörter stimmen nicht überein',
            notification_email_enabled: 'E-Mail-Benachrichtigungen aktivieren',
            notification_email_description: 'Erhalten Sie E-Mail-Benachrichtigungen über Aufgabenzuweisungen, SLA-Verstöße und Compliance-Ereignisse.',
            notification_digest_frequency: 'Zusammenfassungshäufigkeit',
            notification_digest_daily: 'Täglich',
            notification_digest_weekly: 'Wöchentlich',
            notification_digest_none: 'Keine Zusammenfassung',
            notification_in_app_enabled: 'Plattform-Benachrichtigungen aktivieren',
            notification_in_app_description: 'Zeigen Sie Benachrichtigungsabzeichen und -schublade für Echtzeitwarnungen an.',
            jurisdictions: {
                vietnam: 'Vietnam',
                asean: 'ASEAN',
                eu_eea: 'EU/EWR',
                global: 'Global',
            },
            languages: {
                en: 'Englisch',
                vi: 'Tiếng Việt',
                da: 'Dansk',
                sv: 'Svenska',
                nb: 'Norsk Bokmål',
                nn: 'Norsk Nynorsk',
                de: 'Deutsch',
                fi: 'Suomi',
                nl: 'Niederlande',
                fr: 'Französisch',
                lb: 'Lëtzebuergesch',
                ga: 'Gaeilge',
                es: 'Spanisch',
                ca: 'Katalonien',
                eu: 'Euskara',
                pt: 'Portugiesisch',
            },
            industries: {
                financial_services: 'Finanzdienstleistungen',
                healthcare: 'Gesundheitswesen',
                technology: 'Technologie',
                telecommunications: 'Telekommunikation',
                government: 'Öffentlicher Sektor',
                education: 'Bildung',
                manufacturing: 'Fertigung',
                retail: 'Einzelhandel',
                other: 'Sonstige',
            },
            placeholders: {
                org_name: 'z. B. Lotus Financial Services',
                admin_email: 'admin@company.vn',
                team_emails: 'user1@company.vn, user2@company.vn',
                cmp_endpoint: 'https://cmp.example.com/api',
            },
            fields: {
                org_name: 'Organisationsname',
                jurisdiction: 'Rechtsordnung',
                industry: 'Branche',
                org_size: 'Organisationsgröße',
                language: 'Bevorzugte Sprache',
                admin_email: 'Administrator-E-Mail',
                team_emails: 'E-Mail-Adressen der Teammitglieder (kommagetrennt)',
                enable_cmp: 'CMP-Integration aktivieren',
                cmp_endpoint: 'CMP-API-Endpunkt',
                email_notifications: 'E-Mail-Benachrichtigungen',
                in_app_notifications: 'Plattform-Benachrichtigungen',
                digest_frequency: 'Zusammenfassungshäufigkeit',
            },
        },
        tours: {
            title: 'Modul-Einführungstouren',
            start: 'Tour starten',
            continue_tour: 'Tour fortsetzen',
            replay: 'Tour wiederholen',
            exit: 'Tour beenden',
            skip: 'Tour überspringen',
            next: 'Weiter',
            previous: 'Zurück',
            finish: 'Tour abschließen',
            step_of: 'Schritt {current} von {total}',
            info: 'Nehmen Sie an geführten Touren durch die einzelnen Module teil, um die wichtigsten Funktionen und Workflows kennenzulernen. Touren können jederzeit wiederholt werden.',
            autoplay: 'Autoplay',
            interactive: 'Interaktiv',
            play_all: 'Alle abspielen',
            search_tours: 'Touren suchen...',
            duration: 'Dauer',
            steps_label: '[[TOK_1]] Schritte',
            mode: 'Modus',
            pause: 'Pause',
            resume: 'Lebenslauf',
            speed: 'Geschwindigkeit',
            restart: 'Neustart',
            reset: 'Zurücksetzen',
            reset_success: 'Der Tourfortschritt wurde zurückgesetzt.',
            category_core_privacy: 'Kerndatenschutz',
            category_governance: 'Regierungsführung',
            category_operations: 'Operationen',
            category_platform: 'Plattform',
            category_advanced: 'Fortgeschritten',
            category_data_privacy_rights: 'Datenschutz und Rechte',
            category_vendor_third_party: 'Lieferanten- und Drittanbietermanagement',
            category_risk_assessment: 'Risiko & Bewertung',
            category_operations_automation: 'Betrieb und Automatisierung',
            category_platform_admin: 'Plattform und Verwaltung',
            steps_count: '[[TOK_1]] Schritte',
        },
        sample_data: {
            title: 'Beispieldatenverwaltung',
            select_modules: 'Module auswählen',
            current_status: 'Aktueller Status',
            operation_history: 'Vorgangshistorie',
            load: 'Beispieldaten laden',
            clear: 'Beispieldaten löschen',
            processing: 'Verarbeitung...',
            loaded: 'Geladen',
            not_loaded: 'Nicht geladen',
            records: 'Beispieldatensätze',
            confirm_clear: 'Sind Sie sicher, dass Sie alle Beispieldaten für die ausgewählten Module löschen möchten?',
            confirm_clear_title: 'Beispieldaten löschen',
            confirm_load_title: 'Beispieldaten laden',
            confirm_load: 'Sind Sie sicher, dass Sie Beispieldaten für die ausgewählten Module laden möchten?',
            action_load: 'Laden',
            action_clear: 'Löschen',
            info: 'Laden Sie realistische Demodaten für Schulungen und Vorführungen mit dem fiktiven Unternehmen „Lotus Financial Services". Beispieldaten sind gekennzeichnet und können ohne Auswirkung auf echte Daten sicher entfernt werden.',
        },
        help: {
            title: 'Hilfezentrum',
            search: 'Suche',
            search_placeholder: 'Hilfeartikel durchsuchen...',
            clear: 'Löschen',
            all_categories: 'Alle Kategorien',
            all_modules: 'Alle Module',
            back: 'Zurück zum Hilfezentrum',
            callout_important: 'Wichtig',
            callout_tip: 'Tipp',
            no_results: 'Keine Artikel gefunden, die Ihrer Suche entsprechen.',
            no_articles: 'Noch keine Hilfeartikel verfügbar. Artikel werden hier angezeigt, sobald Inhalte hinzugefügt werden.',
            results_for: '{count} Ergebnis(se) für „{query}"',
            quick_links: {
                getting_started: 'Erste Schritte',
                getting_started_desc: 'Installation, Einrichtung und Schnellstartanleitung.',
                user_guide: 'Benutzerhandbuch',
                user_guide_desc: 'Modulweise Nutzungsdokumentation.',
                admin_guide: 'Administratorhandbuch',
                admin_guide_desc: 'Konfiguration, Wartung und Fehlerbehebung.',
                faq: 'FAQ',
                faq_desc: 'Häufig gestellte Fragen und Antworten.',
            },
            search_articles_aria: 'Hilfeartikel suchen',
            article_metadata_aria: 'Artikel-Metadaten',
            articles_list_aria: 'Hilfeartikel',
            category_nav_aria: 'Kategorienavigation',
            quick_links_aria: 'Schnelllinks zu Hilfekategorien',
            returned_to_list: 'Zurück zur Artikelliste',
            opening_article: 'Artikel wird geöffnet: {title}',
            read_article_aria: 'Artikel lesen: {title}',
            pagination_nav_aria: 'Artikel-Seitennavigation',
            error_unavailable: 'Das Hilfecenter ist derzeit nicht verfügbar. Bitte versuchen Sie es später erneut.',
            retry: 'Erneut versuchen',
        },
    },
    common: {
        save: 'Speichern',
        cancel: 'Abbrechen',
        system_actor: 'System',
        delete: 'Löschen',
        edit: 'Bearbeiten',
        create: 'Erstellen',
        update: 'Aktualisieren',
        loading: 'Wird geladen...',
        error: 'Ein Fehler ist aufgetreten',
        success: 'Erfolg',
        logout: 'Abmelden',
        actions: 'Aktionen',
        retrying: 'Erneuter Versuch…',
        permission_denied: 'Sie haben keinen Zugriff auf diese Seite.',
        status: 'Zustand',
        description: 'Beschreibung',
        name: 'Bezeichnung',
        created_at: 'Erstellt am',
        updated_at: 'Aktualisiert am',
        yes: 'Ja',
        no: 'Nein',
        confirm: 'Bestätigen',
        back: 'Zurück',
        next: 'Weiter',
        previous: 'Zurück',
        search: 'Suche',
        filter: 'Filtern',
        page_x_of_y: 'Seite [[TOK_2]] von [[TOK_3]]',
        pagination_label: 'Paginierung',
        view_mode_label: 'Ansichtsmodus',
        export: 'Exportieren',
        exporting: 'Wird exportiert…',
        sidebar_navigation: 'Admin-Seitennavigation',
        items_count: '{count} Einträge',
        items_count_one: '{count} Eintrag',
        export_success: 'Dokument erfolgreich generiert.',
        generate_pdf: 'PDF erstellen',
        import: 'Importieren',
        download: 'Herunterladen',
        upload: 'Hochladen',
        view: 'Anzeigen',
        close: 'Schließen',
        submit: 'Absenden',
        saved: 'Erfolgreich gespeichert',
        saving: 'Speichern...',
        submitting: 'Wird gesendet...',
        created: 'Erfolgreich erstellt',
        all: 'Alle',
        none: 'Keine',
        select: 'Auswählen',
        select_user: 'Benutzer auswählen...',
        custom_input: 'Manuell eingeben',
        required: 'Erforderlich',
        optional: 'Wahlweise',
        notes: 'Notizen',
        tags: 'Schlagwörter',
        archive: 'Archivieren',
        clone: 'Klonen',
        refresh: 'Aktualisieren',
        retry: 'Erneut versuchen',
        reset: 'Zurücksetzen',
        add: 'Hinzufügen',
        remove: 'Entfernen',
        removing: 'Wird entfernt…',
        attachment: 'Anhang',
        upload_file: 'Datei hochladen',
        upload_file_required: 'Datei hochladen (erforderlich)',
        select_entity_type_first: 'Bitte zuerst einen Entitätstyp auswählen',
        failed_to_remove_file: 'Datei konnte nicht entfernt werden.',
        entity_type_label: 'Entitätstyp',
        entity_label: 'Entität',
        entity_reference: 'Entitätsreferenz',
        failed_to_load_entities: 'Entitäten konnten nicht geladen werden',
        enable: 'Aktivieren',
        disable: 'Deaktivieren',
        no_data: 'Keine Daten gefunden',
        confirm_delete: 'Sind Sie sicher, dass Sie dieses Element löschen möchten?',
        confirm_action: 'Sind Sie sicher, dass Sie fortfahren möchten?',
        save_success: 'Erfolgreich gespeichert',
        save_error: 'Speichern fehlgeschlagen',
        delete_success: 'Erfolgreich gelöscht',
        delete_error: 'Löschen fehlgeschlagen',
        hour: 'Stunde',
        hours: 'Stunden',
        load_error: 'Daten konnten nicht geladen werden',
        operation_error: 'Vorgang fehlgeschlagen',
        something_went_wrong: 'Etwas ist schiefgelaufen',
        go_home: 'Zur Übersicht',
        access_denied: 'Zugriff verweigert',
        no_permission: 'Sie haben keine Berechtigung, auf diese Seite zuzugreifen.',
        no_permission_title: 'Unzureichende Berechtigungen',
        no_permission_message: 'Sie haben keine Berechtigung, auf diese Seite zuzugreifen.',
        unknown: 'Unbekannt',
        back_to_dashboard: 'Zurück zur Übersicht',
        id: 'ID',
        type: 'Typ',
        date: 'Datum',
        created_by: 'Erstellt von',
        updated_by: 'Aktualisiert von',
        page_of: 'Seite {page} von {total}',
        showing_items: '{count} Einträge angezeigt',
        items_per_page: 'Einträge pro Seite',
        no_results: 'Keine Datensätze entsprechen Ihren Filtern',
        no_items: 'Keine Einträge gefunden',
        sort_by: 'Sortieren nach',
        ascending: 'Aufsteigend',
        descending: 'Absteigend',
        all_statuses: 'Alle Status',
        all_types: 'Alle Typen',
        all_categories: 'Alle Kategorien',
        all_severities: 'Alle Schweregrade',
        date_range: 'Zeitraum',
        from_date: 'Von',
        to_date: 'Bis',
        clear_filters: 'Filter zurücksetzen',
        apply_filters: 'Filter anwenden',
        save_changes: 'Änderungen speichern',
        discard_changes: 'Änderungen verwerfen',
        confirm_discard: 'Sie haben ungespeicherte Änderungen. Möchten Sie diese verwerfen?',
        copy: 'Kopieren',
        duplicate: 'Duplizieren',
        move: 'Verschieben',
        assign: 'Zuweisen',
        unassign: 'Zuweisung aufheben',
        approve: 'Genehmigen',
        reject: 'Ablehnen',
        deleting: 'Löschen...',
        processing: 'Verarbeitung...',
        loading_page: 'Seite wird geladen...',
        operation_success: 'Vorgang erfolgreich abgeschlossen',
        operation_failed: 'Vorgang fehlgeschlagen. Bitte versuchen Sie es erneut.',
        empty_dash: '—',
        network_error: 'Netzwerkfehler. Überprüfen Sie Ihre Verbindung.',
        session_expired: 'Sitzung abgelaufen. Bitte melden Sie sich erneut an.',
        test: 'Testen',
        pause: 'Pausieren',
        resume: 'Fortsetzen',
        activate: 'Aktivieren',
        last_sync: 'Letzte Synchronisierung',
        health: 'Zustand',
        email: 'E-Mail',
        role: 'Rolle',
        title: 'Titel',
        owner: 'Verantwortlicher',
        priority: 'Priorität',
        category: 'Kategorie',
        details: 'Einzelheiten',
        overview: 'Übersicht',
        configuration: 'Konfiguration',
        history: 'Verlauf',
        new_item: 'Neu',
        edit_item: 'Bearbeiten',
        select_option: 'Auswählen...',
        total: 'Gesamt',
        active: 'Aktiv',
        inactive: 'Inaktiv',
        enabled: 'Aktiviert',
        disabled: 'Deaktiviert',
        last_login: 'Letzte Anmeldung',
        never: 'Nie',
        password_changed: 'Passwort geändert. Sie werden abgemeldet.',
        password_change_failed: 'Passwortänderung fehlgeschlagen',
        passwords_mismatch: 'Die Passwörter stimmen nicht überein',
        install: 'Installieren',
        uninstall: 'Deinstallieren',
        installed: 'Installiert',
        available: 'Verfügbar',
        catalog: 'Katalog',
        published: 'Veröffentlicht',
        version: 'Fassung',
        market: 'Markt',
        language: 'Sprache',
        framework: 'Rahmenwerk',
        template: 'Vorlage',
        connector_type: 'Konnektortyp',
        polling_interval: 'Abfrageintervall (Minuten)',
        new_instance: 'Neue Instanz',
        change_password: 'Passwort ändern',
        current_password: 'Aktuelles Passwort',
        new_password: 'Neues Passwort',
        confirm_password: 'Passwort bestätigen',
        comments: 'Kommentare',
        completed: 'Abgeschlossen',
        contact: 'Kontakt',
        hide: 'Ausblenden',
        hide_details: 'Ausblenden Details',
        label: 'Bezeichnung',
        max: 'Max',
        min: 'Min',
        na: 'N/A',
        of: 'of',
        showing: 'Anzeige',
        page: 'Seite',
        preview: 'Vorschau',
        print: 'Drucken',
        show: 'Anzeigen',
        status_active: 'Aktiv',
        status_completed: 'Abgeschlossen',
        status_draft: 'Entwurf',
        status_in_progress: 'In Fortschritt',
        status_pending: 'Ausstehend',
        view_details: 'Ansehen Details',
        all_priorities: 'Alle Priorities',
        pipeline: 'Ablaufkette',
        all_requests: 'Alle Anfragen',
        schedule: 'Planen',
        deploy: 'Bereitstellen',
        rollback: 'Zurücksetzen',
        advance_stage: 'Voranschreiten Stufe',
        submit_for_approval: 'Absenden für Genehmigung',
        approval_log: 'Genehmigung Protokoll',
        approver: 'Genehmiger',
        decision: 'Entscheidung',
        decided_at: 'Entschieden am',
        rollout_stages: 'Einführung Stufen',
        approval_comment: 'Genehmigung Kommentar',
        optional_comment: 'Optional Kommentar...',
        impact_summary: 'Auswirkung Zusammenfassung',
        target_property_ids: 'Ziel Eigenschaft IDs (comma-separated)',
        policy_id: 'Richtlinie ID',
        target_version: 'Ziel Version',
        target_version_placeholder: 'z. B. 2.0.0',
        scheduled_label: 'Geplant',
        scheduled_start: 'Geplant Starten',
        scheduled_end: 'Geplant Ende',
        properties_count: '{count} Eigenschaften',
        results: 'Ergebnisse',
        comparison_results: 'Vergleich Ergebnisse',
        past_comparison_reports: 'Vergangene Vergleich Berichte',
        scanning: 'Scanne...',
        run_inconsistency_scan: 'Ausführen Inkonsistenz Scannen',
        property_ids_label: 'Eigenschaft IDs (comma-separated, min 2)',
        comparison_type: 'Vergleich Typ',
        golden_template_id: 'Golden Vorlage ID (optional)',
        leave_blank_compare: 'Leave blank zu compare Eigenschaften against each other',
        add_notes_placeholder: 'Hinzufügen your analysis Hinweise here...',
        covered_of_active: '{covered} von {active} aktiv Eigenschaften covered',
        fetch_error: 'Fehler beim fetch Daten. Bitte versuchen Sie es erneut.',
        run_comparison_error: 'Fehler beim Durchlauf comparison. Bitte versuchen Sie es erneut.',
        save_notes_error: 'Fehler beim save Hinweise. Bitte versuchen Sie es erneut.',
        scan_complete: 'Inkonsistenz Scan completed successfully.',
        scan_error: 'Fehler beim Durchlauf inconsistency Scan. Bitte versuchen Sie es erneut.',
        min_two_properties: 'Bitte provide bei least 2 property IDs für comparison.',
        comma_separated: 'kommagetrennt',
        language_english: 'Englisch',
        language_vietnamese: 'Vietnamesisch',
        language_vietnamese_native: 'Tiếng Việt',
        author: 'Autor',
        dependencies: 'Abhängigkeiten',
        checksum: 'Prüfsumme',
        changelog: 'Änderungsprotokoll',
        tier: 'Stufe',
        phone: 'Telefon',
        launch: 'Starten',
        complete: 'Abschließen',
        back_to_list: 'Back zu Liste',
        clear_selection: 'Löschen Auswahl',
        deactivate: 'Deaktivieren',
        scope: 'Geltungsbereich',
        deadline: 'Frist',
        progress: 'Fortschritt',
        frequency: 'Häufigkeit',
        reviewer: 'Prüfer',
        user: 'Benutzer',
        campaign: 'Kampagne',
        items: 'Elemente',
        next_run: 'Nächster Ausführen',
        last_run: 'Letzter Ausführen',
        overdue: 'ÜBERFÄLLIG',
        creating: 'Erstelle...',
        launching: 'Starte...',
        loaded: 'loaded',
        page_size: 'Seitengröße',
        per_page: '/ Seite',
        urgent: 'Dringend',
        pagination: 'Paginierung',
        metric: 'Metrisch',
        value: 'Wert',
        country: 'Land',
        showing_chart_view: 'Diagrammansicht wird angezeigt',
        showing_table_view: 'Datentabellenansicht wird angezeigt',
        policies: 'Richtlinien',
        select_content_type: 'Bitte wählen Sie mindestens einen Inhaltstyp aus.',
        compliant: 'Konform',
        non_compliant_status: 'Nicht konform',
        all_data: 'Alle Daten',
        sr_urgent: 'Dringend',
        n_per_page: '[[TOK_1]] / Seite',
        select_user_placeholder: '-- Benutzer auswählen --',
        field_required: 'Dieses Feld ist erforderlich',
        results_found: 'Ergebnisse gefunden',
        select_placeholder: '-- Auswählen --',
        unknown_user: 'Unbekannter Benutzer',
        export_csv: 'CSV exportieren',
        not_applicable: 'N/A',
        aria_overdue_since: 'Überfällig seit {date}',
        placeholders: {
            enter_justification: 'Eingeben Begründung',
            justification: 'Begründung',
            campaign_name_example: 'Q1 2026 Zugriff Überprüfen',
            optional_description: 'Optional Beschreibung',
            enter_user_id: 'Eingeben der user ID von der reviewer',
            enter_user_id_short: 'Eingeben user ID',
            schedule_name_example: 'Vierteljährlich Zugriff Attestierung',
            enter_property_id: 'Eingeben property ID',
            enter_policy_id: 'Eingeben Richtlinie ID',
            property_or_group_id: 'Eigenschaft oder Gruppe ID',
            describe_template_purpose: 'Beschreiben der Vorlage purpose...',
            step_title: 'Schritt title...',
            detailed_instructions: 'Detaillierte Anweisungen...',
            filter_by_taxonomy_id: 'Filtern nach Taxonomie ID...',
            describe_classification_rule: 'Beschreiben der classification Regel...',
            describe_dedup_rule: 'Beschreiben der Deduplizierung Regel...',
            describe_import_template: 'Beschreiben der Import Vorlage...',
            reason_for_rejection: 'Grund für rejection...',
            jurisdiction_codes_example: 'VN, SG, EU',
            filter_by_locale: 'Filtern nach locale...',
            filter_by_event_type: 'Filtern nach Ereignis type',
            filter_by_actor_id: 'Filtern nach actor ID',
            filter_by_market_code: 'Filtern nach market Code...',
            filter_by_framework_id: 'Filtern nach Rahmenwerk ID...',
            add_comment: 'Hinzufügen ein Kommentar...',
            provide_rejection_reason: 'Angeben ein reason für rejecting dieses Einreichung...',
            filter_by_jurisdiction: 'Filtern nach jurisdiction Code...',
            enter_report_title: 'Eingeben report title',
            enter_name: 'Eingeben Name',
            enter_description: 'Eingeben Beschreibung',
            enter_org_id: 'Eingeben Org ID zu add',
            describe_evidence_gap: 'Beschreiben der Nachweis Lücke...',
            expected_evidence: 'What Nachweis is expected',
            entity_identifier: 'Entität identifier',
            remediation_steps: 'Schritte zu remediate dieses Lücke',
            user_id_or_name: 'Benutzer ID oder Name',
            reporting_period_id: 'Berichterstattung Zeitraum ID',
            maturity_model_id: 'Reife Modell ID',
            describe_maturity_model: 'Beschreiben dieses Reife Modell...',
            describe_role_purpose: "Describe this role's purpose...",
            provide_deny_reason: 'Angeben ein reason für denying dieses request',
            describe_emergency: 'Beschreiben der emergency situation requiring elevated Zugriff (minimum 20 characters)',
            enter_delegate_id: 'Eingeben user ID von der delegate',
            provide_delegation_reason: 'Angeben ein reason für dieses delegation',
            client_identifier: 'Client-Kennung',
            client_secret: 'Client-Geheimnis',
            time_format: 'HH:MM',
            describe_sod_rule: 'Beschreiben der purpose von dieses SoD Regel...',
            enter_role_id: 'Eingeben role ID',
            explain_exception: 'Explain why dieses exception is needed...',
            describe_compensating_controls: 'Beschreiben compensating Kontrollen in place...',
            full_name: 'Vollständig Name',
            min_chars: 'Min. 12 chars',
            enter_override_justification: 'Eingeben Begründung für overriding dieses Gate Bewertung',
            enter_evidence_id: 'Geben Sie die Beweis-ID ein, um Folgendes zu verknüpfen:',
            date_format: 'TT/MM/JJJJ',
            describe_pack_contents: 'Beschreiben Sie den Paketinhalt und Zweck',
            select_reviewers: 'Prüfer auswählen...',
        },
        aria_previous_page: 'Vorherige Seite',
        aria_next_page: 'Nächste Seite',
        aria_results_per_page: 'Ergebnisse pro Seite',
        per_page_25: '25 / Seite',
        per_page_50: '50 / Seite',
        per_page_100: '100 / Seite',
        select_language: 'Sprache auswählen',
        today: 'Heute',
        tomorrow: 'Morgen',
        dashboard_load_error: 'Dashboard konnte nicht geladen werden. Bitte erneut versuchen.',
        enum_grade: {
            red: 'Rot',
            amber: 'Orange',
            yellow: 'Gelb',
            green: 'Grün',
        },
        enum_severity: {
            critical: 'Kritisch',
            high: 'Hoch',
            medium: 'Mittel',
            low: 'Niedrig',
        },
        enum_priority: {
            critical: 'Kritisch',
            high: 'Hoch',
            medium: 'Mittel',
            low: 'Niedrig',
        },
        enum_status: {
            pending: 'Ausstehend',
            in_progress: 'In Bearbeitung',
            completed: 'Abgeschlossen',
            blocked: 'Blockiert',
            escalated: 'Eskaliert',
            cancelled: 'Abgebrochen',
            overdue: 'Überfällig',
            not_started: 'Nicht begonnen',
            new: 'Neu',
            open: 'Offen',
            closed: 'Geschlossen',
            acknowledged: 'Bestätigt',
            resolved: 'Behoben',
        },
        enum_department: {
            unassigned: 'Nicht zugewiesen',
        },
        enum_form_category: {
            assessment: 'Bewertung',
            assessment_report: 'Bewertungsbericht',
            dpia: '[[TOK_0]]',
            authority_submission: 'Einreichung bei der Behörde',
            cross_border_transfer: 'Grenzüberschreitende Übertragung',
            vendor: 'Anbieter',
            breach: 'Verstoß',
            consent: 'Zustimmung',
            governance: 'Regierungsführung',
            register: 'Registrieren',
            monitoring: 'Überwachung',
            dpa: 'DPA',
            dsr: 'DSR',
            privacy: 'Privatsphäre',
            incident: 'Vorfall',
            org: 'Organisation',
            sector: 'Sektor',
            classification: 'Klassifizierung',
            discovery: 'Entdeckung',
        },
        enum_module: {
            rights_requests: 'Rechteanfragen',
            assessments: 'Beurteilungen',
            incidents: 'Vorfälle',
            incident_ops: 'Vorfall-Operationen',
            monitoring: 'Überwachung',
            vendor_risk: 'Lieferantenrisiko',
            governance: 'Regierungsführung',
            deletion_orchestration: 'Löschung',
            access_review: 'Zugriffsüberprüfung',
            consent: 'Zustimmung',
            consent_properties: 'Einwilligungseigenschaften',
            forms: 'Formulare',
            localization: 'Lokalisierung',
            program_governance: 'Programm-Governance',
            privacy_scanner: 'Datenschutzscanner',
            classification: 'Klassifizierung',
            discovery: 'Entdeckung',
            manual: 'Handbuch',
            data_mapping: 'Datenzuordnung',
        },
        enum_risk_level: {
            critical: 'Kritisch',
            high: 'Hoch',
            medium: 'Mittel',
            low: 'Niedrig',
        },
        enum_request_type: {
            all: 'All',
            access: 'Zugriff ([[TOK_0]])',
            deletion: 'Löschung',
            correction: 'Korrektur',
            objection: 'Einspruch',
            portability: 'Portabilität',
            restriction: 'Einschränkung',
            consent_withdrawal: 'Widerruf der Einwilligung',
        },
        enum_locale: {
            en: 'Englisch',
            vi: 'Vietnamesisch',
            all: 'Beides',
        },
        enum_event_type: {
            case_created: 'Fall erstellt',
            status_changed: 'Status geändert',
            case_assigned: 'Fall zugewiesen',
            note_added: 'Hinweis hinzugefügt',
            attachment_added: 'Anhang hinzugefügt',
            attachment_deleted: 'Anhang gelöscht',
            reference_added: 'Referenz hinzugefügt',
            checklist_updated: 'Checkliste aktualisiert',
            identity_verified: 'Identität überprüft',
            closure_summary_added: 'Abschlusszusammenfassung',
            approval_granted: 'Genehmigung erteilt',
            template_applied: 'Vorlage angewendet',
            export_generated: 'Export generiert',
            sla_warning: '[[TOK_0]] Warnung',
            sla_overdue: '[[TOK_0]] Überfällig',
        },
        more: 'more',
        use: 'Use',
        ok: 'OK',
    },
    common_statuses: {
        removed: 'Entfernt',
        draft: 'Entwurf',
        active: 'Aktiv',
        inactive: 'Inaktiv',
        pending: 'Ausstehend',
        in_progress: 'In Bearbeitung',
        completed: 'Abgeschlossen',
        archived: 'Archiviert',
        published: 'Veröffentlicht',
        approved: 'Genehmigt',
        rejected: 'Abgelehnt',
        cancelled: 'Abgebrochen',
        blocked: 'Blockiert',
        deferred: 'Zurückgestellt',
        not_started: 'Nicht gestartet',
        dismissed: 'Verworfen',
        failed: 'Fehlgeschlagen',
        in_review: 'In Überprüfen',
        deprecated: 'Veraltet',
        scheduled: 'Geplant',
        deploying: 'Bereitstellung',
        deployed: 'Bereitgestellt',
        paused: 'Pausiert',
        rolled_back: 'Zurückgesetzt',
        received: 'Empfangen',
        processing: 'Verarbeitung',
        under_assessment: 'Unter Bewertung',
        implemented: 'Implementiert',
        pending_approval: 'Ausstehend Genehmigung',
        pending_deletion: 'Ausstehend Deletion',
        on_hold: 'On Zurückstellen',
        deleted: 'Gelöscht',
        expired: 'Abgelaufen',
        outdated: 'Veraltet',
        drifted: 'Abgewichen',
        decommissioned: 'Außer Betrieb',
        match: 'Abgleichen',
        different: 'Unterschiedlich',
        missing: 'Fehlend',
        confirmed: 'Bestätigt',
        revoked: 'Widerrufen',
        escalated: 'Eskaliert',
        system: 'IT-System',
        custom: 'Benutzerdefiniert',
        warning: 'Warnung',
        blocking: 'Blockierend',
        analyst: 'Analytiker',
        viewer: 'Betrachter',
        daily: 'Täglich',
        weekly: 'Wöchentlich',
        policies: 'Richtlinien',
        denied: 'Abgelehnt',
        verified: 'Verifiziert',
        detected: 'Erkannt',
        ignored: 'Ignoriert',
        open: 'Offen',
        resolved: 'Gelöst',
        suspended: 'Suspendiert',
        retired: 'Im Ruhestand',
        review: 'Rezension',
        generated: 'Generiert',
        exported: 'Exportiert',
    },
    severity: {
        low: 'Niedrig',
        medium: 'Mittel',
        high: 'Hoch',
        critical: 'Kritisch',
    },
    sensitivity: {
        standard: 'Standardstufe',
        sensitive: 'Sensibel',
        special_category: 'Besondere Kategorie',
        badge_sensitive: 'Sensibel',
    },
    change_types: {
        policy_update: 'Richtlinie Aktualisieren',
        new_binding: 'Neu Bindung',
        remove_binding: 'Entfernen Bindung',
        configuration_change: 'Konfiguration Ändern',
        banner_update: 'Banner Aktualisieren',
    },
    comparison_types: {
        full: 'Vollständig',
        banner_only: 'Nur Banner',
        purposes_only: 'Zwecke Only',
        legal_bases_only: 'Rechtlich Bases Only',
        consent_settings: 'Einwilligung Einstellungen',
    },
    lifecycle_stages: {
        active: 'Aktiv',
        archived: 'Archiviert',
        pending_deletion: 'Ausstehend Deletion',
        deleted: 'Gelöscht',
        on_hold: 'On Zurückstellen',
    },
    object_types: {
        personal_data: 'Personenbezogen Daten',
        consent_record: 'Einwilligung Datensatz',
        user_account: 'Benutzer Konto',
        audit_log: 'Audit Protokoll',
        document: 'Dokument',
        backup: 'Sicherung',
    },
    transfer_mechanisms: {
        adequacy_decision: 'Angemessenheit Entscheidung',
        standard_contractual_clauses: 'Standard Vertraglich Klauseln',
        binding_corporate_rules: 'Bindung Corporate Regeln',
        explicit_consent: 'Ausdrücklich Einwilligung',
        public_interest: 'Öffentlich Interesse',
        legal_claims: 'Rechtlich Claims',
        vital_interests: 'Lebenswichtig Interests',
    },
    risk_categories: {
        data_breach: 'Daten Verletzung',
        unauthorized_access: 'Unbefugt Zugriff',
        data_loss: 'Daten Loss',
        regulatory_non_compliance: 'Regulatorisch Non-Compliance',
        third_party_risk: 'Third-Party Risiko',
        operational: 'Betriebsbereit',
        technical: 'Technisch',
        legal: 'Rechtlich',
    },
    mitigation_types: {
        technical: 'Technisch',
        organizational: 'Organisatorisch',
        contractual: 'Vertraglich',
        procedural: 'Prozedural',
    },
    safeguard_types: {
        encryption_in_transit: 'Verschlüsselung bei der Übertragung',
        encryption_at_rest: 'Verschlüsselung im Ruhezustand',
        access_controls: 'Zugangskontrollen',
        contractual_clauses: 'Vertragsklauseln',
        data_minimization: 'Datenminimierung',
        pseudonymization: 'Pseudonymisierung',
        audit_rights: 'Prüfungsrechte',
        breach_notification: 'Benachrichtigung über Verstöße',
        data_localization: 'Datenlokalisierung',
        other: 'Andere',
    },
    scoring_methods: {
        weighted_average: 'Gewichtet Durchschnitt',
        simple_average: 'Einfach Durchschnitt',
        maximum: 'Maximalwert',
        manual: 'Manuell',
    },
    dpa_status: {
        not_required: 'Nicht erforderlich',
        required: 'Erforderlich',
        in_progress: 'In Bearbeitung',
        completed: 'Abgeschlossen',
        signed: 'Unterzeichnet',
    },
    disposal_methods: {
        anonymize: 'Anonymisieren',
        pseudonymize: 'Pseudonymisieren',
        aggregate: 'Aggregieren',
        delete: 'Löschen',
    },
    dashboard: {
        title: 'Übersicht',
        no_data: 'Keine Dashboard-Daten verfügbar.',
        no_data_heading: 'Noch keine Live-Daten',
        no_data_detail: 'Die Dashboard-Widgets unten zeigen das Layout. Daten werden befüllt, sobald das Backend mit der Datenbank verbunden ist.',
        consent_coverage: 'Einwilligungsabdeckung',
        ctia_filings: 'CTIA-Meldungen',
        next_dpia_review: 'Nächste DPIA-Überprüfung',
        next_review_none: 'Keine geplant',
        incident_mps_filings: 'MPS-Meldungen zu Vorfällen',
        compliance_score: 'Compliance-Bewertung',
        grade: 'Note',
        no_score: 'Noch keine Compliance-Bewertung berechnet.',
        rights_requests: 'Auskunftsersuchen',
        open: 'Offen',
        sla_breached: 'SLA verletzt',
        sla_approaching: 'SLA bald fällig',
        closed_month: 'Geschlossen (Monat)',
        incidents: 'Vorfälle & Datenschutzverletzungen',
        active: 'Aktiv',
        breaches: 'Datenschutzverletzungen',
        overdue_tasks: 'Überfällige Aufgaben',
        breach_72h_notice: 'Für aktive Verstöße gilt eine behördliche Benachrichtigungsfrist von 72 Stunden',
        recommendations: 'Empfehlungen',
        take_action: 'Werden Sie aktiv',
        drift_events: 'Abweichungen & Genehmigungen',
        open_events: 'Offene Ereignisse',
        pending_approvals: 'Ausstehende Genehmigungen',
        monitoring: 'Überwachungsaufgaben',
        programs: 'Programme',
        overdue: 'Überfällig',
        pending: 'Ausstehend',
        ric_cases: 'Behördenanfragen',
        coverage: 'Datenabdeckung',
        systems: 'Systeme',
        activities: 'Tätigkeiten',
        vendors: 'Dienstleister',
        dpias: 'DSFAs',
        open_gaps: 'offene Lücken',
        view_as_table: 'Als Tabelle anzeigen',
        view_as_chart: 'Als Diagramm anzeigen',
        table_metric_header: 'Kennzahl',
        table_value_header: 'Wert',
        announce_chart_view: 'Diagrammansicht wird angezeigt',
        announce_table_view: 'Tabellenansicht wird angezeigt',
        section_core_metrics: 'Kernkennzahlen',
        section_task_management: 'Aufgabenverwaltung',
        section_compliance_insights: 'Compliance-Einblicke',
        configure_dashboard: 'Dashboard konfigurieren',
        config_col_active: 'Aktiv',
        config_col_widget: 'Widget',
        collapse_section: 'Einklappen',
        expand_section: 'Ausklappen',
        reset_to_defaults: 'Auf Standard zurücksetzen',
        preferences_saved: 'Dashboard-Einstellungen gespeichert',
        preferences_reset: 'Dashboard auf Rollenstandard zurückgesetzt',
        preferences_load_error: 'Dashboard-Einstellungen konnten nicht geladen werden',
        factor_avg_system_score: 'Durchschnittliche Systembewertung',
        factor_avg_vendor_score: 'Durchschnittliche Anbieterbewertung',
        factor_processing_coverage: 'Abdeckung der Verarbeitungsaktivitäten',
        factor_ropa_completeness: 'RoPA-Vollständigkeit',
        factor_drift_penalty: 'Strafe für Drift-Ereignisse',
        rec_improve_system_gov: 'Verbessern Sie die Dokumentation der Systemgovernance',
        rec_improve_vendor_gov: 'Verbessern Sie die Dokumentation zur Lieferanten-Governance',
        rec_document_processing: 'Dokumentenverarbeitungsaktivitäten für nicht abgedeckte Systeme',
        rec_generate_ropa: 'Generieren Sie RoPA-Datensätze für aktive Verarbeitungsaktivitäten',
        rec_resolve_drift: 'Beheben Sie offene kritische und schwerwiegende Abweichungsereignisse',
        score_good: 'Gut',
        score_fair: 'Befriedigend',
        score_poor: 'Schlecht',
        score_critical: 'Kritisch',
        drag_to_reorder: 'Ziehen zum Umordnen',
        widget_moved: 'Widget verschoben',
        press_space_to_grab: 'Leertaste zum Greifen, Pfeiltasten zum Verschieben, Leertaste zum Ablegen',
        reorder_instructions: 'Verwenden Sie Drag-and-Drop oder Tastenkürzel, um Widgets umzuordnen',
        task_widgets: {
            tasks_overview: 'Aufgabenübersicht',
            pending: 'Ausstehend',
            in_progress: 'In Bearbeitung',
            overdue: 'Überfällig',
            done_7d: 'Fertig (7d)',
            by_priority: 'Nach Priorität',
            view_all_tasks: 'Alle Aufgaben anzeigen',
            upcoming_tasks: 'Anstehende Aufgaben (nächste 7 Tage)',
            no_upcoming: 'In den nächsten 7 Tagen sind keine Aufgaben fällig.',
            view_calendar: 'Kalender anzeigen',
            overdue_alerts: 'Überfällig',
            no_overdue: 'Keine überfälligen Aufgaben. Alles ist auf dem richtigen Weg.',
            assigned_to: 'Zugewiesen an',
            view_all_overdue: 'Alle überfälligen anzeigen',
            notifications: 'Aktuelle Benachrichtigungen',
            unread: 'unread',
            no_notifications: 'Keine Benachrichtigungen. Ihr seid alle beschäftigt!',
            view_all_notifications: 'Alle Benachrichtigungen anzeigen',
            load_error: 'Daten konnten nicht geladen werden.',
            day_late: 'Tag zu spät',
            days_late_plural: 'Tage zu spät',
            due_today: 'Heute fällig',
            just_now: 'gerade jetzt',
            minutes_short: 'm',
            hours_short: 'h',
            days_short: 'd',
            cross_org_stats: 'Organisationsübergreifende Statistiken',
            by_organization: 'Nach Organisation',
            overdue_across_orgs: 'überfällige Aufgaben in allen Organisationen',
            total: 'Insgesamt',
            tasks: 'tasks',
            organization: 'Organisation',
            current_org: 'Aktuelle Organisation',
            all_orgs: 'Alle Organisationen',
            all_organizations: 'Alle Organisationen',
            filter_by_org: 'Nach Organisation filtern',
            cross_org: 'Orgübergreifend',
            empty_calendar: 'Keine Aufgaben für diesen Zeitraum. Erstellen Sie Ihre erste Aufgabe oder überprüfen Sie Ihre Filter.',
            empty_my_tasks: 'Ihnen sind keine Aufgaben zugewiesen. Tolle Arbeit!',
            empty_overdue: 'Keine überfälligen Aufgaben. Alles ist auf dem richtigen Weg.',
            empty_notifications: 'Keine Benachrichtigungen. Ihr seid alle beschäftigt!',
            empty_workflows: 'Keine Workflows konfiguriert. Durchsuchen Sie Vorlagen, um loszulegen.',
        },
        my_tasks_widget: {
            title: 'Meine Aufgaben',
            no_tasks: 'Keine Aufgaben an Sie zugewiesen.',
            load_error: 'Aufgaben konnten nicht geladen werden.',
            overdue: 'überfällig',
            remaining: 'übrig',
            view_all: 'Alle Aufgaben anzeigen',
        },
        my_section_status_widget: {
            title: 'Mein Abschnittsstatus',
            overall_completion: 'Gesamt',
            sections_count: 'Abschnitte',
            no_sections: 'Keine Abschnitte Ihrer Abteilung zugewiesen.',
            load_error: 'Abschnittsstatus konnte nicht geladen werden.',
        },
        revision_requests_widget: {
            title: 'Revisionsanfragen',
            no_revisions: 'Keine Revisionsanfragen. Alle Abschnitte sind auf Kurs.',
            load_error: 'Revisionsanfragen konnten nicht geladen werden.',
        },
        consent_summary: {
            title: 'Zustimmung',
            active: 'Aktiv',
            withdrawn_30d: 'Zurückgezogen (30 Tage)',
            expiring_7d: 'Auslaufend (7 Tage)',
        },
        transfer_assessments: {
            title: 'Transferbewertungen',
            open: 'Offen',
            approved: 'Genehmigt',
            gaps_flagged: 'Lücken gekennzeichnet',
        },
        breach_notifications: {
            title: 'Benachrichtigungen über Verstöße',
            deadline_72h: '72-Stunden-Frist',
            submitted: 'Eingereicht',
            pending: 'Ausstehend',
        },
        authority_requests: {
            title: 'Behördenanfragen',
            pending: 'Ausstehend',
            overdue: 'Überfällig',
            responded_30d: 'Beantwortet (30 Tage)',
        },
        data_subjects_widget: {
            title: 'Betroffene Personen',
            total: 'Insgesamt',
            high_risk: 'Hohes Risiko',
            active_30d: 'Aktiv (30 Tage)',
        },
        audit_activity_summary: {
            title: 'Audit-Aktivität',
            events_today: 'Veranstaltungen heute',
            events_7d: 'Ereignisse (7 Tage)',
            unique_actors_30d: 'Einzigartige Schauspieler (30 Tage)',
        },
        onboarding_progress: {
            title: 'Onboarding-Fortschritt',
            completion_pct: 'Komplett',
            status_label: 'Status',
            current_step: 'Aktueller Schritt',
            status: {
                in_progress: 'In Bearbeitung',
                completed: 'Abgeschlossen',
                skipped: 'Übersprungen',
                not_started: 'Nicht gestartet',
            },
        },
        sector_overlay_reports_due: {
            title: 'Fällige Berichte für Sektor-Overlays',
        },
        persona_widgets: {
            framework_filter: 'Nach Rahmenwerk filtern',
            all_frameworks: 'Alle Rahmenwerke',
            filing_lifecycle: 'Einreichungslebenszyklus',
            filing_pipeline: 'Einreichungspipeline',
            draft: 'Entwurf',
            internal_review: 'Interne Prüfung',
            approved: 'Genehmigt',
            submitted: 'Eingereicht',
            supplement_requested: 'Ergänzung angefordert',
            resubmitted: 'Erneut eingereicht',
            accepted: 'Akzeptiert',
            rejected: 'Abgelehnt',
            closed: 'Geschlossen',
            deadline: 'Frist',
            days_remaining: 'verbleibende Tage',
            days_overdue: 'Tage überfällig',
            no_filings: 'Keine aktiven Einreichungen.',
            department_consolidation: 'Abteilungskonsolidierung',
            departments_completed: 'Abteilungen abgeschlossen',
            departments_pending: 'Abteilungen ausstehend',
            departments_overdue: 'Abteilungen überfällig',
            no_consolidation_cases: 'Keine abteilungsübergreifenden Fälle in Bearbeitung.',
            vendor_risk: 'Lieferanten- und Drittparteirisiko',
            pending_assessment: 'Ausstehende Bewertung',
            overdue_questionnaires: 'Überfällige Fragebögen',
            dpa_review_queue: 'DPA-Prüfungswarteschlange',
            risk_distribution: 'Risikoverteilung',
            total_vendors: 'Gesamtlieferanten',
            by_risk_level: 'Nach Risikoniveau',
            no_vendor_data: 'Keine Lieferantenrisikodaten verfügbar.',
            discovery_summary: 'Datenermittlung',
            discovery_classification: 'Datenentdeckung und -klassifizierung',
            active_scans: 'Aktive Scans',
            labels_pending: 'Etiketten stehen zur Überprüfung aus',
            exceptions_unresolved: 'Ausnahmen ungelöst',
            pending_review: 'Ausstehende Prüfung',
            exceptions: 'Ausnahmen',
            approved_labels: 'Genehmigte Labels',
            total_classified: 'Gesamt klassifiziert',
            no_discovery_data: 'Keine Entdeckungsdaten verfügbar.',
            ai_governance: 'KI-Systemsteuerung',
            systems_inventory: 'Systeme im Inventar',
            systems_in_inventory: 'Systeme im Inventar',
            classification_breakdown: 'Klassifizierungsaufschlüsselung',
            dossier_completion: 'Dossier-Fertigstellung',
            by_classification: 'Nach Klassifizierung',
            labeling_status: 'Kennzeichnungsstatus',
            not_started: 'Nicht gestartet',
            no_ai_data: 'Keine KI-Steuerungsdaten verfügbar.',
            breach_response: 'Verletzungs- und Vorfallsreaktion',
            active_breaches: 'Aktive Verletzungen',
            notification_status: 'Benachrichtigungsstatus',
            remediation_progress: 'Behebungsfortschritt',
            supplement_loops: 'Ergänzungsschleifen',
            no_breach_data: 'Keine aktiven Verletzungsfälle.',
            audit_readiness: 'Prüfungs- und Bewertungsbereitschaft',
            assessments: 'Bewertungen',
            gap_findings: 'Lückenbefunde',
            evidence_completion: 'Nachweisfertigstellung',
            export_ready: 'Exportbereit',
            not_ready: 'Nicht bereit',
            no_audit_data: 'Keine Prüfungsbereitschaftsdaten verfügbar.',
            framework_label_vn_pdpl: 'VN PDPL 2025',
            framework_label_vn_cybersecurity: 'VN Cybersicherheit 2018',
            framework_label_vn_ecommerce: 'VN E-Commerce 2023',
            framework_label_vn_telecom: 'VN Telekommunikation 2023',
            framework_label_vn_ai: 'VN KI-Gesetz 2025',
            framework_label_gdpr: 'DSGVO',
            framework_label_unspecified: 'Nicht spezifiziert',
            my_department: 'Meine Abteilung',
            my_tasks: 'Meine Aufgaben',
            section_status: 'Abschnittsstatus',
            revision_requests: 'Revisionsanfragen',
            completion: 'Fertigstellung',
            reason: 'Grund',
            requested_at: 'Angefordert am',
            no_tasks_assigned: 'Keine Aufgaben zugewiesen.',
            no_sections: 'Keine Abschnitte Ihrer Abteilung zugewiesen.',
            no_revisions: 'Keine Revisionsanfragen.',
            load_error: 'Daten konnten nicht geladen werden.',
        },
    },
    connectors: {
        nav: {
            instances: 'Instanzen',
            credentials: 'Anmeldedatentresor',
            event_bus: 'Ereignisbus',
            definitions: 'Definitionen',
            brds: 'BRD-Erfassung',
            security_reviews: 'Sicherheitsprüfungen',
            poc_scorecards: 'POC-Bewertungskarten',
            automation_planning: 'Automatisierungsplanung',
            system_inventory: 'Systeminventar',
            traceability_matrix: 'Rückverfolgbarkeitsmatrix',
            gap_register: 'Lückenregister',
        },
        instances: {
            title: 'Konnektor-Instanzen',
            page_title: 'Konnektoren',
            add: 'Instanz hinzufügen',
            test: 'Verbindung testen',
            sync_now: 'Jetzt synchronisieren',
            new_instance: 'Neu Konnektor Instanz',
            no_instances: 'Keine Konnektor Instanzen gefunden',
            instance_count: '{count} Instanz(en)',
            confirm_delete: 'Löschen Konnektor Instanz "{name}"?',
            all_connector_types: 'Alle Konnektor Typen',
            select_connector: 'Auswählen ein Konnektor...',
            fetch_error: 'Fehler beim fetch Konnektor Instanzen. Bitte versuchen Sie es erneut.',
            fetch_definitions_error: 'Fehler beim fetch Konnektor Definitionen. Bitte versuchen Sie es erneut.',
            create_error: 'Fehler beim create Konnektor Instanz',
            test_error: 'Fehler beim test Konnektor. Bitte versuchen Sie es erneut.',
            status_error: 'Fehler beim Aktualisieren des Konnektorstatus. Bitte versuchen Sie es erneut.',
            delete_error: 'Fehler beim delete Konnektor Instanz. Bitte versuchen Sie es erneut.',
        },
        credentials: {
            title: 'Anmeldedatentresor',
            page_title: 'Konnektor-Anmeldedaten',
            add: 'Anmeldedaten hinzufügen',
            rotate: 'Rotieren',
            expired: 'Abgelaufen',
            expiring: 'Läuft bald ab',
            orphaned: 'Verwaist',
            new_credential: 'Neu Anmeldedaten',
            no_credentials: 'Keine credentials gefunden',
            no_expiry: 'No Ablauf',
            linked_connectors: 'Verknüpft Konnektoren',
            expires_at: 'Läuft ab am',
            value_label: 'Wert * (write-only)',
            confirm_delete_title: 'Löschen bestätigen',
            confirm_delete_message: 'Diese Anmeldedaten löschen? Verknüpfte Konnektoren verlieren den Zugriff.',
            rotate_title: 'Anmeldedaten rotieren',
            new_credential_value: 'Neuer Anmeldedatenwert',
            fetch_error: 'Fehler beim load credentials. Bitte versuchen Sie es erneut.',
            health_error: 'Fehler beim load Zustand. Bitte versuchen Sie es erneut.',
            create_error: 'Fehler beim create Anmeldedaten',
            rotate_error: 'Fehler beim rotate Anmeldedaten',
            delete_error: 'Fehler beim delete Anmeldedaten',
        },
        event_bus: {
            title: 'Ereignisbus',
            page_title: 'Event-Bus',
            events: 'Ereignisse',
            subscriptions: 'Abonnements',
            dlq: 'Warteschlange für fehlgeschlagene Nachrichten',
            publish: 'Ereignis veröffentlichen',
            retry: 'Erneut versuchen',
            dismiss: 'Verwerfen',
            search_events: 'Suche Ereignisse...',
            filter_event_type: 'Filtern nach Ereignis type...',
            event_type: 'Ereignis Typ',
            source_module: 'Quelle Modul',
            timestamp: 'Zeitstempel',
            delivery_status: 'Zustellung Status',
            correlation_id: 'Korrelation ID',
            tracking_id: 'Verfolgungs-ID',
            delivery_status_hint: 'Der Zustellstatus wird automatisch aktualisiert, wenn Ereignisse verarbeitet werden.',
            no_events: 'Keine Ereignisse gefunden',
            total_with_count: '{count} gesamt',
            prev: 'Zurück',
            new_subscription: '+ Neu Abonnement',
            subscriber_type: 'Abonnent Typ',
            subscriber_id: 'Abonnent ID',
            event_type_pattern: 'Ereignis Typ Muster',
            event_type_pattern_placeholder: 'z.B. incident.*',
            filter_expression: 'Filtern Ausdruck',
            filter_expression_placeholder: 'Optionaler Filter',
            subscriber_type_hint: 'Wählen Sie die Zustellmethode: Webhook sendet HTTP-Anfragen, E-Mail sendet Benachrichtigungen, Warteschlange leitet an eine Nachrichtenwarteschlange weiter.',
            subscriber_id_hint: 'Geben Sie das Ziel für Ereignisse ein. Für Webhooks verwenden Sie eine URL. Für E-Mail eine Adresse. Für Warteschlangen den Warteschlangennamen.',
            event_type_pattern_hint: 'Ereignisse nach Typ mit Platzhaltern abgleichen. Verwenden Sie * für beliebige Segmente (z.B. incident.* passt auf incident.created, incident.resolved).',
            filter_expression_hint: 'Optional. Ereignisse nach Inhalt weiter filtern (z.B. severity=high).',
            subscriber_id_placeholder_webhook: 'z.B. https://ihre-app.com/webhook',
            subscriber_id_placeholder_email: 'z.B. alerts@ihre-firma.com',
            subscriber_id_placeholder_queue: 'z.B. ereignis-warteschlange',
            event_pattern: 'Ereignis Muster',
            filter: 'Filtern',
            enabled: 'Aktiviert',
            delivery_stats: 'Zustellung Stats',
            no_subscriptions: 'Keine Abonnements gefunden',
            on: 'ON',
            off: 'OFF',
            delivered_failed: '{delivered} delivered / {failed} fehlgeschlagen',
            confirm_delete_subscription: 'Löschen dieses Abonnement?',
            unresolved: 'Ungelöst',
            resolved: 'Gelöst',
            event_id: 'Ereignis ID',
            subscription_id: 'Abonnement ID',
            error_code: 'Fehler Code',
            error_message: 'Fehler Message',
            attempts: 'Versuche',
            last_failed: 'Letzter Failed',
            no_dlq_entries: 'Keine dead letter Einträge gefunden',
            dlq_count: '{count} entry/entries gesamt',
            fetch_events_error: 'Fehler beim fetch Ereignisse. Bitte versuchen Sie es erneut.',
            fetch_subscriptions_error: 'Fehler beim fetch Abonnements. Bitte versuchen Sie es erneut.',
            fetch_dlq_error: 'Fehler beim fetch DLQ Einträge. Bitte versuchen Sie es erneut.',
            create_subscription_error: 'Fehler beim create Abonnement',
            toggle_subscription_error: 'Fehler beim toggle Abonnement',
            delete_subscription_error: 'Fehler beim delete Abonnement',
            retry_error: 'Wiederholen fehlgeschlagen',
            dismiss_error: 'Ablehnen fehlgeschlagen',
            event_published: 'Ereignis veröffentlicht',
            publish_event_error: 'Ereignis konnte nicht veröffentlicht werden. Bitte versuchen Sie es erneut.',
            priority_label: 'Priorität',
            priority_low: 'Niedrig',
            priority_normal: 'Normal',
            priority_high: 'Hoch',
            payload_helper_text: 'Geben Sie Ereignisdaten als JSON ein. Beispiel: {"incident_id": "INC-001", "severity": "high"}',
            subscription_created: 'Abonnement erstellt',
            subscription_toggled: 'Abonnement umgeschaltet',
            subscription_deleted: 'Abonnement gelöscht',
            dlq_retried: 'DLQ-Nachricht erneut versucht',
            dlq_dismissed: 'DLQ-Nachricht verworfen',
        },
        definitions: {
            title: 'Connector-Definitionen',
            page_title: 'Konnektordefinitionen',
            add: 'Definition hinzufügen',
            new_definition: 'Neue Connector-Definition',
            edit_definition: 'Bearbeiten Sie die Connector-Definition',
            no_definitions: 'Keine Connector-Definitionen gefunden',
            definition_count: '[[TOK_1]] Definition(en)',
            all_categories: 'Alle Kategorien',
            select_category: 'Wählen Sie eine Kategorie aus...',
            capabilities: 'Fähigkeiten',
            capabilities_hint: 'Fähigkeiten (durch Kommas getrennt)',
            capabilities_placeholder: 'z.B. lesen, schreiben, synchronisieren',
            created: 'Connector-Definition erstellt',
            updated: 'Connector-Definition aktualisiert',
            fetch_error: 'Konnektordefinitionen konnten nicht abgerufen werden. Bitte versuchen Sie es erneut.',
            create_error: 'Konnektordefinition konnte nicht erstellt werden',
            update_error: 'Fehler beim Aktualisieren der Konnektordefinition',
        },
        brds: {
            title: 'BRD-Erfassung',
            page_title: 'BRD-Erfassung',
            create_brd: 'BRD erstellen',
            brd_title: 'BRD-Titel',
            description: 'Beschreibung',
            requirements: 'Anforderungen',
            status: 'Status',
            stakeholders: 'Beteiligte',
            connector_label: 'Konnektor',
            select_connector: 'Konnektor auswählen...',
            approval: 'Genehmigung',
            no_brds_found: 'Keine BRDs gefunden',
            decision_records: 'Entscheidungsprotokolle',
            create_decision: 'Entscheidung erstellen',
            alternatives_considered: 'Erwogene Alternativen',
            alternative_name: 'Alternativname',
            reason_rejected: 'Ablehnungsgrund',
            add_alternative: 'Alternative hinzufügen',
            remove_alternative: 'Alternative {name} entfernen',
            alternatives: 'Alternativen',
            rationale: 'Begründung',
            selected_connector: 'Ausgewählter Konnektor',
            comma_separated_names: 'Kommagetrennte Namen',
            brd_created: 'BRD erstellt',
            decision_record_created: 'Entscheidungsdatensatz erstellt',
            no_decision_records_found: 'Keine Entscheidungsdatensätze gefunden',
            aria_brds_table: 'BRDs',
            aria_decision_records_table: 'Entscheidungsdatensätze',
            aria_approve: '{name} genehmigen',
            aria_archive: '{name} archivieren',
            brd_title_help: 'Ein kurzer, für Menschen lesbarer Name für diese BRD – z. „Jira-Ticketing-Integration“, „Okta SSO-Rollout“.',
            brd_title_placeholder: 'z.B. Jira-Ticketing-Integration',
            description_help: 'Das Geschäftsproblem, das dieser Connector löst. Welches Ergebnis erwarten Sie, wenn es live ist?',
            description_placeholder: 'z.B. Automatisieren Sie die Erstellung von Vorfalltickets anhand von Überwachungswarnungen, sodass der Bereitschaftsdienst innerhalb von 60 Sekunden weitergeleitet wird.',
            connector_help: 'Optional. Wählen Sie einen Anschluss aus, für den diese BRD bestimmt ist. Lassen Sie das Feld leer, wenn der Anschluss noch nicht ausgewählt wurde.',
            requirements_help: 'Durch Kommas getrennte Liste der unverzichtbaren Funktionen – z. B. „OAuth2-Anmeldung, Webhook-Zustellung, Audit-Export“.',
            requirements_placeholder: 'OAuth2-Anmeldung, Webhook-Zustellung, Audit-Export',
            stakeholders_help: 'Durch Kommas getrennte Namen oder E-Mail-Adressen von Personen, die sich abmelden müssen.',
            selected_connector_help: 'Wählen Sie den Connector aus, für den diese Entscheidung gilt.',
            rationale_help: 'Warum dieser Anschluss gewählt wurde. Behandeln Sie die entscheidenden Faktoren, damit ein zukünftiger Leser den Aufruf versteht.',
            rationale_placeholder: 'z.B. Wir haben uns für Jira entschieden, weil es bereits unseren Ticketverlauf speichert und das Team darauf geschult ist.',
            alternatives_considered_help: 'Andere bewertete Steckverbinder und warum sie nicht ausgewählt wurden. Fügt die Verteidigungsfähigkeit für die Prüfung hinzu.',
            alternative_name_placeholder: 'z.B. ServiceNow',
            reason_rejected_placeholder: 'z.B. Kosten 3x höher, kein Vorteil für unseren Anwendungsfall',
        },
        security_reviews: {
            title: 'Sicherheitsprüfungen',
            page_title: 'Sicherheitsüberprüfungen',
            create_review: 'Prüfung erstellen',
            connector_name: 'Konnektorname',
            connector_label: 'Konnektor',
            select_connector: 'Konnektor auswählen...',
            reviewer: 'Prüfer',
            select_reviewer: 'Prüfer auswählen...',
            findings: 'Ergebnisse (eines pro Zeile)',
            risk_level: 'Risikostufe',
            risk_level_placeholder: 'z.B. hoch, mittel, niedrig',
            notes: 'Notizen',
            review_status: 'Prüfungsstatus',
            checklist: 'Checkliste',
            privacy_impact: 'Datenschutzauswirkung',
            approval_gate: 'Genehmigungstor',
            no_reviews_found: 'Keine Prüfungen gefunden',
            review_created: 'Sicherheitsüberprüfung erstellt',
            create_control_mapping: 'Kontrollzuordnung erstellen',
            control_mapping_created: 'Kontrollzuordnung erstellt',
            connector_id_label: 'Konnektor-ID',
            control_id_label: 'Kontroll-ID',
            control_name_label: 'Kontrollname',
            aria_approve: '{name} genehmigen',
            aria_reject: '{name} ablehnen',
            scan_imported: 'Scan erfolgreich importiert',
            import_scan: 'Scan importieren',
            scan_format: 'Scanformat',
            scan_data: 'Scandaten',
            import_results: 'Importergebnisse',
            recommendations: 'Empfehlungen',
            auto_populated_from: 'Automatisch ausgefüllt ab [[TOK_1]]',
            manual_entry: 'Manuelle Eingabe',
            automation_type: 'Automatisierungstyp',
            select_automation_type: 'Automatisierungstyp auswählen...',
            automation_full: 'Vollständig – der Connector automatisiert diese Steuerung vollständig',
            automation_partial: 'Teilweise – Connector liefert Beweise; Menschen handeln immer noch',
            automation_monitoring: 'Nur Überwachung – Connector beobachtet, erzwingt nicht',
            control_id_help: 'Verwenden Sie den Code aus Ihrem Compliance-Schema (z. B. ISO-27001-A.12.1, SOC2-CC6.1 oder Ihre interne Kontroll-ID).',
            control_name_help: 'Kurzer, für Menschen lesbarer Name (z. B. „Netzwerkzugriffsbeschränkung“).',
            description_label: 'Beschreibung',
            load_sarif_example: 'SARIF-Beispiel laden',
            load_json_example: 'Laden Sie ein benutzerdefiniertes [[TOK_0]]-Beispiel',
            scan_format_help: 'SARIF ist der OASIS-Standard, der von den meisten Scannern (Snyk, CodeQL, Semgrep) ausgegeben wird. Verwenden Sie benutzerdefiniertes [[TOK_0]] für Tools, die kein SARIF ausgeben.',
            scan_data_help: 'Fügen Sie die vollständige Scan-Ausgabe ein, laden Sie eine .sarif/.json-Datei hoch oder klicken Sie auf die Schaltfläche „Beispiel laden“, um die Form anzuzeigen.',
            upload_file_label: 'Laden Sie die .sarif- oder .json-Datei hoch',
            invalid_scan_json: 'Scandaten konnten nicht als [[TOK_0]] geparst werden. Suchen Sie nach Syntaxfehlern in der Nähe des hervorgehobenen Zeichens.',
            save_as_review: 'Als Sicherheitsüberprüfung speichern',
            discard_preview: 'Vorschau verwerfen',
            preview_hint: 'Dies ist eine Vorschau – es ist noch nichts gespeichert. Klicken Sie auf „Als Sicherheitsüberprüfung speichern“, um eine ausstehende Überprüfung zu erstellen, die mit diesen Werten vorausgefüllt ist.',
            reviewer_required_for_save: 'Wählen Sie einen Prüfer aus, um diesen Scan als Sicherheitsüberprüfung zu speichern.',
        },
        poc_scorecards: {
            title: 'POC-Bewertungskarten',
            page_title: 'POC-Scorecards',
            create_scorecard: 'Bewertungskarte erstellen',
            connector_label: 'Konnektor',
            select_connector: 'Konnektor auswählen...',
            vendor_name: 'Anbietername',
            recommendation: 'Empfehlung',
            recommendation_placeholder: 'z.B. Fortfahren, Nicht fortfahren, Weitere Bewertung erforderlich',
            criteria: 'Bewertungskriterien',
            criterion_name: 'Kriteriumsname',
            score: 'Punktzahl',
            max_score: 'Maximalpunktzahl',
            notes: 'Notizen',
            add_criterion: 'Kriterium hinzufügen',
            remove_criterion: 'Kriterium {name} entfernen',
            total_score: 'Gesamtpunktzahl',
            api_quality: 'API-Qualität',
            reliability: 'Zuverlässigkeit',
            support_quality: 'Supportqualität',
            cost_score: 'Kostenbewertung',
            overall_score: 'Gesamtbewertung',
            evidence: 'Nachweise',
            no_scorecards_found: 'Keine Bewertungskarten gefunden',
            scorecard_created: 'POC-Scorecard erstellt',
            connector_help: 'Wählen Sie den Connector aus, für den diese POC-Bewertung gedacht ist.',
            vendor_name_help: 'Der zu bewertende Anbieter oder das zu bewertende Produkt – z. „Okta“, „Datadog“, „Snowflake“.',
            vendor_name_placeholder: 'z.B. Okta, Datadog, Schneeflocke',
            recommendation_help: 'Ihr letzter Anruf nach der Bewertung. Halten Sie es kurz und entschlossen.',
            criteria_help: 'Bewerten Sie den Anbieter nach jedem Bewertungskriterium. Fügen Sie eine Zeile pro Kriterium hinzu ([[TOK_0]] Qualität, Zuverlässigkeit, Support, Kosten usw.).',
            criterion_name_help: 'Was Sie bewerten – z.B. „[[TOK_0]] Qualität“, „Zuverlässigkeit“, „Support“, „Kosten“.',
            criterion_name_placeholder: 'z.B. [[TOK_0]] Qualität',
            score_help: 'Für dieses Kriterium wurde eine Punktzahl vergeben. Darf die maximale Punktzahl nicht überschreiten.',
            max_score_help: 'Höchstpunktzahl für dieses Kriterium verfügbar. Verwenden Sie in allen Zeilen die gleiche Skala, damit die Gesamtwerte vergleichbar sind.',
            notes_help: 'Optional. Fügen Sie Beweise, Vorbehalte oder Links hinzu – alles, was das Ergebnis erklärt.',
        },
        common_labels: {
            aria_filter_instances: 'Konnektorinstanzen filtern',
            aria_filter_definitions: 'Konnektordefinitionen filtern',
            aria_filter_credentials: 'Anmeldedaten filtern',
            aria_filter_events: 'Ereignisse filtern',
            aria_filter_dlq: 'Dead-Letter-Warteschlange filtern',
            aria_instance_summary: 'Konnektorinstanz-Zusammenfassung',
            aria_active_connectors: 'Aktive Konnektoren',
            aria_error_connectors: 'Fehlerhafte Konnektoren',
            aria_credential_health: 'Zusammenfassung des Anmeldedaten-Status',
            aria_items_per_page: 'Elemente pro Seite',
            show_password: 'Passwort anzeigen',
            hide_password: 'Passwort ausblenden',
            payload_json_label: 'Nutzlast (JSON)',
            payload_invalid_json: 'Nutzlast muss gültiges JSON sein',
            placeholder_event_type: 'z.B. incident.created',
            placeholder_source_module: 'z.B. monitoring',
            placeholder_version: 'z.B. 1.0',
        },
        statuses: {
            configuring: 'Konfigurieren',
            testing: 'Testen',
            active: 'Aktiv',
            paused: 'Angehalten',
            error: 'Fehler',
            disabled: 'Deaktiviert',
            draft: 'Entwurf',
            approved: 'Genehmigt',
            archived: 'Archiviert',
            pending: 'Ausstehend',
            rejected: 'Abgelehnt',
        },
        system_types: {
            application: 'Anwendung',
            database: 'Datenbank',
            middleware: 'Middleware',
            infrastructure: 'Infrastruktur',
            saas: 'SaaS',
            other: 'Sonstige',
        },
        hosting_types: {
            on_premise: 'Vor Ort',
            cloud: 'Wolke',
            hybrid: 'Hybrid',
            managed: 'Verwaltet',
        },
        system_statuses: {
            active: 'Aktiv',
            decommissioned: 'Außer Betrieb',
            planned: 'Geplant',
            under_review: 'In Überprüfung',
        },
        automation_statuses: {
            planning: 'Planung',
            in_progress: 'In Bearbeitung',
            completed: 'Abgeschlossen',
            on_hold: 'Pausiert',
        },
        gap_types: {
            functional: 'Funktional',
            technical: 'Technisch',
            security: 'Sicherheit',
            compliance: 'Compliance',
            process: 'Prozess',
        },
        severity_labels: {
            critical: 'Kritisch',
            high: 'Hoch',
            medium: 'Mittel',
            low: 'Niedrig',
        },
        gap_statuses: {
            open: 'Offen',
            in_progress: 'In Bearbeitung',
            mitigated: 'Mitigiert',
            closed: 'Geschlossen',
            accepted: 'Akzeptiert',
        },
        verification_statuses: {
            not_started: 'Nicht gestartet',
            in_progress: 'In Bearbeitung',
            verified: 'Verifiziert',
            failed: 'Fehlgeschlagen',
        },
        subscriber_types: {
            webhook: 'Webhook',
            internal: 'Intern',
            email: 'E-Mail',
            queue: 'Warteschlange',
        },
        credential_types: {
            password: 'Passwort',
            api_key: 'API-Schlüssel',
            oauth2_client: 'OAuth2-Client',
            certificate: 'Zertifikat',
            token: 'Token',
            ssh_key: 'SSH-Schlüssel',
            imap_credentials: 'IMAP-Anmeldedaten',
        },
        categories: {
            hr: 'Personalwesen',
            crm: 'CRM',
            erp: 'ERP',
            cloud: 'Wolke',
            security: 'Sicherheit',
            itsm: 'ITSM',
            custom: 'Benutzerdefiniert',
        },
        delivery_statuses: {
            pending: 'Ausstehend',
            delivered: 'Zugestellt',
            partial: 'Teilweise',
            failed: 'Fehlgeschlagen',
        },
        automation_planning: {
            title: 'Automatisierungsplanung',
            page_title: 'Automatisierungsplanung',
            program_name: 'Programmname',
            program_status: 'Status',
            description: 'Beschreibung',
            linked_artifacts: 'Verknüpfte Artefakte',
            create_program: 'Programm erstellen',
            edit_program: 'Programm bearbeiten',
            no_programs_found: 'Keine Programme gefunden',
            program_created: 'Programm erstellt',
            program_updated: 'Programm aktualisiert',
            target_date: 'Zieldatum',
            owner: 'Eigentümer',
            select_status: 'Status auswählen...',
            aria_programs_table: 'Automatisierungsprogramme',
            aria_edit: '{name} bearbeiten',
            export_programs: 'Programme exportieren',
            title_label: 'Programmtitel',
            title_help: 'Ein kurzer, für Menschen lesbarer Name für das Automatisierungsprogramm – z. B. „Q3-Incident-to-Jira-Rollout“, „[[TOK_0]] Zugriffsanfrage-Automatisierung“.',
            title_placeholder: 'z.B. Q3-Incident-zu-Jira-Rollout',
            description_help: 'Was dieses Programm abdeckt und welches Ergebnis Sie erwarten, wenn es live ist. Optional, aber empfohlen.',
            description_placeholder: 'z.B. Übertragen Sie Überwachungswarnungen in Jira, sodass Bereitschaftsdienste innerhalb von 60 Sekunden weitergeleitet werden.',
            owner_label: 'Programminhaber',
            owner_help: 'Die für dieses Programm verantwortliche Person. Sie erhalten Benachrichtigungen über Fortschritte und Tore.',
            select_owner: 'Wählen Sie einen Besitzer aus...',
            frameworks_in_scope: 'Frameworks im Geltungsbereich',
            frameworks_in_scope_help: 'Compliance-Frameworks, die dieses Programm unterstützt. Hilft dem Prüfpfad, zu zeigen, welchen Vorschriften die Automatisierung unterliegt.',
            select_frameworks: 'Frameworks auswählen...',
            status_draft: 'Entwurf',
            status_active: 'Aktiv',
            status_completed: 'Abgeschlossen',
            status_archived: 'Archiviert',
            change_status: 'Status ändern',
            status_updated: 'Status aktualisiert',
            aria_change_status: 'Status ändern für [[TOK_1]]',
        },
        system_inventory: {
            title: 'Systeminventar',
            page_title: 'Systeminventar',
            system_name: 'Systemname',
            system_type: 'Systemtyp',
            hosting: 'Hosting',
            status: 'Status',
            description: 'Beschreibung',
            create_system: 'System erstellen',
            edit_system: 'System bearbeiten',
            no_systems_found: 'Keine Systeme gefunden',
            system_created: 'System erstellt',
            system_updated: 'System aktualisiert',
            select_type: 'Typ auswählen...',
            select_hosting: 'Hosting auswählen...',
            select_status: 'Status auswählen...',
            owner: 'Eigentümer',
            department: 'Abteilung',
            data_categories: 'Datenkategorien',
            data_categories_placeholder: 'Kommagetrennt, z. B. PII, Finanzen, Gesundheit',
            jurisdiction: 'Gerichtsbarkeit',
            jurisdiction_placeholder: 'z. B. EU, US, Global',
            interfaces: 'Schnittstellen',
            interfaces_placeholder: 'Kommagetrennt, z. B. REST API, SFTP, JDBC',
            owner_placeholder: 'Wählen Sie einen verantwortlichen Eigentümer aus...',
            department_placeholder: 'Wählen Sie die verantwortliche Organisationseinheit aus...',
            system_name_hint: 'Verwenden Sie den geschäftlich anerkannten System- oder Anwendungsnamen.',
            system_type_hint: 'Klassifizieren Sie das System, damit das Reporting ähnliche Assets gruppieren kann.',
            hosting_hint: 'Identifizieren Sie, wo das System für Residenz, Sicherheit und Lieferantenbewertung ausgeführt wird.',
            status_hint: 'Legen Sie den Lebenszyklusstatus fest, der von Überprüfungen, Exporten und Audit-Nachweisen verwendet wird.',
            owner_hint: 'Wählen Sie den aktiven Benutzer aus, der für die System-Governance und Follow-up-Aufgaben verantwortlich ist.',
            department_hint: 'Verwenden Sie die Organisationseinheit, die für den Betrieb oder die Verwaltung dieses Systems verantwortlich ist.',
            data_categories_hint: 'Listen Sie die von diesem System verarbeiteten Datenklassen auf, getrennt durch Kommas.',
            jurisdiction_hint: 'Erfassen Sie die wichtigste Rechts- oder Hosting-Gerichtsbarkeit für das Compliance-Mapping.',
            interfaces_hint: 'Listen Sie Connector- oder Integrationspfade auf, die zum Datenaustausch verwendet werden.',
            description_hint: 'Fassen Sie zusammen, was das System tut und warum es für die Datenlandkarte wichtig ist.',
            owner_department_required: 'Eigentümer und Abteilung sind erforderlich.',
            aria_systems_table: 'Systeminventar',
            aria_edit: '{name} bearbeiten',
            export_systems: 'Systeme exportieren',
        },
        traceability_matrix: {
            title: 'Rückverfolgbarkeitsmatrix',
            page_title: 'Rückverfolgbarkeitsmatrix',
            brd_selector: 'BRD auswählen',
            requirement: 'Anforderung',
            linked_artifact: 'Verknüpftes Artefakt',
            verification_status: 'Verifizierungsstatus',
            verified_by: 'Verifiziert von',
            create_entry: 'Eintrag erstellen',
            edit_entry: 'Eintrag bearbeiten',
            no_entries_found: 'Keine Einträge gefunden',
            entry_created: 'Eintrag erstellt',
            entry_updated: 'Eintrag aktualisiert',
            select_brd: 'BRD auswählen...',
            select_status: 'Status auswählen...',
            aria_matrix_table: 'Rückverfolgbarkeitsmatrix',
            aria_edit: 'Eintrag für {name} bearbeiten',
            export_matrix: 'Matrix exportieren',
        },
        gap_register: {
            title: 'Lückenregister',
            page_title: 'Lückenregister',
            gap_title: 'Lückentitel',
            gap_type: 'Lückentyp',
            severity: 'Schweregrad',
            status: 'Status',
            description: 'Beschreibung',
            remediation_plan: 'Behebungsplan',
            assigned_to: 'Zugewiesen an',
            due_date: 'Fälligkeitsdatum',
            create_gap: 'Lücke erstellen',
            edit_gap: 'Lücke bearbeiten',
            no_gaps_found: 'Keine Lücken gefunden',
            gap_created: 'Lücke erstellt',
            gap_updated: 'Lücke aktualisiert',
            select_type: 'Typ auswählen...',
            select_severity: 'Schweregrad auswählen...',
            select_status: 'Status auswählen...',
            aria_gaps_table: 'Lückenregister',
            aria_edit: '{name} bearbeiten',
            export_gaps: 'Lücken exportieren',
            gap_title_hint: 'Provide a concise name for the identified gap.',
            gap_type_hint: 'Select the nature of the gap (e.g., missing coverage or integration issue).',
            severity_hint: 'The impact of this gap on compliance and operations.',
            status_hint: 'Current stage of the gap resolution lifecycle.',
            owner_hint: 'The person responsible for tracking and remediating this gap.',
            description_hint: 'Detailed context regarding the gap, its root cause, and impact.',
            mitigation_plan_hint: 'Steps planned or taken to address and close the gap.',
            linked_requirement_ids_hint: 'Comma-separated requirement codes this gap affects.',
            linked_system_ids_hint: 'Comma-separated system IDs associated with this gap.',
            gap_types: {
                coverage: 'Coverage',
                capability: 'Capability',
                integration: 'Integration',
                compliance: 'Compliance',
            },
        },
        regulatory: {
            system_inventory_governance_info: 'System inventory aligns with Data Law enterprise governance. System types map to regulatory categories, hosting classification determines jurisdiction-specific controls. Use framework linkage to connect systems to applicable regulatory frameworks.',
            automation_planning_workflow_info: 'Automation programs align with compliance workflow obligations defined by applicable regulatory frameworks. Framework scope determines which requirements the program addresses.',
            traceability_regulatory_source_info: 'Each traceability entry connects a BRD requirement to its regulatory source. Verification status tracks whether implementation satisfies the regulatory obligation.',
            security_reviews_control_mapping_info: 'Security reviews evaluate framework-specific controls applicable to each connector. Risk level captures assessed exposure, findings document deviations from control requirements.',
            gap_register_framework_info: 'Gap Register captures compliance gaps per regulatory framework. Use framework filter to view gaps for a specific framework. Severity levels align with framework risk classification.',
            poc_scorecards_criteria_info: 'POC scorecards evaluate connectors against regulatory criteria. Criteria structure supports weighted scoring with evidence notes. Vendor linkage connects to vendor record.',
            evidence_trail_info: 'All connector module actions generate audit events for cross-module evidence trail integrity. CSV exports preserve referential integrity.',
        },
        system_inventory_extra: {
            framework_linkage: 'Rahmenwerk-Verknüpfung',
            framework_linkage_placeholder: 'z.B. GDPR, ISO 27001, NIS2',
        },
        automation_planning_extra: {
            framework_scope: 'Rahmenwerk-Umfang',
            framework_scope_placeholder: 'z.B. GDPR, PCI-DSS',
            procedure_linkage: 'Verfahrensverknüpfung',
            procedure_linkage_placeholder: 'z.B. SOP-001, PROC-DATA-003',
        },
        traceability_matrix_extra: {
            regulatory_source: 'Regulierungsquelle',
            regulatory_source_placeholder: 'z.B. GDPR Art. 30, ISO 27001 A.8',
        },
        security_reviews_extra: {
            control_mapping_col: 'Kontrollzuordnung',
            control_mappings_section: 'Kontrollzuordnungen',
            no_control_mappings: 'Noch keine Steuerungszuordnungen. Klicken Sie auf „Steuerungszuordnung erstellen“, um eine hinzuzufügen.',
            automation_type_col: 'Automatisierung',
        },
        gap_register_extra: {
            framework_filter: 'Rahmenwerk',
            framework_id: 'Rahmenwerk-ID',
            framework_id_placeholder: 'z.B. GDPR, ISO 27001',
            all_frameworks: 'Alle Rahmenwerke',
        },
        poc_scorecards_extra: {
            criteria_count: 'Kriterien',
        },
        export_labels: {
            export_brds: 'BRDs exportieren',
            export_decision_records: 'Entscheidungsregister exportieren',
            export_security_reviews: 'Sicherheitsüberprüfungen exportieren',
            export_poc_scorecards: 'POC-Scorekarten exportieren',
            export_instances: 'Instanzen exportieren',
            export_definitions: 'Definitionen exportieren',
            export_credentials: 'Anmeldeinformationen exportieren',
            export_events: 'Ereignisse exportieren',
            exporting: 'Wird exportiert...',
            export_success: 'Export abgeschlossen',
            export_error: 'Export fehlgeschlagen',
        },
    },
    vendor_risk: {
        risk_acceptance_reasoning: {
            draft_label: 'Begründungsentwurf',
            drafting: 'Begründung verfassen …',
            results_heading: '[[TOK_2]]-ausgearbeitete Begründung ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]] Token',
            narrative_label: 'Begründungserzählung',
            controls_heading: 'Ausgleichskontrollen',
            no_controls: 'Es werden keine kompensierenden Kontrollen vorgeschlagen.',
            citations_label: 'Zitate',
            accept_label: 'Akzeptieren Sie die Argumentation',
            reject_label: 'Entwurf ablehnen',
            accept_hint: 'Accept zeichnet die Begründung des beibehaltenen Entwurfs für die IAT-Abstammung auf. Die Erzähl- und Steuerelemente aktualisieren den Annahmedatensatz nicht automatisch – ein Einfügen durch den Bediener ist erforderlich.',
            resolve_summary: 'Auflösung: [[TOK_1]]',
            error_generic: 'Begründung konnte nicht formuliert werden. Versuchen Sie es erneut oder überprüfen Sie den Risikoakzeptanzstatus.',
        },
        redline_assistant: {
            run_label: 'Redline mit Bibliothek',
            running: 'Redline läuft…',
            results_heading: 'Redline-Vorschläge ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]] Token',
            no_suggestions: 'Es wurden keine Lücken in den Standardklauseln festgestellt.',
            jurisdiction_label: 'Gerichtsstand',
            col_kind: 'Freundlich',
            col_severity: 'Schweregrad',
            col_title: 'Vorschlag',
            col_excerpt: 'Passender Auszug',
            col_apply: 'Bewerben',
            kind_missing: 'Fehlender Standard',
            kind_weaker: 'Schwächer als Standard',
            kind_jurisdiction: 'Zuständigkeitsüberlagerung',
            proposed_label: 'Vorgeschlagener Text',
            citations_label: 'Zitate',
            accept_label: 'Ausgewählte akzeptieren',
            reject_label: 'Bericht ablehnen',
            partial_label: 'Auswahl anwenden',
            accept_hint: '„Auswahl anwenden“ zeichnet die ausgewählten Vorschläge im Entwurf für die IAT-Abstammung auf. Der Vertragstext wird nicht automatisch bearbeitet – der Betreiber bestimmt die Redline.',
            resolve_summary: 'Lösung: [[TOK_2]] · [[TOK_3]] Vorschlag(e) angewendet',
            error_generic: 'Es konnte keine Redline erstellt werden. Versuchen Sie es erneut oder überprüfen Sie den Vertragsstatus.',
            clause_library_link: 'Klauselbibliothek verwalten',
        },
        clause_library: {
            page_title: 'Klauselbibliothek',
            add_label: 'Klausel hinzufügen',
            edit_label: 'Bearbeiten',
            delete_label: 'Löschen',
            slug_label: 'Schnecke',
            title_label: 'Titel',
            body_label: 'Körper',
            jurisdiction_label: 'Gerichtsstand',
            tags_label: 'Tags (durch Kommas getrennt)',
            must_contain_label: 'Muss Markierungen enthalten (durch Kommas getrennt)',
            severity_label: 'Schweregrad bei Fehlen',
            no_clauses: 'Noch keine Klauseln. Fügen Sie einen hinzu, um den Redline-Assistenten zu starten.',
            save_label: 'Speichern',
            cancel_label: 'Abbrechen',
            load_error: 'Klauselbibliothek konnte nicht geladen werden.',
            save_error: 'Klausel konnte nicht gespeichert werden.',
            delete_error: 'Klausel konnte nicht gelöscht werden.',
            delete_confirm: 'Klausel „[[TOK_1]]“ löschen? Dies kann nicht rückgängig gemacht werden.',
        },
        obligation_extraction: {
            extract_label: 'Verpflichtungen extrahieren',
            extracting: 'Extrahieren…',
            results_heading: 'Extrahierte Verpflichtungen ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]] Token',
            no_obligations: 'In diesem Vertragstext sind keine Verpflichtungsmuster erkennbar.',
            col_class: 'Klasse',
            col_summary: 'Zusammenfassung (bearbeitbar)',
            col_excerpt: 'Satzauszug',
            col_due_date: 'Fälligkeitsdatum (bearbeitbar)',
            col_priority: 'Priorität',
            due_date_placeholder: 'YYYY-MM-DD',
            class_notice: 'Kündigungsfrist',
            class_audit: 'Audit richtig',
            class_insurance: 'Versicherung',
            class_sla: 'Antwort [[TOK_0]]',
            class_breach: 'Benachrichtigung über Verstöße',
            class_renewal: 'Erneuerungsfenster',
            citations_label: 'Zitate',
            accept_hint: 'Akzeptieren erstellt eine Aufgabe pro Verpflichtung (Kapitel 8) mit angezeigter Priorität + Fälligkeitsdatum.',
            accept_label: 'Akzeptieren Sie Verpflichtungen',
            reject_label: 'Bericht ablehnen',
            resolve_summary: 'Lösung: [[TOK_2]] · [[TOK_3]] Aufgabe(n) erstellt',
            error_generic: 'Verpflichtungen konnten nicht extrahiert werden. Versuchen Sie es erneut oder überprüfen Sie den Vertragstext.',
        },
        subprocessor_impact: {
            assess_label: 'Bewerten Sie die Auswirkungen',
            assessing: 'Auswirkungen abschätzen…',
            results_heading: 'Auswirkungen auf den Unterprozessor ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]] Token',
            risk_delta_label: 'Risikodelta',
            notification_heading: 'Kundenbenachrichtigung',
            subject_label: 'Betreff',
            deadline_label: 'Benachrichtigungsfrist',
            body_label: 'Benachrichtigungsstelle',
            required_fields_label: 'Erforderliche Felder gemäß Artikel 28 Absatz 4',
            mitigation_heading: 'Abhilfemaßnahmen',
            citations_label: 'Zitate',
            accept_label: 'Beurteilung akzeptieren',
            reject_label: 'Beurteilung ablehnen',
            accept_hint: 'Accept erstellt eine Kundenbenachrichtigungsaufgabe mit der Frist [[TOK_0]] als Fälligkeitsdatum.',
            resolve_summary: 'Auflösung: [[TOK_2]][[TOK_3]]',
            error_generic: 'Dieser Subprozessorwechsel konnte nicht beurteilt werden. Versuchen Sie es erneut oder überprüfen Sie den Änderungsdatensatz.',
        },
        onboarding_evidence: {
            collect_label: 'Führen Sie die Beweissammlung [[TOK_0]] durch',
            collecting: 'Beweise sammeln…',
            results_heading: 'Beweissammlung ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]] Token',
            findings_heading: 'Vorhandene Beweise',
            missing_heading: 'Fehlende Artefakte',
            no_findings: 'Es wurden keine vorhandenen Beweise gefunden.',
            no_missing: 'Für diese Risikostufe fehlen keine erforderlichen Artefakte.',
            next_step_label: 'Nächster Schritt',
            class_dpa: 'Datenverarbeitungsvereinbarung',
            class_soc2: 'SOC 2-Bericht',
            class_iso27001: 'ISO 27001-Zertifikat',
            class_insurance: 'Cyber-Versicherungspolice',
            class_incident_history: 'Vorheriger Vorfall',
            accept_hint: 'Accept erstellt Aufgaben für jedes fehlende Artefakt (maximal 5). Die Feststellungen bleiben Entwurf, bis Sie sie als Beweismittel beifügen.',
            accept_label: 'Bericht annehmen',
            reject_label: 'Bericht ablehnen',
            resolve_summary: 'Lösung: [[TOK_2]] · [[TOK_3]] Aufgabe(n) erstellt',
            error_generic: 'Die Beweissammlung [[TOK_0]] konnte nicht ausgeführt werden. Versuchen Sie es erneut oder überprüfen Sie den Onboarding-Fallstatus.',
        },
        no_permission_title: 'Unzureichende Berechtigungen',
        no_permission_message: 'Sie sind nicht berechtigt, auf das Lieferantenrisikomanagement zuzugreifen.',
        unknown_vendor: 'Unbekannter Anbieter',
        nav: {
            dashboard: 'Risikoübersicht',
            scoring: 'Risikobewertung',
            questionnaires: 'Fragebögen',
            contracts: 'Verträge',
            gates: 'Genehmigungstore',
            reviews: 'Lieferantenbewertungen',
            signals: 'Risikosignale',
            reassessments: 'Neubewertungen',
            portfolio: 'Risikoportfolio',
            acceptances: 'Risikoakzeptanz',
            review_routing: 'Prüfungsweiterleitung',
            onboarding_cases: 'Onboarding-Fälle',
            sub_processor_register: 'Register der Unterauftragsverarbeiter',
        },
        dashboard: {
            title: 'Lieferantenrisikoübersicht',
            page_title: 'Lieferantenrisiko-Dashboard',
            loading: 'Lade Dashboard Daten...',
            risk_tier_header: 'Risikostufe',
            count_header: 'Zählen',
            percentage_header: 'Prozentsatz',
            sections_nav: 'Abschnitte zum Lieferantenrisiko',
            urgent_expiry: 'Dringend: läuft innerhalb von 14 Tagen ab',
            no_previous_tier: 'Keine vorherige Stufe',
            view_as_chart: 'Als Diagramm anzeigen',
            view_as_table: 'Als Tabelle anzeigen',
            showing_chart: 'Diagrammansicht',
            showing_table: 'Datentabellenansicht',
            load_error: 'Fehler beim load Anbieter Risiko Dashboard',
            risk_distribution: 'Risiko Distribution Overview',
            recent_tier_changes: 'Kürzliche Stufe Änderungen',
            no_tier_changes: 'No recent Stufe changes.',
            review_kpis: 'Überprüfen KPIs',
            total_vendors_reviewed: 'Gesamt Anbieter Überprüft',
            reviews_by_outcome: 'Überprüfungen nach Ergebnis',
            contract_coverage: 'Vertrag Abdeckung',
            total_vendors: 'Gesamt Anbieter',
            with_active_dpa: 'Mit Aktiv DPA',
            without_dpa: 'Ohne DPA',
            dpa_coverage: 'DPA Abdeckung',
            active_contracts_by_type: 'Aktiv Verträge nach Typ',
            expiring_contracts: 'Ablaufend Verträge (Next 90 Days)',
            no_expiring_contracts: 'No Verträge expiring within der next 90 Tage.',
            vendor: 'Anbieter',
            previous_tier: 'Vorherig Stufe',
            current_tier: 'Aktuell Stufe',
            changed_at: 'Geändert At',
            expires_at: 'Läuft ab am',
            days_remaining: 'Tage Verbleibend',
            days: 'Tage',
            vendors_label: 'Anbieter',
            no_data: 'No Daten',
            critical: 'Kritisch',
            high: 'Hoch',
            medium: 'Mittel',
            low: 'Niedrig',
            expiring_acceptances_heading: 'Ablaufende Risikoakzeptanzen',
            expiring_30d_label: 'Ablauf in 30 Tagen',
            expiring_60d_label: 'Ablauf in 60 Tagen',
            expiring_90d_label: 'Ablauf in 90 Tagen',
        },
        scoring: {
            title: 'Risikobewertung',
            page_title: 'Bewertung des Lieferantenrisikos',
            filter_scores: 'Risikobewertungen filtern',
            filter_by_tier: 'Filtern Sie nach Risikostufe',
            scores_pagination: 'Paginierung der Risikobewertung',
            config_dimensions: 'Konfiguration der Scoring-Dimensionen',
            scores_loaded: '[[TOK_1]] Risikobewertungen geladen',
            weight_must_equal_100: 'Das Gesamtgewicht muss 100 betragen (aktuell: [[TOK_1]])',
            out_of_10: 'von 10, bewertet mit [[TOK_1]]',
            dimension_name: 'Name der Dimension [[TOK_1]].',
            dimension_weight: '[[TOK_1]] Gewicht (Prozentsatz)',
            must_equal_100: 'muss gleich 100 sein',
            config_title: 'Bewertung Konfiguration',
            scores_title: 'Anbieter Risiko Bewertungen',
            new_score_title: 'Bewertung ein Anbieter',
            new: 'Neu Bewertung',
            vendor_id: 'Anbieter ID',
            risk_tier: 'Risiko Stufe',
            score: 'Bewertung',
            scored_at: 'Bewertet am',
            no_scores: 'Keine Risiko scores gefunden.',
            all_tiers: 'Alle Stufen',
            load_config_error: 'Fehler beim load Risiko Bewertung Konfiguration',
            update_config: 'Bewertungskonfiguration aktualisieren',
            update_config_error: 'Fehler beim update Risiko Bewertung Konfiguration',
            load_scores_error: 'Fehler beim load Anbieter Risiko scores',
            calculate_error: 'Fehler beim calculate Anbieter Risiko score',
            weight: 'Gewicht',
            score_range: 'Bewertung (1-5)',
            method: 'Methode',
        },
        questionnaires: {
            title: 'Fragebögen',
            page_title: 'Lieferantenfragebögen',
            filter_questionnaires: 'Fragebogenfilter',
            questionnaire_views: 'Ansichten im Fragebogen',
            templates_list: 'Liste der Fragebogenvorlagen',
            instances_list: 'Liste der Fragebogeninstanzen',
            filter_by_status: 'Filtern Sie nach Fragebogenstatus',
            templates_per_page: 'Vorlagen pro Seite',
            instances_per_page: 'Instanzen pro Seite',
            select_template: 'Fragebogenvorlage auswählen',
            template_category: 'Vorlagenkategorie',
            templates_tab: 'Vorlagen',
            instances_tab: 'Instanzen',
            new: 'Neu Questionnaire',
            new_template: 'Neue Vorlage',
            new_instance: 'Neue Instanz',
            vendor_id: 'Anbieter ID',
            template_id: 'Vorlage ID',
            assigned_to: 'Zugewiesen Zu',
            due_date: 'Due Datum',
            responses: 'Antworten',
            risk_score: 'Fertigstellung',
            no_questionnaires: 'Keine Fragebögen gefunden.',
            load_templates_error: 'Fehler beim load Fragebogen Vorlagen',
            load_instances_error: 'Fehler beim load Fragebögen',
            create_template_error: 'Fehler beim create Fragebogen Vorlage',
            initiate_error: 'Fehler beim initiate Fragebogen',
            submit_error: 'Fehler beim submit Fragebogen',
            review_error: 'Fehler beim Überprüfung Fragebogen',
            resubmit: 'Erneut einreichen',
            approve_error: 'Fragebogen konnte nicht genehmigt werden',
            reject_error: 'Fragebogen konnte nicht abgelehnt werden',
            resubmit_error: 'Fragebogen konnte nicht erneut eingereicht werden',
            templates_loaded: '[[TOK_1]] Fragebogenvorlagen geladen',
            instances_loaded: '[[TOK_1]] Fragebogeninstanzen geladen',
            fill_responses_cta: 'Antworten ausfüllen',
            fill_responses_title: 'Fragebogenantworten ausfüllen',
            template_missing: 'Vorlage nicht gefunden.',
            responses_saved: 'Antworten gespeichert.',
            load_template_error: 'Vorlage konnte nicht geladen werden.',
            version_history: 'Versionsverlauf',
            download_previous_version: 'Frühere Version herunterladen',
            trigger: 'Auslöser',
            template_label: 'Vorlage',
            reviewer: 'Rezensent',
            reviewer_required: 'Für [[TOK_1]] Fragebögen muss ein Gutachter zugewiesen werden (Aufgabentrennung).',
            select_option: 'Wählen Sie eine Option',
            multi_choice_hint: 'Wählen Sie alles aus, was zutrifft',
            category_initial_onboarding: 'Erstes Onboarding',
            category_annual_review: 'Jahresrückblick',
            category_incident_triggered: 'Durch einen Vorfall ausgelöst',
            category_contract_renewal: 'Vertragsverlängerung',
            template_editor: {
                page_title: 'Fragebogenvorlage bearbeiten',
                preview_page_title: 'Vorschau der Fragebogenvorlage',
                edit_structure: 'Struktur bearbeiten',
                preview: 'Vorschau',
                actions: 'Aktionen',
                back_to_list: 'Zurück zu den Vorlagen',
                load_error: 'Vorlage konnte nicht geladen werden',
                save_error: 'Die Vorlagenstruktur konnte nicht gespeichert werden',
                saved: 'Vorlagenstruktur gespeichert.',
                sections_heading: 'Abschnitte',
                questions_heading: 'Fragen',
                add_section: 'Abschnitt hinzufügen',
                edit_section: 'Abschnitt bearbeiten',
                delete_section: 'Abschnitt löschen',
                move_section_up: 'Abschnitt nach oben verschieben',
                move_section_down: 'Abschnitt nach unten verschieben',
                confirm_delete_section: 'Abschnitt „[[TOK_1]]“ löschen? Alle seine Fragen werden entfernt.',
                section_title: 'Abschnittstitel',
                section_description: 'Abschnittsbeschreibung',
                section_id: 'Abschnitts-ID',
                section_id_hint: 'Wird automatisch generiert, es sei denn, Sie legen eine explizit fest.',
                no_sections: 'Noch keine Abschnitte. Fügen Sie zunächst einen Abschnitt hinzu.',
                no_questions: 'In diesem Abschnitt gibt es noch keine Fragen.',
                add_question: 'Frage hinzufügen',
                edit_question: 'Frage bearbeiten',
                delete_question: 'Frage löschen',
                move_question_up: 'Frage nach oben verschieben',
                move_question_down: 'Frage nach unten verschieben',
                confirm_delete_question: 'Frage „[[TOK_1]]“ löschen?',
                question_text: 'Fragetext',
                question_type: 'Fragetyp',
                question_id: 'Frage-ID',
                evidence_required: 'Nachweis erforderlich',
                risk_weight: 'Risikogewicht',
                scoring_map: 'Wertungskarte',
                scoring_map_json_hint: '[[TOK_0]] Objekt, das Antwortwerte numerischen Bewertungen zuordnet.',
                scoring_map_invalid_json: 'Die Wertungskarte muss gültig sein [[TOK_0]].',
                options_heading: 'Antwortmöglichkeiten',
                add_option: 'Option hinzufügen',
                remove_option: 'Option entfernen',
                option_label: 'Etikett',
                option_value: 'Wert',
                option_risk_weight: 'Risikogewicht',
                min_options_error: 'Auswahlfragen müssen mindestens zwei Optionen haben.',
                option_label_required: 'Jede Option benötigt eine Beschriftung.',
                option_value_required: 'Jede Option benötigt einen Wert.',
                option_value_unique: 'Optionswerte müssen eindeutig sein.',
                branching_rules_heading: 'Verzweigungsregeln',
                branching_rules_hint: 'Diese Frage basierend auf der Antwort auf eine frühere Frage ein- oder ausblenden.',
                add_branching_rule: 'Verzweigungsregel hinzufügen',
                remove_branching_rule: 'Verzweigungsregel entfernen',
                branching_condition_question: 'Wenn Frage',
                branching_condition_value: 'hat Wert',
                branching_action: 'dann',
                branching_action_show: 'zeige diese Frage',
                branching_action_hide: 'verstecke diese Frage',
                branching_select_condition_question: 'Wählen Sie eine frühere Frage aus',
                branching_select_condition_value: 'Wert auswählen',
                save: 'Struktur speichern',
                saving: 'Sparen...',
                cancel: 'Abbrechen',
                close: 'Schließen',
                question_text_required: 'Fragetext ist erforderlich.',
                section_title_required: 'Abschnittstitel ist erforderlich.',
                type_single_choice: 'Einzelauswahl',
                type_multi_choice: 'Mehrfachauswahl',
                type_free_text: 'Freitext',
                type_numeric: 'Numerisch',
                type_date: 'Datum',
                type_file_upload: 'Datei-Upload',
                type_yes_no: 'Ja/Nein',
                preview_heading: 'Vorlagenvorschau',
                preview_subtitle: 'Schreibgeschützte Vorschau, wie der Fragebogen einem Anbieter angezeigt wird.',
                preview_no_content: 'Diese Vorlage enthält noch keine Abschnitte oder Fragen.',
                preview_branching_notice: 'Verzweigungsregeln werden beim Ausfüllen ausgewertet; Die Vorschau zeigt jede Frage.',
            },
            review_modal: {
                title: 'Überprüfen Sie die Antworten auf den Fragebogen',
                open_cta: 'Rezension',
                loading: 'Fragebogen wird geladen...',
                template_missing: 'Vorlage nicht gefunden.',
                load_error: 'Der Fragebogen konnte nicht zur Überprüfung geladen werden.',
                annotation_heading: 'Anmerkungen',
                annotation_placeholder: 'Fügen Sie eine Anmerkung eines Rezensenten zu dieser Frage hinzu...',
                annotation_status_label: 'Anmerkungsstatus',
                annotation_status_acceptable: 'Akzeptabel',
                annotation_status_concern: 'Sorge',
                annotation_status_requires_action: 'Erfordert Maßnahmen',
                review_comments_label: 'Gesamtbewertungskommentare',
                review_comments_placeholder: 'Fassen Sie Ihre Bewertungsergebnisse zusammen...',
                justification_label: 'Entscheidungsbegründung',
                justification_placeholder: 'Erläutern Sie die Gründe für Ihre Entscheidung ...',
                reject_requires_comments: 'Für die Ablehnung eines Fragebogens sind Überprüfungskommentare erforderlich.',
                decision_heading: 'Entscheidung',
                decision: {
                    approved: 'Genehmigen',
                    rejected: 'Ablehnen',
                    additional_info_requested: 'Fordern Sie zusätzliche Informationen an',
                },
                submit: 'Bewertung abgeben',
                submitting: 'Bewertung wird eingereicht...',
                cancel: 'Abbrechen',
                submit_success: 'Bewertung eingereicht.',
                submit_error: 'Bewertung konnte nicht eingereicht werden.',
                separation_of_duties_error: 'Sie können einen Fragebogen, mit dessen Ausfüllen Sie beauftragt wurden, nicht überprüfen. Die Aufgabentrennung erfordert einen anderen Gutachter.',
                decision_required: 'Bitte wählen Sie eine Bewertungsentscheidung aus.',
                announce_opened: 'Bewertungsmodalität geöffnet.',
                announce_submitted: 'Bewertung eingereicht.',
            },
            instance_detail: {
                submitted_at: 'Eingereicht',
                reviewed_at: 'Bewertet',
                reviewer: 'Rezensent',
                review_decision: 'Entscheidung',
                review_comments: 'Überprüfen Sie Kommentare',
                decision_approved: 'Genehmigt',
                decision_rejected: 'Abgelehnt',
                decision_additional_info_requested: 'Weitere Informationen erbeten',
                decision_pending: 'Ausstehende Überprüfung',
                expand_comments: 'Vollständige Kommentare anzeigen',
                collapse_comments: 'Vollständige Kommentare ausblenden',
                no_reviewer: 'Kein Prüfer zugewiesen',
            },
            export: {
                portfolio_label: 'Exportportfolio',
                instance_label: 'Exportieren',
                portfolio_success: 'Portfolio-Export bereit.',
                instance_success: 'Fragebogenexport bereit.',
                portfolio_error: 'Der Export des Fragebogenportfolios ist fehlgeschlagen.',
                instance_error: 'Der Fragebogen konnte nicht exportiert werden.',
            },
            branching: {
                hidden_notice: 'Einige Fragen werden durch Verzweigungsregeln ausgeblendet.',
                cycle_warning: 'In den Verzweigungsregeln wurde ein Zyklus erkannt. Betroffene Fragen sind standardmäßig sichtbar.',
            },
        },
        contracts: {
            title: 'Verträge',
            page_title: 'Lieferantenverträge',
            new: 'Neu Vertrag',
            vendor_id: 'Anbieter ID',
            filter_contracts: 'Verträge filtern',
            filter_by_document_type: 'Filtern Sie nach Dokumenttyp',
            filter_by_status: 'Filtern Sie nach Vertragsstatus',
            per_page: 'Verträge pro Seite',
            expired_notice: 'Dieser Vertrag ist abgelaufen',
            document_type: 'Dokument Typ',
            expiry_date: 'Ablauf Datum',
            no_contracts: 'Keine Verträge gefunden.',
            all_document_types: 'Alle Dokument Typen',
            load_error: 'Fehler beim load Verträge',
            create_error: 'Fehler beim create Vertrag',
            delete_error: 'Fehler beim delete Vertrag',
            update_error: 'Fehler beim update Status',
            confirm_delete: 'Löschen Vertrag "{title}"?',
            renewal_date: 'Erneuerung Datum',
            effective_date: 'Gültig Datum',
            parties: 'Parteien',
            summary: 'Zusammenfassung',
            n_contracts: '{count} Verträge',
            n_contract: '{count} Vertrag',
            contracts_loaded: '{count} Verträge geladen',
            doc_type_dpa: 'DPA',
            doc_type_security_addendum: 'Sicherheitsnachtrag',
            doc_type_scc_annex: 'SCC-Anhang',
            doc_type_sub_processor_list: 'Unterauftragnehmer-Liste',
            doc_type_bcr: 'BCR',
            doc_type_nda: 'NDA',
            doc_type_msa: 'MSA',
            doc_type_sla: 'SLA',
            doc_type_other: 'Sonstiges',
            status_draft: 'Entwurf',
            status_under_negotiation: 'In Verhandlung',
            status_pending_signature: 'Unterschrift ausstehend',
            status_active: 'Aktiv',
            status_expired: 'Abgelaufen',
            status_terminated: 'Beendet',
            status_superseded: 'Ersetzt',
        },
        gates: {
            title: 'Genehmigungstore',
            page_title: 'Gate-Bewertungen',
            new: 'Neu Gate Evaluation',
            vendor_id: 'Anbieter ID',
            gate_name: 'Gate-Name',
            outcome: 'Ergebnis',
            evaluator: 'Bewerter',
            no_gates: 'Keine Gate Bewertungen gefunden.',
            load_error: 'Fehler beim load Gate Bewertungen',
            evaluate_error: 'Fehler beim evaluate Anbieter Gate',
            detail_error: 'Fehler beim fetch Bewertung Detail',
            override_error: 'Fehler beim override Gate Bewertung',
            criteria_results: 'Kriterien Ergebnisse',
            evaluate_form: 'Bewerten Sie das Lieferantentor',
            per_page: 'Bewertungen pro Seite',
            passed: 'Bestanden',
            failed: 'Fehlgeschlagen',
            override: 'Überschreiben',
            override_justification: 'Überschreiben Begründung',
            override_placeholder: 'Eingeben Begründung für overriding dieses Gate Bewertung',
            approval_id: 'Genehmigung ID',
            overall_passed: 'Bestanden',
            overall_failed: 'Nicht bestanden',
            overall_overridden: 'Überschrieben',
            evaluations_loaded: '{count} Gate-Bewertungen geladen',
            create_approval_cta: 'Genehmigung erstellen',
        },
        reviews: {
            title: 'Lieferantenbewertungen',
            page_title: 'Anbieterbewertungen',
            new: 'Neu Überprüfen',
            vendor_id: 'Anbieter ID',
            filter_by_outcome: 'Filtern Sie nach Bewertungsergebnis',
            per_page: 'Bewertungen pro Seite',
            kpi_summary: 'Überprüfen Sie die Zusammenfassung von [[TOK_0]].',
            review_outcome_label: 'Überprüfen Sie das Ergebnis',
            edit_outcome: 'Überprüfungsergebnis bearbeiten',
            reviews_loaded: '[[TOK_1]] Anbieterbewertungen geladen',
            reviewer: 'Prüfer',
            review_type: 'Überprüfen Typ',
            outcome: 'Ergebnis',
            findings: 'Ergebnisse',
            no_reviews: 'Keine Anbieter Überprüfungen gefunden.',
            load_kpis_error: 'Fehler beim fetch Anbieter Überprüfung KPIs',
            load_error: 'Fehler beim fetch Anbieter Überprüfungen',
            update_error: 'Lieferantenbewertung konnte nicht aktualisiert werden',
            create_error: 'Fehler beim create Anbieter Überprüfung',
            total_reviewed: 'Gesamt Anbieter Überprüft',
            total_reviews: 'Gesamt Überprüfungen',
            satisfactory: 'Zufriedenstellend',
            concerns_identified: 'Bedenken Identified',
            remediation_required: 'Behebung Erforderlich',
            escalated: 'Eskaliert',
            program_id: 'Programm ID',
            period_id: 'Zeitraum ID',
            task_id: 'Aufgabe ID',
            recommendations: 'Empfehlungen',
        },
        risk_signals: {
            title: 'Risikosignale',
            page_title: 'Risikosignale',
            new_signal: 'Neues Risikosignal',
            signal_type: 'Signaltyp',
            severity: 'Schweregrad',
            description: 'Beschreibung',
            source: 'Quelle',
            vendor_id: 'Anbieter-ID',
            certification_expiry: 'Zertifizierungsablauf',
            breach_notification: 'Verstoßmeldung',
            financial_instability: 'Finanzielle Instabilität',
            compliance_change: 'Compliance-Änderung',
            custom: 'Benutzerdefiniert',
            active: 'Aktiv',
            acknowledged: 'Bestätigt',
            resolved: 'Gelöst',
            no_signals: 'Keine Risikosignale gefunden',
            source_external_feed: 'Externer Feed',
            source_manual: 'Manuell',
            source_integration: 'Integration',
            source_regulatory: 'Regulatorisch',
            source_media: 'Medien',
            trigger_reassessment_prompt: 'Dies ist ein Signal mit hoher Schwere. Möchten Sie eine Neubewertung des Anbieters starten?',
            reassessment_triggered: 'Neubewertung gestartet.',
            reassessment_trigger_error: 'Neubewertung konnte nicht gestartet werden.',
        },
        reassessments: {
            title: 'Neubewertungsaufgaben',
            page_title: 'Neubewertungsaufgaben',
            trigger: 'Neubewertung auslösen',
            trigger_success: 'Neubewertung erfolgreich ausgelöst',
            reason: 'Grund',
            deadline: 'Frist',
            assigned_to: 'Zugewiesen an',
            vendor_id: 'Anbieter-ID',
            outcome: 'Ergebnis',
            new_risk_level: 'Neues Risikoniveau',
            complete: 'Neubewertung abschließen',
            complete_success: 'Neubewertung erfolgreich abgeschlossen',
            pending: 'Ausstehend',
            in_progress: 'In Bearbeitung',
            completed: 'Abgeschlossen',
            cancelled: 'Abgebrochen',
            no_tasks: 'Keine Neubewertungsaufgaben gefunden',
            risk_trend: 'Risikotrend',
            notes: 'Notizen',
        },
        portfolio: {
            title: 'Risikoportfolio',
            page_title: 'Risikoportfolio',
            dashboard: 'Portfolioübersicht',
            vendor_id: 'Anbieter-ID',
            total_vendors: 'Gesamtzahl Lieferanten',
            average_score: 'Durchschnittliche Risikobewertung',
            high_risk_count: 'Hochrisiko-Lieferanten',
            trend_direction: 'Trendrichtung',
            improved: 'Verbessert',
            stable: 'Stabil',
            degraded: 'Verschlechtert',
            vendor_trend: 'Lieferantentrend',
            outstanding_questionnaires: 'Ausstehende Fragebögen',
            overdue_assessments: 'Überfällige Bewertungen',
            no_outstanding: 'Keine ausstehenden Fragebögen',
            no_overdue: 'Keine überfälligen Bewertungen',
            due_date: 'Fälligkeitsdatum',
        },
        risk_acceptance: {
            title: 'Risikoakzeptanzregister',
            page_title: 'Risikoakzeptanzregister',
            new_acceptance: 'Neue Risikoakzeptanz',
            vendor_id: 'Anbieter-ID',
            risk_level: 'Risikoniveau',
            conditions: 'Bedingungen',
            justification: 'Begründung',
            expiry_date: 'Ablaufdatum',
            create_success: 'Risikoakzeptanz erfolgreich erstellt',
            review_condition: 'Bedingung prüfen',
            condition_met: 'Bedingung erfüllt',
            condition_not_met: 'Bedingung nicht erfüllt',
            review_success: 'Bedingung erfolgreich geprüft',
            export_register: 'Register exportieren',
            active: 'Aktiv',
            expired: 'Abgelaufen',
            revoked: 'Widerrufen',
            no_acceptances: 'Keine Risikoakzeptanzen gefunden',
            met_count: '[[TOK_2]]/[[TOK_3]] erfüllt',
        },
        review_routing: {
            title: 'Prüfungsweiterleitung',
            page_title: 'Überprüfen Sie die Weiterleitung',
            route_to_reviewers: 'An Prüfer weiterleiten',
            route_success: 'Erfolgreich an Prüfer weitergeleitet',
            vendor_id: 'Anbieter-ID',
            reviewer_id: 'Prüfer-ID',
            reviewer_role: 'Prüferrolle',
            questionnaire_id: 'Fragebogen-ID',
            review_status: 'Prüfungsstatus',
            reviewers_label: 'Gutachter (user_id, Rolle pro Zeile)',
            pending: 'Ausstehend',
            in_review: 'In Prüfung',
            completed: 'Abgeschlossen',
            no_routing: 'Keine Prüfungsweiterleitung gefunden',
            primary_reviewer: 'Hauptprüfer',
            secondary_reviewer: 'Zweitprüfer',
            approver: 'Genehmiger',
        },
        onboarding: {
            title: 'Lieferanten-Onboarding-Fälle',
            page_title: 'Lieferanten-Onboarding-Fälle',
            new_case: 'Neuer Onboarding-Fall',
            case_detail: 'Onboarding-Fall',
            open_mps_dossier_filing: 'MPS-Einreichung öffnen',
            dossier_filing_description: 'Erstellt eine neue MPS-Einreichung, vorbefüllt aus diesem Onboarding-Fall. Die Einreichung wird im Fall verlinkt.',
            dossier_filing_dpia_id: 'DPIA-ID',
            dossier_filing_dpia_id_placeholder: 'z. B. dpia_01TEST000000000000000001',
            dossier_filing_title: 'Titel der Einreichung',
            dossier_filing_form_type: 'Formulartyp',
            dossier_filing_submit: 'Einreichung erstellen',
            dossier_filing_validation_error: 'DPIA-ID und Titel sind erforderlich.',
            dossier_filing_created: 'MPS-Einreichung erstellt',
            dossier_filing_error: 'MPS-Einreichung konnte nicht erstellt werden.',
            linked_questionnaire_due_date: 'Fälligkeitsdatum',
            linked_questionnaire_assignee: 'Zugewiesen an',
            linked_questionnaire_submitted_at: 'Eingereicht am',
            score_last_scored: 'Zuletzt bewertet',
            score_dimensions: 'Dimensionen',
            linked_contract_document_type: 'Dokumenttyp',
            linked_contract_effective_date: 'Wirksamkeitsdatum',
            linked_contract_expiry_date: 'Ablaufdatum',
            linked_sub_processor_countries: 'Verarbeitungsländer',
            linked_sub_processor_last_assessment: 'Letzte Bewertung',
            linked_sub_processor_next_assessment: 'Nächste Bewertung',
            case_id: 'Fall-ID',
            vendor: 'Lieferant',
            case_type: 'Falltyp',
            service_description: 'Dienstleistungsbeschreibung',
            data_categories: 'Datenkategorien',
            systems_accessed: 'Zugegriffene Systeme',
            jurisdiction: 'Rechtsordnung',
            hosting_model: 'Hosting-Modell',
            controller_role: 'Verantwortlicher/Auftragsverarbeiter-Rolle',
            status_pipeline: 'Status-Pipeline',
            tabs_label: 'Onboarding-Fallabschnitte',
            per_page: 'Fälle pro Seite',
            filter_cases: 'Onboarding-Fälle filtern',
            cases_count: 'Fälle',
            cases_loaded: 'Onboarding-Fälle geladen',
            no_cases: 'Keine Onboarding-Fälle gefunden.',
            vendor_lookup_placeholder: 'Lieferanten-ID eingeben',
            data_categories_placeholder: 'z.B. personenbezogene Daten, Finanzen, Gesundheit',
            systems_placeholder: 'z.B. CRM, ERP, HR-System',
            status_open: 'Offen',
            status_in_progress: 'In Bearbeitung',
            status_awaiting_approval: 'Warten auf Genehmigung',
            status_approved: 'Genehmigt',
            status_remediation_required: 'Behebung erforderlich',
            status_closed: 'Geschlossen',
            type_new_vendor: 'Neuer Lieferant',
            type_service_change: 'Dienstleistungsänderung',
            type_renewal: 'Verlängerung',
            type_reassessment: 'Neubewertung',
            tab_overview: 'Übersicht',
            tab_due_diligence: 'Sorgfaltsprüfung',
            tab_security_assessment: 'Sicherheitsbewertung',
            tab_contractual_controls: 'Vertragliche Kontrollen',
            tab_sub_processors: 'Unterauftragsverarbeiter',
            tab_approval_gates: 'Genehmigungstore',
            tab_evidence: 'Nachweise',
            tab_placeholder: 'Der Inhalt dieses Abschnitts wird während des Onboarding-Prozesses ausgefüllt.',
            completion_not_started: 'Nicht begonnen',
            completion_in_progress: 'In Bearbeitung',
            completion_completed: 'Abgeschlossen',
            completion_requiring_attention: 'Aufmerksamkeit erforderlich',
            gate_name: 'Tor-Name',
            approver: 'Genehmiger',
            decision: 'Entscheidung',
            comments: 'Kommentare',
            decide: 'Entscheidung treffen',
            decision_approved: 'Genehmigt',
            decision_rejected: 'Abgelehnt',
            decision_deferred: 'Zurückgestellt',
            no_approvals: 'Keine Genehmigungstore für diesen Fall konfiguriert.',
            approval_success: 'Genehmigungsentscheidung erfolgreich erfasst',
            approval_error: 'Genehmigungsentscheidung konnte nicht erfasst werden',
            transition_status: 'Status wechseln',
            confirm_transition: 'Fall von "{from}" nach "{to}" wechseln?',
            transition_success: 'Fallstatus erfolgreich gewechselt',
            transition_error: 'Fallstatus konnte nicht gewechselt werden',
            create_success: 'Onboarding-Fall erfolgreich erstellt',
            create_error: 'Onboarding-Fall konnte nicht erstellt werden',
            load_error: 'Onboarding-Fälle konnten nicht geladen werden',
            detail_error: 'Falldetails konnten nicht geladen werden',
            export: 'Exportieren',
            export_error: 'Onboarding-Fall konnte nicht exportiert werden',
            evidence_tab_description: 'Nachweise für den Onboarding-Fall hochladen und exportieren.',
            upload_evidence_label: 'Nachweis hochladen',
            attached_evidence_heading: 'Angehängte Nachweise',
            no_evidence_attached: 'Noch keine Nachweise angehängt.',
            export_bundle_button: 'Nachweispaket exportieren',
            load_attachments_error: 'Nachweise konnten nicht geladen werden.',
            linked_questionnaires_heading: 'Verknüpfte Fragebögen',
            no_linked_questionnaires: 'Keine verknüpften Fragebögen.',
            linked_scores_heading: 'Verknüpfte Bewertungen',
            no_linked_scores: 'Keine verknüpften Bewertungen.',
            latest_score_label: 'Neueste Bewertung',
            linked_contracts_heading: 'Verknüpfte Verträge',
            no_linked_contracts: 'Keine verknüpften Verträge.',
            linked_sub_processors_heading: 'Verknüpfte Unterauftragsverarbeiter',
            no_linked_sub_processors: 'Keine verknüpften Unterauftragsverarbeiter.',
        },
        sub_processors: {
            title: 'Register der Unterauftragsverarbeiter',
            page_title: 'Register der Unterauftragsverarbeiter',
            new_record: 'Neuer Unterauftragsverarbeiter',
            edit_record: 'Unterauftragsverarbeiter bearbeiten',
            onboarding_case: 'Onboarding-Fall',
            services: 'Erbrachte Dienstleistungen',
            data_categories: 'Datenkategorien',
            processing_countries: 'Verarbeitungsländer',
            dpa_chain_status: 'DPA-Kettenstatus',
            certifications: 'Zertifizierungen',
            last_assessment: 'Letzte Bewertung',
            next_assessment: 'Nächste Bewertung',
            change_history: 'Änderungshistorie',
            history: 'Verlauf',
            changed_by: 'Geändert von',
            comma_separated: 'Kommagetrennte Werte',
            filter_records: 'Einträge filtern',
            filter_by_dpa: 'Nach DPA-Kettenstatus filtern',
            all_dpa_statuses: 'Alle DPA-Status',
            per_page: 'Einträge pro Seite',
            records_count: 'Unterauftragsverarbeiter',
            records_loaded: 'Einträge geladen',
            no_records: 'Keine Unterauftragsverarbeiter gefunden.',
            no_history: 'Keine Änderungshistorie verfügbar.',
            dpa_active: 'Aktiv',
            dpa_pending: 'Ausstehend',
            dpa_expired: 'Abgelaufen',
            dpa_not_required: 'Nicht erforderlich',
            create_success: 'Unterauftragsverarbeiter erfolgreich erstellt',
            create_error: 'Konnte nicht erstellt werden',
            update_success: 'Unterauftragsverarbeiter erfolgreich aktualisiert',
            update_error: 'Konnte nicht aktualisiert werden',
            load_error: 'Register konnte nicht geladen werden',
            history_error: 'Änderungshistorie konnte nicht geladen werden',
            export_csv: 'CSV exportieren',
            export_json: 'JSON exportieren',
            export_error: 'Daten konnten nicht exportiert werden',
        },
    },
    deletion_orchestration: {
        nav: {
            dashboard: 'Orchestrierungsübersicht',
            runs: 'Orchestrierungsläufe',
            tasks: 'Ausführungsaufgaben',
            templates: 'Checklistenvorlagen',
            vendor_requests: 'Lieferantenanfragen',
            proof_chain: 'Nachweiskette',
            dsr_integration: 'DSR-Integration',
            vendor_verification: 'Lieferantenverifizierung',
            completeness: 'Vollständigkeitsübersicht',
        },
        dashboard: {
            title: 'Orchestrierungsübersicht',
            loading: 'Lade Dashboard Daten...',
            active_runs: 'Aktiv Runs',
            completion_rate: 'Fertigstellung Rate',
            avg_completion_time: 'Avg Fertigstellung Zeit',
            overdue_tasks: 'Überfällig Aufgaben',
            vendor_compliance: 'Anbieter Konformität',
            recent_runs: 'Kürzliche Runs',
            no_recent_runs: 'Keine kürzlichen Orchestrierungsdurchläufe.',
            run_id: 'Ausführen ID',
            ticket_id: 'Ticket-ID',
            progress: 'Fortschritt',
            systems: 'Systeme',
            vendors: 'Anbieter',
            load_error: 'Das Orchestrierungs-Dashboard konnte nicht geladen werden. Bitte versuchen Sie es erneut.',
            aria_table: 'Aktuelle Orchestrierungsläufe',
        },
        runs: {
            title: 'Orchestrierungsläufe',
            new: 'Neu Ausführen',
            run_id: 'Ausführen ID',
            ticket_id: 'Ticket-ID',
            progress: 'Fortschritt',
            systems: 'Systeme',
            vendors: 'Anbieter',
            data_subject_ref: 'Daten Betreff Ref',
            data_categories: 'Daten Kategorien',
            enable_proof_chain: 'Aktivieren Nachweis Kette',
            start: 'Starten',
            started: 'Lauf gestartet',
            mark_ready: 'Als „Bereit“ markieren',
            marked_ready: 'Lauf als bereit markiert',
            complete: 'Komplett',
            complete_exceptions: 'Vollständig mit Ausnahmen',
            pause: 'Pause',
            resume: 'Lebenslauf',
            cancel: 'Abbrechen',
            no_runs: 'Keine orchestration runs gefunden.',
            load_error: 'Orchestrierungsläufe konnten nicht geladen werden. Bitte versuchen Sie es erneut.',
            create_error: 'Orchestrierungslauf konnte nicht erstellt werden',
            aria_filter_status: 'Filtern Sie nach Ausführungsstatus',
            aria_table: 'Orchestrierungsläufe',
            placeholder_ticket_id: 'z. B. TKT-000123',
            placeholder_data_subject_ref: 'z. B. DS-REF-001',
            placeholder_data_categories: 'z. B. personal_data, Finanzen, Gesundheit',
            title_label: 'Title',
            run_type: 'Run Type',
            run_type_labels: {
                data_subject_request: 'Data Subject Request',
                retention_expiry: 'Retention Expiry',
                manual: 'Manual',
                scheduled: 'Scheduled',
            },
            field_guidelines: {
                title: 'A descriptive name for this orchestration run.',
                run_type: 'The origin or trigger for the deletion process.',
                ticket_id: 'The associated ticket ID from your DSR or support system.',
                data_subject_ref: 'A unique identifier for the data subject (e.g., internal ID, email hash).',
                data_categories: 'Specific categories of personal data to be deleted (comma-separated).',
                proof_enabled: 'Maintains an immutable cryptographic chain of evidence for this run.',
            },
            actions: 'Actions',
            progress_guideline: 'Calculated based on completed system tasks and vendor requests.',
            placeholder_title: 'e.g., Q2 2026 Customer Deletion Batch',
        },
        tasks: {
            title: 'Ausführungsaufgaben',
            task_id: 'Aufgabe ID',
            run_id: 'Ausführen ID',
            system_name: 'Systemname',
            assigned_to: 'Zugewiesen Zu',
            sla_deadline: 'SLA Frist',
            progress: 'Fortschritt',
            enter_run_id: 'Eingeben Ausführen ID zu filter...',
            select_run: 'Wählen Sie einen Lauf aus, um Aufgaben anzuzeigen',
            unassigned: 'Nicht zugewiesen',
            overdue: 'Überfällig',
            assign_task: 'Zuweisen Aufgabe',
            assignee_id: 'Zugewiesener ID',
            update_status: 'Aktualisieren Status',
            new_status: 'Neu Status',
            no_transitions: 'Diese Aufgabe befindet sich in einem Endzustand und kann nicht geändert werden.',
            select_status_placeholder: 'Neuen Status auswählen',
            skip_justification: 'Begründung für Überspringen',
            failure_reason: 'Fehlergrund',
            no_tasks: 'Keine execution Aufgaben gefunden.',
            new_task: 'Neue Aufgabe',
            system_id: 'System-ID',
            data_classification: 'Datenklassifizierung',
            load_error: 'execution tasks konnten nicht geladen werden. Bitte versuchen Sie es erneut.',
            assign_error: 'Fehler beim assign task',
            status_error: 'Fehler beim Aktualisieren des Aufgabenstatus',
            no_tasks_for_run: 'Dieser Löschvorgang hat noch keine Ausführungsaufgaben.',
            aria_filter_run_id: 'Nach Lauf-ID filtern',
            aria_filter_status: 'Filtern Sie nach Aufgabenstatus',
            aria_table: 'Ausführungsaufgaben',
            view_steps: 'Schritte anzeigen',
            steps_modal_title: 'Ausführungsschritte',
            step_title: 'Schritt',
            step_status: 'Schrittstatus',
            step_notes: 'Notizen',
            step_evidence: 'Nachweisdateien',
            step_evidence_required: 'Für diesen Schritt ist ein Nachweis erforderlich',
            step_evidence_missing: 'Noch keine Nachweise hochgeladen',
            step_save: 'Schritt speichern',
            step_saved: 'Schritt aktualisiert',
            step_save_error: 'Schritt konnte nicht aktualisiert werden',
            create_success: 'Ausführungsaufgabe erstellt',
            create_error: 'Ausführungsaufgabe konnte nicht erstellt werden',
            step_upload_label: 'Nachweis anhängen',
        },
        templates: {
            title: 'Checklistenvorlagen',
            new: 'Neu Vorlage',
            template_id: 'Vorlage ID',
            system_type: 'System Typ',
            est_duration: 'Est. Dauer',
            steps: 'Schritte',
            action_type: 'Aktion Typ',
            instructions: 'Anweisungen',
            mandatory: 'Obligatorisch',
            add_step: 'Hinzufügen Schritt',
            step_n: 'Schritt',
            no_templates: 'Keine checklist Vorlagen gefunden.',
            all_system_types: 'Alle System Typen',
            load_error: 'Checklistenvorlagen konnten nicht geladen werden. Bitte versuchen Sie es erneut.',
            create_error: 'Checklistenvorlage konnte nicht erstellt werden',
            aria_filter_system_type: 'Filtern Sie nach Systemtyp',
            aria_filter_status: 'Filtern Sie nach Vorlagenstatus',
            aria_table: 'Checklisten-Vorlagen',
            placeholder_name: 'z. B. Checkliste zum Löschen der Datenbank',
            guideline_name: 'Use a clear operating name, for example “Database Deletion Checklist”.',
            guideline_system_type: 'Choose the system category this checklist will usually run against.',
            guideline_status: 'Draft templates can be reviewed before activation; active templates can be reused in runs.',
            guideline_description: 'Summarise scope, retention context, and when teams should select this template.',
            update_success: 'Vorlage erfolgreich aktualisiert',
            create_success_msg: 'Vorlage erfolgreich erstellt',
            update_error: 'Fehler beim Aktualisieren der Vorlage',
            activate_success: 'Vorlage erfolgreich aktiviert',
            activate_error: 'Fehler beim Aktivieren der Vorlage',
            archive_success: 'Vorlage erfolgreich archiviert',
            archive_error: 'Fehler beim Archivieren der Vorlage',
            clone_success: 'Vorlage erfolgreich geklont',
            clone_error: 'Fehler beim Klonen der Vorlage',
        },
        vendor_requests: {
            title: 'Anbieter Deletion Anfragen',
            new: 'Neu Anfrage',
            request_id: 'Anfrage ID',
            vendor_name: 'Anbieter Name',
            vendor_id: 'Anbieter ID',
            data_subject_ref: 'Daten Betreff Ref',
            data_categories: 'Daten Kategorien',
            legal_basis: 'Rechtlich Grundlage',
            sla_days: 'SLA Tage',
            requested_completion: 'Angefordert Fertigstellung',
            communications: 'Kommunikationen',
            total_requests: 'Gesamt Anfragen',
            no_requests: 'Keine Anbieter Löschung requests gefunden.',
            filter_vendor_id: 'Filtern nach Anbieter ID...',
            change_status: 'Status Ändern',
            new_status: 'Neuer Status',
            actions: 'Aktionen',
            load_error: 'Die Löschanfragen des Anbieters konnten nicht geladen werden. Bitte versuchen Sie es erneut.',
            create_error: 'Die Anforderung zum Löschen des Anbieters konnte nicht erstellt werden',
            dashboard_error: 'Das Dashboard zum Löschen des Anbieters konnte nicht geladen werden. Bitte versuchen Sie es erneut.',
            aria_filter_status: 'Filtern Sie nach Anforderungsstatus',
            aria_filter_vendor_id: 'Filtern Sie nach Anbieter-ID',
            aria_table: 'Löschungsanfragen des Anbieters',
            placeholder_vendor_id: 'z. B. VND-001',
            placeholder_vendor_name: 'z. B. Acme Analytics',
            placeholder_data_subject_ref: 'z. B. DS-REF-001',
            placeholder_data_categories: 'z. B. personal_data, Analytik',
            placeholder_legal_basis: 'z. B. [[TOK_0]] Artikel 19',
        },
        proof_chain: {
            title: 'Nachweis Kette Betrachter',
            enter_run_id: 'Eingeben Ausführen ID...',
            load_chain: 'Laden Kette',
            verify_chain: 'Verifizieren Kette',
            verifying: 'Verifiziere...',
            chain_valid: 'Kette is valid',
            chain_invalid: 'Kette is broken',
            chain_length: 'Kette Length',
            broken_at_index: 'Unterbrochen bei index',
            no_proof_records: 'Keine Nachweis Datensätze gefunden für dieses Durchlauf..',
            proof_id: 'Nachweis ID',
            entity_type: 'Entität Typ',
            entity_id: 'Entität ID',
            event_hash: 'Ereignis Hash',
            previous_hash: 'Vorherig Hash',
            attestation: 'Attestierung',
            attestation_actor: 'Durchgeführt von',
            attestation_signed_at: 'Signiert am',
            attestation_signature: 'Signatur',
            attestation_evidence_refs: 'Nachweisverweise',
            run_field_label: 'Löschvorgang',
            select_run: 'Löschvorgang auswählen…',
            aria_select_run: 'Löschvorgang für die Nachweiskettensuche',
            chain_broken_here: 'Kette broken here',
            load_error: 'Die Prüfkette konnte nicht geladen werden. Bitte versuchen Sie es erneut.',
            verify_error: 'Die Beweiskette konnte nicht überprüft werden. Bitte versuchen Sie es erneut.',
            aria_run_id: 'Führen Sie die ID für die Proof-Chain-Suche aus',
        },
        dsr_integration: {
            change_status: 'Status ändern',
            request_type: 'Anfragetyp',
            data_subject_hint: 'Kennung der betroffenen Person, deren Daten gelöscht werden (z. B. E-Mail oder Kunden-ID). Entspricht in der Regel dem Antragsteller des ausgewählten DSR-Falls.',
            title: 'DSR-Löschungsintegration',
            create_run: 'DSR-Löschungslauf erstellen',
            dsr_case_id: 'DSR-Fall-ID',
            data_subject_id: 'Betroffenen-ID',
            systems: 'Zielsysteme',
            route_to_department: 'An Abteilung weiterleiten',
            confirm_deletion: 'Löschung bestätigen',
            no_runs: 'Keine DSR-Löschungsläufe gefunden',
            status: 'Löschungsstatus',
            deadline: 'Frist',
        },
        vendor_verification: {
            title: 'Lieferantenlöschungsverifizierung',
            create_followup: 'Nachverfolgung erstellen',
            deadline: 'Bestätigungsfrist',
            escalation_contact: 'Eskalationskontakt',
            record_confirmation: 'Bestätigung erfassen',
            overdue: 'Überfällige Löschungen',
            escalate: 'Eskalieren',
            confirm_escalation: 'Sind Sie sicher, dass Sie diese Löschungsanfrage an den Anbieter eskalieren möchten?',
            no_followups: 'Keine Lieferantennachverfolgungen gefunden',
            no_overdue: 'Keine überfälligen Lieferantenlöschungen',
            vendor_request: 'Lieferantenanfrage',
            vendor: 'Lieferant',
            unknown_vendor: 'Unbekannter Lieferant',
            overdue_badge: 'Überfällig',
            mark_confirmed: 'Als bestätigt markieren',
            mark_confirmed_for: 'Löschung als bestätigt markieren für {vendor}',
            confirm_confirmation: 'Diese Lieferantenlöschung als bestätigt markieren?',
            confirmation_success: 'Lieferantenlöschung bestätigt',
            confirmation_failed: 'Lieferantenlöschung konnte nicht bestätigt werden',
            select_request: 'Lieferantenanfrage auswählen…',
            escalation_contact_placeholder: 'z. B. dpo@vendor.example',
            create_success: 'Lieferantennachverfolgung erfolgreich erstellt',
            create_failed: 'Lieferantennachverfolgung konnte nicht erstellt werden',
            deadline_hint: 'Diese Seite listet nur Nachverfolgungen auf, deren Frist bereits abgelaufen ist.',
            deadline_future_warning: 'Diese Frist liegt in der Zukunft, daher erscheint die Nachverfolgung erst in der Liste der überfälligen Einträge, wenn das Datum überschritten ist.',
            escalation_success: 'Dienstleisterlöschung erfolgreich eskaliert',
            escalation_failed: 'Eskalation der Dienstleisterlöschung fehlgeschlagen',
        },
        completeness: {
            title: 'Löschungsvollständigkeit',
            check_conflicts: 'Aufbewahrungskonflikte prüfen',
            no_conflicts: 'Keine Aufbewahrungskonflikte gefunden',
            conflict_resolution: 'Konfliktlösung',
            extend_retention: 'Aufbewahrung verlängern',
            proceed_deletion: 'Mit Löschung fortfahren',
            escalate_conflict: 'Eskalieren',
            resolve: 'Konflikt lösen',
            data_subject_id: 'ID der betroffenen Person',
            placeholder_data_subject_id: 'Geben Sie die ID der betroffenen Person ein',
            data_subject_hint: 'Kennung der Person, deren Löschung Sie überprüfen (z. B. E-Mail, Kunden-ID oder DSR-Referenz). Wählen Sie eine bekannte Person oder geben Sie eine ein.',
            guidance: 'Geben Sie eine Datensubjekt-ID ein oder wählen Sie eine aus, wählen Sie optional Systeme und führen Sie die Prüfung aus, um Löschvollständigkeit und Aufbewahrungskonflikte anzuzeigen.',
            completion: 'Löschabschluss',
            pending_items: 'Ausstehende Elemente',
            system: 'System',
            policy: 'Richtlinie',
            retention_end: 'Aufbewahrungsende',
            completed_items: 'Abgeschlossene Elemente',
            last_review_label: 'Letzte Rezension',
            days_ago: 'vor Tagen',
            review_overdue: 'Überprüfungszyklus überschritten. Eine erneute Überprüfung ist erforderlich.',
        },
        run_status_labels: {
            pending: 'Ausstehend',
            planning: 'Planung',
            ready: 'Bereit',
            in_progress: 'In Bearbeitung',
            paused: 'Pausiert',
            completed: 'Abgeschlossen',
            completed_with_exceptions: 'Abgeschlossen mit Ausnahmen',
            cancelled: 'Abgebrochen',
        },
        task_status_labels: {
            pending: 'Ausstehend',
            assigned: 'Zugewiesen',
            in_progress: 'In Bearbeitung',
            awaiting_verification: 'Warte auf Verifizierung',
            verified: 'Verifiziert',
            failed: 'Fehlgeschlagen',
            skipped: 'Übersprungen',
        },
        system_type_labels: {
            database: 'Datenbank',
            saas_application: 'SaaS-Anwendung',
            file_storage: 'Dateispeicher',
            email_system: 'E-Mail-System',
            analytics_platform: 'Analyseplattform',
            backup_system: 'Backup-System',
            vendor_managed: 'Anbieterverwaltet',
            custom: 'Benutzerdefiniert',
        },
        template_status_labels: {
            draft: 'Entwurf',
            active: 'Aktiv',
        },
        action_type_labels: {
            manual_check: 'Manuelle Prüfung',
            api_call: 'API-Aufruf',
            sql_query: 'SQL-Abfrage',
            script_execution: 'Skriptausführung',
            file_deletion: 'Dateilöschung',
            verification: 'Verifizierung',
            notification: 'Benachrichtigung',
            approval: 'Genehmigung',
        },
        request_status_labels: {
            draft: 'Entwurf',
            sent: 'Gesendet',
            acknowledged: 'Bestätigt',
            in_progress: 'In Bearbeitung',
            completed: 'Abgeschlossen',
            overdue: 'Überfällig',
            escalated: 'Eskaliert',
            disputed: 'Bestritten',
        },
        event_type_labels: {
            initiation: 'Initiierung',
            data_deletion: 'Datenlöschung',
            completion: 'Abschluss',
            verification: 'Verifizierung',
            rollback: 'Rückgängig',
        },
        count_labels: {
            one_template: '1 Vorlage',
            n_templates: '{n} Vorlagen',
            one_run: '1 Durchlauf',
            n_runs: '{n} Durchläufe',
            one_task: '1 Aufgabe',
            n_tasks: '{n} Aufgaben',
            one_request: '1 Anfrage',
            n_requests: '{n} Anfragen',
        },
        aria: {
            completion_rate: 'Abschlussrate: {pct}%',
            vendor_compliance: 'Anbieter-Compliance: {pct}%',
            run_progress: 'Durchlauffortschritt: {pct}%',
            run_progress_systems: 'Fortschritt: {completed} von {total} Systemen verarbeitet',
            chain_broken: 'Kette an diesem Eintrag unterbrochen',
            chain_valid: 'Kette an diesem Eintrag gültig',
            chain_unknown: 'Kettenstatus unbekannt',
            escalate_vendor: 'Eskalieren {id}',
            resolve_conflict: 'Konflikt für {system} lösen',
        },
        regulatory: {
            annual_review_cycle_info: 'Die Vollständigkeit der Löschung muss mindestens alle 365 Tage überprüft werden. Datensätze, die diesen Schwellenwert überschreiten, werden zur obligatorischen erneuten Überprüfung markiert, um die Einhaltung gesetzlicher Vorschriften sicherzustellen.',
            runs_data_d1_lifecycle_info: 'Orchestrierungslaufzustände werden dem DATA-D1-Lebenszyklus zugeordnet: Planung = Katalog, bereit = klassifizieren, in_progress = Regeln anwenden, abgeschlossen = Beweise generiert, completed_with_exceptions = Überprüfung erforderlich. Jeder Übergang wird in der Beweiskette aufgezeichnet.',
            vendor_record_linkage_info: 'Jeder Löschantrag eines Lieferanten ist über vendor_id mit seinem Lieferantendatensatz verknüpft. Für die Abschlussbestätigung sind kryptografische Beweise aus der Beweiskette erforderlich, bevor die Anfrage als abgeschlossen markiert werden kann.',
            templates_internal_classification_info: 'Alle Lösch-Checklisten-Vorlagen werden als interne Organisationsdokumente eingestuft. Sie tragen keine offiziellen Zulassungsformular-IDs und sollten nicht als Zulassungsanträge eingereicht werden.',
            proof_chain_evidence_info: 'Jeder Beweisdatensatz erfasst die betroffene Person/Kategorie, den Zeitstempel, den Akteur, die Rechtsgrundlage und einen SHA-256-Hash. Zusammen ergeben diese Felder einen kryptografischen Löschnachweis, der die regulatorischen Prüfanforderungen erfüllt.',
            retention_data_law_info: 'Aufbewahrungspläne in diesem Dashboard werden aus der Datengesetzklassifizierung abgeleitet, die jeder Datenkategorie zugewiesen ist. Wenn sich eine Klassifizierung ändert, werden die verknüpften Aufbewahrungsregeln automatisch aktualisiert, um die Übereinstimmung mit den gesetzlichen Bestimmungen sicherzustellen.',
            dsr_erasure_route_info: 'DSR-Löschläufe sind mit dem ursprünglichen Rights Request-Fall verknüpft. Die regulatorische Frist (in der Regel 30 Tage gemäß [[TOK_0]] Art. 17) wird automatisch verfolgt. Überfällige Fälle werden zur Eskalation markiert.',
        },
    },
    discovery: {
        nav: {
            dashboard: 'Erkennungsübersicht',
            scans: 'Erkennungsscans',
            staging_area: 'Bereitstellungsbereich',
            dedup_rules: 'Deduplizierungsregeln',
            classification_rules: 'Klassifizierungsregeln',
            suggestions: 'Vorschlagswarteschlange',
            analytics: 'Vorschlagsanalyse',
            import_templates: 'Importvorlagen',
            connectors: 'Konnektorverwaltung',
            discovery_cycles: 'Erkennungszyklen',
            owner_review: 'Eigentümerprüfung',
            classification_lineage: 'Klassifizierungshistorie',
        },
        dashboard: {
            title: 'Erkennungsübersicht',
            loading: 'Lade Dashboard Daten...',
            total_scans: 'Gesamt Scans',
            active_scans: 'Aktiv Scans',
            completed_30d: 'Abgeschlossen (30d)',
            failed_30d: 'Fehlgeschlagen (30T)',
            systems_discovered: 'Systeme Entdeckt',
            pending_staged_records: 'Ausstehend Staged Datensätze',
            recent_scans: 'Kürzliche Scans',
            no_recent_scans: 'No recent Scans.',
            scan_id: 'Scannen ID',
            discovered: 'Entdeckt',
            view_all_scans: 'Ansehen Alle Scans',
            staging_area: 'Staging-Bereich',
            suggestion_queue: 'Vorschlag Warteschlange',
            records_reviewed: 'Überprüfte Datensätze',
            records_approved: 'Genehmigte Datensätze',
            exceptions_pending: 'Ausstehende Ausnahmen',
            view_as_chart: 'Als Diagramm anzeigen',
            view_as_table: 'Als Tabelle anzeigen',
        },
        scans: {
            title: 'Erkennungsscans',
            new: 'Neu Scannen',
            scan_id: 'Scannen ID',
            scan_type: 'Scannen Typ',
            progress: 'Fortschritt',
            discovered: 'Entdeckt',
            no_scans: 'Keine discovery Scans gefunden.',
            all_scan_types: 'Alle Scannen Typen',
            source_config: 'Quelle Konfiguration (JSON)',
            invalid_json: 'Ungültig JSON in source Konfiguration',
            load_error: 'Fehler beim load discovery Scans. Bitte versuchen Sie es erneut.',
            create_error: 'Fehler beim create discovery Scan',
            change_status: 'Status ändern',
            new_status: 'Neuer Status',
            actions: 'Aktionen',
            type_endpoint: 'Endpunkt',
            type_spreadsheet_import: 'Tabellenimport',
            type_cmdb_sync: 'CMDB-Synchronisierung',
            type_cloud_sync: 'Cloud-Synchronisierung',
            status_pending: 'Ausstehend',
            status_running: 'Wird ausgeführt',
            status_completed: 'Abgeschlossen',
            status_failed: 'Fehlgeschlagen',
            status_cancelled: 'Abgebrochen',
            source_config_placeholder: '{"host": "...", "port": 443}',
        },
        staging_area: {
            title: 'Bereitstellungsbereich',
            record_id: 'Datensatz ID',
            source_scan: 'Quelle Scannen',
            entity_type: 'Entität Typ',
            suggested_name: 'Vorgeschlagen Name',
            confidence: 'Konfidenz',
            no_records: 'Keine staged Datensätze gefunden.',
            promote: 'Fördern',
            discard: 'Verwerfen',
            review: 'Überprüfen',
            merge: 'Zusammenführen',
            merge_title: 'Datensatz zusammenführen',
            merge_target_id: 'Zusammenführen Ziel ID',
            reject_reason_placeholder: 'Grund für rejection...',
            promotion_status: 'Förderung Status',
            dedup_status: 'Deduplizierungsstatus',
            all_source_types: 'Alle Quelle Typen',
            all_promotion_statuses: 'Alle Förderung Statuses',
            all_dedup_statuses: 'Alle Dedup Statuses',
            load_error: 'Fehler beim load staged Datensätze. Bitte versuchen Sie es erneut.',
            promote_error: 'Fehler beim promote Datensatz',
            reject_error: 'Fehler beim reject Datensatz',
            merge_error: 'Fehler beim merge Datensatz',
            review_error: 'Fehler beim mark Datensatz für Überprüfung',
            bulk_promote_error: 'Fehler beim bulk promote Datensätze',
            bulk_reject_error: 'Fehler beim bulk reject Datensätze',
            service_type_web_server: 'Webserver',
            service_type_database: 'Datenbank',
            service_type_api_gateway: 'API-Gateway',
            service_type_storage: 'Speicher',
            service_type_authentication: 'Authentifizierung',
            service_type_analytics: 'Analytik',
            service_type_unknown: 'Unbekannt',
            source_type_endpoint_scan: 'Endpunktscan',
            source_type_spreadsheet: 'Tabelle',
            source_type_cmdb: 'CMDB',
            source_type_cloud_inventory: 'Cloud-Inventar',
            promotion_status_new: 'Neu',
            promotion_status_under_review: 'In Überprüfung',
            promotion_status_promoted: 'Gefördert',
            promotion_status_rejected: 'Abgelehnt',
            promotion_status_merged: 'Zusammengeführt',
            dedup_status_unmatched: 'Keine Übereinstimmung',
            dedup_status_potential_match: 'Mögliche Übereinstimmung',
            dedup_status_exact_match: 'Exakte Übereinstimmung',
            dedup_status_resolved: 'Gelöst',
            confirm_bulk_reject: 'Sind Sie sicher, dass Sie die ausgewählten Datensätze ablehnen möchten?',
            scan_batch_id: 'Batch-ID',
            promote_to_registry_title: 'Zur Datenregistrierung hochstufen',
            promote_modal_instructions: 'Erstellt ein Datenregistrierungselement mit collection_method: beobachtet und einer Herkunftsverknüpfung mit diesem Entdeckungsdatensatz. Das Element befindet sich zunächst im Entwurfsstatus zur Überprüfung.',
            promote_label_category: 'Kategorie',
            promote_label_name_override: 'Name (optionale Überschreibung)',
            placeholder_name_override: 'Standardmäßig wird der Name/Hostname des Erkennungseintrags verwendet',
            promote_label_sensitivity: 'Vorgeschlagene Empfindlichkeit',
            inherit_from_category: 'Von der Kategorie erben',
        },
        dedup_rules: {
            title: 'Deduplizierungsregeln',
            new: 'Neu Regel',
            rule_name: 'Regel Name',
            match_fields: 'Abgleichen Felder',
            threshold: 'Schwellenwert',
            no_rules: 'Keine Deduplizierung Regeln gefunden.',
            seed_defaults: 'Initialisieren Standardwerte',
            match_type: 'Abgleichen Typ',
            similarity_threshold: 'Ähnlichkeit Schwellenwert',
            field_name: 'Feld Name',
            load_error: 'Fehler beim load Deduplizierung Regeln. Bitte versuchen Sie es erneut.',
            create_error: 'Fehler beim create Deduplizierung Regel',
            toggle_error: 'Fehler beim toggle Deduplizierung Regel',
            seed_error: 'Fehler beim seed Standardwerte',
            priority: 'Priorität',
            enabled_status: 'Aktiviert',
            disabled_status: 'Deaktiviert',
            default_badge: 'Standard',
            enable: 'Aktivieren',
            disable: 'Deaktivieren',
            match_type_exact: 'Exakt',
            match_type_fuzzy: 'Unscharf',
            match_type_regex: 'Regex',
            match_type_ip_range: 'IP-Bereich',
        },
        classification_rules: {
            title: 'Klassifizierungsregeln',
            new: 'Neu Regel',
            rule_name: 'Regel Name',
            pattern: 'Muster',
            classification: 'Klassifizierung',
            no_rules: 'Keine classification Regeln gefunden.',
            seed_defaults: 'Initialisieren Standardwerte',
            run_rules_now: 'Regeln jetzt ausführen',
            run_rules_success: '[[TOK_1]] neue Klassifizierungsvorschläge generiert',
            run_rules_no_results: 'Es wurden keine neuen Vorschläge generiert – alle übereinstimmenden Regeln verfügen bereits über ausstehende Vorschläge',
            run_rules_error: 'Die Klassifizierungsregeln konnten nicht ausgeführt werden. Bitte versuchen Sie es erneut.',
            taxonomy_id: 'Taxonomie ID',
            level_id: 'Stufe ID',
            condition_logic: 'Bedingung Logic',
            weight: 'Gewicht',
            conditions: 'Bedingungen',
            condition_field: 'Feld',
            condition_operator: 'Betreiber',
            condition_value: 'Wert',
            effectiveness: 'Wirksamkeit',
            match_count: 'Übereinstimmungen',
            approval_count: 'Genehmigungen',
            rejection_count: 'Ablehnungen',
            filter_taxonomy: 'Filtern nach Taxonomie ID...',
            load_error: 'Fehler beim load classification Regeln. Bitte versuchen Sie es erneut.',
            create_error: 'Fehler beim create classification Regel',
            seed_error: 'Fehler beim seed Standardwerte',
            toggle_error: 'Fehler beim toggle Regel. Bitte versuchen Sie es erneut.',
            priority: 'Priorität',
            enabled_status: 'Aktiviert',
            disabled_status: 'Deaktiviert',
            enable: 'Aktivieren',
            disable: 'Deaktivieren',
            logic_and: 'UND',
            logic_or: 'ODER',
            operator_equals: 'Gleich',
            operator_contains: 'Enthält',
            operator_matches_regex: 'Entspricht Regex',
            operator_in_list: 'In Liste',
            operator_not_equals: 'Nicht gleich',
            operator_not_contains: 'Enthält nicht',
            enabled_label: 'Aktiviert',
            disabled_label: 'Deaktiviert',
            taxonomy_label: 'Taxonomie',
            operator_label: 'Betreiber',
            value_label: 'Wert',
        },
        suggestions: {
            title: 'Vorschlagswarteschlange',
            entity_type: 'Entität Typ',
            suggested_name: 'Vorgeschlagen Name',
            source: 'Quelle',
            confidence: 'Konfidenz',
            accept: 'Akzeptieren',
            reject: 'Ablehnen',
            no_suggestions: 'No Vorschläge in queue.',
            modify_approve: 'Ändern & Genehmigen',
            delegate: 'Delegierter',
            delegate_user_id: 'Delegierter Benutzer ID',
            new_level_id: 'Neu Stufe ID',
            reject_reason_placeholder: 'Grund für rejection...',
            current_level: 'Aktuell Stufe',
            suggested_level: 'Vorgeschlagen Stufe',
            filter_taxonomy: 'Filtern nach Taxonomie ID...',
            all_confidence: 'Alle Konfidenz Bands',
            load_error: 'Fehler beim load Vorschläge. Bitte versuchen Sie es erneut.',
            approve_error: 'Fehler beim approve Vorschlag',
            reject_error: 'Fehler beim reject Vorschlag',
            modify_error: 'Fehler beim modify & approve Vorschlag',
            delegate_error: 'Fehler beim delegate Vorschlag',
            bulk_approve_error: 'Fehler beim bulk approve Vorschläge',
            bulk_reject_error: 'Fehler beim bulk reject Vorschläge',
            suggestion_type_new_label: 'Neues Label',
            suggestion_type_validation: 'Validierung',
            suggestion_type_reclassification: 'Neuklassifizierung',
            status_pending: 'Ausstehend',
            status_approved: 'Genehmigt',
            status_rejected: 'Abgelehnt',
            status_superseded: 'Ersetzt',
            confidence_high: 'Hoch',
            confidence_medium: 'Mittel',
            confidence_low: 'Niedrig',
            confirm_bulk_reject: 'Sind Sie sicher, dass Sie die ausgewählten Vorschläge ablehnen möchten?',
        },
        analytics: {
            title: 'Vorschlagsanalyse',
            total_suggestions: 'Gesamt Vorschläge',
            accepted: 'Akzeptiert',
            rejected: 'Abgelehnt',
            pending: 'Ausstehend',
            acceptance_rate: 'Akzeptanzrate',
            by_entity_type: 'By Entität Typ',
            by_source: 'By Quelle',
            avg_decision_time: 'Avg Entscheidung Zeit',
            rule_effectiveness: 'Regel Wirksamkeit',
            by_status: 'Nach Status',
            by_confidence: 'By Konfidenz Band',
            load_error: 'Fehler beim load Vorschlag analytics. Bitte versuchen Sie es erneut.',
            confidence_high: 'Hoch',
            confidence_medium: 'Mittel',
            confidence_low: 'Niedrig',
            by_confidence_band: 'Nach Konfidenzstufe',
            approval_rate: 'Genehmigungsrate',
            by_label_state: 'Nach Label-Status',
        },
        import_templates: {
            title: 'Importvorlagen',
            new: 'Neu Vorlage',
            template_name: 'Vorlage Name',
            file_format: 'Datei Format',
            column_mappings: 'Spalte Zuordnungen',
            no_templates: 'Keine Import Vorlagen gefunden.',
            source_column: 'Quelle Spalte',
            target_field: 'Ziel Feld',
            transform: 'Transformieren',
            source_column_label: 'Quellspalte',
            target_field_label: 'Zielfeld',
            transform_label: 'Verwandeln',
            confirm_delete: 'Are you sure you want zu delete dieses Import Vorlage?',
            load_error: 'Fehler beim load Import Vorlagen. Bitte versuchen Sie es erneut.',
            save_error: 'Fehler beim save Import Vorlage',
            delete_error: 'Fehler beim delete Import Vorlage',
            file_type_csv: 'CSV',
            file_type_xlsx: 'XLSX',
        },
        connectors: {
            title: 'Konnektorverwaltung',
            new: 'Neu Konnektor',
            connector_name: 'Konnektor Name',
            connector_type: 'Typ',
            last_sync: 'Letzter Synchronisierung',
            no_connectors: 'Keine connectors gefunden.',
            cmdb_syncs: 'CMDB Synchronisierungen',
            cloud_syncs: 'Cloud Synchronisierungen',
            new_sync: 'Neu Synchronisierung',
            no_syncs: 'Keine syncs gefunden.',
            cmdb_error: 'Fehler beim load CMDB Scans. Bitte versuchen Sie es erneut.',
            cloud_error: 'Fehler beim load cloud Scans. Bitte versuchen Sie es erneut.',
            trigger_error: 'Fehler beim trigger Synchronisierung',
            trigger_sync_error: 'Fehler beim trigger {type}',
            cmdb_section_title: 'CMDB-Synchronisierungen',
            cloud_section_title: 'Cloud-Synchronisierungen',
            column_connector: 'Konnektor',
            action_start: 'Starten',
            confirm_cancel_sync: 'Diese Synchronisierung abbrechen?',
            start_error: 'Synchronisierung konnte nicht gestartet werden',
            cancel_error: 'Synchronisierung konnte nicht abgebrochen werden',
            type_endpoint: 'Endpunkt-Scan',
            type_spreadsheet_import: 'Tabellenimport',
            type_cmdb_sync: 'CMDB-Synchronisierung',
            type_cloud_sync: 'Cloud-Synchronisierung',
        },
        discovery_cycles: {
            title: 'Erkennungszyklen',
            new_cycle: 'Neuer Erkennungszyklus',
            cycle_name: 'Zyklusname',
            scope_type: 'Umfangstyp',
            scope_ids: 'Umfangs-IDs',
            cadence_days: 'Frequenz (Tage)',
            status: 'Status',
            no_cycles: 'Keine Erkennungszyklen gefunden',
            compare: 'Zyklen vergleichen',
            delta_report: 'Änderungsbericht',
            new_records: 'Neue Datensätze',
            changed_records: 'Geänderte Datensätze',
            removed_records: 'Entfernte Datensätze',
            schedule: 'Scan planen',
            scope_organization: 'Organisation',
            scope_department: 'Abteilung',
            scope_system: 'System',
            scope_systems: 'Systeme',
            bulk_actions: 'Massenaktionen',
            selected: '{count} ausgewählt',
            bulk_create: 'Massenerstellung',
            bulk_assign_scope: 'Massenbereich zuweisen',
            bulk_advance: 'Massenstatus voranschreiten',
            confirm_bulk_action: 'Massenaktion bestätigen',
            bulk_confirm_message: 'Sind Sie sicher, dass Sie diese Aktion ausführen möchten?',
            cycles_affected: '{count} Zyklen werden betroffen sein',
            select_all: 'Alle auswählen',
            select_cycle: 'Zyklus {name} auswählen',
            from_template: 'aus Vorlage',
            bulk_results: 'Massenergebnisse',
            failed_label: 'fehlgeschlagen',
            template_id: 'Vorlagen-ID',
            count: 'Anzahl',
            advance_to: 'Zielstatus',
            bulk_success: 'Massenvorgang abgeschlossen',
        },
        owner_review: {
            title: 'Eigentümerprüfungsaufgaben',
            assign_owner: 'Eigentümer zuweisen',
            owner_id: 'Eigentümer',
            decision: 'Entscheidung',
            approve: 'Genehmigen',
            modify: 'Ändern',
            reject: 'Ablehnen',
            escalate: 'Eskalieren',
            no_tasks: 'Keine Prüfungsaufgaben gefunden',
            bulk_resolve: 'Massenauflösung',
            exceptions: 'Ausnahmeposten',
            no_exceptions: 'Keine Ausnahmeposten gefunden',
            record_id_label: 'Datensatz-ID',
            selected: 'ausgewählt',
            notes: 'Notizen',
            select_all: 'Alle auswählen',
            select: 'Auswählen',
            confirm_resolve: 'Bestätigen',
        },
        classification_lineage: {
            title: 'Klassifizierungshistorie',
            link_suggestion: 'Mit vorgeschlagenem Label verknüpfen',
            suggestion_id: 'Vorschlag',
            proposed_label_id: 'Vorgeschlagenes Label',
            no_lineage: 'Keine Historiedaten gefunden',
            full_lineage: 'Vollständige Historie',
            record_id_label: 'Datensatz-ID',
            staged_record_label: 'Inszenierte Aufzeichnung',
            enter_staged_record_id: 'Geben Sie die ID des bereitgestellten Datensatzes ein',
            scan_id_label: 'Scan-ID',
            select_record: 'Datensatz auswählen',
            select_suggestion: 'Vorschlag auswählen',
            select_label: 'Bezeichnung auswählen',
        },
        common_labels: {
            n_rules: '[[TOK_1]] Regeln',
            one_rule: '1 Regel',
            n_scans: '[[TOK_1]] scannt',
            one_scan: '1 Scan',
            n_syncs: '[[TOK_1]] wird synchronisiert',
            one_sync: '1 Synchronisierung',
            n_records: '[[TOK_1]] Datensätze',
            one_record: '1 Datensatz',
            n_templates: '[[TOK_1]] Vorlagen',
            one_template: '1 Vorlage',
            n_suggestions: '[[TOK_1]] Vorschläge',
            one_suggestion: '1 Vorschlag',
            n_selected: '[[TOK_1]] ausgewählt',
            dashboard_loaded: 'Discovery-Dashboard geladen',
            n_scans_loaded: '[[TOK_1]] Scans geladen',
            n_staged_records_loaded: '[[TOK_1]] bereitgestellte Datensätze geladen',
            confirm_delete_import_template: 'Sind Sie sicher, dass Sie diese Importvorlage löschen möchten?',
            invalid_json_source_config: 'Ungültig [[TOK_0]] in source_config',
            scope_organization: 'Organisation',
            scope_department: 'Abteilung',
            scope_system: 'System',
            aria_filter_scans: 'Scans filtern',
            aria_filter_staged_records: 'Filtern Sie bereitgestellte Datensätze',
            aria_filter_suggestions: 'Filter',
            aria_filter_by_taxonomy_id: 'Nach Taxonomie-ID filtern',
            aria_filter_by_enabled_status: 'Filtern Sie nach aktiviertem Status',
            aria_filter_by_source_type: 'Filtern Sie nach Quelltyp',
            aria_filter_by_promotion_status: 'Filtern Sie nach Aktionsstatus',
            aria_filter_by_dedup_status: 'Filtern Sie nach Deduplizierungsstatus',
            aria_filter_by_scan_type: 'Filtern Sie nach Scantyp',
            aria_filter_by_status: 'Nach Status filtern',
            aria_filter_by_confidence: 'Nach Konfidenzband filtern',
            aria_select_all_records: 'Wählen Sie alle Datensätze aus',
            aria_select_record: 'Datensatz auswählen [[TOK_1]]',
            aria_select_all_suggestions: 'Wählen Sie alle Vorschläge aus',
            aria_select_suggestion: 'Vorschlag auswählen [[TOK_1]]',
            aria_promote_record: 'Datensatz hochstufen [[TOK_1]]',
            aria_discard_record: 'Datensatz verwerfen [[TOK_1]]',
            aria_merge_record: 'Datensatz zusammenführen [[TOK_1]]',
            aria_review_record: 'Überprüfungsdatensatz [[TOK_1]]',
            aria_accept_suggestion: 'Vorschlag annehmen [[TOK_1]]',
            aria_reject_record: 'Datensatz ablehnen',
            aria_merge_record_dialog: 'Datensatz zusammenführen',
            aria_create_new_scan: 'Neuen Scan erstellen',
            aria_sync_progress: 'Synchronisierungsfortschritt: [[TOK_2]] von [[TOK_3]] Elementen verarbeitet',
            aria_scan_progress: 'Scanfortschritt: [[TOK_2]] von [[TOK_3]] Elementen verarbeitet',
            aria_confidence: 'Vertrauen: [[TOK_1]]%',
            aria_effectiveness: 'Wirksamkeit: [[TOK_1]]',
            aria_promote_n_records: '[[TOK_1]] ausgewählte Datensätze hervorheben',
            aria_discard_n_records: '[[TOK_1]] ausgewählte Datensätze verwerfen',
            placeholder_pii_detection_rule: 'z. B. PII-Erkennungsregel',
            placeholder_tax_id: 'z. B. TAX-001',
            placeholder_lvl_id: 'z. B. LVL-001',
            placeholder_service_type: 'z. B. service_type',
            placeholder_database: 'z.B. Datenbank',
            placeholder_hostname_match: 'z. B. Hostname Exact Match',
            placeholder_hostname: 'z. B. Hostname',
            placeholder_hr_systems_csv: 'z. B. HR-Systeme [[TOK_0]] Importieren',
            placeholder_server_name: 'z. B. Servername',
            placeholder_hostname_field: 'z. B. Hostname',
            placeholder_lowercase: 'z. B. Kleinbuchstaben',
            placeholder_source_config: '{"host": "...", "port": 443}',
            placeholder_stg_id: 'z. B. STG-000123',
            placeholder_lvl_002: 'z. B. LVL-002',
            placeholder_usr_id: 'z. B. USR-000123',
            decision_for: 'Entscheidung für [[TOK_1]]',
        },
        exports: {
            title: 'Exportieren',
            inventory: 'Dateninventar',
            classification_register: 'Klassifikationsregister',
            raci: 'RACI-Matrix',
            exceptions: 'Ausnahmebericht',
            evidence_pack: 'Nachweispaket',
            delta_report: 'Änderungsbericht',
            executive_summary: 'Zusammenfassung',
            export_button: 'Exportieren',
            downloading: 'Wird heruntergeladen...',
            download_complete: 'Download abgeschlossen.',
            download_error: 'Export-Download fehlgeschlagen. Bitte erneut versuchen.',
        },
        flags: {
            title: 'Nachgelagerte Markierungen',
            pending: 'Ausstehende Markierungen',
            cross_border_review_needed: 'Grenzüberschreitende Prüfung erforderlich',
            sharing_disclosure_needed: 'Weitergabe-Offenlegung erforderlich',
            dpia_review_needed: 'DSFA-Prüfung erforderlich',
            acknowledge: 'Bestätigen',
            resolve: 'Lösen',
            no_flags: 'Keine nachgelagerten Markierungen.',
        },
        delta: {
            title: 'Änderungsübersicht',
            new_count: '{n} neue',
            removed_count: '{n} entfernte',
            changed_count: '{n} geänderte',
            re_review_triggered: 'Erneute Prüfung ausgelöst',
            create_re_review: 'Erneute Prüfung erstellen',
            recent_alerts: 'Aktuelle Änderungswarnungen',
            no_alerts: 'Keine aktuellen Änderungswarnungen.',
            threshold_exceeded: 'Änderungsschwellenwert überschritten (>10%)',
        },
        regulatory: {
            dashboard_governance_info: 'Dieses Dashboard zeigt den Governance-Status auf Zyklusebene an: gescannte Systeme, bereitgestellte Datensätze, überprüfte Datensätze, genehmigte Datensätze und ausstehende Ausnahmen. Dies entspricht den Governance-Lead-Erfolgskriterien: „Live-Dashboard darüber, wer sein Inventar, seine Klassifizierung und seine Freigabeprotokolle aktualisiert hat“ (P-VN-05).',
            export_artifacts_info: 'Discovery-Exporte umfassen alle erforderlichen Artefakttypen gemäß UC-VN-10 und DATA-EVD-01: genehmigtes Dateninventar, Klassifizierungsregister, Eigentums-/RACI-Zuordnung, Ausnahmewarteschlange, Executive Summary, Beweispaket und Deltabericht.',
            scan_inventory_pipeline_info: 'Jeder abgeschlossene Scan erzeugt Datensätze, die mit der Vorlage vn_data_law_data_inventory_register kompatibel sind (Anforderung 88dd9877). Entdeckte Datenbestände werden automatisch in das Datenbestandsregister eingetragen, um der datenrechtlichen Verpflichtung zur Führung eines digitalen Datenbestands nachzukommen.',
            connector_linkage_info: 'Jede Connector-Konfiguration muss Folgendes umfassen: Systemtyp (z. B. [[TOK_0]], Cloud-Plattform), Datenspeicherreferenz (Datenbank, Dateispeicher, SaaS) und Geschäftsprozessverknüpfung (UC-VN-10 erforderliche unterstützende Datensätze). Diese Felder stellen sicher, dass entdeckte Assets auf ihr Quellsystem und ihren Geschäftskontext zurückverfolgt werden können.',
            owner_routing_info: 'Überprüfungsaufgaben werden basierend auf dem System-/Dateneigentum an die richtige Abteilung oder den richtigen Anwendungseigentümer weitergeleitet (UC-VN-10 Schritt 5). Beim Routing wird das Systemeigentumsregister verwendet, keine Ad-hoc-Zuweisung.',
            owner_actions_audit_info: 'Eigentümer können jede Klassifizierung genehmigen, ändern, ablehnen oder eskalieren (UC-VN-10 Schritt 6). Bei jeder Aktion werden Akteur, Zeitstempel und Grund erfasst, wodurch Governance-Audit-Nachweisereignisse gemäß der Anforderung f12fc090 (jährliche Governance-Bescheinigung) erstellt werden. Der Prüfpfad zeigt, wer überprüft hat, was wann geändert wurde.',
            escalation_timers_info: 'Eskalationstimer: Die Frist für die Überprüfung durch den Eigentümer beträgt 5 Werktage. Die Ausnahmeeskalation beträgt 48 Stunden (UC-VN-10 Timer). Ungelöste Elemente werden automatisch eskaliert, wenn die Frist abläuft. Timer können je nach Organisationsrichtlinie konfiguriert werden.',
            original_suggestion_preserved_info: 'Der ursprüngliche Maschinen-/Systemklassifizierungsvorschlag bleibt bei jeder Eigentümerüberschreibung erhalten (UC-VN-10 Nachweispflicht). Der ursprüngliche Vorschlag wird niemals überschrieben und bleibt für Prüfzwecke sichtbar.',
            dedup_lineage_info: 'Deduplizierungsregeln verhindern doppelte Inventareinträge, wenn derselbe Datenbestand über mehrere Scans oder Connectors hinweg erkannt wird. Die aktuellsten Scan-Metadaten werden als primärer Datensatz beibehalten, während Herkunftsverweise zu allen früheren Entdeckungen zur Nachverfolgbarkeit bei Audits beibehalten werden.',
            label_states_info: 'Analytics unterscheidet vier Label-Status für die Governance-Überprüfung: maschinell vorgeschlagen (ausstehend), vom Eigentümer genehmigt, vom Eigentümer geändert und abgelehnt. Mithilfe dieser Zustände können Prüfer die Automatisierungsgenauigkeit und das Engagement der Eigentümer beurteilen.',
            import_pipeline_info: 'Importvorlagen müssen Datensätze erzeugen, die mit der Discovery-Pipeline kompatibel sind. Importierte Datensätze gelangen mit denselben Metadatenanforderungen wie gescannte Datensätze in die Bereitstellung: Quellsystemidentifikation, Batch-ID und Zeitstempel. Spaltenzuordnungen sollten auf Felder abzielen, die in vn_data_law_data_inventory_register definiert sind.',
            lineage_full_path_info: 'Die Klassifizierungsherkunft verfolgt den vollständigen Pfad: Scannen/Importieren -> Staging -> Eigentümerüberprüfung -> genehmigtes Etikett -> Registereintrag (UC-VN-10 Schritte 1–10). In jeder Phase werden Datensatz-ID, Akteur, Zeitstempel und Zustandsübergang angezeigt, um eine vollständige Rückverfolgbarkeit der Prüfung zu gewährleisten.',
            staging_workflow_info: 'Gestaffelte Datensätze unterscheiden sich optisch von genehmigten Inventareinträgen durch ihr Promotion-Status-Badge (UC-VN-10 Schritt 3). Jeder Datensatz behält Herkunftsmetadaten bei: Quellsystem, Scan-Batch-ID und Erkennungszeitstempel für eine vollständige Rückverfolgbarkeit bei Audits.',
            suggestion_data_d1_info: 'Die Vorschläge stehen im Einklang mit dem Klassifizierungsverfahren des Datengesetzes DATA-D1: (1) Datenbestände katalogisieren, (2) nach Vertraulichkeitsgrad klassifizieren, (3) Handhabungsregeln definieren. Jeder Vorschlag enthält Sensibilitäts- und Wichtigkeitsdimensionen gemäß Anforderung 18e4bfd1.',
            downstream_flags_info: 'Elemente, die für die gemeinsame Nutzung, grenzüberschreitende Übertragung oder Behandlung mit hohem Risiko gekennzeichnet sind, lösen verknüpfte nachgelagerte Arbeitsabläufe aus: Bewertung der grenzüberschreitenden Übertragung, Risikobewertung der gemeinsamen Nutzung und [[TOK_0]] Überprüfung (UC-VN-10 Schritt 8).',
            delta_detection_info: 'Erkennungszyklen unterstützen die Deltaerkennung gemäß UC-VN-10 Schritt 11: Jeder Zyklus zeigt, welche Datensätze seit der letzten genehmigten Baseline neu, geändert oder entfernt wurden. Materialänderungen (>10 % Delta) lösen automatisch Re-Review-Workflows aus.',
        },
    },
    incident_ops: {
        errors: {
            fetch: 'Fehler beim load..',
            save: 'Fehler beim save..',
            fetch_escalation_log_failed: 'Fehler beim fetch Eskalation Protokoll..',
            fetch_activations_failed: 'Fehler beim fetch activations..',
            deactivate_failed: 'Fehler beim deactivate..',
            complete_activation_failed: 'Fehler beim abgeschlossen activation..',
            fetch_playbook_templates_failed: 'Fehler beim fetch Playbook Vorlagen..',
            create_playbook_template_failed: 'Fehler beim create Playbook Vorlage..',
            clone_template_failed: 'Fehler beim clone Vorlage..',
            update_status_failed: 'Fehler beim update Status..',
            deprecate_template_failed: 'Fehler beim deprecate Vorlage..',
            seed_defaults_failed: 'Fehler beim seed Standardwerte..',
            fetch_regulator_exports_failed: 'Fehler beim fetch regulator exports..',
            create_regulator_export_failed: 'Fehler beim create regulator Export..',
            update_submission_status_failed: 'Fehler beim update Einreichung Status..',
            fetch_response_metrics_failed: 'Fehler beim fetch response Metriken..',
            fetch_sla_dashboard_failed: 'Fehler beim fetch SLA Dashboard..',
            fetch_sla_definitions_failed: 'Fehler beim fetch SLA Definitionen..',
            create_sla_definition_failed: 'Fehler beim create SLA Definition..',
            seed_sla_defaults_failed: 'Fehler beim seed SLA Standardwerte..',
            fetch_vendor_coordination_failed: 'Fehler beim fetch Anbieter Koordination..',
            fetch_vendor_detail_failed: 'Fehler beim fetch Anbieter Detail..',
            create_vendor_coordination_failed: 'Fehler beim create Anbieter Koordination..',
            add_communication_failed: 'Fehler beim add communication..',
            add_info_request_failed: 'Fehler beim add Info request..',
            add_action_request_failed: 'Fehler beim add Aktion request..',
        },
        nav: {
            playbooks: 'Leitfadenvorlagen',
            sla_definitions: 'SLA-Definitionen',
            sla_dashboard: 'SLA-Übersicht',
            escalation_log: 'Eskalationsprotokoll',
            regulator_exports: 'Behördenexporte',
            deadlines: 'Benachrichtigung Deadlines',
            vendor_coordination: 'Lieferantenkoordination',
            metrics: 'Reaktionsmetriken',
            playbook_links: 'Playbook-Verknüpfungen',
            regulatory_sla: 'Regulatorische SLA',
            coordination_dashboard: 'Koordination',
            evidence_chain: 'Beweiskette',
            post_review: 'Nachvorfallprüfung',
        },
        playbooks: {
            page_title: 'Playbook-Vorlagen',
            activations_page_title: 'Playbook-Aktivierungen',
            title: 'Leitfadenvorlagen',
            new: 'Neu Vorlage',
            seed_defaults: 'Initialisieren Standardwerte',
            scenario_type: 'Szenario Typ',
            severity_applicability: 'Schweregrad Applicability',
            all_scenario_types: 'Alle Szenario Typen',
            new_playbook: 'Neu Playbook Vorlage',
            clone: 'Klonen',
            clone_template: 'Klonen Vorlage',
            template_name: 'Vorlage Name',
            deprecate: 'Veralten',
            confirm_deprecate: 'Veralten Vorlage "{name}"?',
            create_template: 'Erstellen Vorlage',
            update_status: 'Aktualisieren Status',
            no_templates: 'Keine Playbook Vorlagen gefunden',
            deactivation_reason_placeholder: 'Grund für deactivation...',
            description_placeholder: 'Playbook Beschreibung...',
            name_placeholder: 'Playbook Name...',
        },
        sla_definitions: {
            page_title: 'SLA-Definitionen',
            title: 'SLA-Definitionen',
            new: 'Neu SLA Definition',
            sla_name: 'SLA-Name',
            target_hours: 'Ziel Hours',
            escalation_after: 'Eskalation After',
            applies_to: 'Applies Zu',
            no_definitions: 'Keine SLA Definitionen gefunden.',
            target_value_placeholder: 'Ziel value',
            name_placeholder: 'SLA Name...',
            threshold_hours_label: 'Schwellenwert-Stunden',
            severity_label: 'Schweregrad',
            all_types: 'Alle Typen',
            all_severities: 'Alle Schweregrade',
            default_label: 'Standard',
        },
        sla_dashboard: {
            compliant: 'Konform',
            page_title: 'SLA-Übersicht',
            title: 'SLA-Übersicht',
            loading: 'Lade SLA Daten...',
            compliance_rate: 'Konformität Rate',
            breached: 'Verletzt',
            at_risk: 'At Risiko',
            on_track: 'On Verfolgen',
            by_severity: 'By Schweregrad',
            total_records: 'Anzahl Datensätze',
            met: 'Erfüllt',
            sla_records: 'SLA-Datensätze',
            sla_reference: 'SLA-Referenz',
            record_id: 'Datensatz-ID',
            metric_type: 'Metriktyp',
            severity: 'Schweregrad',
            elapsed: 'Verstrichen',
            clock_start: 'Uhrenstart',
        },
        escalation_log: {
            page_title: 'Eskalationsprotokoll',
            title: 'Eskalationsprotokoll',
            incident_id: 'Vorfall ID',
            escalated_by: 'Eskaliert By',
            escalated_to: 'Eskaliert Zu',
            reason: 'Grund',
            escalated_at: 'Eskaliert At',
            no_escalations: 'Keine escalations gefunden.',
            filter_incident_id: 'Filtern nach Vorfall ID',
            escalation_id: 'Eskalations-ID',
            level: 'Stufe',
            level_range: 'Niveau (L1–L4)',
            create_escalation: 'Eskalation erstellen',
            incident_id_placeholder: 'z.B. INC-001',
            target_role_placeholder: 'z.B. dpo, incident_manager',
            select_placeholder: '— auswählen —',
        },
        regulator_exports: {
            page_title: 'Behördenexporte',
            title: 'Behördenexporte',
            new: 'Neu Exportieren',
            incident_id: 'Vorfall ID',
            regulator: 'Regulierungsbehörde',
            export_format: 'Dateiformat',
            exported_at: 'Exportiert At',
            no_exports: 'Keine regulator exports gefunden.',
            enter_incident_id: 'Eingeben Vorfall ID',
            export_id: 'Export-ID',
            watermark: 'Wasserzeichen',
            submission_status: 'Einreichungsstatus',
            all_jurisdictions: 'Alle Zuständigkeiten',
            no_transitions: 'Keine weiteren Übergänge verfügbar von',
            select_new_status: '— neuen Status auswählen —',
            sections_included: 'Enthaltene Abschnitte',
            form_classification: 'Klassifizierung',
            submission_channel: 'Kanal',
        },
        deadlines: {
            title: 'Benachrichtigung Deadlines',
            incident_id: 'Vorfall ID',
            deadline: 'Frist',
            regulator: 'Regulierungsbehörde',
            remaining: 'Verbleibend',
            no_deadlines: 'Keine Benachrichtigung deadlines gefunden.',
        },
        vendor_coordination: {
            page_title: 'Lieferantenkoordinierung',
            title: 'Lieferantenkoordination',
            new: 'Neu Koordination',
            incident_id: 'Vorfall ID',
            vendor_name: 'Anbieter Name',
            contact: 'Kontakt',
            coordination_status: 'Koordination Status',
            no_items: 'Keine Anbieter Koordination items gefunden.',
            assessment_placeholder: 'Erstmalig Bewertung von Anbieter...',
            coordination_id: 'Koordinations-ID',
            communications: 'Kommunikation',
            info_requests: 'Infoanfragen',
            action_requests: 'Aktionsanfragen',
            direction: 'Richtung',
            channel_label: 'Kanal',
            no_transitions: 'Keine weiteren Übergänge verfügbar.',
            vendor_ref_number: 'Referenznummer',
            report_date: 'Berichtsdatum',
            contact_email: 'E-Mail',
            contact_phone: 'Telefon',
            channel_email: 'E-Mail',
            channel_meeting: 'Besprechung',
            channel_phone: 'Telefon',
            channel_portal: 'Portalbereich',
            incident_id_placeholder: 'Filtern nach Vorfall ID...',
            priority_critical: 'Kritisch',
            priority_high: 'Hoch',
            priority_low: 'Low',
            priority_medium: 'Mittel',
            vendor_id_placeholder: 'Filtern nach Anbieter ID...',
            description_placeholder: 'Beschreibung...',
            filter_vendor_id: 'Filtern nach Anbieter ID',
            inbound: 'Eingehend',
            outbound: 'Ausgehend',
            summary_placeholder: 'Zusammenfassung...',
            priority_label: 'Priorität',
            due_date_label: 'Fälligkeitsdatum',
            info_request_desc: 'Beschreibung der Informationsanfrage',
            action_request_desc: 'Beschreibung der Aktionsanforderung',
            content_label: 'Inhalt',
            select_incident: 'Vorfall auswählen',
            select_vendor: 'Dienstleister auswählen',
            discovery_date: 'Erkennung Datum',
        },
        metrics: {
            page_title: 'Antwortmetriken',
            title: 'Reaktionsmetriken',
            loading: 'Lade Metriken Daten...',
            avg_response_time: 'Avg Antwort Zeit',
            avg_resolution_time: 'Avg Lösung Zeit',
            total_incidents: 'Gesamt Vorfälle',
            by_severity: 'By Schweregrad',
            by_status: 'Nach Status',
            trend: 'Entwicklung',
            start_sla_clock: 'SLA-Uhr starten',
            sla_records: '[[TOK_0]] Datensätze',
            no_sla_records: 'Noch keine SLA-Datensätze.',
            record_id: 'Datensatz-ID',
            severity: 'Schweregrad',
            progress: 'Fortschritt',
            incident_id_required: 'Vorfalls-ID ist erforderlich',
            sla_definition_required: 'SLA-Definition ist erforderlich',
            metric_type_required: 'Metriktyp ist erforderlich',
            threshold_required: 'Schwellenwert-Stunden sind erforderlich',
            sla_clock_started: 'SLA-Uhr gestartet',
            sla_definition: 'SLA-Definition',
            no_definitions: 'Keine SLA-Definitionen gefunden.',
            select_definition: 'SLA-Definition auswählen...',
            select_metric_type: 'Metriktyp auswählen...',
            select_severity: 'Schweregrad auswählen...',
            threshold_hours: 'Schwellenwert (Stunden)',
            warning_threshold_pct: 'Warnschwelle (%)',
            start_clock: 'Uhr starten',
            starting: 'Startet...',
            metric_label: 'Metrik',
            value_label: 'Wert',
            incident_id: 'Vorfalls-ID',
            threshold_placeholder: 'z.B. 24',
            metric_types: {
                triage_time: 'Sichtungszeit',
                containment_time: 'Eindämmungszeit',
                notification_time: 'Benachrichtigungszeit',
                resolution_time: 'Lösungszeit',
            },
            severities: {
                critical: 'Kritisch',
                high: 'Hoch',
                medium: 'Mittel',
                low: 'Low',
            },
        },
        playbook_links: {
            page_title: 'Playbook-Verknüpfungen',
            title: 'Playbook-Benachrichtigungsverknüpfungen',
            new_link: 'Playbook mit Benachrichtigung verknüpfen',
            activation_id: 'Aktivierungs-ID',
            notification_id: 'Benachrichtigungs-ID',
            select_activation: 'Aktivierung auswählen...',
            select_notification: 'Benachrichtigung auswählen...',
            no_links: 'Keine Playbook-Verknüpfungen gefunden',
            seed_pdpl: 'PDPL-Playbooks initialisieren',
            created: 'Playbook-Verknüpfung erstellt',
            seeded: 'PDPL-Playbooks initialisiert',
            create_failed: 'Playbook-Verknüpfung konnte nicht erstellt werden',
            seed_failed: 'Initialisierung der PDPL-Playbooks fehlgeschlagen',
        },
        regulatory_sla: {
            page_title: 'Regulatorische SLA-Zuordnungen',
            title: 'Regulatorische SLA-Zuordnungen',
            new_mapping: 'Neue SLA-Zuordnung',
            sla_definition: 'SLA-Definition',
            select_sla_definition: 'SLA-Definition auswählen...',
            framework_code: 'Rahmenwerk-Code',
            deadline_type: 'Fristtyp',
            deadline_hours: 'Frist in Stunden',
            auto_escalate: 'Auto-Eskalation',
            seed_pdpl: 'PDPL-Standardwerte initialisieren',
            no_mappings: 'Keine regulatorischen SLA-Zuordnungen gefunden',
            dashboard: 'Regulatorische SLA-Übersicht',
            deadline_types: {
                initial_notification: 'Erste Benachrichtigung',
                supplement_response: 'Ergänzungsantwort',
                authority_response: 'Antwort der Behörde',
                remediation_report: 'Sanierungsbericht',
            },
            statutory_reference: 'Gesetzliche Referenz',
        },
        coordination_dashboard: {
            page_title: 'Koordinierungsübersicht',
            title: 'Koordinationsübersicht',
            incident_id: 'Vorfall-ID',
            select_incident: 'Vorfall auswählen...',
            team_role: 'Teamrolle',
            members: 'Mitglieder',
            tasks: 'Aufgaben',
            sla_status: 'SLA-Status',
            no_teams: 'Keine Koordinationsteams gefunden',
            new_team: 'Neues Koordinationsteam',
            enter_incident_id: 'Geben Sie eine Vorfalls-ID ein, um Koordinierungsteams anzuzeigen.',
            member_ids_placeholder: 'Benutzer1, Benutzer2',
            edit_team: 'Team bearbeiten',
            task_count: 'Aufgabenanzahl',
            tasks_completed: 'Abgeschlossen',
            team_roles: {
                security: 'Sicherheit',
                legal: 'Recht',
                it: 'IT',
                management: 'Führung',
                department_owner: 'Abteilungsinhaber',
                external: 'Extern',
            },
        },
        evidence_chain: {
            page_title: 'Beweiskette',
            title: 'Beweiskette',
            new_entry: 'Neuer Beweis-Eintrag',
            select_incident: 'Vorfall auswählen...',
            actor: 'Akteur',
            select_actor: 'Akteur auswählen...',
            evidence_id: 'Beweis-ID',
            action: 'Aktion',
            recipient: 'Empfänger',
            no_entries: 'Keine Beweisketteneinträge gefunden',
            enter_incident_id: 'Geben Sie eine Vorfalls-ID ein, um die Beweiskette anzuzeigen.',
            evidence_id_placeholder: 'z. B. EVD-2026-0001',
            evidence_id_help: 'Eine eindeutige Referenz für das Beweisstück – eine Protokolldatei, ein Datenträgerabbild oder ein Screenshot. Ein Vorschlag ist vorausgefüllt; passen Sie ihn an Ihren Beweiskatalog an.',
            select_incident_first: 'Wählen Sie oben einen Vorfall aus, bevor Sie einen Beweiseintrag hinzufügen.',
            for_incident: 'Für Vorfall',
            actions: {
                collected: 'Gesammelt',
                shared: 'Geteilt',
                exported: 'Exportiert',
                archived: 'Archiviert',
            },
        },
        post_review: {
            page_title: 'Nachvorfallprüfung',
            title: 'Nachvorfallprüfung',
            new_review: 'Neue Prüfung',
            select_incident: 'Vorfall auswählen...',
            lessons_learned: 'Erfahrungen',
            recommendations: 'Empfehlungen',
            improvement_actions: 'Verbesserungsmaßnahmen',
            submit_for_review: 'Zur Prüfung einreichen',
            aria_submit_review: 'Prüfung {name} zur Überprüfung einreichen',
            aria_sign_off: 'Prüfung {name} freigeben',
            sign_off: 'Freigabe',
            no_reviews: 'Keine Nachvorfallprüfungen gefunden',
            enter_incident_id: 'Geben Sie eine Vorfalls-ID ein, um die Nachvorfallprüfung anzuzeigen.',
            one_per_line: 'Einer pro Zeile',
            statuses: {
                draft: 'Entwurf',
                in_review: 'In Prüfung',
                signed_off: 'Freigegeben',
                closed: 'Geschlossen',
            },
        },
        activations: {
            title: 'Playbook-Aktivierungen',
            activation_id: 'Aktivierungs-ID',
            phases: 'Phasen',
            activated_at: 'Aktiviert um',
            activated_by: 'Aktiviert von',
            deactivate: 'Deaktivieren',
            complete: 'Abschließen',
            deactivation_reason: 'Deaktivierungsgrund',
            evidence_button: 'Beweise',
            evidence_modal_title: 'Aktivierungsnachweis',
            no_evidence: 'Dieser Aktivierung liegen keine Beweise bei.',
            upload_evidence_label: 'Aktivierungsnachweis hochladen',
        },
    },
    program_governance: {
        maturity_walkthrough: {
            run_label: 'Führe mich durch Lücken',
            running: 'Gehlücken…',
            results_heading: 'Verbesserungs-Roadmap ([[TOK_2]] Lücke[[TOK_3]])',
            tokens_label: '≈ [[TOK_1]] Token',
            no_gaps: 'Keine Lücken erkannt – alle Domänen erreichen oder über dem Zielwert.',
            col_priority: 'Priorität',
            col_domain: 'Domäne',
            col_levels: 'Aktuell → Ziel',
            col_severity: 'Schweregrad',
            col_actions: 'Sanierungsmaßnahmen',
            citations_label: 'Zitate',
            accept_label: 'Roadmap akzeptieren',
            reject_label: 'Entwurf ablehnen',
            export_label: 'Exportieren [[TOK_0]]',
            exported_label: 'Roadmap exportiert',
            accept_hint: 'Accept zeichnet die Roadmap im beibehaltenen Entwurf auf. Verwenden Sie Export [[TOK_0]], um die Lieferung zu generieren; Der Bediener fügt improvement_actions wieder in die Bewertung ein.',
            resolve_summary: 'Auflösung: [[TOK_1]]',
            error_generic: 'Lückenlösung konnte nicht ausgeführt werden. Versuchen Sie es erneut oder überprüfen Sie den Bewertungsstatus.',
        },
        policy_gap: {
            run_label: 'Erkennen Sie Richtlinienlücken',
            running: 'Lücken erkennen…',
            results_heading: 'Richtlinienlücken ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]] Token',
            no_gaps: 'Keine Deckungslücken festgestellt.',
            col_severity: 'Schweregrad',
            col_kind: 'Freundlich',
            col_clause: 'Klausel/Anforderung',
            kind_missing: 'Fehlende Klausel',
            kind_weak: 'Schwache Abdeckung',
            kind_stale: 'Veraltet (Rezension überfällig)',
            remediation_label: 'Vorgeschlagene Abhilfe',
            citations_label: 'Zitate',
            accept_label: 'Lückenbericht akzeptieren',
            reject_label: 'Bericht ablehnen',
            export_label: 'Exportieren [[TOK_0]]',
            accept_hint: 'Akzeptieren zeichnet den Lückenbericht zum beibehaltenen Entwurf auf. Verwenden Sie Exportieren [[TOK_0]], um einen Richtlinien-Audit-Bericht zu erstellen. Der Bediener steuert die eigentliche Richtlinienbearbeitung.',
            resolve_summary: 'Auflösung: [[TOK_1]]',
            error_generic: 'Es konnten keine Richtlinienlücken festgestellt werden. Versuchen Sie es erneut oder überprüfen Sie den Dokumentstatus.',
        },
        remediation_plan_generator: {
            run_label: 'Plan aus Lücken generieren',
            running: 'Plan erstellen…',
            results_heading: 'Sanierungsplan ([[TOK_2]] Phase[[TOK_3]])',
            tokens_label: '≈ [[TOK_1]] Token',
            phase_label: 'Phase [[TOK_1]]',
            window_label: 'Fenster',
            owner_label: 'Eigentümerrolle',
            evidence_label: 'Nachweisarten erforderlich',
            tasks_label: 'Aufgaben',
            no_phases: 'Keine Phasen erzeugt – Eingabelückensatz ist möglicherweise leer.',
            citations_label: 'Zitate',
            accept_label: 'Plan akzeptieren',
            reject_label: 'Plan ablehnen',
            export_label: 'Exportieren [[TOK_0]]',
            accept_hint: 'Accept erstellt Phasenaufgaben, die mit dem Plandatensatz verknüpft sind. Verwenden Sie Exportieren [[TOK_0]] für die vollständige Lieferung. Platzhalter für Besitzerrollen müssen vom Bediener weiterverfolgt werden.',
            resolve_summary: 'Lösung: [[TOK_2]] · [[TOK_3]] Aufgabe(n) erstellt',
            error_generic: 'Der Behebungsplan konnte nicht erstellt werden. Versuchen Sie es erneut oder überprüfen Sie die Gap-Set-Eingabe.',
            source_picker_label: 'Quelle',
            source_all: 'Alle',
            source_consent: 'Analyse der Einwilligungslücke',
            source_policy: 'Erkennung von Richtlinienlücken',
            source_vendor: 'Lieferanten-Onboarding',
            load_upstream_label: 'Vom Upstream laden',
            loading_upstream: 'Laden…',
            upstream_count: '[[TOK_1]] Lücke(n) geladen',
        },
        nav: {
            maturity_models: 'Reifegradmodelle',
            maturity_assessments: 'Reifgradbewertungen',
            trend_dashboard: 'Trendübersicht',
            reporting_periods: 'Berichtszeiträume',
            executive_summaries: 'Zusammenfassungen',
            audit_readiness: 'Prüfungsbereitschaft',
            evidence_gaps: 'Nachweislücken',
            program_health: 'Programmzustand',
            obligation_mappings: 'Pflichtzuordnungen',
            governance_documents: 'Governance-Dokumente',
            remediation_plans: 'Maßnahmenpläne',
            governance_model: 'Governance-Modell',
            document_drafting: 'Dokumententwurf',
            document_issuance: 'Dokumentenausgabe',
            acknowledgment_tracking: 'Bestätigungsverfolgung',
            change_log: 'Änderungsprotokoll',
            review_cadence: 'Überprüfungskadenz',
        },
        maturity_models: {
            title: 'Reifegradmodelle',
            new: 'Neu Modell',
            seed_defaults: 'Initialisieren Standardwerte',
            domains: 'Domänen',
            activate: 'Aktivieren',
            no_models: 'Keine Reife models gefunden',
            new_maturity_model: 'Neu Reife Modell',
            create_model: 'Erstellen Modell',
            load_error: 'Reifegradmodelle konnten nicht geladen werden. Bitte erneut versuchen.',
            create_error: 'Reifegradmodell konnte nicht erstellt werden',
            status_error: 'Modellstatus konnte nicht aktualisiert werden',
            seed_error: 'Standardwerte konnten nicht generiert werden',
            aria_seed_defaults: 'Standard-Reifegradmodelle generieren',
            aria_create_new: 'Neues Reifegradmodell erstellen',
            loading_sr: 'Reifegradmodelle werden geladen',
            model_name_placeholder: 'z.B., Datenschutz-Reifegradmodell',
            status_changed: 'Modellstatus geändert auf {status}',
        },
        maturity_assessments: {
            title: 'Reifgradbewertungen',
            new: 'Neu Bewertung',
            model: 'Modell',
            assessor: 'Bewerter',
            overall_score: 'Gesamt Bewertung',
            overall_score_help: 'Eine gewichtete Reifebewertung von 0–5, die automatisch berechnet wird, wenn eine Bewertung abgeschlossen wird. Erhöhen Sie sie, indem Sie jede Domäne während der Evaluierung höher bewerten und die Bewertung anschließend über Zur Überprüfung einreichen → Abschließen führen.',
            assessed_at: 'Bewertet am',
            no_assessments: 'Keine Reife assessments gefunden.',
            load_error: 'Reifegradbeurteilungen konnten nicht geladen werden. Bitte erneut versuchen.',
            create_error: 'Bewertung konnte nicht erstellt werden',
            start_error: 'Bewertung konnte nicht gestartet werden',
            archive_error: 'Bewertung konnte nicht archiviert werden',
            eval_error: 'Bewertung zur Evaluierung konnte nicht geladen werden',
            eval_min_score: 'Bitte bewerten Sie mindestens eine Domäne',
            eval_save_error: 'Domänenbewertungen konnten nicht gespeichert werden',
            review_error: 'Konnte nicht zur Überprüfung eingereicht werden',
            finalize_error: 'Bewertung konnte nicht abgeschlossen werden',
            start: 'Starten',
            start_confirm_title: 'Bewertung starten',
            start_confirm_message: 'Sind Sie sicher, dass Sie diese Bewertung starten möchten?',
            archive_confirm_title: 'Bewertung archivieren',
            archive_confirm_message: 'Sind Sie sicher, dass Sie diese Bewertung archivieren möchten?',
            evaluate_domains: 'Evaluieren',
            evaluate_domains_title: 'Domänen evaluieren',
            submit_for_review: 'Zur Überprüfung einreichen',
            finalize: 'Abschließen',
            archive: 'Archivieren',
            all_reviewers: 'Alle Prüfer müssen genehmigen',
            any_reviewer: 'Jeder Prüfer kann genehmigen',
            select_level: 'Reifegrad auswählen...',
            findings_placeholder: 'Ergebnisse, Notizen, Evidenzreferenzen...',
            no_domains: 'Keine Domänen für dieses Modell gefunden.',
        },
        trend_dashboard: {
            title: 'Trendübersicht',
            loading: 'Lade trend Daten...',
            score_trend: 'Bewertung Trend',
            domain_comparison: 'Domäne Vergleich',
            period: 'Zeitraum',
            load_error: 'Trendzusammenfassung konnte nicht geladen werden. Bitte erneut versuchen.',
            metrics_load_error: 'Trendmetriken konnten nicht geladen werden. Bitte erneut versuchen.',
            module: 'Modul',
            metric: 'Kennzahl',
            value: 'Wert',
            trend: 'Trend',
            aria_filters: 'Filter für Trendmetriken',
            showing_chart: 'Diagrammansicht',
            showing_table: 'Datentabellenansicht',
        },
        reporting_periods: {
            title: 'Berichtszeiträume',
            new: 'Neu Zeitraum',
            period_name: 'Zeitraum Name',
            start_date: 'Starten Datum',
            end_date: 'Ende Datum',
            no_periods: 'Keine reporting Zeiträume gefunden.',
            load_error: 'Berichtszeiträume konnten nicht geladen werden. Bitte erneut versuchen.',
            create_error: 'Berichtszeitraum konnte nicht erstellt werden',
            auto_generate_error: 'Berichtszeiträume konnten nicht automatisch generiert werden',
            status_error: 'Periodenstatus konnte nicht aktualisiert werden',
            start_collecting: 'Erfassung starten',
            mark_as_draft: 'Als Entwurf markieren',
            submit_for_review: 'Zur Überprüfung einreichen',
            publish: 'Veröffentlichen',
            auto_generate: 'Berichtszeiträume automatisch generieren',
            period_label_placeholder: 'z.B., Q1 2026',
            status_updated: 'Periodenstatus aktualisiert',
        },
        executive_summaries: {
            title: 'Zusammenfassungen',
            new: 'Neu Zusammenfassung',
            period: 'Zeitraum',
            generated_at: 'Generiert At',
            generated_by: 'Generiert By',
            no_summaries: 'Keine executive summaries gefunden.',
            generate: 'Generieren',
            load_error: 'Führungszusammenfassungen konnten nicht geladen werden. Bitte erneut versuchen.',
            generate_error: 'Führungszusammenfassung konnte nicht generiert werden',
            save_error: 'Führungszusammenfassung konnte nicht gespeichert werden',
        },
        audit_readiness: {
            title: 'Prüfungsbereitschaft',
            loading: 'Lade Audit readiness Daten...',
            overall_readiness: 'Gesamt Readiness',
            by_domain: 'By Domäne',
            evidence_coverage: 'Nachweis Abdeckung',
            gaps: 'Lücken',
            load_error: 'Aktuelle Bereitschaft konnte nicht geladen werden. Bitte erneut versuchen.',
            history_error: 'Bereitschaftsverlauf konnte nicht geladen werden. Bitte erneut versuchen.',
            calculate_error: 'Auditbereitschaft konnte nicht berechnet werden',
            aria_recalculate: 'Auditbereitschaftsbewertung neu berechnen',
            aria_current_readiness: 'Aktuelle Auditbereitschaft',
            aria_history: 'Verlauf der Bereitschaftsbewertung',
            recalculated: 'Auditbereitschaft neu berechnet',
            loading_sr: 'Auditbereitschaftsdaten werden geladen',
        },
        evidence_gaps: {
            title: 'Nachweislücken',
            domain: 'Domäne',
            control: 'Kontrolle',
            gap_type: 'Lücke Typ',
            severity: 'Schweregrad',
            no_gaps: 'Keine Nachweis Lücken gefunden.',
            load_error: 'Evidenzlücken konnten nicht geladen werden. Bitte erneut versuchen.',
            stats_error: 'Lückenstatistiken konnten nicht geladen werden. Bitte erneut versuchen.',
            create_error: 'Evidenzlücke konnte nicht erstellt werden',
            update_error: 'Evidenzlücke konnte nicht aktualisiert werden',
            status_error: 'Status konnte nicht aktualisiert werden',
            aria_create_new: 'Neue Evidenzlücke erstellen',
            aria_statistics: 'Statistiken zu Evidenzlücken',
            loading_sr: 'Evidenzlücken werden geladen',
            status_updated: 'Lückenstatus aktualisiert',
            entity_type_placeholder: 'z.B., Lieferant, System',
            all_modules: 'Alle Domänen',
            all_severities: 'Alle Schweregrade',
        },
        program_health: {
            title: 'Programmzustand',
            loading: 'Lade Programm Zustand Daten...',
            overall_health: 'Gesamt Zustand',
            by_module: 'By Modul',
            risk_areas: 'Risiko Areas',
            recommendations: 'Empfehlungen',
            load_error: 'Programmgesundheitsdaten konnten nicht geladen werden. Bitte erneut versuchen.',
            aria_key_metrics: 'Kennzahlen der Programmgesundheit',
            aria_module_scorecard: 'Modul-Bewertungskarten-Aufschlüsselung',
            loading_sr: 'Programmgesundheitsdaten werden geladen',
            trending_up: 'Aufwärtstrend',
            trending_down: 'Abwärtstrend',
            trending_stable: 'Stabil',
            data_loaded: 'Programmgesundheitsdaten geladen',
        },
        obligation_mappings: {
            title: 'Pflichtzuordnungen',
            create_mapping: 'Pflichtzuordnung erstellen',
            framework: 'Rahmenwerk',
            select_framework: 'Rahmenwerk auswählen...',
            obligation: 'Pflicht',
            obligation_ref: 'Pflichtreferenz',
            obligation_description: 'Pflichtbeschreibung',
            role: 'Rolle',
            assigned_role: 'Zugewiesene Rolle',
            assigned_department: 'Zugewiesene Abteilung',
            select_department: 'Abteilung auswählen...',
            control_ids: 'Kontroll-IDs',
            raci_assignments: 'RACI-Zuordnungen',
            create_raci: 'RACI-Zuordnung erstellen',
            activity: 'Aktivität',
            activity_name: 'Aktivitätsname',
            activity_description: 'Aktivitätsbeschreibung',
            responsible: 'Verantwortlich',
            select_users: 'Benutzer auswählen...',
            accountable: 'Rechenschaftspflichtig',
            select_user: 'Benutzer auswählen...',
            consulted: 'Konsultiert',
            informed: 'Informiert',
            review_frequency: 'Überprüfungsfrequenz',
            frequency_monthly: 'Monatlich',
            frequency_quarterly: 'Vierteljährlich',
            frequency_semi_annual: 'Halbjährlich',
            frequency_annual: 'Jährlich',
            no_mappings_found: 'Keine Pflichtzuordnungen gefunden.',
            no_raci_found: 'Keine RACI-Zuordnungen gefunden.',
            mapping_created: 'Verpflichtungszuordnung erstellt',
            mapping_updated: 'Pflichtzuordnung aktualisiert',
            mapping_deleted: 'Pflichtzuordnung gelöscht',
            raci_created: 'RACI-Zuweisung erstellt',
            raci_updated: 'RACI-Zuordnung aktualisiert',
            raci_deleted: 'RACI-Zuordnung gelöscht',
            aria_edit_mapping: 'Zuordnung {name} bearbeiten',
            aria_delete_mapping: 'Zuordnung {name} löschen',
            aria_edit_raci: 'RACI {name} bearbeiten',
            aria_delete_raci: 'RACI {name} löschen',
            confirm_delete_mapping: 'Diese Pflichtzuordnung löschen?',
            confirm_delete_raci: 'Diese RACI-Zuordnung löschen?',
            table_view: 'Tabellenansicht',
            matrix_view: 'Matrixansicht',
            print_export: 'Drucken / Exportieren',
            filter_framework: 'Nach Rahmenwerk filtern',
            no_matrix_data: 'Keine RACI-Zuweisungen zur Anzeige in der Matrixansicht.',
            aria_print_export: 'RACI-Matrix drucken oder exportieren',
        },
        governance_documents: {
            title: 'Governance-Dokumente',
            create_document: 'Governance-Dokument erstellen',
            document_title: 'Dokumenttitel',
            document_type: 'Dokumenttyp',
            content_url: 'Inhalts-URL',
            content_url_placeholder: 'https://...',
            framework_codes: 'Rahmencodes',
            select_frameworks: 'Rahmenwerke auswählen...',
            effective_date: 'Gültigkeitsdatum',
            review_date: 'Überprüfungsdatum',
            status: 'Status',
            version: 'Version',
            acknowledgments: 'Bestätigungen',
            acknowledge: 'Bestätigen',
            acknowledged_by: 'Bestätigt von',
            department: 'Abteilung',
            no_documents_found: 'Keine Governance-Dokumente gefunden.',
            draft: 'Entwurf',
            review: 'Überprüfung',
            approved: 'Genehmigt',
            issued: 'Ausgestellt',
            superseded: 'Abgelöst',
            document_created: 'Dokument erstellt',
            document_acknowledged: 'Dokument bestätigt',
            policy: 'Richtlinie',
            procedure: 'Verfahren',
            standard: 'Standard',
            guideline: 'Leitlinie',
        },
        governance_model: {
            title: 'Governance-Modell',
            create_model: 'Governance-Modell erstellen',
            edit_model: 'Governance-Modell bearbeiten',
            model_name: 'Modellname',
            description: 'Beschreibung',
            governance_type: 'Governance-Typ',
            type_centralized: 'Zentralisiert',
            type_federated: 'Föderiert',
            type_hybrid: 'Hybrid',
            framework_codes: 'Rahmenwerk-Codes',
            select_frameworks: 'Rahmenwerke auswählen...',
            review_frequency: 'Überprüfungshäufigkeit',
            freq_monthly: 'Monatlich',
            freq_quarterly: 'Vierteljährlich',
            freq_semi_annual: 'Halbjährlich',
            freq_annual: 'Jährlich',
            committees: 'Ausschüsse',
            committee_name: 'Ausschussname',
            committee_members: 'Mitglieder (kommagetrennt)',
            committee_mandate: 'Mandat',
            add_committee: 'Ausschuss hinzufügen',
            no_committees: 'Keine Ausschüsse definiert.',
            delegation_rules: 'Delegationsregeln',
            from_role: 'Von Rolle',
            to_role: 'An Rolle',
            scope: 'Umfang',
            add_delegation_rule: 'Delegationsregel hinzufügen',
            control_owner_summary: 'Kontrollinhaber-Zusammenfassung',
            no_raci_data: 'Keine RACI-Daten verknüpft.',
            activity: 'Aktivität',
            responsible: 'Verantwortlich',
            accountable: 'Rechenschaftspflichtig',
            consulted: 'Konsultiert',
            informed: 'Informiert',
            no_models_found: 'Keine Governance-Modelle gefunden.',
            model_created: 'Governance-Modell erstellt',
            model_updated: 'Governance-Modell aktualisiert',
            model_deleted: 'Governance-Modell gelöscht',
            confirm_delete: 'Dieses Governance-Modell löschen?',
            expand: 'Erweitern',
            collapse: 'Einklappen',
            aria_expand: 'Details für {name} erweitern',
            aria_edit: 'Governance-Modell {name} bearbeiten',
            aria_delete: 'Governance-Modell {name} löschen',
            aria_export_csv: '{name} als CSV exportieren',
            aria_export_json: '{name} als JSON exportieren',
            framework_read_permission_warning: 'Sie benötigen die Berechtigung regulatory_framework:read, um Frameworks auszuwählen. Bitten Sie einen Administrator, es zu gewähren.',
            select_members: 'Wählen Sie Ausschussmitglieder aus',
            select_from_role: 'Wählen Sie die delegierende Rolle aus',
            select_to_role: 'Wählen Sie die Empfangsrolle aus',
            mandate_markdown_hint: 'Markdown unterstützt: **fett**, Listen, Links.',
            scope_tab_obligation: 'Verpflichtung',
            scope_tab_framework: 'Rahmen',
            scope_tab_free_text: 'Freitext',
            select_obligation: 'Wählen Sie eine Verpflichtung aus',
            select_framework: 'Wählen Sie ein Framework aus',
            aria_remove_committee: 'Ausschuss {n} entfernen',
            aria_remove_delegation_rule: 'Delegationsregel {n} entfernen',
            no_frameworks_available: 'Keine Rahmenwerke verfügbar. Fügen Sie zuerst regulatorische Rahmenwerke hinzu.',
        },
        document_drafting: {
            title: 'Dokumententwurf & Genehmigung',
            document_title: 'Dokumenttitel',
            document_type: 'Dokumenttyp',
            status: 'Status',
            drafter: 'Verfasser',
            deadline: 'Frist',
            assign_drafter: 'Verfasser zuweisen',
            select_drafter: 'Verfasser auswählen...',
            assign: 'Zuweisen',
            submit_for_review: 'Zur Überprüfung einreichen',
            legal_review: 'Rechtliche Überprüfung',
            reviewer: 'Prüfer',
            select_reviewer: 'Prüfer auswählen...',
            comments: 'Kommentare',
            review_action: 'Überprüfungsaktion',
            approve: 'Genehmigen',
            request_changes: 'Änderungen anfordern',
            submit_review: 'Überprüfung einreichen',
            executive_approval: 'Leitungsgenehmigung',
            no_drafts_found: 'Keine Dokumente in Entwurfs-, Überprüfungs- oder Genehmigungsphase.',
            drafter_assigned: 'Verfasser zugewiesen',
            status_updated: 'Dokumentstatus aktualisiert',
            review_approved: 'Überprüfung genehmigt',
            changes_requested: 'Änderungen angefordert',
            document_approved: 'Dokument genehmigt',
            aria_assign: 'Verfasser für {name} zuweisen',
            aria_submit_review: '{name} zur Überprüfung einreichen',
            aria_review: '{name} überprüfen',
            aria_approve: '{name} genehmigen',
        },
        document_issuance: {
            title: 'Dokumentenausgabe & Verteilung',
            document_title: 'Dokumenttitel',
            document_type: 'Dokumenttyp',
            status: 'Status',
            version: 'Version',
            effective_date: 'Gültigkeitsdatum',
            distribution_scope: 'Verteilungsbereich',
            distribution_placeholder: 'Z.B.: Alle Abteilungen',
            issuance_number: 'Ausgabenummer',
            issuance_number_placeholder: 'Z.B.: ISS-2026-001',
            supersedes: 'Ersetzt Dokument',
            none: 'Keines',
            issue_document: 'Dokument ausgeben',
            ready_for_issuance: 'Bereit zur Ausgabe',
            issued_documents: 'Ausgegebene Dokumente',
            no_issued_documents: 'Keine ausgegebenen Dokumente gefunden.',
            view_lineage: 'Abstammung anzeigen',
            supersession_lineage: 'Ersetzungsabstammung',
            document_issued: 'Dokument ausgegeben',
            document_superseded: 'Dokument ersetzt',
            aria_issue: '{name} ausgeben',
            aria_view_lineage: 'Abstammung von {name} anzeigen',
        },
        acknowledgment_tracking: {
            title: 'Bestätigungsverfolgung',
            document_title: 'Dokument',
            acknowledged_count: 'Bestätigt',
            pending_count: 'Ausstehend',
            percentage: 'Abschluss',
            details: 'Einzelheiten',
            send_reminder: 'Erinnerung senden',
            acknowledgment_details: 'Bestätigungsdetails',
            user: 'Benutzer',
            department: 'Abteilung',
            acknowledged_at: 'Bestätigt am',
            status: 'Status',
            acknowledged: 'Bestätigt',
            no_issued_documents: 'Keine Dokumente zu verfolgen.',
            no_acknowledgments: 'Keine Bestätigungen erfasst.',
            reminder_sent: 'Erinnerung gesendet',
            aria_expand: 'Details für {name} anzeigen',
            aria_send_reminder: 'Erinnerung für {name} senden',
        },
        change_log: {
            title: 'Änderungsprotokoll',
            date: 'Datum',
            document: 'Dokument',
            change_type: 'Änderungstyp',
            actor: 'Akteur',
            summary: 'Zusammenfassung',
            export_csv: 'CSV exportieren',
            filters: 'Protokollfilter',
            filter_document: 'Nach Dokument filtern',
            all_documents: 'Alle Dokumente',
            filter_change_type: 'Nach Typ filtern',
            all_types: 'Alle Typen',
            date_from: 'Datum von',
            date_to: 'Datum bis',
            version_history: 'Versionshistorie',
            version_archive: 'Versionsarchiv',
            no_entries: 'Keine Einträge gefunden.',
            no_history: 'Keine Historie verfügbar.',
            exported: 'Protokoll exportiert',
            aria_export: 'Protokoll als CSV exportieren',
            aria_view_history: 'Historie von {name} anzeigen',
        },
        review_cadence: {
            title: 'Überprüfungskadenz',
            configure_cadence: 'Kadenz konfigurieren',
            edit_cadence: 'Kadenz bearbeiten',
            document: 'Dokument',
            select_document: 'Dokument auswählen...',
            review_frequency: 'Überprüfungshäufigkeit',
            freq_30: '30 Tage',
            freq_60: '60 Tage',
            freq_90: '90 Tage',
            freq_180: '180 Tage',
            freq_365: '365 Tage',
            last_reviewed: 'Zuletzt überprüft',
            next_review: 'Nächste Überprüfung',
            status: 'Status',
            overdue: 'Überfällig',
            on_track: 'Im Plan',
            days: 'Tage',
            horizon: 'Überprüfungshorizont',
            overdue_warning: 'Überfällige Überprüfungen',
            overdue_count: '{count} Dokument(e) überfällig.',
            no_cadences: 'Keine Kadenzen konfiguriert.',
            cadence_created: 'Kadenz erstellt',
            cadence_updated: 'Kadenz aktualisiert',
            aria_edit: 'Kadenz von {name} bearbeiten',
        },
        remediation_plans: {
            title: 'Maßnahmenpläne',
            create_plan: 'Maßnahmenplan erstellen',
            gap_id: 'Lückenreferenz',
            select_gap: 'Lücke auswählen...',
            plan_title: 'Titel',
            description: 'Beschreibung',
            priority: 'Priorität',
            priority_critical: 'Kritisch',
            priority_high: 'Hoch',
            priority_medium: 'Mittel',
            priority_low: 'Niedrig',
            assigned_to: 'Zugewiesen an',
            select_user: 'Benutzer auswählen...',
            target_date: 'Zieldatum',
            framework_code: 'Rahmenwerk',
            select_framework: 'Rahmenwerk auswählen...',
            gap_finding: 'Lückenfeststellung',
            action_items: 'Maßnahmenpunkte',
            owner: 'Verantwortlicher',
            deadline: 'Frist',
            planned: 'Geplant',
            in_progress: 'In Bearbeitung',
            completed: 'Abgeschlossen',
            verified: 'Verifiziert',
            no_plans_found: 'Keine Maßnahmenpläne gefunden.',
            evidence: 'Nachweis',
            plan_created: 'Abhilfeplan erstellt',
            action_items_hint: 'Maßnahmen (eine pro Zeile)',
        },
        statuses: {
            identified: 'Identifiziert',
            assigned: 'Zugewiesen',
            in_remediation: 'In der Sanierung',
            resolved: 'Gelöst',
            accepted_risk: 'Akzeptiertes Risiko',
            planned: 'Geplant',
            in_progress: 'In Bearbeitung',
            under_review: 'Wird überprüft',
            finalized: 'Abgeschlossen',
            archived: 'Archiviert',
            draft: 'Entwurf',
            active: 'Aktiv',
            upcoming: 'Demnächst',
            collecting: 'Sammeln',
            published: 'Veröffentlicht',
            review: 'Rezension',
            approved: 'Genehmigt',
            issued: 'Ausgestellt',
            superseded: 'Abgelöst',
            completed: 'Abgeschlossen',
            verified: 'Verifiziert',
        },
        severities: {
            critical: 'Kritisch',
            high: 'Hoch',
            medium: 'Mittel',
            low: 'Low',
        },
        priorities: {
            critical: 'Kritisch',
            high: 'Hoch',
            medium: 'Mittel',
            low: 'Low',
        },
        gap_types: {
            missing: 'Fehlt',
            expired: 'Abgelaufen',
            insufficient: 'Unzureichend',
        },
        document_types: {
            policy: 'Politik',
            procedure: 'Vorgehensweise',
            standard: 'Standard',
            guideline: 'Richtlinie',
            template: 'Vorlage (intern)',
        },
        maturity_levels: {
            level_1: 'Stufe 1 – Anfänglich',
            level_2: 'Ebene 2 – Entwicklung',
            level_3: 'Level 3 – Definiert',
            level_4: 'Stufe 4 – verwaltet',
            level_5: 'Stufe 5 – Optimierung',
        },
        grades: {
            excellent: 'Ausgezeichnet',
            good: 'Gut',
            fair: 'Fair',
            poor: 'Arm',
            critical: 'Kritisch',
            needs_improvement: 'Verbesserungsbedarf',
            not_assessed: 'Nicht bewertet',
        },
        modules: {
            data_mapping: 'Datenzuordnung',
            consent: 'Zustimmung',
            governance: 'Regierungsführung',
            incidents: 'Vorfälle',
            monitoring: 'Überwachung',
            classification: 'Klassifizierung',
            vendor_risk: 'Lieferantenrisiko',
            discovery: 'Entdeckung',
            deletion: 'Löschung',
        },
        cadences: {
            monthly: 'Monatlich',
            quarterly: 'Vierteljährlich',
            semi_annual: 'Halbjährlich',
            annual: 'Jährlich',
        },
        section_labels: {
            opening: 'Eröffnung',
            key_metrics: 'Schlüsselkennzahlen',
            highlights: 'Höhepunkte',
            concerns: 'Bedenken',
            recommendations: 'Empfehlungen',
            outlook: 'Ausblick',
        },
        out_of_100: '/ 100',
        count_gaps: '[[TOK_1]] Lücke',
        count_gaps_plural: '[[TOK_1]] Lücken',
        count_summaries: '[[TOK_1]] Zusammenfassung',
        count_summaries_plural: '[[TOK_1]] Zusammenfassungen',
        count_assessments: '[[TOK_1]] Bewertung',
        count_assessments_plural: '[[TOK_1]] Bewertungen',
        count_models: '[[TOK_1]] Modell',
        count_models_plural: '[[TOK_1]] Modelle',
        count_periods: '[[TOK_1]] Zeitraum',
        count_periods_plural: '[[TOK_1]] Zeiträume',
        count_metrics: '[[TOK_1]] Metrik',
        count_metrics_plural: '[[TOK_1]] Metriken',
        unknown_user: 'Unbekannter Benutzer',
        unknown_gap: 'Unbekannte Lücke',
        no_permission_title: 'Unzureichende Berechtigungen',
        no_permission_message: 'Sie haben keine Berechtigung, auf diese Seite zuzugreifen.',
        ac_vn_frameworks_title: 'VN Framework-Abdeckung',
        ac_vn_frameworks_body: 'Reifegradbewertungen decken alle sechs vietnamesischen Regulierungsrahmen ab: [[TOK_0]], Datenrecht, Telekommunikationsrecht, Cybersicherheitsrecht, [[TOK_1]] Recht und E-Commerce-Recht – jeweils mit rahmenspezifischen Bewertungskriterien.',
        ac_controller_processor_title: 'Controller vs. Prozessor',
        ac_controller_processor_body: 'Bei den Pflichtzuordnungen wird zwischen den Verantwortlichkeiten des Datenverantwortlichen und des Datenverarbeiters unterschieden. Weisen Sie mithilfe der RACI-Matrix Rollen zu, um sicherzustellen, dass jede Verpflichtung einen eindeutigen Eigentümer hat, unabhängig davon, ob die Organisation als Verantwortlicher oder Auftragsverarbeiter fungiert.',
        ac_versioned_evidence_title: 'Versionierter Beweispfad',
        ac_versioned_evidence_body: 'Bei jedem Statusübergang (Entwurf, Überprüfung, Genehmigt, Ausgestellt) wird ein zeitgestempelter, versionierter Datensatz erstellt, der als überprüfbarer Beweis dient. Das Änderungsprotokoll erfasst den gesamten Lebenszyklusverlauf des Dokuments.',
        ac_remediation_gap_link_title: 'Verbunden mit Bewertungslücken',
        ac_remediation_gap_link_body: 'Jeder Sanierungsplan ist direkt mit einer identifizierten Bewertungslücke verknüpft. Weisen Sie einen Eigentümer zu und legen Sie eine Zielfrist fest, um den Lösungsfortschritt von der Lücke bis zur Schließung zu verfolgen.',
        ac_annual_attestation_title: 'Jährlicher Zertifizierungszyklus',
        ac_annual_attestation_body: 'Die Berichtszeiträume richten sich nach der jährlichen Bescheinigungspflicht des vietnamesischen Datengesetzes. Nutzen Sie den Rhythmus „Jährlich“ (365-Tage-Zyklus), um attestierungsgerechte Zeiträume automatisch zu generieren.',
        ac_evidence_per_obligation_title: 'Nachweis gemäß Rahmenverpflichtung',
        ac_evidence_per_obligation_body: 'Beweislücken identifizieren fehlende, abgelaufene oder unzureichende Nachweise für jede Rahmenverpflichtung. Filtern Sie nach Domäne, um zu sehen, für welche regulatorischen Anforderungen keine unterstützenden Beweise vorliegen.',
        ac_cross_framework_title: 'Rahmenübergreifende Vollständigkeit',
        ac_cross_framework_body: 'Die Audit-Bereitschaft bietet eine rahmenübergreifende Vollständigkeitsansicht. Die Komponentenbewertungen spiegeln die Abdeckung aller abgebildeten Frameworks wider und heben Bereiche hervor, die vor einer Prüfung Aufmerksamkeit erfordern.',
        ac_cadence_default_title: 'Standard-Überprüfungsrhythmus',
        ac_cadence_default_body: 'Der standardmäßige Überprüfungsrhythmus beträgt 180 Tage. Überfällige Bewertungen werden automatisch gekennzeichnet. Passen Sie die Häufigkeit pro Dokument nach Bedarf an – die Optionen reichen von 30 bis 365 Tagen.',
        ac_templates_internal_title: 'Vorlagenklassifizierung',
        ac_templates_internal_body: 'Vorlagen werden als interne Dokumente klassifiziert. Verwenden Sie den Dokumenttyp „Vorlage“, um wiederverwendbare Governance-Artefakte mit ausschließlich internem Verteilungsbereich zu kennzeichnen.',
    },
    mcp_pending: {
        title: 'MCP — Ausstehende Schreibvorgänge',
        subtitle: 'Externe Claude-Clients schlagen hier Schreibvorgänge vor. Genehmigen oder lehnen Sie jeden Eintrag ab — Forseti führt erst nach Admin-Freigabe aus.',
        no_pending: 'Keine ausstehenden Schreibvorgänge.',
        col_tool: 'Werkzeug',
        col_preview: 'Vorschau',
        col_key: '[[TOK_0]]-Taste',
        col_requested: 'Angefordert',
        col_expires: 'Läuft ab',
        col_status: 'Status',
        status_pending: 'Ausstehend',
        status_approved: 'Genehmigt',
        status_declined: 'Abgelehnt',
        status_expired: 'Abgelaufen',
        status_executed: 'Ausgeführt',
        approve_label: 'Genehmigen',
        decline_label: 'Ablehnen',
        refresh_label: 'Aktualisieren',
        error_generic: 'Ausstehende Schreibvorgänge konnten nicht geladen werden.',
        confirm_approve: 'Bei Genehmigung wird das Werkzeug für Ihre Organisation mit den Berechtigungen des API key-Inhabers ausgeführt. Fortfahren?',
        confirm_decline: 'Diesen ausstehenden Schreibvorgang ablehnen? Dies kann nicht rückgängig gemacht werden.',
        advisory_banner: 'Ausstehende Schreibvorgänge laufen 24 Stunden nach Erstellung ab. Der stündliche GC-Sweep lehnt abgelaufene Einträge automatisch ab.',
    },
    audit_walkthrough: {
        title: 'Forseti — Generator für Audit-Begehungen',
        subtitle: 'Erstellen Sie eine strukturierte Begehung für ein Audit-Kickoff: Eröffnungsfrage je Kontrolle, erwartete Nachweise, Folgefragen, potenzielle Lücken.',
        audit_picker_label: 'Prüfung',
        audit_picker_hint: 'Wählen Sie ein geplantes Audit, um eine Begehung zu erstellen.',
        run_label: 'Begehung erstellen',
        running: 'Erstellung läuft…',
        results_heading: 'Begehung — {count} Kontrolle(n)',
        tokens_label: '≈ {count} Token',
        no_controls: 'Keine Kontrollen im Geltungsbereich. Fügen Sie dem Audit-Datensatz Kontrollen hinzu.',
        col_control: 'Kontrolle',
        col_question: 'Eröffnungsfrage',
        col_evidence: 'Nachweis',
        col_gaps: 'Potenzielle Lücken',
        expected_evidence_label: 'Erwartete Nachweise',
        followup_probes_label: 'Folgefragen',
        accept_label: 'Begehung akzeptieren',
        reject_label: 'Ablehnen',
        export_label: 'DOCX exportieren',
        resolve_summary: 'Ergebnis: {status}',
        error_generic: 'Begehung konnte nicht erstellt werden. Versuchen Sie es erneut oder prüfen Sie den Audit-Status.',
    },
    privilege_creep: {
        title: 'Forseti — Erkennung schleichender Rechteausweitung',
        subtitle: 'Periodische Prüfung von Rollenzuweisungen. Befunde sind beratend — Forseti widerruft niemals automatisch.',
        run_label: 'Jetzt prüfen',
        running: 'Prüfung läuft…',
        findings_heading: '{count} Befund(e)',
        no_findings: 'Keine schleichende Rechteausweitung festgestellt.',
        col_user: 'Benutzer',
        col_job_function: 'Jobfunktion',
        col_severity: 'Schweregrad',
        col_unexpected: 'Unerwartete Berechtigungen',
        col_remediation: 'Vorgeschlagene Behebung',
        col_status: 'Status',
        severity_critical: 'Kritisch',
        severity_high: 'Hoch',
        severity_medium: 'Mittel',
        severity_low: 'Niedrig',
        status_open: 'Offen',
        status_dismissed: 'Verworfen',
        status_remediated: 'Behoben',
        dismiss_label: 'Verwerfen',
        remediate_label: 'Als behoben markieren',
        note_label: 'Notiz (optional)',
        error_generic: 'Schleichende Rechteausweitung konnte nicht geprüft werden. Versuchen Sie es später erneut.',
        advisory_banner: 'Diese Befunde sind beratend. Forseti widerruft niemals automatisch Berechtigungen — besprechen Sie sie mit dem Rolleninhaber, bevor Sie handeln.',
    },
    compliance_rules: {
        rule_mapping: {
            title: 'Automatische Zuordnung von Compliance-Regeln',
            subtitle: 'Forseti geht ein installiertes Regulierungspaket durch und schlägt neue oder aktualisierte Compliance-Regeln vor, die auf den Quellartikeln basieren.',
            pack_picker_label: 'Regulierungspaket',
            pack_picker_hint: 'Wählen Sie ein installiertes Paket zum Zuordnen aus.',
            run_label: 'Karte aus der Packung',
            running: 'Kartierung…',
            results_heading: '[[TOK_1]] Vorschlag(e)',
            tokens_label: '≈ [[TOK_1]] Token aus Ihrem monatlichen Bucket',
            no_suggestions: 'Keine Vorschläge – der Inhalt des Pakets ist möglicherweise bereits vollständig von den bestehenden Regeln abgedeckt.',
            kind_new: 'Neue Regel',
            kind_refresh: 'Vorhandenes aktualisieren',
            kind_no_change: 'Keine Änderung erforderlich',
            col_kind: 'Freundlich',
            col_title: 'Vorgeschlagener Titel',
            col_existing: 'Bestehende Regel',
            col_source: 'Quelle',
            proposed_body_label: 'Vorgeschlagener Körper',
            source_quote_label: 'Quellenangabe',
            accept_selected: 'Ausgewählte akzeptieren',
            reject_all: 'Alles ablehnen',
            accept_all: 'Akzeptiere alles',
            resolve_summary: 'Lösung: [[TOK_2]] · [[TOK_3]] Regel(n) erstellt',
            error_generic: 'Die Regelzuordnung konnte nicht ausgeführt werden. Versuchen Sie es erneut oder überprüfen Sie den Paketcode.',
        },
    },
    access_accountability: {
        nav: {
            session_dashboard: 'Sitzungsübersicht',
            access_log: 'Zugriffsprotokoll',
            justification_review: 'Begründungsprüfung',
            investigations: 'Untersuchungen',
            pattern_analysis: 'Musteranalyse',
            anchoring_status: 'Verankerungsstatus',
            configuration: 'Konfiguration',
            access_policies: 'Zugriffsrichtlinien',
            review_campaigns: 'Überprüfungskampagnen',
            evidence_packages: 'Nachweispakete',
        },
        session_dashboard: {
            title: 'Sitzungsübersicht',
            loading: 'Lade Dashboard Daten...',
            total_sessions: 'Gesamt Sitzungen',
            active_sessions: 'Aktiv Sitzungen',
            avg_duration: 'Avg Dauer',
            concurrent_peak: 'Gleichzeitig Peak',
            auth_method_breakdown: 'Auth Methode Breakdown',
            geo_country_breakdown: 'Geo Land Breakdown',
            recent_session_events: 'Kürzliche Sitzung Ereignisse',
            user_id: 'Benutzer ID',
            session_id: 'Sitzung ID',
            ip_address: 'IP Adresse',
            auth_method: 'Auth Methode',
            started_at: 'Gestartet At',
            event_type: 'Ereignis Typ',
            all_event_types: 'Alle Ereignis Typen',
            filter_by_user: 'Filtern nach Benutzer ID...',
            no_active_sessions: 'No aktiv Sitzungen',
            no_session_events: 'Keine Sitzung Ereignisse gefunden',
            revoke: 'Widerrufen',
            revoke_session: 'Widerrufen Sitzung',
            revoke_reason: 'Grund',
            revoke_placeholder: 'Angeben ein reason für revoking dieses Sitzung...',
            session_label: 'Sitzung:',
            load_failed: 'Fehler beim load Sitzung Dashboard. Bitte versuchen Sie es erneut.',
            events_load_failed: 'Fehler beim load Sitzung Ereignisse. Bitte versuchen Sie es erneut.',
            revoke_failed: 'Fehler beim revoke Sitzung',
            session_events_loaded: '{n} session events geladen',
            event_types: {
                session_created: 'Sitzung erstellt',
                session_refreshed: 'Sitzung aktualisiert',
                session_expired: 'Sitzung abgelaufen',
                session_revoked: 'Sitzung widerrufen',
                session_terminated: 'Sitzung beendet',
                login_success: 'Anmeldung erfolgreich',
                login_failure: 'Anmeldefehler',
                logout: 'Abmelden',
                token_refresh: 'Token-Aktualisierung',
                mfa_challenge: 'MFA-Herausforderung',
            },
        },
        access_log: {
            title: 'Zugriffsprotokoll',
            user_id: 'Benutzer ID',
            resource: 'Ressource',
            action: 'Aktion',
            ip_address: 'IP Adresse',
            timestamp: 'Zeitstempel',
            no_logs: 'Keine Zugriff Protokoll Einträge gefunden.',
            filter_by_user: 'Filtern nach Benutzer ID...',
            load_failed: 'Fehler beim load Zugriff Protokoll. Bitte versuchen Sie es erneut.',
            export_success: 'Exportieren initiated successfully',
            export_failed: 'Fehler beim Export Zugriff Protokoll',
            record_count: 'Datensatz',
            record_count_plural: 'Datensätze',
            unclassified: 'Nicht klassifiziert',
            classification_missing: 'Klassifizierung fehlt',
            response_code: 'Antwortcode',
            classification_levels: {
                public: 'Oeffentlich',
                internal: 'Intern',
                confidential: 'Vertraulich',
                restricted: 'Eingeschraenkt',
                unclassified: 'Nicht klassifiziert',
            },
        },
        justification_review: {
            title: 'Begründungsprüfung',
            user_id: 'Benutzer ID',
            resource: 'Ressource',
            justification: 'Begründung',
            submitted_at: 'Eingereicht At',
            reviewer: 'Prüfer',
            no_reviews: 'Keine Begründung Überprüfungen gefunden.',
            load_failed: 'Fehler beim load Begründungen. Bitte versuchen Sie es erneut.',
            review_failed: 'Fehler beim Überprüfung Begründung',
            decline_failed: 'Fehler beim decline Zugriff',
            justification_count: 'Begründung',
            justification_count_plural: 'Begründungen',
            reviewed: 'Überprüft',
            concerning: 'Besorgniserregend',
            escalated: 'Eskaliert',
            link_investigation_placeholder: 'Verknüpfen zu ein Untersuchung (optional)',
            review_queue: 'Überprüfen Warteschlange',
            access_id_label: 'Zugangs-ID',
            access_id_placeholder: 'Zugriffsprotokoll-Eintrags-ID',
            select_user_placeholder: 'Benutzer auswählen (optional)',
            resource_type_label: 'Ressourcentyp',
            resource_type_placeholder: 'z.B. document, database',
            resource_id_label: 'Ressourcen-ID',
            resource_id_placeholder: 'Ressourcenkennung',
            reason_placeholder: 'Grund für den Zugriff auf diese Ressource...',
            create_failed: 'Fehler beim create justification',
            unclassified: 'Nicht klassifiziert',
            review_statuses: {
                pending: 'Ausstehend',
                reviewed: 'Bewertet',
                concerning: 'Betreffend',
                escalated: 'Eskaliert',
            },
            reason_codes: {
                business_need: 'Geschäftsbedarf',
                legal_obligation: 'Gesetzliche Verpflichtung',
                data_subject_request: 'Anfrage einer betroffenen Person',
                audit_requirement: 'Audit-Anforderung',
                incident_response: 'Reaktion auf Vorfälle',
                research: 'Forschung',
                administrative: 'Administrativ',
                other: 'Andere',
            },
        },
        investigations: {
            title: 'Untersuchung Workspace',
            new: 'Neu Untersuchung',
            subject: 'Betreff',
            investigator: 'Ermittler',
            opened_at: 'Geöffnet At',
            findings: 'Ergebnisse',
            no_investigations: 'Keine Untersuchungen gefunden.',
            load_failed: 'Fehler beim load Untersuchungen. Bitte versuchen Sie es erneut.',
            create_failed: 'Fehler beim create Untersuchung',
            timeline_add_failed: 'Fehler beim add Zeitverlauf Eintrag',
            link_access_failed: 'Fehler beim link Zugriff IDs',
            link_justification_failed: 'Fehler beim link Begründung IDs',
            close_failed: 'Fehler beim close Untersuchung',
            export_success: 'Exportieren initiated successfully',
            export_failed: 'Fehler beim Export Untersuchung',
            refresh_failed: 'Fehler beim refresh Untersuchung Detail. Bitte versuchen Sie es erneut.',
            update_failed: 'Fehler beim Aktualisieren der Untersuchung',
            investigation_count: 'Untersuchung',
            investigation_count_plural: 'Untersuchungen',
            title_placeholder: 'Untersuchung title',
            description_placeholder: 'Detailed Beschreibung von der Untersuchung...',
            assignee_placeholder: 'Benutzer ID von assignee (optional)',
            timeline_action_placeholder: 'e.g., Überprüft Zugriff logs',
            timeline_note_placeholder: 'Optionaler Hinweis',
            access_ids_placeholder: 'Zugriffs-ID-1, Zugriffs-ID-2',
            justification_ids_placeholder: 'Begründungs-ID-1, Begründungs-ID-2',
            findings_placeholder: 'Zusammenfassen der Untersuchung Ergebnisse...',
            by_actor: 'by',
            close_investigation: 'Schließen Untersuchung',
            add_timeline_failed: 'Fehler beim add Zeitverlauf Eintrag..',
            fetch_failed: 'Fehler beim fetch Untersuchungen..',
            change_status: 'Untersuchungsstatus ändern',
            details: 'Untersuchungsdetails',
            link_evidence: 'Beweis verknüpfen',
            link_justifications: 'Begründungen verknüpfen',
            access_ids_label: 'Zugangs-IDs',
            justification_ids_label: 'Begründungs-IDs',
            access_ids_link_placeholder: 'Zugriffs-ID-1, Zugriffs-ID-2',
            justification_ids_link_placeholder: 'Begründungs-ID-1, Begründungs-ID-2',
            investigations_loaded: '{n} investigations geladen',
            status_changed_to: 'Status geändert auf {status}',
            add_timeline_entry: 'Zeitleisteneintrag hinzufügen',
            add_access_ids: 'Zugangs-IDs hinzufügen',
            add_justification_ids: 'Begründungs-IDs hinzufügen',
            investigation_types: {
                anomaly_review: 'Anomalieüberprüfung',
                complaint_driven: 'Beschwerdeorientiert',
                scheduled_review: 'Geplante Überprüfung',
                whistleblower_report: 'Whistleblower-Bericht',
            },
            severity_labels: {
                low: 'Niedrig',
                medium: 'Mittel',
                high: 'Hoch',
                critical: 'Kritisch',
            },
            status_labels: {
                open: 'Offen',
                in_progress: 'In Bearbeitung',
                pending_review: 'Ausstehende Überprüfung',
                closed_substantiated: 'Abgeschlossen (begründet)',
                closed_unsubstantiated: 'Geschlossen (unbegründet)',
                closed_inconclusive: 'Geschlossen (nicht schlüssig)',
            },
            disposition_labels: {
                substantiated: 'Begründet',
                unsubstantiated: 'Unbegründet',
                inconclusive: 'Nicht schlüssig',
            },
        },
        pattern_analysis: {
            title: 'Musteranalyse',
            loading: 'Lade Muster Daten...',
            anomalies_detected: 'Anomalien Erkannt',
            patterns: 'Muster',
            by_user: 'By Benutzer',
            by_resource: 'By Ressource',
            time_range: 'Zeit Range',
            load_failed: 'Fehler beim analyze patterns. Bitte versuchen Sie es erneut.',
            top_resources: 'Top 10',
            access_by_hour: 'Zugriff nach Hour von Tag',
            access_by_day: 'Zugriff nach Tag von Week',
            fetch_failed: 'Fehler beim fetch Muster analysis..',
            analysis_loaded: 'Musteranalyse für {user} geladen, {n} Sitzungen gefunden',
            date_format_placeholder: 'TT/MM/JJJJ',
            access_by_hour_heading: 'Zugriff nach Tageszeit',
            access_by_day_heading: 'Zugriff nach Wochentag',
            by_classification: 'Nach Klassifizierungsstufe',
            top_accessed_resources: 'Am häufigsten aufgerufene Ressourcen',
            user_access_summary: 'Benutzerzugriffszusammenfassung',
            days: {
                sunday: 'Sonntag',
                monday: 'Montag',
                tuesday: 'Dienstag',
                wednesday: 'Mittwoch',
                thursday: 'Donnerstag',
                friday: 'Freitag',
                saturday: 'Samstag',
            },
            linked_access_logs: 'Verknüpfte Zugriffsprotokolle',
            linked_access_logs_desc: 'Zugriffsprotokolleinträge, die den erkannten Mustern für diesen Benutzer zugeordnet sind.',
        },
        anchoring_status: {
            title: 'Verankerungsstatus',
            loading: 'Lade anchoring Daten...',
            anchored: 'Verankert',
            pending: 'Ausstehend',
            failed: 'Fehlgeschlagen',
            last_anchor: 'Letzter Anker',
            no_records: 'Keine anchoring Datensätze gefunden.',
            status_load_failed: 'Fehler beim load anchoring Status. Bitte versuchen Sie es erneut.',
            proofs_load_failed: 'Fehler beim load Zugriff Nachweise. Bitte versuchen Sie es erneut.',
            verify_failed: 'Fehler beim verify Nachweis Kette. Bitte versuchen Sie es erneut.',
            anchor_failed: 'Fehler beim Anker Zugriff Nachweis',
            batch_anchor_failed: 'Fehler beim batch Anker Zugriff Nachweise',
            proof_count: 'Nachweis',
            proof_count_plural: 'Nachweise',
            anchor_single: 'Anker Single',
            anchor_batch: 'Anker Stapel',
            access_id_placeholder: 'Eingeben Zugriff ID zu Anker',
            batch_ids_placeholder: 'Zugriffs-ID-1, Zugriffs-ID-2, Zugriffs-ID-3',
            verify_chain: 'Verifizieren Kette',
            chain_breaks: 'Kette Breaks',
            total_checked: 'Gesamt Checked',
            anchor_placeholder: 'Eingeben Zugriff ID zu Anker',
            fetch_failed: 'Fehler beim fetch anchoring Status..',
            fetch_proofs_failed: 'Fehler beim fetch Nachweise..',
            access_id: 'Zugangs-ID',
            chain_sequence: 'Kettensequenz',
            proof_hash_label: 'Beweis-Hash',
            batch_id: 'Batch-ID',
            proofs_loaded: '{n} access proofs geladen',
            anchor_statuses: {
                pending: 'Ausstehend',
                submitted: 'Eingereicht',
                confirmed: 'Bestätigt',
                failed: 'Fehlgeschlagen',
            },
            anchor_types: {
                sha256_chain: 'SHA-256 Kette',
                blockchain_anchor: 'Blockchain-Anker',
                zkp_stub: 'ZKP Stub',
            },
        },
        configuration: {
            title: 'Konfiguration',
            session_settings: 'Sitzung Einstellungen',
            log_retention: 'Protokoll Aufbewahrung (days)',
            anomaly_threshold: 'Anomalie Schwellenwert',
            anchoring_enabled: 'Verankerung Aktiviert',
            save_config: 'Speichern Konfiguration',
            load_failed: 'Fehler beim load Konfiguration. Bitte versuchen Sie es erneut.',
            save_success: 'Konfiguration saved successfully',
            save_failed: 'Fehler beim save Konfiguration. Bitte versuchen Sie es erneut.',
            justification_rules: 'Begründung Regeln',
            reason_codes: 'Grund Codes',
            anchoring_settings: 'Verankerung Einstellungen',
            anchoring_method: 'Verankerung Methode',
            anchoring_frequency: 'Verankerung Häufigkeit',
            batch_interval: 'Stapel Interval (minutes)',
            eligibility_criteria: 'Berechtigung Kriterien',
            add_criterion_placeholder: 'Hinzufügen eligibility criterion...',
            retention_settings: 'Aufbewahrung Einstellungen',
            standard_retention: 'Standard Aufbewahrung (days)',
            sensitive_retention: 'Sensibel Aufbewahrung (days)',
            working_hours: 'Arbeits Hours',
            work_start: 'Starten Zeit',
            work_end: 'Ende Zeit',
            timezone: 'Zeitzone',
            timezone_placeholder: 'z.B. Asia/Ho_Chi_Minh',
            working_days: 'Arbeits Tage',
            concurrent_sessions: 'Gleichzeitig Sitzung Limits',
            concurrent_threshold: 'Gleichzeitig Sitzung Schwellenwert',
            classification_level: 'Klassifizierung Stufe',
            prompt_mode: 'Aufforderung Modus',
            grace_period: 'Toleranz Zeitraum (s)',
            code_placeholder: 'Code',
            is_custom: 'Benutzerdefiniert',
            label_placeholder: 'Bezeichnung',
            description_placeholder: 'Beschreibung',
            custom: 'Benutzerdefiniert',
            fetch_failed: 'Fehler beim fetch Konfiguration..',
            classification_levels: {
                public: 'Öffentlich',
                internal: 'Intern',
                confidential: 'Vertraulich',
                restricted: 'Eingeschränkt',
                unclassified: 'Nicht klassifiziert',
            },
            prompt_modes: {
                reason_only: 'Nur Grund',
                reason_text: 'Grund + Text',
                reason_text_supervisor: 'Grund + Text + Vorgesetzter',
            },
            anchoring_methods: {
                sha256_chain: 'SHA-256 Kette',
                blockchain_anchor: 'Blockchain-Anker',
                zkp_stub: 'ZKP Stub',
            },
            anchoring_frequencies: {
                realtime: 'Echtzeit',
                batched: 'Gestapelt',
                on_demand: 'Auf Anfrage',
            },
        },
        access_policies: {
            title: 'Zugriffsrichtlinien',
            create_policy: 'Zugriffsrichtlinie erstellen',
            policy_name: 'Richtlinienname',
            framework_code: 'Rahmenwerk',
            select_framework: 'Rahmenwerk auswählen...',
            review_frequency: 'Überprüfungshäufigkeit',
            scope: 'Geltungsbereich',
            no_policies_found: 'Keine Zugriffsrichtlinien gefunden.',
            policy_created: 'Zugriffsrichtlinie erstellt',
            frequency_labels: {
                monthly: 'Monatlich',
                quarterly: 'Vierteljährlich',
                semi_annual: 'Halbjährlich',
                annual: 'Jährlich',
            },
        },
        review_campaigns: {
            title: 'Zugriffsüberprüfungskampagnen',
            create_campaign: 'Überprüfungskampagne erstellen',
            reviewer: 'Prüfer',
            due_date: 'Fälligkeitsdatum',
            certify: 'Zertifizieren',
            no_campaigns_found: 'Keine Zugriffsüberprüfungskampagnen gefunden.',
            status_open: 'Offen',
            status_in_review: 'In Überprüfung',
            status_completed: 'Abgeschlossen',
            campaign_created: 'Prüfungskampagne erstellt',
            review_certified: 'Zugangsprüfung zertifiziert',
            certify_campaign: 'Kampagne {id} zertifizieren',
            policy_id: 'Richtlinien-ID',
            select_policy: 'Richtlinie auswählen...',
            reviewer_ids_label: 'Prüfer',
            select_reviewers: 'Prüfer auswählen...',
            status_labels: {
                open: 'Offen',
                in_review: 'In Überprüfung',
                completed: 'Abgeschlossen',
            },
            evidence_package_id: 'Beweispaket-ID',
        },
        evidence_packages: {
            title: 'Nachweispakete',
            generate_package: 'Nachweispaket generieren',
            export_type: 'Exporttyp',
            package_type: 'Pakettyp',
            framework_scope: 'Rahmenwerksumfang',
            period: 'Zeitraum',
            generated_by: 'Generiert von',
            generated_at: 'Generiert am',
            no_packages_found: 'Keine Nachweispakete gefunden.',
            package_generated: 'Beweispaket generiert',
            export_type_full: 'Vollständiger Export',
            export_type_summary: 'Zusammenfassung',
            export_type_certification_only: 'Nur Zertifizierung',
            package_type_access_review: 'Zugangsprüfung',
            package_type_investigation: 'Untersuchung',
            package_type_certification: 'Zertifizierung',
            package_type_authority_request: 'Behördenanfrage',
            period_start: 'Beginn des Zeitraums',
            period_end: 'Ende des Zeitraums',
            select_frameworks: 'Rahmenwerke auswählen...',
            completeness_col: 'Vollständigkeit',
            status_col: 'Status',
            generated_by_col: 'Erstellt von',
        },
        evidence_package_detail: {
            title: 'Beweispaketdetails',
            not_found: 'Beweispaket nicht gefunden.',
            package_metadata: 'Paketmetadaten',
            status: 'Status',
            item_count: 'Anzahl Elemente',
            disposition: 'Disposition',
            closed_at: 'Geschlossen am',
            completeness_dashboard: 'Vollständigkeitsübersicht',
            no_completeness_data: 'Keine Vollständigkeitsdaten verfügbar.',
            controls_covered: 'Kontrollen abgedeckt',
            missing: 'Fehlend',
            sign_off_tracker: 'Freigabeverfolgung',
            stage_framework_owner: 'Rahmenwerkeigentümer',
            stage_legal_compliance: 'Recht und Compliance',
            stage_internal_audit: 'Interne Revision',
            approved: 'Genehmigt',
            returned: 'Zurückgegeben',
            pending: 'Ausstehend',
            approve: 'Genehmigen',
            return_btn: 'Zurückgeben',
            sign_off_submitted: 'Freigabe eingereicht',
            artifacts: 'Artefakte',
            no_artifacts: 'Keine Artefakte gefunden.',
            template_id: 'Vorlagen-ID',
            description: 'Beschreibung',
            classification: 'Klassifikation',
            evidence_type: 'Beweistyp',
            framework_section: 'Rahmenabschnitt',
            history: 'Genehmigungshistorie',
            expand: 'Erweitern',
            collapse: 'Zuklappen',
            action: 'Aktion',
            actor: 'Akteur',
            timestamp: 'Zeitstempel',
            comment: 'Kommentar',
            close_case: 'Fall schließen',
            confirm_close: 'Schließen bestätigen',
            closure_notes: 'Abschlussnotizen',
            disposition_compliant: 'Konform',
            disposition_non_compliant: 'Nicht konform',
            disposition_partial: 'Teilweise',
            case_closed: 'Beweispaket geschlossen',
            export_package: 'Paket exportieren',
            export_complete: 'Beweispaket exportiert',
        },
    },
    consent_properties: {
        nav: {
            dashboard: 'Übersicht',
            properties: 'Eigenschaften',
            groups: 'Gruppen',
            bindings: 'Bindungen',
            change_requests: 'Änderungsanträge',
            comparison: 'Vergleich',
            inconsistencies: 'Inkonsistenzen',
            snapshot_schedules: 'Momentaufnahmepläne',
            golden_templates: 'Goldene Vorlagen',
            evidence_packs: 'Nachweispakete',
            audit: 'Prüfung',
        },
        select_property: 'Eigenschaft auswählen…',
        select_policy: 'Richtlinie auswählen…',
        select_properties: 'Eigenschaften auswählen…',
        select_target_properties: 'Zieleigenschaften auswählen…',
        select_owner: 'Eigentümer auswählen…',
        select_technical_contact: 'Technischen Kontakt auswählen…',
        property_statuses: {
            active: 'Aktiv',
            inactive: 'Inaktiv',
            pending: 'Ausstehend',
            decommissioned: 'Stillgelegt',
        },
        dashboard: {
            title: 'Übergreifende Eigenschaftsübersicht',
            loading: 'Lade Dashboard Daten...',
            total_properties: 'Gesamt Eigenschaften',
            active_properties: 'Aktiv Eigenschaften',
            snapshot_coverage: 'Snapshot-Abdeckung',
            properties_covered: 'Eigenschaften abgedeckt',
            total_bindings: 'Bindungen insgesamt',
            deployed_bindings: 'Bereitgestellt',
            pending_bindings: 'Ausstehende Bereitstellung',
            deployment_progress: 'Bereitstellungsfortschritt',
            on_target: 'Im Ziel',
            below_target: 'Unter Ziel',
            target_label: 'Ziel',
            total_groups: 'Gesamt Gruppen',
            pending_changes: 'Ausstehend Änderungen',
            inconsistencies: 'Inkonsistenzen',
            recent_activity: 'Kürzliche Aktivität',
            no_recent_activity: 'Keine kürzlichen Aktivitäten.',
            fetch_error: 'Fehler beim load Dashboard. Bitte versuchen Sie es erneut.',
        },
        properties: {
            title: 'Eigenschaftsregister',
            new: 'Neu Eigenschaft',
            edit: 'Bearbeiten Eigenschaft',
            property_name: 'Bezeichnung',
            property_type: 'Typ',
            identifier: 'Kennung',
            environment: 'Umgebung',
            owner_id: 'Eigentümer ID',
            technical_contact_id: 'Technisch Kontakt ID',
            decommission: 'Außerbetriebnahme',
            confirm_decommission: 'Are you sure you want zu decommission dieses property?',
            no_properties: 'Keine Eigenschaften gefunden.',
            all_environments: 'Alle Environments',
            all_types: 'Alle Typen',
            cmp_instance_id: '[[TOK_0]] Instanz-ID',
            deployment_date: 'Bereitstellungsdatum',
            identifier_placeholder: 'z. B. www.example.com oder com.example.app',
            owner_name: 'Eigentümer',
            technical_contact_name: 'Technischer Kontakt',
            sensitive_data_categories: 'Kategorien sensibler Daten',
            sensitive_data_categories_placeholder: 'Wählen Sie sensible Datenkategorien aus',
            requires_enhanced_review: 'Erfordert eine erweiterte Überprüfung',
            sensitive_review_status: 'Überprüfung sensibler Daten',
            sensitive_review_pending: 'Ausstehende Überprüfung',
            sensitive_review_approved: 'Genehmigt',
            sensitive_review_rejected: 'Abgelehnt',
            sensitive_review_submit: 'Bewertung abgeben',
            sensitive_review_approve: 'Genehmigen',
            sensitive_review_reject: 'Ablehnen',
            sensitive_review_notes: 'Überprüfen Sie die Notizen',
            sensitive_review_notes_placeholder: 'Bewertungsnotizen eingeben...',
            record_withdrawal: 'Auszahlung aufzeichnen',
            withdrawal_subject_id: 'Betreff-ID',
            withdrawal_consent_id: 'Einwilligungs-ID',
            withdrawal_reason: 'Grund',
            withdrawal_downstream_systems: 'Nachgelagerte Systeme',
            withdrawal_downstream_placeholder: 'System-1, System-2',
            withdrawal_success: 'Der Widerruf wurde erfolgreich weitergegeben.',
            withdrawal_error: 'Die Auszahlung konnte nicht verbreitet werden.',
            withdrawal_data_subject_id: 'ID der betroffenen Person',
            withdrawal_data_subject_id_placeholder: 'z. B. usr_abc123',
            withdrawal_consent_record_id: 'Einwilligungsdatensatz-ID',
            withdrawal_consent_record_id_placeholder: 'z. B. consent_xyz789',
            withdrawal_purposes: 'Zurückgezogene Zwecke',
            withdrawal_purposes_placeholder: 'Wählen Sie die Zwecke aus, zu denen Sie Ihre Einwilligung widerrufen möchten...',
            withdrawal_withdrawn_at: 'Auszahlungsdatum',
            withdrawal_tasks_created: 'Aufgaben erstellt',
            withdrawal_affected_bindings: 'Betroffene Bindungen',
            withdrawal_affected_activities: 'Betroffene Verarbeitungsaktivitäten',
            withdrawal_history: 'Auszahlungsverlauf',
        },
        groups: {
            title: 'Eigenschaftsgruppen',
            new: 'Neu Gruppe',
            group_name: 'Gruppe Name',
            member_count: 'Mitglieder',
            no_groups: 'Keine property groups gefunden.',
            policies: 'Richtlinien',
            confirm_delete: 'Sind Sie sicher, dass Sie diese Gruppe löschen möchten?',
        },
        bindings: {
            title: 'Bindungsmatrix',
            property: 'Eigenschaft',
            purpose: 'Zweck',
            legal_basis: 'Rechtlich Grundlage',
            bound: 'Gebunden',
            no_bindings: 'Keine bindings gefunden.',
            bind_policy: 'Bindungsrichtlinie',
            bulk_bind: 'Massenbindung',
            bind_policy_to_property: 'Richtlinie an Eigentum binden',
            bulk_bind_policy: 'Massenbindungsrichtlinie',
            unbound: 'Ungebunden',
            policy_id: 'Richtlinien-ID',
            version_placeholder: 'z. B. 1.0.0',
            property_ids_placeholder: 'Prop-ID-1, Prop-ID-2, Prop-ID-3',
            binding_name: 'Bindung',
            property_name: 'Eigenschaftsname',
            policy_name: 'Richtlinienname',
            bindings_list: 'Bindungsliste',
            binding_actions: {
                start_deploy: 'Bereitstellung starten',
                mark_deployed: 'Als bereitgestellt markieren',
                rollback: 'Zurückrollen',
            },
        },
        change_requests: {
            title: 'Änderungsantragsprozess',
            new: 'Neu Ändern Anfrage',
            requester: 'Antragsteller',
            change_type: 'Ändern Typ',
            property: 'Eigenschaft',
            submitted_at: 'Eingereicht At',
            no_requests: 'Keine change requests gefunden.',
            fetch_pipeline_error: 'Fehler beim fetch Pipeline. Bitte versuchen Sie es erneut.',
            fetch_list_error: 'Fehler beim fetch change requests. Bitte versuchen Sie es erneut.',
            create_error: 'Fehler beim create change request. Bitte versuchen Sie es erneut.',
            action_error: 'Fehler beim perform Aktion. Bitte versuchen Sie es erneut.',
            approver_name: 'Genehmiger',
            placeholder_target_props: 'prop-id-1, prop-id-2',
            view_all: 'Alle',
            view_my_properties: 'Meine Eigenschaften',
            stage_requests: '{stage}-Anfragen',
        },
        comparison: {
            title: 'Vergleichsarbeitsbereich',
            select_properties: 'Auswählen Eigenschaften zu Vergleichen',
            compare: 'Vergleichen',
            no_comparison: 'Auswählen bei least two Eigenschaften zu compare.',
            fetch_error: 'Fehler beim fetch comparison reports. Bitte versuchen Sie es erneut.',
            run_error: 'Fehler beim Durchlauf comparison. Bitte versuchen Sie es erneut.',
            save_notes_error: 'Fehler beim save Hinweise. Bitte versuchen Sie es erneut.',
            scan_complete: 'Inkonsistenz Scan completed successfully.',
            scan_error: 'Fehler beim Durchlauf inconsistency Scan. Bitte versuchen Sie es erneut.',
            min_two_properties: 'Bitte provide bei least 2 property IDs für comparison.',
            view_inconsistencies: 'Inkonsistenzen anzeigen',
            click_to_select: 'Klicken Sie, um zwei oder mehr Eigenschaften auszuwählen',
            no_properties_available: 'Keine Eigenschaften verfügbar',
            no_matching_properties: 'Keine übereinstimmenden Eigenschaften',
            select_at_least_two_props: 'Wählen Sie mindestens zwei Eigenschaften aus der Dropdown-Liste.',
            no_differences_found: 'Keine Unterschiede zwischen den ausgewählten Eigenschaften gefunden.',
            found_inconsistencies: '{count} Inkonsistenzen in {properties} Eigenschaften und {bindings} Bindungen gefunden.',
        },
        inconsistencies: {
            title: 'Inkonsistenzliste',
            property: 'Eigenschaft',
            field: 'Feld',
            expected: 'Erwartet',
            actual: 'Tatsächlich',
            severity: 'Schweregrad',
            no_inconsistencies: 'Keine inconsistencies gefunden.',
            trend: 'Inkonsistenztrend',
            trend_chart_label: 'Inkonsistenz-Trenddiagramm, das die Anzahl im Zeitverlauf zeigt',
            acknowledge: 'Bestätigen',
            resolve: 'Lösen',
            suppress: 'Unterdrücken',
            cr_id_placeholder: 'CR-Kennung',
            view_all: 'Alle',
            view_my_properties: 'Meine Eigenschaften',
            view_dpo_review: '[[TOK_0]] Überprüfungswarteschlange',
            change_request_id_required: 'Um diese Inkonsistenz zu beheben, ist eine Änderungsanforderungs-ID erforderlich.',
        },
        snapshot_schedules: {
            title: 'Momentaufnahmepläne',
            new: 'Neu Planen',
            schedule_name: 'Planen Name',
            frequency: 'Häufigkeit',
            next_run: 'Nächster Ausführen',
            last_run: 'Letzter Ausführen',
            no_schedules: 'Keine Snapshot Zeitpläne gefunden.',
            target_type: 'Zieltyp',
            target_id: 'Ziel-ID',
            custom_frequency_days: 'Benutzerdefinierte Häufigkeit (Tage)',
            time_of_day: 'Tageszeit',
            time: 'Zeit',
            retention_days: 'Aufbewahrung (Tage)',
            execute_now: 'Jetzt ausführen',
            placeholder_days: 'z.B. 10',
            target_name: 'Zielname',
        },
        golden_templates: {
            title: 'Goldene Vorlagen',
            new: 'Neu Vorlage',
            template_name: 'Vorlage Name',
            property_type: 'Eigenschaft Typ',
            no_templates: 'Keine golden Vorlagen gefunden.',
            applicable_group_ids: 'Anwendbare Gruppen-IDs (durch Kommas getrennt)',
            applicable_groups: 'Anwendbare Gruppen',
            purposes: 'Zwecke',
            legal_bases: 'Rechtliche Grundlagen',
            banner_config: 'Bannerkonfiguration',
            consent_settings: 'Einwilligungseinstellungen',
            group_ids_placeholder: 'Gruppen-ID-1, Gruppen-ID-2',
            apply_to_property: 'Auf Eigenschaft anwenden',
            apply_to_group: 'Auf Gruppe anwenden',
            apply_success: 'Vorlage erfolgreich angewendet.',
            applications: 'Anwendungsverlauf',
            no_applications: 'Noch keine Vorlagenanwendungen.',
            no_configuration_details: 'Vorlage hat keine Konfigurationsdetails. Bearbeiten Sie die Vorlage, um Zwecke, Rechtsgrundlagen, Banner-Einstellungen oder Einwilligungseinstellungen hinzuzufügen.',
        },
        rollouts: {
            title: 'Vorlagen-Rollouts',
            rollout_status: 'Rollout-Status',
            confirmed: 'Bestätigt',
            pending: 'Ausstehend',
            failed: 'Fehlgeschlagen',
            confirm: 'Eigenschaft bestätigen',
            confirm_success: 'Eigenschaft im Rollout bestätigt.',
            can_close: 'Alle Eigenschaften bestätigt — Rollout abgeschlossen',
            cannot_close: 'Warte auf Eigenschaftsbestätigungen',
            no_rollouts: 'Keine Rollouts gefunden.',
            in_progress: 'In Bearbeitung',
            completed: 'Abgeschlossen',
            cancelled: 'Abgebrochen',
            reject: 'Eigenschaft ablehnen',
            reject_success: 'Eigenschaft im Rollout abgelehnt.',
            confirm_all: 'Alle bestätigen',
            reject_all: 'Alle ablehnen',
            confirm_label: 'Rollout bestätigen für',
            reject_label: 'Rollout ablehnen für',
            confirm_all_label: 'Alle ausstehenden Rollouts bestätigen',
            reject_all_label: 'Alle ausstehenden Rollouts ablehnen',
            no_properties_in_rollout: 'Diese Einführung hat keine Eigenschaften.',
        },
        analytics: {
            title: 'Eigenschaftsanalyse',
            opt_in_rate: 'Opt-in-Rate',
            opt_out_rate: 'Opt-out-Rate',
            withdrawal_rate: 'Widerrufsrate',
            total_consents: 'Gesamte Einwilligungen',
            total_withdrawals: 'Gesamte Widerrufe',
            compliance_score: 'Compliance-Bewertung',
            non_compliant: 'Nicht-konforme Eigenschaften',
            no_non_compliant: 'Alle Eigenschaften sind konform.',
            threshold: 'Compliance-Schwellenwert',
            property_id: 'Immobilien-ID',
            compliant: 'Konform',
            non_compliant_status: 'Nicht konform',
            compliance_help_summary: 'Wie wird der Compliance-Score berechnet und wie behebe ich ihn?',
            compliance_help_intro: 'Eine Eigenschaft wird als nicht konform gekennzeichnet, wenn ihre Bewertung unter 80 % liegt. Die Punktzahl wird wie folgt berechnet:',
            compliance_help_with_template_label: 'Wenn ein Golden Template angewendet wird:',
            compliance_help_with_template_text: '% der Konfigurationsschlüssel (Zwecke, legal_bases, banner_config, consent_settings), die genau mit der Vorlage übereinstimmen.',
            compliance_help_no_template_label: 'Wenn kein Golden Template angewendet wird:',
            compliance_help_no_template_text: '% der Bindungen (der Eigenschaft zugewiesene Einwilligungstypen) mit deployment_status = bereitgestellt. Eine Eigenschaft ohne Bindungen hat standardmäßig den Wert 100 %.',
            compliance_help_fix_intro: 'Um eine Eigenschaft aus dieser Liste zu entfernen, führen Sie einen der folgenden Schritte aus:',
            compliance_help_fix_deploy_label: 'Stellen Sie seine Bindungen bereit',
            compliance_help_fix_deploy_text: 'Öffnen Sie die Seite „Bindungsmatrix“ und setzen Sie den Bereitstellungsstatus jeder Bindung auf „Bereitgestellt“.',
            compliance_help_fix_template_label: 'Wenden Sie eine goldene Vorlage an',
            compliance_help_fix_template_text: 'Verwenden Sie „Auf Gruppe anwenden“ in der Vorlage und bestätigen Sie dann das Rollout für diese Eigenschaft. Stellen Sie sicher, dass die Konfiguration der Eigenschaft mit der Vorlage übereinstimmt.',
            compliance_help_fix_decommission_label: 'Entsorgen Sie die Immobilie',
            compliance_help_fix_decommission_text: 'Verwenden Sie die Schaltfläche „Außerbetriebnahme“ im Detailfenster der Immobilie, wenn sie nicht mehr verwendet wird.',
            compliance_help_fix_no_bindings_label: 'Entfernen Sie alle Bindungen',
            compliance_help_fix_no_bindings_text: 'Wenn eine Eigenschaft keine Vorlage und keine Bindungen hat, wird sie standardmäßig mit 100 % bewertet.',
        },
        evidence_packs: {
            title: 'Nachweispakete',
            new: 'Neu Paket',
            pack_name: 'Paket Name',
            properties: 'Eigenschaften',
            generated_at: 'Generiert At',
            no_packs: 'Keine Nachweis packs gefunden.',
            generate: 'Generieren',
            content_type_consent_records: 'Einwilligung Datensätze',
            content_type_policy_versions: 'Richtlinie Versionen',
            content_type_binding_history: 'Bindung Verlauf',
            content_type_change_requests: 'Ändern Anfragen',
            content_type_inconsistency_reports: 'Inkonsistenz Berichte',
            content_type_snapshot_data: 'Snapshot Daten',
            content_type_audit_trail: 'Prüfprotokoll',
        },
        audit: {
            title: 'Einwilligungseigenschaftsprüfung',
            event_type: 'Ereignis Typ',
            entity_type: 'Entität Typ',
            entity_id: 'Entität ID',
            actor: 'Akteur',
            timestamp: 'Zeitstempel',
            no_events: 'Keine Audit Ereignisse gefunden.',
            entity_type_property: 'Eigenschaft',
            entity_type_group: 'Gruppe',
            entity_type_binding: 'Bindung',
            entity_type_change_request: 'Änderungsanfrage',
            entity_type_golden_template: 'Goldene Vorlage',
            entity_type_snapshot_schedule: 'Snapshot-Zeitplan',
            entity_type_inconsistency: 'Inkonsistenz',
            entity_type_evidence_pack: 'Nachweispaket',
            action_created: 'Erstellt',
            action_updated: 'Aktualisiert',
            action_deleted: 'Gelöscht',
            action_decommissioned: 'Außer Betrieb',
            action_status_changed: 'Status geändert',
            action_submitted: 'Eingereicht',
            action_approved: 'Genehmigt',
            action_rejected: 'Abgelehnt',
            action_deployed: 'Bereitgestellt',
            action_rolled_back: 'Zurückgesetzt',
            action_paused: 'Pausiert',
            action_resumed: 'Fortgesetzt',
            action_cancelled: 'Abgebrochen',
            action_acknowledged: 'Bestätigt',
            action_resolved: 'Gelöst',
            action_suppressed: 'Unterdrückt',
            action_executed: 'Ausgeführt',
        },
        property_types: {
            website: 'Website',
            mobile_app: 'Mobile App',
            ott: 'OTT',
            iot_device: 'IoT-Gerät',
            kiosk: 'Kiosk',
            api_service: 'API-Dienst',
            sdk: 'SDK',
        },
        environments: {
            production: 'Produktion',
            staging: 'Inszenierung',
            development: 'Entwicklung',
            testing: 'Test',
        },
        group_types: {
            brand: 'Marke',
            region: 'Region',
            product_line: 'Produktlinie',
            business_unit: 'Geschäftseinheit',
            custom: 'Benutzerdefiniert',
        },
        target_types: {
            property: 'Eigenschaft',
            group: 'Gruppe',
            all: 'Alle',
        },
        frequencies: {
            hourly: 'Stündlich',
            daily: 'Täglich',
            weekly: 'Wöchentlich',
            monthly: 'Monatlich',
            custom: 'Benutzerdefiniert',
        },
        binding_statuses: {
            current: 'Aktuell',
            outdated: 'Veraltet',
            pending: 'Ausstehend',
            deploying: 'Wird bereitgestellt',
            rolled_back: 'Zurückgesetzt',
        },
        sensitive_categories: {
            health: 'Gesundheitsdaten',
            biometric: 'Biometrische Daten',
            genetic: 'Genetische Daten',
            racial_ethnic: 'Rasse/ethnische Herkunft',
            political_opinions: 'Politische Meinungen',
            religious_beliefs: 'Religiöse Überzeugungen',
            trade_union: 'Gewerkschaftsmitgliedschaft',
            sexual_orientation: 'Sexuelle Orientierung',
            criminal_records: 'Strafregister',
            financial: 'Finanzdaten',
            children: 'Kinderdaten',
            geolocation: 'Präzise Geolokalisierung',
        },
        export_csv: 'CSV exportieren',
        exporting: 'Exportiere...',
        page_x_of_y: 'Seite {page} von {total}',
        regulatory: {
            capture_method_guidance: '[[TOK_0]] erfordert einen Einwilligungsnachweis, der mit dem Erfassungskanal übereinstimmt. Eigenschaftstypen werden den Einwilligungserfassungsmethoden zugeordnet: Website/OTT = Banner-basierte Einwilligung, mobile App/SDK = In-App-Zustimmungsfluss, Kiosk = physische/Bildschirm-Zustimmungserfassung, [[TOK_1]]-Dienst = programmatische Einwilligung, IoT-Gerät = Einwilligungsmechanismus auf Geräteebene.',
            dashboard_metrics_info: 'Dieses Dashboard bietet dem [[TOK_0]] eine einzige Ansicht des Einwilligungsstatus über alle digitalen Eigenschaften hinweg. Zu den wichtigsten Kennzahlen gehören: Prozentsatz der Bindungsabdeckung (bereitgestellt im Vergleich zur Gesamtzahl der Bindungen), Einhaltung der Vorlage über das Inkonsistenzen-Widget, ausstehende Änderungsanforderungen, die überprüft werden müssen, und Aufschlüsselung des Eigenschaftsstatus, die Eigenschaften mit aktivem, inaktivem oder stillgelegtem Status anzeigt. Immobilien mit sensiblen Datenkategorien werden über das Immobilienregister verfolgt.',
            change_request_impact_info: 'Änderungsanträge, die sich auf Einwilligungseigenschaften auswirken, müssen die regulatorischen Auswirkungen dokumentieren: welche [[TOK_0]] Anforderungen betroffen sind, ob die Änderung Auswirkungen auf die Verarbeitung sensibler Daten hat (Art. 2.4) und ob die Änderung eine erneute Einwilligung der betroffenen Personen erfordert. In der Zusammenfassung der Auswirkungen in jeder Änderungsanforderung sind die [[TOK_1]] regulatorischen Referenzen für Prüfnachweise aufgeführt.',
            outdated_binding_warning: 'Bindungen mit dem Status „veraltet“ weisen darauf hin, dass eine Eigenschaft eine Richtlinienversion ausführt, die nicht aktuell ist. Diese Eigenschaften entsprechen möglicherweise nicht den neuesten [[TOK_0]]-Anforderungen oder Aktualisierungen der Organisationsrichtlinien. Überprüfen und aktualisieren Sie veraltete Bindungen umgehend, um die [[TOK_1]]-Konformität in allen Einwilligungseigenschaften aufrechtzuerhalten.',
            template_pdpl_alignment: 'Gemäß [[TOK_0]] Art. 11, goldene Vorlagen müssen Zwecke mit Rechtsgrundlagen verknüpfen. Bannerkonfigurationen müssen ein Opt-in (nicht ein Opt-out) gemäß Art. erzwingen. 11.3 ausdrückliche Zustimmung. In den Vorlagen muss ein Widerrufsmechanismus gemäß Art. 12. Bei sensiblen Daten (Art. 2.4) müssen Vorlagen eine ausdrückliche schriftliche oder gleichwertige Einwilligung erfordern – eine Click-through-Akzeptanz reicht nicht aus.',
        },
    },
    localization: {
        nav: {
            dashboard: 'Übersicht',
            market_packs: 'Marktpakete',
            language_packs: 'Sprachpakete',
            frameworks: 'Regulatorische Rahmenwerke',
            mappings: 'Modulzuordnungen',
            submissions: 'Paketeinreichungen',
            translations: 'Übersetzungsvorschau',
            audit: 'Prüfprotokoll',
        },
        dashboard: {
            title: 'Lokalisierungsübersicht',
            loading: 'Lade Dashboard Daten...',
            active_market_packs: 'Aktiv Markt Pakete',
            published_packs_available: 'Veröffentlicht market packs available',
            language_packs: 'Sprache Pakete',
            total_language_packs: 'Gesamt language packs registered',
            active_regulatory_frameworks: 'Aktiv Regulatorisch Rahmenwerke',
            frameworks_active: 'Rahmenwerke mit aktiv Status',
            pending_pack_submissions: 'Ausstehend Paket Einreichungen',
            submissions_awaiting_review: 'Einreichungen awaiting Überprüfung',
            recent_audit_events: 'Kürzliche Audit Ereignisse',
            no_recent_audit: 'No recent Audit Ereignisse.',
            event_type: 'Ereignis Typ',
            entity_type: 'Entität Typ',
            entity_id: 'Entität ID',
            actor: 'Akteur',
            timestamp: 'Zeitstempel',
        },
        market_packs: {
            title: 'Marktpaketkatalog',
            new: 'Neu Markt Paket',
            pack_name: 'Paket Name',
            market: 'Markt',
            locale: 'Sprache',
            no_packs: 'Keine market packs gefunden.',
        },
        language_packs: {
            title: 'Sprachpakete',
            new: 'Neu Sprache Paket',
            language: 'Sprache',
            locale_code: 'Sprache Code',
            completeness: 'Vollständigkeit',
            completeness_detail: 'Vollständigkeitsdetails',
            overall_completeness: 'Gesamtvollständigkeit',
            total_keys: 'Gesamtschlüssel',
            translated_keys: 'Übersetzte Schlüssel',
            missing_keys: 'Fehlende Schlüssel',
            namespace_breakdown: 'Namensraumaufschlüsselung',
            namespace: 'Namensraum',
            translated: 'Übersetzt',
            no_packs: 'Keine language packs gefunden.',
            install_language_pack: 'Sprachpaket installieren',
            available_packs: 'Verfügbare Sprachpakete',
            install: 'Installieren',
            all_installed: 'Alle Sprachpakete sind bereits installiert.',
            install_success: 'Sprachpaket erfolgreich installiert.',
            market: 'Markt',
            featured: 'Hervorgehoben',
        },
        frameworks: {
            title: 'Regulatorische Rahmenwerke',
            new: 'Neu Rahmenwerk',
            framework_name: 'Rahmenwerk Name',
            jurisdiction: 'Gerichtsbarkeit',
            effective_date: 'Gültig Datum',
            no_frameworks: 'Keine regulatory frameworks gefunden.',
            view_requirements: 'Anforderungen anzeigen',
            hide_requirements: 'Anforderungen ausblenden',
            show_legacy: 'Legacy-Rahmenwerke anzeigen',
            effective_until: 'Gültig bis',
            effective_on: 'Gültig ab',
            replaced_by: 'Ersetzt durch',
            replaces_label: 'Ersetzt',
            status_legacy: 'Veraltet',
            status_upcoming: 'Bevorstehend',
            watchlist: 'Beobachtungsliste',
            watchlist_empty: 'Kein Entwurf oder bevorstehende Frameworks',
            watchlist_empty_desc: 'Zur Überwachung werden hier Frameworks mit dem Status „Entwurf“ oder „bevorstehend“ angezeigt.',
            expected_effective: 'Wirksam erwartet',
            effective_date_tbd: 'Datum des Inkrafttretens: TBD',
            activate: 'Aktivieren',
            ai_law_title: 'Vietnam [[TOK_0]] Gesetz',
            ai_risk_classification: '[[TOK_0]] Risikoklassifizierung',
            ai_system_dossier: '[[TOK_0]] Systemdossier',
            ai_labeling_checklist: '[[TOK_0]] Kennzeichnung und Offenlegung',
            ai_incident_report: '[[TOK_0]] Vorfallbericht',
            ai_impact_assessment: '[[TOK_0]] Folgenabschätzung',
            ai_sandbox_application: 'Sandbox-Anwendung',
            ai_sandbox_monitoring: 'Sandbox-Überwachung',
            ai_sandbox_completion: 'Sandbox-Abschluss',
            ai_submission_tracker: 'Einreichungs-Tracker',
            ai_evidence_capture: 'Beweiserfassung',
            risk_level_minimal: 'Minimales Risiko',
            risk_level_limited: 'Begrenztes Risiko',
            risk_level_high: 'Hohes Risiko',
            risk_level_unacceptable: 'Inakzeptables Risiko',
            submission_status_draft: 'Entwurf',
            submission_status_submitted: 'Eingereicht',
            submission_status_returned: 'Zur Änderung zurückgeschickt',
            submission_status_accepted: 'Akzeptiert',
            submission_status_rejected: 'Abgelehnt',
            submission_status_closed: 'Geschlossen',
            ecommerce_law_title: 'Vietnamesisches E-Commerce-Gesetz',
            ecommerce_platform_classification: 'Plattformklassifizierung',
            ecommerce_seller_register: 'Verkäuferregister',
            ecommerce_complaint_register: 'Beschwerderegister',
            ecommerce_takedown_register: 'Takedown-Register',
            ecommerce_submission_tracking: 'Einreichungsverfolgung',
            ecommerce_dossier_checklist: 'Dossier-Checkliste',
            ecommerce_cross_border: 'Grenzüberschreitende Compliance',
            ecommerce_trustmark: 'Trustmark-Programm',
            ecommerce_notification: 'Benachrichtigung',
            ecommerce_registration: 'Registrierung',
            ecommerce_termination: 'Kündigung',
            ecommerce_reporting_readiness: 'Meldebereitschaft',
            ecommerce_evidence_capture: 'Beweiserfassung',
            submission_status_approved: 'Genehmigt',
            cybersec_law_2025_title: 'Vietnamesisches Cybersicherheitsgesetz (2025)',
            cybersec_system_classification: 'Systemklassifizierung',
            cybersec_risk_assessment: 'Risikobewertung',
            cybersec_incident_report: 'Vorfallbericht',
            cybersec_authority_cooperation: 'Behördenkooperation',
            cybersec_data_localization: 'Datenlokalisierung',
            cybersec_vendor_security: 'Anbietersicherheit',
            cybersec_submission_tracker: 'Einreichungs-Tracker',
            cybersec_evidence_capture: 'Beweiserfassung',
            cybersec_dossier_checklist: 'Dossier-Checkliste',
            cybersec_classification_general: 'Allgemein',
            cybersec_classification_important: 'Wichtig',
            cybersec_classification_critical: 'Kritisch',
            data_law_title: 'Vietnamesisches Datengesetz',
            data_inventory: 'Dateninventar',
            data_classification: 'Datenklassifizierung',
            data_sharing: 'Datenaustausch',
            data_governance: 'Daten-Governance',
            data_submission_tracker: 'Einreichungs-Tracker',
            data_evidence_capture: 'Beweiserfassung',
            data_dossier_checklist: 'Dossier-Checkliste',
            telecom_law_title: 'Vietnamesisches Telekommunikationsgesetz',
            telecom_authority_request: 'Anfrage der Behörde',
            telecom_disclosure: 'Offenlegung',
            telecom_confidentiality: 'Vertraulichkeit',
            telecom_submission_tracker: 'Einreichungs-Tracker',
            telecom_evidence_capture: 'Beweiserfassung',
            telecom_dossier_checklist: 'Dossier-Checkliste',
            pdpl_law_title: 'Vietnamesisches Gesetz zum Schutz personenbezogener Daten',
            pdpl_breach_notification: 'Benachrichtigung über Verstöße',
            pdpl_dpo_notification: '[[TOK_0]] Terminbenachrichtigung',
            pdpl_data_subject_notification: 'Benachrichtigung der betroffenen Person',
            pdpl_submission_tracker: 'Einreichungs-Tracker',
            pdpl_evidence_capture: 'Beweiserfassung',
            pdpl_dossier_checklist: 'Dossier-Checkliste',
            pdpl_authority_filing: 'Einreichung bei der Behörde',
            pdpl_mops_filing: 'MoPS-Einreichung',
        },
        mappings: {
            title: 'Modulzuordnungen',
            new: 'Neu Zuordnung',
            module: 'Modul',
            market_pack: 'Markt Paket',
            mapping_status: 'Zuordnung Status',
            no_mappings: 'Keine Modul Zuordnungen gefunden.',
            incomplete_entries_warning: '{count} Zuordnung(en) ausgeblendet wegen fehlender Framework-ID, Anforderungs-ID oder Modul.',
        },
        submissions: {
            title: 'Paketeinreichungen',
            new: 'Neu Einreichung',
            submitter: 'Einreicher',
            pack: 'Paket',
            submitted_at: 'Eingereicht At',
            no_submissions: 'Keine Paket Einreichungen gefunden.',
            installed_sector_overlays_title: 'Sektor-Overlays ({count})',
            installed_sector_overlays_aria: 'Installierte Sektor-Overlays',
            installed_col_name: 'Name',
            installed_col_code: 'Code',
            installed_col_sector: 'Sektor',
            installed_col_mode: 'Modus',
            installed_col_status: 'Status',
            installed_refresh: 'Aktualisieren',
        },
        translations: {
            title: 'Übersetzungsvorschau',
            select_locale: 'Auswählen Sprache',
            select_module: 'Auswählen Modul',
            key: 'Key',
            value: 'Wert',
            no_translations: 'Keine translations gefunden.',
        },
        audit: {
            title: 'Lokalisierung Audit Trail',
            event_type: 'Ereignis Typ',
            entity_type: 'Entität Typ',
            entity_id: 'Entität ID',
            entity_name: 'Entitätsname',
            actor: 'Akteur',
            timestamp: 'Zeitstempel',
            payload: 'Nutzlast',
            collapse_payload: 'Nutzlastdetails einklappen',
            expand_payload: 'Nutzlastdetails ausklappen',
            collapse: 'Einklappen',
            expand: 'Ausklappen',
            all_entity_types: 'Alle Entitätstypen',
            no_events: 'Keine Audit Ereignisse gefunden.',
        },
        market_packs_detail: {
            installed_at: 'Installiert am',
            pack_details_label: 'Paketdetails',
            market_code: 'Marktcode',
            supported_locales: 'Unterstützte Gebietsschemata',
            min_platform_version: 'Mindest-Plattformversion',
            pack_information: 'Paketinformation',
            pack_contents: 'Packungsinhalt',
            included_frameworks: 'Enthaltene Regelwerke',
            pack_artifacts: 'Paket-Artefakte',
            no_artifacts: 'Keine Artefakte für dieses Paket gefunden',
            pack_not_found: 'Paket nicht gefunden',
        },
        mappings_form: {
            framework_id: 'Framework-ID',
            requirement_id: 'Anforderungs-ID',
            module_label: 'Modul',
            mapping_type: 'Zuordnungstyp',
            configuration_json: 'Konfiguration (JSON)',
            conflict_resolution: 'Konfliktlösung',
            is_override: 'Ist Überschreibung',
            all_modules: 'Alle Module',
            all_mapping_types: 'Alle Zuordnungstypen',
        },
        submissions_detail: {
            submission_id: 'Einreichungs-ID',
            validation: 'Validierung',
            reviewers: 'Prüfer',
            start_review: 'Überprüfung starten',
            hide_comments: 'Kommentare ausblenden',
            review_comments: 'Prüfungskommentare',
            loading_comments: 'Kommentare werden geladen...',
            no_comments: 'Noch keine Kommentare.',
            add_comment: 'Kommentar hinzufügen',
            reject_submission: 'Einreichung ablehnen',
            reason_for_rejection: 'Ablehnungsgrund',
            reviewer_ids: 'Prüfer-IDs (kommagetrennt)',
            submit_new_pack: 'Neues Paket einreichen',
            pack_type: 'Pakettyp',
            market_code: 'Marktcode',
            target_locales: 'Zielgebietsschemata',
            pack_file: 'Paketdatei',
            pack_format_info: 'Paketformat: Marktpakete sollten gebietsschemaspezifische [[TOK_0]]-Dateien mit Namespace-/Schlüsselübersetzungen enthalten. Sprachpakete sollten Übersetzungen für die angegebenen Zielgebietsschemas bereitstellen. Ein detailliertes Schema finden Sie in der Dokumentation.',
            accepted_formats: 'Akzeptierte Formate: .json oder .zip. [[TOK_0]]-Dateien sollten ein flaches oder namespaced-Objekt aus übersetzten Schlüssel-Wert-Paaren enthalten. ZIP-Dateien sollten eine oder mehrere [[TOK_1]]-Gebietsschemadateien enthalten.',
            comma_separated_locales: 'Kommagetrennte Gebietsschemacodes für dieses Sprachpaket',
            confirm_approval: 'Genehmigung bestätigen',
            approve_message: 'Diese Paketeinreichung genehmigen?',
            submission_label: 'Einreichung',
            all_pack_types: 'Alle Pakettypen',
            passed: 'bestanden',
            failed_label: 'fehlgeschlagen',
            market_code_required: 'Marktcode ist erforderlich',
            version_required: 'Version ist erforderlich',
            pack_type_regulatory: 'Regulatorisch',
            framework_code: 'Rahmenwerk-Code',
            jurisdiction_code: 'Zuständigkeitscode',
            pack_source: 'Quelle',
            pack_source_manual: 'Manuell',
            pack_version: 'Paketversion',
            install_regulatory_pack: 'Regulatorisches Paket installieren',
            regulatory_pack_desc: 'Laden Sie ein regulatorisches Rahmenwerk-Paket hoch (.zip)',
            framework_required: 'Rahmenwerk-Code ist erforderlich',
            jurisdiction_required: 'Zuständigkeitscode ist erforderlich',
        },
        catalog_detail: {
            packs_installed_of: 'von {total} Paketen installiert',
            install_all: 'Alle installieren',
            installing: 'Wird installiert...',
            removing: 'Wird entfernt...',
            requires: 'Erfordert',
            tab_catalog: 'Katalog',
            tab_installed: 'Installiert',
            details: 'Einzelheiten',
        },
        translations_detail: {
            source_locale: 'Quellgebietsschema',
            target_locale: 'Zielgebietsschema',
            locales_must_differ: 'Quell- und Zielgebietsschema müssen unterschiedlich sein.',
            all_keys_translated: 'Alle Schlüssel übersetzt',
            keys_missing: '[[TOK_1]] Schlüssel fehlen',
            show_missing_only: 'Nur fehlende anzeigen',
            namespace: 'Namensraum',
            source: 'Quelle',
            target: 'Ziel',
        },
        frameworks_detail: {
            tab_frameworks: 'Rahmenwerke',
            tab_watchlist: 'Beobachtungsliste',
            authority: 'Behörde',
            requirements_count: 'Anforderungen',
            all_types: 'Alle Typen',
            collapse_all: 'Alle einklappen',
            expand_all: 'Alle ausklappen',
            filtered_to: 'Gefiltert auf',
            clear_filter: 'Filter löschen',
            no_requirements: 'Keine Anforderungen für dieses Framework gefunden.',
            requirements_label: 'Anforderungen',
            status_updated: 'Status erfolgreich aktualisiert',
            overview_tab: 'Übersicht',
            forms_tab: 'Formulare',
            procedures_tab: 'Verfahren',
            fines_risks_tab: 'Bußgelder & Risiken',
            deadlines_tab: 'Fristen',
            guidance_tab: 'Anleitung',
            guidance_empty: 'Für dieses Framework gibt es keine Anleitungsinhalte.',
            guidance_loading: 'Anleitung wird geladen…',
            guidance_section: 'Abschnitt „Anleitung“.',
            guidance_view: 'Anleitung anzeigen',
            guidance_map_to_workflow: 'Dem Workflow zuordnen',
            guidance_link_evidence: 'Beweise verknüpfen',
            guidance_filter_type: 'Typ',
            guidance_filter_category: 'Kategorie',
            guidance_filter_module: 'Modul',
            guidance_filter_status: 'Status',
            guidance_filter_search: 'Suchanleitung',
            guidance_filter_all: 'Alle',
            guidance_table_reference: 'Referenz',
            guidance_table_name: 'Führungsname',
            guidance_table_type: 'Typ',
            guidance_table_category: 'Kategorie',
            guidance_table_effective_date: 'Datum des Inkrafttretens',
            guidance_table_modules: 'Verwandte Module',
            guidance_table_actions: 'Aktionen',
            guidance_reference_only_banner: 'Nur Referenz – gilt für den Sektor {[[TOK_1]]}, jedoch nicht für Ihre Organisation.',
            guidance_related_link: 'Verwandte Anleitungen',
            deadlines_empty: 'Keine regulatorischen Fristen für dieses Regelwerk gefunden.',
            deadlines_sla_type: 'SLA-Typ',
            deadlines_value: 'Frist',
            deadlines_unit: 'Einheit',
            deadlines_extension: 'Verlängerung',
            deadlines_reference: 'Rechtsgrundlage',
            framework_stack: 'Rechtsrahmen-Struktur',
            layer_parent_law: 'Stammgesetz',
            layer_implementing_decree: 'Durchführungsverordnung',
            layer_enforcement_decree: 'Vollstreckungsverordnung',
            layer_admin_procedures: 'Verwaltungsverfahren',
            status_active: 'Aktiv',
            status_draft: 'Entwurf',
            draft_enforcement_badge: 'Entwurf — noch nicht erlassen',
            effective_date: 'Inkrafttreten',
            forms_table_id: 'Formular-ID',
            forms_table_name: 'Formularname',
            forms_table_source: 'Quelle',
            forms_table_category: 'Kategorie',
            forms_table_type: 'Typ',
            fill_form: 'Formular ausfüllen',
            view_reference: 'Referenz anzeigen',
            forms_official: 'Offiziell',
            forms_internal: 'Intern',
            forms_empty: 'Keine Formulare für diesen Rechtsrahmen gefunden.',
            forms_loading: 'Formulare werden geladen...',
            filter_by_source_layer: 'Nach Quellebene filtern',
            all_layers: 'Alle Ebenen',
            procedures_id: 'Verfahrens-ID',
            procedures_name: 'Verfahren',
            procedures_trigger: 'Auslöser',
            procedures_steps: 'Schritte',
            procedures_outputs: 'Ergebnisse',
            procedures_related_forms: 'Zugehörige Formulare',
            procedures_submission_channels: 'Übermittlungskanäle',
            procedures_empty: 'Keine Verfahren für diesen Rechtsrahmen gefunden.',
            fines_area: 'Verstoßbereich',
            fines_articles: 'Artikelentwürfe',
            fines_individual: 'Bußgeld (Einzelperson)',
            fines_organization: 'Bußgeld (Organisation)',
            fines_revenue: 'Umsatzeskalation',
            fines_deadlines: 'Fristen',
            fines_remediation: 'Abhilfemaßnahmen',
            fines_related: 'Zugehörige Verfahren',
            fines_empty: 'Keine Vollstreckungsdaten für diesen Rechtsrahmen verfügbar.',
            fines_enforcement_pending: 'Vollstreckungsrahmen noch nicht veröffentlicht. Sanktionsdaten werden ergänzt, wenn das Durchführungsinstrument erlassen wird.',
            view_details: 'Details anzeigen',
            back_to_list: 'Zurück zur Liste',
            description: 'Beschreibung',
            jurisdiction: 'Zuständigkeit',
            lineage: 'Abstammung',
            replaces: 'Ersetzt',
            replaced_by: 'Ersetzt durch',
            requirements: 'Anforderungen',
            tab_navigation: 'Rechtsrahmen-Detail-Tabs',
            forms_table_actions: 'Aktionen',
            create_form: 'Formular erstellen',
            mark_promulgated: 'Als verkündet markieren',
            status_promulgated: 'Verkündet',
            promulgated_success: 'Schichtstatus auf verkündet aktualisiert',
            transition_review: 'Übergangsüberprüfung',
            transition_review_desc: 'Dieses Rahmenwerk hat eine ausstehende Übergangsüberprüfung für die Übernahme des Nachfolgegesetzes.',
            transition_review_by: 'Überprüfungsfrist',
            transition_review_status: 'Überprüfungsstatus',
            transition_review_notes: 'Anmerkungen',
            transition_review_pending: 'Ausstehend',
            transition_review_in_progress: 'In Bearbeitung',
            transition_review_completed: 'Abgeschlossen',
            transition_review_successor: 'Nachfolge-Rahmenwerk',
            transition_review_lead_time: 'Vorlaufzeit',
            transition_review_lead_time_days: '{days} Tage vor Inkrafttreten',
            transition_review_forms_heading: 'Formular-Übergangsüberprüfungen',
            transition_review_forms_desc: 'Überprüfen Sie jede operative Vorlage auf Relevanz unter dem Nachfolge-Rahmenwerk.',
            transition_review_outcome: 'Ergebnis',
            transition_review_outcome_carry_forward: 'Übernehmen',
            transition_review_outcome_carry_forward_revised: 'Übernehmen (überarbeitet)',
            transition_review_outcome_retire: 'Stilllegen',
            transition_review_outcome_split: 'Aufteilen',
            transition_review_outcome_awaiting_decree: 'Warten auf Verordnung',
            transition_review_no_forms: 'Keine Formular-Übergangsüberprüfungen konfiguriert.',
            transition_review_update_success: 'Übergangsüberprüfung erfolgreich aktualisiert',
            transition_review_operational_note: 'Dies sind prozessunterstützende operative Vorlagen, keine gesetzlichen Formularzähler. Die rechtliche Zuordnung verbleibt beim alten Rahmenwerk, bis das Nachfolgegesetz in Kraft tritt.',
            rights_tab: 'Rechte',
            rights_empty: 'Für dieses Rahmenwerk sind keine Betroffenenrechte definiert.',
            rights_code: 'Code',
            rights_name: 'Recht',
            rights_legal_basis: 'Rechtsgrundlage',
            rights_elaborating_articles: 'Detailartikel',
            rights_description: 'Beschreibung',
            requirements_reference: 'Referenz',
            requirements_mandatory: 'Obligatorisch',
            requirements_yes: 'Yes',
            requirements_no: 'No',
            requirements_source: 'Quelle',
            category_legal_basis: 'Rechtsgrundlage',
            category_data_subject_rights: 'Rechte der betroffenen Person',
            category_notification: 'Benachrichtigung',
            category_assessment: 'Bewertung',
            category_governance: 'Regierungsführung',
            category_record_keeping: 'Aufzeichnungen führen',
            category_cross_border: 'Grenzüberschreitend',
            category_technical_measures: 'Technische Maßnahmen',
            category_incident_reporting: 'Meldung von Vorfällen',
            category_risk_management: 'Risikomanagement',
            category_supply_chain: 'Lieferkette',
            category_certification: 'Zertifizierung',
            child_frameworks: '[[TOK_1]] untergeordnetes Framework',
            child_frameworks_plural: '[[TOK_1]] Untergeordnete Frameworks',
            replaces_prefix: 'Ersetzt:',
            replaced_by_prefix: 'Ersetzt durch:',
            responsible_prefix: 'Verantwortlich:',
            watchlist_empty_hint: 'Zur Überwachung werden hier Frameworks mit dem Status „Entwurf“ oder „bevorstehend“ angezeigt.',
            framework_count: '[[TOK_1]]-Framework',
            framework_count_plural: '[[TOK_1]] Frameworks',
            hiding_legacy: '([[TOK_1]] Vermächtnis verbergen)',
            label_VN_PDPL: '[[TOK_0]] (Dekret 13/2023)',
            label_VN_PDPD_DECREE_13: 'PDPD-Dekret 13/2023',
            label_VN_PDPL_LAW_2025: '[[TOK_0]] Gesetz 91/2025',
            label_VN_PDPL_DECREE_356_2025: 'Dekret [[TOK_0]]',
            label_VN_PDPL_ADMIN_PROCEDURES_778_2026: 'QĐ 778/QĐ-BCA-A05',
            label_VN_PDPL_ENFORCEMENT_DRAFT_2026: '[[TOK_0]] Durchsetzungsentwurf 2026',
            label_VN_MOPS_ADMIN_SIMPLIFICATION_NQ22_2026: 'NQ22 Temporary Overlay 2026',
            label_VN_DATA_LAW: 'Datenrecht',
            label_VN_DATA_LAW_DECREE_165_2025: 'Datenrechtsdekret 165/2025',
            label_VN_DATA_EXCHANGES_DRAFT_2026: 'Entwurf für Datenbörsen 2026',
            label_VN_TELECOM_LAW_2023: 'Telekommunikationsgesetz 2023',
            label_VN_TELECOM_DECREE_163_2024: 'Telekommunikationsdekret 163/2024',
            label_VN_CYBERSEC_LAW: 'Cybersicherheitsgesetz (24/2018)',
            label_VN_CYBERSEC_DECREE_53: 'Cybersec-Dekret 53/2022',
            label_VN_CYBERSEC_LAW_2025: 'Cybersicherheitsgesetz 116/2025',
            label_VN_ECOMMERCE_LAW_2025: 'E-Commerce-Gesetz 122/2025',
            label_VN_AI_LAW_2026: '[[TOK_0]] Gesetz 2026',
            label_VN_AI_DECREE_142_2026: '[[TOK_0]] Decree 142/2026/NĐ-CP',
            issuer_company: 'Unternehmen',
            issuer_authority_a05_mps: 'MPS/A05',
            issuer_authority_mic: 'MIC',
            issuer_authority_mps_ndc: 'MPS/NDC',
            issuer_other_authority: 'Autorität',
            sla_type_rights_request_ack: 'Rechteanfrage-Bestätigung',
            'sla_type_Access control review': 'Überprüfung der Zugangskontrolle',
            'sla_type_Annual governance attestation': 'Jährliche Governance-Bescheinigung',
            'sla_type_Audit review cycle': 'Audit-Überprüfungszyklus',
            'sla_type_Authority request response': 'Antwort auf die Anfrage der Behörde',
            'sla_type_Change notification processing': 'Bearbeitung von Änderungsmeldungen',
            'sla_type_Complaint acknowledgment': 'Reklamationsbestätigung',
            'sla_type_Complaint resolution': 'Beschwerdelösung',
            'sla_type_Confidentiality policy review': 'Überprüfung der Vertraulichkeitsrichtlinie',
            'sla_type_Cybersecurity incident full report': 'Vollständiger Bericht zu Cybersicherheitsvorfällen',
            'sla_type_Cybersecurity incident initial report': 'Erster Bericht über Cybersicherheitsvorfälle',
            'sla_type_Data inventory review': 'Überprüfung des Datenbestands',
            'sla_type_Disclosure log review cycle': 'Überprüfungszyklus des Offenlegungsprotokolls',
            'sla_type_Incident classification decision': 'Entscheidung zur Einstufung des Vorfalls',
            'sla_type_Information system classification review': 'Überprüfung der Klassifizierung von Informationssystemen',
            'sla_type_Notification processing (sales website/app)': 'Benachrichtigungsverarbeitung (Verkaufswebsite/-App)',
            'sla_type_Pen test cycle': 'Pen-Test-Zyklus',
            'sla_type_Registration processing (service platform)': 'Registrierungsabwicklung (Serviceplattform)',
            'sla_type_Risk assessment cycle': 'Risikobewertungszyklus',
            'sla_type_Takedown decision (after review)': 'Takedown-Entscheidung (nach Prüfung)',
            'sla_type_Termination notice (public)': 'Kündigungsmitteilung (öffentlich)',
            sla_type_ai_impact_assessment_completion: '[[TOK_0]] Abschluss der Folgenabschätzung',
            sla_type_ai_sandbox_application_review: '[[TOK_0]] Überprüfung der Sandbox-Anwendung',
            sla_type_ai_serious_incident_report: '[[TOK_0]] Bericht über schwerwiegenden Vorfall',
            sla_type_ai_system_registration: '[[TOK_0]] Systemregistrierung',
            sla_type_authority_request_response: 'Antwort auf die Anfrage der Behörde',
            sla_type_certificate_issuance_review: 'Überprüfung der Zertifikatsausstellung',
            sla_type_complaint_handling_approach_notice: 'Hinweis zum Umgang mit Beschwerden',
            sla_type_complaint_incomplete_info_request: 'Beschwerde unvollständige Informationsanfrage',
            sla_type_data_governance_attestation: 'Bescheinigung über die Datenverwaltung',
            sla_type_dsr_acknowledgment: 'DSR-Bestätigung',
            sla_type_dsr_cl2_withdraw_restrict_object: 'DSR (Kl.2) – Zurückziehen / Einschränken / Einspruch',
            sla_type_dsr_cl2_withdraw_restrict_object_third_party: 'DSR (Kl.2) – Dritter',
            sla_type_dsr_cl3_access_correct_provide: 'DSR (Kl.3) – Zugriff/Korrektur/Bereitstellung',
            sla_type_dsr_cl3_access_correct_provide_third_party: 'DSR (Kl.3) – Dritter',
            sla_type_dsr_cl4_deletion: 'DSR (Kl.4) – Streichung',
            sla_type_dsr_cl4_deletion_third_party: 'DSR (Kl.4) – Löschung, Dritter',
            sla_type_dsr_cl5_protective_measures: 'DSR (Kl.5) – Schutzmaßnahmen',
            sla_type_telecom_authority_request_response: 'Antwort auf Anfrage der Telekommunikationsbehörde',
            sla_type_rights_request_completion: 'Abschluss der Rechteanfrage',
            sla_type_incident_authority_notification: 'Benachrichtigung der Vorfallbehörde',
            sla_type_incident_subject_notification: 'Benachrichtigung über den Vorfall',
            sla_type_dpia_completion: '[[TOK_0]] Abschluss',
            sla_type_data_retention_review: 'Überprüfung der Datenspeicherung',
            sla_type_authority_filing_review: 'Überprüfung der Einreichung durch die Behörde',
            sla_type_authority_supplement_response: 'Antwort der Behörde nach Ergänzung',
            sla_type_authority_resubmission: 'Wiedervorlage der Behörde',
            sla_type_authority_filing_supplement_response: 'Antwort der Behörde auf Ergänzungsantrag',
            sla_type_authority_filing_resubmission: 'Behörde reicht Wiedervorlage ein',
            unit_working_days: 'Arbeitstage',
            unit_calendar_days: 'Kalendertage',
            unit_hours: 'Stunden',
            form_category_dpa: 'DPA',
            form_category_dsr: 'DSR',
            form_category_consent: 'Zustimmung',
            form_category_privacy: 'Privatsphäre',
            form_category_breach: 'Verstoß',
            form_category_dpia: '[[TOK_0]]',
            form_category_register: 'Registrieren',
            form_category_monitoring: 'Überwachung',
            form_category_vendor: 'Anbieter',
            form_category_org: 'Organisatorisch',
            form_category_sector: 'Sektor',
            form_category_data_mapping: 'Datenzuordnung',
            form_category_governance: 'Regierungsführung',
            form_category_incident: 'Vorfall',
            form_category_authority_submission: 'Einreichung bei der Behörde',
            form_category_notice: 'Hinweis',
            form_category_assessment_report: 'Bewertungsbericht',
            form_category_request: 'Anfrage',
            form_category_dossier: 'Dossier',
            form_category_filing: 'Einreichung',
            module_consent: 'Zustimmung',
            module_rights_request: 'Rechteanfrage',
            module_classification: 'Klassifizierung',
            module_dpia: '[[TOK_0]]',
            module_governance: 'Regierungsführung',
            module_monitoring: 'Überwachung',
            module_register: 'Registrieren',
            module_risk: 'Risiko',
            module_data_mapping: 'Datenzuordnung',
            module_incident: 'Vorfall',
            module_assessment: 'Bewertung',
            module_vendor: 'Anbieter',
            module_policy: 'Politik',
            module_audit: 'Prüfung',
            module_training: 'Ausbildung',
            module_discovery: 'Entdeckung',
            enum_guidance_type_calculation_guidance: 'Berechnungsanleitung',
            enum_guidance_type_implementation_guidance: 'Implementierungsleitfaden',
            enum_guidance_type_interpretive_note: 'Interpretationshinweis',
            enum_guidance_type_legal_guidance: 'Rechtliche Hinweise',
            enum_guidance_type_procedural_guidance: 'Verfahrenshinweise',
            enum_guidance_type_sector_guidance: 'Branchenberatung',
            enum_guidance_type_technical_methodology: 'Technische Methodik',
            enum_guidance_category_annual_reporting: 'Jährliche Berichterstattung',
            enum_guidance_category_authority_cooperation: 'Behördenkooperation',
            enum_guidance_category_authority_coordination: 'Behördenkoordination',
            enum_guidance_category_business_continuity: 'Geschäftskontinuität',
            enum_guidance_category_capital_adequacy: 'Kapitaladäquanz',
            enum_guidance_category_complaint_handling: 'Beschwerdebearbeitung',
            enum_guidance_category_consent: 'Zustimmung',
            enum_guidance_category_consent_management: 'Einwilligungsmanagement',
            enum_guidance_category_consumer_protection: 'Verbraucherschutz',
            enum_guidance_category_control_environment: 'Kontrollumgebung',
            enum_guidance_category_cross_border: 'Grenzüberschreitend',
            enum_guidance_category_cross_border_transfers: 'Grenzüberschreitende Überweisungen',
            enum_guidance_category_data_classification: 'Datenklassifizierung',
            enum_guidance_category_data_localization: 'Datenlokalisierung',
            enum_guidance_category_data_protection_impact_assessment: 'Datenschutz-Folgenabschätzung',
            enum_guidance_category_direct_marketing: 'Direktmarketing',
            enum_guidance_category_dpia: 'DPIA',
            enum_guidance_category_governance: 'Regierungsführung',
            enum_guidance_category_ict_risk_management: 'IKT-Risikomanagement',
            enum_guidance_category_incident_management: 'Vorfallmanagement',
            enum_guidance_category_internal_audit: 'Interne Revision',
            enum_guidance_category_isms_documentation: 'ISMS-Dokumentation',
            enum_guidance_category_lawful_basis: 'Rechtsgrundlage',
            enum_guidance_category_licensing: 'Lizenzierung',
            enum_guidance_category_local_presence: 'Lokale Präsenz',
            enum_guidance_category_logging_and_retention: 'Protokollierung und Aufbewahrung',
            enum_guidance_category_logical_and_physical_access: 'Logischer und physischer Zugriff',
            enum_guidance_category_operational_resilience_testing: 'Prüfung der betrieblichen Belastbarkeit',
            enum_guidance_category_outsourcing: 'Outsourcing',
            enum_guidance_category_platform_registration: 'Plattformregistrierung',
            enum_guidance_category_quality_of_service: 'Servicequalität',
            enum_guidance_category_risk_classification: 'Risikoklassifizierung',
            enum_guidance_category_risk_management: 'Risikomanagement',
            enum_guidance_category_scope_definition: 'Geltungsbereichsdefinition',
            enum_guidance_category_sectoral_localisation: 'Sektorale Lokalisierung',
            enum_guidance_category_subscriber_protection: 'Abonnentenschutz',
            enum_guidance_category_supply_chain: 'Lieferkette',
            enum_guidance_category_system_classification: 'Systemklassifizierung',
            enum_guidance_category_system_operations: 'Systembetrieb',
            enum_guidance_category_telecommunications_data: 'Telekommunikationsdaten',
            enum_guidance_category_third_party_risk: 'Risiko Dritter',
            enum_guidance_category_transitional_provisions: 'Übergangsbestimmungen',
            enum_guidance_category_vulnerability_management: 'Schwachstellenmanagement',
            enum_guidance_status_active: 'Aktiv',
            enum_guidance_status_draft: 'Entwurf',
            enum_module_access_management: 'Zugriffsverwaltung',
            enum_module_ai_governance: '[[TOK_0]] Governance',
            enum_module_asset_management: 'Vermögensverwaltung',
            enum_module_audit_trail: 'Prüfpfad',
            enum_module_breach_notification: 'Benachrichtigung über Verstöße',
            enum_module_capital_adequacy: 'Kapitaladäquanz',
            enum_module_classification: 'Klassifizierung',
            enum_module_consent: 'Zustimmung',
            enum_module_consent_management: 'Einwilligungsmanagement',
            enum_module_cross_border_transfers: 'Grenzüberschreitende Überweisungen',
            enum_module_data_localization: 'Datenlokalisierung',
            enum_module_data_mapping: 'Datenzuordnung',
            enum_module_data_protection: 'Datenschutz',
            enum_module_data_subject_rights: 'Rechte der betroffenen Person',
            enum_module_dpia: 'DPIA',
            enum_module_encryption: 'Verschlüsselung',
            enum_module_governance: 'Regierungsführung',
            enum_module_incident: 'Vorfall',
            enum_module_incident_management: 'Vorfallmanagement',
            enum_module_internal_audit: 'Interne Revision',
            enum_module_isms_documentation: 'ISMS-Dokumentation',
            enum_module_isms_governance: 'ISMS-Governance',
            enum_module_logging_and_monitoring: 'Protokollierung und Überwachung',
            enum_module_monitoring: 'Überwachung',
            enum_module_policy_management: 'Richtlinienverwaltung',
            enum_module_risk: 'Risiko',
            enum_module_risk_management: 'Risikomanagement',
            enum_module_training: 'Ausbildung',
            enum_module_vendor: 'Anbieter',
            enum_module_vendor_management: 'Lieferantenmanagement',
            enum_module_vendor_risk: 'Lieferantenrisiko',
            enum_module_vulnerability_management: 'Schwachstellenmanagement',
            category_access: 'Zugang',
            category_availability: 'Verfügbarkeit',
            category_change_management: 'Änderungsmanagement',
            category_classification: 'Klassifizierung',
            category_communication_and_information: 'Kommunikation & Information',
            category_compliance: 'Compliance',
            category_confidentiality: 'Vertraulichkeit',
            category_control_activities: 'Kontrollaktivitäten',
            category_control_environment: 'Kontrollumgebung',
            category_incident: 'Vorfall',
            category_internal_audit: 'Interne Revision',
            category_internal_control: 'Interne Kontrolle',
            category_logical_and_physical_access: 'Logischer und physischer Zugriff',
            category_mis_data: 'Daten des Managementinformationssystems',
            category_monitoring: 'Überwachung',
            category_monitoring_activities: 'Überwachungsaktivitäten',
            category_outsourcing: 'Outsourcing',
            category_privacy: 'Privatsphäre',
            category_processing_integrity: 'Verarbeitungsintegrität',
            category_reporting: 'Berichterstattung',
            category_risk_assessment: 'Risikobewertung',
            category_risk_mitigation: 'Risikominderung',
            category_sector_applicability: 'Branchenbezogene Anwendbarkeit',
            category_system_operations: 'Systembetrieb',
            category_training: 'Ausbildung',
            category_vendor: 'Anbieter',
            guidance_related_forms_advisory: 'Für einige Formulare gibt es entsprechende Anleitungen – siehe im',
            guidance_related_procedures_advisory: 'Für einige Verfahren gibt es entsprechende Anleitungen – siehe im',
            guidance_related_requirements_advisory: 'Für einige Anforderungen gibt es entsprechende Anleitungen – siehe im',
        },
        channels: {
            title: 'Einreichungskanäle und Fristen',
            channels: 'Einreichungskanäle',
            add_channel: 'Kanal hinzufügen',
            channel_type: 'Typ',
            name: 'Name',
            instructions: 'Anweisungen',
            active: 'Aktiv',
            no_channels: 'Keine Einreichungskanäle konfiguriert',
            portal: 'Portal',
            in_person: 'Persönlich',
            postal: 'Post',
            email: 'E-Mail',
            add: 'Hinzufügen',
            deadlines: 'Regulatorische Fristen',
            add_deadline: 'Frist hinzufügen',
            label: 'Bezeichnung',
            days: 'Tage',
            day_type: 'Tagestyp',
            calendar_days: 'Kalendertage',
            working_days: 'Arbeitstage',
            no_deadlines: 'Keine Fristen konfiguriert',
            description: 'Beschreibung',
            failed_load: 'Fehler beim load channel data',
            channel_added: 'Kanal hinzugefügt',
            channel_added_announce: 'Einreichungskanal hinzugefügt',
            failed_add_channel: 'Fehler beim add channel',
            deadline_added: 'Frist hinzugefügt',
            deadline_added_announce: 'Regulatorische Frist hinzugefügt',
            failed_add_deadline: 'Fehler beim add deadline',
        },
        module_links: {
            title: 'Framework-Verknüpfung',
            modules: 'Verknüpfte Module',
            add_module: 'Modul hinzufügen',
            module_code: 'Modulcode',
            required: 'Erforderlich',
            link: 'Verknüpfen',
            no_modules: 'Keine Module verknüpft',
            notes: 'Notizen',
            personas: 'Verknüpfte Personas',
            add_persona: 'Persona hinzufügen',
            persona_id: 'Persona-ID',
            role_description: 'Rollenbeschreibung',
            no_personas: 'Keine Personas verknüpft',
            failed_load: 'Fehler beim load framework links',
            module_linked: 'Modul verknüpft',
            module_linked_announce: 'Modul erfolgreich verknüpft',
            failed_link_module: 'Fehler beim link module',
            persona_linked: 'Persona verknüpft',
            persona_linked_announce: 'Persona erfolgreich verknüpft',
            failed_link_persona: 'Fehler beim link persona',
        },
        regulatory_updates: {
            statuses: {
                pending: 'Ausstehend',
                assessed: 'Bewertet',
                applied: 'Angewendet',
                dismissed: 'Verworfen',
            },
            title: 'Regulatorische Aktualisierungen und Framework-Dashboard',
            page_description: 'Überblick über die Abdeckung aller installierten Regulierungsrahmen sowie das Änderungsprotokoll regulatorischer Aktualisierungen im Produkt: Änderungen, Wirksamkeitsdaten und Folgenabschätzungen.',
            coverage_dashboard: 'Framework-Abdeckungs-Dashboard',
            no_frameworks: 'Keine Frameworks gefunden',
            framework: 'Rahmen',
            modules: 'Module',
            templates: 'Vorlagen',
            forms: 'Formulare',
            channels: 'Kanäle',
            deadlines: 'Fristen',
            pending: 'Ausstehende Aktualisierungen',
            updates: 'Regulatorische Aktualisierungen',
            create_update: 'Aktualisierung erstellen',
            framework_id: 'Framework-ID',
            update_title: 'Titel',
            description: 'Beschreibung',
            effective_date: 'Inkrafttreten',
            amendment_ref: 'Änderungsreferenz',
            create: 'Erstellen',
            no_updates: 'Keine regulatorischen Aktualisierungen',
            status: 'Status',
            impact: 'Auswirkung',
            change_summary: 'Änderungszusammenfassung',
            assess: 'Bewerten',
            failed_load: 'Fehler beim load data',
            update_created: 'Aktualisierung erstellt',
            update_created_announce: 'Regulatorische Aktualisierung erstellt',
            failed_create: 'Fehler beim create update',
            update_assessed: 'Aktualisierung bewertet',
            failed_assess: 'Fehler beim assess update',
        },
        sector_overlay: {
            sector_labels: {
                banking: 'Bankwesen',
                insurance: 'Versicherungen',
                healthcare: 'Gesundheitswesen',
                ict_critical: 'Kritische IKT',
                telecom: 'Telekommunikation',
                energy: 'Energie',
                transport: 'Transport',
                digital_services: 'Digitale Dienste',
                digital_technology_industry: 'Digitale Technologiebranche',
                public_administration: 'Öffentliche Verwaltung',
                payments: 'Zahlungsverkehr',
                other: 'Sonstige',
            },
            sector_label: 'Sektor',
            direct_scope_label: 'Unmittelbarer rechtlicher Geltungsbereich',
            chip_direct: 'Unmittelbar anwendbar',
            chip_reference: 'Nur als Referenz',
            banner_direct_copy: 'Unmittelbar auf Ihre Organisation anwendbar. Sektorberichte und Fristen sind aktiv.',
            banner_reference_copy: 'Nur als Referenz — Ihre Organisation ist diesem Sektor nicht zugeordnet.',
            edit_mode_button: 'Modus bearbeiten',
            edit_form_title: 'Installationsmodus ändern',
            mode_direct_label: 'Direkt — rechtlich anwendbar',
            mode_direct_help: 'Aktiviert Sektorfristen und Dashboard-Widgets.',
            mode_reference_label: 'Nur als Referenz',
            mode_reference_help: 'Kann eingesehen werden, aber ohne Fristen oder Widgets.',
            reason_note_label: 'Begründung (optional)',
            reason_note_placeholder: 'z. B. Tochtergesellschaft einer Bank übernommen',
            cancel: 'Abbrechen',
            confirm: 'Bestätigen',
            confirming: 'Wird gespeichert…',
            save: 'Speichern',
            saving: 'Wird gespeichert…',
            toast_mode_changed: 'Der Modus des Sektor-Overlays wurde aktualisiert.',
            toast_installed: 'Sektor-Overlay installiert.',
            toast_sectors_saved: 'Sektor-Selbsteinstufung gespeichert.',
            install_modal_title: 'Sektor-Overlay installieren',
            install_modal_intro: 'Sektor-Overlays sind optionale Regulierungspakete für eine einzelne Branche.',
            install_modal_footer: 'Sie können den Installationsmodus später auf der Framework-Detailseite ändern.',
            install_button: 'Installieren',
            installed_label: 'Installiert',
            uninstall_button: 'Deinstallieren',
            uninstall_confirm: 'Bestätigen Sie die Deinstallation',
            uninstall_cancel: 'Abbrechen',
            suggested_label: 'Empfohlen',
            catalog_page_title: 'Sektor-Overlays',
            catalog_page_intro: 'Optionale Regulierungspakete für jeweils einen bestimmten Industriesektor.',
            catalog_empty_title: 'Keine Sektor-Overlays verfügbar',
            catalog_empty_description: 'Hier erscheinen Sektor-Overlay-Pakete, die auf Ihrer Plattform veröffentlicht wurden.',
            authority_label: 'Behörde',
            org_sectors_title: 'Branchenzuordnung',
            org_sectors_intro: 'Wählen Sie die Branchen aus, in denen Ihre Organisation tätig ist.',
            widget_title: 'Fällige Berichte für Sektor-Overlays',
            widget_aria_label: 'Fällige Berichte für Sektor-Overlays',
            widget_empty: 'Keine anstehenden Fristen für Sektor-Overlays.',
            audit_event_mode_changed: 'Installationsmodus des Sektor-Overlays geändert',
            audit_event_installed: 'Sektor-Overlay installiert',
            view_details_button: 'Details anzeigen →',
            banner_aria_label: 'Status des Sektor-Overlays',
            toast_load_failed: 'Sektor-Overlays konnten nicht geladen werden',
            toast_install_failed: 'Sektor-Overlay konnte nicht installiert werden',
            toast_uninstall_confirm_required: 'Geben Sie zur Bestätigung der Deinstallation "{packCode}" ein.',
            toast_uninstalled: '{packCode} wurde deinstalliert.',
            toast_uninstall_failed: 'Sektor-Overlay konnte nicht deinstalliert werden',
            uninstall_warning_destructive_label: 'Diese Aktion ist destruktiv.',
            uninstall_warning_body: 'Bei der Deinstallation werden der Framework-Datensatz und alle gespeicherten regulatorischen Fristen zu {frameworkCode} aus dieser Organisation entfernt.',
            uninstall_warning_type_to_confirm: 'Geben Sie zur Bestätigung {packCode} ein.',
            uninstall_in_progress: 'Deinstallation läuft…',
            widget_view_all: 'Alle Sektor-Overlays anzeigen →',
            widget_due_in_days: 'Fällig in {days} Tagen',
            widget_overdue_days: 'Seit {days} Tagen überfällig',
            widget_due_today: 'Heute fällig',
            widget_due_unknown: '—',
        },
        phased_obligations: {
            panel_title: 'Gestaffelte Pflichten',
            panel_aria_label: 'Gestaffelte Pflichten',
            panel_intro: 'Einige Klauseln dieses Frameworks treten später in Kraft als das Framework selbst.',
            phased_effective_date_label: 'Gestaffeltes Inkrafttreten:',
            status_pending: 'Ausstehend',
            status_active: 'Aktiv',
            status_early: 'Aktiv (vorzeitig umgesetzt)',
            notice_window_label: 'Mitteilungsfrist an die Behörde:',
            days_label: 'Tage',
            recipient_label: 'Empfänger:',
            early_implement_button: 'Als vorzeitig umgesetzt markieren',
            early_implement_modal_title: 'Gestaffelte Pflicht als vorzeitig umgesetzt markieren',
            early_implement_modal_intro: 'Wenn Sie eine vorzeitige Umsetzung erfassen, wird die Pflicht sofort aktiviert und die Frist für die behördliche Mitteilung gestartet.',
            effective_at_label: 'Wirksam ab',
            reason_label: 'Begründung (optional)',
            reason_placeholder: 'z. B. Vorzeitige Umsetzung vom Vorstand am 2026-09-01 beschlossen',
            confirm: 'Bestätigen',
            toast_early_implemented: 'Vorzeitige Umsetzung erfasst.',
            audit_event_early_implemented: 'Gestaffelte Pflicht als vorzeitig umgesetzt markiert',
            widget_rolling_window_label: 'Gestaffelte Aktivierungen innerhalb von 90 Tagen',
        },
    },
    partner_marketplace: {
        nav: {
            dashboard: 'Übersicht',
            partner_orgs: 'Partnerorganisationen',
            service_tiers: 'Servicestufen',
            deliverable_templates: 'Liefervorlagen',
            deliverables: 'Liefergegenstände',
            brand_profiles: 'Markenprofile',
            support_tickets: 'Supportanfragen',
            workflow_templates: 'Arbeitsablaufvorlagen',
            workflows: 'Arbeitsabläufe',
            escalation: 'Eskalation',
            reports: 'Berichte',
            audit: 'Prüfprotokoll',
        },
        dashboard: {
            title: 'Partnerübersicht',
            loading: 'Lade Dashboard Daten...',
            total_managed_tenants: 'Gesamt Verwaltet Mandanten',
            avg_health_score: 'Avg Zustand Bewertung',
            open_tickets: 'Offen Tickets',
            upcoming_deliverables: 'Bevorstehend Lieferobjekte',
            escalated_tickets: 'Eskaliert Tickets',
            managed_tenants: 'Verwaltet Mandanten',
            partner_tier: 'Partner Stufe',
            managed_tenants_count: 'Verwaltet Mandanten Anzahl',
            onboarding_date: 'Onboarding Datum',
            view_details: 'Ansehen Details',
            no_partner_orgs: 'Keine partner Organisationen gefunden.',
        },
        partner_orgs: {
            title: 'Partnerorganisationen',
            new: 'Neu Partner Org',
            contact_name: 'Kontakt Name',
            contact_email: 'Kontakt E-Mail',
            partner_tier: 'Partner Stufe',
            managed_orgs: 'Verwaltet Orgs',
            onboarding_date: 'Onboarding Datum',
            no_orgs: 'Keine partner Organisationen gefunden.',
            contact_phone: 'Kontakt Telefon',
            metadata_json: 'Metadaten (JSON)',
            change_status: 'Ändern Status',
            new_status: 'Neu Status',
            invalid_json_metadata: 'Ungültig JSON in metadata field',
            suspended: 'Gesperrt',
            offboarded: 'Ausgeschieden',
            all_tiers: 'Alle Stufen',
            silver: 'Silber',
            gold: 'Goldstufe',
            platinum: 'Platin',
            status_offboarded: 'Ausgeschieden',
            status_suspended: 'Gesperrt',
            tier_gold: 'Goldstufe',
            tier_platinum: 'Platin',
            tier_silver: 'Silber',
        },
        service_tiers: {
            title: 'Servicestufen',
            new: 'Neu Stufe',
            tier_name: 'Stufe Name',
            monthly_fee: 'Monatlich Fee',
            features: 'Funktionen',
            no_tiers: 'Keine service Stufen gefunden.',
            tier_code: 'Stufe Code',
            user_seats: 'Benutzer Plätze',
            user_seat_limit: 'Benutzer Platz Limit',
            storage_gb: 'Speicher (GB)',
            storage_limit_gb: 'Speicher Limit (GB)',
            response_time_hrs: 'Antwort Zeit (hrs)',
            resolution_time_hrs: 'Lösung Zeit (hrs)',
            review_frequency: 'Überprüfen Häufigkeit',
            sla_response_time: 'SLA Antwort Zeit (hours)',
            sla_resolution_time: 'SLA Lösung Zeit (hours)',
            module_profile_json: 'Modul Profil (JSON)',
            comparing: 'Vergleiche...',
            compare: 'Vergleichen',
            comparison: 'Dienst Stufe Vergleich',
            attribute: 'Attribut',
            deprecate: 'Veralten',
            deprecated: 'Veraltet',
            invalid_json_module: 'Ungültig JSON in Modul profile field',
            select_compare: 'Auswählen bei least 2 Stufen zu compare',
            comparison_title: 'Dienst Stufe Vergleich',
            status_deprecated: 'Veraltet',
            activate: 'Aktivieren',
            invalid_json_module_profile: 'Ungültig JSON in Modul profile',
            resolution_time: 'Lösung Zeit',
            response_time: 'Antwort Zeit',
            select_at_least_two: 'Auswählen bei least 2 Stufen',
        },
        deliverable_templates: {
            title: 'Liefervorlagen',
            new: 'Neu Vorlage',
            template_name: 'Vorlage Name',
            deliverable_type: 'Lieferobjekt Typ',
            no_templates: 'Keine deliverable Vorlagen gefunden.',
            frequency: 'Häufigkeit',
            est_effort_hrs: 'Est. Aufwand (hrs)',
            estimated_effort: 'Geschätzt Aufwand (hours)',
            associated_module: 'Associated Modul',
            linked_tiers_count: 'Verknüpft Stufen Anzahl',
            evidence_requirements: 'Nachweis Anforderungen (comma-separated)',
            tier_ids: 'Stufe IDs (comma-separated)',
            frequency_one_time: 'Ein Zeit',
            frequency_monthly: 'Monatlich',
            frequency_quarterly: 'Vierteljährlich',
            frequency_annually: 'Jährlich',
            type_report: 'Bericht',
            type_review: 'Überprüfen',
            type_assessment: 'Bewertung',
            type_meeting: 'Besprechung',
            type_configuration: 'Konfiguration',
            freq_one_time: 'Ein Zeit',
            freq_monthly: 'Monatlich',
            freq_quarterly: 'Vierteljährlich',
            freq_annually: 'Jährlich',
            status_deprecated: 'Veraltet',
        },
        deliverables: {
            title: 'Liefergegenstände',
            new: 'Neu Lieferobjekt',
            partner: 'Geschäftspartner',
            deliverable_type: 'Lieferobjekt Typ',
            due_date: 'Due Datum',
            no_deliverables: 'Keine deliverables gefunden.',
            assigned_to: 'Zugewiesen Zu',
            completion_date: 'Fertigstellung Datum',
            update_status: 'Aktualisieren Status',
            hide_details: 'Ausblenden Details',
            view_details: 'Ansehen Details',
            evidence_ids: 'Nachweis IDs',
            client_approval: 'Client Genehmigung',
            bulk_update: 'Massen Aktualisieren',
            bulk_update_status: 'Massen Aktualisieren Status',
            generate_schedule: 'Generieren Planen',
            generate_deliverable_schedule: 'Generieren Lieferobjekt Planen',
            organization_id: 'Organisation ID',
            service_tier_id: 'Dienst Stufe ID',
            filter_assigned_to: 'Filtern nach Zugewiesen Zu',
            select_status: 'Auswählen Status...',
            new_status: 'Neu Status',
            upcoming: 'Bevorstehend',
            overdue: 'Überfällig',
            status_deferred: 'Aufgeschoben',
            status_overdue: 'Überfällig',
            status_upcoming: 'Bevorstehend',
        },
        brand_profiles: {
            title: 'Markenprofile',
            new: 'Neu Marke Profil',
            partner: 'Geschäftspartner',
            brand_name: 'Marke Name',
            primary_color: 'Primär Farbe',
            logo_url: 'Logo-URL',
            no_profiles: 'Keine brand profiles gefunden.',
            secondary_color: 'Sekundär Farbe',
            header_text: 'Kopfzeile Text',
            footer_text: 'Fußzeile Text',
            contact_email: 'Kontakt E-Mail',
            contact_phone: 'Kontakt Telefon',
            contact_website: 'Kontakt Website',
            contact_address: 'Kontakt Adresse',
            is_default: 'Is Standard',
            set_default: 'Festlegen Standard',
            preview: 'Vorschau',
            report_header_preview: 'Bericht Kopfzeile Vorschau',
            report_footer_preview: 'Bericht Fußzeile Vorschau',
            preview_description: 'This is ein preview von der report header mit der ausgewählt brand colors.',
            contact_website_short: 'Webseite',
            logo_preview: 'Logo-Vorschau',
        },
        support_tickets: {
            title: 'Supportanfragen',
            new: 'Neu Ticket',
            partner: 'Geschäftspartner',
            subject: 'Betreff',
            assigned_to: 'Zugewiesen Zu',
            no_tickets: 'Keine support Tickets gefunden.',
            category: 'Kategorie',
            priority: 'Priorität',
            escalation_tier: 'Eskalation Stufe',
            sla_status: 'SLA-Status',
            update_status: 'Aktualisieren Status',
            escalate: 'Eskalieren',
            add_note: 'Hinzufügen Hinweis',
            escalate_ticket: 'Eskalieren Ticket',
            escalate_to_tier: 'Eskalieren Zu Stufe',
            notes_timeline: 'Hinweise Zeitverlauf',
            no_notes: 'No Hinweise yet.',
            attachments: 'Anhänge',
            no_attachments: 'Keine Anhänge.',
            client_org_id: 'Kunden-Organisations-ID',
            content: 'Inhalt',
            note_type: 'Typ',
            view_detail: 'Ansehen Detail',
            hide: 'Ausblenden',
            new_status: 'Neu Status',
            all_categories: 'Alle Kategorien',
            all_priorities: 'Alle Priorities',
            all_tiers: 'Alle Stufen',
            ticket_not_found: 'Ticket not gefunden',
            ticket_id: 'Ticket-ID',
            client_org: 'Kunden-Organisation',
            deescalate: 'Deeskalieren',
            deescalate_ticket: 'Ticket deeskalieren',
            deescalate_to_tier: 'De-escalate Zu Stufe',
            add_attachment: 'Hinzufügen Anhang',
            file: 'Datei',
            linked_entity: 'Verknüpft Entität',
            sla_target: 'Ziel',
            breached: 'Verletzt',
            remaining_hours: 'verbleibend',
            na: 'N/A',
            tickets_found: 'Tickets gefunden',
            reason: 'Grund',
            target: 'Ziel',
            upload: 'Hochladen',
        },
        workflow_templates: {
            title: 'Arbeitsablaufvorlagen',
            new: 'Neu Vorlage',
            template_name: 'Vorlage Name',
            steps: 'Schritte',
            no_templates: 'Keine Workflow Vorlagen gefunden.',
            category: 'Kategorie',
            view_steps: 'Ansehen Schritte',
            hide_steps: 'Ausblenden Schritte',
            step: 'Schritt',
            step_title: 'Titel',
            step_description: 'Beschreibung',
            assignee_role: 'Zugewiesener Rolle',
            sla_hours: 'SLA-Stunden',
            evidence_required: 'Nachweis Erforderlich',
            guidance_notes: 'Leitfaden Hinweise',
            add_step: 'Hinzufügen Schritt',
            no_steps: 'Keine Schritte definiert.',
            no_steps_defined: 'Keine Schritte definiert.',
            templates_found: 'Vorlagen gefunden',
            all_categories: 'Alle Kategorien',
        },
        workflows: {
            title: 'Workflow Instanzen',
            new: 'Neu Workflow',
            template: 'Vorlage',
            partner: 'Geschäftspartner',
            current_step: 'Aktuell Schritt',
            progress: 'Fortschritt',
            no_workflows: 'Keine Workflow Instanzen gefunden.',
            instances_found: 'Instanzen gefunden',
        },
        escalation: {
            title: 'Eskalation Dashboard',
            ticket: 'Anfrage',
            partner: 'Geschäftspartner',
            escalated_at: 'Eskaliert At',
            reason: 'Grund',
            no_escalations: 'Keine escalations gefunden.',
            time_in_tier: 'Zeit in Stufe',
            auto_evaluate: 'Auto Bewerten',
            priority_critical: 'Kritisch',
            priority_high: 'Hoch',
            priority_medium: 'Mittel',
            priority_low: 'Low',
            deescalated_from_dashboard: 'De-escalated von Dashboard',
            sla_breached: 'SLA Verletzt',
            sla_remaining: 'SLA Verbleibend',
        },
        reports: {
            title: 'Berichte',
            partner: 'Geschäftspartner',
            report_type: 'Bericht Typ',
            generated_at: 'Generiert At',
            no_reports: 'Keine reports gefunden.',
            generate: 'Generieren Bericht',
        },
        audit: {
            title: 'Partner-Prüfprotokoll',
            event_type: 'Ereignis Typ',
            entity_type: 'Entität Typ',
            entity_id: 'Entität ID',
            actor: 'Akteur',
            timestamp: 'Zeitstempel',
            no_events: 'Keine Audit Ereignisse gefunden.',
            events_found: 'Ereignisse gefunden',
            event_type_created: 'Erstellt',
            event_type_updated: 'Aktualisiert',
            event_type_deleted: 'Gelöscht',
            event_type_status_change: 'Statusänderung',
            event_type_escalation: 'Eskalation',
            event_type_assignment: 'Aufgabe',
            entity_type_partner_org: 'Partnerorganisation',
            entity_type_service_tier: 'Serviceebene',
            entity_type_deliverable_template: 'Lieferbare Vorlage',
            entity_type_deliverable_instance: 'Lieferbare Instanz',
            entity_type_brand_profile: 'Markenprofil',
            entity_type_support_ticket: 'Support-Ticket',
            entity_type_workflow_template: 'Workflow-Vorlage',
            entity_type_workflow_instance: 'Workflow-Instanz',
            entity_type_generated_report: 'Generierter Bericht',
            entity_type_escalation_rule: 'Eskalationsregel',
        },
        no_permission_title: 'Unzureichende Berechtigungen',
        no_permission_message: 'Sie haben keine Berechtigung, auf den Partnerarbeitsbereich zuzugreifen.',
        status_active: 'Aktiv',
        status_suspended: 'Suspendiert',
        status_offboarded: 'Offboarded',
        status_completed: 'Abgeschlossen',
        status_cancelled: 'Abgesagt',
        status_deprecated: 'Veraltet',
        status_new: 'Neu',
        status_triaged: 'Triagiert',
        status_in_progress: 'In Bearbeitung',
        status_waiting_on_client: 'Warten auf den Kunden',
        status_waiting_on_vendor: 'Warten auf den Verkäufer',
        status_escalated: 'Eskaliert',
        status_resolved: 'Gelöst',
        status_closed: 'Geschlossen',
        status_pending: 'Ausstehend',
        status_skipped: 'Übersprungen',
        category_onboarding: 'Onboarding',
        category_incident_escalation: 'Eskalation des Vorfalls',
        category_config_change: 'Konfigurationsänderung',
        category_periodic_review: 'Regelmäßige Überprüfung',
        category_offboarding: 'Offboarding',
        category_custom: 'Benutzerdefiniert',
        category_configuration: 'Konfiguration',
        category_incident: 'Vorfall',
        category_compliance_question: 'Compliance-Frage',
        category_feature_request: 'Funktionsanfrage',
        category_bug_report: 'Fehlerbericht',
        priority_critical: 'Kritisch',
        priority_high: 'Hoch',
        priority_medium: 'Mittel',
        priority_low: 'Niedrig',
        tier_silver: 'Silber',
        tier_gold: 'Gold',
        tier_platinum: 'Platin',
        report_type_compliance_summary: 'Compliance-Zusammenfassung',
        report_type_risk_overview: 'Risikoübersicht',
        report_type_incident_report: 'Vorfallbericht',
        report_type_consent_status: 'Einwilligungsstatus',
        report_type_program_maturity: 'Programmreife',
        report_type_executive_pack: 'Executive-Paket',
        note_type_internal: 'Intern',
        note_type_client_visible: 'Kunde sichtbar',
        status_updated: 'Status erfolgreich aktualisiert',
        deliverable_status_updated: 'Lieferstatus erfolgreich aktualisiert',
        ticket_status_updated: 'Ticketstatus erfolgreich aktualisiert',
        ticket_escalated: 'Das Ticket wurde erfolgreich eskaliert',
        note_added: 'Notiz erfolgreich hinzugefügt',
        attachment_uploaded: 'Anhang erfolgreich hochgeladen',
        ticket_deescalated: 'Das Ticket wurde erfolgreich deeskaliert',
        auto_evaluation_completed: 'Automatische Bewertung abgeschlossen',
        template_created: 'Workflow-Vorlage erfolgreich erstellt',
        template_updated: 'Workflow-Vorlage erfolgreich aktualisiert',
        brand_set_default: 'Markenprofil erfolgreich als Standard festgelegt',
        brand_created: 'Markenprofil erfolgreich erstellt',
        brand_updated: 'Markenprofil erfolgreich aktualisiert',
        tier_created: 'Serviceebene erfolgreich erstellt',
        tier_updated: 'Die Serviceebene wurde erfolgreich aktualisiert',
        tier_deprecated: 'Die Dienstebene wurde erfolgreich eingestellt',
        tier_activated: 'Servicestufe erfolgreich aktiviert',
        period: 'Zeitraum',
        format: 'Formatieren',
        period_start: 'Periodenbeginn',
        period_end: 'Periodenende',
        reports_count: '[[TOK_1]] Berichte',
        reports_count_one: '[[TOK_1]] Bericht',
        metric: 'Metrisch',
        value: 'Wert',
        showing_chart_view: 'Diagrammansicht wird angezeigt',
        showing_table_view: 'Datentabellenansicht wird angezeigt',
        evidence_ids_placeholder: 'z.B. ev-001, ev-002',
        confirm_cancel_workflow: 'Möchten Sie diesen Workflow wirklich abbrechen? Diese Aktion kann nicht rückgängig gemacht werden.',
        export_csv: 'Exportieren [[TOK_0]]',
        compliance_qualifications_title: 'Qualifikationen für den Compliance-Service',
        compliance_qualifications_desc: 'Die Partnerstufe (Silber/Gold/Platin) bestimmt den Umfang des Compliance-Services. Gold- und Platin-Partner sind für Einsätze in regulierten Branchen qualifiziert. Verwenden Sie das Feld „Metadaten“, um Zertifizierungen (ISO 27001, SOC 2), Spezialisierungen und Gerichtsbarkeitsqualifikationen für jeden Partner zu erfassen.',
        regulatory_output_title: 'Regulierungsausgabeausrichtung',
        regulatory_output_desc: 'Jeder Vorlagentyp ist einer regulatorischen Ausgabekategorie zugeordnet: Berichte erstellen Compliance-Dokumentation, Überprüfungen validieren die Wirksamkeit von Kontrollen, Bewertungen decken Risikobewertungen ab ([[TOK_0]], Lückenanalyse), Besprechungen dokumentieren Governance-Sitzungen. Nachweisanforderungen definieren die Artefakte, auf die sich jeder Liefergegenstand beziehen muss, um für die Prüfung bereit zu sein.',
        sla_compliance_title: '[[TOK_0]] Verfolgung der Compliance-Lieferung',
        sla_compliance_desc: 'SLAs für Reaktions- und Lösungszeiten sind vertraglich bindend für die Bereitstellung von Compliance-Services. Die Überprüfungshäufigkeit bestimmt, wie oft die Compliance-Ergebnisse der Partner bewertet werden. [[TOK_0]] Verstöße bei Compliance-kritischen Tickets lösen eine automatische Eskalation aus und werden im Partner Audit Trail für regulatorische Beweise protokolliert.',
        regulatory_engagement_title: 'Muster des regulatorischen Engagements',
        regulatory_engagement_desc: 'Workflow-Kategorien werden den Arten von regulatorischen Eingriffen zugeordnet: Onboarding umfasst die anfängliche Compliance-Einrichtung und Lückenanalyse, die regelmäßige Überprüfung übernimmt wiederkehrende Compliance-Bewertungen, Incident Escalation verwaltet die Reaktion auf regulatorische Verstöße, Offboarding stellt sicher, dass die Datenaufbewahrungspflichten erfüllt werden. Für jeden Schritt kann die Sammlung von Nachweisen zur Vollständigkeit des Prüfprotokolls erforderlich sein.',
        compliance_escalation_title: 'Compliance-kritische Eskalationsverfahren',
        compliance_escalation_desc: 'L1 kümmert sich um Standardbetriebsprobleme. L2 deckt Compliance-relevante Fehler ab (Versäumung regulatorischer Fristen, Kontrolllücken). L3 ist für Szenarien von Verstößen gegen Vorschriften reserviert, die eine sofortige Aufmerksamkeit der Geschäftsleitung erfordern. [[TOK_0]] Verstoß gegen L2/L3-Tickets generiert automatisch Audit-Trail-Einträge. Alle Eskalations- und Deeskalationsaktionen werden permanent protokolliert.',
        audit_regulatory_title: 'Regulatorischer Beweispfad',
        audit_regulatory_desc: 'Dieser Prüfpfad liefert manipulationssichere Aufzeichnungen zur Einhaltung gesetzlicher Vorschriften. Jede Partneraktion (Erstellen, Aktualisieren, Löschen, Eskalation, Statusänderung) wird mit Akteuridentität, Zeitstempel und vollständiger Nutzlastdifferenz protokolliert. Verwenden Sie Entitätstypfilter, um Beweise nach Compliance-Domäne zu isolieren. Exportieren Sie gefilterte Ergebnisse, um eine revisionssichere Dokumentation für behördliche Inspektionen zu erstellen.',
        evidence_trail_title: 'Modulübergreifender Beweispfad',
        evidence_trail_desc: 'Jeder Workflow-Schritt kann Beweis-IDs sammeln, die modulübergreifend mit Liefergegenständen, Prüfereignissen und Compliance-Artefakten verknüpft sind. Durch das Vorrücken eines Schritts mit Beweis-IDs entsteht eine überprüfbare Kette, die die Arbeitsabläufe der Partner mit der behördlichen Dokumentation verbindet. Abgeschlossene Arbeitsabläufe mit vollständigen Beweisketten dienen als Nachweis für die Erfüllung des Compliance-Engagements.',
        evidence_ids_label: 'Beweis-IDs',
    },
    org_groups: {
        title: 'Organisationsgruppen',
        new: 'Erstellen Gruppe',
        group_name: 'Gruppe Name',
        member_count: 'Mitglied Anzahl',
        root_org: 'Stamm Org',
        no_groups: 'Keine org groups gefunden.',
        add_organization: 'Organisation hinzufügen',
        select_organization: 'Organisation auswählen...',
        no_available_orgs: 'Keine verfügbaren Organisationen zum Hinzufügen.',
        no_members: 'Keine Mitgliedsorganisationen in dieser Gruppe.',
        member_added: 'Organisation zur Gruppe hinzugefügt.',
        member_removed: 'Organisation aus der Gruppe entfernt.',
        already_in_group: 'Diese Organisation ist bereits in einer Gruppe.',
        org_not_found: 'Organisation nicht gefunden.',
        add_member_error: 'Organisation konnte nicht zur Gruppe hinzugefügt werden.',
        remove_member_error: 'Organisation konnte nicht aus der Gruppe entfernt werden.',
        confirm_remove_member: 'Sind Sie sicher, dass Sie "{name}" aus dieser Gruppe entfernen möchten?',
        load_error: 'Org-Gruppendetails konnten nicht geladen werden.',
        page_title_list: 'Organisationsgruppen',
        page_title_detail: 'Details zur Organisationsgruppe',
        page_title_create: 'Organisationsgruppe erstellen',
        page_title_settings: 'Organisationsgruppeneinstellungen',
        page_title_users: 'Gruppenbenutzer',
        page_title_reports: 'Gruppenberichte',
        page_title_dashboard: 'Gruppen-Dashboard',
        page_title_audit: 'Gruppenprüfung',
        page_title_org_audit: 'Audit der Organisationsgruppe',
        page_title_shared_vendors: 'Geteilte Anbieter',
        page_title_shared_frameworks: 'Gemeinsame Frameworks',
        page_title_shared_forms: 'Freigegebene Formularvorlagen',
        page_title_merged_vendors: 'Zusammengeschlossene Anbieter',
        page_title_settings_inheritance: 'Vererbung der Einstellungen',
        announce_loaded_groups: '[[TOK_1]] Organisationsgruppen geladen',
        announce_loaded_group: 'Geladene Gruppe [[TOK_1]]',
        announce_loaded_users: 'Geladene [[TOK_1]] Gruppenbenutzer',
        announce_loaded_reports: '[[TOK_1]] Berichte geladen',
        announce_loaded_vendors: 'Geladen [[TOK_1]] freigegebene Anbieter',
        announce_loaded_frameworks: '[[TOK_1]] freigegebene Frameworks geladen',
        announce_loaded_templates: '[[TOK_1]] freigegebene Formularvorlagen geladen',
        announce_loaded_audit: '[[TOK_1]] Prüfereignisse geladen',
        announce_loaded_merged: 'Geladene [[TOK_2]] freigegebene und [[TOK_3]] lokale Anbieter',
        announce_dashboard_loaded: 'Dashboard geladen.',
        announce_dashboard_refreshed: 'Dashboard aktualisiert.',
        announce_dashboard_refresh_failed: 'Das Dashboard konnte nicht aktualisiert werden.',
        announce_refreshing: 'Erfrischendes Dashboard...',
        announce_settings_loaded: 'Einstellungsvererbung geladen.',
        announce_settings_saved: 'Einstellungen erfolgreich gespeichert.',
        announce_saving_settings: 'Einstellungen speichern...',
        announce_error_saving: 'Fehler beim Speichern der Einstellungen.',
        announce_group_dissolved: 'Gruppe aufgelöst.',
        announce_creating_group: 'Organisationsgruppe wird erstellt...',
        announce_group_created: 'Organisationsgruppe erfolgreich erstellt.',
        announce_error_creating: 'Fehler beim Erstellen der Organisationsgruppe.',
        announce_vendor_published: 'Anbieter erfolgreich veröffentlicht.',
        announce_vendor_retired: 'Der Anbieter ist im Ruhestand.',
        announce_framework_published: 'Framework erfolgreich veröffentlicht.',
        announce_framework_retired: 'Framework im Ruhestand.',
        announce_template_published: 'Formularvorlage erfolgreich veröffentlicht.',
        announce_template_retired: 'Formularvorlage wurde eingestellt.',
        announce_role_assigned: 'Rolle erfolgreich zugewiesen.',
        announce_error_assign_role: 'Fehler beim Zuweisen der Rolle.',
        announce_role_revoked: 'Rolle erfolgreich widerrufen.',
        announce_report_generating: 'Bericht wird erstellt...',
        announce_report_requested: 'Berichterstellung angefordert.',
        announce_error_report: 'Fehler beim Anfordern eines Berichts.',
        announce_report_deleted: 'Bericht gelöscht.',
        announce_search_applied: 'Suche angewendet.',
        announce_search_cleared: 'Suche gelöscht.',
        announce_tab_selected: 'Registerkarte [[TOK_1]] ausgewählt',
        announce_error_add_member: 'Fehler beim Hinzufügen eines Mitglieds zur Gruppe.',
        announce_category_reverted: '[[TOK_1]] wurde auf vom übergeordneten Element geerbt zurückgesetzt.',
        announce_category_overridden: '[[TOK_1]] auf lokale Überschreibung gesetzt.',
        announce_override_saved: '[[TOK_1]] Überschreibung gespeichert.',
        announce_export_started: 'Audit wird exportiert als [[TOK_1]]...',
        announce_export_completed: 'Export als [[TOK_1]] abgeschlossen.',
        announce_export_failed: 'Der Export ist fehlgeschlagen.',
        announce_filter_org: 'Gefiltert nach Organisation [[TOK_1]]',
        announce_filter_org_cleared: 'Organisationsfilter gelöscht',
        announce_filter_event: 'Gefiltert nach Ereignistyp [[TOK_1]]',
        announce_filter_cleared: 'Filter gelöscht',
        announce_download: 'Herunterladen von [[TOK_2]] als [[TOK_3]]',
        error_load_groups: 'Organisationsgruppen konnten nicht geladen werden. Bitte versuchen Sie es erneut.',
        error_load_users: 'Gruppenbenutzer konnten nicht geladen werden.',
        error_load_reports: 'Gruppenberichte konnten nicht geladen werden.',
        error_load_dashboard: 'Das Gruppen-Dashboard konnte nicht geladen werden.',
        error_load_settings: 'Die Gruppeneinstellungen konnten nicht geladen werden.',
        error_load_vendors: 'Zusammengeführte Anbieter konnten nicht geladen werden.',
        error_save_settings: 'Einstellungen konnten nicht gespeichert werden.',
        error_dissolve_group: 'Die Gruppe konnte nicht aufgelöst werden.',
        error_assign_role: 'Rolle konnte nicht zugewiesen werden.',
        error_create_group: 'Die Organisationsgruppe konnte nicht erstellt werden. Bitte versuchen Sie es erneut.',
        error_request_report: 'Fehler beim Anfordern eines Berichts.',
        error_group_name_required: 'Gruppenname ist erforderlich.',
        success_settings_saved: 'Einstellungen erfolgreich gespeichert.',
        confirm_retire_vendor: 'Sind Sie sicher, dass Sie den Anbieter „[[TOK_1]]“ aus dem Verkehr ziehen möchten?',
        confirm_retire_framework: 'Sind Sie sicher, dass Sie das Framework „[[TOK_1]]“ außer Betrieb nehmen möchten?',
        confirm_retire_template: 'Sind Sie sicher, dass Sie die Formularvorlage „[[TOK_1]]“ zurückziehen möchten?',
        confirm_dissolve_group: 'Sind Sie sicher, dass Sie „[[TOK_1]]“ auflösen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
        confirm_revoke_role: 'Sind Sie sicher, dass Sie die Rolle „[[TOK_2]]“ von „[[TOK_3]]“ widerrufen möchten?',
        confirm_delete_report: 'Sind Sie sicher, dass Sie den Bericht „[[TOK_1]]“ löschen möchten?',
        dissolve_group: 'Gruppe auflösen',
        dissolve_warning: 'Dadurch wird die Organisationsgruppe dauerhaft aufgelöst. Alle Mitgliedsorganisationen werden entfernt.',
        count_groups: '[[TOK_1]] Gruppe',
        count_groups_plural: '[[TOK_1]] Gruppen',
        count_users: '[[TOK_1]] Benutzer',
        count_users_plural: '[[TOK_1]] Benutzer mit Gruppenrollen',
        count_events: '[[TOK_1]] Ereignis',
        count_events_plural: '[[TOK_1]] Ereignisse',
        count_reports: '[[TOK_1]] Bericht',
        count_reports_plural: '[[TOK_1]] Berichte',
        count_vendors: '[[TOK_1]] Anbieter, der in der gesamten Gruppe geteilt wird',
        count_vendors_plural: '[[TOK_1]] Anbieter, die in der gesamten Gruppe geteilt werden',
        count_frameworks: '[[TOK_1]] Framework, das in der gesamten Gruppe geteilt wird',
        count_frameworks_plural: '[[TOK_1]] Frameworks, die in der gesamten Gruppe geteilt werden',
        count_templates: '[[TOK_1]] Vorlage, die in der gesamten Gruppe geteilt wird',
        count_templates_plural: '[[TOK_1]] Vorlagen, die in der gesamten Gruppe geteilt werden',
        count_shared_vendors: '[[TOK_1]] geteilte Anbieter',
        count_local_vendors: '[[TOK_1]] lokale Anbieter',
        merged_combined_view: 'Kombinierte Ansicht von [[TOK_2]] freigegebenen und [[TOK_3]] lokalen Anbietern',
        dashboard: {
            title: 'Gruppenübersicht',
            loading: 'Lade Dashboard Daten...',
            total_groups: 'Gesamt Gruppen',
            total_members: 'Gesamt Mitglieder',
            active_groups: 'Aktiv Gruppen',
            overall_compliance_score: 'Gesamt-Compliance-Score',
            group_risk_level: 'Gruppenrisikostufe',
            sla_compliance: '[[TOK_0]] Compliance',
            compliance_posture: 'Compliance-Haltung',
            risk_heatmap: 'Risiko-Heatmap',
            sla_performance: '[[TOK_0]] Leistung',
            recent_incidents: 'Aktuelle Vorfälle',
            recent_activity: 'Letzte Aktivität',
            refresh_label: 'Dashboard-Daten aktualisieren',
            score_good: 'Gut',
            score_needs_attention: 'Braucht Aufmerksamkeit',
            score_critical: 'Kritisch',
            trend_up: 'Tendenz steigend',
            trend_down: 'Abwärtstrend',
            trend_stable: 'Stabil',
            risk_low: 'Low',
            risk_medium: 'Mittel',
            risk_high: 'Hoch',
            risk_critical: 'Kritisch',
            risk_unknown: 'Unbekannt',
            col_organization: 'Organisation',
            col_score: 'Punktzahl',
            col_trend: 'Trend',
            col_open_issues: 'Offene Probleme',
            col_critical_issues: 'Kritische Probleme',
            col_health: 'Gesundheit',
            col_vendor_risk: 'Lieferantenrisiko',
            col_data_risk: 'Datenrisiko',
            col_compliance_risk: 'Compliance-Risiko',
            col_total_cases: 'Gesamtzahl der Fälle',
            col_on_time: 'Pünktlich',
            col_breached: 'Durchbrochen',
            col_sla_percent: '[[TOK_0]] %',
            col_avg_days: 'Durchschnittliche Tage',
            sr_vendor_risk: 'Risikobewertung des Anbieters: [[TOK_1]]',
            sr_data_risk: 'Datenrisikobewertung: [[TOK_1]]',
            sr_compliance_risk: 'Compliance-Risikobewertung: [[TOK_1]]',
            sr_sla_breaches: 'Warnung: [[TOK_1]] [[TOK_2]] Verstöße',
            sr_severity: 'Schweregrad: [[TOK_1]]',
        },
        detail: {
            title: 'Gruppendetails',
            members: 'Mitglieder',
            settings: 'Einstellungen',
            audit: 'Prüfung',
            sr_loading: 'Details zur Organisationsgruppe werden geladen',
            sr_loading_hierarchy: 'Ladehierarchie',
            member_org: 'Mitgliedsorganisation',
            root_org_label: 'Wurzelorganisation',
        },
        users: {
            title: 'Gruppenbenutzer',
            add_user: 'Hinzufügen Benutzer',
            no_users: 'No users in dieses Gruppe.',
            role_group_admin: 'Gruppenadministrator',
            role_group_reader: 'Gruppenleser',
            sr_loading: 'Gruppenbenutzer werden geladen',
        },
        reports: {
            title: 'Gruppenberichte',
            no_reports: 'Keine reports gefunden.',
            generate_report: 'Neuen Bericht erstellen',
            report_type_compliance: 'Compliance-Zusammenfassung',
            report_type_risk: 'Risikoübersicht',
            report_type_sla: '[[TOK_0]] Leistung',
            report_type_incident: 'Vorfallbericht',
            report_type_executive: 'Executive Brief',
            report_type_board: 'Vorstandsbericht',
            status_queued: 'In der Warteschlange',
            status_generating: 'Generieren',
            status_completed: 'Abgeschlossen',
            status_failed: 'Fehlgeschlagen',
            period_start: 'Periodenbeginn',
            period_end: 'Periodenende',
            sr_loading: 'Gruppenberichte werden geladen',
        },
        shared_vendors: {
            title: 'Gemeinsame Lieferanten',
            no_vendors: 'Keine shared Anbieter gefunden.',
            merged_vendors: 'Zusammengeführt Anbieter',
            publish_form_label: 'Gemeinsamen Anbieter veröffentlichen',
            sr_loading: 'Geteilte Anbieter werden geladen',
            sr_loading_merged: 'Zusammengeführte Anbieter werden geladen',
            local_vendors: 'Lokale Anbieter',
            source_shared: 'Von der Gruppe geteilt',
            source_local: 'Lokaler Anbieter',
            category_technology: 'Technologie',
            category_consulting: 'Beratung',
            category_outsourcing: 'Outsourcing',
            category_cloud: 'Wolke',
            category_data_processing: 'Datenverarbeitung',
            category_other: 'Andere',
            risk_tier_low: 'Low',
            risk_tier_medium: 'Mittel',
            risk_tier_high: 'Hoch',
            risk_tier_critical: 'Kritisch',
            compliance_compliant: 'Konform',
            compliance_non_compliant: 'Nicht konform',
            compliance_pending: 'Ausstehend',
            compliance_under_review: 'Wird überprüft',
            status_active: 'Aktiv',
            status_retired: 'Im Ruhestand',
        },
        shared_frameworks: {
            title: 'Gemeinsame Rahmenwerke',
            no_frameworks: 'Keine shared frameworks gefunden.',
            publish_form_label: 'Gemeinsames Framework veröffentlichen',
            sr_loading: 'Gemeinsam genutzte Frameworks werden geladen',
            status_active: 'Aktiv',
            status_retired: 'Im Ruhestand',
        },
        shared_forms: {
            title: 'Gemeinsame Formularvorlagen',
            no_forms: 'Keine shared Formular Vorlagen gefunden.',
            publish_form_label: 'Freigegebene Formularvorlage veröffentlichen',
            sr_loading: 'Laden freigegebener Formularvorlagen',
            status_active: 'Aktiv',
            status_retired: 'Im Ruhestand',
        },
        audit: {
            title: 'Gruppenprüfung',
            consolidated_title: 'Konsolidiert Audit Trail',
            consolidated_subtitle: 'Cross-organization Audit Ereignisse für dieses Gruppe',
            audit_log_title: 'Gruppe Audit Protokoll',
            event_type: 'Ereignis Typ',
            actor: 'Akteur',
            timestamp: 'Zeitstempel',
            source_org: 'Quelle Org',
            org: 'Org',
            summary: 'Zusammenfassung',
            details: 'Einzelheiten',
            no_events: 'Keine Audit Ereignisse gefunden.',
            all_events: 'Alle Ereignisse',
            all_orgs: 'Alle Orgs',
            organization: 'Organisation',
            from: 'Von',
            to: 'To',
            search_events: 'Suche Ereignisse...',
            clear: 'Löschen',
            events_24h: 'Ereignisse (24h)',
            events_7d: 'Ereignisse (7d)',
            active_orgs: 'Aktiv Orgs',
            exporting: 'Exportiere...',
            export_csv: 'Exportieren CSV',
            export_json: 'Exportieren JSON',
            back_to_group: 'Back zu Gruppe',
            back_to_detail: 'Back zu Detail',
            sr_loading: 'Audit-Ereignisse werden geladen',
            sr_loading_summary: 'Audit-Zusammenfassung wird geladen',
        },
        settings: {
            title: 'Gruppe Einstellungen',
            inheritance: 'Einstellungen Inheritance',
            inheritance_subtitle: 'Konfigurieren Sie, welche Einstellungskategorien von der Gruppe erben oder lokale Überschreibungen verwenden',
            sla_settings: 'SLA Einstellungen',
            calendar_settings: 'Kalender Einstellungen',
            notification_settings: 'Benachrichtigung Einstellungen',
            intake_settings: 'Aufnahme Einstellungen',
            cmp_integration: 'CMP-Integration',
            overridden: 'Überschrieben',
            inheriting: 'Vererbung',
            hide_defaults: 'Ausblenden Standardwerte',
            show_group_defaults: 'Anzeigen Gruppe Standardwerte',
            group_defaults: 'Gruppe Standardwerte',
            inherit_from_group: 'Erben von Gruppe',
            use_local_override: 'Use Local Überschreiben',
            local_override_json: 'Local Überschreiben (JSON)',
            save_override: 'Speichern Überschreiben',
            saving: 'Speichere...',
            sr_loading: 'Vererbung der Ladeeinstellungen',
            sr_loading_settings: 'Gruppeneinstellungen werden geladen',
            sr_enabled: 'Aktiviert',
            sr_disabled: 'Deaktiviert',
            sr_override_active: 'Lokale Übersteuerung aktiv',
            sr_inherited: 'Vom Elternteil geerbt',
            danger_zone: 'Gefahrenzone',
            sharing_options: 'Freigabeoptionen',
            advanced_options: 'Erweiterte Optionen',
        },
        status_active: 'Aktiv',
        status_dissolved: 'Aufgelöst',
        status_pending: 'Ausstehend',
        status_suspended: 'Suspendiert',
    },
    integrations: {
        nav: {
            webhooks: 'Webhook-Endpunkte',
            domains: 'Domänen',
            export_schedules: 'Exportzeitpläne',
            email_log: 'E-Mail-Protokoll',
        },
    },
    platform: {
        nav: {
            users: 'Benutzer',
            roles: 'Rollen',
            profile: 'Mein Profil',
        },
        security: {
            mfa: 'MFA-Einstellungen',
            sso: 'SSO-Konfiguration',
            api_keys: 'API-Schlüssel',
            service_accounts: 'Dienstkonten',
            ip_allowlist: 'IP-Positivliste',
            delegations: 'Delegierungen',
            break_glass: 'Notfallzugriff',
            session_settings: 'Sitzungseinstellungen',
            active_sessions: 'Aktive Sitzungen',
            access_reviews: 'Zugriffsüberprüfungen',
            my_reviews: 'Meine Überprüfungen',
            role_analytics: 'Rollenanalysen',
            attestation_schedules: 'Bestätigungszeitpläne',
            sod_rules: 'SoD-Regeln',
            sod_violations: 'SoD-Verstöße',
        },
        module_config: {
            title: 'Modulkonfiguration',
            subtitle: 'Aktivieren oder deaktivieren Sie Funktionsmodule für Ihre Organisation. Deaktivierte Module werden in der Navigation ausgeblendet.',
            enabled: 'Aktiviert',
            disabled: 'Deaktiviert',
            save: 'Konfiguration speichern',
            saving: 'Speichern...',
            saved: 'Konfiguration erfolgreich gespeichert',
            nav_label: 'Modulkonfiguration',
            settings: 'Einstellungen',
            webhooks: 'Webhook-Endpunkte',
            domains: 'Domänen',
            export_schedules: 'Exportzeitpläne',
            email_log: 'E-Mail-Protokoll',
        },
        files_nav: {
            section: 'Dateien',
            configuration: 'Konfiguration',
            browser: 'Dateibrowser',
            dashboard: 'Dateien-Dashboard',
        },
        immutable_audit_trails: {
            nav_group_label: 'Prüfung und Nachweis',
            nav_settings: 'Einstellungen',
            nav_status: 'Beweisstatus',
            nav_integrity_center: 'Integritätszentrum',
            nav_usage: 'Nutzung & Credits',
            settings_title: 'Unveränderliche Prüfprotokolle – Einstellungen',
            settings_subtitle: 'Organisationsspezifische Einstellungen für das Immutable Audit Trails-Add-on.',
            settings_banner: 'Das Add-on „Immutable Audit Trails“ ist für Ihre Organisation nicht aktiviert. Aktivieren Sie es hier, um mit der Verankerung von Nachweisen für Tier-A- und Tier-B-Prüfungsereignisse zu beginnen.',
            status_title: 'Unveränderliche Prüfprotokolle – Beweisstatus',
            status_subtitle: 'Modulübergreifende Proof-Beziehungen pro Ereignis.',
            status_banner: 'Das Add-on „Immutable Audit Trails“ ist für Ihre Organisation nicht aktiviert. Besuchen Sie die Einstellungen, um es zu aktivieren.',
            integrity_center_title: 'Unveränderliche Prüfprotokolle – Integrity Center',
            integrity_center_subtitle: 'Überprüfen Sie Beweise und exportieren Sie Integrity Packs.',
            integrity_center_banner: 'Das Add-on „Immutable Audit Trails“ ist für Ihre Organisation nicht aktiviert. Besuchen Sie die Einstellungen, um es zu aktivieren, bevor Sie die Überprüfung durchführen oder Integrity Packs exportieren.',
            usage_title: 'Unveränderliche Audit Trails – Nutzung und Credits',
            usage_subtitle: 'Guthaben, Paketkäufe und Nutzungshistorie.',
            usage_banner: 'Aktivieren Sie unveränderliche Prüfprotokolle in den Einstellungen, um Proof-Credits zu verbrauchen.',
            module_tips_placeholder: 'Tipps und Anleitungen für diese Oberfläche finden Sie im Hilfecenter.',
            column_label: 'Beweis',
            no_proof_aria: 'Kein Beweis aufgezeichnet',
            proof_status_receipt_label: 'Beleg {id}',
            in_progress_hint: 'In Bearbeitung – wird automatisch aktualisiert',
            status_pills: {
                pending: 'Ausstehend',
                submitted: 'Eingereicht',
                anchored: 'Verankert',
                confirmed: 'Bestätigt',
                retrying: 'Erneuter Versuch',
                paused_cap: 'Pausiert (Kappe)',
                failed: 'Fehlgeschlagen',
                failed_auth: 'Authentifizierung fehlgeschlagen',
            },
            status_tooltips: {
                pending: 'Ausstehend – in der Warteschlange für den Proof-Service. Wird in Kürze zu „Eingereicht“ verschoben; Es sind keine Maßnahmen erforderlich.',
                submitted: 'Eingereicht – Ihr Ereignis wurde an den Korrekturdienst gesendet. Im Batch-Modus wartet es darauf, versiegelt und in der Kette verankert zu werden. Automatisch aktualisiert; Es sind keine Maßnahmen erforderlich.',
                anchored: 'Verankert – der Stapel wurde in die Kette geschrieben und wartet auf die endgültige Bestätigung. Automatisch aktualisiert; Es sind keine Maßnahmen erforderlich.',
                confirmed: 'Bestätigt – der Beweis ist in der Kette verankert und überprüfbar.',
                retrying: 'Erneuter Versuch – ein vorübergehender Fehler ist aufgetreten. Der Abgleicher versucht es automatisch erneut. Es sind keine Maßnahmen erforderlich.',
                paused_cap: 'Pausiert – Ihre monatliche Proof-Credit-Obergrenze wurde erreicht. Lösen Sie weitere Credits ein oder warten Sie bis zum nächsten Abrechnungsmonat.',
                failed: 'Fehlgeschlagen – die Verankerung war nicht erfolgreich. Der Abgleicher wird es automatisch erneut versuchen; Wenden Sie sich an den Support, wenn das Problem weiterhin besteht.',
                failed_auth: 'Authentifizierung fehlgeschlagen – der Prüfdienst hat unsere Anmeldeinformationen abgelehnt. Überprüfen Sie die Seite „Einstellungen für unveränderliche Audit-Trails“.',
            },
            mode_pills: {
                direct: 'Direkt',
                batch: 'Charge',
            },
            drawer: {
                title: 'Beweisdetails',
                close: 'Schließen',
                section_proof: 'Beweis',
                section_batch: 'Batch-Mitgliedschaft',
                status: 'Status',
                proof_reference: 'Beweisreferenz',
                receipt_id: 'Empfangs-ID',
                taxonomy_class: 'Taxonomie-Kurs',
                units_consumed: 'Verbrauchte Einheiten',
                created_at: 'Erstellt',
                verification_ref: 'Referenz zur Kettenverifizierung',
                chain: 'Kette',
                tx_hash: 'Tx-Hash',
                block_ref: 'Blockreferenz',
                batch_reference: 'Chargenreferenz',
                leaf_index: 'Blattindex',
                local_event_hash: 'Lokaler Ereignis-Hash',
                show_inclusion: 'Einschlusspfad anzeigen',
                hide_inclusion: 'Einschlusspfad ausblenden',
                privacy_note: 'Nutzlast wird gehasht; Für diese Veranstaltung wurden von ComplianceOne keine personenbezogenen Daten hinterlassen.',
                verify_now: 'Jetzt überprüfen',
                verify_pending: 'Verifizierung läuft…',
                verify_verified: 'Verifiziert – lokale und kettenseitige Prüfungen bestanden.',
                verify_issue_prefix: 'Verifizierungsproblem: ',
                verify_failed: 'Der Bestätigungsaufruf ist fehlgeschlagen.',
                verify_result_prefix: 'Überprüfungsurteil: ',
                verify_pending_note: 'Überprüfung ausstehend: Dieser Beweis wartet noch auf die Verankerung in der Kette. Versuchen Sie es erneut, nachdem die Charge versiegelt wurde.',
                awaiting_anchor_note: 'Dieser Beweis ist Teil einer offenen Charge. Die Verifizierung wird verfügbar, sobald der Batch versiegelt und in der Kette verankert ist – normalerweise innerhalb des konfigurierten Batch-Fensters der Organisation. Das Statusabzeichen wird automatisch aktualisiert.',
                terminal_error_note: 'Dieser Beweis konnte nicht verankert werden. Der Proof-Status-Abgleicher wird es automatisch erneut versuchen; Bei der manuellen Überprüfung gibt es noch nichts zu überprüfen.',
            },
            integrity_center: {
                section_run: 'Führen Sie die Überprüfung durch',
                section_progress: 'Lauffortschritt',
                section_issues: 'Probleme',
                period_start: 'Beginn der Periode',
                period_end: 'Periodenende',
                module_filter: 'Module (durch Kommas getrennt, optional)',
                modules_placeholder: 'rights_requests, Vorfälle',
                run_button: 'Führen Sie die Überprüfung durch',
                export_button: 'Integrity Pack exportieren',
                export_success: 'Integrity Pack exportiert.',
                export_failed: 'Der Export ist fehlgeschlagen.',
                empty_disabled: 'Aktivieren Sie unveränderliche Prüfprotokolle in den Einstellungen, um Verifizierungsdurchgänge durchzuführen.',
                error_period_required: 'Wählen Sie ein Start- und Enddatum.',
                error_start_run: 'Der Lauf konnte nicht gestartet werden.',
                processed: 'Verarbeitet: [[TOK_2]] von [[TOK_3]]',
                col_verdict: 'Urteil',
                col_count: 'Zählen',
                col_proof_link: 'Beweislink',
                col_module: 'Modul',
                col_event_type: 'Ereignistyp',
                col_expected: 'Erwarteter Hash',
                col_recomputed: 'Neu berechneter Hash',
                col_raised_at: 'Aufgewachsen bei',
                any_verdict: 'Irgendein Urteil',
                no_issues: 'Keine Probleme gefunden.',
            },
            settings_page: {
                load_error: 'Die Einstellungen konnten nicht geladen werden.',
                save: 'Speichern',
                save_success: 'Einstellungen gespeichert.',
                save_error: 'Speichern fehlgeschlagen.',
                discard: 'Änderungen verwerfen',
                read_only_banner: 'Sie haben nur Lesezugriff. Wenden Sie sich an einen Plattformadministrator, um Änderungen vorzunehmen.',
                section_status: 'Status und Aktivierung',
                enabled_label: 'Add-on aktiviert',
                enabled_help: 'Wenn diese Option aktiviert ist, wird jedes Tier-A- und Tier-B-Prüfungsereignis gehasht und verankert.',
                section_scope: 'Umfang',
                scope_self: 'Nur ich selbst',
                scope_self_and_children: 'Selbst- und Kinderorganisationen',
                scope_children_only: 'Nur für Kinder (Elternteil prüft seine eigenen Ereignisse nicht)',
                section_mode: 'Standard-Proof-Modus',
                mode_direct: 'Direkt (ein Anker pro Veranstaltung)',
                mode_batch: 'Batch (Merkle-Root-Anker pro Gruppe)',
                mode_hybrid: 'Hybrid (Registrierungsstandard pro Klasse)',
                batch_window_label: 'Batch-Fenster (Minuten, 1–60)',
                section_taxonomy: 'Taxonomie geschützter Ereignisse',
                taxonomy_help: 'Überschreibungen pro Ereignisklasse. Stufe A → Direktmodus, Stufe B → Stapelmodus, Aus → nicht geprüft.',
                taxonomy_search: 'Suchüberschreibungen',
                taxonomy_reset: 'Auf Standardeinstellungen zurücksetzen',
                taxonomy_event_class: 'Veranstaltungsklasse',
                taxonomy_override: 'Überschreiben',
                taxonomy_actions: 'Aktionen',
                taxonomy_clear: 'Klar',
                taxonomy_no_overrides: 'Keine Überschreibungen – Verwendung der Registrierungsstandardwerte.',
                taxonomy_add_class: 'event_class.code',
                taxonomy_add: 'Überschreibung hinzufügen',
                section_privacy: 'Datenschutzkontrollen',
                privacy_log_actor_ip: 'IP des Akteurs protokollieren',
                privacy_log_user_agent: 'Benutzeragent protokollieren',
                privacy_privileged_access_proofing: 'Nachweis von Lesevorgängen mit privilegiertem Zugriff (Stufe A)',
                privacy_note: 'Änderungen gelten nur prospektiv.',
                section_caps: 'Obergrenzen und Limits',
                cap_label: 'Monatliche Obergrenze (Einheiten; leer = unbegrenzt)',
                warn_label: 'Warnschwellenwert (Einheiten; muss kleiner als die Obergrenze sein)',
                auto_pause_label: 'Neue Proofs werden automatisch angehalten, sobald die Obergrenze erreicht ist',
                section_export: 'Exportzugriff',
                export_help: 'Rollen-IDs, die zum Exportieren von Integrity Packs berechtigt sind. Durch Kommas getrennt; leer = Berechtigungsstandard IMMUTABLE_AUDIT_TRAILS_EXPORT verwenden.',
                section_group: 'Gruppenbeteiligung',
                group_view_intro: 'Sie sind als Gruppenelternteil konfiguriert. Jede untergeordnete Organisation kontrolliert ihre eigene Aktivierung/Deaktivierung; Ihre Entscheidungen wirken sich auf Ihre Abrechnung gemäß den Gruppenabrechnungsregeln aus.',
                group_view_rule_enabled: 'Ein Kind mit „enabled=false“ wird als „Nicht teilnehmend“ angezeigt. Sie sehen die Abwesenheit; Das Kind steuert den Schalter.',
                group_view_rule_billing: 'Der Kinderkonsum wird auf Ihre monatliche Obergrenze angerechnet. Sehen Sie sich die Seite „Nutzung“ an, um die kombinierte Brennrate zu überwachen.',
                group_view_rule_edit: 'Auf dieser Seite können Sie die Einstellungen eines Kindes nicht bearbeiten. Öffnen Sie die untergeordnete Organisation direkt zum Bearbeiten.',
                group_view_open_groups: 'Öffnen Sie Organisationsgruppen',
                section_credentials: 'Anmeldeinformationen',
                credential_id: 'Anmeldeinformations-ID',
                credential_rotated_at: 'Zuletzt gedreht',
                rotate_button: 'Anmeldeinformationen rotieren',
                rotate_success: 'Berechtigungsnachweis geändert. Alte Anmeldeinformationen sind noch [[TOK_1]] Minuten gültig.',
                rotate_failed: 'Die Rotation der Anmeldedaten ist fehlgeschlagen.',
                rotate_modal_title: 'Anmeldeinformationen [[TOK_0]] rotieren?',
                rotate_modal_body: 'Die Rotation stellt einen neuen Ausweis aus. Der alte Berechtigungsnachweis wird von [[TOK_0]] für ein 60-minütiges Kulanzfenster weiterhin akzeptiert, damit Mitarbeiter während des Flugs ihre aktuellen Aufgaben erledigen können. Nach 60 Minuten wird der alte Ausweis widerrufen.',
                rotate_modal_confirm: 'Jetzt drehen',
                tier_a_off_modal_title: 'Proofing für eine Ereignisklasse deaktivieren?',
                tier_a_off_modal_body: 'Wenn Sie eine Ereignisklasse auf „Aus“ setzen, verhindert der Proof-Tap, dass diese Ereignisse verankert werden. Architektur §6 erläutert die regulatorische Implikation: Tier-A-Ereignisse sind regulierungsrelevant; Wenn Sie sie deaktivieren, kann dies die Verteidigungsfähigkeit Ihres Audit-Trails beeinträchtigen.',
                tier_a_off_modal_confirm: 'Ich verstehe – Override anwenden',
                error_warn_lt_cap: 'Der Warnschwellenwert muss unter der monatlichen Obergrenze liegen.',
                error_window_range: 'Das Batch-Fenster muss zwischen 1 und 60 Minuten liegen.',
                error_run_in_progress: 'Ein Verifizierungslauf ist im Gange; Das Add-on kann derzeit nicht deaktiviert werden.',
            },
            status_page: {
                filter_status: 'Status',
                filter_mode: 'Proof-Modus',
                filter_module: 'Modul',
                filter_source_collection: 'Quellensammlung',
                filter_from_date: 'Von',
                filter_to_date: 'Zu',
                filter_search: 'Suchen',
                any_status: 'Beliebiger Status',
                any_mode: 'Jeder Modus',
                col_module: 'Modul',
                col_event_type: 'Ereignistyp',
                col_proof_status: 'Status',
                col_proof_mode: 'Modus',
                col_created_at: 'Erstellt',
                col_units: 'Einheiten',
                empty_disabled: 'Das Add-on „Immutable Audit Trails“ ist für Ihre Organisation nicht aktiviert. Besuchen Sie die Einstellungen, um es zu aktivieren.',
                empty_enabled_no_rows: 'Keine Proof-Links entsprechen den aktuellen Filtern.',
                export_csv: 'Exportieren [[TOK_0]]',
                export_xlsx: 'Exportieren [[TOK_0]]',
                export_success: 'Export abgeschlossen',
                export_failed: 'Der Export ist fehlgeschlagen',
            },
            usage_page: {
                section_alerts: 'Warnungen',
                alert_dismiss: 'Entlassen',
                alert_dismiss_aria: 'Warnung schließen [[TOK_1]]',
                alert_dismissed: 'Warnung abgewiesen',
                alert_dismiss_failed: 'Warnung konnte nicht geschlossen werden',
                section_balance: 'Guthaben',
                balance_label: 'Verfügbare Credits',
                balance_hint: 'Verbleibende Einheiten (1 Einheit = 1 geschützter Ereignisnachweis).',
                section_current_month: 'Aktueller Monat',
                consumed_label: 'Verbraucht',
                granted_label: 'Zugegeben',
                refunded_label: 'Erstattet',
                net_label: 'Netz',
                section_history: 'Nutzungshistorie',
                history_kind: 'Freundlich',
                history_units: 'Einheiten',
                history_balance_after: 'Ausgleich danach',
                history_notes: 'Notizen',
                history_at: 'Wann',
                cap_warning_banner: 'Sie haben Ihren Warnschwellenwert für diesen Abrechnungsmonat überschritten. Erwägen Sie die Einlösung zusätzlicher Credits.',
                cap_paused_banner: 'Monatsobergrenze erreicht. Die Einreichung von Nachweisen wird bis zum nächsten Monat oder bis zur Erhöhung der Obergrenze ausgesetzt.',
                section_redeem: 'Guthabenpaket einlösen',
                redeem_purchase_id: 'Rechnungsnummer',
                redeem_package: 'Paket',
                redeem_button: 'Einlösen',
                redeem_pending: 'Einlösen…',
                redeem_success: 'Credits eingelöst',
                redeem_failed: 'Einlösen fehlgeschlagen',
                redeem_option_template: '[[TOK_4]] — [[TOK_5]] [[TOK_6]] — [[TOK_7]]',
                redeem_option_units: 'Einheiten',
                alert_dismissing: 'Entlassen…',
                alert_kind: {
                    cap_reached: 'Monatsobergrenze erreicht',
                    low_balance: 'Geringes Gleichgewicht',
                    auth_failure: 'Authentifizierungsfehler',
                    merkle_mismatch: 'Merkle-Nichtübereinstimmung',
                    batch_terminal_failure: 'Fehler im Batch-Terminal',
                    direct_terminal_failure: 'Fehler am Terminal für direkte Übermittlung',
                },
                usage_kind: {
                    consume: 'Konsumieren',
                    refund: 'Rückerstattung',
                    grant: 'Grant',
                    adjustment: 'Anpassung',
                    reservation: 'Reservierung',
                },
                package_starter: 'Anlasser',
                package_growth: 'Wachstum',
                package_enterprise: 'Unternehmen',
                // Sprint 48.5.x — self-service "Buy More" billing (Flow A + B).
                buy_more: {
                    buy_button: 'Mehr Guthaben kaufen',
                    purchase_title: 'Mehr Guthaben kaufen',
                    purchase_subtitle: 'Wählen Sie ein Paket. Sie werden zur sicheren Stripe-Kasse weitergeleitet, und Ihre Rechnung erhalten Sie per E-Mail.',
                    checkout_button: 'Weiter zur Kasse',
                    checkout_pending: 'Kasse wird geöffnet…',
                    cancel_button: 'Abbrechen',
                    purchase_error: 'Die Kasse konnte nicht gestartet werden. Bitte versuchen Sie es in Kürze erneut.',
                    redeem_subtitle: 'Bereits bezahlt? Wählen Sie das gekaufte Paket aus und geben Sie die Rechnungs-ID aus Ihrer E-Mail ein, um das Guthaben hinzuzufügen.',
                    error_not_found: 'Es wurde keine Rechnung mit dieser Nummer gefunden. Überprüfen Sie die Rechnungsnummer und versuchen Sie es erneut.',
                    error_not_paid: 'Diese Rechnung ist noch nicht als bezahlt markiert.',
                    error_org_mismatch: 'Diese Rechnung wurde nicht an Ihre Organisation ausgestellt.',
                    error_package_mismatch: 'Diese Rechnung stimmt nicht mit dem ausgewählten Paket überein.',
                    error_billing_unavailable: 'Der Abrechnungsdienst konnte nicht erreicht werden. Bitte versuchen Sie es in Kürze erneut.',
                },
            },
        },
        files_config: {
            title: 'Dateikonfiguration',
            subtitle: 'Konfigurieren Sie Datei-Upload-Limits, Aufbewahrungsrichtlinien und Außerkraftsetzungen je Besitzertyp für die Plattformanhangsoberfläche.',
            section_global: 'Globale Standardwerte',
            section_global_help: 'Diese Grenzwerte gelten für jede von Benutzern in Ihrer Organisation hochgeladene Datei, es sei denn, sie werden unten durch eine Überschreibung pro Besitzertyp geändert.',
            section_overrides: 'Überschreibungen je Besitzertyp',
            section_overrides_help: 'Überschreiben Sie die globalen Grenzwerte für einen bestimmten Eigentümertyp. Werte pro Eigentümertyp haben immer Vorrang vor der globalen Einstellung.',
            max_file_size_label: 'Maximale Dateigröße',
            max_file_size_hint: 'Pro einzelnem Upload (MiB)',
            max_total_attachments_label: 'Maximale Gesamtanzahl an Anhängen',
            max_total_attachments_hint: 'Über die gesamte Organisation hinweg',
            max_total_size_label: 'Maximaler Gesamtspeicher',
            max_total_size_hint: 'In der gesamten Organisation (MiB)',
            allowed_mime_types_label: 'Zulässige Dateitypen',
            allowed_mime_types_placeholder: 'Wählen Sie MIME-Typen aus',
            retention_days_label: 'Aufbewahrungsdauer (Tage)',
            retention_days_hint: 'Wie lange müssen Dateien aufbewahrt werden, bevor sie gelöscht werden können? Für keine Aufbewahrungsrichtlinie leer lassen.',
            legal_hold_label: 'Rechtlicher Aufbewahrungszeitraum',
            legal_hold_hint: 'Wenn diese Option aktiviert ist, erfordert das endgültige Löschen einer Datei dieses Eigentümertyps die Berechtigung zum Überschreiben der gesetzlichen Aufbewahrungsfrist und eine ausdrückliche Zustimmung des Betreibers.',
            save: 'Änderungen speichern',
            saving: 'Sparen…',
            reset: 'Zurücksetzen',
            save_success: 'Einstellungen gespeichert',
            save_version_conflict: 'Ein anderer Operator hat diese Einstellungen aktualisiert, während Sie sie bearbeitet haben. Laden Sie neu, um die neuesten Werte anzuzeigen.',
            empty_state_title: 'Plattformstandards verwenden',
            empty_state_body: 'Ihre Organisation verwendet derzeit die Standarddateirichtlinie der Plattform. Bearbeiten Sie einen beliebigen Wert unten, um eine Überschreibung auf Organisationsebene zu erstellen.',
            read_only_banner: 'Sie haben nur Lesezugriff auf die Dateikonfiguration. Wenden Sie sich an einen Plattformadministrator, um Änderungen vorzunehmen.',
            owner_type_default_badge: 'Standard',
            owner_type_overridden_badge: 'Überschrieben',
            owner_type_label: 'Besitzertyp',
            owner_type_collapse: 'Zusammenbruch',
            owner_type_expand: 'Erweitern',
            override_save: 'Außerkraftsetzung speichern',
            override_remove: 'Überschreibung entfernen',
            mime_labels: {
                'application/pdf': '[[TOK_0]] Dokument',
                'image/png': 'PNG-Bild',
                'image/jpeg': 'JPEG-Bild',
                'image/jpg': 'JPG-Bild',
                'application/msword': 'Word-Dokument (Legacy)',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'Word-Dokument',
                'application/vnd.ms-excel': 'Excel-Tabelle (alt)',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'Excel-Tabelle',
                'text/csv': '[[TOK_0]]-Datei',
                'text/plain': 'Klartext',
                'message/rfc822': 'E-Mail-Nachricht',
            },
        },
        files_browser: {
            title: 'Dateibrowser',
            subtitle: 'Durchsuchen, filtern und verwalten Sie alle im gesamten Unternehmen hochgeladenen Anhänge.',
            filter_owner_type: 'Besitzertyp',
            filter_uploader: 'Hochgeladen von',
            filter_from: 'Hochgeladen nachher',
            filter_to: 'Vorher hochgeladen',
            filter_size_min: 'Mindestgröße (MiB)',
            filter_size_max: 'Maximale Größe (MiB)',
            filter_mime: 'Dateityp',
            filter_deleted_state: 'Löschstatus',
            filter_deleted_any: 'Alle Dateien',
            filter_deleted_only: 'Nur gelöscht',
            filter_deleted_exclude: 'Ausschließen gelöscht',
            filter_orphaned: 'Nur verwaist',
            filter_search_placeholder: 'Dateiname suchen…',
            filter_apply: 'Wenden Sie Filter an',
            filter_clear: 'Filter löschen',
            col_filename: 'Dateiname',
            col_owner_type: 'Besitzertyp',
            col_owner_entity: 'Besitzer',
            col_uploader: 'Hochgeladen von',
            col_uploaded_at: 'Hochgeladen',
            col_size: 'Größe',
            col_mime: 'Typ',
            col_state: 'Staat',
            col_actions: 'Aktionen',
            state_active: 'Aktiv',
            state_deleted: 'Gelöscht',
            state_orphaned: 'Verwaist',
            action_view_detail: 'Details anzeigen',
            action_download: 'Herunterladen',
            action_ai_edits: '[[TOK_0]] Änderungen',
            action_soft_delete: 'Vorläufiges Löschen',
            action_restore: 'Wiederherstellen',
            action_hard_delete: 'Hartes Löschen',
            bulk_soft_delete: 'Vorläufiges Löschen ausgewählt',
            bulk_export_csv: 'Exportieren [[TOK_0]]',
            bulk_select_all: 'Alles auswählen',
            reason_label: 'Grund',
            reason_min_10_chars: 'Begründung ist erforderlich (mindestens 10 Zeichen)',
            reason_min_20_chars: 'Begründung ist erforderlich (mindestens 20 Zeichen)',
            legal_hold_override_label: 'Gesetzliche Aufbewahrungsfrist außer Kraft setzen',
            legal_hold_override_warning: 'Diese Datei unterliegt einer rechtlichen Aufbewahrungsfrist. Das endgültige Löschen wird im Audit-Trail mit Ihrem Grund und der Überschreibungsmarkierung aufgezeichnet.',
            empty_state_title: 'Keine Dateien entsprechen Ihren Filtern',
            empty_state_body: 'Passen Sie Ihre Filter an, um Ergebnisse anzuzeigen, oder löschen Sie sie, um alle Dateien anzuzeigen.',
            pagination_prev: 'Zurück',
            pagination_next: 'Als nächstes',
            pagination_page: 'Seite [[TOK_2]] von [[TOK_3]]',
            pagination_size_label: 'Pro Seite',
            pagination_total: 'Gesamt: [[TOK_1]]',
            toast_soft_deleted: 'Datei vorläufig gelöscht',
            toast_restored: 'Datei wiederhergestellt',
            toast_hard_deleted: 'Datei dauerhaft gelöscht',
            toast_bulk_deleted: '[[TOK_1]] Datei(en) gelöscht',
            toast_error: 'Der Vorgang ist fehlgeschlagen',
            confirm_soft_delete_title: 'Soft-Delete-Datei',
            confirm_restore_title: 'Datei wiederherstellen',
            confirm_hard_delete_title: 'Datei endgültig löschen',
            confirm_bulk_soft_delete_title: 'Ausgewählte Dateien vorläufig löschen',
            confirm_submit: 'Bestätigen',
            confirm_cancel: 'Abbrechen',
        },
        files_detail: {
            modal_title: 'Dateidetails',
            close: 'Schließen',
            meta_filename: 'Dateiname',
            meta_size: 'Größe',
            meta_mime: 'Typ',
            meta_owner_type: 'Besitzertyp',
            meta_owner_entity: 'Eigentümereinheit',
            meta_uploader: 'Hochgeladen von',
            meta_uploaded_at: 'Hochgeladen',
            meta_storage_path: 'Speicherpfad',
            meta_deleted_state: 'Löschstatus',
            audit_section_title: 'Audit-Trail',
            audit_load_more: 'Weitere Veranstaltungen laden',
            audit_empty: 'Für diese Datei wurden keine Prüfereignisse aufgezeichnet.',
            audit_config_changed: 'Konfiguration geändert',
            audit_soft_deleted: 'Vorläufig gelöscht',
            audit_restored: 'Restauriert',
            audit_hard_deleted: 'Endgültig gelöscht',
            audit_downloaded: 'Heruntergeladen',
            audit_quota_breached: 'Versuch einer Quotenverletzung',
            action_download: 'Herunterladen',
            action_soft_delete: 'Vorläufiges Löschen',
            action_restore: 'Wiederherstellen',
            action_hard_delete: 'Hartes Löschen',
            effective_settings_title: 'Effektive Politik',
            effective_max_file_size: 'Maximale Dateigröße',
            effective_retention_days: 'Aufbewahrung',
            effective_legal_hold: 'Rechtlicher Aufbewahrungszeitraum',
            effective_legal_hold_yes: 'Aktiv',
            effective_legal_hold_no: 'Keine',
        },
        files_dashboard: {
            title: 'Dateien-Dashboard',
            subtitle: 'Speichernutzung, Wachstum und verwaiste Dateien im gesamten Unternehmen.',
            kpi_total_files: 'Gesamtdateien',
            kpi_total_size: 'Gesamtspeicher',
            kpi_near_quota: 'Kontingentnutzung',
            kpi_orphaned: 'Verwaiste Dateien',
            chart_by_owner_type: 'Dateien nach Eigentümertyp',
            chart_growth_30d: '30-Tage-Wachstum',
            toggle_count: 'Nach Zählung',
            toggle_size: 'Nach Größe',
            orphaned_panel_title: 'Verwaiste Dateien (Top 20)',
            orphaned_view_all: 'Alle verwaisten Dateien anzeigen',
            orphaned_empty: 'Keine verwaisten Dateien gefunden.',
            growth_empty: 'Keine Upload-Aktivität in den letzten 30 Tagen.',
            retention_n_days: '[[TOK_1]] Tag(e)',
            retention_none: 'Keine Richtlinie',
        },
    },
    category_labels: {
        'user-guide': 'Benutzerhandbuch',
        'admin-guide': 'Admin-Handbuch',
        'getting-started': 'Erste Schritte',
        faq: 'FAQ',
    },
    tag_labels: {
        faq: 'FAQ',
        dsar: 'DSAR',
        dsr: 'DSR',
        cmp: 'CMP',
        hmac: 'HMAC',
        sso: 'SSO',
        mfa: 'MFA',
        rbac: 'RBAC',
        api: 'API',
        'api-keys': '[[TOK_0]] Schlüssel',
        webhook: 'Webhook',
        webhooks: 'Webhooks',
        admin: 'Admin',
        aesirx: 'AesirX',
        purposes: 'Zwecke',
        preferences: 'Präferenzen',
        onboarding: 'Onboarding',
        'first-steps': 'Erste Schritte',
        login: 'Anmelden',
        navigation: 'Navigation',
        users: 'Benutzer',
        user: 'Benutzer',
        roles: 'Rollen',
        role: 'Rolle',
        'access-control': 'Zugangskontrolle',
        'access-management': 'Zugriffsverwaltung',
        permissions: 'Berechtigungen',
        permission: 'Erlaubnis',
        consent: 'Zustimmung',
        'consent-management': 'Einwilligungsmanagement',
        privacy: 'Privatsphäre',
        pdpl: 'PDPL',
        gdpr: 'GDPR',
        iso27001: 'ISO 27001',
        audit: 'Prüfung',
        auditing: 'Wirtschaftsprüfung',
        breach: 'Verstoß',
        incident: 'Vorfall',
        incidents: 'Vorfälle',
        notification: 'Benachrichtigung',
        notifications: 'Benachrichtigungen',
        reporting: 'Berichterstattung',
        risk: 'Risiko',
        vendor: 'Anbieter',
        vendors: 'Anbieter',
        'vendor-risk': 'Lieferantenrisiko',
        assessment: 'Bewertung',
        assessments: 'Beurteilungen',
        dpia: 'DPIA',
        'cross-border': 'Grenzüberschreitend',
        transfer: 'Übertragen',
        transfers: 'Überweisungen',
        deletion: 'Löschung',
        retention: 'Aufbewahrung',
        'data-mapping': 'Datenzuordnung',
        discovery: 'Entdeckung',
        classification: 'Klassifizierung',
        workflow: 'Arbeitsablauf',
        workflows: 'Arbeitsabläufe',
        template: 'Vorlage',
        templates: 'Vorlagen',
        catalog: 'Katalog',
        monitoring: 'Überwachung',
        tasks: 'Aufgaben',
        task: 'Aufgabe',
        'task-management': 'Aufgabenverwaltung',
        organizations: 'Organisationen',
        org: 'Organisation',
        governance: 'Regierungsführung',
        compliance: 'Compliance',
        forms: 'Formulare',
        form: 'Formular',
        connectors: 'Anschlüsse',
        connector: 'Stecker',
        integration: 'Integration',
        integrations: 'Integrationen',
        security: 'Sicherheit',
        encryption: 'Verschlüsselung',
        backup: 'Sicherung',
        recovery: 'Erholung',
        maintenance: 'Wartung',
        settings: 'Einstellungen',
        configuration: 'Konfiguration',
        sla: 'SLA',
        escalation: 'Eskalation',
        remediation: 'Sanierung',
        evidence: 'Beweise',
        'case-management': 'Fallmanagement',
        profile: 'Profil',
        delegation: 'Delegation',
        'service-accounts': 'Dienstkonten',
        license: 'Lizenz',
        'license-management': 'Lizenzverwaltung',
        plan: 'Planen',
        plans: 'Pläne',
        dashboard: 'Armaturenbrett',
        'web-consent': 'Web-Einwilligung',
        'partner-marketplace': 'Partnermarktplatz',
        partner: 'Partner',
        partners: 'Partner',
        deliverables: 'Leistungen',
        'service-tiers': 'Servicestufen',
        'support-tickets': 'Support-Tickets',
        'audit-trail': 'Prüfpfad',
        'first-time-setup': 'Erstmalige Einrichtung',
        setup: 'Einrichtung',
        quickstart: 'Schnellstart',
        tour: 'Rundgang',
        tours: 'Touren',
        'sample-data': 'Beispieldaten',
        'data-subject': 'Betroffene Person',
        'data-subjects': 'Betroffene Personen',
        pseudonymous: 'Pseudonym',
        identified: 'Identifiziert',
        'help-center': 'Hilfecenter',
        article: 'Artikel',
        articles: 'Artikel',
        search: 'Suchen',
        'platform-settings': 'Plattformeinstellungen',
        'platform-config': 'Plattformkonfiguration',
        'module-config': 'Modulkonfiguration',
        'module-configuration': 'Modulkonfiguration',
        'rights-requests': 'Rechteanfragen',
        'access-accountability': 'Zugriff auf Verantwortlichkeit',
        'data-discovery': 'Datenermittlung',
        'incident-ops': 'Vorfalloperationen',
        'deletion-orchestration': 'Löschorchestrierung',
        'compliance-forms': 'Compliance-Formulare',
        'program-governance': 'Programm-Governance',
        localization: 'Lokalisierung',
        'privacy-scanner': 'Datenschutzscanner',
        'consent-properties': 'Einwilligungseigenschaften',
        acceptances: 'Annahmen',
        access: 'Zugang',
        'access-review': 'Zugriffsüberprüfung',
        'access-reviews': 'Zugriff auf Bewertungen',
        accountability: 'Verantwortung',
        acknowledgment: 'Danksagung',
        'action-plans': 'Aktionspläne',
        activation: 'Aktivierung',
        activations: 'Aktivierungen',
        'active-response': 'Aktive Reaktion',
        activity: 'Aktivität',
        adequacy: 'Angemessenheit',
        'admin-guide': 'Admin-Handbuch',
        aggregation: 'Aggregation',
        agreements: 'Vereinbarungen',
        ai: 'AI',
        alerts: 'Warnungen',
        analytics: 'Analytik',
        anchoring: 'Verankerung',
        approval: 'Zustimmung',
        approvals: 'Zulassungen',
        apps: 'Apps',
        assets: 'Vermögenswerte',
        assignments: 'Aufgaben',
        attestation: 'Bescheinigung',
        'audit-log': 'Audit-Protokoll',
        'audit-pack': 'Audit-Paket',
        authentication: 'Authentifizierung',
        authority: 'Autorität',
        'auto-play': 'Automatische Wiedergabe',
        automated: 'Automatisiert',
        automation: 'Automatisierung',
        baseline: 'Grundlinie',
        batches: 'Chargen',
        bidirectional: 'Bidirektional',
        bilingual: 'Zweisprachig',
        bindings: 'Bindungen',
        blockchain: 'Blockchain',
        board: 'Vorstand',
        brand: 'Marke',
        brds: 'BRDs',
        'break-glass': 'Glasbruch',
        builder: 'Baumeister',
        bulk: 'Masse',
        'bulk-sync': 'Massensynchronisierung',
        bundles: 'Bündel',
        calendar: 'Kalender',
        campaigns: 'Kampagnen',
        cases: 'Fälle',
        categories: 'Kategorien',
        category: 'Kategorie',
        certification: 'Zertifizierung',
        chain: 'Kette',
        change: 'Veränderung',
        'change-awareness': 'Bewusstsein ändern',
        'change-log': 'Änderungsprotokoll',
        'change-management': 'Änderungsmanagement',
        'change-requests': 'Änderungswünsche',
        'cmp-validation': '[[TOK_0]] Validierung',
        collection: 'Sammlung',
        comparison: 'Vergleich',
        completeness: 'Vollständigkeit',
        completion: 'Fertigstellung',
        'compliance-posture': 'Compliance-Haltung',
        'compliance-proof': 'Compliance-Nachweis',
        'compliance-reviews': 'Compliance-Überprüfungen',
        config: 'Konfig',
        confirmation: 'Bestätigung',
        conflicts: 'Konflikte',
        consolidation: 'Konsolidierung',
        continuous: 'Kontinuierlich',
        contracts: 'Verträge',
        controls: 'Kontrollen',
        cookies: 'Kekse',
        cooperation: 'Zusammenarbeit',
        coordination: 'Koordination',
        'corporate-governance': 'Unternehmensführung',
        'corrective-actions': 'Korrekturmaßnahmen',
        coverage: 'Abdeckung',
        'credential-vault': 'Tresor für Anmeldeinformationen',
        credentials: 'Anmeldeinformationen',
        cycles: 'Zyklen',
        dashboards: 'Dashboards',
        'data-assets': 'Datenbestände',
        'data-flows': 'Datenflüsse',
        'data-sensitivity': 'Datensensibilität',
        'data-steward': 'Datenverwalter',
        deadlines: 'Fristen',
        'decree-356': 'Dekret 356',
        dedup: 'Dedup',
        definitions: 'Definitionen',
        deliverable: 'Lieferbar',
        departments: 'Abteilungen',
        'dependency-order': 'Abhängigkeitsordnung',
        deployment: 'Bereitstellung',
        detection: 'Erkennung',
        diff: 'Diff',
        'digital-properties': 'Digitale Eigenschaften',
        dimensions: 'Abmessungen',
        disable: 'Deaktivieren',
        'disaster-recovery': 'Notfallwiederherstellung',
        disclosure: 'Offenlegung',
        documentation: 'Dokumentation',
        documents: 'Dokumente',
        domains: 'Domänen',
        dossier: 'Dossier',
        dpa: 'DPA',
        drift: 'Drift',
        'drift-detection': 'Drifterkennung',
        'due-diligence': 'Due Diligence',
        email: 'Email',
        emergency: 'Notfall',
        enable: 'Aktivieren',
        'enterprise-map': 'Unternehmenskarte',
        erasure: 'Löschung',
        evaluation: 'Bewertung',
        'event-bus': 'Veranstaltungsbus',
        exceptions: 'Ausnahmen',
        execution: 'Ausführung',
        executive: 'Exekutive',
        exercises: 'Übungen',
        export: 'Exportieren',
        exports: 'Exporte',
        filing: 'Einreichung',
        filter: 'Filtern',
        filtering: 'Filtern',
        findings: 'Erkenntnisse',
        flows: 'Fließt',
        'follow-up': 'Nachverfolgung',
        forensic: 'Forensisch',
        forensics: 'Forensik',
        'form-filler': 'Formularausfüller',
        framework: 'Rahmen',
        frameworks: 'Rahmenwerke',
        'gap-analysis': 'Lückenanalyse',
        'gap-report': 'Lückenbericht',
        gaps: 'Lücken',
        gates: 'Tore',
        'getting-started': 'Erste Schritte',
        'golden-templates': 'Goldene Vorlagen',
        grc: 'GRC',
        'group-management': 'Gruppenleitung',
        groups: 'Gruppen',
        'guided-tours': 'Geführte Touren',
        guides: 'Führer',
        handling: 'Handhabung',
        'hands-on': 'Praktisch',
        health: 'Gesundheit',
        help: 'Hilfe',
        hierarchy: 'Hierarchie',
        history: 'Geschichte',
        i18n: 'i18n',
        iam: 'IAM',
        'identity-provider': 'Identitätsanbieter',
        implementation: 'Umsetzung',
        import: 'Importieren',
        improvement: 'Verbesserung',
        'incident-response': 'Reaktion auf Vorfälle',
        inconsistencies: 'Inkonsistenzen',
        instances: 'Instanzen',
        intake: 'Aufnahme',
        'intake-key': 'Einlassschlüssel',
        interactive: 'Interaktiv',
        international: 'International',
        inventory: 'Inventar',
        investigation: 'Untersuchung',
        investigations: 'Untersuchungen',
        'ip-allowlist': 'IP-Zulassungsliste',
        issues: 'Probleme',
        justification: 'Begründung',
        justifications: 'Begründungen',
        kanban: 'Kanban',
        keyboard: 'Tastatur',
        keys: 'Schlüssel',
        'knowledge-base': 'Wissensdatenbank',
        koncernstyring: 'Unternehmensführung',
        kpi: 'KPI',
        labeling: 'Beschriftung',
        language: 'Sprache',
        'language-packs': 'Sprachpakete',
        languages: 'Sprachen',
        lawfulness: 'Rechtmäßigkeit',
        layout: 'Layout',
        'legal-basis': 'Rechtsgrundlage',
        'lessons-learned': 'Gelernte Lektionen',
        levels: 'Ebenen',
        library: 'Bibliothek',
        lifecycle: 'Lebenszyklus',
        lineage: 'Abstammung',
        links: 'Links',
        listings: 'Einträge',
        live: 'Lebe',
        locale: 'Gebietsschema',
        log: 'Log',
        logging: 'Protokollierung',
        'managed-service': 'Managed-Service',
        mapping: 'Kartierung',
        mappings: 'Zuordnungen',
        'market-packs': 'Marktpakete',
        marketplace: 'Marktplatz',
        maturity: 'Reife',
        metrics: 'Metriken',
        models: 'Modelle',
        module: 'Modul',
        modules: 'Module',
        mps: 'MPS',
        'multi-factor': 'Multifaktor',
        'multi-market': 'Multi-Markt',
        'multi-org': 'Multi-Org',
        'multi-property': 'Mehrere Objekte',
        'my-tasks': 'Meine Aufgaben',
        obligations: 'Verpflichtungen',
        offboarding: 'Offboarding',
        oidc: 'OIDC',
        orchestration: 'Orchestrierung',
        'org-groups': 'Organisationsgruppen',
        organization: 'Organisation',
        overdue: 'Überfällig',
        overview: 'Übersicht',
        'owner-review': 'Eigentümerbewertung',
        package: 'Paket',
        packages: 'Pakete',
        packs: 'Packungen',
        pagination: 'Paginierung',
        'parent-child': 'Eltern-Kind',
        patterns: 'Muster',
        performance: 'Leistung',
        periodic: 'Periodisch',
        periods: 'Perioden',
        personal: 'Persönlich',
        'personal-data': 'Persönliche Daten',
        personas: 'Personas',
        planning: 'Planung',
        platform: 'Plattform',
        playbooks: 'Spielbücher',
        poc: 'PoC',
        'point-in-time': 'Zeitpunkt',
        policies: 'Richtlinien',
        portfolio: 'Portfolio',
        'post-incident': 'Nach dem Vorfall',
        'power-user': 'Power-User',
        practice: 'Üben',
        pricing: 'Preise',
        'privacy-impact': 'Auswirkungen auf die Privatsphäre',
        procedures: 'Verfahren',
        processes: 'Prozesse',
        processing: 'Verarbeitung',
        'processing-activities': 'Verarbeitungstätigkeiten',
        procurement: 'Beschaffung',
        productivity: 'Produktivität',
        profiles: 'Profile',
        programs: 'Programme',
        progress: 'Fortschritt',
        proof: 'Beweis',
        propagation: 'Vermehrung',
        properties: 'Eigenschaften',
        'pub-sub': 'Pub-Sub',
        'public-form': 'Öffentliche Form',
        quality: 'Qualität',
        questionnaires: 'Fragebögen',
        'quick-links': 'Quicklinks',
        'quick-start': 'Schnellstart',
        'quick-starts': 'Schnellstarts',
        raci: 'RACI',
        readiness: 'Bereitschaft',
        'real-time': 'Echtzeit',
        reassessments: 'Neubewertungen',
        reconciliation: 'Versöhnung',
        record: 'Aufnahme',
        records: 'Aufzeichnungen',
        recurring: 'Wiederkehrend',
        register: 'Registrieren',
        registry: 'Registrierung',
        regulations: 'Vorschriften',
        regulator: 'Regulator',
        regulatory: 'Regulatorisch',
        'regulatory-frameworks': 'Regulatorische Rahmenbedingungen',
        remap: 'Neu zuordnen',
        reminders: 'Erinnerungen',
        reports: 'Berichte',
        requests: 'Anfragen',
        requirements: 'Anforderungen',
        response: 'Antwort',
        'response-plans': 'Reaktionspläne',
        'response-team': 'Reaktionsteam',
        'response-templates': 'Antwortvorlagen',
        'response-time': 'Reaktionszeit',
        responses: 'Antworten',
        responsibility: 'Verantwortung',
        results: 'Ergebnisse',
        review: 'Rezension',
        reviews: 'Rezensionen',
        'right-to-delete': 'Recht auf Löschung',
        rights: 'Rechte',
        'risk-tiers': 'Risikostufen',
        rollouts: 'Rollouts',
        rollup: 'Rollup',
        ropa: 'ROPA',
        routing: 'Routenführung',
        rpo: 'RPO',
        rto: 'RTO',
        rules: 'Regeln',
        runs: 'Läuft',
        saml: 'SAML',
        scan: 'Scannen',
        scanning: 'Scannen',
        scc: 'SCC',
        schedule: 'Zeitplan',
        scheduled: 'Geplant',
        schedules: 'Zeitpläne',
        scheduling: 'Terminplanung',
        scores: 'Partituren',
        scoring: 'Wertung',
        scripts: 'Skripte',
        'security-reviews': 'Sicherheitsüberprüfungen',
        'sensitive-data': 'Sensible Daten',
        sensitivity: 'Empfindlichkeit',
        'separation-of-duties': 'Aufgabentrennung',
        service: 'Service',
        sessions: 'Sitzungen',
        'setup-wizard': 'Setup-Assistent',
        severity: 'Schweregrad',
        'shared-governance': 'Gemeinsame Governance',
        'shared-settings': 'Gemeinsame Einstellungen',
        shortcuts: 'Verknüpfungen',
        sidebar: 'Seitenleiste',
        signals: 'Signale',
        'single-sign-on': 'Single Sign-On',
        snapshots: 'Schnappschüsse',
        sod: 'SoD',
        sorting: 'Sortieren',
        sources: 'Quellen',
        staging: 'Inszenierung',
        standards: 'Standards',
        status: 'Status',
        structure: 'Struktur',
        'sub-processor': 'Unterauftragsverarbeiter',
        'sub-processors': 'Unterauftragsverarbeiter',
        submissions: 'Einsendungen',
        subprocessors: 'Unterauftragsverarbeiter',
        subscription: 'Abonnement',
        suggestions: 'Vorschläge',
        summaries: 'Zusammenfassungen',
        supplements: 'Ergänzungen',
        support: 'Unterstützung',
        sync: 'Synchronisieren',
        system: 'System',
        systems: 'Systeme',
        tables: 'Tische',
        tagging: 'Markieren',
        'tamper-proof': 'Manipulationssicher',
        taxonomies: 'Taxonomien',
        taxonomy: 'Taxonomie',
        tenants: 'Mieter',
        termination: 'Kündigung',
        'third-party': 'Drittanbieter',
        'ticket-sync': 'Ticketsynchronisierung',
        tickets: 'Tickets',
        tiers: 'Ebenen',
        tokens: 'Token',
        totp: 'TOTP',
        traceability: 'Rückverfolgbarkeit',
        tracking: 'Verfolgung',
        trail: 'Weg',
        training: 'Ausbildung',
        translation: 'Übersetzung',
        translations: 'Übersetzungen',
        transparency: 'Transparenz',
        trends: 'Trends',
        unified: 'Einheitlich',
        updates: 'Aktualisierungen',
        validation: 'Validierung',
        vault: 'Tresor',
        'vendor-requests': 'Lieferantenanfragen',
        verification: 'Überprüfung',
        versioning: 'Versionierung',
        versions: 'Versionen',
        vietnam: 'Vietnam',
        violations: 'Verstöße',
        visualization: 'Visualisierung',
        waivers: 'Verzichtserklärungen',
        'web-records': 'Webaufzeichnungen',
        website: 'Website',
        websites: 'Websites',
        weights: 'Gewichte',
        'white-label': 'White-Label',
        withdrawal: 'Rückzug',
    },
    module_labels: {
        rights_requests: 'Auskunftsersuchen',
        data_mapping: 'Datenverzeichnis',
        governance: 'Dienstleistersteuerung',
        consent: 'Einwilligungssteuerung',
        consent_properties: 'Einwilligungseigenschaften',
        assessments: 'DSFA & Bewertungen',
        classification: 'Datenklassifizierung',
        monitoring: 'Überwachungsprogramme',
        program: 'Überwachungsprogramm',
        incidents: 'Vorfallreaktion',
        connectors: 'Konnektoren',
        vendor_risk: 'Lieferantenrisiko',
        deletion_orchestration: 'Löschorchestrierung',
        discovery: 'Datenentdeckung',
        incident_ops: 'Vorfallsbetrieb',
        program_governance: 'Programmsteuerung',
        access_accountability: 'Zugriffsverantwortung',
        localization: 'Lokalisierung',
        partner_workspace: 'Partner-Arbeitsbereich',
        privacy_scanner: 'Datenschutz-Scanner',
        onboarding: 'Onboarding',
        compliance_forms: 'Compliance-Formulare',
        audit_trail: 'Prüfprotokoll',
        data_subjects: 'Betroffene Personen',
        organizations: 'Organisationen',
        task_management: 'Aufgabenverwaltung',
        deletion_orch: 'Löschorchestrierung',
        forms: 'Compliance-Formulare',
        partner_marketplace: 'Partner-Marktplatz',
        dashboard: 'Armaturenbrett',
        platform_settings: 'Plattformeinstellungen',
        help_center: 'Hilfezentrum',
    },
    module_descriptions: {
        rights_requests: 'Verwalten Sie Auskunftsersuchen betroffener Personen einschließlich Zugang, Löschung und Datenübertragbarkeit. Verfolgen Sie den Anfragezyklus, weisen Sie Bearbeiter zu und halten Sie gesetzliche Fristen ein.',
        data_mapping: 'Bilden Sie Datenflüsse in Ihrer Organisation ab. Verfolgen Sie Verarbeitungstätigkeiten, Datenkategorien, Zwecke, Aufbewahrungsrichtlinien und Systemintegrationen.',
        governance: 'Verwalten Sie Lieferanten-Compliance und -Governance. Verfolgen Sie Lieferantenbewertungen, Verträge, SLA-Leistung und regulatorische Verpflichtungen.',
        consent: 'Verwalten Sie die Einholung, Speicherung und den Widerruf von Einwilligungen. Verfolgen Sie Einwilligungsdatensätze, Zwecke und die Integration mit Einwilligungsplattformen.',
        consent_properties: 'Konfigurieren Sie Einwilligungseigenschaften, Gruppen und goldene Vorlagen. Definieren Sie wiederverwendbare Einwilligungskonfigurationen für eine einheitliche Bereitstellung.',
        assessments: 'Führen Sie Datenschutz-Folgenabschätzungen (DSFA) und Datenschutz-Risikobewertungen durch. Bewerten Sie Verarbeitungstätigkeiten auf Compliance-Risiken.',
        classification: 'Klassifizieren Sie Datenbestände nach Sensibilitätsstufe. Wenden Sie Taxonomie-Labels an, verfolgen Sie Lebenszyklus-Einträge und identifizieren Sie Klassifizierungslücken.',
        monitoring: 'Richten Sie Überwachungsprogramme ein, um Compliance-Metriken, zentrale Risikoindikatoren und Kontrollwirksamkeit über die Zeit zu verfolgen.',
        incidents: 'Melden und verwalten Sie Datenschutzvorfälle und Datenschutzverletzungen. Verfolgen Sie Untersuchungs-, Benachrichtigungs- und Abhilfe-Workflows.',
        connectors: 'Konfigurieren Sie Datenquellen-Konnektoren und Integrationen. Verbinden Sie externe Systeme für automatisierte Datenentdeckung und Überwachung.',
        vendor_risk: 'Bewerten und überwachen Sie Risiken von Drittanbietern. Bewerten Sie Lieferanten, verfolgen Sie Risikominderung und verwalten Sie Lieferanten-Risikokonfigurationen.',
        deletion_orchestration: 'Orchestrieren Sie die Datenlöschung über Systeme hinweg. Verfolgen Sie Löschanfragen, überprüfen Sie Nachweisketten und stellen Sie vollständige Datenentfernung sicher.',
        discovery: 'Entdecken Sie personenbezogene Daten in verbundenen Systemen. Scannen Sie Datenquellen, um ein umfassendes Dateninventar aufzubauen.',
        incident_ops: 'Operatives Vorfallmanagement mit Playbooks, Eskalations-Workflows und SLA-Verfolgung für die Vorfallbehebung.',
        program_governance: 'Verfolgen Sie den Reifegrad des gesamten Datenschutzprogramms, Compliance-Bewertungen, Nachweislücken und die Berichterstattung an die Geschäftsleitung in Ihrer Organisation.',
        access_accountability: 'Untersuchen und prüfen Sie Benutzerzugriffsmuster. Verfolgen Sie Zugriffskonfigurationen, überwachen Sie verdächtige Aktivitäten und setzen Sie Rechenschaftspflicht durch.',
        localization: 'Installieren und verwalten Sie Markt-Lokalisierungspakete. Fügen Sie regulatorische Rahmenwerke, Sprachpakete und regionsspezifische Compliance-Inhalte hinzu.',
        partner_workspace: 'Arbeiten Sie mit externen Partnern zusammen. Teilen Sie Compliance-Daten, verfolgen Sie Partnerverpflichtungen und verwalten Sie Partnerbeziehungen.',
        privacy_scanner: 'Scannen Sie Websites auf Datenschutz-Compliance-Probleme. Überwachen Sie Cookie-Nutzung, Tracking-Skripte und das Vorhandensein von Datenschutzrichtlinien in Echtzeit.',
        onboarding: 'Führen Sie neue Organisationen durch die Plattformeinrichtung. Schritt-für-Schritt-Onboarding-Assistent für die Erstkonfiguration und den Datenimport.',
        compliance_forms: 'Erstellen und verwalten Sie Compliance-Formulare aus einem Vorlagenkatalog. Füllen Sie regulatorische Formulare aus, verfolgen Sie Einreichungen und erstellen Sie Berichte.',
        audit_trail: 'Sehen Sie ein vollständiges Prüfprotokoll aller Systemaktionen ein. Verfolgen Sie, wer was, wann und wo über alle Module hinweg getan hat.',
        organizations: 'Verwalten Sie Organisationen und Mandantenfähigkeits-Einstellungen. Konfigurieren Sie Organisationsprofile, Hierarchien und organisationsübergreifende Beziehungen.',
    },
    privacy_scanner: {
        anomaly_explain: {
            explain_label: 'Erklären Sie Anomalien',
            explaining: 'Erklären…',
            results_heading: 'Erklärungen zur Anomalie ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]] Token',
            items_label: '[[TOK_1]] Elemente',
            remediation_label: 'Sanierungsschritte',
            items_detail_label: 'Betroffene Artikel',
            accept_label: 'Erklärung akzeptieren',
            reject_label: 'Erklärung ablehnen',
            error_generic: 'Konnte die Anomalien nicht erklären. Versuchen Sie es erneut oder überprüfen Sie, ob der Scan erfolgreich abgeschlossen wurde.',
        },
        cookie_insight: {
            insight_label: 'Einblick in Cookies und Tracker [[TOK_0]].',
            producing: 'Erkenntnisse schaffen…',
            results_heading: 'Cookie- und Tracker-Einblick ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]] Token',
            items_label: '[[TOK_1]] Elemente',
            classification_label: 'Klassifizierung',
            severity_label: 'Schweregrad',
            banner_copy_label: 'Empfohlene Bannerkopie',
            retention_label: 'Hinweise zur Aufbewahrung',
            citations_label: 'Zitate',
            kind_cookie: 'Keks',
            kind_tracker: 'Tracker',
            class_necessary: 'Notwendig',
            class_analytics: 'Analytik',
            class_marketing: 'Marketing',
            class_social: 'Sozial',
            accept_label: 'Akzeptiere Einsicht',
            reject_label: 'Einsicht ablehnen',
            no_items: 'Bei diesem Scan wurden keine Cookies oder Tracker erkannt.',
            error_generic: 'Die Cookie-Einsicht konnte nicht erstellt werden. Versuchen Sie es erneut oder überprüfen Sie, ob der Scan erfolgreich abgeschlossen wurde.',
        },
        monitoring: {
            title: 'Datenschutzüberwachung',
            new_scan: 'Neuer Scan',
            scan_url: 'Zu scannende URL',
            scan_frequency: 'Scan-Häufigkeit',
            last_scan: 'Letzter Scan',
            score: 'Datenschutzbewertung',
            issues: 'Gefundene Probleme',
            history: 'Scan-Verlauf',
            settings: 'Überwachungseinstellungen',
        },
        real_time: {
            title: 'Echtzeit-Scanner',
            scan_now: 'Jetzt scannen',
            scanning: 'Wird gescannt...',
            results: 'Scan-Ergebnisse',
            no_results: 'Noch keine Scan-Ergebnisse.',
            cookies: 'Browser-Cookies',
            trackers: 'Tracker',
            consent_banners: 'Einwilligungsbanner',
            third_party: 'Drittanbieter-Skripte',
            archive: 'Ergebnisarchiv',
            settings: 'Scanner-Einstellungen',
        },
        dashboard: {
            page_title: 'Dashboard zur Datenschutzüberwachung',
            privacy_monitoring: 'Datenschutzüberwachung',
            plan_label: '[[TOK_1]] Plan',
            expires_label: 'läuft ab [[TOK_1]]',
            settings: 'Einstellungen',
            refresh: 'Aktualisieren',
            refreshing_dashboard: 'Erfrischendes Überwachungs-Dashboard',
            refresh_aria: 'Überwachungs-Dashboard aktualisieren',
            not_configured_title: 'Datenschutzüberwachung nicht konfiguriert',
            not_configured_desc: 'Verbinden Sie Ihren [[TOK_0]] Datenschutzüberwachungsdienst, um mit der Verfolgung der Website-Compliance zu beginnen.',
            configure_monitoring: 'Konfigurieren Sie die Überwachung',
            license_expired_title: 'Lizenz abgelaufen',
            license_expired_desc: 'Ihre [[TOK_0]] Privacy Monitoring-Lizenz ist abgelaufen. Bitte erneuern Sie es, um eine Dienstunterbrechung zu vermeiden.',
            compliance_score: 'Compliance-Score',
            cookies_detected: 'Cookies erkannt',
            trackers_label: 'Tracker',
            open_issues: 'Offene Probleme',
            score_good: 'Gut',
            score_needs_improvement: 'Verbesserungsbedarf',
            score_critical: 'Kritisch',
            action_required: 'Aktion erforderlich',
            cookies_sr: 'Cookies erkannt',
            trackers_sr: 'Tracker gefunden',
            open_issues_sr: 'offene Fragen',
            action_required_sr: 'Handlungsbedarf',
            metric_label: 'Metrisch',
            value_label: 'Wert',
            status_label: 'Status',
            aria_metrics: 'Metriken zur Datenschutzüberwachung',
            plan_limit_warning: 'Scannen von [[TOK_4]]: [[TOK_2]]/[[TOK_3]] – Sie haben Ihr Planlimit erreicht.',
            manage_domains: 'Verwalten Sie Domains oder aktualisieren Sie Ihren Plan.',
            monitored_domains: 'Überwachte Domänen',
            domain_added: 'Domäne [[TOK_1]] hinzugefügt',
            domain_removed: 'Domäne [[TOK_1]] entfernt',
            failed_add_domain: 'Das Hinzufügen der Domäne ist fehlgeschlagen',
            failed_remove_domain: 'Die Domäne konnte nicht entfernt werden',
            failed_load: 'Das Monitoring-Dashboard konnte nicht geladen werden',
            new_domain_aria: 'Neue Domain [[TOK_0]]',
            add_domain: 'Domäne hinzufügen',
            adding_domain: 'Hinzufügen…',
            no_domains: 'Es sind noch keine überwachten Domänen konfiguriert.',
            aria_domains_table: 'Überwachte Domänen',
            col_domain: 'Domäne',
            col_compliance_score: 'Compliance-Score',
            col_status: 'Status',
            col_cookies: 'Kekse',
            col_trackers: 'Tracker',
            col_issues: 'Probleme',
            col_last_scan: 'Letzter Scan',
            col_action: 'Aktion',
            compliance_status_sr: 'Compliance-Status',
            showing_chart: 'Diagrammansicht wird angezeigt',
            showing_table: 'Datentabellenansicht wird angezeigt',
            loading_sr: 'Überwachungs-Dashboard wird geladen',
            col_framework_tags: 'Framework-Tags',
            col_last_monitored: 'Zuletzt überwacht',
            framework_tags_sr: 'geltenden Regulierungsrahmen',
            last_monitored_sr: 'Zeitstempel der kontinuierlichen Überwachung',
            audit_trail_heading: 'Prüfpfad',
            audit_trail_info: 'Jeder Überwachungsscan wird mit einem Zeitstempel versehen und protokolliert. Compliance-Änderungen auf Domänenebene führen zu einem unveränderlichen Prüfdatensatz, der zur behördlichen Überprüfung exportiert werden kann.',
            cybersecurity_law_info_heading: 'Erkennung von Cybersicherheitsgesetzen',
            cybersecurity_law_info: 'Überwachte Domänen werden automatisch auf die Anforderungen des Cybersicherheitsgesetzes überprüft (z. B. Vietnamesisches Cybersicherheitsgesetz, [[TOK_0]]-Richtlinie). Framework-Tags geben an, welche Vorschriften gelten. Probleme werden nach regulatorischen Rahmenbedingungen für eine gezielte Behebung kategorisiert.',
        },
        scan: {
            page_title: 'Echtzeit-Scan',
            title: 'Echtzeit-Datenschutzscanner',
            settings: 'Einstellungen',
            results_archive: 'Ergebnisarchiv',
            launch_scan: 'Starten Sie den Scan',
            target_url: 'Ziel [[TOK_0]]',
            protocol_aria: 'Protokoll',
            url_required: '[[TOK_0]] ist erforderlich',
            url_whitespace: 'Bitte entfernen Sie Leerzeichen aus dem [[TOK_0]]',
            url_invalid: 'Bitte geben Sie eine gültige Domain ein (z. B. example.com)',
            add_subpages: 'Unterseiten hinzufügen',
            add_subpages_aria: 'Unterseiten hinzufügen, [[TOK_1]] hinzugefügt',
            start_scan: 'Starten Sie den Scan',
            launching: 'Starten…',
            scan_launched: 'Der Scan wurde erfolgreich gestartet',
            scan_failed: 'Scan konnte nicht gestartet werden',
            scan_progress: 'Scan-Fortschritt',
            scanning_in_progress: 'Der Scanvorgang läuft…',
            scan_id: 'Scan-ID',
            status_label: 'Status',
            status_unknown: 'unknown',
            progress_label: 'Fortschritt',
            pages_label: 'Seiten',
            refresh_status: 'Status aktualisieren',
            new_scan: 'Neuer Scan',
            scan_completed: 'Scan abgeschlossen, Ergebnisse verfügbar',
            failed_check_status: 'Der Scanstatus konnte nicht überprüft werden',
            scan_results: 'Scan-Ergebnisse',
            main_page: 'Hauptseite',
            page_n: 'Seite [[TOK_1]]',
            result_pages_nav: 'Ergebnisseiten',
            page_url: 'Seite [[TOK_0]]',
            risk_score: 'Risikobewertung',
            risk_score_sr: 'Risikobewertung',
            cookies_label: 'Kekse',
            cookies_sr: 'Cookies erkannt',
            scripts_label: 'Skripte',
            scripts_sr: 'Skripte erkannt',
            issues_label: 'Probleme',
            issues_sr: 'Probleme gefunden',
            issues_found: 'Gefundene Probleme',
            aria_issues_table: 'Beim Scan gefundene Probleme',
            col_severity: 'Schweregrad',
            col_category: 'Kategorie',
            col_title: 'Titel',
            col_remediation: 'Sanierung',
            severity_sr: 'severity',
            scan_result_metrics: 'Scan-Ergebnismetriken',
            view_full_detail: 'Vollständiges Detail anzeigen',
            col_consent_category: 'Einwilligungskategorie',
            consent_category_sr: 'Einwilligungskategorisierung',
            compliance_evidence_heading: 'Compliance-Nachweis',
            compliance_evidence_info: 'Scan-Ergebnisse werden automatisch mit Compliance-Fällen verknüpft. Jedes Problem kann einer Einwilligungskategorie (wesentlich, funktional, Analyse, Marketing) zugeordnet werden und liefert revisionssichere Beweise für die behördliche Überprüfung.',
            rule_config_heading: 'Regelkonfiguration',
            rule_config_info: 'Scanregeln können je nach Regulierungsrahmen konfiguriert werden. Cookie-Prüfungen, Skripterkennung und Anbieteranalyse können über die Einstellungen aktiviert oder deaktiviert werden. Es können benutzerdefinierte Regeln definiert werden, die den Compliance-Anforderungen Ihres Unternehmens entsprechen.',
            case_linkage_heading: 'Verknüpfung von Compliance-Fällen',
            case_linkage_info: 'Bei Echtzeitscans gefundene Probleme können zur Nachverfolgung und Behebung mit Compliance-Fällen verknüpft werden. Navigieren Sie zur Seite „Scan-Ergebnisdetails“, um Fallzuordnungen anzuzeigen.',
            subpages_modal_title: 'Unterseiten hinzufügen',
            subpages_modal_desc: 'Fügen Sie bis zu 5 Unterseiten-URLs hinzu, die neben der Hauptdomäne gescannt werden sollen.',
            subpage_n: 'Unterseite [[TOK_1]]',
        },
        result_detail: {
            page_title: 'Details zum Scanergebnis',
            title: 'Scan-Ergebnis',
            back_to_archive: 'Zurück zum Archiv',
            failed_load: 'Scan-Ergebnis konnte nicht geladen werden',
            loading_sr: 'Scanergebnis wird geladen…',
            scan_id: 'Scan-ID',
            target_url: 'Ziel [[TOK_0]]',
            status_label: 'Status',
            status_sr: 'status',
            started: 'Begonnen',
            completed: 'Abgeschlossen',
            pages_scanned: 'Gescannte Seiten',
            https_label: 'HTTPS',
            highest_risk_score: 'Höchster Risikowert',
            most_cookies: 'Die meisten Kekse',
            most_vendors: 'Die meisten Drittanbieter',
            most_issues: 'Die meisten Probleme',
            across_pages: 'seitenübergreifend',
            highest_values_aria: 'Höchste Werte auf allen Seiten',
            scanned_pages_nav: 'Gescannte Seiten',
            main_page: 'Hauptseite',
            page_n: 'Seite [[TOK_1]]',
            page_url: 'Seite [[TOK_0]]',
            risk_score: 'Risikobewertung',
            overall_risk_sr: 'Gesamtrisikobewertung',
            cookies_label: 'Kekse',
            cookies_sr: 'Cookies erkannt',
            vendors_label: 'Drittanbieter',
            vendors_sr: 'Drittanbieter erkannt',
            issues_label: 'Probleme',
            issues_sr: 'Probleme gefunden',
            risk_breakdown_aria: 'Aufschlüsselung der Risikobewertung',
            issues_found: 'Gefundene Probleme',
            aria_issues_table: 'Beim Scan gefundene Probleme',
            col_severity: 'Schweregrad',
            col_category: 'Kategorie',
            col_title: 'Titel',
            col_remediation: 'Sanierung',
            severity_sr: 'severity',
            cookies_heading: 'Cookies ([[TOK_1]])',
            aria_cookies_table: 'Cookies erkannt',
            col_name: 'Name',
            col_domain: 'Domäne',
            col_path: 'Pfad',
            col_secure: 'Sicher',
            col_httponly: 'HttpOnly',
            col_samesite: 'SameSite',
            vendors_heading: 'Drittanbieter ([[TOK_1]])',
            aria_vendors_table: 'Drittanbieter erkannt',
            col_hostname: 'Hostname',
            scripts_heading: 'Skripte / Beacons ([[TOK_1]])',
            aria_scripts_table: 'Skripte und Beacons erkannt',
            col_url: 'URL',
            col_type: 'Typ',
            links_heading: 'Links',
            first_party: 'Erstanbieter',
            third_party: 'Drittanbieter',
            col_risk_category: 'Risikokategorie',
            col_regulatory_framework: 'Regulierungsrahmen',
            col_actionable_detail: 'Umsetzbares Detail',
            risk_category_sr: 'regulatorische Risikokategorie',
            risk_category_mapping_heading: 'Zuordnung von Risikokategorien',
            risk_category_mapping_info: 'Jeder Scanbefund wird einer regulatorischen Risikokategorie zugeordnet (Datenerfassung, grenzüberschreitende Übertragung, Einwilligungsverwaltung, Datenaufbewahrung, Sicherheitskontrollen). Diese Zuordnung ermöglicht eine gezielte Sanierung, die nach den Auswirkungen der Vorschriften priorisiert wird.',
            compliance_case_heading: 'Compliance Case Association',
            compliance_case_info: 'Scan-Ergebnisse werden zur durchgängigen Nachverfolgung mit Compliance-Fällen verknüpft. Probleme können direkt aus den Scan-Ergebnissen in den Compliance-Fall-Workflow eskaliert werden.',
        },
        results_archive: {
            page_title: 'Scan-Ergebnisarchiv',
            title: 'Scan-Ergebnisarchiv',
            back_to_scanner: 'Zurück zum Scanner',
            failed_load: 'Scan-Ergebnisse konnten nicht geladen werden',
            results_loaded: 'Scan-Ergebnisse geladen, [[TOK_1]] Datensätze',
            total_label: 'Gesamt: [[TOK_1]]',
            aria_table: 'Scan-Ergebnisarchiv',
            col_scan_date: 'Scandatum',
            col_target_url: 'Ziel [[TOK_0]]',
            col_duration: 'Dauer',
            col_issues_found: 'Gefundene Probleme',
            col_risk_score: 'Risikobewertung',
            col_status: 'Status',
            col_actions: 'Aktionen',
            scan_status_sr: 'Scanstatus',
            view_result: 'Ansicht',
            no_results: 'Keine Scan-Ergebnisse gefunden.',
            loading_sr: 'Scan-Ergebnisse werden geladen',
            pagination_aria: 'Paginierung der Scanergebnisse',
            col_risk_category: 'Risikokategorie',
            risk_category_sr: 'regulatorische Risikokategorie',
            archive_retention_heading: 'Archivaufbewahrung',
            archive_retention_info: 'Scanergebnisse werden für die in der Datenaufbewahrungsrichtlinie Ihrer Organisation angegebene Dauer aufbewahrt. Die archivierten Ergebnisse umfassen den vollständigen Scan-Kontext (Framework-Tags, Risikokategorien, Abhilfemaßnahmen) und können als [[TOK_0]] für behördliche Nachweise exportiert werden.',
            export_context_info: 'Exportierte [[TOK_0]]-Dateien enthalten regulatorischen Kontext: Risikokategorie, anwendbare Rahmenbedingungen und umsetzbare Abhilfedetails für jedes Ergebnis.',
        },
        scanner_settings: {
            page_title: 'Scannereinstellungen',
            title: 'Scannereinstellungen',
            back_to_scanner: 'Zurück zum Scanner',
            failed_load: 'Die Scannerkonfiguration konnte nicht geladen werden',
            endpoint_url: 'Endpunkt [[TOK_0]]',
            save_success: 'Scannerkonfiguration erfolgreich gespeichert.',
            save_failed: 'Die Scannerkonfiguration konnte nicht gespeichert werden',
            test_connection: 'Testverbindung',
            testing: 'Testen...',
            save_configuration: 'Konfiguration speichern',
            saving: 'Sparen...',
            loading_sr: 'Laden der Scannereinstellungen',
        },
        monitoring_settings: {
            page_title: 'Datenschutzüberwachungseinstellungen',
            title: 'Überwachungseinstellungen',
            back_to_dashboard: 'Zurück zum Dashboard',
            failed_load: 'Die Überwachungskonfiguration konnte nicht geladen werden',
            credentials_heading: '[[TOK_0]] Anmeldeinformationen',
            connected_as: 'Verbunden als [[TOK_1]]',
            credentials_desc: 'Geben Sie Ihre [[TOK_0]]-Kontoanmeldeinformationen ein, um Privacy Monitoring zu verbinden. Finden Sie Ihre Mitglieds-ID auf der Profilseite Ihres [[TOK_1]]-Kontos.',
            client_id: 'Kunden-ID',
            client_secret: 'Client-Geheimnis',
            username: '[[TOK_0]] Benutzername (E-Mail)',
            password: '[[TOK_0]] Passwort',
            placeholder_keep: '(Leer lassen, um vorhanden zu bleiben)',
            credential_form_aria: '[[TOK_0]] Anmeldeformular',
            test_connection: 'Testverbindung',
            testing: 'Testen…',
            test_aria: 'Testen Sie die [[TOK_0]]-Verbindung',
            testing_aria: 'Verbindung testen',
            save_configuration: 'Konfiguration speichern',
            saving: 'Sparen…',
            save_aria: 'Anmeldedaten speichern',
            saving_aria: 'Anmeldeinformationen speichern',
            credentials_saved: '[[TOK_0]] Anmeldeinformationen erfolgreich gespeichert.',
            credentials_saving: '[[TOK_0]] Anmeldeinformationen gespeichert. Konfiguration wird neu geladen…',
            credentials_save_failed: 'Anmeldeinformationen konnten nicht gespeichert werden',
            client_id_required: 'Kunden-ID und Benutzername sind erforderlich.',
            all_fields_required: 'Alle Anmeldedatenfelder sind erforderlich.',
            email_heading: 'E-Mail-Benachrichtigungen',
            receive_emails: 'Erhalten Sie E-Mails mit Scanberichten',
            email_toggle_aria: 'E-Mails mit Scanberichten ein-/ausschalten',
            only_on_change: 'Senden Sie nur eine E-Mail, wenn sich der Risikostatus ändert',
            only_on_change_aria: 'E-Mail nur bei Risikostatusänderung umschalten',
            emails_enabled: 'Scan-Berichts-E-Mails aktiviert',
            emails_disabled: 'Scan-Berichts-E-Mails deaktiviert',
            only_change_on: 'Nur E-Mail bei Risikoänderung',
            only_change_off: 'E-Mail bei jedem Scan',
            email_failed: 'E-Mail-Einstellung konnte nicht aktualisiert werden',
            email_settings_aria: 'Einstellungen für E-Mail-Benachrichtigungen',
            loading_sr: 'Überwachungseinstellungen werden geladen',
        },
        entity_types: {
            user: 'Benutzer',
            case: 'Fall',
            incident: 'Vorfall',
            assessment: 'Bewertung',
            vendor: 'Anbieter',
            consent: 'Zustimmung',
            policy: 'Politik',
            data_map: 'Datenkarte',
        },
        actions: {
            create: 'Erstellen',
            update: 'Aktualisieren',
            delete: 'Löschen',
            view: 'Ansicht',
            export: 'Exportieren',
            status_change: 'Statusänderung',
        },
    },
    forms: {
        dashboard: {
            title: 'Formularübersicht',
            total_templates: 'Vorlagen gesamt',
            installed: 'Installiert',
            available: 'Verfügbar',
            by_market: 'Nach Markt',
            back_dashboard: 'Back zu Dashboard',
            browse_templates: 'Durchsuchen Vorlagen',
            catalog_coverage: 'Katalog Abdeckung',
            quick_start: 'Schnell Starten',
            recent_instances: 'Kürzliche Instanzen',
            total_instances: 'Gesamt Instanzen',
            fetch_failed: 'Fehler beim fetch Dashboard Daten..',
            no_instances: 'Keine Instanzen gefunden.',
            form_metrics: 'Formularmetriken-Übersicht',
            templates_total: 'Vorlagen insgesamt',
            instances_total: 'Instanzen insgesamt',
            installed_of_available: '[[TOK_2]] von [[TOK_3]] installiert',
            templates_in_category: 'Vorlagen in {category}',
        },
        templates: {
            title: 'Formularvorlagen',
            new: 'Neue Vorlage',
            edit: 'Vorlage bearbeiten',
            name: 'Vorlagenname',
            form_type: 'Formulartyp',
            market: 'Markt',
            language: 'Sprache',
            schema: 'Formularschema',
            preview: 'Vorschau',
            duplicate: 'Vorlage duplizieren',
            grid_view: 'Raster Ansehen',
            list_view: 'Liste Ansehen',
            fetch_failed: 'Fehler beim fetch Vorlagen..',
            filter_templates: 'Vorlagen filtern',
            version_history: 'Versionshistorie',
            no_version_history: 'Keine Versionshistorie — dies ist die Erstversion.',
            form_id: 'Formular-ID',
            source_instrument: 'Quellinstrument',
            issuer: 'Aussteller',
            all_frameworks: 'Alle Frameworks',
            view_mode: 'Ansichtsmodus',
        },
        catalog: {
            title: 'Formularkatalog',
            install: 'Installieren',
            uninstall: 'Deinstallieren',
            install_all: 'Alle installieren',
            installed_tab: 'Installiert',
            catalog_tab: 'Katalog',
            search_placeholder: 'Vorlagen durchsuchen...',
            no_templates: 'Keine Vorlagen gefunden.',
            template_count: '{count} Vorlagen',
            all_markets: 'Alle Markets',
            sections: 'Abschnitte',
            all_categories: 'Alle Kategorien',
            category: 'Kategorie',
            category_install_failed: 'Fehler beim install category Vorlagen..',
            category_install_success: 'Kategorie Vorlagen installed.',
            fetch_failed: 'Fehler beim fetch Vorlagen..',
            fetch_installed_failed: 'Fehler beim fetch installed Vorlagen..',
            fields: 'Felder',
            install_failed: 'Fehler beim install Vorlage..',
            install_success: 'Vorlage installed successfully.',
            installing: 'Installiere...',
            removing: 'Entferne...',
            uninstall_confirm: 'Are you sure you want zu uninstall dieses Vorlage?',
            uninstall_failed: 'Fehler beim uninstall Vorlage..',
            uninstall_success: 'Vorlage uninstalled successfully.',
            installation_summary: 'Installationsübersicht',
            filter_catalog: 'Katalog filtern',
            all_frameworks: 'Alle Frameworks',
            templates_installed_count: '[[TOK_1]] Vorlage(n) erfolgreich installiert',
            all_already_installed: 'Alle Vorlagen in dieser Kategorie sind bereits installiert',
            form_id: 'Formular-ID',
            issuer: 'Aussteller',
            catalog_tabs: 'Formularkatalog-Tabs',
        },
        filler: {
            back_templates: 'Back zu Vorlagen',
            no_sections: 'Keine Abschnitte gefunden.',
            draft_created: 'Entwurf created.',
            draft_saved: 'Entwurf saved.',
            fetch_template_failed: 'Fehler beim fetch Vorlage..',
            save_draft: 'Speichern Entwurf',
            save_draft_failed: 'Fehler beim save Entwurf..',
            saving: 'Speichere...',
            select_option: 'Auswählen ein Option',
            submit: 'Absenden',
            submit_failed: 'Fehler beim submit..',
            submitting: 'Sende...',
            title: 'Formular-Assistent',
            form_id_label: 'Formular-ID',
            schema_label: 'Schema',
            framework_label: 'Rahmen',
            issuer_label: 'Aussteller',
            source_label: 'Quelle',
            market_label: 'Markt',
            section_of: 'Abschnitt {current} von {total}',
            form_navigation: 'Formularnavigation',
            form_progress: 'Formularfortschritt: Abschnitt {current} von {total}',
            removed_item: 'Element {index} aus {field} entfernt',
            added_item: 'Neues Element zu {field} hinzugefügt',
            go_to_previous: 'Zum vorherigen Abschnitt, Abschnitt {current} von {total}',
            go_to_next: 'Zum nächsten Abschnitt, Abschnitt {current} von {total}',
            risk_matrix_placeholder: '1–5',
        },
        filing: {
            title: 'Einreichungsstatus',
            advance: 'Einreichungsstatus aktualisieren...',
            not_started: 'Nicht begonnen',
            drafting: 'Entwurf',
            internal_review: 'Interne Prüfung',
            approved_for_submission: 'Zur Einreichung genehmigt',
            submitted_to_authority: 'Bei Behörde eingereicht',
            supplement_requested: 'Ergänzung angefordert',
            supplement_in_progress: 'Ergänzung in Bearbeitung',
            resubmitted: 'Erneut eingereicht',
            accepted: 'Angenommen',
            rejected: 'Abgelehnt',
            closed: 'Geschlossen',
        },
        instances: {
            approved_by: 'Genehmigt By',
            form_answers: 'Formular Antworten',
            no_answers: 'Keine answers gefunden.',
            view_outputs: 'Ansehen Ausgaben',
            approve: 'Genehmigen',
            approve_failed: 'Fehler beim approve..',
            approving: 'Genehmige...',
            detail_title: 'Instanz Detail',
            fetch_failed: 'Fehler beim fetch Instanzen..',
            generate_failed: 'Fehler beim generate Ausgabe..',
            generate_output: 'Generieren Ausgabe',
            generating: 'Generiere...',
            submitted_at: 'Eingereicht At',
            instance_metadata: 'Formularinstanz-Metadaten',
            filing_status_steps: 'Archivierungsstatus-Schritte',
            current_status: 'aktueller Status',
            filing_status_update_failed: 'Fehler beim Aktualisieren des Einreichungsstatus',
        },
        outputs: {
            back_instance: 'Back zu Instanz',
            no_outputs_msg: 'No Ausgaben have been generated yet.',
            no_outputs_title: 'No Ausgaben',
            output_name: 'Ausgabe Name',
            download: 'Herunterladen',
            download_failed: 'Fehler beim download..',
            fetch_failed: 'Fehler beim fetch Ausgaben..',
            format: 'Dateiformat',
            generated_at: 'Generiert At',
            generated_by: 'Generiert By',
            size: 'Größe',
            title: 'Formular Ausgaben',
            print: 'Drucken',
            print_outputs: 'Formularausgaben drucken',
            printing: 'Formularausgaben werden gedruckt',
            pdf_preview: 'PDF-Vorschau',
            downloading: '{name} wird heruntergeladen',
            preview_in_new_window: '{name} ({format}) in neuem Fenster anzeigen',
        },
        cybersec_domains: {
            scope: 'Umfang und Anwendbarkeit',
            risk: 'Risikobewertung und Kontrollzuordnung',
            policy: 'Organisatorische Sicherheitsrichtlinien',
            localization: 'Datenlokalisierung und lokale Präsenz',
            vendor: 'Drittanbieter und Lieferkette',
            authority: 'Bearbeitung behördlicher Anfragen',
            incident: 'Vorfallreaktion und Beweissicherung',
            training: 'Schulung und Bereitschaft',
        },
        market_finalization_domains: {
            data_law: 'Datengesetz — Governance und operative Kontrollen',
            pdpl_2025: 'PDPL 2025 — Datenschutz-Governance und Betroffenenrechte',
            decree_356: 'Dekret 356/2025 — Lieferanten- und grenzüberschreitende Kontrollen',
            telecom: 'Telekommunikationsgesetz — Vertraulichkeit und Behördenanfragen',
        },
        nav: {
            filing_case_links: 'Einreichungsfallverknüpfungen',
            section_routing: 'Abschnittsweiterleitung',
            submission_packages: 'Einreichungspakete',
        },
        filing_case_links: {
            title: 'Einreichungsfallverknüpfungen',
            link_form: 'Formular mit Einreichungsfall verknüpfen',
            filing_case_type: 'Einreichungsfalltyp',
            form_instance: 'Formularinstanz',
            select_form_instance: 'Formularinstanz auswählen...',
            select_filing_case: 'Einreichungsfall auswählen...',
            no_links_found: 'Keine Einreichungsfallverknüpfungen gefunden.',
            linked: 'Verknüpft',
            filing_case_id: 'Archivierungsfall-ID',
            link_created: 'Archivierungsfall-Verknüpfung erstellt',
            link_deleted: 'Einreichungsfallverknüpfung gelöscht',
            aria_delete_link: 'Verknüpfung {name} löschen',
            case_type_dpia_dossier: 'DSFA-Dossier',
            case_type_cross_border_filing: 'Grenzüberschreitende Einreichung',
            case_type_breach_notification: 'Meldung einer Datenschutzverletzung',
            no_instances_guidance: 'Noch keine Formularinstanzen. Erstellen Sie eine aus Formularvorlagen.',
            no_filings_guidance: 'Noch keine Einreichungsfälle. Erstellen Sie einen aus Bewertungen.',
        },
        section_routing: {
            title: 'Abschnittsweiterleitung',
            assign_section: 'Abschnitt zuweisen',
            department: 'Abteilung',
            select_department: 'Abteilung auswählen...',
            assignee: 'Zugewiesene Person',
            select_assignee: 'Zugewiesene Person auswählen...',
            section: 'Abschnitt',
            select_section: 'Abschnitt auswählen...',
            select_form_instance: 'Formularinstanz auswählen...',
            no_assignments_found: 'Keine Abschnittszuweisungen gefunden.',
            select_instance_prompt: 'Formularinstanz auswählen, um Abschnittszuweisungen anzuzeigen.',
            complete_section: 'Abschnitt abschließen',
            status_pending: 'Ausstehend',
            status_in_progress: 'In Bearbeitung',
            status_completed: 'Abgeschlossen',
            status_reviewed: 'Überprüft',
            form_instance_id: 'Formularinstanz-ID',
            assignment_created: 'Abschnittszuweisung erstellt',
            assignment_deleted: 'Abschnittszuweisung gelöscht',
            status_updated: 'Abschnittsstatus aktualisiert',
            aria_delete_assignment: 'Zuweisung {name} löschen',
            deadline: 'Frist',
            deadline_help: 'Optional. Zuweisungen nach diesem Datum werden als überfällig angezeigt.',
            overdue: 'Überfällig',
            days_remaining: 'Tage verbleibend',
            approval_requested: 'Zur Überprüfung eingereicht',
            form_approved: 'Formular genehmigt',
            form_rejected: 'Formular abgelehnt',
            no_departments_guidance: 'Keine Abteilungen konfiguriert. Richten Sie diese in den Organisationseinstellungen ein.',
            no_sections_guidance: 'Keine Abschnitte in der Vorlage definiert. Stellen Sie sicher, dass die Formularvorlage Abschnitte enthält.',
            select_instance_first: 'Wählen Sie zuerst eine Formularinstanz aus, um verfügbare Abschnitte zu laden.',
        },
        submission_packages: {
            title: 'Einreichungspakete',
            assemble_package: 'Einreichungspaket zusammenstellen',
            dossier: 'Dossier',
            select_dossier: 'Dossier auswählen...',
            package_label: 'Paketbezeichnung',
            cover_letter: 'Anschreiben',
            checklist: 'Checkliste',
            evidence_index: 'Beweisverzeichnis',
            completeness: 'Vollständigkeit',
            incomplete_warning: 'Zusammenstellung nicht möglich: Formular hat unvollständige Abschnitte.',
            no_packages_found: 'Keine Einreichungspakete gefunden.',
            version: 'Version',
            package_assembled: 'Einreichungspaket zusammengestellt',
            package_deleted: 'Einreichungspaket gelöscht',
            aria_delete_package: 'Paket {name} löschen',
            status_draft: 'Entwurf',
            status_complete: 'Vollständig',
            status_submitted: 'Eingereicht',
            status_accepted: 'Akzeptiert',
            status_rejected: 'Abgelehnt',
            package_updated: 'Einreichungspaket aktualisiert',
            document_generated: 'Dokument erstellt',
            documents: 'Dokumente',
            generate: 'Generieren',
            preview: 'Vorschau',
            download: 'Herunterladen',
            download_all: 'Alle herunterladen',
            no_dossiers_guidance: 'Noch keine Dossiers. Erstellen Sie eines aus Bewertungen.',
            package_plan_help: 'In Paketplan aufnehmen (automatische Dokumentenerstellung verfügbar):',
            cover_letter_help: 'Offizielles Anschreiben an die zuständige Behörde',
            checklist_help: 'Compliance-Checkliste zur Überprüfung aller Einreichungsanforderungen',
            evidence_index_help: 'Index der im Einreichungsdokument referenzierten Nachweisdokumente',
            completeness_skipped: 'Vollständigkeitsprüfung übersprungen — keine Formularinstanz mit diesem Dossier verknüpft.',
            completeness_unavailable: 'Vollständigkeitsprüfung nicht verfügbar — Paketzusammenstellung wird fortgesetzt.',
            duplicate_package_error: 'Für dieses Dossier existiert bereits ein Einreichungspaket.',
            doc_cover_letter: 'Anschreiben',
            doc_checklist: 'Checkliste',
            doc_evidence_index: 'Nachweisverzeichnis',
            export_csv: 'CSV exportieren',
            export_success: 'Verknüpfungen der Einreichungsfälle erfolgreich exportiert',
            no_assignments_guidance: 'Noch keine Abschnittszuweisungen. Weisen Sie Abschnitte Abteilungen und Teammitgliedern zu, um die Weiterleitung zu starten.',
        },
        template_picker: {
            title: 'Vorlage auswählen',
            hint: 'Wählen Sie eine regulatorische Formularvorlage oder beginnen Sie mit einem leeren Formular.',
            market_filter: 'Nach Markt filtern',
            framework_filter: 'Nach Rahmenwerk filtern',
            all_markets: 'Alle Märkte',
            all_frameworks: 'Alle Rahmenwerke',
            search_placeholder: 'Vorlagen suchen...',
            blank_form: 'Leeres / allgemeines Formular',
            blank_form_desc: 'Ohne Vorlage erstellen — Felder manuell ausfüllen.',
            no_templates: 'Keine Vorlagen für diesen Filter gefunden.',
            select: 'Auswählen',
            link_error: 'Vorlagenverknüpfung fehlgeschlagen — Sie können eine Vorlage später in der Bearbeitungsansicht verknüpfen.',
            internal_badge: 'Interne Vorlage',
            legacy_badge: 'Veraltet',
            draft_badge: 'Entwurf',
            upcoming_badge: 'Kommend',
            hidden_badge: 'Ausgeblendet',
            show_hidden_toggle: 'Ausgeblendete / veraltete Vorlagen anzeigen',
            show_hidden_toggle_hint: 'Administratoransicht: umfasst Vorlagen, die als internal_only, hidden, legacy oder draft markiert sind.',
        },
        cover_letter_modal: {
            title: 'Anschreiben: Vorschau und Bearbeitung',
            iframe_title: 'Anschreiben-Vorschau',
            stage_label: 'Phase',
            stage_initial: 'Erste Einreichung',
            stage_supplement: 'Ergänzungsantwort',
            stage_resubmission: 'Erneute Einreichung',
            subject_label: 'Betreff',
            body_label: 'Hauptabsatz',
            notes_label: 'Zusätzliche Notizen',
            refresh_preview: 'Vorschau aktualisieren',
            confirm: 'Bestätigen und speichern',
            regenerate: 'Neu generieren',
            snapshot_saved: 'Anschreiben gespeichert',
        },
        related_panel: {
            title: 'Zugehörige Regulierungsformulare',
            open_form: 'Formular ausfüllen',
            no_forms: 'Keine zugehörigen Formulare gefunden.',
            hint_vn: 'VN-spezifische Regulierungsformulare verfügbar — wählen Sie ein Formular, um den Compliance-Assistenten zu öffnen.',
            internal_badge: 'Intern',
            official_badge: 'Offiziell',
            loading: 'Zugehörige Formulare werden geladen...',
            error: 'Zugehörige Formulare konnten nicht geladen werden.',
            form_id: 'Formular-ID',
            form_name: 'Formularname',
            framework: 'Rahmenwerk',
        },
        view_form: 'Formular anzeigen',
        edit_form: 'Formular bearbeiten',
        save_draft: 'Entwurf speichern',
        module_settings: 'Moduleinstellungen',
        validation_errors: 'Bitte beheben Sie die Validierungsfehler',
        custom_name_help: 'Optional — Standard ist der Vorlagenname, falls leer',
        select_placeholder: 'Auswählen...',
        previous_section: 'Zurück',
        next_section: 'Weiter',
        loading: 'Wird geladen...',
        array_add: 'Hinzufügen',
        array_remove: 'Entfernen',
        array_item_label: '{label} Element {index}',
        array_add_item: 'Element zu {label} hinzufügen',
        array_remove_item: 'Element {index} aus {label} entfernen',
        legacy_banner: 'Dieser Datensatz wurde vor den vereinheitlichten Formularen erstellt. Einige Daten können zwischen Entität und Formularinstanz abweichen.',
        field_required: '{label} ist erforderlich',
        section_announcement: 'Abschnitt [[TOK_3]] von [[TOK_4]]: [[TOK_5]]',
        sections_nav_label: 'Formularabschnitte',
        no_sections: 'Keine Vorlagenabschnitte verfügbar.',
        section_label_tpl: 'Abschnitt [[TOK_2]]: [[TOK_3]]',
        module_settings_auto_applied: 'Modulspezifische Einstellungen werden automatisch übernommen.',
        operation_failed: 'Der Vorgang ist fehlgeschlagen',
        failed_to_load_form: 'Formular konnte nicht geladen werden',
        failed_to_save_form: 'Formular konnte nicht gespeichert werden',
        failed_to_submit_form: 'Formular konnte nicht gesendet werden',
        failed_to_load_template: 'Vorlage konnte nicht geladen werden',
        failed_to_save_draft: 'Entwurf konnte nicht gespeichert werden',
        failed_to_create: 'Erstellung fehlgeschlagen',
    },
    pack_catalog: {
        title: 'Paketkatalog',
        install: 'Paket installieren',
        uninstall: 'Paket deinstallieren',
        install_batch: 'Paketgruppe installieren',
        installed_tab: 'Installiert',
        catalog_tab: 'Katalog',
        pack_details: 'Paketdetails',
        frameworks: 'Rahmenwerke',
        requirements: 'Anforderungen',
        artifacts: 'Artefakte',
        language_pack: 'Sprachpaket',
        dependencies: 'Abhängigkeiten',
        no_packs: 'Keine Pakete gefunden.',
    },
    platform_pages: {
        users: {
            title: 'Benutzer',
            new: 'Neuer Benutzer',
            invite: 'Benutzer einladen',
            edit: 'Benutzer bearbeiten',
            name: 'Bezeichnung',
            email: 'E-Mail',
            role: 'Rolle',
            status: 'Zustand',
            identity_type: 'Identitätstyp',
            last_login: 'Letzte Anmeldung',
            deactivate: 'Deaktivieren',
            reactivate: 'Reaktivieren',
            unlock: 'Entsperren',
            reset_password: 'Passwort zurücksetzen',
            remove: 'Entfernen',
            remove_confirm: '"{name}" entfernen? Diese Aktion ist dauerhaft und der Benutzer verliert jeglichen Zugriff. Der Datensatz wird zu Prüfzwecken aufbewahrt.',
        },
        roles: {
            title: 'Rollen',
            new: 'Neue Rolle',
            edit: 'Rolle bearbeiten',
            name: 'Rollenname',
            description: 'Beschreibung',
            permissions: 'Berechtigungen',
            users_count: 'Benutzer',
            detail: 'Rollendetails',
            all_tiers: 'Alle Stufen',
            role_name_placeholder: 'z. B. regionaler Compliance-Leiter',
        },
        profile: {
            title: 'Mein Profil',
            name: 'Bezeichnung',
            display_name: 'Anzeigename',
            email: 'E-Mail',
            phone: 'Telefon',
            department: 'Abteilung',
            job_title: 'Berufsbezeichnung',
            language: 'Sprache',
            role: 'Rolle',
            persona: 'Erkannte Persona',
            last_login: 'Letzte Anmeldung',
            save: 'Änderungen speichern',
            save_success: 'Profil erfolgreich aktualisiert',
            module_tips_section: 'Modultipps',
            tips_toggle: 'Regulatorische Tipps in Modulen anzeigen',
            dismissed_tips: 'Ausgeblendete Tipps',
            reset_dismissed: 'Alle ausgeblendeten Tipps zurücksetzen',
            notification_prefs: 'Benachrichtigungseinstellungen',
            notification_prefs_link: 'Benachrichtigungseinstellungen verwalten →',
            change_password: 'Passwort ändern',
            current_password: 'Aktuelles Passwort',
            new_password: 'Neues Passwort',
            confirm_password: 'Passwort bestätigen',
            accessibility: 'Barrierefreiheit',
            high_contrast: 'Hoher Kontrast Modus',
            high_contrast_desc: 'Kontrast erhoehen fuer bessere Lesbarkeit. Erfuellt WCAG 2.1 AAA.',
            passwords_no_match: 'Passwörter stimmen nicht überein',
            password_changed_logout: 'Passwort geändert. Sie werden abgemeldet.',
            failed_update: 'Profil konnte nicht aktualisiert werden',
            failed_change_password: 'Passwort konnte nicht geändert werden',
            none: 'Keine',
            never: 'Nie',
            password_requirements: 'Min. 12 Zeichen, Großbuchstabe, Kleinbuchstabe, Ziffer, Sonderzeichen',
        },
        security: {
            mfa_title: 'MFA-Einstellungen',
            mfa_enable: 'MFA aktivieren',
            mfa_disable: 'MFA deaktivieren',
            mfa_setup: 'Scannen Sie diesen QR-Code mit Ihrer Authentifizierungs-App',
            sso_title: 'SSO-Konfiguration',
            sso_provider: 'Anbieter',
            sso_client_id: 'Client-ID',
            sso_redirect: 'Weiterleitungs-URI',
            api_keys_title: 'API-Schlüssel',
            api_keys_new: 'Neuer API-Schlüssel',
            api_keys_name: 'Schlüsselname',
            api_keys_last_used: 'Zuletzt verwendet',
            api_keys_expires: 'Ablaufdatum',
            api_keys_revoke: 'Widerrufen',
            service_accounts_title: 'Dienstkonten',
            ip_allowlist_title: 'IP-Positivliste',
            ip_add: 'IP-Adresse hinzufügen',
            ip_address: 'IP-Adresse',
            ip_description: 'Beschreibung',
            delegations_title: 'Delegierungen',
            delegations_new: 'Neue Delegierung',
            delegations_from: 'Von Benutzer',
            delegations_to: 'An Benutzer',
            delegations_expires: 'Ablaufdatum',
            break_glass_title: 'Notfallzugriff',
            break_glass_request: 'Zugriff anfordern',
            break_glass_reason: 'Grund für den Zugriff',
            break_glass_duration: 'Dauer',
            session_settings_title: 'Sitzungseinstellungen',
            session_timeout: 'Sitzungszeitüberschreitung (Minuten)',
            session_max_concurrent: 'Maximale gleichzeitige Sitzungen',
            active_sessions_title: 'Aktive Sitzungen',
            active_sessions_device: 'Gerät',
            active_sessions_ip: 'IP-Adresse',
            active_sessions_started: 'Gestartet',
            active_sessions_revoke: 'Sitzung widerrufen',
            active_sessions_confirm_terminate: 'Möchten Sie diese Sitzung wirklich beenden?',
            active_sessions_confirm_terminate_current: 'Dies ist Ihre aktuelle Sitzung. Wenn Sie es beenden, werden Sie sofort abgemeldet. Weitermachen?',
            active_sessions_confirm_terminate_all: 'Sind Sie sicher, dass Sie alle anderen Sitzungen beenden möchten? Nur Ihre aktuelle Sitzung bleibt aktiv.',
            active_sessions_terminated: 'Sitzung erfolgreich beendet.',
            active_sessions_all_terminated: 'Alle anderen Sitzungen wurden beendet.',
            active_sessions_terminate_all: 'Beenden Sie alle anderen Sitzungen',
            active_sessions_last_activity: 'Letzte Aktivität',
            active_sessions_current: 'Aktuelle Sitzung',
            active_sessions_revoke_selected: 'Ausgewählte widerrufen',
            active_sessions_confirm_terminate_selected: 'Möchten Sie die ausgewählten Sitzungen wirklich beenden?',
            active_sessions_selected_terminated: 'Ausgewählte Sitzungen erfolgreich beendet.',
            ip_allowlist_desc: 'Verwalten Sie zulässige IP-Adressen für den Zugriff auf [[TOK_0]].',
            ip_no_entries: 'Keine IP-Adressen konfiguriert.',
            session_settings_desc: 'Konfigurieren Sie das Sitzungszeitlimit und die Beschränkungen für gleichzeitige Sitzungen.',
            session_settings_save_policy: 'Sitzungsrichtlinie speichern',
            session_settings_saved: 'Sitzungseinstellungen erfolgreich aktualisiert.',
            session_settings_idle_timeout: 'Leerlaufzeitüberschreitung (Minuten)',
            session_settings_absolute_timeout: 'Absolutes Timeout (Minuten)',
            session_settings_help_idle: 'Die Sitzung läuft nach diesem Zeitraum der Inaktivität ab.',
            session_settings_help_absolute: 'Die Sitzung läuft unabhängig von der Aktivität nach dieser Gesamtdauer ab.',
            session_settings_help_max: 'Maximale Anzahl gleichzeitiger Sitzungen pro Benutzer.',
            sso_note: 'Änderungen an der SSO-Konfiguration erfordern möglicherweise eine erneute Authentifizierung der Benutzer.',
            service_accounts_warning: 'Dieser [[TOK_0]]-Schlüssel wird nur einmal angezeigt. Kopieren Sie es jetzt und bewahren Sie es sicher auf.',
            service_accounts_new: 'Neues Dienstkonto',
            service_accounts_name: 'Kontoname',
            service_accounts_role: 'Rolle',
            service_accounts_created: 'Erstellt',
            service_accounts_desc: 'Verwalten Sie Maschine-zu-Maschine-Dienstkonten für [[TOK_0]] Integrationen.',
            break_glass_warning: 'Der Zugriff durch Glasbruch wird überwacht und protokolliert. Nur für echte Notfälle verwenden.',
            break_glass_min_chars: '[[TOK_2]] / [[TOK_3]] Mindestzeichen',
            break_glass_permission_count: '[[TOK_1]] Berechtigung(en) ausgewählt',
            break_glass_submitted: 'Glasbruchantrag eingereicht. Warten auf Genehmigung.',
            break_glass_approved: 'Antrag auf Glasbruch genehmigt.',
            break_glass_denied: 'Glasbruchanforderung abgelehnt.',
            break_glass_confirm_activate: 'Diesen Glasbruchantrag genehmigen? Dadurch wird der Notfallzugang sofort gewährt.',
            break_glass_confirm_title: 'Bestätigen Sie die Aktivierung',
            break_glass_pending: 'Ausstehende Anfragen',
            break_glass_active_sessions: 'Aktive Break-Glass-Sitzungen',
            break_glass_time_remaining: 'Verbleibende Zeit',
            break_glass_expired: 'Abgelaufen',
            break_glass_approved_denied_by: 'Genehmigt/Abgelehnt von',
            delegations_desc: 'Verwalten Sie temporäre Berechtigungsdelegierungen zwischen Benutzern.',
            delegations_my: 'Meine Delegationen',
            delegations_to_me: 'An mich delegiert',
            delegations_scope_all: 'Alle Berechtigungen',
            delegations_scope_specific: 'Spezifische Berechtigungen',
            delegations_created: 'Delegation erfolgreich erstellt.',
            delegations_revoked: 'Delegation widerrufen.',
            delegations_confirm_revoke: 'Sind Sie sicher, dass Sie diese Delegation widerrufen möchten?',
            delegations_confirm_revoke_title: 'Bestätigen Sie „Widerrufen“.',
            delegations_permission_count: '[[TOK_1]] Berechtigung(en)',
            api_keys_status: 'Status',
            api_keys_prefix: 'Schlüsselpräfix',
            api_keys_permissions_count: 'Berechtigungen',
            api_keys_ip_count: 'IP-Einschränkungen',
            api_keys_created: 'Erstellt',
            api_keys_confirm_revoke_title: 'Bestätigen Sie „Widerrufen“.',
            api_keys_confirm_revoke_message: 'Sind Sie sicher, dass Sie den [[TOK_2]]-Schlüssel „[[TOK_1]]“ widerrufen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
            api_keys_confirm_rotate_title: 'Bestätigen Sie die Drehung',
            api_keys_confirm_rotate_message: 'Sind Sie sicher, dass Sie den [[TOK_2]]-Schlüssel „[[TOK_1]]“ drehen möchten? Der aktuelle Schlüssel funktioniert sofort nicht mehr.',
            api_keys_created_success: '[[TOK_0]] Schlüssel erfolgreich erstellt.',
            api_keys_revoked_success: 'Der [[TOK_2]]-Schlüssel „[[TOK_1]]“ wurde widerrufen.',
            api_keys_rotated_success: 'Der [[TOK_2]]-Schlüssel „[[TOK_1]]“ wurde gedreht. Kopieren Sie den neuen Schlüssel unten.',
            api_keys_load_error: '[[TOK_0]]-Schlüssel konnten nicht geladen werden.',
            api_keys_create_error: 'Der Schlüssel [[TOK_0]] konnte nicht erstellt werden.',
            api_keys_revoke_error: 'Der Schlüssel [[TOK_0]] konnte nicht widerrufen werden.',
            api_keys_rotate_error: 'Der Schlüssel [[TOK_0]] konnte nicht gedreht werden.',
            break_glass_duration_15: '15 Minuten',
            break_glass_duration_30: '30 Minuten',
            break_glass_duration_60: '60 Minuten (1h)',
            break_glass_duration_120: '120 Minuten (2h)',
            break_glass_duration_240: '240 Minuten (4h)',
            sod_rules_title: 'Regeln zur Aufgabentrennung',
            sod_violations_report: 'Bericht über Verstöße',
            sod_create_rule: 'Regel erstellen',
            sod_col_name: 'Name',
            sod_col_description: 'Beschreibung',
            sod_col_conflict_count: 'Konfliktanzahl',
            sod_col_severity: 'Schweregrad',
            sod_col_status: 'Status',
            sod_col_actions: 'Aktionen',
            sod_no_rules: 'Keine SoD-Regeln gefunden',
            sod_severity_warning: 'Warnung',
            sod_severity_blocking: 'Blockieren',
            sod_active: 'Aktiv',
            sod_inactive: 'Inaktiv',
            sod_edit: 'Bearbeiten',
            sod_exceptions: 'Ausnahmen',
            sod_deactivate: 'Deaktivieren',
            sod_confirm_deactivate_title: 'Bestätigen Sie die Deaktivierung',
            sod_confirm_deactivate_message: 'Regel „[[TOK_1]]“ deaktivieren? Es werden keine Verstöße mehr gemeldet.',
            sod_deactivate_error: 'Regel konnte nicht deaktiviert werden',
            sod_rule_count: '{count} rules',
        },
        access_reviews: {
            title: 'Zugriffsüberprüfungen',
            campaigns: 'Überprüfungskampagnen',
            new_campaign: 'Neue Kampagne',
            campaign_name: 'Kampagnenname',
            scope: 'Umfang',
            reviewers: 'Prüfer',
            due_date: 'Fälligkeitsdatum',
            progress: 'Fortschritt',
            my_reviews: 'Meine Überprüfungen',
            approve: 'Genehmigen',
            revoke: 'Widerrufen',
            analytics: 'Rollenanalysen',
            analytics_title: 'Rollenanalysen',
            permission_usage: 'Berechtigungsnutzung',
            role_coverage: 'Rollenabdeckung',
            campaign_detail: 'Kampagnendetails',
            campaign_description: 'Beschreibung',
            campaign_status: 'Status',
            campaign_deadline: 'Frist',
            campaign_scope_type: 'Bereichstyp',
            campaign_completion: 'Fertigstellung',
            campaign_total_items: 'Gesamtzahl der Artikel',
            campaign_pending_items: 'Ausstehend',
            campaign_confirmed_items: 'Bestätigt',
            campaign_revoked_items: 'Widerrufen',
            campaign_escalated_items: 'Eskaliert',
            campaign_launch: 'Kampagne starten',
            campaign_cancel: 'Kampagne abbrechen',
            campaign_confirm_launch: 'Sind Sie sicher, dass Sie diese Kampagne starten möchten?',
            campaign_confirm_cancel: 'Möchten Sie diese Kampagne wirklich abbrechen?',
            campaign_launched: 'Kampagne erfolgreich gestartet.',
            campaign_cancelled: 'Kampagne abgebrochen.',
            review_items: 'Überprüfen Sie die Elemente',
            review_item_user: 'Benutzer',
            review_item_role: 'Rolle',
            review_item_reviewer: 'Rezensent',
            review_item_decision: 'Entscheidung',
            review_item_justify: 'Begründung',
            review_item_confirm: 'Bestätigen',
            review_item_revoke: 'Widerrufen',
            review_item_escalate: 'Eskalieren',
            all_decisions: 'Alle Entscheidungen',
            bulk_action: 'Massenaktion',
            bulk_confirm: 'Massenbestätigung',
            bulk_revoke: 'Massenwiderruf',
            selected_count: '[[TOK_1]] ausgewählt',
            justify_required: 'Eine Begründung ist erforderlich',
            scope_all_users: 'Alle Benutzer',
            scope_role_owner: 'Rolleninhaber',
            scope_department: 'Abteilung',
            back_to_campaigns: 'Zurück zu Kampagnen',
            recommendations: 'Empfehlungen',
            refreshing: 'Erfrischend...',
            decide: 'Entscheide',
            decision_by: 'Entscheidung von',
            loading_items: 'Artikel werden geladen...',
            loading_review_items: 'Bewertungsartikel werden geladen...',
            campaign_not_found: 'Kampagne nicht gefunden',
            loading_campaign: 'Kampagnendetails werden geladen...',
            campaign_completed: 'Kampagne erfolgreich abgeschlossen.',
            confirm_cancel_title: 'Bestätigen Sie „Abbrechen“.',
            justify_bulk_confirm: 'Begründung für die Massenbestätigung:',
            justify_bulk_revoke: 'Begründung für den Massenwiderruf:',
            items_selected: '[[TOK_1]] Element(e) ausgewählt',
            justify_bulk_required: 'Für Massenaktionen ist eine Begründung erforderlich',
            create_campaign_title: 'Erstellen Sie eine Kampagne zur Zugriffsüberprüfung',
            name_required: 'Name ist erforderlich',
            scope_type_required: 'Bereichstyp ist erforderlich',
            reviewer_strategy_required: 'Eine Gutachterstrategie ist erforderlich',
            deadline_required: 'Eine Frist ist erforderlich',
            reviewer_id_required: 'Für eine bestimmte Benutzerstrategie ist eine Prüfer-ID erforderlich',
            invalid_json: 'Ungültig [[TOK_0]]',
            scope_filter_label: 'Bereichsfilter ([[TOK_0]])',
            reviewer_strategy_label: 'Reviewer-Strategie',
            reviewer_id_label: 'Rezensenten-ID',
            deadline_label: 'Frist',
            create_campaign_btn: 'Kampagne erstellen',
            scope_type_label: 'Bereichstyp',
            scope_by_role: 'Nach Rolle',
            scope_by_department: 'Nach Abteilung',
            scope_custom: 'Benutzerdefiniert',
            reviewer_manager: 'Manager',
            reviewer_specific_user: 'Spezifischer Benutzer',
            enter_json_filter: 'Geben Sie den Filter [[TOK_0]] ein',
            hint_label: 'Hinweis:',
            role_usage: 'Rollennutzung',
            over_privileged_users: 'Überprivilegierte Benutzer',
            role_name_col: 'Rollenname',
            assigned_users: 'Zugewiesene Benutzer',
            active_users_30d: 'Aktive Benutzer (30 Tage)',
            total_perms: 'Gesamtdauerwellen',
            used_perms: 'Gebrauchte Dauerwellen',
            unused_perms: 'Unbenutzte Dauerwellen',
            no_data_available: 'Keine Daten verfügbar',
            roles_col: 'Rollen',
            total_col: 'Insgesamt',
            used_col: 'Gebraucht',
            unused_pct: 'Unbenutzt %',
            current_count: 'Aktueller Zählerstand',
            recommended_count: 'Empfohlene Anzahl',
            rationale: 'Begründung',
            loading_analytics: 'Analyse wird geladen...',
            loading_role_analytics: 'Rollenanalysedaten werden geladen...',
            computed_at: 'Berechnet bei:',
            form_errors: 'Das Formular weist [[TOK_1]] Fehler auf. Bitte korrigieren Sie sie.',
            scope_filter_invalid_json: 'Bereichsfilter enthält ungültige [[TOK_0]]',
            scope_hint_all_users: 'Kein Filter erforderlich – alle Benutzer werden einbezogen.',
            review_type_label: 'Überprüfungstyp',
            review_type_required: 'Überprüfungstyp ist erforderlich',
            reviewer_ids_label: 'Prüfer-IDs',
            reviewer_ids_hint: 'Benutzer-IDs durch Kommas getrennt eingeben',
            reviewer_ids_required: 'Mindestens eine Prüfer-ID ist erforderlich',
            start_date_label: 'Startdatum',
            start_date_required: 'Startdatum ist erforderlich',
            end_date_label: 'Enddatum',
            end_date_required: 'Enddatum ist erforderlich',
            review_type_user_access: 'Benutzerzugriff',
            review_type_role_permissions: 'Rollenberechtigungen',
            review_type_service_accounts: 'Dienstkonten',
            review_type_privileged_access: 'Privilegierter Zugriff',
            review_type_application_access: 'Anwendungszugriff',
            auto_revoke_label: 'Automatisch widerrufen bei Ablehnung',
            campaigns_title: 'Greifen Sie auf Bewertungskampagnen zu',
            create_campaign_label: '+ Kampagne erstellen',
            no_campaigns_found: 'Keine Kampagnen gefunden',
            loading_campaigns: 'Kampagnen werden geladen...',
            no_reviews_assigned: 'Ihnen wurden keine Bewertungen zugewiesen',
            loading_reviews: 'Bewertungen werden geladen...',
            review_decision_title: 'Überprüfungsentscheidung',
            justification_label: 'Begründung',
            announce_loaded_review_items: '[[TOK_1]] Bewertungselemente geladen',
            announce_loaded_campaigns: 'Geladene [[TOK_1]] Kampagnen',
            announce_decision_submitted: 'Entscheidung „[[TOK_1]]“ zur Überprüfung eingereicht',
            announce_decision_submitted_for: 'Entscheidung „[[TOK_2]]“ eingereicht für [[TOK_3]]',
            announce_bulk_decision: 'Bulk [[TOK_2]] wird auf [[TOK_3]] Artikel angewendet',
        },
        attestation: {
            title: 'Bestätigungszeitpläne',
            new: 'Neuer Zeitplan',
            edit: 'Zeitplan bearbeiten',
            create_title: 'Bestätigungszeitplan erstellen',
            edit_title: 'Bestätigungszeitplan bearbeiten',
            schedule_history: 'Zeitplanverlauf',
            next_run_date: 'Nächstes Ausführungsdatum',
            schedule_name: 'Zeitplanname',
            frequency: 'Häufigkeit',
            next_run: 'Nächste Ausführung',
            last_run: 'Letzte Ausführung',
            history: 'Bestätigungsverlauf',
            description: 'Beschreibung',
            scope: 'Umfang',
            status: 'Status',
            created_at: 'Erstellt',
            updated_at: 'Aktualisiert',
            trigger_now: 'Jetzt auslösen',
            back_to_schedules: 'Zurück zu den Zeitplänen',
            confirm_trigger: 'Trigger this schedule now?',
            confirm_delete: 'Delete this schedule?',
            triggered: 'Zeitplan erfolgreich ausgelöst.',
            deleted: 'Zeitplan gelöscht.',
            saved: 'Zeitplan erfolgreich gespeichert.',
            campaigns_generated: 'Generierte Kampagnen',
            run_date: 'Ausführungsdatum',
            run_status: 'Ausführungsstatus',
            create_schedule: 'Zeitplan erstellen',
            view_history: 'Verlauf anzeigen',
            deactivate: 'Deaktivieren',
            overdue: 'OVERDUE',
            overdue_sr: 'Der Zeitplan ist überfällig',
            confirm_trigger_title: 'Aktion bestätigen',
            confirm_trigger_message: 'Are you sure you want to trigger this schedule now?',
            confirm_deactivate_title: 'Bestätigen Sie die Deaktivierung',
            confirm_deactivate_message: 'Möchten Sie diesen Zeitplan wirklich deaktivieren?',
            triggered_success: 'Zeitplan erfolgreich ausgelöst.',
            deactivated_success: 'Zeitplan deaktiviert.',
            name_label: 'Name *',
            frequency_label: 'Häufigkeit *',
            scope_type_label: 'Umfangstyp *',
            scope_filter_label: 'Bereichsfilter ([[TOK_0]])',
            reviewer_strategy_label: 'Reviewer-Strategie *',
            reviewer_id_label: 'Rezensenten-ID *',
            frequency_quarterly: 'Vierteljährlich',
            frequency_semi_annual: 'Halbjährlich',
            frequency_annual: 'Jährlich',
            scope_all_users: 'Alle Benutzer',
            scope_by_role: 'Nach Rolle',
            scope_by_department: 'Nach Abteilung',
            scope_framework: 'Rahmen',
            scope_custom: 'Benutzerdefiniert',
            reviewer_manager: 'Manager',
            reviewer_role_owner: 'Rolleninhaber',
            reviewer_specific_user: 'Spezifischer Benutzer',
            computed_next_run_date: 'Berechnetes Datum für die nächste Ausführung',
            current_scheduled_date: 'Aktuelles geplantes Datum',
            recomputed_frequency_changed: '(neu berechnet – Frequenz geändert)',
            estimated_days_hint: 'Geschätzt basierend auf [[TOK_1]] Tagen ab heute',
            validation_name_required: 'Name ist erforderlich',
            validation_frequency_required: 'Häufigkeit ist erforderlich',
            validation_scope_type_required: 'Bereichstyp ist erforderlich',
            validation_reviewer_strategy_required: 'Eine Gutachterstrategie ist erforderlich',
            validation_reviewer_id_required: 'Für eine bestimmte Benutzerstrategie ist eine Prüfer-ID erforderlich',
            validation_invalid_json: 'Ungültig [[TOK_0]]',
            validation_scope_filter_invalid_json: 'Bereichsfilter enthält ungültige [[TOK_0]]',
            form_errors: 'Das Formular weist [[TOK_1]] Fehler auf. Bitte korrigieren Sie sie.',
            create_schedule_btn: 'Zeitplan erstellen',
            schedule_history_title: 'Zeitplanverlauf',
            campaign_name_col: 'Kampagnenname',
            items_col: 'Artikel',
            no_campaigns_yet: 'Es wurden noch keine Kampagnen generiert',
            loading_history: 'Verlauf wird geladen...',
            loading_schedule: 'Zeitplan wird geladen...',
            total_campaigns: 'Kampagnen insgesamt: [[TOK_1]]',
            results_per_page: 'Ergebnisse pro Seite',
            page_size_option: '[[TOK_1]] / Seite',
        },
        sod: {
            title: 'Funktionstrennung (SoD-Regeln)',
            new: 'Neue Regel',
            edit: 'Regel bearbeiten',
            create_title: 'SoD-Regel erstellen',
            edit_title: 'SoD-Regel bearbeiten',
            rule_name: 'Regelname',
            conflicting_permissions: 'Kollidierende Berechtigungen',
            permission_a: 'Berechtigung A',
            permission_b: 'Berechtigung B',
            violations: 'SoD-Verstöße',
            violation_user: 'Benutzer',
            violation_rule: 'Verletzte Regel',
            violation_date: 'Erkannt am',
            exceptions: 'SoD-Ausnahmen',
            exception_reason: 'Ausnahmegrund',
            exception_approver: 'Genehmigt von',
            exception_status: 'Ausnahmestatus',
            has_exception: 'Hat eine Ausnahme',
            no_exception: 'Keine Ausnahme',
            grant_exception: 'Ausnahme gewähren',
            granting: 'Gewähren...',
            grant_new_exception: 'Neue Ausnahme gewähren',
            exceptions_for: 'Ausnahmen für: [[TOK_1]]',
            back_to_rules: 'Zurück zu den Regeln',
            no_violations: 'Es wurden keine Verstöße festgestellt',
            no_exceptions_found: 'Für diese Regel wurden keine Ausnahmen gefunden',
            all_exception_statuses: 'Alle Ausnahmestatus',
            user_id_label: 'Benutzer-ID',
            justification_label: 'Begründung',
            compensating_controls_label: 'Kompensierende Kontrollen',
            expires_at_label: 'Läuft ab um',
            granting_exception_for: 'Gewähren einer Ausnahme für Regel: [[TOK_1]]',
            severity: 'Schweregrad',
            severity_warning: 'Warnung',
            severity_blocking: 'Blockieren',
            violation_count: '[[TOK_1]] Verstoß(e)',
            exception_count: '[[TOK_1]] Ausnahme(n)',
            rule_description: 'Beschreibung',
            confirm_delete: 'Sind Sie sicher, dass Sie diese Regel löschen möchten?',
            deleted: 'Regel gelöscht.',
            framework_code: 'Rahmenwerk',
            name_label: 'Name *',
            severity_label: 'Schweregrad *',
            conflict_pairs_legend: 'Konfliktberechtigungspaare',
            conflict_pairs_hint: 'Jedes Paar definiert zwei Berechtigungen, die nicht von demselben Benutzer gehalten werden sollten.',
            placeholder_permission_a: '-- Erlaubnis A --',
            placeholder_permission_b: '-- Erlaubnis B --',
            permission_a_for_pair: 'Berechtigung A für Paar [[TOK_1]]',
            permission_b_for_pair: 'Berechtigung B für Paar [[TOK_1]]',
            conflict_pair_label: 'Konfliktpaar [[TOK_1]]',
            remove_conflict_pair: 'Konfliktpaar entfernen [[TOK_1]]',
            add_pair: '+ Paar hinzufügen',
            placeholder_name: 'z.B. Trennung der Zahlungsgenehmigung',
            create_rule: 'Regel erstellen',
            loading_rule: 'SoD-Regel wird geladen...',
            failed_load_rule: 'Die Regel konnte nicht geladen werden.',
            failed_create_rule: 'Die SoD-Regel konnte nicht erstellt werden.',
            failed_update_rule: 'SoD-Regel konnte nicht aktualisiert werden.',
            validation_name_required: 'Name ist erforderlich.',
            validation_pair_required: 'Es ist mindestens ein Konfliktberechtigungspaar erforderlich.',
            validation_pair_both_required: 'Paar [[TOK_1]]: Beide Berechtigungen müssen ausgewählt werden.',
            validation_pair_must_differ: 'Paar [[TOK_1]]: Berechtigung A und Berechtigung B müssen unterschiedlich sein.',
            added_conflict_pair: 'Konfliktpaar hinzugefügt [[TOK_1]]',
            removed_conflict_pair: 'Konfliktpaar [[TOK_1]] entfernt',
            announce_loaded_violations: '[[TOK_1]] Verstöße geladen',
            announce_loaded_exceptions: '[[TOK_1]] Ausnahmen geladen',
            announce_loaded_rules: '[[TOK_1]] SoD-Regeln geladen',
            announce_loading_exceptions: 'Ausnahmen werden geladen…',
            regulatory_info: {
                sod_context: 'SoD-Regeln setzen die von der PDPL geforderte regulatorische Rollentrennung durch. Verstoesse mit framework_code koennen in rahmenspezifische Nachweispakete aufgenommen werden (UC-VN-09).',
                violation_export_context: 'SoD-Verletzungsexporte enthalten framework_code, widerspruchliche Rollen, Schweregrad, Ersteller und Erkennungszeitpunkt fuer Nachweispakete (P-VN-10).',
                exception_context: 'SoD-Ausnahmen erzeugen pruefungsfaehige Nachweise: Genehmiger, Begruendung, kompensierende Kontrollen und Ablaufdatum. Abgelaufene Ausnahmen bleiben sichtbar (UC-VN-09 Schritt 5).',
            },
        },
        regulatory_info: {
            attestation_context: 'Attestation schedules support the annual governance attestation cycle required by Data Law (DATA-D4). When scope_type is set to "framework", schedules can be linked to specific regulatory frameworks.',
            api_keys_context: 'API key telemetry constitutes account evidence per VN_CYBERSEC_LAW_2025 Section B.5. Each key record includes last_used_at, ip_allowlist, permissions, status, and expires_at.',
            session_context: 'Session management enforces access controls per Telecom Law confidentiality requirements (Section B.4). Session events produce audit trail entries.',
            break_glass_context: 'Break-glass procedures produce regulatory justification evidence: requestor identity, justification, permissions, duration, approver identity, and approval/denial timestamps.',
            license_context: 'License settings gate modules by tier using PACKAGE_DEFINITIONS. Framework-specific modules require appropriate license tiers. Tier changes produce audit trail entries.',
            module_config_context: 'Module configuration supports framework-driven enablement. Disabling a module required by an active regulatory framework may break evidence completeness.',
            notification_context: 'Compliance-critical notifications (breach deadlines, attestation due dates) are marked with a compliance_critical flag and cannot be fully suppressed.',
            delegation_context: 'Delegation governance produces audit-grade evidence: delegator_id, delegate_id, permission scope, start/end dates, and status. Expired delegations remain visible.',
            access_control_context: 'Access control configuration meets Cybersecurity Law requirements (VN_CYBERSEC_LAW_2025): IP allowlist, MFA, service accounts, and SSO changes are audit-trailed.',
        },
    },
    cmp: {
        integration: {
            title: 'CMP-Integration',
            status: 'Verbindungsstatus',
            endpoint: 'CMP-Endpunkt',
            last_sync: 'Letzte Synchronisierung',
            configure: 'Konfigurieren',
        },
        purpose_mapping: {
            title: 'Zweckzuordnung',
            cmp_purpose: 'CMP-Zweck',
            grc_purpose: 'GRC-Zweck',
            mapping_status: 'Zuordnungsstatus',
            auto_map: 'Automatisch zuordnen',
            new_mapping: 'Neue Zuordnung',
        },
        webhook: {
            title: 'Webhook-Konfiguration',
            webhook_url: 'Webhook-URL',
            secret: 'Webhook-Geheimnis',
            events: 'Ereignistypen',
            test_webhook: 'Webhook testen',
        },
        bulk_sync: {
            title: 'Massenabgleich',
            sync_now: 'Jetzt synchronisieren',
            last_run: 'Letzte Ausführung',
            records_synced: 'Synchronisierte Datensätze',
            sync_history: 'Synchronisierungsverlauf',
            syncing: 'Synchronisierung...',
        },
        sync_settings: {
            sync_failures: 'Synchronisierung Failures',
            sync_secret_warning: 'Synchronisierung Geheimnis (save dieses now — it will not be shown again):',
            push_description: 'Konfigurieren der GRC Suite zu push case Status updates zu AesirX CMP.',
            technical_description: 'Diese Konfiguration steuert, wie die GRC Suite Fallstatusaktualisierungen an [[TOK_1]] [[TOK_0]] verschiebt.',
            direction_label: 'Richtung',
            direction_value: 'GRC Suite → AesirX CMP (ausgehend)',
            auth_label: 'Authentifizierung',
            auth_value: 'HMAC-SHA256-Signatur im X-GRC-Signature-Header',
            retry_label: 'Wiederholen Richtlinie',
            retry_value: '3 retries mit exponential backoff (30s, 2min, 10min)',
            inbound_label: 'Eingehend Konfiguration',
            inbound_value: 'Eingehend Webhook (CMP → GRC) is configured in',
            cmp_webhook_settings: 'CMP Webhook Einstellungen',
            page_title: 'CMP Synchronisierungseinstellungen',
            outbound_sync_configured: 'Ausgehende Synchronisierung konfiguriert.',
            configure_sync_failed: 'Synchronisierung konnte nicht konfiguriert werden',
            configuration_updated: 'Konfiguration aktualisiert.',
            update_configuration_failed: 'Konfiguration konnte nicht aktualisiert werden',
            connection_test_failed: 'Verbindungstest fehlgeschlagen',
            test_result_message: 'Test an {endpoint} gesendet. Status: {status}',
            endpoint_placeholder: 'https://your-cmp-domain/api/grc-sync',
            events: {
                new_to_under_review: 'Neu → Unter Überprüfen (assigned)',
                under_review_to_identity_verification: 'Unter Überprüfen → Identity Verifizierung',
                under_review_to_in_progress: 'Unter Überprüfen → In Fortschritt',
                in_progress_to_completed: 'In Fortschritt → Abgeschlossen',
                in_progress_to_denied: 'In Fortschritt → Denied',
                any_to_closed: 'Any → Geschlossen',
            },
        },
    },
    settings_pages: {
        webhooks: {
            title: 'Webhooks',
            new: 'Neuer Webhook',
            url: 'URL',
            url_placeholder: 'https://example.com/webhook',
            events: 'Ereignisse',
            secret: 'Geheimnis',
            active: 'Aktiv',
            test: 'Testen',
            create_failed: 'Fehler beim create Webhook..',
            create_success: 'Webhook erfolgreich erstellt.',
            deactivate_failed: 'Fehler beim deactivate Webhook..',
            deactivate_success: 'Webhook deaktiviert.',
            fetch_failed: 'Fehler beim fetch Webhooks..',
            send_test_failed: 'Fehler beim send test..',
            test_failed: 'Webhook test fehlgeschlagen.',
            test_success: 'Webhook-Test erfolgreich.',
            edit_title: 'Webhook bearbeiten',
            announce_loaded: 'Webhooks geladen',
            update_success: 'Webhook erfolgreich aktualisiert.',
            update_failed: 'Fehler beim Aktualisieren des Webhooks.',
            activate_success: 'Webhook aktiviert.',
            activate_failed: 'Fehler beim Aktivieren des Webhooks.',
        },
        domains: {
            title: 'Domänen',
            new: 'Neue Domain',
            domain_name: 'Domainname',
            verified: 'Verifiziert',
            verify: 'Verifizieren',
            add_failed: 'Fehler beim add Domäne..',
            add_success: 'Domäne added successfully.',
            domain_placeholder: 'z.B. grc.example.com',
            fetch_failed: 'Fehler beim fetch Domänen..',
            remove_failed: 'Fehler beim remove Domäne..',
            remove_success: 'Domäne removed successfully.',
            txt_record: 'TXT Datensatz',
            verify_dns_failed: 'DNS verification fehlgeschlagen.',
            verify_failed: 'Fehler beim verify Domäne..',
            verify_success: 'Domäne verified successfully.',
        },
        export_schedules: {
            title: 'Exportzeitpläne',
            new: 'Neuer Zeitplan',
            schedule_name: 'Bezeichnung',
            frequency: 'Häufigkeit',
            format: 'Dateiformat',
            last_run: 'Letzte Ausführung',
            next_run: 'Nächste Ausführung',
            create_failed: 'Fehler beim create Zeitplan..',
            create_success: 'Planen created successfully.',
            day_of_month: 'Tag von Monat',
            day_of_week: 'Tag von Week',
            deactivate_failed: 'Fehler beim deactivate Zeitplan..',
            deactivate_success: 'Planen deactivated.',
            fetch_failed: 'Fehler beim fetch Zeitpläne..',
            freq_daily: 'Täglich',
            freq_monthly: 'Monatlich',
            freq_weekly: 'Wöchentlich',
            recipients: 'Empfänger',
            time_utc: 'Zeit (UTC)',
            trigger_failed: 'Fehler beim trigger Export..',
            trigger_success: 'Exportieren triggered successfully.',
            type_audit_trail: 'Prüfprotokoll',
            type_compliance_report: 'Konformität Bericht',
            type_custom: 'Benutzerdefiniert',
            type_incident_report: 'Vorfall Bericht',
            type_ropa: 'ROPA',
        },
        email_log: {
            title: 'E-Mail-Protokoll',
            recipient: 'Empfänger',
            subject: 'Betreff',
            sent_at: 'Gesendet am',
            status: 'Zustand',
            resend: 'Erneut senden',
            fetch_failed: 'Fehler beim fetch E-Mail logs..',
        },
    },
    organizations: {
        title: 'Organisationen',
        create: 'Erstellen Organisation',
        edit: 'Bearbeiten Organisation',
        name: 'Bezeichnung',
        slug: 'URL-Kennung',
        timezone: 'Zeitzone',
        locale: 'Standard Sprache',
        parent: 'Übergeordnet Organisation',
        group: 'Gruppe',
        org_group: 'Organisationsgruppe',
        no_group: '(Keine – nicht in einer Gruppe)',
        created: 'Erstellt',
        no_parent: '(Keine – eigenständig)',
        no_orgs: 'Keine Organisationen gefunden',
        load_error: 'Fehler beim load Organisationen',
        save_error: 'Fehler beim save Organisation',
        created_msg: 'Organisation created',
        updated: 'Organisation updated',
        deactivate: 'Deaktivieren',
        deactivated: 'Organisation deactivated',
        confirm_deactivate: 'Are you sure you want zu deactivate dieses Organisation?',
        loaded_results: 'Organizations geladen, {count} Ergebnisse',
        form_loaded: 'Organization-Formular geladen',
        locale_vi_vn: 'Tiếng Việt (vi-VN)',
        locale_en_us: 'Englisch (en-US)',
    },
    intake_configs: {
        title: 'Öffentlich Aufnahme Configs',
        create: 'Erstellen Konfiguration',
        edit: 'Bearbeiten Aufnahme Konfiguration',
        label_col: 'Bezeichnung',
        key: 'Aufnahme Schlüssel',
        key_hint: 'Öffentlich URL will be: /rights-request?key=',
        mapped_org: 'Ziel Organisation',
        status: 'Zustand',
        enabled: 'Aktiviert',
        disabled: 'Deaktiviert',
        request_types: 'Aktiviert Anfrage Typen',
        language: 'Standard Sprache',
        public_url: 'Öffentlich URL',
        no_configs: 'Keine Aufnahme configs gefunden Erstellen one zu enable public rights request forms..',
        load_error: 'Fehler beim load Aufnahme configs',
        save_error: 'Fehler beim save',
        delete_error: 'Fehler beim delete',
        created_msg: 'Konfiguration created',
        updated: 'Konfiguration updated',
        deleted: 'Aufnahme Konfiguration deleted',
        confirm_delete: 'Löschen dieses Aufnahme Konfiguration?',
        select_types: 'Auswählen bei least one request type',
        select_org: 'Auswählen ein target Organisation',
        routing_mode: 'Routingmodus',
        single_org: 'Einzelne Organisation',
        org_group_mode: 'Organisationsgruppe',
        org_group: 'Organisationsgruppe',
        select_group: 'Organisationsgruppe auswählen...',
        group_root_hint: 'Wird automatisch auf die Stammorganisation der Gruppe gesetzt, wenn eine Gruppe ausgewählt wird.',
        loaded_results: 'Intake configurations geladen, {count} Ergebnisse',
        form_loaded: 'Intake configuration-Formular geladen',
    },
    frequency: {
        weekly: 'Wöchentlich',
        monthly: 'Monatlich',
        quarterly: 'Vierteljährlich',
        semi_annually: 'Halbjährlich',
        annually: 'Jährlich',
        custom: 'Benutzerdefiniert',
    },
    task_management: {
        nav: {
            calendar: 'Kalender',
            all_tasks: 'Alle Aufgaben',
            my_tasks: 'Meine Aufgaben',
            overdue: 'Überfällig',
            board: 'Vorstand',
            workflows: 'Arbeitsabläufe',
        },
        list: {
            title: 'Alle Aufgaben',
            my_title: 'Meine Aufgaben',
            overdue_title: 'Überfällige Aufgaben',
            new_task: 'Aufgabe erstellen',
            no_tasks: 'Keine Aufgaben gefunden.',
            empty_state: 'Keine Aufgaben gefunden. Aufgaben werden aus Modulworkflows wie Bewertungen, Vorfällen und Überprüfungskampagnen generiert.',
            total: 'Aufgaben gesamt',
            search_placeholder: 'Aufgaben suchen...',
            bulk_actions: 'Massenaktionen',
            change_status: 'Status ändern',
            change_priority: 'Priorität ändern',
            assign: 'Zuweisen',
            sr_my_tasks_count: '{count} Aufgaben Ihnen zugewiesen',
            sr_days_overdue: '{count} Tage überfällig',
            sla_label: 'SLA',
        },
        detail: {
            title: 'Aufgabendetail',
            description: 'Beschreibung',
            workflow_progress: 'Workflow-Fortschritt',
            checklist: 'Checkliste',
            dependencies: 'Abhängigkeiten',
            comments: 'Kommentare',
            activity_timeline: 'Aktivitätszeitachse',
            assignees: 'Zugewiesene',
            add_assignee: 'Zugewiesenen hinzufügen',
            remove_assignee: 'Zugewiesenen entfernen',
            due_date: 'Fälligkeitsdatum',
            start_date: 'Startdatum',
            sla_status: 'SLA-Status',
            sla_on_track: 'Im Zeitplan',
            sla_at_risk: 'Gefährdet',
            sla_breached: 'Verletzt',
            tags: 'Schlagworte',
            source_entity: 'Quellentität',
            view_source: 'Quelle anzeigen',
            add_dependency: 'Abhängigkeit hinzufügen',
            remove_dependency: 'Abhängigkeit entfernen',
            write_comment: 'Kommentar schreiben...',
            post_comment: 'Senden',
            edit_comment: 'Bearbeiten',
            delete_comment: 'Löschen',
            add_checklist_item: 'Element hinzufügen',
            no_dependencies: 'Keine Abhängigkeiten',
            no_comments: 'Noch keine Kommentare',
            blocks: 'Blockiert',
            blocked_by: 'Blockiert durch',
            related: 'Verwandt',
            working_days_remain: 'Arbeitstage verbleibend',
            created_by: 'Erstellt von',
            completed_at: 'Abgeschlossen am',
            no_assignees: 'Keine Zugewiesenen',
            add_assignee_placeholder: 'Benutzer-ID eingeben...',
            edited: 'bearbeitet',
            timeline: 'Aktivitätszeitachse',
            no_timeline: 'Noch keine Aktivität',
            no_workflow: 'Kein Workflow zugewiesen',
            add_dependency_placeholder: 'Aufgaben-ID eingeben...',
            sr_status_updated: 'Status aktualisiert auf [[TOK_1]]',
            sr_priority_updated: 'Priorität aktualisiert auf [[TOK_1]]',
            convert_to_workflow: 'Als Workflow ausführen',
            convert_modal_title: 'Aufgabe in Workflow-Ausführung umwandeln',
            convert_workflow_label: 'Arbeitsablauf',
            convert_workflow_placeholder: 'Wählen Sie einen Workflow aus …',
            convert_attachments_label: 'Anhänge',
            convert_attachments_empty: 'Keine Anhänge zu dieser Aufgabe.',
            convert_persona_label: 'Persona-Überschreibung (optional)',
            convert_submit: 'Workflow-Lauf starten',
            convert_starting: 'Workflow-Ausführung wird gestartet…',
            convert_started: 'Workflow-Lauf gestartet – Eröffnungslauf…',
            convert_disabled_in_flight: 'Ein von dieser Aufgabe ausgeführter Workflow wird bereits ausgeführt.',
            linked_workflow_chip: 'Von [[TOK_1]]',
            linked_chat_chip: 'Von [[TOK_0]] Chat',
            linked_more: '+[[TOK_1]] mehr',
        },
        calendar: {
            title: 'Aufgabenkalender',
            page_title: 'Kalender',
            create_task: 'Aufgabe erstellen',
            month: 'Monat',
            week: 'Woche',
            day: 'Tag',
            today: 'Heute',
            more_tasks: '+[[TOK_1]] mehr',
            no_tasks_day: 'Keine Aufgaben an diesem Tag',
            all_day: 'Ganztägig',
            quick_create_tooltip: 'Aufgabe für diesen Tag erstellen',
            view_changed: 'Kalenderansicht geändert auf {view}',
            tasks_in_view: '{count} Aufgaben in Ansicht',
            task_in_view: '[[TOK_1]] Aufgabe im Blick',
        },
        filters: {
            assignee: 'Zugewiesener',
            me: 'Ich',
            role: 'Rolle',
            status: 'Status',
            priority: 'Priorität',
            task_type: 'Aufgabentyp',
            source_module: 'Quellmodul',
            organization: 'Organisation',
            sla_breached_only: 'Nur SLA-verletzt anzeigen',
            clear_filters: 'Filter löschen',
            apply_filters: 'Anwenden',
            source_label: 'Quelle',
            source_manual: 'Handbuch',
            source_module_kind: 'Modulgeneriert',
            source_chat: 'Von [[TOK_0]] Chat',
            source_workflow_run: 'Von [[TOK_0]] Workflow-Ausführung',
        },
        status: {
            pending: 'Ausstehend',
            in_progress: 'In Bearbeitung',
            blocked: 'Blockiert',
            completed: 'Abgeschlossen',
            overdue: 'Überfällig',
            escalated: 'Eskaliert',
            cancelled: 'Storniert',
        },
        priority: {
            critical: 'Kritisch',
            high: 'Hoch',
            medium: 'Mittel',
            low: 'Niedrig',
        },
        task_types: {
            manual_task: 'Manuelle Aufgabe',
            dsr_case: 'DSR-Fall',
            dsr_review: 'DSR-Prüfung',
            dsr_escalation: 'DSR-Eskalation',
            dpia_review: 'DSFA-Prüfung',
            dpia_approval: 'DSFA-Genehmigung',
            transfer_review: 'Transferprüfung',
            incident_task: 'Vorfallsaufgabe',
            incident_notification: 'Vorfallsbenachrichtigung',
            playbook_step: 'Playbook-Schritt',
            regulator_deadline: 'Behördenfrist',
            monitoring_task: 'Überwachungsaufgabe',
            kpi_alert: 'KPI-Alarm',
            vendor_review: 'Lieferantenprüfung',
            vendor_questionnaire: 'Lieferantenfragebogen',
            governance_review: 'Steuerungsprüfung',
            drift_alert: 'Abweichungsalarm',
            governance_approval: 'Steuerungsgenehmigung',
            deletion_task: 'Löschaufgabe',
            deletion_verification: 'Löschverifizierung',
            access_review: 'Zugriffsprüfung',
            sod_alert: 'SoD-Alarm',
            consent_workflow: 'Einwilligungs-Workflow',
            consent_alert: 'Einwilligungsalarm',
            property_review: 'Eigenschaftsprüfung',
            inconsistency_alert: 'Inkonsistenzalarm',
            form_review: 'Formularprüfung',
            dossier_deadline: 'Dossierfrist',
            submission_task: 'Einreichungsaufgabe',
            translation_review: 'Übersetzungsprüfung',
            governance_task: 'Steuerungsaufgabe',
            reporting_deadline: 'Berichtsfrist',
            scanner_alert: 'Scanner-Alarm',
            classification_review: 'Klassifizierungsprüfung',
            lifecycle_task: 'Lebenszyklusaufgabe',
            discovery_review: 'Entdeckungsprüfung',
        },
        task_type_groups: {
            manual: 'Manuell',
            dsr: 'DSR / Betroffenenrechte',
            assessments: 'Bewertungen',
            incidents: 'Vorfälle',
            incident_ops: 'Vorfallsbetrieb',
            monitoring: 'Überwachung',
            vendor_risk: 'Lieferantenrisiko',
            governance: 'Steuerung',
            deletion: 'Löschung',
            access_review: 'Zugriffsprüfung',
            consent: 'Einwilligung',
            consent_properties: 'Einwilligungseigenschaften',
            forms: 'Formulare',
            localization: 'Lokalisierung',
            program_governance: 'Programmsteuerung',
            privacy_scanner: 'Datenschutz-Scanner',
            classification: 'Klassifizierung',
            discovery: 'Entdeckung',
        },
        create: {
            title: 'Aufgabe erstellen',
            task_title: 'Titel',
            task_description: 'Beschreibung',
            task_type: 'Aufgabentyp',
            task_type_label: 'Aufgabentyp',
            task_type_placeholder: 'Aufgabentyp wählen',
            priority: 'Priorität',
            assignees: 'Zugewiesene',
            assignee_search_placeholder: 'Benutzer suchen...',
            due_date: 'Fälligkeitsdatum',
            start_date: 'Startdatum',
            checklist: 'Checkliste',
            tags: 'Schlagworte',
            add_checklist_item: 'Checklistenpunkt hinzufügen',
            validation: {
                title_required: 'Titel ist erforderlich',
                title_max_length: 'Titel darf maximal 500 Zeichen haben',
                description_max_length: 'Beschreibung darf maximal 5000 Zeichen haben',
                due_date_before_start: 'Fälligkeitsdatum muss nach dem Startdatum liegen',
                max_reminders: 'Maximal 5 Erinnerungen pro Aufgabe',
            },
            reminders: {
                title: 'Erinnerungen',
                add: 'Erinnerung hinzufügen',
                at_due_date: 'Am Fälligkeitsdatum',
                minutes_before: '[[TOK_1]] Minuten zuvor',
                hours_before: '[[TOK_1]] Stunden vorher',
                days_before: '[[TOK_1]] Tage zuvor',
                weeks_before: '[[TOK_1]] Wochen vorher',
                custom: 'Benutzerdefiniert',
                channel_platform: 'Plattform',
                channel_email: 'E-Mail',
                channel_both: 'Beides',
            },
            workflow: {
                label: 'Arbeitsablauf',
                none: 'Keine (manuelle Statusverwaltung)',
                steps_count: '[[TOK_1]] Schritte',
                preview_label: 'Workflow-Schritte',
            },
        },
        errors: {
            fetch_failed: 'Aufgaben konnten nicht geladen werden.',
            save_failed: 'Aufgabe konnte nicht gespeichert werden.',
            delete_failed: 'Aufgabe konnte nicht gelöscht werden.',
            status_change_failed: 'Aufgabenstatus konnte nicht geändert werden.',
            assign_failed: 'Aufgabe konnte nicht zugewiesen werden.',
            comment_failed: 'Kommentar konnte nicht gespeichert werden.',
            checklist_failed: 'Fehler beim Aktualisieren der Checkliste.',
            dependency_failed: 'Fehler beim Aktualisieren der Abhängigkeit.',
            workflow_failed: 'Workflow konnte nicht gespeichert werden.',
            workflow_activate_failed: 'Workflow konnte nicht aktiviert werden.',
            workflow_delete_failed: 'Workflow konnte nicht gelöscht werden.',
            template_install_failed: 'Vorlage konnte nicht installiert werden.',
            search_failed: 'Aufgabensuche fehlgeschlagen.',
            convert_failed: 'Der Workflow-Lauf konnte nicht gestartet werden.',
            convert_quota_exhausted: 'Token-Bucket niedrig. Füllen Sie vor dem erneuten Ausführen auf.',
        },
        dependency_types: {
            blocks: 'Blockiert',
            blocked_by: 'Blockiert durch',
            related: 'Verwandt',
        },
        workflow: {
            current_step: 'Aktueller Schritt',
            transition: 'Übergang',
            history: 'Schritthistorie',
            no_workflow: 'Kein Workflow zugewiesen',
            detail_title: 'Workflow-Details',
            list_title: 'Workflow-Definitionen',
            create_workflow: 'Workflow erstellen',
            browse_templates: 'Vorlagen durchsuchen',
            template_catalog_title: 'Workflow-Vorlagenkatalog',
            name: 'Name',
            description: 'Beschreibung',
            task_types: 'Aufgabentypen',
            steps: 'Schritte',
            version: 'Version',
            created: 'Erstellt',
            actions: 'Aktionen',
            status_draft: 'Entwurf',
            status_active: 'Aktiv',
            status_archived: 'Archiviert',
            activate: 'Aktivieren',
            archive: 'Archivieren',
            save: 'Speichern',
            edit: 'Bearbeiten',
            delete: 'Löschen',
            clone: 'Klonen',
            install: 'Installieren',
            installed: 'Installiert',
            system: 'System',
            general_settings: 'Allgemeine Einstellungen',
            default_assignment: 'Standardzuweisung',
            default_sla: 'Standard-SLA',
            workflow_steps: 'Workflow-Schritte',
            add_step: 'Schritt hinzufügen',
            step_name: 'Schrittname',
            step_status: 'Statuswert',
            assignment_strategy: 'Zuweisungsstrategie',
            assignment_role: 'Zuweisungsrolle',
            sla_hours: 'SLA-Stunden',
            sla_calendar_type: 'Kalendertyp',
            working_days: 'Arbeitstage',
            calendar_days: 'Kalendertage',
            is_terminal: 'Terminalschritt',
            required_fields: 'Pflichtfelder',
            checklist_template: 'Checklistenvorlage',
            transitions: 'Übergänge',
            add_transition: 'Übergang hinzufügen',
            from_step: 'Von',
            to_step: 'Nach',
            permission: 'Berechtigung',
            sla_action: 'SLA-Aktion',
            notify: 'Benachrichtigen',
            escalation_rules: 'Eskalationsregeln',
            add_rule: 'Regel hinzufügen',
            trigger: 'Auslöser',
            threshold: 'Schwellenwert',
            action: 'Aktion',
            target_role: 'Zielrolle',
            trigger_sla_threshold: 'SLA-Schwellenwert',
            trigger_sla_breach: 'SLA-Verletzung',
            trigger_blocked_duration: 'Blockierte Dauer',
            trigger_manual: 'Manuell',
            action_notify: 'Benachrichtigen',
            action_escalate: 'Eskalationsstufe',
            action_reassign: 'Neu zuweisen',
            sla_start: 'Starten',
            sla_pause: 'Pause',
            sla_resume: 'Fortsetzen',
            sla_stop: 'Stopp',
            strategy_manual: 'Manuell',
            strategy_role_based: 'Rollenbasiert',
            strategy_round_robin: 'Round Robin',
            strategy_least_loaded: 'Am wenigsten belastet',
            strategy_creator: 'Ersteller',
            confirm_delete: 'Sind Sie sicher, dass Sie diesen Workflow löschen möchten?',
            confirm_archive: 'Sind Sie sicher, dass Sie diesen Workflow archivieren möchten?',
            cannot_delete_active: 'Aktive Workflows können nicht gelöscht werden. Erst archivieren.',
            validation_errors: 'Workflow-Validierungsfehler',
            step_count: '[[TOK_1]] Schritte',
            no_workflows: 'Keine Workflows gefunden.',
            no_templates: 'Keine Vorlagen verfügbar.',
            sr_templates_count: '[[TOK_1]] Vorlagen verfügbar',
            template_installed: 'Vorlage erfolgreich installiert.',
            activate_success: 'Workflow erfolgreich aktiviert.',
            archive_success: 'Workflow erfolgreich archiviert.',
            save_success: 'Workflow erfolgreich gespeichert.',
            delete_success: 'Workflow erfolgreich gelöscht.',
        },
        columns: {
            priority: 'Priorität',
            title: 'Titel',
            status: 'Status',
            type: 'Typ',
            assignees: 'Zugewiesene(r)',
            due_date: 'Fälligkeitsdatum',
            source: 'Quelle',
            actions: 'Aktionen',
        },
        groups: {
            overdue: 'Überfällig',
            due_today: 'Heute fällig',
            due_this_week: 'Diese Woche fällig',
            due_later: 'Später fällig',
            no_due_date: 'Kein Fälligkeitsdatum',
        },
        board: {
            title: 'Aufgaben-Board',
            drag_hint: 'Aufgaben zwischen Spalten ziehen, um den Status zu ändern',
            empty_column: 'Keine Aufgaben',
            keyboard_hint: 'Tastatur: Pfeiltasten zum Navigieren, Leertaste zum Aufnehmen, Links/Rechts zur Spaltenauswahl, Enter zum Ablegen, Escape zum Abbrechen.',
            sr_moving: '{title} wird verschoben. Über {column}. Enter zum Ablegen, Escape zum Abbrechen.',
            sr_tasks_shown: '{count} Aufgaben angezeigt',
            sr_picked_up: '{title} aufgenommen',
            sr_returned: '[[TOK_2]] zurückgegeben an [[TOK_3]]',
            sr_dropped: '{title} in {column} abgelegt, Position {position} von {total}',
            sr_move_cancelled: 'Verschiebung abgebrochen',
            sr_over_column: 'Über {column}',
            sr_moved_to: '{title} verschoben nach {column}',
            invalid_transition: 'Aufgabe kann nicht von {from} nach {to} verschoben werden.',
            terminal_status: 'Diese Aufgabe hat einen Endstatus und kann nicht verschoben werden.',
            invalid_drop_target: 'Ungueltiges Ablageziel',
        },
        team: {
            title: 'Teamauslastung',
            assignee: 'Zugewiesener',
            active: 'Aktiv',
            overdue: 'Überfällig',
            blocked: 'Blockiert',
            completed_7d: 'Abgeschlossen (7 Tage)',
            load: 'Auslastung',
            load_high: 'Hoch',
            load_medium: 'Mittel',
            load_normal: 'Normal',
        },
        graph: {
            title: 'Abhängigkeitsdiagramm',
            list_view: 'Listenansicht',
            graph_view: 'Diagrammansicht',
            zoom_in: 'Vergrößern',
            zoom_out: 'Herauszoomen',
            reset_zoom: 'Zurücksetzen',
            blocks_label: 'blocks',
            related_label: 'related',
            no_dependencies: 'Keine Abhängigkeiten zur Visualisierung.',
        },
        add_dependency_modal: {
            title: 'Abhängigkeit hinzufügen',
            search_placeholder: 'Suchen Sie Aufgaben nach Titel oder ID...',
            no_results: 'Keine Aufgaben gefunden.',
            this_blocks: 'Diese Aufgabe blockiert ausgewählte',
            this_blocked_by: 'Diese Aufgabe ist durch Ausgewählte blockiert',
            related: 'Verwandt',
            max_dependencies: 'Maximal 10 Abhängigkeiten pro Aufgabe.',
            circular_error: 'Kann nicht hinzugefügt werden: würde eine zirkuläre Abhängigkeit erzeugen.',
        },
        conflict_detection: {
            title: 'Konflikterkennung',
            unresolved: 'ungelöst',
            no_conflicts: 'Keine Konflikte erkannt',
            section: 'Abschnitt',
            field: 'Feld',
            dept_a: 'Abteilung A',
            value_a: 'Wert A',
            dept_b: 'Abteilung B',
            value_b: 'Wert B',
            severity: 'Schweregrad',
            status: 'Status',
            resolved: 'Gelöst',
            open: 'Offen',
            resolve: 'Lösen',
            load_failed: 'Fehler beim load conflicts',
            resolve_success: 'Konflikt erfolgreich gelöst',
            resolve_failed: 'Fehler beim resolve conflict',
            severity_critical: 'Kritisch',
            severity_warning: 'Warnung',
            severity_info: 'Infos',
        },
        consolidation: {
            title: 'Konsolidierungsfortschritt',
            add_child: 'Unteraufgabe hinzufügen',
            child_task_id: 'Unteraufgabe-ID',
            department_id: 'Abteilungs-ID',
            link: 'Verknüpfen',
            overall_completion: 'Gesamtfertigstellung',
            departments_complete: 'Abteilungen abgeschlossen',
            overdue: 'Überfällig',
            ready: 'Bereit',
            not_ready: 'Nicht bereit',
            master_status: 'Hauptstatus',
            department_breakdown: 'Abteilungsaufschlüsselung',
            department: 'Abteilung',
            status: 'Status',
            completion: 'Fertigstellung',
            due_date: 'Fälligkeitsdatum',
            overdue_flag: 'Überfällig',
            child_tasks: 'Unteraufgaben',
            task: 'Aufgabe',
            load_failed: 'Fehler beim load consolidation data',
            child_linked: 'Unteraufgabe erfolgreich verknüpft',
            link_failed: 'Fehler beim link child task',
            confirm_unlink: 'Möchten Sie die Verknüpfung dieser Unteraufgabe wirklich aufheben?',
            child_unlinked: 'Unteraufgabe entkoppelt',
            unlink_failed: 'Entkopplung der Unteraufgabe fehlgeschlagen',
            unlink: 'Entkoppeln',
            status_completed: 'Abgeschlossen',
            status_in_progress: 'In Bearbeitung',
            status_pending: 'Ausstehend',
            select_child_task: 'Unteraufgabe auswählen',
            select_department: 'Abteilung auswählen',
        },
        section_assignments: {
            title: 'Abschnittszuweisungen',
            assign_section: 'Abschnitt zuweisen',
            section_ref: 'Abschnittsreferenz',
            section_label: 'Abschnittsbezeichnung',
            department_id: 'Abteilungs-ID',
            department: 'Abteilung',
            assignee_id: 'Zugewiesene-ID',
            assignee: 'Bevollmächtigter',
            mandatory: 'Pflichtfeld',
            assign: 'Zuweisen',
            no_assignments: 'Keine Abschnittszuweisungen',
            status: 'Status',
            completion: 'Fertigstellung',
            mark_complete: 'Abschließen',
            load_failed: 'Fehler beim load section assignments',
            assign_success: 'Abschnitt erfolgreich zugewiesen',
            assign_failed: 'Fehler beim assign section',
            status_updated: 'Status aktualisiert',
            status_update_failed: 'Fehler beim Aktualisieren des Status',
            section_ref_placeholder: 'z.B. 3.2',
            status_completed: 'Abgeschlossen',
            status_in_progress: 'In Bearbeitung',
            status_pending: 'Ausstehend',
            select_department: 'Abteilung auswählen',
            select_assignee: 'Wählen Sie den Beauftragten aus',
        },
        overdue_columns: {
            days_overdue: 'Tage ueberfaellig',
        },
        regulatory_info: {
            deadline_context: 'Beim Erstellen von DPIA-Aufgaben sollten Faelligkeitsdaten den PDPL-Einreichungsfristen entsprechen: Abteilungseingabe = 10 Arbeitstage. Cybersicherheits- und Telekommunikationsfristen gelten ebenfalls.',
            overdue_deadline_context: 'Regulatorische Fristen aus Paketdaten: PDPL Abteilungseingabe = 10 Arbeitstage, Ergaenzungsantwort = 15 Arbeitstage, Wiedereinreichung = 10 Arbeitstage. SLA-verletzte Aufgaben werden visuell hervorgehoben.',
            section_assignment_context: 'DPIA Multi-Abteilungs-Workflow (PDPL-P1): DPO weist Dossierabschnitte Abteilungen zu. Abteilungseingabefrist: 10 Arbeitstage.',
            template_catalog_context: 'Systemvorlagen decken rahmenspezifische Prozesse ab: PDPL DPIA, Datenschutzgesetz-Attestierung, Cybersicherheits-Vorfallreaktion, Telekom-Behoerdenanfragen und KI-Registrierung. Systemvorlagen sind nicht bearbeitbar.',
            workflow_instantiation_context: 'Installierte Vorlagen koennen zu aktiven Workflows instanziiert werden. Aufgaben werden automatisch mit berechneten Faelligkeitsdaten erstellt.',
        },
    },
    notifications: {
        bell: {
            title: 'Benachrichtigungen',
            unread_count: 'unread',
        },
        drawer: {
            title: 'Benachrichtigungen',
            mark_all_read: 'Alle als gelesen markieren',
            no_notifications: 'Keine Benachrichtigungen',
            filter: {
                all: 'All',
                unread: 'Ungelesen',
                tasks: 'Aufgaben',
                approvals: 'Zulassungen',
                alerts: 'Warnungen',
            },
        },
        preferences: {
            title: 'Benachrichtigungseinstellungen',
            description: 'Konfigurieren Sie, wie Sie Benachrichtigungen erhalten',
            category: {
                label: 'Kategorie',
                task_assigned: 'Aufgabe zugewiesen',
                task_sla_approaching: '[[TOK_0]] Nähert sich',
                task_overdue: 'Aufgabe überfällig',
                task_completed: 'Aufgabe abgeschlossen',
                task_escalated: 'Aufgabe eskaliert',
                workflow_transition: 'Workflow-Übergang',
                approval_requested: 'Genehmigung beantragt',
                comment_added: 'Kommentar hinzugefügt',
                weekly_digest: 'Wöchentliche Zusammenfassung',
                sla_breach_report: '[[TOK_0]] Verstoßbericht',
                system_alert: 'Systemwarnung',
            },
            channel: {
                platform: 'Plattform',
                email: 'Email',
            },
            quiet_hours: {
                title: 'Ruhige Stunden',
                start: 'Starten',
                end: 'End',
                timezone: 'Zeitzone',
            },
            digest: {
                title: 'Häufigkeit der Verdauung',
                daily: 'Täglich',
                weekly: 'Wöchentlich',
                none: 'Keine',
            },
            watched: {
                title: 'Beobachtete Entitäten',
                empty: 'Keine beobachteten Entitäten',
            },
            save: 'Einstellungen speichern',
            saving: 'Sparen...',
            saved_success: 'Einstellungen erfolgreich gespeichert',
            load_error: 'Gespeicherte Einstellungen konnten nicht geladen werden. Standardeinstellungen werden angezeigt – Änderungen werden gespeichert, wenn Sie auf Speichern klicken.',
            enabled: 'Aktiviert',
            disabled: 'Deaktiviert',
            unwatch: 'Unwatch',
        },
        admin_queue: {
            title: 'Benachrichtigungs-Administrationswarteschlange',
            description: 'E-Mail-Zustellstatus überwachen und fehlgeschlagene Nachrichten erneut senden',
            load_error: 'E-Mail-Warteschlangendaten konnten nicht geladen werden',
            retry_error: 'E-Mail konnte nicht erneut gesendet werden',
            filter_status: 'Nach Status filtern',
            all_statuses: 'Alle',
            refresh: 'Aktualisieren',
            status_queued: 'In Warteschlange',
            status_sent: 'Gesendet',
            status_failed: 'Fehlgeschlagen',
            status_bounced: 'Zurückgewiesen',
            col_recipient: 'Empfänger',
            col_category: 'Kategorie',
            col_template: 'Vorlage',
            col_status: 'Status',
            col_retries: 'Wiederholungen',
            col_created: 'Erstellt',
            col_sent: 'Gesendet am',
            col_actions: 'Aktionen',
            no_items: 'Keine E-Mail-Warteschlangeneinträge gefunden',
            retry: 'Erneut versuchen',
            retrying: 'Wird erneut versucht...',
            prev: 'Zurück',
            next: 'Weiter',
            access_denied_title: 'Administratorzugang erforderlich',
            access_denied: 'Diese Seite ist nur für Administratoren verfügbar. Bitte kontaktieren Sie Ihren Administrator, wenn Sie Zugang benötigen.',
            announce_queue_loaded: 'E-Mail-Warteschlange geladen, [[TOK_1]] Elemente',
            announce_processed: 'Verarbeitete [[TOK_1]] E-Mail(s)',
            process_now: 'Jetzt verarbeiten',
            processing_ellipsis: 'Verarbeitung…',
        },
    },
    ui_assist: {
        toolbar: {
            title: 'UI-Assistent',
            activate: 'Aktivieren',
            deactivate: 'Deaktivieren',
            connected: 'Verbunden',
            disconnected: 'Nicht verbunden',
            disconnected_hint: 'Nicht verbunden – führen Sie „npm run Relay“ aus, um eine Verbindung zur Claude-CLI herzustellen',
            open_panel: 'Öffnen Sie das UI Assist-Panel',
            history: 'Geschichte',
            settings: 'Einstellungen',
        },
        prompt: {
            placeholder: 'Beschreiben Sie die Änderung, die Sie vornehmen möchten ...',
            send: 'Senden',
            cancel: 'Abbrechen',
            char_count: '[[TOK_2]] / [[TOK_3]]',
        },
        session: {
            streaming: 'Verarbeitung…',
            complete: 'Komplett',
            error: 'Fehler',
            abort: 'Abbruch',
            abort_confirm: 'Sind Sie sicher, dass Sie den Vorgang abbrechen möchten?',
            aborted_hint: 'Sitzung wurde unterbrochen — Sie können von hier aus fortfahren.',
            undo: 'Rückgängig machen',
            redo: 'Wiederholen',
            retry: 'Versuchen Sie es noch einmal',
            dismiss: 'Entlassen',
        },
        label: {
            component: 'Komponente',
            element: 'Element',
            file: 'Datei',
        },
        response: {
            you: 'You',
            claude: 'Claude',
            empty: 'Noch keine Nachrichten. Wählen Sie Elemente aus und senden Sie eine Aufforderung, um loszulegen.',
        },
        panel: {
            tab_conversation: 'Chatten',
            tab_tasks: 'Aufgaben',
            tab_sprint: 'Sprint',
            tab_sessions: 'Sitzungen',
            tab_lobby: 'Lobby',
            follow_up: 'Follow-up',
            followup_placeholder: 'Stellen Sie eine Folgefrage ...',
            interrupt_placeholder: 'Eingabe zum Unterbrechen und Umleiten…',
            send_interrupt: 'Senden & Unterbrechen',
            will_interrupt: 'Bricht die aktuelle Antwort ab und sendet stattdessen diese',
            expand: 'Auf Vollbild erweitern',
            collapse: 'Auf Seitenleiste verkleinern',
            no_sessions: 'Keine vorherigen Sitzungen. Wählen Sie Elemente aus und senden Sie eine Anweisung.',
            session_active: 'Aktiv',
            session_ended: 'Beendet',
            session_messages: '{count} Nachrichten',
            switch_session: 'Zu dieser Sitzung wechseln',
            load_session: 'Sitzungsverlauf laden',
            session_restored: 'Sitzung aus dem Verlauf wiederhergestellt',
            archive_session: 'Archivsitzung',
            archive_confirm: 'Diese Sitzung archivieren? Die Sitzungsdatei wird gelöscht.',
            new_session: 'Neue Sitzung',
            new_session_desc: 'Verwenden Sie „Aktivieren“, um ein UI-Element auszuwählen und eine neue Sitzung zu starten',
            start_new_session: 'Neue Sitzung starten',
            no_active_session_chat: 'Starten Sie eine neue Sitzung oder wählen Sie mit „Aktivieren“ ein UI-Element auf der Seite aus, um zu beginnen.',
            no_active_session_tasks: 'Starten Sie eine neue Sitzung oder wählen Sie eine bestehende Sitzung aus, um Aufgaben zu erstellen.',
            no_active_session_sprint: 'Starten Sie eine neue Sitzung oder wählen Sie eine bestehende Sitzung aus, um einen Sprint zu planen.',
            previous_sessions: 'Frühere Sitzungen',
        },
        tasks: {
            none_found: 'In der Antwort wurden keine Aufgaben gefunden. Bitten Sie Claude, Aufgaben vorzuschlagen.',
            selected: 'selected',
            create_selected: 'Erstellen Sie Aufgaben',
            execute_tasks: 'Aufgaben ausführen',
            creating: 'Erstellen…',
            created: 'Aufgaben erstellt',
            create_error: 'Aufgabe konnte nicht erstellt werden',
            plan_sprint: 'Sprint planen',
            priority_critical_desc: 'Blocker — sofort beheben',
            priority_high_desc: 'Wichtig — in diesem Sprint lösen',
            priority_medium_desc: 'Normal — für kommenden Sprint planen',
            priority_low_desc: 'Optional — Backlog-Kandidat',
            add_custom: 'Aufgabe hinzufügen',
            add_title_placeholder: 'Aufgabentitel…',
            add_desc_placeholder: 'Beschreibung (optional)',
            add_save: 'Hinzufügen',
            add_cancel: 'Abbrechen',
        },
        sprint: {
            title: 'Sprint-Planer',
            assigned: 'assigned',
            new_placeholder: 'Sprintname (z. B. Sprint 18.1.0)',
            add: 'Add',
            backlog: 'Rückstand',
            move_to: 'Umzug nach…',
            empty: 'Erstellen Sie eine Sprintgruppe und weisen Sie ihr Aufgaben zu.',
            create_all: 'Alle Aufgaben erstellen',
            remove: 'Entfernen',
            drop_here: 'Weisen Sie Aufgaben aus dem Backlog unten zu',
            add_task: 'Aufgabe aus Backlog hinzufügen…',
        },
        feature_disabled: 'UI Assist ist nicht aktiviert',
        permission_denied: 'Sie sind nicht berechtigt, UI Assist zu verwenden',
    },
    license: {
        title: 'Lizenz & Paket',
        current_license: 'Aktuelle Lizenz',
        license_key: 'Lizenzschlüssel',
        activate: 'Lizenz aktivieren',
        deactivate: 'Lizenz deaktivieren',
        validate_now: 'Jetzt validieren',
        status: 'Lizenzstatus',
        active: 'Aktiv',
        expired: 'Abgelaufen',
        suspended: 'Suspendiert',
        invalid: 'Ungültig',
        pending: 'Ausstehend',
        no_license: 'Keine Lizenz',
        expires_at: 'Läuft ab',
        last_validated: 'Zuletzt validiert',
        domain: 'Lizenzierte Domain',
        activation_success: 'Lizenz erfolgreich aktiviert.',
        activation_failed: 'Die Lizenzaktivierung ist fehlgeschlagen.',
        domain_mismatch: 'Die Lizenzdomäne stimmt nicht mit der aktuellen Domäne überein.',
        deactivation_success: 'Lizenz deaktiviert.',
        validation_success: 'Lizenz erfolgreich validiert.',
        validation_failed: 'Die Lizenzvalidierung ist fehlgeschlagen.',
        enter_key: 'Geben Sie Ihren Lizenzschlüssel ein',
        confirm_deactivate: 'Sind Sie sicher, dass Sie diese Lizenz deaktivieren möchten? Modulbeschränkungen gelten basierend auf der Standardstufe.',
    },
    package_mgmt: {
        title: 'Paket',
        module_column: 'Modul',
        current_tier: 'Aktuelles Paket',
        light: 'Licht',
        standard: 'Standard',
        enterprise_unlimited: 'Enterprise Unlimited',
        change_package: 'Paket ändern',
        upgrade: 'Upgrade',
        downgrade: 'Downgrade',
        target_tier: 'Zielpaket',
        new_license_key: 'Lizenzschlüssel für Zielpaket',
        confirm_change: 'Bestätigen Sie die Paketänderung',
        change_success: 'Paket erfolgreich geändert.',
        change_failed: 'Paketänderung fehlgeschlagen.',
        modules_included: 'Module enthalten',
        modules_restricted: 'Im aktuellen Paket nicht verfügbar',
        upgrade_to_enable: 'Führen Sie ein Upgrade durch, um dieses Modul zu aktivieren.',
        module_availability: 'Modulverfügbarkeit',
        comparison: 'Paketvergleich',
        power_users: 'Power-User',
        unlimited: 'Unbegrenzt',
        impact_warning: 'Durch ein Downgrade werden die folgenden Module deaktiviert:',
        invalid_license: 'Der bereitgestellte Lizenzschlüssel ist für dieses Paket nicht gültig.',
        tier_mismatch: 'Der Lizenzschlüssel gilt für eine andere Paketstufe.',
    },
    board_report: {
        title: 'Vorstandsbericht zur Compliance',
        subtitle: 'Zusammenfassung der Compliance über alle Module',
        date_from: 'Von Datum',
        date_to: 'Bis Datum',
        language: 'Berichtssprache',
        generate: 'Bericht erstellen',
        generating: 'Bericht wird erstellt...',
        download_pdf: 'PDF herunterladen',
        close: 'Bericht schließen',
        open_board_report: 'Vorstandsbericht erstellen',
        close_board_report: 'Vorstandsbericht schließen',
        report_period: 'Berichtszeitraum',
        generated_at: 'Erstellt am',
        generated_by: 'Erstellt von',
        organization: 'Organisation',
        section_rights_requests: 'Rechtsanfragen',
        section_vendors: 'Lieferanten',
        section_dpias: 'DSFAs',
        section_consent: 'Einwilligungsrichtlinien',
        section_data_mapping: 'Datenzuordnung',
        section_incidents: 'Vorfälle',
        section_classification: 'Datenklassifizierung',
        section_governance: 'Regierungsführung',
        open: 'Offen',
        closed: 'Geschlossen',
        sla_compliance: 'SLA-Einhaltung',
        total: 'Gesamt',
        expired_dpa: 'Abgelaufene DPA',
        high_risk: 'Hohes Risiko',
        completed: 'Abgeschlossen',
        overdue: 'Überfällig',
        policies_active: 'Aktive Richtlinien',
        coverage: 'Abdeckung',
        systems: 'Systeme',
        completeness: 'Vollständigkeit',
        avg_resolution_days: 'Durchschn. Lösungszeit (Tage)',
        labeled: 'Gekennzeichnet',
        unlabeled_systems: 'Ungekennzeichnete Systeme',
        compliance_score: 'Compliance-Bewertung',
        drift_events_open: 'Offene Abweichungen',
        no_data: 'Keine Daten für den ausgewählten Zeitraum verfügbar.',
        error_date_range: 'Bitte wählen Sie sowohl Start- als auch Enddatum.',
        table_category: 'Kategorie',
        table_metric: 'Kennzahl',
        table_value: 'Wert',
        showing_chart_view: 'Diagrammansicht wird angezeigt',
        showing_table_view: 'Datentabellenansicht wird angezeigt',
        error_generate: 'Vorstandsbericht konnte nicht erstellt werden.',
        playbook_evidence_title: 'Nachweise für Playbook-Ausführungen',
        playbook_evidence_description: 'Ausführungsaktivität pro Playbook und angehängte Nachweisdateien für den Berichtszeitraum.',
        playbook_name: 'Spielbuch',
        playbook_execution_count: 'Ausführungen',
        playbook_steps_total: 'Schritte',
        playbook_steps_required: 'Nachweis erforderlich',
        playbook_steps_attached: 'Nachweis angehängt',
        playbook_coverage_pct: 'Abdeckung',
        playbook_evidence_files: 'Nachweisdateien',
        playbook_no_evidence: 'Keine Playbook-Ausführungen in diesem Zeitraum.',
        playbook_download_file: 'Datei herunterladen',
    },
    framework_module_links: {
        title: 'Rahmenverknüpfung',
        modules: 'Verknüpfte Module',
        add_module: 'Modul hinzufügen',
        module_code: 'Modulcode',
        required: 'Erforderlich',
        notes: 'Notizen',
        link: 'Verknüpfen',
        no_modules: 'Keine Module verknüpft',
        personas: 'Verknüpfte Personas',
        add_persona: 'Persona hinzufügen',
        persona_id: 'Persona-ID',
        role_description: 'Rollenbeschreibung',
        no_personas: 'Keine Personas verknüpft',
    },
    framework_channels: {
        title: 'Einreichungskanäle & Fristen',
        channels: 'Einreichungskanäle',
        add_channel: 'Kanal hinzufügen',
        channel_type: 'Typ',
        name: 'Name',
        instructions: 'Anweisungen',
        active: 'Aktiv',
        no_channels: 'Keine Einreichungskanäle konfiguriert',
        portal: 'Portal',
        in_person: 'Persönlich',
        postal: 'Post',
        email: 'E-Mail',
        add: 'Hinzufügen',
        deadlines: 'Regulatorische Fristen',
        add_deadline: 'Frist hinzufügen',
        label: 'Bezeichnung',
        days: 'Tage',
        day_type: 'Tagestyp',
        calendar_days: 'Kalendertage',
        working_days: 'Arbeitstage',
        description: 'Beschreibung',
        no_deadlines: 'Keine Fristen konfiguriert',
    },
    regulatory_updates: {
        title: 'Regulatorische Aktualisierungen & Rahmen-Dashboard',
        coverage_dashboard: 'Rahmenabdeckungs-Dashboard',
        no_frameworks: 'Keine Rahmenwerke gefunden',
        framework: 'Rahmenwerk',
        status: 'Status',
        modules: 'Module',
        templates: 'Vorlagen',
        forms: 'Formulare',
        channels: 'Kanäle',
        deadlines: 'Fristen',
        pending: 'Ausstehende Aktualisierungen',
        updates: 'Regulatorische Aktualisierungen',
        create_update: 'Aktualisierung erstellen',
        framework_id: 'Rahmenwerk-ID',
        update_title: 'Titel',
        description: 'Beschreibung',
        effective_date: 'Gültigkeitsdatum',
        create: 'Erstellen',
        no_updates: 'Keine regulatorischen Aktualisierungen',
        impact: 'Auswirkung',
        assess: 'Bewerten',
    },
    module_tips: deModuleTips,
    framework_rights: {
        be_informed: 'Recht auf Information',
        consent: 'Recht auf Einwilligung',
        refuse_consent: 'Recht auf Verweigerung der Einwilligung',
        withdraw_consent: 'Recht auf Widerruf der Einwilligung',
        access: 'Auskunftsrecht',
        rectification: 'Recht auf Berichtigung',
        data_provision: 'Recht auf Datenbereitstellung',
        deletion: 'Recht auf Löschung',
        restriction_of_processing: 'Recht auf Einschränkung der Verarbeitung',
        object_to_processing: 'Widerspruchsrecht',
        complaint: 'Recht auf Beschwerde',
        denunciation: 'Recht auf Anzeige',
        lawsuit: 'Recht auf Klageerhebung',
        claim_damages: 'Recht auf Schadensersatz',
        request_protection_measures: 'Recht auf Schutzmaßnahmen',
    },
    framework_content: {
        EU_EPRIVACY_DIRECTIVE: {
            display_name: 'Richtlinie 2002/58/EG (ePrivacy-Richtlinie)',
            description: 'Übergeordnete Richtlinie für nationale ePrivacy-Umsetzungen. Deckt Cookies, Datenschutz bei elektronischer Kommunikation und Direktmarketing ab. Jeder Mitgliedsstaat muss es in nationales Recht umsetzen.',
        },
        EU_GDPR: {
            display_name: 'Datenschutz-Grundverordnung (EU) 2016/679',
            description: 'Die Datenschutz-Grundverordnung ([[TOK_0]]) ist eine EU-Verordnung zum Datenschutz und zur Privatsphäre. Es gilt unmittelbar in allen EU-/EWR-Mitgliedsstaaten.',
        },
        EU_NIS2_DIRECTIVE: {
            display_name: 'Richtlinie (EU) 2022/2555 ([[TOK_0]])',
            description: 'Übergeordnete Richtlinie für nationale [[TOK_0]]-Umsetzungen. Deckt das Cybersicherheitsrisikomanagement, die Meldung von Vorfällen und die Sicherheit der Lieferkette für wesentliche und wichtige Unternehmen ab.',
        },
        VN_AI_LAW_2026: {
            display_name: 'Vietnamesisches [[TOK_0]] Gesetz ([[TOK_1]]) – gültig ab 1. März 2026',
            description: 'Vietnam [[TOK_0]] Gesetz (Luật Trí tuệ nhân tạo [[TOK_2]]), das die Entwicklung, den Einsatz und die Nutzung von Systemen der künstlichen Intelligenz regelt. Legt Risikoklassifizierung, Transparenz- und Kennzeichnungspflichten, Anforderungen zur Meldung von Vorfällen, Verpflichtungen zur Folgenabschätzung und einen Mechanismus für kontrollierte Tests (Sandbox) für [[TOK_1]]-Aktivitäten in Vietnam fest.',
        },
        VN_AI_DECREE_142_2026: {
            display_name: 'Decree 142/2026/NĐ-CP — [[TOK_0]] Law Implementation',
            description: 'Decree 142/2026/NĐ-CP (Nghị định số 142/2026/NĐ-CP) detailing certain articles and implementing measures of the Vietnam [[TOK_0]] Law (Law 134/2025/QH15). Issued 2026-04-30, effective 2026-05-01. Lead authority: Ministry of Science and Technology. Operationalises [[TOK_0]] risk classification, classification dossier, reclassification review, high-risk conformity assessment, high-risk risk-management system, transparency / explanation / technical marking / visible labeling, serious [[TOK_0]] incident reporting (72h / 5wd / 15d), state-agency [[TOK_0]] impact assessment (Mẫu AI02), and the controlled testing / [[TOK_0]] sandbox lifecycle (Mẫu AI03a-AI09b). Submission via the [[TOK_0]] one-stop e-portal or MoST transitional channel. No statutory fines.',
        },
        VN_CYBERSEC_LAW: {
            display_name: 'Vietnamesisches Cybersicherheitsgesetz (Ära 24/2018)',
            description: 'Vietnams Gesetz zur Cybersicherheit (Gesetz Nr. [[TOK_0]]), das Anforderungen für Cybersicherheit, Datenlokalisierung und Vorfallmeldung festlegt. Aktiv bis zur Aufhebung durch Gesetz [[TOK_1]] mit Wirkung zum 01.07.2026.',
        },
        VN_CYBERSEC_DECREE_53: {
            display_name: 'Dekret 53 – Umsetzung des Cybersicherheitsgesetzes',
            description: 'Dekret [[TOK_0]] zur Umsetzung des Cybersicherheitsgesetzes, das die Festlegung des Geltungsbereichs, Auslöser für die Datenlokalisierung, Anforderungen an die lokale Präsenz und Arbeitsabläufe bei der Zusammenarbeit mit Behörden umfasst.',
        },
        VN_CYBERSEC_LAW_2025: {
            display_name: 'Gesetz zur Cybersicherheit ([[TOK_0]])',
            description: 'Vietnams konsolidiertes Gesetz zur Cybersicherheit (Gesetz [[TOK_0]]), das das Gesetz [[TOK_1]] ersetzt und am 1. Juli 2026 in Kraft tritt. Konsolidiert den Geltungsbereich des Dekrets [[TOK_2]]Đ-CP (siehe VN_CYBERSEC_DECREE_53).',
        },
        VN_DATA_LAW: {
            display_name: 'Vietnamesisches Datengesetz',
            description: 'Das vietnamesische Datengesetz (Gesetz [[TOK_0]] legt umfassende Daten-Governance-Anforderungen fest, einschließlich Dateninventur, -klassifizierung, Sharing-Governance und grenzüberschreitender Datentransfer-Governance. Überschneidungen mit VN_PDPL_LAW_2025 (Aspekte personenbezogener Daten) und VN_CYBERSEC_LAW_2025 (Datenlokalisierung/-klassifizierung).',
        },
        VN_DATA_LAW_DECREE_165_2025: {
            display_name: 'Dekret [[TOK_0]]Đ-CP (Umsetzung des Datengesetzes)',
            description: 'Dekret [[TOK_0]]Đ-CP zur Umsetzung des vietnamesischen Datengesetzes (Gesetz [[TOK_1]]). Bietet offizielle Formulare für die Folgenabschätzung der grenzüberschreitenden Datenübertragung, die jährliche Risikobewertungsberichterstattung und den Zugriff auf nationale Datenbanken. Definiert 11 offizielle Mẫu-Số-Formen.',
        },
        VN_DATA_EXCHANGES_DRAFT_2026: {
            display_name: 'Entwurf eines Dekrets über den Betrieb von Datenbörsen 2026',
            description: 'Entwurf eines Erlasses über den Betrieb von Datenaustauschplattformen (Dự thảo Nghị định quy định về hoạt động của sàn dữ liệu). Reguliert die Plattformklassifizierung, die Teilnehmerberechtigung, die Kontrolle der Auflistung von Datenprodukten und -diensten, Sandbox-Tests, den Transaktionsablauf, elektronische Vertragsabschlüsse, Bescheinigungen von Eigentumsrechten an Daten und die Bearbeitung von Beschwerden/Streitigkeiten. Derzeit in öffentlicher Konsultation; noch nicht verkündet. Zitiert das Gesetz über Daten [[TOK_0]], das Gesetz über den Schutz personenbezogener Daten [[TOK_1]], das Gesetz über Cybersicherheit [[TOK_2]] und das Gesetz über elektronische Transaktionen [[TOK_3]].',
        },
        VN_ECOMMERCE_LAW_2025: {
            display_name: 'Gesetz zum elektronischen Geschäftsverkehr ([[TOK_0]])',
            description: 'Vietnamesisches Gesetz über den elektronischen Handel (Luật Thương mại điện tử [[TOK_0]]), das ein einheitliches nationales System für den elektronischen Handel festlegt und den inländischen und grenzüberschreitenden Plattformbetrieb, Plattform-Governance und -Rechenschaftspflicht, Verbraucherschutz, Verkäufer- und Affiliate-Kontrollen, Beschwerdebearbeitung, Inhaltsmoderation und Durchsetzung der Löschung sowie die Vorbereitung von Verwaltungsverfahren für das staatliche E-Commerce-Managementsystem abdeckt.',
        },
        VN_PDPL: {
            display_name: 'Vietnam [[TOK_0]] (Ära Dekret 13/2023)',
            description: 'Das vietnamesische Dekret zum Schutz personenbezogener Daten (Dekret [[TOK_0]] legt umfassende Datenschutzanforderungen fest. Legacy-Rahmen – ersetzt durch Gesetz [[TOK_1]] und Dekret [[TOK_2]] mit Wirkung zum 01.01.2026.',
        },
        VN_PDPD_DECREE_13: {
            display_name: 'Dekret 13 – [[TOK_0]] Betriebsbasislinie',
            description: 'Dekret [[TOK_1]], das operative Instrument für [[TOK_0]] Aufgaben, einschließlich Dossiereinreichung, Governance-Artefakte, grenzüberschreitende Mechanismen und MoPS-Verwaltungsverfahren. Ersetzt durch Dekret [[TOK_2]] mit Wirkung zum 01.01.2026.',
        },
        VN_PDPL_LAW_2025: {
            display_name: 'Gesetz zum Schutz personenbezogener Daten ([[TOK_0]])',
            description: 'Das vietnamesische Gesetz zum Schutz personenbezogener Daten (Gesetz [[TOK_2]] legt einen umfassenden Rahmen für den Schutz personenbezogener Daten fest und tritt am 1. Januar 2026 in Kraft. Deckt die Compliance-Themen A–J ab: rechtmäßige Verarbeitungsgrundlagen, Einwilligung zu sensiblen Daten, Rechte betroffener Personen (Zugriff/Berichtigung/Löschung/Einschränkung/Einspruch/Übertragbarkeit), Benachrichtigung von Verstößen an Behörden und betroffene Personen, [[TOK_0]] für die Verarbeitung mit hohem Risiko, Steuerung der grenzüberschreitenden Übertragung, [[TOK_1]] Benennung, Aufzeichnungen über Verarbeitungstätigkeiten, vertragliche Pflichten des Auftragsverarbeiters. Behördliche Einreichungspflichten über MoPS (VN_PDPL_ADMIN_PROCEDURES_778_2026). Querverweise: VN_PDPL_DECREE_356_2025 (Durchführungsverordnung), VN_CYBERSEC_LAW_2025 (Cybersicherheitsüberschneidungen), VN_DATA_LAW (Datenverwaltung).',
        },
        VN_PDPL_DECREE_356_2025: {
            display_name: 'Dekret [[TOK_1]] ([[TOK_0]] Umsetzung)',
            description: 'Dekret [[TOK_0]] zur Umsetzung des Gesetzes zum Schutz personenbezogener Daten, das das Dekret [[TOK_1] ersetzt. Deckt die Einreichung von Dossiers, Governance-Artefakte, grenzüberschreitende Mechanismen und die Zertifizierung von Dienstleistern ab. Anhang Formularverzeichnis: Abschnitte I–VIII (Folgenabschätzung, grenzüberschreitende Übertragung, Zertifizierung). MoPS-Verwaltungsverfahren über VN_PDPL_ADMIN_PROCEDURES_778_2026 (Entscheidung 778/QĐ-BCA-A05). Zertifizierungsablauf: Antrag → Ausstellung → Änderungsantrag → Neuausstellung → Widerruf. Querverweise: VN_PDPL_LAW_2025 (übergeordnetes Recht), VN_CYBERSEC_LAW_2025 (Datenlokalisierung), VN_DATA_LAW (Überschneidungen bei der Datenverwaltung).',
        },
        VN_PDPL_ADMIN_PROCEDURES_778_2026: {
            display_name: '[[TOK_0]] A05 Verwaltungsverfahren (Entscheidung 778/QĐ-BCA-A05)',
            description: 'Entscheidung 778/QĐ-BCA-A05 (Februar 2026) – Verwaltungsverfahren zum Schutz personenbezogener Daten gemäß A05 ([[TOK_0]]). Definiert Verfahren zur Einreichung, Verarbeitung und Ausgabe von Dossiers, einschließlich DLCN-HC-Formularen und gesetzlich vorgeschriebenen Formularen.',
        },
        VN_PDPL_ENFORCEMENT_DRAFT_2026: {
            display_name: 'Entwurf des Vollstreckungsbeschlusses 2026',
            description: 'Entwurf eines Dekrets zur Durchsetzung und Sanktionierung von Verstößen gegen das Gesetz zum Schutz personenbezogener Daten (Gesetz [[TOK_0]]). Definiert Strafrahmen, erschwerende/mildernde Faktoren und Durchsetzungsverfahren. Derzeit im Entwurfsstatus, bis zur Veröffentlichung.',
        },
        VN_MOPS_ADMIN_SIMPLIFICATION_NQ22_2026: {
            display_name: 'Government Resolution NQ22/2026 — MoPS Administrative Simplification (Temporary Overlay)',
            description: 'Temporary procedural overlay (effective 2026-04-29, expiring 2027-03-01) introducing three official channels (National Public Service Portal, direct submission to MoPS, postal submission to MoPS) for [[TOK_0]] Decree 356/2025 and Decision 778/2026 dossier submissions. Email is NOT a NQ22 official channel — a separate unofficial email-ZIP submission guidance ([[TOK_0]]_GUIDANCE_EMAIL_ZIP_DOSSIER_SUBMISSION_2026) is shipped with requires_legal_review: true. Procedural overlay only — does NOT alter substantive obligations, fine ranges, or the binding force of underlying frameworks. Review task scheduled 2027-02-01.',
        },
        VN_TELECOM_LAW_2023: {
            display_name: 'Vietnamesisches Telekommunikationsgesetz 2023',
            description: 'Vietnamesisches Telekommunikationsgesetz 2023 (Luật Viễn thông), ein Sektor-Overlay für Telekommunikations-/ISP-/Plattformunternehmen mit Verpflichtungen zur Vertraulichkeit, Offenlegungskontrolle und zur Bearbeitung behördlicher Anfragen. Querverweise: VN_CYBERSEC_LAW_2025 (Informationssystemsicherheit), VN_PDPL_LAW_2025 (Benutzerdatenverarbeitung), VN_DATA_LAW (Datenverwaltung).',
        },
        VN_TELECOM_DECREE_163_2024: {
            display_name: 'Dekret [[TOK_0]]Đ-CP (Umsetzung des Telekommunikationsgesetzes)',
            description: 'Dekret [[TOK_0]]Đ-CP zur Umsetzung des Telekommunikationsgesetzes (Gesetz [[TOK_1]]). Bietet offizielle Formulare für die Meldung von Telekommunikationsdiensten, die Lizenzierung, die Registrierung und die Entwicklungspläne für Rechenzentren. Definiert 7 offizielle Mẫu-Số-Formen.',
        },
    },
    framework_requirements: {
        d163_r4: {
            title: 'Einreichung des Entwicklungsplans für ein Rechenzentrum',
            description: 'Entwicklungspläne für Rechenzentren müssen bei der zuständigen Behörde gemäß dem Dekret [[TOK_0]]Đ-CP eingereicht werden.',
        },
        d163_r3: {
            title: 'Registrierung von Telekommunikationsdiensten',
            description: 'Die Anmeldung von Telekommunikationsdiensten ist unter Verwendung des vorgeschriebenen Formulars bei der zuständigen Behörde einzureichen.',
        },
        d163_r2: {
            title: 'Antrag auf Telekommunikationslizenz',
            description: 'Anträge auf Telekommunikationslizenzen müssen unter Verwendung des vorgeschriebenen Formulars gemäß dem Dekret [[TOK_0]]Đ-CP eingereicht werden.',
        },
        d163_r1: {
            title: 'Benachrichtigung über die Bereitstellung von Telekommunikationsdiensten',
            description: 'Anbieter von Telekommunikationsdiensten müssen die Leistungserbringung vor Beginn der Dienstleistung der zuständigen Behörde unter Verwendung des vorgeschriebenen Formulars anzeigen.',
        },
        vn_dp_draft_f: {
            title: 'Beschwerden, Streitigkeiten und Risikomanagement',
            description: 'Plattformbetreiber müssen die Aufnahme von Beschwerden, einen Arbeitsablauf zur Streitbeilegung mit Beweissicherung, Risikoerkennung und Frühwarnkontrollen sowie eine regelmäßige Überprüfung der Datenschutz-, Cybersicherheits- und Zugriffsverwaltungsrisiken gewährleisten.',
        },
        vn_dp_draft_e: {
            title: 'Transaktionsablauf und Bescheinigung der Eigentumsrechte an Daten',
            description: 'Für Transaktionen sind eine Kontoregistrierung, eine Auflistungsgenehmigung, ein elektronischer Vertragsabschluss, eine Zahlungsbestätigung, ein Lieferprotokoll und gegebenenfalls die Ausstellung einer Bescheinigung über Eigentumsrechte an den Daten erforderlich. Der Transaktionsverlauf und die Rückverfolgbarkeit müssen in einem Transaktionsregister aufbewahrt werden.',
        },
        vn_dp_draft_d: {
            title: 'Sandbox- und Testumgebungskontrollen',
            description: 'Testumgebungen müssen isoliert, zugriffsbeschränkt, sicherheitsüberwacht und überprüft werden, bevor eine Ausgabe extrahiert wird. Es dürfen keine Quelldaten aus der Testumgebung extrahiert werden und der Abschluss/die Bereinigung von Testsitzungen muss aufgezeichnet werden.',
        },
        vn_dp_draft_c: {
            title: 'Steuerelemente für die Datenprodukt- und Serviceauflistung',
            description: 'Listings müssen durch rechtmäßige Quellen- und Eigentums-/Nutzungsnachweise, technische Validierungsaufzeichnungen, Qualitätsoffenlegungen sowie plattformseitige Listing-Überprüfungs- und Genehmigungsaufzeichnungen gestützt werden. Unzulässige Daten müssen vor der Auflistung gefiltert werden.',
        },
        vn_dp_draft_b: {
            title: 'Teilnehmerberechtigung und Onboarding',
            description: 'Plattformbetreiber müssen den Rechtsstatus, die Geschäftsfähigkeit und die Geschäftsvoraussetzungen für Verkäufer und Käufer überprüfen, Transaktions- und Zahlungskonten registrieren und ein Teilnehmerregister führen.',
        },
        vn_dp_draft_a: {
            title: 'Klassifizierung und Betriebsmodell der Datenplattform',
            description: 'Plattformbetreiber müssen eine Klassifizierung des Plattformtyps festlegen (nationale Datenplattform im Vergleich zu anderen Datenplattformen), die Berechtigung und Verantwortlichkeiten der Betreiber festlegen sowie Preise, Gebühren, Betriebsregeln und technische Governance dokumentieren.',
        },
        d165_r5: {
            title: 'Zugriff auf nationale Datenbankinformationen',
            description: 'Für Anträge auf Extraktion/Nutzung von Informationen aus der nationalen Datenbank für digitale Daten sind vorgeschriebene Formulare erforderlich (siehe Abschnitt 07a/07b).',
        },
        d165_r4: {
            title: 'Jährliche Berichterstattung über die Risikobewertung',
            description: 'Jährliche Risikobewertungsberichte müssen unter Verwendung der vorgeschriebenen Formulare eingereicht werden (siehe Abschnitt 05a/05b, 06).',
        },
        d165_r3: {
            title: 'Kündigungsmitteilung für grenzüberschreitende Überweisungen',
            description: 'Die Beendigung des grenzüberschreitenden Transfers muss unter Verwendung der vorgeschriebenen Formulare (siehe Abschnitt 04a/04b) mitgeteilt werden.',
        },
        d165_r2: {
            title: 'Benachrichtigung über das Bewertungsergebnis',
            description: 'Die Behörde stellt Bescheide über die Beurteilungsergebnisse unter Verwendung des vorgeschriebenen Formulars aus (siehe Abschnitt 03).',
        },
        d165_r1: {
            title: 'Einreichung einer Folgenabschätzung für die grenzüberschreitende Datenübertragung',
            description: 'Organisationen müssen Dossiers zur Folgenabschätzung für grenzüberschreitende Datenübermittlungen/-verarbeitungen unter Verwendung vorgeschriebener Formulare einreichen (siehe Abschnitt 01a/01b, 02).',
        },
        a964190d_8d1d_4284_bc7d_4023e2866751: {
            title: 'Einwilligung für Cookies und ähnliche Technologien',
            description: 'Das Speichern von oder der Zugriff auf Informationen auf einem Endgerät ist nur mit vorheriger Einwilligung nach Aufklärung gestattet, es sei denn, es handelt sich um eine technisch notwendige Speicherung.',
        },
        '8437d96d_cf01_4f87_89f6_4faaf8eefdf6': {
            title: 'Vertraulichkeit der Kommunikation',
            description: 'Die Mitgliedstaaten gewährleisten die Vertraulichkeit der Kommunikation und der damit verbundenen Verkehrsdaten über ein öffentliches Kommunikationsnetz und öffentlich zugängliche elektronische Kommunikationsdienste.',
        },
        c5420073_50c6_4981_816a_398460e5f546: {
            title: 'Einwilligung zum Direktmarketing (Opt-in)',
            description: 'Die Nutzung elektronischer Kommunikationssysteme für Direktmarketing bedarf der vorherigen Zustimmung des Abonnenten.',
        },
        c8bf67d2_874b_4647_92d7_39aaa3230819: {
            title: 'Soft-Opt-In für Bestandskunden',
            description: 'Direktmarketing an Bestandskunden für ähnliche Produkte/Dienstleistungen ist ohne Zustimmung gestattet, wenn ein Opt-out vorgesehen ist.',
        },
        b546df40_9217_4204_b71c_5af5022a0ff9: {
            title: 'Benachrichtigung bei Verstößen für Telekommunikationsanbieter',
            description: 'Anbieter öffentlich zugänglicher elektronischer Kommunikationsdienste müssen der zuständigen nationalen Behörde Verstöße gegen den Schutz personenbezogener Daten melden.',
        },
        '5bd66ae4_dee3_4611_9104_71742df55484': {
            title: 'Widerspruchsrecht gegen Direktmarketing',
            description: 'Den Abonnenten wird die Möglichkeit eingeräumt, dem Erhalt von Direktmarketing-Nachrichten jederzeit und kostenfrei zu widersprechen.',
        },
        a10af31f_ba28_494e_ab50_f8679e86a0b0: {
            title: 'Speicherung und Löschung von Verkehrsdaten',
            description: 'Verkehrsdaten von Teilnehmern und Nutzern müssen gelöscht oder anonymisiert werden, wenn sie für die Übertragung nicht mehr benötigt werden, mit Ausnahme von Abrechnungs- oder Zusammenschaltungszahlungen.',
        },
        '8577e60f_66a8_4651_8336_d561db9929ad': {
            title: 'Bedingungen für die Verarbeitung von Standortdaten',
            description: 'Andere Standortdaten als Verkehrsdaten dürfen nur in anonymisierter Form oder mit Einwilligung des Nutzers im erforderlichen Umfang und für die erforderliche Dauer verarbeitet werden.',
        },
        '7f3abb41_8713_4276_93b5_6902f419a016': {
            title: 'Rechtmäßigkeit der Verarbeitung – Einwilligung',
            description: 'Die Verarbeitung ist nur dann rechtmäßig, wenn die betroffene Person der Verarbeitung ihrer personenbezogenen Daten für einen oder mehrere bestimmte Zwecke zugestimmt hat.',
        },
        '1c2a945a_8eac_428d_8105_e80e95288ea4': {
            title: 'Rechtmäßigkeit der Verarbeitung – Vertrag',
            description: 'Die Verarbeitung ist für die Erfüllung eines Vertrages, dessen Vertragspartei die betroffene Person ist, erforderlich.',
        },
        '2b50c0fb_ee96_412e_a092_c3c1f3f817e8': {
            title: 'Rechtmäßigkeit der Verarbeitung – gesetzliche Verpflichtung',
            description: 'Die Verarbeitung ist zur Erfüllung einer rechtlichen Verpflichtung erforderlich, der der Verantwortliche unterliegt.',
        },
        '702ea760_9e5c_4c32_babc_0b5094ca9735': {
            title: 'Rechtmäßigkeit der Verarbeitung – lebenswichtige Interessen',
            description: 'Die Verarbeitung ist erforderlich, um lebenswichtige Interessen der betroffenen Person oder einer anderen natürlichen Person zu schützen.',
        },
        '8b55ce88_2d5e_467b_a55c_8c5b0efab67e': {
            title: 'Rechtmäßigkeit der Verarbeitung – öffentliches Interesse',
            description: 'Die Verarbeitung ist für die Wahrnehmung einer Aufgabe erforderlich, die im öffentlichen Interesse liegt oder in Ausübung öffentlicher Gewalt erfolgt.',
        },
        '8a72dd16_ee3c_4947_b5cd_9484719adad8': {
            title: 'Rechtmäßigkeit der Verarbeitung – berechtigte Interessen',
            description: 'Die Verarbeitung ist zur Wahrung berechtigter Interessen des Verantwortlichen oder eines Dritten erforderlich.',
        },
        afefc965_8f83_4d75_a9fc_92d4d4f549d6: {
            title: 'Verarbeitung besonderer Kategorien (sensible Daten)',
            description: 'Die Verarbeitung besonderer Kategorien personenbezogener Daten (Rassenherkunft, politische Meinungen, Gesundheit usw.) ist untersagt, sofern keine besonderen Voraussetzungen in Art. 9(2) erfüllt sind.',
        },
        '10a2d63f_744d_4222_91f6_86a5a4cdaefd': {
            title: 'Bedingungen für die Einwilligung',
            description: 'Der Verantwortliche muss nachweisen, dass die Einwilligung erteilt wurde. Die Einwilligung muss freiwillig, konkret, informiert und eindeutig erfolgen. Der Widerruf muss so einfach sein wie die Erteilung der Einwilligung.',
        },
        '27697f99_efef_49e6_b8e7_c2dc550d1791': {
            title: 'Einwilligung des Kindes – digitale Dienste',
            description: 'Für die Verarbeitung personenbezogener Daten eines Kindes unter 16 Jahren (oder einem vom Mitgliedstaat festgelegten niedrigeren Alter, nicht unter 13 Jahren) ist für die Nutzung von Diensten der Informationsgesellschaft die Zustimmung der Eltern erforderlich.',
        },
        '53883480_508e_4f8e_984f_9354c18de285': {
            title: 'Transparente Information und Kommunikation',
            description: 'Der Verantwortliche stellt Informationen über die Verarbeitung in prägnanter, transparenter, verständlicher und leicht zugänglicher Form zur Verfügung.',
        },
        b5eb22b7_78f2_4c55_b342_827d5f8ac90c: {
            title: 'Informationen zur Direktabholung',
            description: 'Werden personenbezogene Daten von der betroffenen Person erhoben, stellt der Verantwortliche zum Zeitpunkt der Erhebung konkrete Informationen bereit.',
        },
        e55f7dbf_cd2a_4713_887e_8c64744e2d95: {
            title: 'Informationen zur indirekten Erhebung',
            description: 'Sofern die personenbezogenen Daten nicht von der betroffenen Person erhoben wurden, muss der Verantwortliche innerhalb einer angemessenen Frist bestimmte Informationen bereitstellen.',
        },
        '6bc5ec07_0589_4593_882a_13f41c31e1f6': {
            title: 'Zugangsrecht',
            description: 'Die betroffene Person hat das Recht, eine Bestätigung der Verarbeitung und Zugang zu den personenbezogenen Daten sowie ergänzende Informationen zu erhalten.',
        },
        '0e011e25_dcea_4a1e_ae55_583e683cea44': {
            title: 'Recht auf Berichtigung',
            description: 'Die betroffene Person hat das Recht, unverzüglich die Berichtigung unrichtiger personenbezogener Daten zu verlangen.',
        },
        e8ec5a55_f657_4a99_9b92_3e9861067d28: {
            title: 'Recht auf Löschung (Recht auf Vergessenwerden)',
            description: 'Die betroffene Person hat das Recht, bei Vorliegen bestimmter Gründe die unverzügliche Löschung personenbezogener Daten zu verlangen.',
        },
        '5b0c92fd_cd08_47be_bfd2_0540ad73f84f': {
            title: 'Recht auf Einschränkung der Verarbeitung',
            description: 'Die betroffene Person hat das Recht, unter bestimmten Voraussetzungen eine Einschränkung der Verarbeitung zu verlangen.',
        },
        '3b829862_39f4_41be_8f2b_d469469a801b': {
            title: 'Mitteilungspflicht – Berichtigung/Löschung/Einschränkung',
            description: 'Der Verantwortliche teilt allen Empfängern, denen die Daten mitgeteilt wurden, jede Berichtigung, Löschung oder Einschränkung mit.',
        },
        '9cf34be6_121b_4fdf_ad7c_c4773696522e': {
            title: 'Recht auf Datenübertragbarkeit',
            description: 'Die betroffene Person hat das Recht, ihre personenbezogenen Daten in einem strukturierten, gängigen und maschinenlesbaren Format zu erhalten.',
        },
        becae433_90b9_4cc0_bd33_df50976c1561: {
            title: 'Widerspruchsrecht',
            description: 'Die betroffene Person hat das Recht, der Verarbeitung aufgrund von öffentlichem Interesse oder berechtigten Interessen, einschließlich Profiling, zu widersprechen.',
        },
        '4ef387f1_439c_4579_82a3_01565e6dc05d': {
            title: 'Automatisierte individuelle Entscheidungsfindung, einschließlich Profiling',
            description: 'Die betroffene Person hat das Recht, nicht einer ausschließlich auf einer automatisierten Verarbeitung beruhenden Entscheidung unterworfen zu werden, die rechtliche oder ähnlich erhebliche Wirkung entfaltet.',
        },
        '667ae5eb_a39a_4809_a032_923cc804eaed': {
            title: 'Verstoßmeldung an Aufsichtsbehörde (72h)',
            description: 'Im Falle einer Verletzung des Schutzes personenbezogener Daten muss der Verantwortliche die Aufsichtsbehörde innerhalb von 72 Stunden nach Kenntniserlangung benachrichtigen, es sei denn, es ist unwahrscheinlich, dass dies zu einem Risiko führt.',
        },
        '40e4c2ad_bc85_436c_814f_265f02c8c3b1': {
            title: 'Meldung von Verstößen an betroffene Personen (hohes Risiko)',
            description: 'Wenn ein Verstoß voraussichtlich ein hohes Risiko für Rechte und Freiheiten mit sich bringt, teilt der Verantwortliche der betroffenen Person den Verstoß unverzüglich mit.',
        },
        '9dbb47bd_172f_4335_b7f3_4558476c4192': {
            title: 'Antwort auf Anfragen betroffener Personen (30 Tage)',
            description: 'Der Verantwortliche antwortet auf Anfragen betroffener Personen unverzüglich und innerhalb eines Monats nach Erhalt, bei komplexen Anfragen um zwei weitere Monate verlängerbar.',
        },
        '175d16b7_a0fc_44ff_bb9e_5ccb5d3de5a9': {
            title: 'Datenschutz-Folgenabschätzung',
            description: 'Wenn die Verarbeitung voraussichtlich ein hohes Risiko für Rechte und Freiheiten mit sich bringt, führt der Verantwortliche vor der Verarbeitung eine [[TOK_0]] durch.',
        },
        e54a7b09_33dd_4cda_8e21_d10a51e5e925: {
            title: 'Vorherige Rücksprache mit der Aufsichtsbehörde',
            description: 'Der Verantwortliche muss die Aufsichtsbehörde konsultieren, wenn ein [[TOK_0]] darauf hinweist, dass die Verarbeitung ohne Abhilfemaßnahmen zu einem hohen Risiko führen würde.',
        },
        '047b7838_bae5_4861_9c38_c99fedec9c96': {
            title: '[[TOK_0]] Pflichtverarbeitungsliste',
            description: '[[TOK_0]] wird für die systematische Bewertung/Profilierung, die groß angelegte Verarbeitung spezieller Kategorien und die systematische Überwachung öffentlicher Bereiche benötigt.',
        },
        aa08dc83_7c1a_441d_a8e7_960f65c8de87: {
            title: 'Aufzeichnungen über Verarbeitungstätigkeiten (Verantwortlicher)',
            description: 'Jeder Verantwortliche führt ein Verzeichnis der Verarbeitungsaktivitäten in seinem Verantwortungsbereich, einschließlich Zwecken, Kategorien, Empfängern, Übermittlungen und Aufbewahrung.',
        },
        b7eb6296_5962_449c_b267_d322d7919122: {
            title: 'Aufzeichnungen über Verarbeitungstätigkeiten (Auftragsverarbeiter)',
            description: 'Jeder Auftragsverarbeiter muss ein Verzeichnis aller Kategorien von Verarbeitungstätigkeiten führen, die im Auftrag eines Verantwortlichen durchgeführt werden.',
        },
        '0d57e6d5_bbf5_4ea6_9a89_0f57bed61b5b': {
            title: 'Sicherheit der Verarbeitung',
            description: 'Verantwortlicher und Auftragsverarbeiter ergreifen geeignete technische und organisatorische Maßnahmen, um eine dem Risiko angemessene Sicherheit zu gewährleisten.',
        },
        ad85edfc_3c92_4ce4_a414_3ba6186cae98: {
            title: 'Datenschutz durch Technikgestaltung und durch datenschutzfreundliche Voreinstellungen',
            description: 'Der Verantwortliche muss geeignete Maßnahmen ergreifen, um sicherzustellen, dass nur personenbezogene Daten verarbeitet werden, die für den jeweiligen Zweck erforderlich sind (Datenminimierung).',
        },
        '933b438d_53b8_4b6a_b1db_8e7f1b429ede': {
            title: 'Benennung des Datenschutzbeauftragten',
            description: 'Verantwortlicher und Auftragsverarbeiter benennen einen [[TOK_0]], wenn die Verarbeitung von einer Behörde durchgeführt wird, eine regelmäßige und systematische Überwachung oder eine groß angelegte Verarbeitung besonderer Kategorien umfasst.',
        },
        '28810a5d_d818_411a_9e8c_792d1b2c9b2f': {
            title: 'Allgemeiner Grundsatz für Überweisungen',
            description: 'Eine Übermittlung personenbezogener Daten in ein Drittland erfolgt nur unter Einhaltung der Voraussetzungen des Kapitels V.',
        },
        '60add64b_bb0c_44e7_baaf_666af65b2d0f': {
            title: 'Übertragungen auf der Grundlage einer Angemessenheitsentscheidung',
            description: 'Eine Übermittlung kann erfolgen, wenn die Kommission entschieden hat, dass das Drittland ein angemessenes Schutzniveau gewährleistet.',
        },
        cde8c7cd_3727_40ce_a321_e6b72b335179: {
            title: 'Übermittlungen unterliegen angemessenen Sicherheitsvorkehrungen',
            description: 'Liegt kein Angemessenheitsbeschluss vor, können Übermittlungen stattfinden, sofern geeignete Sicherheitsvorkehrungen getroffen werden, einschließlich Standardvertragsklauseln oder BCRs.',
        },
        '0e8edaa1_2156_44d9_95f2_1b284f581658': {
            title: 'Standardvertragsklauseln',
            description: 'Von der Kommission oder einer Aufsichtsbehörde angenommene Standardvertragsklauseln bieten angemessene Garantien für internationale Übermittlungen.',
        },
        '608a8de7_6c75_4f88_bd4c_1cc308780ab9': {
            title: 'Verbindliche Unternehmensregeln',
            description: 'Verbindliche Unternehmensregeln, die von einer zuständigen Aufsichtsbehörde genehmigt wurden, bieten angemessene Schutzmaßnahmen für konzerninterne internationale Transfers.',
        },
        '420ced80_0d3b_4a28_adad_14ba54df3e40': {
            title: 'Ausnahmen für bestimmte Situationen',
            description: 'In Ermangelung angemessener oder sicherer Maßnahmen können Übermittlungen auf der Grundlage einer ausdrücklichen Einwilligung, einer vertraglichen Notwendigkeit, eines öffentlichen Interesses, eines Rechtsanspruchs, lebenswichtiger Interessen oder eines öffentlichen Registers erfolgen.',
        },
        c86fbc0d_7188_486c_8ea5_96b3fe957c6f: {
            title: 'Verantwortung und Schulung des Leitungsorgans',
            description: 'Die Leitungsorgane wesentlicher und wichtiger Einrichtungen müssen Maßnahmen zum Risikomanagement im Bereich der Cybersicherheit genehmigen und sich regelmäßigen Schulungen unterziehen.',
        },
        ffb95a09_993c_4db0_a4bb_c48000e43b33: {
            title: 'Maßnahmen zum Risikomanagement im Bereich der Cybersicherheit',
            description: 'Wesentliche und wichtige Einrichtungen müssen geeignete und verhältnismäßige technische, betriebliche und organisatorische Maßnahmen ergreifen, um Cybersicherheitsrisiken zu bewältigen.',
        },
        '6a7c8c8f_4b81_4b47_adb7_c6abd12acd4b': {
            title: 'Richtlinien und Verfahren zur Behandlung von Vorfällen',
            description: 'Unternehmen müssen Richtlinien zur Behandlung von Vorfällen implementieren, einschließlich Erkennungs-, Analyse-, Eindämmungs- und Reaktionsverfahren.',
        },
        de019eab_9992_4361_be7c_3e592f209d76: {
            title: 'Geschäftskontinuität und Krisenmanagement',
            description: 'Unternehmen müssen Maßnahmen zur Geschäftskontinuität umsetzen, einschließlich Backup-Management, Notfallwiederherstellung und Krisenmanagement.',
        },
        '6b5f482f_301c_4f69_bd91_f9ae1b21de6c': {
            title: 'Sicherheit der Lieferkette',
            description: 'Unternehmen müssen sich mit sicherheitsrelevanten Aspekten der Beziehungen zu Direktlieferanten und Dienstleistern befassen, einschließlich der Risikobewertung der Lieferkette.',
        },
        c8e7738b_358c_4c79_9fc2_a564f15a6e37: {
            title: 'Sicherheit in Netzwerk- und Informationssystemen',
            description: 'Unternehmen müssen Sicherheit bei der Beschaffung, Entwicklung und Wartung von Netzwerk- und Informationssystemen implementieren, einschließlich der Handhabung von Schwachstellen.',
        },
        '72520ed1_51ff_4983_a785_9be1f72cf7dd': {
            title: 'Umgang mit und Offenlegung von Sicherheitslücken',
            description: 'Unternehmen müssen Richtlinien und Verfahren für die koordinierte Offenlegung und Handhabung von Schwachstellen implementieren.',
        },
        f009e65d_d55e_4c98_9532_63c150694698: {
            title: 'Wirksamkeit der Cybersicherheitsrisikobewertung',
            description: 'Unternehmen müssen Richtlinien und Verfahren implementieren, um die Wirksamkeit von Maßnahmen zum Risikomanagement im Bereich der Cybersicherheit zu bewerten.',
        },
        '00e88824_675d_4b37_960c_757b3176c079': {
            title: 'Kryptografie und Verschlüsselungsrichtlinien',
            description: 'Unternehmen müssen Richtlinien und Verfahren für den Einsatz von Kryptografie und gegebenenfalls Verschlüsselung implementieren.',
        },
        de29d287_81f1_46b1_b327_9cbf06ddad3d: {
            title: 'Personalsicherheit, Zugangskontrolle, Asset-Management',
            description: 'Die Unternehmen müssen Personalsicherheit, Zugangskontrollrichtlinien und Vermögensverwaltung implementieren.',
        },
        '750f4459_9ba4_415e_bc47_5b0ec27d35a2': {
            title: 'Multi-Faktor-Authentifizierung',
            description: 'Unternehmen müssen Multi-Faktor-Authentifizierungs- oder kontinuierliche Authentifizierungslösungen, gesicherte Sprach-/Video-/Textkommunikation und gesicherte Notfallkommunikationssysteme verwenden.',
        },
        '359474f9_1820_4e3e_9031_a593b66ccde4': {
            title: 'Frühwarnung an CSIRT (24h)',
            description: 'Unternehmen müssen dem zuständigen CSIRT innerhalb von 24 Stunden, nachdem sie von einem erheblichen Vorfall Kenntnis erlangt haben, eine Frühwarnung übermitteln.',
        },
        '66acd92c_3091_4148_b935_68b0d24308e7': {
            title: 'Vorfallmeldung an CSIRT (72h)',
            description: 'Unternehmen müssen dem zuständigen CSIRT innerhalb von 72 Stunden nach Kenntnisnahme eines erheblichen Vorfalls eine Vorfallmeldung übermitteln.',
        },
        '68269688_06b2_43ea_8e3e_a84532086557': {
            title: 'Abschlussbericht an CSIRT (1 Monat)',
            description: 'Unternehmen müssen dem zuständigen CSIRT spätestens einen Monat nach der Meldung des Vorfalls einen Abschlussbericht vorlegen.',
        },
        c8512bde_b064_4926_b333_06b9c95cecd7: {
            title: 'Anwendbarkeitsbestimmung für [[TOK_0]] Aktivitäten',
            description: 'Stellen Sie fest, ob die Organisation [[TOK_0]] Aktivitäten durchführt, die dem vietnamesischen [[TOK_1]]-Gesetz unterliegen, und dokumentieren Sie die Entscheidung über die Anwendbarkeit.',
        },
        '3a87ad63_179a_45ba_8743_98d865df80ab': {
            title: '[[TOK_0]] Klassifizierung des Systemrisikos nach Risikostufe',
            description: 'Klassifizieren Sie jedes [[TOK_0]]-System nach Risikostufe (minimal, begrenzt, hoch, inakzeptabel) mithilfe der geführten Klassifizierungsmethode.',
        },
        '0f4475d3_77a6_4b41_bfe2_d4b299b1bd45': {
            title: '[[TOK_0]] Pflege des Systemregistereintrags',
            description: 'Führen Sie ein Register von [[TOK_0]] Systemen mit Systemname, Eigentümer, Zweck, Bereitstellungskontext, Risikostufe und Anbieterbeteiligung.',
        },
        '2a73ce94_906a_4c95_8a45_a5bdf2a8118c': {
            title: '[[TOK_0]] Systemdossier mit Artefakt-Checkliste und Beweisen',
            description: 'Erstellen und pflegen Sie ein Systemdossier mit der erforderlichen Artefakt-Checkliste, der Beweisbibliothek und dem Versionsverlauf.',
        },
        e92cfb42_d91b_444f_adbc_c03903844eac: {
            title: 'Transparenzpflichten für [[TOK_0]] Systembetreiber',
            description: 'Implementieren Sie Transparenzmaßnahmen für [[TOK_0]]-Systeme, einschließlich Benutzerbenachrichtigung, Offenlegung der Beteiligung von [[TOK_1]] und Systemdokumentation.',
        },
        '45eb43d7_9b63_4166_aa0d_fa6aeeaa70ba': {
            title: '[[TOK_0]] Ausgabekennzeichnung, Wasserzeichen und Metadatensignatur',
            description: 'Implementieren Sie Kennzeichnung und Wasserzeichen für von [[TOK_0]] generierte Inhalte, einschließlich ggf. Metadatensignierung.',
        },
        '9566c94d_0dd3_419c_869f_6707d2a972f9': {
            title: 'Offenlegungspflichten für von [[TOK_0]] generierte Inhalte',
            description: 'Teilen Sie Benutzern mit, wenn Inhalte von [[TOK_0]] generiert werden, und stellen Sie Mechanismen bereit, mit denen Benutzer die Beteiligung von [[TOK_1]] identifizieren können.',
        },
        '21d39ea5_df78_45c6_8710_b203db229e25': {
            title: 'Erklärbarkeit und nutzerorientierte Transparenzpflichten',
            description: 'Bereitstellung erklärbarer Ergebnisse für [[TOK_0]] Entscheidungen, die Einzelpersonen betreffen, und Pflege einer benutzerorientierten Transparenzdokumentation.',
        },
        f523fbc2_156d_466d_ad50_6a0c51b3ac9d: {
            title: 'Menschliche Aufsichtspflichten für Hochrisiko-[[TOK_0]]-Systeme',
            description: 'Stellen Sie sicher, dass menschliche Aufsichtsmechanismen für Systeme mit hohem Risiko [[TOK_0]] vorhanden sind, einschließlich Eskalations- und Außerkraftsetzungsfunktionen.',
        },
        bd180a89_4976_4790_9e50_f1c5c97dc576: {
            title: '[[TOK_0]] Überwachung und Erkennung von Vorfällen',
            description: 'Implementieren Sie Überwachungsfunktionen, um [[TOK_0]] Systemvorfälle, Fehlfunktionen und unerwünschte Ergebnisse zu erkennen.',
        },
        e7c1c60b_856c_4d3d_b6c9_092cde9b56bd: {
            title: 'Schwerwiegender [[TOK_0]] Vorfall, der der Behörde gemeldet wird',
            description: 'Melden Sie schwerwiegende [[TOK_0]] Vorfälle innerhalb der vorgeschriebenen Frist (72 Stunden) der zuständigen Behörde.',
        },
        '97f15adc_558a_49f2_bb06_86597cb9579b': {
            title: '[[TOK_0]] Einhaltung des Zeitplans für Vorfallbenachrichtigungen',
            description: 'Halten Sie die Benachrichtigungsfristen für [[TOK_0]] Vorfälle ein, einschließlich Erstbenachrichtigung, Aktualisierungen und Abschlussberichte.',
        },
        '96c33d7e_fe52_4730_adac_70c8c477c88e': {
            title: '[[TOK_0]] Folgenabschätzung für Hochrisikosysteme',
            description: 'Führen Sie Folgenabschätzungen für Systeme mit hohem Risiko [[TOK_0]] durch, die Risiken, Abhilfemaßnahmen, menschliche Aufsicht und Überwachungspläne abdecken.',
        },
        '0f3b72c0_1030_44ff_ba53_596f45601cd7': {
            title: 'Kontrollierte Tests/Sandbox-Berechtigungsbestimmung',
            description: 'Bestimmen Sie die Eignung für die Teilnahme an kontrollierten Tests (Sandbox) und dokumentieren Sie die Eignungsbewertung.',
        },
        '4a6aed20_f655_4182_a760_aef1f329d5df': {
            title: 'Sandbox-Antragseinreichung und Genehmigungsverfolgung',
            description: 'Senden Sie Sandbox-Anträge an die zuständige Behörde und verfolgen Sie den Genehmigungsstatus während des gesamten Einreichungslebenszyklus.',
        },
        '8376988d_cd32_491e_a5b8_3340d3973358': {
            title: 'Sandbox-Überwachungskontrollpunkte und Abschluss/Beendigung',
            description: 'Führen Sie während der Sandbox-Teilnahme regelmäßige Überwachungskontrollpunkte durch und erstellen Sie Abschluss-/Abschlussberichte.',
        },
        '7cb2b544_0512_4702_a092_9f1c10872376': {
            title: 'Kennzeichnung der Ausnahme-/Ausnahmedokumentation mit Begründung',
            description: 'Dokumentieren Sie etwaige Befreiungen oder Ausnahmen von der Kennzeichnung mit Begründung und Belegen.',
        },
        dccd7fbf_872a_4716_87a4_b9c5ce8e2387: {
            title: 'Datenlokalisierung für vietnamesische Benutzer',
            description: 'Daten vietnamesischer Nutzer über in Vietnam bereitgestellte Dienste müssen auf dem Territorium Vietnams gespeichert werden.',
        },
        '9eb86a03_e165_4963_8813_2272b638d529': {
            title: 'Meldung von Cybersicherheitsvorfällen',
            description: 'Cybersicherheitsvorfälle müssen den zuständigen Behörden rechtzeitig gemeldet werden.',
        },
        '736ac7de_7a6a_4bfd_b2be_c594e290038a': {
            title: 'Klassifizierung von Informationssystemen',
            description: 'Informationssysteme müssen nach Wichtigkeitsstufen klassifiziert und geeignete Sicherheitsmaßnahmen angewendet werden.',
        },
        ffb807cf_f121_4b52_8e50_e091c33180c9: {
            title: 'Risikobewertung der Cybersicherheit',
            description: 'Für Informationssysteme müssen regelmäßig Risikobewertungen zur Cybersicherheit durchgeführt werden.',
        },
        a4de518b_a5f1_481f_9b08_f8d2bc9db7e5: {
            title: 'Bestimmung innerhalb des Geltungsbereichs (Entscheidungsbaum)',
            description: 'Organisationen müssen mithilfe des vorgeschriebenen Entscheidungsbaums feststellen, ob sie in den Geltungsbereich des Dekrets 53 fallen.',
        },
        '01f99e9a_5e30_4d14_aae5_a2ce322a700b': {
            title: 'Bewertung und Vorbereitung der Datenlokalisierung',
            description: 'Organisationen müssen die Anforderungen an die Datenlokalisierung bewerten und ihre Bereitschaft nachweisen.',
        },
        cf24f011_dc23_4d84_aef5_994dde440571: {
            title: 'Checkliste für die Speicher- und Aufbewahrungsbereitschaft',
            description: 'Zur Einhaltung der Datenlokalisierung muss eine Checkliste für die Speicher- und Aufbewahrungsbereitschaft ausgefüllt werden.',
        },
        b3884cb8_c785_4258_9517_9e393be4f4e1: {
            title: 'Beurteilung des örtlichen Präsenzbedarfs',
            description: 'Organisationen müssen beurteilen, ob lokale Präsenzanforderungen gelten, und entsprechend planen.',
        },
        c1dc645b_cb1a_42a6_8ca5_9b15cfa84156: {
            title: 'Erhalt und Überprüfung der Anforderung durch die Behörde',
            description: 'Behördenanfragen müssen gemäß den vorgeschriebenen Verfahren entgegengenommen, überprüft und bearbeitet werden.',
        },
        d4571651_f39d_4c51_8f2d_7248c37f7b14: {
            title: 'Antwort der Behörde auf Anfrage innerhalb der Frist',
            description: 'Auf behördliche Anfragen muss innerhalb der vorgeschriebenen Frist geantwortet werden.',
        },
        '66c1df70_3456_40e9_b645_6c6bd3be702e': {
            title: 'Protokoll zur Bearbeitung von Behördenanfragen',
            description: 'Es muss ein Protokoll aller Aktivitäten zur Bearbeitung behördlicher Anfragen geführt werden.',
        },
        '04bbba2a_9804_4199_a517_054b6f4689fb': {
            title: 'Anwendbarkeit und In-Scope-Bestimmung (konsolidiert)',
            description: 'Organisationen müssen feststellen, ob sie in den Geltungsbereich des konsolidierten Cybersicherheitsgesetzes fallen, das sowohl den Geltungsbereich des alten Gesetzes 24/2018 als auch des Dekrets 53/2022 abdeckt.',
        },
        '89a21eaf_cf09_4fec_bbb4_a1dadd652f6e': {
            title: 'Klassifizierung des Informationssystems nach Wichtigkeitsstufe',
            description: 'Informationssysteme müssen nach Wichtigkeitsstufen (allgemein, wichtig, kritisch) mit entsprechenden Sicherheitspflichten klassifiziert werden.',
        },
        '83ad981e_23ff_4a92_bebd_cd24487e912f': {
            title: 'Governance-Struktur für Cybersicherheit und verantwortliches Personal',
            description: 'Organisationen müssen Governance-Strukturen für Cybersicherheit einrichten und verantwortliches Personal benennen.',
        },
        '98d9a523_fefb_400b_bb7f_ebaf609a6ed4': {
            title: 'Regelmäßige Risikobewertung der Cybersicherheit',
            description: 'Für alle Verschlusssachensysteme müssen regelmäßige Cybersicherheitsrisikobewertungen durchgeführt werden.',
        },
        '5236539f_4c1a_4eff_b2eb_fc11eb4eab23': {
            title: 'Sicherheitsmaßnahmen pro Informationssystemklassifizierung',
            description: 'Für jede Klassifizierungsstufe des Informationssystems müssen geeignete technische Sicherheitsmaßnahmen angewendet werden.',
        },
        b69a8be2_ae0c_408c_b8f1_73b573eca876: {
            title: 'Zugangskontrolle und Identitätsmanagement',
            description: 'Für Informationssysteme müssen Maßnahmen zur Zugangskontrolle und zum Identitätsmanagement implementiert werden.',
        },
        ac774c26_feb7_4123_b799_c54f77bd87b5: {
            title: 'Protokollierung, Überwachung und Audit-Trail',
            description: 'Informationssysteme müssen über Protokollierungs-, Überwachungs- und Audit-Trail-Funktionen verfügen.',
        },
        a86cb01d_239b_44e2_9e09_e6973bcf9658: {
            title: 'Schwachstellenmanagement und Patching',
            description: 'Schwachstellenmanagement- und Patching-Prozesse müssen eingerichtet und aufrechterhalten werden.',
        },
        '826a789f_0c03_4918_81a1_6aa1cc2c205c': {
            title: 'Datenlokalisierung für vietnamesische Benutzerdaten',
            description: 'Daten vietnamesischer Nutzer über in Vietnam bereitgestellte Dienste müssen auf dem Territorium Vietnams gespeichert werden.',
        },
        '8bee2b51_ace8_4118_89c8_010b96640016': {
            title: 'Lokale Präsenzanforderungen für ausländische Dienstleister',
            description: 'Ausländische Dienstleister, die in Vietnam tätig sind, müssen wie vorgeschrieben eine lokale Präsenz aufrechterhalten.',
        },
        '74d89250_b45f_41b6_bfe3_f915071580de': {
            title: 'Lokale Speicherarchitektur und grenzüberschreitende Flussdokumentation',
            description: 'Die lokale Speicherarchitektur muss dokumentiert und grenzüberschreitende Datenflüsse abgebildet und kontrolliert werden.',
        },
        '04dec6f8_3280_494c_8506_292804b16d4d': {
            title: 'Erkennung und Reaktion auf Cybersicherheitsvorfälle',
            description: 'Organisationen müssen über die Fähigkeit verfügen, Cybersicherheitsvorfälle zu erkennen und darauf zu reagieren.',
        },
        faeda71b_5050_497d_b08b_e3f3f5313ad4: {
            title: 'Obligatorische Vorfallmeldung an die zuständige Behörde',
            description: 'Qualifizierte Cybersicherheitsvorfälle müssen innerhalb der vorgeschriebenen Fristen an [[TOK_1]]/[[TOK_0]] gemeldet werden.',
        },
        d732b5a2_2b2c_48a0_955d_97a39daf132d: {
            title: 'Einhaltung des Zeitplans für die Meldung von Vorfällen',
            description: 'Vorfallmeldungen müssen den vorgeschriebenen Fristen entsprechen (Erstmeldung innerhalb von 24 Stunden, vollständige Meldung innerhalb von 72 Stunden).',
        },
        '8e2dffb0_3481_44f0_baf2_130ddd8cfe12': {
            title: 'Bearbeitung und Zusammenarbeit von Behördenanfragen',
            description: 'Behördenanfragen müssen zeitnah bearbeitet werden und die Zusammenarbeit muss gemäß den vorgeschriebenen Verfahren erfolgen.',
        },
        e4c5b870_1d61_48fe_a6c2_1b9f5a458ea3: {
            title: 'Fallregister und Offenlegungsprotokoll für behördliche Anfragen',
            description: 'Alle behördlichen Anfragen und Offenlegungen müssen in einem Fallregister mit vollständigem Prüfprotokoll protokolliert werden.',
        },
        '8eff8b17_65bc_4f94_8ece_c509a9fd9abb': {
            title: 'Sicherheitsbewertung von Anbietern und Dritten',
            description: 'Drittanbieter mit Zugriff auf Informationssysteme müssen sich einer Sicherheitsbewertung unterziehen.',
        },
        '69891e1b_97f6_464c_9cce_b1276794fe4a': {
            title: 'Kontrollen für den Zugriff auf Lieferantendaten und die Benachrichtigung über Vorfälle',
            description: 'Der Zugriff auf Lieferantendaten muss dokumentiert und vertragliche Pflichten zur Meldung von Vorfällen festgelegt werden.',
        },
        d89b6bc0_7a9e_4816_b31e_7c0abc02e90c: {
            title: 'Schulungen und Übungen zum Sicherheitsbewusstsein',
            description: 'Es müssen regelmäßig Schulungen zur Sensibilisierung für Cybersicherheit und Tabletop-Übungen durchgeführt werden.',
        },
        f9c5d3cc_5bb2_4b30_a5fb_ada34e407981: {
            title: 'Regelmäßiger Pentest und Sicherheitsaudit',
            description: 'Für vertrauliche Informationssysteme müssen regelmäßige Penetrationstests und Sicherheitsüberprüfungen durchgeführt werden.',
        },
        '88dd9877_d2e2_4e41_a248_ae39b1ff478f': {
            title: 'Pflegen Sie den digitalen Datenbestand',
            description: 'Unternehmen müssen ein umfassendes digitales Dateninventar führen, in dem alle Datenbestände katalogisiert werden.',
        },
        '18e4bfd1_42cf_4d87_870f_5a34242962ef': {
            title: 'Datenklassifizierung nach Sensibilität und Wichtigkeit',
            description: 'Daten müssen entsprechend der im Datengesetz festgelegten Sensibilitäts- und Wichtigkeitsstufen klassifiziert werden.',
        },
        b89981ac_7559_46f9_a74c_a143976dde4e: {
            title: 'Definieren Sie Handhabungsregeln nach Klassifizierungsstufe',
            description: 'Für jede Datenklassifizierungsebene müssen Handhabungsregeln festgelegt werden.',
        },
        '3bf8019d_b72c_41d7_82cf_fc367efd9526': {
            title: 'Verfolgen Sie den Datenaustausch und die Offenlegung mit Genehmigungen',
            description: 'Alle Datenaustausch- und Offenlegungsaktivitäten müssen mit entsprechenden Genehmigungen nachverfolgt werden.',
        },
        '8623eca2_4cf9_41bd_bfbd_2300c06ca1f3': {
            title: 'Governance der grenzüberschreitenden Datenübertragung',
            description: 'Grenzüberschreitende Datenübermittlungen müssen den Governance-Anforderungen des Datengesetzes entsprechen.',
        },
        '006b8aa6_9379_4eff_b8ab_935f9a087601': {
            title: 'Behalten Sie Governance-Richtlinien und Verantwortlichkeiten bei',
            description: 'Organisationen müssen Daten-Governance-Richtlinien einhalten und Governance-Verantwortlichkeiten zuweisen.',
        },
        f12fc090_5c3e_4fa8_9813_74bea0359c5c: {
            title: 'Jährliche Governance-Bescheinigung',
            description: 'Zur Bestätigung der fortlaufenden Einhaltung muss eine jährliche Governance-Bescheinigung ausgefüllt werden.',
        },
        f6c3060a_5e52_4f97_b1af_c6a5f00bfaee: {
            title: 'Datenrisikobewertung',
            description: 'Um Daten-Governance-Risiken zu identifizieren und zu mindern, muss eine Datenrisikobewertung durchgeführt werden.',
        },
        '6f228998_1c61_49cf_a585_3d3e9baff55a': {
            title: 'Verantwortungs- und Governance-Verpflichtungen des Plattformbetreibers',
            description: 'Richten Sie Rechenschaftsstrukturen für Plattformbetreiber ein, einschließlich Governance-Richtlinien, Überwachungsverantwortlichkeiten und Durchsetzungspflichten.',
        },
        eee1d423_3783_4530_bc64_eef6fd9d02dc: {
            title: 'Plattformregeln für die Veröffentlichung und Transparenz von Informationen',
            description: 'Veröffentlichen Sie Plattformregeln, Handelsbedingungen und betriebliche Offenlegungen auf transparente und zugängliche Weise.',
        },
        '50b57433_7a51_4e92_9c84_c748d6865b70': {
            title: 'E-Commerce-Verkaufswebsite/App-Benachrichtigung an MOIT',
            description: 'Senden Sie eine Benachrichtigung an MOIT für E-Commerce-Verkaufswebsites und -anwendungen über Online.gov.vn oder bestimmte Kanäle.',
        },
        '92854abe_6654_4155_8495_f3419a8a8da0': {
            title: 'E-Commerce-Dienstplattform-/Marktplatzregistrierung bei MOIT',
            description: 'Registrieren Sie E-Commerce-Dienstleistungsplattformen und Marktplätze bei MOIT, einschließlich Dossiereinreichung und Genehmigungsverfolgung.',
        },
        b8bff437_805e_4a4a_a62e_89cb90b89d3f: {
            title: 'Führung des Verkäuferregisters (Inland und Ausland)',
            description: 'Führen Sie ein Register aller Verkäufer auf der Plattform, einschließlich in- und ausländischer Verkäufer, mit Onboarding, Verifizierung und Lebenszyklusverfolgung.',
        },
        '75778639_5235_4d13_a728_fa772c27fc0c': {
            title: 'Livestream-Verkäuferregister und Compliance-Kontrollen',
            description: 'Führen Sie ein Verzeichnis der Livestream-Verkäufer mit Identitätsprüfung, Aktivitätsverfolgung und Compliance-Kontrollen.',
        },
        '405f2932_742a_4bcb_9784_1a3d81f2e714': {
            title: 'Affiliate- und Marketingpartnerregister',
            description: 'Führen Sie ein Verzeichnis von Affiliate-Vermarktern und Empfehlungspartnern mit Vertragsstatus, Inhaltsrichtlinien und Compliance-Bestätigungen.',
        },
        cce5a4eb_a576_459c_95b5_bdd0e8ed30a8: {
            title: 'Produktauflistung und Durchsetzung verbotener/bedingter Waren',
            description: 'Implementieren Sie Produktlistenkontrollen, einschließlich der Überprüfung, Überwachung und Durchsetzung verbotener und bedingter Waren.',
        },
        '9fc01e19_18dd_4d60_b95a_c1f4bcdbb6ae': {
            title: 'Verbraucherbeschwerden werden mit Eingang, Maßnahmen und Prüfpfad registriert',
            description: 'Führen Sie ein Beschwerderegister mit Aufnahmeaufzeichnungen, Untersuchungsmaßnahmen, Lösungsergebnissen und einem vollständigen Prüfprotokoll.',
        },
        '8a21764e_e5f4_4934_9913_c235f4c462ca': {
            title: 'Beschwerdebearbeitungsverfahren und Lösungsfristen',
            description: 'Richten Sie Verfahren zur Beschwerdebearbeitung mit definierten Zeitplänen für die Bestätigung, Untersuchung und Lösung ein.',
        },
        '8406373c_ec31_4bf8_810f_72d9d73b3de8': {
            title: 'Moderation, Überwachung und Durchsetzung von Deaktivierungen von Inhalten',
            description: 'Implementieren Sie Verfahren zur Moderation, Überwachung und Entfernung von Inhalten für illegale, verbotene oder rechtsverletzende Inhalte.',
        },
        '6f32c315_323b_4ce6_a4bb_3262a5b56afe': {
            title: 'Registrierung von Lösch- und Durchsetzungsmaßnahmen mit Beweissicherung',
            description: 'Führen Sie ein Register der Lösch- und Durchsetzungsmaßnahmen mit Entscheidungsaufzeichnungen, Beweissicherung und Verkäuferbenachrichtigungen.',
        },
        c0bbbfbf_29bd_4813_89f1_956eab9f1a23: {
            title: 'Plattformrichtlinien und Offenlegungsregister (Versionen, Veröffentlichungsdaten, Akzeptanz)',
            description: 'Führen Sie ein Register der Plattformrichtlinien und Offenlegungen mit Versionsverlauf, Veröffentlichungsdaten und Akzeptanznachweisen.',
        },
        c9fcbe90_622d_43ca_9ec6_db26c0eda490: {
            title: 'Verbraucherinformationspflichten – genaue Produktinformationen und Schutz vor Täuschung',
            description: 'Sorgen Sie für genaue, klare Produkt- und Serviceinformationen und ergreifen Sie Maßnahmen, um betrügerische Praktiken auf der Plattform zu verhindern.',
        },
        '8f49603b_454c_4470_ab07_2f845a447595': {
            title: 'Betriebsbedingungen und Registrierung/Benachrichtigung für ausländische Plattformen',
            description: 'Halten Sie die Betriebsbedingungen für ausländische Plattformen ein, die vietnamesische Benutzer bedienen, einschließlich der Registrierungs- und Meldepflichten.',
        },
        e0dc85cc_5d2a_4142_b1a6_cc2fde891f7b: {
            title: 'Lokale Vertretung oder Autorisierung für ausländische Plattformen',
            description: 'Benennen Sie gemäß den gesetzlichen Bestimmungen einen lokalen Vertreter oder eine autorisierte Stelle in Vietnam für ausländische Plattformen.',
        },
        '5719f47c_f298_429e_90c3_df6ceed856e1': {
            title: 'Grenzüberschreitende Koordination der Verkäufer- und Beschwerdebearbeitung',
            description: 'Koordinieren Sie die grenzüberschreitende Verkäuferbearbeitung und Beschwerdelösung, einschließlich Eskalation und Beweismanagement.',
        },
        c0b3db29_9161_4cef_a889_94e3b85d78fe: {
            title: 'Interaktion und Berichtsbereitschaft des staatlichen E-Commerce-Managementsystems',
            description: 'Bereiten Sie sich auf die Interaktion mit dem staatlichen E-Commerce-Managementsystem vor, einschließlich der Zuordnung von Datenfeldern und der Berichtsfunktion.',
        },
        '145a7016_720a_4a06_badd_00145842821e': {
            title: 'Benachrichtigung über Materialänderungen nach der Genehmigung',
            description: 'Senden Sie Benachrichtigungen über wesentliche Änderungen an Plattformdetails, Richtlinien oder Abläufen nach der ersten Genehmigung.',
        },
        '4bc0ee2a_610d_490d_8122_d6d1afadaa22': {
            title: 'Kündigungs- und Deaktivierungsbenachrichtigung',
            description: 'Senden Sie Kündigungs- oder Deaktivierungsbenachrichtigungen, wenn Sie den E-Commerce-Betrieb einstellen, einschließlich öffentlicher Bekanntmachung und Verbraucherschutzabwicklung.',
        },
        be95bc85_2b25_4de7_a3e7_154b780289e4: {
            title: 'Berechtigung und Aufrechterhaltung des Gütesiegel- und Glaubwürdigkeitsbewertungsprogramms',
            description: 'Bewerten Sie die Eignung für Gütesiegel- und Glaubwürdigkeitsbewertungsprogramme und bewahren Sie Compliance-Nachweise für die fortlaufende Teilnahme auf.',
        },
        f639afe2_18f2_4c0a_82d9_626308994267: {
            title: 'Einwilligung zur Verarbeitung personenbezogener Daten',
            description: 'Für die Verarbeitung personenbezogener Daten ist die Einwilligung der betroffenen Person erforderlich, es sei denn, es gilt eine Ausnahmeregelung.',
        },
        '5dd8e1b9_ac2d_48af_8c62_538937f0a4f7': {
            title: 'Einwilligung zur Verarbeitung sensibler Daten',
            description: 'Für die Verarbeitung sensibler personenbezogener Daten ist eine ausdrückliche Einwilligung mit gesonderter, eindeutiger Mitteilung an die betroffene Person erforderlich.',
        },
        '5a958c76_6943_4449_a15c_ddb503ce526f': {
            title: 'Zugangsrecht',
            description: 'Betroffene Personen haben das Recht auf Auskunft über ihre personenbezogenen Daten, die beim Verantwortlichen gespeichert sind.',
        },
        '1ae0a58b_65a5_4a32_9b2c_0baed7799a32': {
            title: 'Recht auf Berichtigung',
            description: 'Betroffene Personen haben das Recht, die Berichtigung unrichtiger personenbezogener Daten zu verlangen.',
        },
        '25c61e57_273f_48cb_a318_d6315ad744f1': {
            title: 'Recht auf Löschung',
            description: 'Betroffene Personen haben das Recht, die Löschung ihrer personenbezogenen Daten zu verlangen.',
        },
        '0eafe047_ed8b_4a9a_bda9_b4ef2ae353c2': {
            title: 'Recht auf Einschränkung der Verarbeitung',
            description: 'Betroffene Personen haben das Recht, eine Einschränkung der Verarbeitung ihrer personenbezogenen Daten zu verlangen.',
        },
        '77f9677a_f436_43ec_a947_3bdc44fc192a': {
            title: 'Widerspruchsrecht',
            description: 'Betroffene Personen haben das Recht, der Verarbeitung ihrer personenbezogenen Daten zu widersprechen.',
        },
        c8b19e70_782c_49c9_8a71_14bef4147d6b: {
            title: 'Recht auf Widerruf der Einwilligung',
            description: 'Betroffene Personen haben das Recht, eine einmal erteilte Einwilligung jederzeit zu widerrufen.',
        },
        '7f472a1c_b37f_498d_adc7_df8d8eafbae9': {
            title: 'Meldung eines Verstoßes an die Behörde (72 Stunden)',
            description: 'Der Datenverantwortliche muss das Ministerium für öffentliche Sicherheit innerhalb von 72 Stunden nach Feststellung einer Verletzung des Schutzes personenbezogener Daten benachrichtigen.',
        },
        '98bed7ab_e814_43f5_8e70_e95c413266a1': {
            title: 'Benachrichtigung bei Verstößen an betroffene Personen',
            description: 'Der Datenverantwortliche muss betroffene Personen unverzüglich über eine Verletzung des Schutzes personenbezogener Daten informieren.',
        },
        '404a3576_dd84_4bac_acf4_29719615c45e': {
            title: '[[TOK_0]] für die Verarbeitung mit hohem Risiko',
            description: 'Für Verarbeitungstätigkeiten, die voraussichtlich ein hohes Risiko mit sich bringen, muss eine Datenschutz-Folgenabschätzung durchgeführt werden.',
        },
        '29d9ed94_9360_457c_9aca_37aefac66969': {
            title: 'Beurteilung des grenzüberschreitenden Transfers',
            description: 'Vor der Übermittlung personenbezogener Daten außerhalb Vietnams muss eine Folgenabschätzung durchgeführt werden.',
        },
        '9620ff08_b83c_4e1f_9350_eba835b145fe': {
            title: 'Verzeichnis der Verarbeitungstätigkeiten',
            description: 'Datenverantwortliche müssen ein Verzeichnis der Verarbeitungsaktivitäten (RoPA) führen, das alle Verarbeitungsaktivitäten dokumentiert.',
        },
        '96ee0ff3_3ead_431e_aa57_08ccff4821fc': {
            title: 'Aufzeichnungen der Datenverarbeitungsvereinbarung',
            description: 'Es müssen Aufzeichnungen über Datenverarbeitungsverträge mit Auftragsverarbeitern und Unterauftragsverarbeitern geführt werden.',
        },
        '434dc319_1922_49e4_b757_37622135c4b2': {
            title: 'Schutzmaßnahmen für grenzüberschreitende Übermittlungen',
            description: 'Für die Übermittlung personenbezogener Daten außerhalb Vietnams sind angemessene Sicherheitsvorkehrungen und dokumentierte Bewertungen erforderlich.',
        },
        '3372c651_d5a8_4cae_ae57_2fc684ad0768': {
            title: 'Bestätigung innerhalb von 2 Werktagen',
            description: 'Anträge betroffener Personen müssen innerhalb von 2 Arbeitstagen nach Eingang bestätigt werden.',
        },
        b15fa62d_3f52_4e42_8442_f4969e08883a: {
            title: 'Fertigstellung innerhalb von 15 Werktagen',
            description: 'Anträge betroffener Personen müssen innerhalb von 15 Arbeitstagen bearbeitet werden, mit einer möglichen Verlängerung um 5 Arbeitstage.',
        },
        '5d81233c_f671_4827_b874_827762edfc20': {
            title: 'Einreichung des Dossiers zur MoPS-Folgenabschätzung',
            description: 'Organisationen, die Hochrisikoverarbeitungen durchführen, müssen beim Ministerium für öffentliche Sicherheit im vorgeschriebenen Verwaltungsverfahren ein Folgenabschätzungsdossier einreichen.',
        },
        '83bf5bf8_edbd_4f0a_9f8e_5f47db01324d': {
            title: 'Einreichung von MoPS-Dossiers für grenzüberschreitende Transfers',
            description: 'Organisationen, die personenbezogene Daten außerhalb Vietnams übermitteln, müssen beim Ministerium für öffentliche Sicherheit ein Dossier zur Folgenabschätzung für die grenzüberschreitende Übertragung einreichen.',
        },
        '9454e465_e618_4b6f_80b3_d79fdd9cc5cb': {
            title: 'Zertifizierung von Verarbeitungsdienstleistern',
            description: 'Organisationen, die die Verarbeitung personenbezogener Daten als Dienstleistung anbieten, müssen vom Ministerium für öffentliche Sicherheit eine Dienstleistungsverarbeitungsbescheinigung erhalten.',
        },
        b88aec34_046a_4e0a_9c77_ddad27ea4bc4: {
            title: 'Bearbeitung des Dossiers zur Folgenabschätzung, wenn die Auslöser erfüllt sind',
            description: 'Wenn vorgeschriebene Auslöser erfüllt sind, muss ein Dossier zur Folgenabschätzung der Verarbeitung eingereicht werden.',
        },
        '9d34a206_b85e_4649_a23b_e2c6f1398402': {
            title: 'Dossier über die Auswirkungen grenzüberschreitender Transfers',
            description: 'Für internationale Datenübermittlungen muss ein Dossier über die Auswirkungen einer grenzüberschreitenden Übertragung erstellt und eingereicht werden.',
        },
        '210d3ec3_e6f2_424b_ae25_cad76bc13320': {
            title: 'Benennung des Datenschutzbeauftragten',
            description: 'Gemäß Verordnung 13 muss ein Datenschutzbeauftragter benannt werden.',
        },
        '776183b2_2797_40e8_8d81_c4f512c566d2': {
            title: 'Governance-Artefakte (Richtlinien, Rollen, Verfahren)',
            description: 'Governance-Artefakte, einschließlich Richtlinien, Rollen und Verfahren, müssen gepflegt werden.',
        },
        '4f1385f1_6dfc_4368_b4af_1040cd3f77b7': {
            title: 'Vollständigkeit des Beweispakets und unveränderlicher Prüfpfad',
            description: 'Die Beweispakete müssen vollständig sein und ein unveränderlicher Prüfpfad muss aufrechterhalten werden.',
        },
        f6826e26_8991_4a0f_9117_481490230bdd: {
            title: 'Unterstützung bei der Einreichung von Fallabläufen',
            description: 'Für Folgenabschätzungen und grenzüberschreitende Dossiers müssen die Arbeitsabläufe bei der Einreichung von Fällen unterstützt werden.',
        },
        '8a28ee33_305a_491f_a93f_90e59f8da91b': {
            title: 'Vertragliche Anforderungen des Auftragsverarbeiters',
            description: 'Vertragliche Anforderungen an Auftragsverarbeiter müssen festgelegt und überwacht werden.',
        },
        '4fd36e83_8286_40e0_b9b2_a4bc5e8377b3': {
            title: 'Jährliche Compliance-Überprüfung',
            description: 'Um die fortlaufende Einhaltung zu überprüfen, muss eine jährliche Compliance-Überprüfung durchgeführt werden.',
        },
        '8b6b6c13_0d32_4439_819f_4bd8cff02217': {
            title: 'Einreichungsunterlagen der Behörde',
            description: 'Es müssen Aufzeichnungen über alle behördlichen Einreichungen geführt werden.',
        },
        e7ce6c23_03dc_42dd_bccd_fa571c3afee3: {
            title: 'Rechtsgrundlagen für die Verarbeitung personenbezogener Daten',
            description: 'Die Verarbeitung personenbezogener Daten muss auf rechtmäßigen Grundlagen im Sinne der [[TOK_0]] basieren.',
        },
        c919c66c_6a74_4403_bb97_04b773d270bf: {
            title: 'Einwilligungsvoraussetzungen für sensible Daten',
            description: 'Die Verarbeitung sensibler personenbezogener Daten erfordert eine ausdrückliche Einwilligung mit besonderen Anforderungen.',
        },
        '419cc7c3_a257_4293_a054_304dc2fcb8df': {
            title: 'Rechte der betroffenen Person (Auskunft, Berichtigung, Löschung, Einschränkung, Widerspruch, Übertragbarkeit)',
            description: 'Betroffene Personen haben umfassende Rechte, einschließlich Auskunft, Berichtigung, Löschung, Einschränkung, Widerspruch und Übertragbarkeit.',
        },
        '638e6e25_3a74_4864_8bff_8e21ab82860b': {
            title: 'Meldung eines Verstoßes an die Behörde',
            description: 'Datenverantwortliche müssen die zuständige Behörde innerhalb der vorgeschriebenen Frist über Verstöße gegen den Schutz personenbezogener Daten informieren.',
        },
        '6e75c111_66b1_4726_8c27_6537846edb30': {
            title: 'Benachrichtigung bei Verstößen an betroffene Personen',
            description: 'Datenverantwortliche müssen betroffene Personen über Verstöße gegen den Schutz personenbezogener Daten informieren.',
        },
        f686123d_3bdd_4a61_a53c_efe5b52d9058: {
            title: 'Datenschutz-Folgenabschätzung',
            description: 'Für Verarbeitungstätigkeiten mit hohem Risiko muss eine Datenschutz-Folgenabschätzung durchgeführt werden.',
        },
        '554ea5b6_092d_4295_a57a_1bd9b2eef291': {
            title: 'Grenzüberschreitende Transfer-Governance',
            description: 'Grenzüberschreitende Übermittlungen personenbezogener Daten müssen den Governance-Anforderungen entsprechen.',
        },
        cf9a5b29_46fd_4072_b877_13b8a69df82c: {
            title: 'Benennung des Datenschutzbeauftragten',
            description: 'Organisationen müssen bei Bedarf einen Datenschutzbeauftragten benennen.',
        },
        f5a4965d_eb0c_47df_9933_f185ae46463b: {
            title: 'Aufzeichnungen über Verarbeitungstätigkeiten',
            description: 'Organisationen müssen Aufzeichnungen über alle Verarbeitungsaktivitäten führen.',
        },
        ce8986ff_684d_41ec_8147_b3f2a1c5206c: {
            title: 'Vertragliche Pflichten des Auftragsverarbeiters',
            description: 'Mit den Auftragsverarbeitern müssen vertragliche Verpflichtungen vereinbart werden.',
        },
        '7a3d7554_7b6f_49d7_8864_4a5cd71fd6bd': {
            title: 'Einreichung des Dossiers zur Folgenabschätzung',
            description: 'Dossiers zur Folgenabschätzung müssen wie vorgeschrieben bei der zuständigen Behörde eingereicht werden.',
        },
        '65dba62f_0788_44c1_89e3_09d802e28eb9': {
            title: 'Dossier über die Auswirkungen grenzüberschreitender Transfers',
            description: 'Für internationale Datenübermittlungen muss ein Dossier über die Auswirkungen einer grenzüberschreitenden Übertragung erstellt und eingereicht werden.',
        },
        '0eccb520_b1fa_4fa3_a3ab_2d30823dd00e': {
            title: '[[TOK_0]] Termin und Benachrichtigung',
            description: 'Es ist ein Datenschutzbeauftragter zu bestellen und der Behörde mitzuteilen.',
        },
        '43ead19e_982a_4615_bafd_e6a3a4e80b3a': {
            title: 'Governance-Richtlinien und -Verfahren',
            description: 'Governance-Richtlinien und -Verfahren müssen festgelegt und aufrechterhalten werden.',
        },
        '9ebc7a42_e1f1_49c4_ac90_22a691fd2219': {
            title: 'Beweispaket und unveränderlicher Prüfpfad',
            description: 'Die Beweispakete müssen vollständig sein und ein unveränderlicher Prüfpfad muss aufrechterhalten werden.',
        },
        '5b0ba1c0_7b86_4c80_b9f9_26e4ff9652c2': {
            title: 'Lebenszyklus eines Aktenfalls',
            description: 'Der Lebenszyklus eines Aktenfalls muss in vorgeschriebenen Phasen verwaltet werden.',
        },
        '83f2f346_47bb_4377_a711_3cef26742f39': {
            title: 'Vertragliche Anforderungen des Auftragsverarbeiters',
            description: 'Vertragliche Anforderungen an Auftragsverarbeiter müssen festgelegt und überwacht werden.',
        },
        cb972e06_f773_492e_8ad5_f65d1e999b79: {
            title: 'Zertifizierung als Service-Processing-Anbieter',
            description: 'Organisationen, die Datenverarbeitungsdienste anbieten, müssen eine Zertifizierung erhalten.',
        },
        '4ba36ab5_39f0_4d79_927e_c39587bed226': {
            title: 'Einreichungsunterlagen der Behörde',
            description: 'Es müssen Aufzeichnungen über alle behördlichen Einreichungen geführt werden.',
        },
        f7a62c88_3cda_4031_bc52_1598661a5128: {
            title: 'Jährliche Compliance-Überprüfung',
            description: 'Um die fortlaufende Einhaltung zu überprüfen, muss eine jährliche Compliance-Überprüfung durchgeführt werden.',
        },
        '3e97f4d4_60ad_46a8_ad2b_615d4ca04aee': {
            title: 'Technische Maßnahmen zur Datensicherheit',
            description: 'Technische Maßnahmen zur Datensicherheit müssen umgesetzt und aufrechterhalten werden.',
        },
        '45f4e745_a923_4879_94ce_5a2b41b7e886': {
            title: 'Dekret 356 offizielle Formularanforderungen für Dokumente',
            description: 'Für die entsprechenden Einreichungen beim Ministerium für öffentliche Sicherheit sind die 13 offiziellen Mẫu số-Verwaltungsverfahrensformulare (Mẫu số 01a–10) zu verwenden, die im Dekret [[TOK_0]]Đ-CP vorgeschrieben sind. Bei den Elementen I–VIII handelt es sich um interne Datenstrukturzuordnungen, nicht um offizielle Regulierungsformulare.',
        },
        ff452604_7461_4c12_aeab_cb7dd1fb5ba3: {
            title: '[[TOK_0]] Dossiereinreichung an A05',
            description: 'Organisationen müssen [[TOK_0]] Dossiers an A05/[[TOK_1] für Verarbeitungsaktivitäten mit sensiblen personenbezogenen Daten oder umfangreiche Verarbeitungen einreichen.',
        },
        '003600ae_7a0f_4034_b206_72f59409b8f3': {
            title: 'Einreichung des grenzüberschreitenden Transferdossiers',
            description: 'Organisationen müssen Dossiers zur grenzüberschreitenden Datenübermittlung zur Überprüfung und Genehmigung gemäß A05/[[TOK_0]] einreichen.',
        },
        '4632b20c_293a_4c7e_968e_4ce178c3b7d8': {
            title: 'Bearbeitung des Antrags auf ein Servicezertifikat',
            description: 'Datenverarbeitungsdienstleister müssen Zertifikate ab A05/[[TOK_0]] beantragen.',
        },
        be96add4_ebdb_4b6c_9426_4dc87b7cd2ce: {
            title: 'Benachrichtigung über die Verarbeitung personenbezogener Daten',
            description: 'Verantwortliche müssen A05/[[TOK_0]] über die Verarbeitung personenbezogener Daten unter Verwendung der vorgeschriebenen Formulare informieren (siehe Abschnitt 01a/01b).',
        },
        '39f50471_27cc_46bd_acff_9aa2211d43ab': {
            title: 'Jährliche Lageberichterstattung',
            description: 'Verantwortliche müssen jährliche Situationsberichte zur Verarbeitung personenbezogener Daten vorlegen (Stand 09).',
        },
        '3b45c6fa_d66a_448a_9ff1_597caa055e09': {
            title: 'Vertraulichkeit der Benutzerinformationen standardmäßig',
            description: 'Benutzerinformationen müssen standardmäßig vertraulich behandelt werden.',
        },
        '2994510e_b1f8_4cdd_947c_d9542746433b': {
            title: 'Minimale organisatorische und technische Schutzkontrollen',
            description: 'Es müssen minimale organisatorische und technische Schutzmaßnahmen umgesetzt werden.',
        },
        '8643160f_9a10_4d93_baf5_082c6a7c768a': {
            title: 'Offenlegung nur auf geeigneter Grundlage',
            description: 'Die Weitergabe von Nutzerdaten ist nur auf gesetzlicher Grundlage zulässig.',
        },
        c1fb7d85_fdc0_402e_ab0c_ff134bd72dfa: {
            title: 'Obligatorische Offenlegungsprotokollierung und Überprüfbarkeit',
            description: 'Alle Offenlegungen müssen protokolliert und überprüfbar sein.',
        },
        efa36bc0_abae_417a_b676_9509af37f89d: {
            title: 'Interner Genehmigungsworkflow für Offenlegungen',
            description: 'Für alle Offenlegungen muss ein interner Genehmigungsworkflow eingerichtet werden.',
        },
        d086fdcd_9a23_4500_893c_db8ac62bd787: {
            title: 'Bearbeitung der Antwort auf Autoritätsanfragen',
            description: 'Behördenanfragen müssen gemäß den vorgeschriebenen Verfahren bearbeitet und beantwortet werden.',
        },
    },
    framework_rights_descriptions: {
        be_informed: 'Die betroffene Person hat das Recht, über die Verarbeitung personenbezogener Daten informiert zu werden.',
        consent: 'Die betroffene Person hat das Recht auf Einwilligung in die Verarbeitung ihrer personenbezogenen Daten.',
        refuse_consent: 'Die betroffene Person hat das Recht, der Verarbeitung ihrer personenbezogenen Daten nicht zuzustimmen.',
        withdraw_consent: 'Die betroffene Person hat das Recht, den Widerruf einer zuvor erteilten Einwilligung zu verlangen.',
        access: 'Die betroffene Person hat das Recht, ihre beim Verantwortlichen gespeicherten personenbezogenen Daten einzusehen und darauf zuzugreifen.',
        rectification: 'Die betroffene Person hat das Recht, unrichtige personenbezogene Daten zu korrigieren oder deren Berichtigung zu verlangen.',
        data_provision: 'Die betroffene Person hat das Recht, die Bereitstellung ihrer personenbezogenen Daten zu verlangen (yêu cầu cung cấp dữ liệu cá nhân).',
        deletion: 'Vorbehaltlich gesetzlicher Ausnahmen hat die betroffene Person das Recht, die Löschung oder Vernichtung personenbezogener Daten zu verlangen.',
        restriction_of_processing: 'Die betroffene Person hat das Recht, eine Einschränkung der Verarbeitung ihrer personenbezogenen Daten zu verlangen.',
        object_to_processing: 'Die betroffene Person hat das Recht, einen Widerspruchsantrag gegen die Verarbeitung ihrer personenbezogenen Daten zu stellen.',
        complaint: 'Die betroffene Person hat das Recht, eine Beschwerde (khiếu nại) bezüglich der Verarbeitung personenbezogener Daten einzureichen.',
        denunciation: 'Die betroffene Person hat das Recht, bei Verstößen gegen den Schutz personenbezogener Daten Anzeige zu erstatten.',
        lawsuit: 'Die betroffene Person hat das Recht, bei Verstößen gegen ihre Datenschutzrechte rechtliche Schritte einzuleiten.',
        claim_damages: 'Die betroffene Person hat das Recht, Schadensersatz für Schäden zu verlangen, die durch Verstöße gegen den Schutz personenbezogener Daten verursacht wurden.',
        request_protection_measures: 'Die betroffene Person hat das Recht, von den zuständigen Behörden oder relevanten Organisationen/Einzelpersonen die Umsetzung von Maßnahmen zum Schutz ihrer personenbezogenen Daten zu verlangen.',
    },
    framework_procedures: {
        VN_DP_DRAFT_P7: {
            name: 'Risikomanagement und -überwachung (Entwurf)',
            steps: {
                '1': 'Risikokategorien identifizieren',
                '2': 'Führen Sie Frühwarnkontrollen durch',
                '3': 'Risiken bei der Erfassung, Speicherung, Verarbeitung, Weitergabe und Transaktion von Bewertungen',
                '4': 'Erfassen Sie Datenschutz-, Cybersicherheits- und Zugriffsverwaltungsrisiken',
                '5': 'Lösen Sie Abhilfemaßnahmen aus',
                '6': 'Behalten Sie den Bewertungsverlauf bei',
            },
        },
        VN_DP_DRAFT_P6: {
            name: 'Beschwerden und Streitigkeiten (Entwurf)',
            steps: {
                '1': 'Nehmen Sie Beschwerden/Streitigkeiten entgegen',
                '2': 'Überprüfen Sie die Vollständigkeit der erforderlichen Informationen. Bei Unvollständigkeit innerhalb von 24 Stunden Nachtrag anfordern',
                '3': 'Benachrichtigen Sie die Parteien innerhalb von 3 Arbeitstagen nach Erhalt einer vollständigen Anfrage über den Bearbeitungsansatz und den voraussichtlichen Zeitplan',
                '4': 'Fordern Sie Antworten und unterstützende Dokumente an',
                '5': 'Bewerten Sie den Streitfall und die Plattformverantwortung',
                '6': 'Auflösungsergebnis aufzeichnen',
                '7': 'Beweise sichern und Fall abschließen',
            },
        },
        VN_DP_DRAFT_P5: {
            name: 'Lieferung und Eigentumsbescheinigung an Daten (Entwurf)',
            steps: {
                '1': 'Liefern Sie das Produkt/die Dienstleistung gemäß der Vertragsmethode',
                '2': 'Notieren Sie das Lieferereignis und die Lieferzeit',
                '3': 'Erstellen Sie eine Bescheinigung über Eigentumsrechte an Daten',
                '4': 'Registrieren Sie den Abschluss der Transaktion',
                '5': 'Aktivieren Sie bei Bedarf eine spätere Suche/Verifizierung',
            },
        },
        VN_DP_DRAFT_P4: {
            name: 'Transaktionsanbahnung und Vertragsabschluss (Entwurf)',
            steps: {
                '1': 'Rezensionsauflistung und Bewertungsergebnis',
                '2': 'Initiieren Sie den Kauf-, Verhandlungs- oder Auktionsworkflow',
                '3': 'Elektronischen Vertrag erstellen',
                '4': 'Sichern Sie sich die Akzeptanz beider Parteien',
                '5': 'Erfassen Sie den Zahlungsabschluss',
                '6': 'Lieferung genehmigen',
            },
        },
        VN_DP_DRAFT_P3: {
            name: 'Sandbox-/Testumgebungszugriff (Entwurf)',
            steps: {
                '1': 'Senden Sie eine Sandbox-Anfrage',
                '2': 'Definieren Sie den Umfang, die zulässigen Daten, den Zeitraum und die Verarbeitungsberechtigungen',
                '3': 'Bereitstellung einer isolierten technischen Umgebung',
                '4': 'Überwachen Sie Sicherheit und Zugriff während des Tests',
                '5': 'Überprüfen Sie die Ausgabe vor der Extraktion',
                '6': 'Genehmigen Sie die Entnahme nur dort, wo dies zulässig ist',
                '7': 'Schließen Sie die Testsitzung und bereinigen Sie die Umgebung',
            },
        },
        VN_DP_DRAFT_P2: {
            name: 'Datenprodukt-/Dienstleistungsliste (Entwurf)',
            steps: {
                '1': 'Listungsantrag erstellen',
                '2': 'Erfassen Sie Quellen- und Eigentums-/Nutzungsnachweise',
                '3': 'Notieren Sie technische Merkmale, Format, [[TOK_0]] Details und Einschränkungen',
                '4': 'Erfassen Sie qualitativ hochwertige Offenlegungen',
                '5': 'Reichen Sie das Listungsdossier zur Plattformprüfung ein',
                '6': 'Die Plattform führt Vollständigkeits-, Rechtmäßigkeits- und technische Prüfungen durch',
                '7': 'Eintrag genehmigen oder ablehnen',
                '8': 'Bei Genehmigung die Auflistung mit beigefügtem Bewertungsergebnis veröffentlichen',
            },
        },
        VN_DP_DRAFT_P1: {
            name: 'Teilnehmer-Onboarding (Entwurf)',
            steps: {
                '1': 'Bestimmen Sie den Teilnehmertyp: Verkäufer oder Käufer',
                '2': 'Überprüfen Sie den Rechtsstatus und die Geschäftsfähigkeit',
                '3': 'Überprüfen Sie zusätzliche Bedingungen, wenn bedingte Geschäftsbereiche gelten',
                '4': 'Transaktionskonto registrieren',
                '5': 'Zahlungskonto verknüpfen',
                '6': 'Genehmigen Sie die Teilnahme an der Plattform',
                '7': 'Speichern Sie Teilnehmeraufzeichnungen und Prüfprotokolle',
            },
        },
        AI_A1: {
            name: '[[TOK_0]] Systemregistrierung/Benachrichtigung',
            steps: {
                '1': 'Anwendbarkeitsprüfung und [[TOK_0]] Systemklassifizierung',
                '2': 'Erstellen Sie ein Registrierungs-/Benachrichtigungsdossier',
                '3': 'Interne Genehmigung',
                '4': 'Über den Kanal einreichen',
                '5': 'Änderungsschleife – bei Rückgabe aktualisieren und erneut einreichen',
                '6': 'Bestätigung schließen und speichern',
            },
        },
        AI_A2: {
            name: '[[TOK_0]] Risikoklassifizierungs-Workflow',
            steps: {
                '1': 'Erstellen Sie einen [[TOK_0]] Systemregistereintrag',
                '2': 'Führen Sie den Klassifizierungsassistenten aus',
                '3': 'Beweise beifügen',
                '4': 'Klassifizierung genehmigen',
                '5': 'Verknüpfen Sie die Ausgaben mit dem Systemdossier',
            },
        },
        AI_A3: {
            name: 'Kennzeichnungs- und Offenlegungskonformität',
            steps: {
                '1': 'Kennzeichnungspflichten nach System und Anwendungsfall identifizieren',
                '2': 'Kennzeichnungshinweise implementieren',
                '3': 'Erfassen Sie Beweise – Screenshots, UI-Kopie, technische Metadaten',
                '4': 'Behandeln Sie Ausnahmen und zeichnen Sie Begründungen auf',
                '5': 'Genehmigen und Version',
            },
        },
        AI_A4: {
            name: 'Meldung schwerwiegender Vorfälle',
            steps: {
                '1': 'Erstellen Sie [[TOK_0]] Vorfalldatensatz',
                '2': 'Schweregrad klassifizieren',
                '3': 'Führen Sie Eindämmungsmaßnahmen und Beweiserfassung durch',
                '4': 'Generieren Sie den Export einer Vorlage für einen Bericht über schwerwiegende Vorfälle',
                '5': 'Übermitteln Sie es über den Kanal an die Behörde',
                '6': 'Verfolgen Sie die Antworten und Schließungen der Behörden',
            },
        },
        AI_A5: {
            name: '[[TOK_0]] Folgenabschätzung',
            steps: {
                '1': 'Bewertungsprotokoll erstellen',
                '2': 'Füllen Sie die erforderlichen Abschnitte aus',
                '3': 'Fügen Sie Beweise bei – Datenflüsse, Modelldokumentation, Kontrollen',
                '4': 'Interne Genehmigung',
                '5': 'Bericht exportieren und im Dossier speichern',
            },
        },
        AI_A6: {
            name: 'Kontrollierte Tests/Sandbox-Teilnahme',
            steps: {
                '1': 'Vollständige Berechtigungs- und Bereitschaftsaufzeichnung',
                '2': 'Anwendung vorbereiten und exportieren',
                '3': 'Über den Kanal einreichen',
                '4': 'Verfolgen Sie die Genehmigung',
                '5': 'Führen Sie Überwachungskontrollpunkte und Protokolle aus',
                '6': 'Vollständiger Fertigstellungsbericht und Abschlusspaket',
            },
        },
        CYBERSEC_C1: {
            name: 'Bewertung der Sicherheit kritischer Informationssysteme',
            steps: {
                '1': 'Klassifizieren Sie Informationssysteme gemäß den nationalen Cybersicherheitsanforderungen',
                '2': 'Führen Sie Sicherheitsbewertungen und Risikobewertungen für klassifizierte Systeme durch',
                '3': 'Implementieren Sie die erforderlichen Sicherheitsmaßnahmen und grundlegenden Kontrollen',
                '4': 'Dokumentieren Sie den Nachweis der Einhaltung und planen Sie regelmäßige Überprüfungen',
            },
        },
        CYBERSEC_C2: {
            name: 'Benachrichtigung über Cybersicherheitsvorfälle',
            steps: {
                '1': 'Erkennen, klassifizieren und bewerten Sie den Cybersicherheitsvorfall',
                '2': 'Führen Sie sofortige Reaktionsmaßnahmen und Beweissicherung durch',
                '3': 'Melden Sie sich bei der Behörde und beteiligen Sie sich an der nationalen Koordinierung der Reaktion auf Vorfälle',
                '4': 'Führen Sie nach dem Vorfall eine Überprüfung durch und dokumentieren Sie die gewonnenen Erkenntnisse',
            },
        },
        CYBERSEC_C3: {
            name: 'Überprüfung der Datenlokalisierungskonformität',
            steps: {
                '1': 'Bewerten Sie anhand des Diensttyps und der Datenkategorien, ob Auslöser für die Datenlokalisierung gelten',
                '2': 'Überprüfen Sie, ob die lokale Speicherarchitektur und grenzüberschreitende Flusskontrollen vorhanden sind',
                '3': 'Bewerten Sie gegebenenfalls die Anforderungen an die Präsenz vor Ort (Zweigstelle/Repräsentanz).',
                '4': 'Dokumentieren Sie Konformitätsnachweise und bewahren Sie sie zur behördlichen Überprüfung auf',
            },
        },
        CYBERSEC_C4: {
            name: 'Antwort auf die Kooperationsanfrage der Behörde',
            steps: {
                '1': 'Erhalten und überprüfen Sie die Legitimität und den Umfang der behördlichen Anfrage',
                '2': 'Sammeln und bereiten Sie angeforderte Informationen vor oder führen Sie erforderliche Aktionen aus',
                '3': 'Senden Sie die Antwort innerhalb der erforderlichen Frist an die Behörde',
                '4': 'Protokollieren Sie die Offenlegung und schließen Sie den Fall',
            },
        },
        CYBERSEC_C5: {
            name: 'Überprüfung der Qualifikation des Cybersicherheitspersonals',
            steps: {
                '1': 'Bewerten Sie die Sicherheitslage des Anbieters mithilfe des Cybersecurity-Assessment-Frameworks',
                '2': 'Überprüfen Sie den Umfang des Anbieterdatenzugriffs und registrieren Sie sich im Anbieterdatenzugriffsprotokoll',
                '3': 'Überprüfen Sie die Klausel zur Benachrichtigung über Vorfälle des Anbieters und die vertraglichen Cybersicherheitsanforderungen',
                '4': 'Planen Sie regelmäßige Sicherheitsüberprüfungen der Anbieter und überwachen Sie die Einhaltung',
            },
        },
        DATA_D1: {
            name: 'Einrichtung des Dateninventars und der Klassifizierung',
            steps: {
                '1': 'Katalogisieren Sie alle Datenbestände mit Typen und Quellen im Datenbestandsregister',
                '2': 'Klassifizieren Sie jeden Vermögenswert nach Sensitivitätsstufe',
                '3': 'Definieren Sie Handhabungsregeln pro Klassifizierungsstufe',
                '4': 'Erfassen Sie Beweise – Screenshots, Architekturdiagramme, Zugangskontrollen',
                '5': 'Planen Sie regelmäßige Überprüfungen',
            },
        },
        DATA_D2: {
            name: 'Datenaustausch-Governance',
            steps: {
                '1': 'Bewerten Sie neue Vereinbarungen zur Datenfreigabe anhand einer Risikobewertung für die Datenfreigabe',
                '2': 'Vollständiger interner Genehmigungsworkflow',
                '3': 'Zeichnen Sie das Freigabeereignis im Datenfreigabe-/Offenlegungsprotokoll auf',
                '4': 'Erfassen Sie Beweise – Genehmigungsunterlagen, Vertragsdokumente',
                '5': 'Regelmäßige Überprüfung der Sharing-Vereinbarungen',
            },
        },
        DATA_D3: {
            name: 'Bewertung der grenzüberschreitenden Datenübertragung',
            steps: {
                '1': 'Identifizieren Sie grenzüberschreitende Übertragungen im Datenbestand',
                '2': 'Führen Sie eine Bewertung des Übertragungsrisikos durch',
                '3': 'Wenden Sie Schutzmaßnahmen und Governance-Maßnahmen an',
                '4': 'Dokument im grenzüberschreitenden Abschnitt der Governance-Bescheinigung',
                '5': 'Exportieren Sie das Bewertungspaket für das Audit',
            },
        },
        DATA_D4: {
            name: 'Jährliche Governance-Bescheinigung',
            steps: {
                '1': 'Überprüfen Sie die Governance-RACI-Matrix',
                '2': 'Überprüfen Sie den Richtlinienstatus (Governance, Klassifizierung, Freigabe, Aufbewahrung).',
                '3': 'Vollständiges Attestierungspaket',
                '4': 'Holen Sie die interne Genehmigung ein',
                '5': 'Export- und Archivbescheinigung',
            },
        },
        DATA_D5: {
            name: 'Umgang mit Datenvorfällen',
            steps: {
                '1': 'Klassifizieren Sie den Vorfall mithilfe des Entscheidungsdatensatzes',
                '2': 'Führen Sie eine Reaktion auf Vorfälle gemäß Playbook durch',
                '3': 'Erfassen Sie Beweise – Protokolle, Screenshots, Kommunikation',
                '4': 'Führen Sie eine Überprüfung nach dem Vorfall durch',
                '5': 'Wenn eine behördliche Benachrichtigung erforderlich ist: Einreichungsfall erstellen und an [[TOK_0]] senden',
                '6': 'Schließen und archivieren',
            },
        },
        ECOM_P1: {
            name: 'Benachrichtigung (Verkaufswebsite/App)',
            steps: {
                '1': 'Bestimmen Sie die Klassifizierung: Verkaufsseite/App vs. Marktplatz/Serviceplattform',
                '2': 'Erstellen Sie einen internen Dossierdatensatz mit Unternehmensidentität, Website-/App-Informationen und erforderlichen Offenlegungen',
                '3': 'Erstellen Sie ein Beweispaket – Screenshots von Offenlegungen, Richtlinien-URLs, Versionsverlauf',
                '4': 'Über Online.gov.vn einreichen – Dokumente hochladen, Zeitstempel und Bestätigung aufzeichnen',
                '5': 'Verfolgen Sie die Verarbeitung – bei Rücksendung zur Änderung die Gründe erfassen und erneut einreichen',
                '6': 'Schließen – Bestätigung speichern, Nachweise verknüpfen und Prüfprotokoll erstellen',
            },
        },
        ECOM_P2: {
            name: 'Registrierung (Serviceplattformen / Marktplätze)',
            steps: {
                '1': 'Bestimmen Sie das Plattformmodell und die Verpflichtungen – Marktplatz vs. gemischter vs. Social Commerce',
                '2': 'Build-Registrierungsdossier – Antragsformular, Dienstbereitstellungsplan, AGB, Plattformregeln',
                '3': 'Interne Genehmigungen – Rechts-/Compliance-Eigentümer zuweisen, zur Einreichung genehmigen',
                '4': 'Über Online.gov.vn einreichen – Dossier hochladen, Zeitstempel aufzeichnen',
                '5': 'Verarbeitungsschleife – bei Rückgabe zur Änderung, Aktualisierung und erneuten Übermittlung',
                '6': 'Genehmigung und Operationalisierung – Bestätigung speichern, laufende Compliance-Register führen',
            },
        },
        ECOM_P3: {
            name: 'Aktualisierungs-/Änderungsbenachrichtigung',
            steps: {
                '1': 'Änderungsauslöser identifizieren – wesentliche Änderung an Dossierelementen',
                '2': 'Änderungspaket generieren – Änderungszusammenfassung, aktualisierte Dokumente, Beweisaktualisierungen',
                '3': 'Senden Sie die Aktualisierung und zeichnen Sie den Übermittlungsstatus auf',
                '4': 'Bearbeitung verfolgen und abschließen',
            },
        },
        ECOM_P4: {
            name: 'Kündigung/Deaktivierung',
            steps: {
                '1': 'Bereiten Sie das Kündigungspaket vor – Kündigungsdatum, Grund, Verbraucherschutz-Handhabungsplan, Nachweis der öffentlichen Bekanntmachung',
                '2': 'Kündigung einreichen – Zeitstempel und Bestätigung aufzeichnen',
                '3': 'Schließen – Endgültigen Status und Beweise speichern',
            },
        },
        ECOM_P5: {
            name: 'Programm zur Vertrauenswürdigkeits-/Glaubwürdigkeitsbewertung',
            steps: {
                '1': 'Überprüfung der Eignung und Bereitschaft',
                '2': 'Bereiten Sie das Dossier mit dem offiziellen Formular vor',
                '3': 'Senden und verfolgen',
                '4': 'Bewahren Sie kontinuierliche Compliance-Nachweise auf',
            },
        },
        PDPL_P1: {
            name: '[[TOK_0]] Einreichung der Einreichung bei [[TOK_1]]',
            steps: {
                '1': 'Füllen Sie [[TOK_0]] mithilfe des Formularpfads gemäß Dekret 356 aus (Version 02a/02b)',
                '2': 'Stellen Sie Begleitdokumente und Belege zusammen',
                '3': 'Reichen Sie ein Originaldossier beim Ministerium für öffentliche Sicherheit ein ([[TOK_0]])',
                '4': 'Überwachen Sie Ergänzungsanfragen von [[TOK_0]] und antworten Sie innerhalb der Frist',
                '5': 'Bewahren Sie das Dossier und den Nachweis der Einreichung für den Prüfpfad auf',
            },
        },
        PDPL_P2: {
            name: 'Antrag auf grenzüberschreitende Überweisung',
            steps: {
                '1': 'Füllen Sie das Dossier für grenzüberschreitende Transfers mit den Formularen des Dekrets 356 aus (Version 01a/01b, Version 09)',
                '2': 'Reichen Sie innerhalb von 60 Tagen nach Beginn der Bearbeitung ein Originaldossier bei [[TOK_0]] ein',
                '3': 'Benachrichtigen Sie [[TOK_0]] nach erfolgreicher Übertragung mit den Kontaktdaten der empfangenden Partei',
                '4': 'Reagieren Sie innerhalb der Frist auf Ergänzungs-/Korrektur-/Inspektionsanfragen von [[TOK_0]].',
            },
        },
        PDPL_P3: {
            name: 'Antrag auf ein Datenverarbeitungsdienstzertifikat',
            steps: {
                '1': 'Bereiten Sie ein Zertifizierungsantragsdossier gemäß den Anforderungen des Dekrets 356 vor',
                '2': 'Senden Sie den Antrag mit den erforderlichen Belegen an [[TOK_0]].',
                '3': 'Reagieren Sie auf [[TOK_0]] Rezensionskommentare und Ergänzungsanfragen',
                '4': 'Pflegen Sie den Zeitplan für Zertifikate und Erneuerungen',
            },
        },
        PDPL_P4: {
            name: 'Bearbeitung von Anfragen zu Rechten betroffener Personen',
            steps: {
                '1': 'Anfrage empfangen und protokollieren; Überprüfung der Identität der betroffenen Person innerhalb von 2 Werktagen',
                '2': 'Bewerten Sie die Art der Anfrage und legen Sie die anwendbare Frist fest (10/15/20 Tage nach Typ).',
                '3': 'Führen Sie Fulfillment-Aktionen über alle relevanten Systeme und Abteilungen hinweg aus',
                '4': 'Bereiten Sie eine Antwort mit Ergebnis und Begründung vor und senden Sie sie an die betroffene Person',
                '5': 'Den Fall abschließen und Beweise für die Prüfung aufbewahren; Dokumentieren Sie etwaige Ablehnungsgründe',
            },
        },
        PDPL_P5: {
            name: 'Verstoßmeldung an [[TOK_0]]',
            steps: {
                '1': 'Den Verstoß erkennen und bewerten; Meldepflicht innerhalb von 2 Arbeitstagen festlegen',
                '2': 'Bereiten Sie das Benachrichtigungspaket gemäß den [[TOK_0]]-Anforderungen vor',
                '3': 'Senden Sie die Benachrichtigung innerhalb von 2 Arbeitstagen nach der Entdeckung an [[TOK_0]].',
                '4': 'Auf [[TOK_0]] Folgeanfragen antworten; Nachträge und Koordinationsnachweise einreichen',
            },
        },
        TELECOM_T1: {
            name: 'Bearbeitung von Behördenanfragen',
            steps: {
                '1': 'Empfangen und protokollieren Sie die behördliche Anfrage per Aufnahmeprotokoll',
                '2': 'Überprüfen Sie die Identität der Behörde, die Rechtsgrundlage und den Umfang der Anfrage',
                '3': 'Führen Sie eine interne rechtliche Prüfung durch und holen Sie die Genehmigung des Managements ein',
                '4': 'Bereiten Sie ein Antwortpaket mit gesammelten Beweisen vor',
                '5': 'Antwortschreiben entwerfen und genehmigen',
                '6': 'Erstellen Sie einen Einreichungsfall und senden Sie die Antwort über den Kanal',
                '7': 'Protokollieren Sie die Offenlegung und verfolgen Sie die Bestätigung der Autorität',
                '8': 'Schließen Sie den Fall ab und bewahren Sie Beweise für den Prüfpfad auf',
            },
        },
        TELECOM_T2: {
            name: 'Offenlegungsmanagement',
            steps: {
                '1': 'Offenlegungsanfrage erhalten (Benutzereinwilligung, rechtliche Verpflichtung oder behördliche Anfrage)',
                '2': 'Kompletter Offenlegungsgenehmigungs-Workflow',
                '3': 'Offenlegung durchführen und im Protokollregister eintragen',
                '4': 'Erfassen Sie Beweise – Genehmigungsaufzeichnungen, Kommunikationsaufzeichnungen',
                '5': 'Regelmäßige Überprüfung des Offenlegungsprotokolls',
            },
        },
        TELECOM_T3: {
            name: 'Vertraulichkeitsrichtlinie und Einrichtung der Zugriffskontrolle',
            steps: {
                '1': 'Vertraulichkeitsrichtlinie entwerfen und genehmigen',
                '2': 'Entwerfen und genehmigen Sie Zugriffskontroll- und Protokollierungsrichtlinien',
                '3': 'Dokumentverarbeitungsaktivitäten im Benutzerinformationsverarbeitungsregister',
                '4': 'Erfassen Sie Beweise – Richtliniendokumente, Umsetzungsnachweise',
                '5': 'Planen Sie regelmäßige Überprüfungen',
            },
        },
        TELECOM_T4: {
            name: 'Bewertung von Telekommunikationsvorfällen',
            steps: {
                '1': 'Den Vorfall einordnen und bewerten',
                '2': 'Bestimmen Sie die Benachrichtigungsanforderungen',
                '3': 'Wenn eine behördliche Mitteilung erforderlich ist: Einreichungsfall erstellen',
                '4': 'Beweise erfassen und sichern',
                '5': 'Auflösung und Abschluss',
            },
        },
        TELECOM_T5: {
            name: 'Aufbewahrungs- und Löschverwaltung',
            steps: {
                '1': 'Definieren Sie einen Aufbewahrungs- und Löschplan pro Datenkategorie',
                '2': 'Implementieren Sie Löschverfahren',
                '3': 'Beweise erfassen – Aufzeichnungen löschen',
                '4': 'Regelmäßige Überprüfung der Zeitpläne',
            },
        },
    },
    framework_fines: {
        VN_CYBERSEC_LAW: {
            'CYBERSEC-FINE-A': 'Fehlerbehandlung bei Vorfällen und Meldung von Fehlern',
            'CYBERSEC-FINE-B': 'Fehler bei der Überwachung der Systemsicherheit und der Basiskontrolle',
            'CYBERSEC-FINE-C': 'Versäumnisse bei der Zusammenarbeit bei Behördenanfragen',
            'CYBERSEC-FINE-D': 'Datenlokalisierung und Verstöße gegen die lokale Präsenz',
            'CYBERSEC-FINE-E': 'Fehler bei der Malware-Prävention und beim Systemschutz',
            'CYBERSEC-FINE-F': 'Antwortfehler der Plattform/des Dienstanbieters',
            'CYBERSEC-FINE-G': 'Sicherheitsmängel von Anbietern/Dritten',
        },
        VN_ECOMMERCE_LAW_2025: {
            'ECOM-FINE-A': 'Registrierung / Benachrichtigung / Verwaltungsbereitschaft',
            'ECOM-FINE-B': 'Beschwerden und Verbraucherschutz',
            'ECOM-FINE-C': 'Überwachung und Durchsetzung von Takedowns',
            'ECOM-FINE-D': 'Grenzüberschreitende Operationen',
            'ECOM-FINE-E': 'Plattformregeln und Transparenz',
        },
        VN_PDPL: {
            'PDPL-FINE-A': 'Versäumnis, [[TOK_0]] durchzuführen',
            'PDPL-FINE-B': 'Unbefugte grenzüberschreitende Übertragung',
            'PDPL-FINE-C': 'Verarbeitung ohne Rechtsgrundlage',
            'PDPL-FINE-D': 'Unterlassene Reaktion auf DSR',
            'PDPL-FINE-E': 'Versäumnis, eine Datenschutzverletzung zu melden',
            'PDPL-FINE-F': 'Nicht konforme Verarbeitungsvereinbarung',
            'PDPL-FINE-G': 'Verstöße gegen die Verarbeitung sensibler Daten',
            'PDPL-FINE-H': 'Verstöße gegen die Datenverarbeitung von Kindern',
            'PDPL-FINE-I': 'Verstöße gegen die automatisierte Entscheidungsfindung',
            'PDPL-FINE-J': 'Nichteinhaltung behördlicher Anordnungen',
        },
        VN_TELECOM_LAW_2023: {
            'TELECOM-FINE-A': 'Fehler bei der Bearbeitung von Behördenanfragen',
            'TELECOM-FINE-B': 'Vertraulichkeit und unbefugte Offenlegung',
            'TELECOM-FINE-C': 'Zugriffskontroll- und Protokollierungsfehler',
            'TELECOM-FINE-D': 'Verstöße gegen die Aufbewahrungs- und Löschvorschriften',
            'TELECOM-FINE-E': 'Fehler bei der Bewertung von Telekommunikationsvorfällen',
        },
    },
    framework_fines_detail: {
        VN_TELECOM_LAW_2023: {
            'TELECOM-FINE-E': {
                fine_individual: 'Bis zu 100 Millionen VND',
                fine_org: 'Bis zu 200 Millionen VND',
                deadlines: 'Sofort nach Erkennung',
            },
            'TELECOM-FINE-D': {
                fine_individual: 'Bis zu 100 Millionen VND',
                fine_org: 'Bis zu 200 Millionen VND',
                deadlines: 'Dauerhafte Verpflichtung',
            },
            'TELECOM-FINE-C': {
                fine_individual: 'Bis zu 100 Millionen VND',
                fine_org: 'Bis zu 200 Millionen VND',
                deadlines: 'Dauerhafte Verpflichtung',
            },
            'TELECOM-FINE-B': {
                fine_individual: 'Bis zu 100 Millionen VND',
                fine_org: 'Bis zu 200 Millionen VND',
                deadlines: 'Dauerhafte Verpflichtung',
            },
            'TELECOM-FINE-A': {
                fine_individual: 'Bis zu 100 Millionen VND',
                fine_org: 'Bis zu 200 Millionen VND',
                deadlines: 'Wie im Antrag der Behörde angegeben',
            },
        },
        VN_ECOMMERCE_LAW_2025: {
            'ECOM-FINE-E': {
                fine_individual: 'Bis zu 80 Millionen VND',
                fine_org: 'Bis zu 160 Millionen VND',
                deadlines: 'Dauerhafte Verpflichtung',
            },
            'ECOM-FINE-D': {
                fine_individual: 'Bis zu 80 Millionen VND',
                fine_org: 'Bis zu 160 Millionen VND',
                deadlines: 'Dauerhafte Verpflichtung',
            },
            'ECOM-FINE-C': {
                fine_individual: 'Bis zu 80 Millionen VND',
                fine_org: 'Bis zu 160 Millionen VND',
                deadlines: 'Dauerhafte Verpflichtung',
            },
            'ECOM-FINE-B': {
                fine_individual: 'Bis zu 80 Millionen VND',
                fine_org: 'Bis zu 160 Millionen VND',
                deadlines: 'Gemäß den Pflichten zur Beschwerdebearbeitung',
            },
            'ECOM-FINE-A': {
                fine_individual: 'Bis zu 80 Millionen VND',
                fine_org: 'Bis zu 160 Millionen VND',
                deadlines: 'Vor Beginn des E-Commerce-Betriebs',
            },
        },
        VN_CYBERSEC_LAW: {
            'CYBERSEC-FINE-G': {
                fine_individual: 'Bis zu 100 Millionen VND',
                fine_org: 'Bis zu 200 Millionen VND',
                deadlines: 'Dauerhafte Verpflichtung',
            },
            'CYBERSEC-FINE-F': {
                fine_individual: 'Bis zu 100 Millionen VND',
                fine_org: 'Bis zu 200 Millionen VND',
                deadlines: 'Wie im Antrag der Behörde angegeben',
            },
            'CYBERSEC-FINE-E': {
                fine_individual: 'Bis zu 100 Millionen VND',
                fine_org: 'Bis zu 200 Millionen VND',
                deadlines: 'Dauerhafte Verpflichtung',
            },
            'CYBERSEC-FINE-D': {
                fine_individual: 'Bis zu 100 Millionen VND',
                fine_org: 'Bis zu 200 Millionen VND',
                deadlines: 'Wie in der behördlichen Entscheidung angegeben; Dauerschuldverhältnis bei Auslösung',
            },
            'CYBERSEC-FINE-C': {
                fine_individual: 'Bis zu 100 Millionen VND',
                fine_org: 'Bis zu 200 Millionen VND',
                deadlines: 'Wie im Antrag der Behörde angegeben',
            },
            'CYBERSEC-FINE-B': {
                fine_individual: 'Bis zu 100 Millionen VND',
                fine_org: 'Bis zu 200 Millionen VND',
                deadlines: 'Dauerschuld; Vor dem Betrieb des Systems müssen Kontrollen vorhanden sein',
            },
            'CYBERSEC-FINE-A': {
                fine_individual: 'Bis zu 100 Millionen VND',
                fine_org: 'Bis zu 200 Millionen VND',
                deadlines: 'Sofortige Reaktion erforderlich; Berichterstattung innerhalb der vorgeschriebenen Frist',
            },
        },
        VN_PDPL: {
            'PDPL-FINE-A': {
                fine_individual: 'Bis zu 1,5 Milliarden VND',
                fine_org: 'Bis zu 3 Milliarden VND',
                deadlines: '60 Tage ab Beginn der Bearbeitung, um das Dossier an [[TOK_0]] einzureichen.',
            },
            'PDPL-FINE-B': {
                fine_individual: 'Bis zu 1,5 Milliarden VND',
                fine_org: 'Bis zu 3 Milliarden VND',
                revenue: '3–5 % des Vorjahresumsatzes in Vietnam in schweren Fällen',
                deadlines: '60 Tage ab Beginn der Bearbeitung, um das Dossier an [[TOK_0]] einzureichen; Benachrichtigung nach der Übertragung erforderlich',
            },
            'PDPL-FINE-C': {
                fine_individual: 'Bis zu 1,5 Milliarden VND',
                fine_org: 'Bis zu 3 Milliarden VND',
                deadlines: 'Dauerschuld; Vor der Verarbeitung ist eine Einwilligung einzuholen',
            },
            'PDPL-FINE-D': {
                fine_individual: 'Bis zu 1,5 Milliarden VND',
                fine_org: 'Bis zu 3 Milliarden VND',
                deadlines: '2 Arbeitstage Verfahrensantwort; 10 Tage Zugang/Korrektur; 15 Tage Widerrufs-/Sperrfrist/Widerrufsfrist; 20 Tage Löschung',
            },
            'PDPL-FINE-E': {
                fine_individual: 'Bis zu 1,5 Milliarden VND',
                fine_org: 'Bis zu 3 Milliarden VND',
                deadlines: '2 Werktage, um [[TOK_0]] zu benachrichtigen, nachdem ein Verstoß festgestellt wurde',
            },
            'PDPL-FINE-F': {
                fine_individual: 'Bis zu 1,5 Milliarden VND',
                fine_org: 'Bis zu 3 Milliarden VND',
                deadlines: 'Dauerhafte Verpflichtung',
            },
            'PDPL-FINE-G': {
                fine_individual: 'Bis zu 1,5 Milliarden VND',
                fine_org: 'Bis zu 3 Milliarden VND',
                deadlines: 'Dauerschuld; Vor der Verarbeitung sensibler Daten müssen Kontrollen vorhanden sein',
            },
            'PDPL-FINE-H': {
                fine_individual: 'Bis zu 1,5 Milliarden VND',
                fine_org: 'Bis zu 3 Milliarden VND',
                deadlines: 'Dauerschuld; Vor der Verarbeitung ist die Zustimmung der Eltern erforderlich',
            },
            'PDPL-FINE-I': {
                fine_individual: 'Bis zu 1,5 Milliarden VND',
                fine_org: 'Bis zu 3 Milliarden VND',
                deadlines: 'Dauerhafte Verpflichtung',
            },
            'PDPL-FINE-J': {
                fine_individual: 'Bis zu 1,5 Milliarden VND',
                fine_org: 'Bis zu 3 Milliarden VND',
                revenue: 'Bis zu 5 % des Vorjahresumsatzes in Vietnam bei wiederholten Verstößen',
                deadlines: 'Wie in der behördlichen Anordnung angegeben',
            },
        },
    },
    framework_procedures_detail: {
        VN_DP_DRAFT_P7: {
            trigger: 'Laufender Betrieb der Plattform',
            responsible: {
                '1': 'Plattformbetreiber / Risiko',
                '2': 'Plattformbetreiber / Sicherheit',
                '3': 'Plattformbetreiber / Risiko',
                '4': 'Plattformbetreiber / Sicherheit',
                '5': 'Plattformbetreiber',
                '6': 'Compliance',
            },
            step_outputs: {},
        },
        VN_DP_DRAFT_P6: {
            trigger: 'Ein Teilnehmer reicht eine Beschwerde oder einen Streitbeilegungsantrag ein',
            responsible: {
                '1': 'Plattformbetreiber',
                '2': 'Plattformbetreiber',
                '3': 'Plattformbetreiber',
                '4': 'Plattformbetreiber',
                '5': 'Plattformbetreiber / Recht',
                '6': 'Plattformbetreiber',
                '7': 'Compliance',
            },
            step_outputs: {},
        },
        VN_DP_DRAFT_P5: {
            trigger: 'Die Lieferung erfolgt nach Erfüllung der Vertrags- und Zahlungsbedingungen',
            responsible: {
                '1': 'Verkäufer / Plattformbetreiber',
                '2': 'Plattformbetreiber',
                '3': 'Plattformbetreiber',
                '4': 'Plattformbetreiber',
                '5': 'Plattformbetreiber',
            },
            step_outputs: {},
        },
        VN_DP_DRAFT_P4: {
            trigger: 'Ein Käufer initiiert eine Transaktion für Daten, Produkte oder Dienstleistungen',
            responsible: {
                '1': 'Käufer',
                '2': 'Käufer / Plattformbetreiber',
                '3': 'Plattformbetreiber',
                '4': 'Käufer / Verkäufer',
                '5': 'Plattformbetreiber / Zahlung',
                '6': 'Plattformbetreiber',
            },
            step_outputs: {},
        },
        VN_DP_DRAFT_P3: {
            trigger: 'Ein Teilnehmer möchte Datenprodukte/-dienste in der isolierten Umgebung bewerten',
            responsible: {
                '1': 'Teilnehmer',
                '2': 'Plattformbetreiber / Teilnehmer',
                '3': 'Plattformbetreiber / IT',
                '4': 'Plattformbetreiber / Sicherheit',
                '5': 'Plattformbetreiber',
                '6': 'Plattformbetreiber',
                '7': 'Plattformbetreiber / IT',
            },
            step_outputs: {},
        },
        VN_DP_DRAFT_P2: {
            trigger: 'Ein Verkäufer möchte Daten, Produkte oder Datendienste zum Handel anbieten',
            responsible: {
                '1': 'Verkäufer',
                '2': 'Verkäufer/Rechtsanwalt',
                '3': 'Verkäufer / IT',
                '4': 'Verkäufer',
                '5': 'Verkäufer',
                '6': 'Plattformbetreiber',
                '7': 'Plattformbetreiber',
                '8': 'Plattformbetreiber',
            },
            step_outputs: {},
        },
        VN_DP_DRAFT_P1: {
            trigger: 'Ein Verkäufer oder Käufer tritt der Datenplattform bei',
            responsible: {
                '1': 'Plattformbetreiber',
                '2': 'Plattformbetreiber / Recht',
                '3': 'Plattformbetreiber / Recht',
                '4': 'Plattformbetreiber',
                '5': 'Plattformbetreiber',
                '6': 'Plattformbetreiber',
                '7': 'Compliance',
            },
            step_outputs: {},
        },
        PDPL_P1: {
            trigger: 'Beginn der Verarbeitung personenbezogener Daten, die eine Folgenabschätzung erfordert',
            responsible: {
                '1': '[[TOK_0]] / Datenschutzteam',
                '2': 'Datenschutzteam',
                '3': 'Recht / Compliance',
                '4': '[[TOK_0]] / Datenschutzteam',
                '5': 'Compliance-Team',
            },
            step_outputs: {},
        },
        PDPL_P2: {
            trigger: 'Absicht, personenbezogene Daten außerhalb Vietnams zu übertragen',
            responsible: {
                '1': '[[TOK_0]] / Datenschutzteam',
                '2': 'Recht / Compliance',
                '3': 'Recht / Compliance',
                '4': '[[TOK_0]] / Datenschutzteam',
            },
            step_outputs: {},
        },
        PDPL_P3: {
            trigger: 'Organisation, die zertifizierungspflichtige Datenverarbeitungsdienste anbietet',
            responsible: {
                '1': 'Recht / Compliance',
                '2': 'Recht / Compliance',
                '3': '[[TOK_0]] / Datenschutzteam',
                '4': 'Compliance-Team',
            },
            step_outputs: {},
        },
        PDPL_P4: {
            trigger: 'Eingang einer Anfrage zu den Rechten der betroffenen Person',
            responsible: {
                '1': 'Datenschutzteam / Kundenservice',
                '2': '[[TOK_0]] / Datenschutzteam',
                '3': 'Abteilungsleiter / IT',
                '4': '[[TOK_0]] / Datenschutzteam',
                '5': 'Compliance-Team',
            },
            step_outputs: {},
        },
        PDPL_P5: {
            trigger: 'Feststellung einer Verletzung oder Verletzung des Schutzes personenbezogener Daten',
            responsible: {
                '1': 'Incident Response Team / [[TOK_0]]',
                '2': '[[TOK_0]] / Datenschutzteam',
                '3': 'Recht / Compliance',
                '4': '[[TOK_0]] / Incident Response Team',
            },
            step_outputs: {},
        },
    },
    framework_deadline_references: {
        'PDPL Art. 9': '[[TOK_0]] Art. 9',
        'PDPL Art. 17': '[[TOK_0]] Art. 17',
        'PDPL Art. 23': '[[TOK_0]] Art. 23',
        'Decree 13 Art. 24': 'Dekret 13 Art. 24',
        'MoPS Admin Procedures': 'MoPS-Administrationsverfahren',
        'Annual cycle': 'Jahreszyklus',
        'Decree 13/2023/NĐ-CP Art. 24': 'Dekret [[TOK_0]]Đ-CP Art. 24',
        'Decree 356/2025/NĐ-CP Art. 25(4)': 'Dekret [[TOK_0]]Đ-CP Art. 25(4)',
        'Decree 356/2025/NĐ-CP Art. 5 Cl. 2': 'Dekret [[TOK_0]]Đ-CP Art. 5 Cl. 2',
        'Decree 356/2025/NĐ-CP Art. 5 Cl. 2–5': 'Dekret [[TOK_0]]Đ-CP Art. 5 Cl. 2–5',
        'Decree 356/2025/NĐ-CP Art. 5 Cl. 3': 'Dekret [[TOK_0]]Đ-CP Art. 5 Cl. 3',
        'Decree 356/2025/NĐ-CP Art. 5 Cl. 4': 'Dekret [[TOK_0]]Đ-CP Art. 5 Cl. 4',
        'Decree 356/2025/NĐ-CP Art. 5 Cl. 5': 'Dekret [[TOK_0]]Đ-CP Art. 5 Cl. 5',
        'Decree 356/2025/NĐ-CP Art. 8(3)': 'Dekret [[TOK_0]]Đ-CP Art. 8(3)',
        'Draft Decree on Data Platforms 2026': 'Entwurf eines Dekrets über Datenplattformen 2026',
        'Law 122/2025/QH15 Ch. III; NĐ 98/2020; NĐ 24/2025': 'Gesetz [[TOK_0]] Kap. III; NĐ 98/2020; NĐ 24/2025',
        'Law 122/2025/QH15 Ch. IV (Consumer Protection)': 'Gesetz [[TOK_0]] Kap. IV (Verbraucherschutz)',
        'Law 122/2025/QH15 — Online.gov.vn operational procedure': 'Gesetz [[TOK_0]] – Online.gov.vn Betriebsverfahren',
        'Law 134/2025/QH15 Article 12': 'Gesetz [[TOK_0]] Artikel 12',
        'Law 134/2025/QH15 Article 21': 'Gesetz [[TOK_0]] Artikel 21',
        'Law 134/2025/QH15 Article 27': 'Gesetz [[TOK_0]] Artikel 27',
        'Law 134/2025/QH15 Articles 9–10': 'Gesetz [[TOK_0]] Artikel 9–10',
        'Law 24/2023/QH15 — article mapping pending': 'Gesetz [[TOK_0]] – Artikelzuordnung steht aus',
        'Law 60/2024/QH15 (internal control target)': 'Gesetz [[TOK_0]] (internes Kontrollziel)',
        'Law 91/2025/QH15 Art. 21': 'Gesetz [[TOK_0]] Art. 21',
        'Law 91/2025/QH15 Art. 23': 'Gesetz [[TOK_0]] Art. 23',
        'Policy-defined': 'Richtliniendefiniert',
        Quarterly: 'Vierteljährlich',
        'QĐ 778/QĐ-BCA-A05 administrative procedure': 'QĐ 778/QĐ-BCA-A05 Verwaltungsverfahren',
        'internal control target (Law 116/2025/QH15 Art. 24(2)(b), 41(5) — exact timeline pending implementing instrument)': 'internes Kontrollziel (Gesetz [[TOK_0]] Art. 24(2)(b), 41(5) – genauer Zeitplan bis zur Umsetzung des Instruments)',
        'internal control target (Law 116/2025/QH15 Art. 41(3) — exact timeline pending implementing instrument)': 'internes Kontrollziel (Gesetz [[TOK_0]] Art. 41(3) – genauer Zeitplan bis zur Umsetzung des Instruments)',
        'source verification pending': 'Quellenüberprüfung steht noch aus',
        'Circular 83/2025/TT-NHNN — Ad-hoc Internal Audit Reporting to SBV (Layer 5)': 'Circular 83/2025/TT-NHNN — Ad-hoc-Berichterstattung der Internen Revision an die SBV (Layer 5)',
        'Circular 83/2025/TT-NHNN — Annual ICAAP Report (Phụ lục III) (Layer 5)': 'Circular 83/2025/TT-NHNN — Jährlicher ICAAP-Bericht (Phụ lục III) (Layer 5)',
        'Circular 83/2025/TT-NHNN — Annual Phụ lục I (Layer 5)': 'Circular 83/2025/TT-NHNN — Jährliches Phụ lục I (Layer 5)',
        'Circular 83/2025/TT-NHNN — Annual Phụ lục IV (Layer 5)': 'Circular 83/2025/TT-NHNN — Jährliches Phụ lục IV (Layer 5)',
        'Circular 83/2025/TT-NHNN — Annual Risk Management Report (Phụ lục II) (Layer 5)': 'Circular 83/2025/TT-NHNN — Jährlicher Risikomanagementbericht (Phụ lục II) (Layer 5)',
        'Circular 83/2025/TT-NHNN — Asset Management Responsibility (Layer 2, theme C)': 'Circular 83/2025/TT-NHNN — Verantwortung für das Asset-Management (Layer 2, theme C)',
        "Circular 83/2025/TT-NHNN — Board / Members' Council Oversight (Layer 2, theme A)": 'Circular 83/2025/TT-NHNN — Aufsicht durch Vorstand / Mitgliederbeirat (Layer 2, theme A)',
        'Circular 83/2025/TT-NHNN — Board Committees (Layer 2, theme A)': 'Circular 83/2025/TT-NHNN — Vorstandsausschüsse (Layer 2, theme A)',
        'Circular 83/2025/TT-NHNN — Board Decisions and Minutes (Layer 2, theme A)': 'Circular 83/2025/TT-NHNN — Vorstandsbeschlüsse und Protokolle (Layer 2, theme A)',
        'Circular 83/2025/TT-NHNN — Branch Control Procedures (Layer 2, theme C)': 'Circular 83/2025/TT-NHNN — Kontrollverfahren für Niederlassungen (Layer 2, theme C)',
        'Circular 83/2025/TT-NHNN — Compliance Assessment of Internal Rules (Layer 2, theme D)': 'Circular 83/2025/TT-NHNN — Compliance-Bewertung interner Regeln (Layer 2, theme D)',
        'Circular 83/2025/TT-NHNN — Compliance Function (Layer 2, theme D)': 'Circular 83/2025/TT-NHNN — Compliance-Funktion (Layer 2, theme D)',
        'Circular 83/2025/TT-NHNN — Compliance Remediation Monitoring (Layer 2, theme D)': 'Circular 83/2025/TT-NHNN — Überwachung von Compliance-Nachbesserungen (Layer 2, theme D)',
        'Circular 83/2025/TT-NHNN — Concentration Risk (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — Konzentrationsrisiko (Layer 3, theme E)',
        'Circular 83/2025/TT-NHNN — Conflict of Interest (Layer 2, theme C)': 'Circular 83/2025/TT-NHNN — Interessenkonflikte (Layer 2, theme C)',
        'Circular 83/2025/TT-NHNN — Control Culture (Layer 2, theme A/B)': 'Circular 83/2025/TT-NHNN — Kontrollkultur (Layer 2, theme A/B)',
        'Circular 83/2025/TT-NHNN — Credit Risk (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — Kreditrisiko (Layer 3, theme E)',
        'Circular 83/2025/TT-NHNN — Delegated Authority (Layer 2, theme C)': 'Circular 83/2025/TT-NHNN — Delegierte Entscheidungsbefugnisse (Layer 2, theme C)',
        'Circular 83/2025/TT-NHNN — Early Implementation Notification (Layer 5)': 'Circular 83/2025/TT-NHNN — Mitteilung über vorzeitige Umsetzung (Layer 5)',
        'Circular 83/2025/TT-NHNN — General Director Responsibility (Layer 2, theme A)': 'Circular 83/2025/TT-NHNN — Verantwortung des Generaldirektors (Layer 2, theme A)',
        'Circular 83/2025/TT-NHNN — ICAAP (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — ICAAP (Layer 3, theme E)',
        'Circular 83/2025/TT-NHNN — Interest-Rate Risk in the Banking Book (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — Zinsänderungsrisiko im Bankbuch (Layer 3, theme E)',
        'Circular 83/2025/TT-NHNN — Internal Audit Charter (Layer 2, theme H)': 'Circular 83/2025/TT-NHNN — Revisionsordnung der Internen Revision (Layer 2, theme H)',
        'Circular 83/2025/TT-NHNN — Internal Audit Engagements (Theme H)': 'Circular 83/2025/TT-NHNN — Prüfungsmandate der Internen Revision (Theme H)',
        'Circular 83/2025/TT-NHNN — Internal Audit Findings Communication (Layer 2, theme H)': 'Circular 83/2025/TT-NHNN — Kommunikation von Prüfungsfeststellungen der Internen Revision (Layer 2, theme H)',
        'Circular 83/2025/TT-NHNN — Internal Audit Findings and Corrective Actions (Theme H)': 'Circular 83/2025/TT-NHNN — Feststellungen der Internen Revision und Korrekturmaßnahmen (Theme H)',
        'Circular 83/2025/TT-NHNN — Internal Audit Follow-Up (Theme H)': 'Circular 83/2025/TT-NHNN — Nachverfolgung der Internen Revision (Theme H)',
        'Circular 83/2025/TT-NHNN — Internal Audit Governance': 'Circular 83/2025/TT-NHNN — Governance der Internen Revision',
        'Circular 83/2025/TT-NHNN — Internal Audit Independence (Layer 2, theme H)': 'Circular 83/2025/TT-NHNN — Unabhängigkeit der Internen Revision (Layer 2, theme H)',
        'Circular 83/2025/TT-NHNN — Internal Audit Plan (Layer 2/Theme H)': 'Circular 83/2025/TT-NHNN — Prüfungsplan der Internen Revision (Layer 2/Theme H)',
        'Circular 83/2025/TT-NHNN — Internal Audit Reporting to SBV (Layer 2, theme H)': 'Circular 83/2025/TT-NHNN — Berichterstattung der Internen Revision an die SBV (Layer 2, theme H)',
        'Circular 83/2025/TT-NHNN — Internal Control System Governance (Layer 2)': 'Circular 83/2025/TT-NHNN — Governance des Internen Kontrollsystems (Layer 2)',
        'Circular 83/2025/TT-NHNN — Internal Reporting Procedure (Layer 2, theme C)': 'Circular 83/2025/TT-NHNN — Verfahren für interne Berichterstattung (Layer 2, theme C)',
        'Circular 83/2025/TT-NHNN — Internal Reports Register (Layer 4, theme F)': 'Circular 83/2025/TT-NHNN — Register interner Berichte (Layer 4, theme F)',
        'Circular 83/2025/TT-NHNN — Law-Change Monitoring (Layer 2, theme D)': 'Circular 83/2025/TT-NHNN — Überwachung von Rechtsänderungen (Layer 2, theme D)',
        'Circular 83/2025/TT-NHNN — Legal and Reputational Risk (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — Rechts- und Reputationsrisiko (Layer 3, theme E)',
        'Circular 83/2025/TT-NHNN — Limit Breach Escalation (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — Eskalation bei Limitverletzungen (Layer 3, theme E)',
        'Circular 83/2025/TT-NHNN — Liquidity Risk (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — Liquiditätsrisiko (Layer 3, theme E)',
        'Circular 83/2025/TT-NHNN — MIS Annual Review (Layer 4, theme F)': 'Circular 83/2025/TT-NHNN — Jährliche MIS-Überprüfung (Layer 4, theme F)',
        'Circular 83/2025/TT-NHNN — MIS Backup and Continuity (Layer 4, theme F)': 'Circular 83/2025/TT-NHNN — MIS-Backup und -Kontinuität (Layer 4, theme F)',
        'Circular 83/2025/TT-NHNN — MIS Escalation Mechanisms (Layer 4, theme F)': 'Circular 83/2025/TT-NHNN — MIS-Eskalationsmechanismen (Layer 4, theme F)',
        'Circular 83/2025/TT-NHNN — MIS Reliability and Confidentiality (Layer 4, theme F)': 'Circular 83/2025/TT-NHNN — MIS-Zuverlässigkeit und Vertraulichkeit (Layer 4, theme F)',
        'Circular 83/2025/TT-NHNN — MIS Risk Data Sources (Layer 4, theme F)': 'Circular 83/2025/TT-NHNN — MIS-Risikodatenquellen (Layer 4, theme F)',
        'Circular 83/2025/TT-NHNN — Management Information System (Layer 4)': 'Circular 83/2025/TT-NHNN — Management-Informationssystem (Layer 4)',
        'Circular 83/2025/TT-NHNN — Market Risk (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — Marktrisiko (Layer 3, theme E)',
        'Circular 83/2025/TT-NHNN — Material Risk Register (Layer 3)': 'Circular 83/2025/TT-NHNN — Register wesentlicher Risiken (Layer 3)',
        'Circular 83/2025/TT-NHNN — Model Risk (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — Modellrisiko (Layer 3, theme E)',
        'Circular 83/2025/TT-NHNN — New Product Review (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — Prüfung neuer Produkte (Layer 3, theme E)',
        'Circular 83/2025/TT-NHNN — Operational Risk (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — Operationelles Risiko (Layer 3, theme E)',
        'Circular 83/2025/TT-NHNN — Outsourcing BCP (Layer 2, theme G)': 'Circular 83/2025/TT-NHNN — Business-Continuity-Planung für Outsourcing (Layer 2, theme G)',
        'Circular 83/2025/TT-NHNN — Outsourcing Contracts (Layer 2, theme G)': 'Circular 83/2025/TT-NHNN — Outsourcing-Verträge (Layer 2, theme G)',
        'Circular 83/2025/TT-NHNN — Outsourcing Controls': 'Circular 83/2025/TT-NHNN — Kontrollen für Outsourcing',
        'Circular 83/2025/TT-NHNN — Outsourcing Due Diligence (Layer 2, theme G)': 'Circular 83/2025/TT-NHNN — Sorgfaltsprüfung für Outsourcing (Layer 2, theme G)',
        'Circular 83/2025/TT-NHNN — Outsourcing Fallback Provider (Layer 2, theme G)': 'Circular 83/2025/TT-NHNN — Ersatzanbieter für Outsourcing (Layer 2, theme G)',
        'Circular 83/2025/TT-NHNN — Outsourcing Materiality (Layer 2, theme G)': 'Circular 83/2025/TT-NHNN — Wesentlichkeit von Outsourcing (Layer 2, theme G)',
        'Circular 83/2025/TT-NHNN — Outsourcing Monitoring (Layer 2, theme G)': 'Circular 83/2025/TT-NHNN — Überwachung von Outsourcing (Layer 2, theme G)',
        'Circular 83/2025/TT-NHNN — Phụ lục V/VI Technical References (Layer 5)': 'Circular 83/2025/TT-NHNN — Technische Referenzen Phụ lục V/VI (Layer 5)',
        'Circular 83/2025/TT-NHNN — Policy Register (Layer 2, theme C)': 'Circular 83/2025/TT-NHNN — Richtlinienregister (Layer 2, theme C)',
        'Circular 83/2025/TT-NHNN — Professional Ethics (Layer 2, theme C)': 'Circular 83/2025/TT-NHNN — Berufsethik (Layer 2, theme C)',
        'Circular 83/2025/TT-NHNN — Risk Appetite (Layer 3)': 'Circular 83/2025/TT-NHNN — Risikoappetit (Layer 3)',
        'Circular 83/2025/TT-NHNN — Risk Committee Coordination (Layer 2, theme E)': 'Circular 83/2025/TT-NHNN — Koordination des Risikoausschusses (Layer 2, theme E)',
        'Circular 83/2025/TT-NHNN — Risk Data Governance (Layer 3, theme E/F) — phased to 2028-01-01': 'Circular 83/2025/TT-NHNN — Governance von Risikodaten (Layer 3, theme E/F) — gestaffelt bis 2028-01-01',
        'Circular 83/2025/TT-NHNN — Risk Limit Review (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — Überprüfung von Risikolimits (Layer 3, theme E)',
        'Circular 83/2025/TT-NHNN — Risk Limits Framework (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — Rahmenwerk für Risikolimits (Layer 3, theme E)',
        'Circular 83/2025/TT-NHNN — Risk Management Function (Layer 2, theme E)': 'Circular 83/2025/TT-NHNN — Risikomanagement-Funktion (Layer 2, theme E)',
        'Circular 83/2025/TT-NHNN — Risk Methodology and Models (Layer 2, theme E)': 'Circular 83/2025/TT-NHNN — Risikomethodik und Modelle (Layer 2, theme E)',
        'Circular 83/2025/TT-NHNN — Risk Reporting (Layer 2, theme E)': 'Circular 83/2025/TT-NHNN — Risikoberichterstattung (Layer 2, theme E)',
        'Circular 83/2025/TT-NHNN — Risk Reporting Cadence (Layer 4, theme F)': 'Circular 83/2025/TT-NHNN — Taktung der Risikoberichterstattung (Layer 4, theme F)',
        'Circular 83/2025/TT-NHNN — SBV Remediation Submission (Layer 5)': 'Circular 83/2025/TT-NHNN — Einreichung von Nachbesserungen an die SBV (Layer 5)',
        'Circular 83/2025/TT-NHNN — SBV Submission Channels (Layer 5)': 'Circular 83/2025/TT-NHNN — Einreichungskanäle zur SBV (Layer 5)',
        'Circular 83/2025/TT-NHNN — Sector Applicability (Layer 1)': 'Circular 83/2025/TT-NHNN — Sektorale Anwendbarkeit (Layer 1)',
        'Circular 83/2025/TT-NHNN — Segregation of Duties (Layer 2, theme C)': 'Circular 83/2025/TT-NHNN — Funktionstrennung (Layer 2, theme C)',
        'Circular 83/2025/TT-NHNN — Senior Management Supervision (Layer 2, theme A)': 'Circular 83/2025/TT-NHNN — Aufsicht durch das Senior Management (Layer 2, theme A)',
        'Circular 83/2025/TT-NHNN — Strategic Risk (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — Strategisches Risiko (Layer 3, theme E)',
        'Circular 83/2025/TT-NHNN — Stress Testing (Layer 3, theme E) — phased to 2028-01-01': 'Circular 83/2025/TT-NHNN — Stresstests (Layer 3, theme E) — gestaffelt bis 2028-01-01',
        'Circular 83/2025/TT-NHNN — Supervisory Board (Layer 2, theme A)': 'Circular 83/2025/TT-NHNN — Aufsichtsrat (Layer 2, theme A)',
        'Circular 83/2025/TT-NHNN — Supervisory Findings Register (Layer 4, theme F)': 'Circular 83/2025/TT-NHNN — Register aufsichtsrechtlicher Feststellungen (Layer 4, theme F)',
        'Circular 83/2025/TT-NHNN — Three Lines Roles and Escalation (Layer 2, theme B)': 'Circular 83/2025/TT-NHNN — Rollen und Eskalation im Drei-Linien-Modell (Layer 2, theme B)',
        'Circular 83/2025/TT-NHNN — Three Lines of Defence (Layer 2)': 'Circular 83/2025/TT-NHNN — Drei-Linien-Modell (Layer 2)',
        'Circular 83/2025/TT-NHNN — Violation Escalation (Layer 2, theme D)': 'Circular 83/2025/TT-NHNN — Eskalation bei Verstößen (Layer 2, theme D)',
    },
    framework_authorities: {
        'Quốc hội (National Assembly)': 'Quốc hội (Nationalversammlung)',
        'Ministry of Public Security / A05 Department': 'Ministerium für öffentliche Sicherheit / Abteilung A05',
        'Ministry of Public Security': 'Ministerium für öffentliche Sicherheit',
        'Ministry of Information and Communications': 'Ministerium für Information und Kommunikation',
        'Government of Vietnam': 'Regierung von Vietnam',
        'European Data Protection Board (EDPB)': 'Europäischer Datenschutzausschuss (EDPB)',
        'ENISA / National CSIRTs': 'ENISA / Nationale CSIRTs',
        'State Bank of Vietnam': 'Staatsbank von Vietnam',
    },
    tour_titles: {
        access_accountability: 'Nehmen Sie an der Accountability-Tour teil',
        assessments: 'Bewertungstour',
        audit_trail: 'Audit-Trail-Tour',
        classification: 'Klassifizierungstour',
        compliance_forms: 'Tour zu Compliance-Formularen',
        connectors: 'Steckverbinder-Tour',
        consent_properties: 'Consent-Eigenschaften-Tour',
        consent: 'Einwilligungstour',
        dashboard: 'Dashboard-Tour',
        data_mapping: 'Daten-Mapping-Tour',
        data_subjects: 'Tour zu betroffenen Personen',
        deletion_orchestration: 'Tour zur Löschorchestrierung',
        discovery: 'Entdeckungstour',
        governance: 'Governance-Tour',
        help_center: 'Hilfe-Center-Tour',
        incident_ops: 'Incident Operations Tour',
        incidents: 'Tour zu Vorfällen',
        localization: 'Lokalisierungstour',
        monitoring: 'Überwachungstour',
        onboarding: 'Onboarding-Tour',
        organizations: 'Organisationstour',
        partner_workspace: 'Partner-Workspace-Tour',
        platform_settings: 'Tour zu den Plattformeinstellungen',
        privacy_scanner: 'Privatsphäre-Scanner-Tour',
        program_governance: 'Programm-Governance-Tour',
        rights_requests: 'Tour zu Rechteanfragen',
        task_management: 'Aufgabenverwaltungstour',
        vendor_risk: 'Anbieter-Risikotour',
    },
    tour_descriptions: {
        access_accountability: 'Überprüfen Sie als Leiter der Internen Revision (P-VN-10) Zugriffsnachweise, prüfen Sie die Nutzung von Berechtigungen und untersuchen Sie anomale Muster, um die Integrität und Vertraulichkeit von [[TOK_0]] Artikel 5(1)(f) nachzuweisen.',
        assessments: 'Führen Sie als Unternehmen [[TOK_1] (P-VN-01) DPIAs gemäß Dekret 356 Mau so 02a durch, identifizieren Sie Compliance-Lücken und bewerten Sie grenzüberschreitende Übertragungsrisiken gemäß [[TOK_0]].',
        audit_trail: 'Fragen Sie als Leiter der internen Revision (P-VN-10) modulübergreifende Beweise ab, stellen Sie Prüfpakete zusammen und exportieren Sie manipulationssichere Protokolle für behördliche Einreichungen.',
        classification: 'Definieren Sie als Datenverwalter (P-VN-05 Datenklassifizierungstaxonomien, weisen Sie Vertraulichkeitsbezeichnungen zu, setzen Sie Aufbewahrungsrichtlinien durch und schließen Sie Abdeckungslücken, die für die Einhaltung von [[TOK_0]] erforderlich sind.',
        compliance_forms: 'Durchsuchen, vervollständigen und übermitteln Sie als Unternehmen [[TOK_0]] (P-VN-01) die offiziellen vietnamesischen Regulierungsformulare, einschließlich Phu luc I, Phu luc II und Mau so-Vorlagen für PDP-Komitee-Einreichungen.',
        connectors: 'Erfassen Sie als IT-Systemleiter (P-VN-05) Geschäftsanforderungen für Integrationen, ordnen Sie Konnektoren den Compliance-Datenflüssen zu und überprüfen Sie die POC-Bereitschaft, bevor Sie in Betrieb gehen.',
        consent_properties: 'Konfigurieren Sie als Unternehmen [[TOK_1]] (P-VN-01) die Bereitstellung von [[TOK_2]]: digitale Eigentumsregistrierung, goldene Vorlagen für konsistente [[TOK_0]] Einwilligungsbanner und verbindliche Matrizen, die Eigenschaften mit Verarbeitungsaktivitäten verknüpfen.',
        consent: 'Als Unternehmen [[TOK_1] (P-VN-01) verwalten Sie den Lebenszyklus der Einwilligungsrichtlinie: Definieren Sie Erfassungszwecke, setzen Sie [[TOK_0]] Widerrufsrechte durch und integrieren Sie sie in Ihre Consent Management Platform.',
        dashboard: 'Orientieren Sie sich als Unternehmen [[TOK_1]] (P-VN-01) an der Compliance-Positions-Kommandozentrale, die [[TOK_0]] Fristen, Verstöße gegen SLAs und Audit-Bereitschafts-KPIs anzeigt.',
        data_mapping: 'Erstellen Sie als Datenverwalter (P-VN-05 Ihr ROPA-Inventar, bilden Sie grenzüberschreitende Datenflüsse ab und führen Sie das gemäß [[TOK_0] erforderliche Verarbeitungsaktivitätsregister.',
        data_subjects: 'Als Enterprise DPO oder Education Compliance Lead verwalten Sie einheitliche Profile betroffener Personen, die Einwilligungsdatensätze, Rechteanfragen und Zeitleistenaktivitäten auf der gesamten Plattform verknüpfen.',
        deletion_orchestration: 'Überprüfen Sie als [[TOK_1]] (P-VN-01) die durchgängige Datenlöschung über interne Systeme und Drittanbieter hinweg mit kryptografischen Beweisketten für die Einhaltung von [[TOK_0]] Artikel 17 des Rechts auf Löschung.',
        discovery: 'Führen Sie als Datenverwalter (P-VN-05 automatisierte Scans durch, um personenbezogene Daten in verbundenen Systemen zu ermitteln, prüfen Sie bereitgestellte Ergebnisse und geben Sie die Ergebnisse an das Klassifizierungsmodul zur [[TOK_0]]-Kennzeichnung weiter.',
        governance: 'Pflegen Sie als Vendor Risk Manager (P-VN-08 das Lieferantenregister, verfolgen Sie Unterauftragsverarbeiterketten, bewerten Sie grenzüberschreitende Transferrisiken und setzen Sie Governance-Playbooks gemäß [[TOK_0] durch.“',
        help_center: 'Für alle Personen – Datenschutzbeauftragte, Prüfer, IT-Leiter und Compliance-Manager – finden Sie Antworten, Anleitungen und modulspezifische Dokumentation zur Unterstützung Ihrer täglichen Compliance-Workflows.',
        incident_ops: 'Aktivieren Sie als Incident Commander (P-VN-09 Reaktions-Playbooks, verfolgen Sie die Einhaltung von [[TOK_1]] anhand des 72-Stunden-Benachrichtigungsfensters [[TOK_0], verwalten Sie Eskalationen und koordinieren Sie die Reaktion des Anbieters.',
        incidents: 'Erkennen und melden Sie als Incident Commander (P-VN-09) Datenverstöße mit 72-Stunden-Benachrichtigungspflichten ([[TOK_0]] an das PDP-Komitee, Triage nach Schweregrad und erstellen Sie Vorfalldossiers in Audit-Qualität.',
        localization: 'Verwalten Sie als Unternehmen [[TOK_1]] (P-VN-01) den Lebenszyklus des Regulierungsrahmens: Installieren Sie vietnamesische Marktpakete, aktivieren Sie die Rahmen [[TOK_0]] und Dekret 13, ordnen Sie Anforderungen den Plattformmodulen zu und verwalten Sie Übersetzungen.',
        monitoring: 'Richten Sie als Unternehmen [[TOK_1] (P-VN-01) fortlaufende Compliance-Überwachungsprogramme ein, verfolgen Sie regulatorische Änderungen, messen Sie KPIs und verwalten Sie regulatorische Interaktionsfälle unter [[TOK_0]].',
        onboarding: 'Als Compliance-Trainer (P-VN-02) führen Sie Schulungen über geführte Touren durch, laden realistische Beispieldaten für praktische Übungen und führen den Einrichtungsassistenten für Schnellstartszenarien aus.',
        organizations: 'Konfigurieren Sie als [[TOK_0]] (P-VN-01) Compliance-Strukturen für mehrere Organisationen, richten Sie Abteilungshierarchien ein und leiten Sie Anfragen betroffener Personen innerhalb Ihrer Unternehmensgruppe weiter.',
        partner_workspace: 'Als Partner Account Manager binden Sie Partnerorganisationen ein, konfigurieren Serviceebenen, verfolgen Compliance-Ergebnisse und verwalten den Partnermarktplatz.',
        platform_settings: 'Als Plattformadministrator verwalten Sie die gesamte Betriebskonfiguration – Identität, Sicherheit, Integrationen und Modulzugriff, die Ihrem Compliance-Programm zugrunde liegen.',
        privacy_scanner: 'Führen Sie als Datenschutzanalyst (P-VN-06) kontinuierliche Überwachungsscans durch, um Verstöße gegen die Cookie-Einwilligung, nicht autorisierte Tracker und Richtlinienlücken zu erkennen und so Beweise für die Einhaltung von ePrivacy und [[TOK_0]] zu generieren.',
        program_governance: 'Navigieren Sie zwischen Reifegradmodellen, Bewertungen, Evidenzlücken, Zusammenfassungen und mehr. Jedes Untermodul trägt zu einer ganzheitlichen Sicht auf den Zustand Ihres internen Programms bei.',
        rights_requests: 'Als Unternehmen [[TOK_1] (P-VN-01) verwalten Sie Anträge auf Rechte betroffener Personen gemäß [[TOK_0]] mit gesetzlichen Fristen von 15 Tagen, Identitätsüberprüfung und Lösungspfaden auf Prüfniveau.',
        task_management: 'Leiten Sie Compliance-Aufgaben über Personas hinweg, verfolgen Sie [[TOK_0]] Fristen und automatisieren Sie Arbeitsabläufe, die Ihr Team zur Verantwortung ziehen.',
        vendor_risk: 'Bewerten Sie als Vendor Risk Manager (P-VN-08) Risiken Dritter, erzwingen Sie Gate-Reviews und veranlassen Sie Neubewertungen – im Gegensatz zur Program Governance, die Ihre interne Reife verfolgt.',
    },
    consolidation: {
        title: 'Konsolidierungsfaelle',
        new_case: 'Konsolidierungsfall erstellen',
        case_count: 'case',
        created: 'Konsolidierungsfall erstellt',
        create: 'Fall erstellen',
        creating: 'Erstellen...',
        cancel: 'Abbrechen',
        no_cases: 'Keine Konsolidierungsfälle gefunden.',
        all_statuses: 'Alle Status',
        all_purposes: 'Alle Zwecke',
        filter_status: 'Nach Status filtern',
        filter_purpose: 'Nach Zweck filtern',
        col_title: 'Titel',
        col_purpose: 'Zweck',
        col_status: 'Status',
        col_progress: 'Fortschritt',
        col_deadline: 'Frist',
        col_department: 'Abteilung',
        col_version: 'Version',
        col_evidence: 'Beweise',
        sections_accepted: 'accepted',
        prev: 'Zurück',
        next: 'Als nächstes',
        page: 'Seite',
        prev_page: 'Vorherige Seite',
        next_page: 'Nächste Seite',
        field_title: 'Titel',
        field_purpose: 'Zweck',
        field_framework: 'Rahmencode',
        field_deadline: 'Frist',
        field_reviewer: 'Benutzer-ID des Prüfers',
        title_placeholder: 'Geben Sie den Falltitel ein',
        framework_placeholder: 'z. B. PDPD-2023',
        reviewer_placeholder: 'Geben Sie die Benutzer-ID des Prüfers ein',
        purposes: {
            dpia_filing: '[[TOK_0]] Einreichung',
            cross_border_filing: 'Grenzüberschreitende Einreichung',
            annual_governance_attestation: 'Jährliche Governance-Bescheinigung',
            breach_package: 'Verstoßpaket',
            audit_inspection_pack: 'Audit-Inspektionspaket',
        },
        statuses: {
            draft: 'Entwurf',
            collecting: 'Sammeln',
            consolidating: 'Konsolidierung',
            review: 'Rezension',
            corrections: 'Korrekturen',
            pending_approval: 'Ausstehende Genehmigung',
            approved: 'Genehmigt',
            completed: 'Abgeschlossen',
            closed: 'Geschlossen',
            rejected: 'Abgelehnt',
        },
        section_statuses: {
            pending: 'Ausstehend',
            in_progress: 'In Bearbeitung',
            submitted: 'Eingereicht',
            accepted: 'Akzeptiert',
            needs_correction: 'Muss korrigiert werden',
            corrected: 'Korrigiert',
        },
        flag_types: {
            missing_section: 'Fehlender Abschnitt',
            conflicting_entry: 'Widersprüchlicher Eintrag',
            stale_entry: 'Veralteter Eintrag',
            missing_evidence: 'Fehlende Beweise',
            incomplete_data: 'Unvollständige Daten',
            duplicate_entry: 'Doppelter Eintrag',
        },
        flag_severities: {
            critical: 'Kritisch',
            warning: 'Warnung',
            info: 'Infos',
        },
        sections_title: 'Abschnitte',
        no_sections: 'Noch keine Abschnitte zugewiesen.',
        flags_title: 'Flaggen',
        no_flags: 'Keine Flags erkannt.',
        open: 'open',
        approval_chain: 'Genehmigungskette',
        pending: 'Ausstehend',
        audit_trail: 'Prüfpfad',
        no_audit: 'Keine Prüfereignisse.',
        auto_assign: 'Abschnitte automatisch zuweisen',
        start_collection: 'Sammlung starten',
        review_case: 'Fall überprüfen',
        generate_export: 'Export generieren',
        review_title: 'Konsolidierungsüberprüfung',
        advance_approval: 'Vorab zur Genehmigung',
        back_to_case: 'Zurück zum Fall',
        accept: 'Akzeptiere',
        return_section: 'Rückkehr',
        return_comment: 'Kommentar zurückgeben...',
        resolve: 'Lösen',
        dismiss: 'Entlassen',
        resolution_notes: 'Lösungshinweise...',
        notes: 'Notizen',
        section_accepted: 'Abschnitt akzeptiert',
        section_returned: 'Abschnitt zur Korrektur zurückgegeben',
        advanced_to_approval: 'Der Fall wurde zur Genehmigung weitergeleitet',
        section_data: 'Abschnittsdaten',
        save_progress: 'Fortschritt speichern',
        submit_section: 'Abschnitt „Senden“.',
        submitting: 'Einreichen...',
        resubmit: 'Erneut einreichen',
        progress_saved: 'Fortschritt gespeichert',
        section_submitted: 'Abschnitt eingereicht',
        correction_required: 'Korrektur erforderlich',
        evidence_title: 'Beweise',
        no_evidence: 'Keine Beweise beigefügt.',
        add_evidence: 'Beweise hinzufügen',
        evidence_added: 'Beweise hinzugefügt',
        evidence_files: 'Beweisakten',
        uploaded_by: 'hochgeladen von',
        comments_title: 'Kommentare',
        no_comments: 'Noch keine Kommentare.',
        comment_placeholder: 'Kommentar hinzufügen...',
        add_comment: 'Kommentar hinzufügen',
        comment_added: 'Kommentar hinzugefügt',
        view_data: 'Eingereichte Daten anzeigen',
        export_title: 'Dossier-Export',
        export_generated: 'Exportpaket generiert',
        regenerate: 'Regenerieren',
        regenerating: 'Regenerierend...',
        generated_at: 'Erstellt am',
        artifacts_title: 'Artefakte exportieren',
        artifact_type: 'Artefakt',
        file_name: 'Dateiname',
        file_size: 'Größe',
        generated: 'Generiert',
        download: 'Herunterladen',
        artifacts: {
            master_report: 'Masterbericht',
            evidence_bundle: 'Beweisbündel (ZIP)',
            contributor_lineage: 'Abstammung des Mitwirkenden',
            conflict_resolution: 'Konfliktlösung',
            approval_history: 'Genehmigungshistorie',
        },
        official_forms: 'Offizielle Formulare',
        forms_description: 'Aus den konsolidierten Daten können folgende amtliche Formulare generiert werden. Offizielle Formulare sind von internen Arbeitspapieren getrennt.',
        announce_loaded_cases: 'Geladene [[TOK_1]] Konsolidierungsfälle',
        announce_case_detail_loaded: 'Falldetail geladen',
        announce_case_transitioned: 'Fall wurde auf [[TOK_1]] umgestellt',
        announce_flag_resolved: 'Flagge gelöst',
        announce_flag_dismissed: 'Flagge abgewiesen',
        case_detail_loaded: 'Falldetail geladen',
        sections_auto_assigned: 'Abschnitte werden automatisch aus der Abteilungshierarchie zugewiesen',
        errors: {
            load_failed: 'Daten konnten nicht geladen werden. Bitte versuchen Sie es erneut.',
            create_failed: 'Fall konnte nicht erstellt werden. Bitte versuchen Sie es erneut.',
            required_fields: 'Bitte füllen Sie alle erforderlichen Felder aus.',
            not_found: 'Nicht gefunden.',
            comment_required: 'Bei der Rückgabe eines Abschnitts ist ein Kommentar erforderlich.',
            notes_required: 'Beim Lösen oder Verwerfen einer Meldung sind Notizen erforderlich.',
        },
    },
    rights_requests: {
        import: {
            title: 'Fälle importieren',
            nav_title: 'Massenimport',
            description: 'Laden Sie eine CSV-Datei hoch, um Rechtsanfragefälle in Massen zu importieren.',
            select_file: 'CSV-Datei auswählen',
            file_help: 'CSV mit Überschriften, die den Fallfeldern entsprechen.',
            file_too_large: 'Datei zu groß. Maximale Größe ist 2MB.',
            preview: 'Vorschau',
            columns_detected: 'Erkannte Spalten: {count}',
            column_mapping: 'Spaltenzuordnung',
            import_button: 'Importieren',
            import_complete: 'Import abgeschlossen',
            import_error: 'Import fehlgeschlagen',
            result: 'Importergebnis',
            total: 'Gesamt',
            imported: 'Importiert',
            skipped: 'Übersprungen',
            failed: 'Fehlgeschlagen',
            errors: 'Fehler',
            error_row: 'Zeile',
            error_field: 'Feld',
            error_message: 'Nachricht',
            history: 'Importverlauf',
            no_history: 'Kein Importverlauf.',
            history_file: 'Dateiname',
            history_date: 'Datum',
        },
        batch: {
            nav_title: 'Batch-Prozess',
            page_title: 'DSR-Batch-Prozess',
            page_subtitle: 'Laden Sie eine [[TOK_1]] ausstehender DSRs hoch. Forseti entwirft eine Bestätigungsantwort pro Anfrage und stellt pro Zeile eine Überprüfungsaufgabe in die Warteschlange. Der [[TOK_0]] überprüft und akzeptiert jeden vor dem Senden.',
            upload_heading: 'Hochladen',
            csv_hint: 'Erforderliche Spalten: request_id, requester_email, request_type. Optional: Frist (ISO-8601), Notizen.',
            rows_heading: '[[TOK_1]] Zeilen analysiert',
            submit_label: 'Batch ausführen',
            submitting: 'Ausarbeitung…',
            col_request_id: 'Anfrage-ID',
            col_email: 'E-Mail des Antragstellers',
            col_type: 'Typ',
            col_status: 'Status',
            col_actions: 'Aktionen',
            status_queued: 'In der Warteschlange',
            status_drafted: 'Ausgearbeitet',
            status_failed: 'Fehlgeschlagen',
            status_accepted: 'Akzeptiert',
            status_rejected: 'Abgelehnt',
            'status_parsing-error': 'Parse-Fehler',
            accept: 'Akzeptiere',
            reject: 'Ablehnen',
            permission_denied: 'Sie sind nicht berechtigt, Forseti-Workflows auszuführen.',
        },
    },
    assessment_triggers: {
        title: 'Bewertungsauslöser',
        subtitle: 'Konfigurieren Sie die automatische Erstellung von Bewertungen und [[TOK_0]]-Benachrichtigungen für Datenschutz-Workflows.',
        auto_create_dpia_label: '[[TOK_0]] automatisch erstellen, wenn die Verarbeitung einer Aktivität erforderlich ist, die als [[TOK_1]] markiert ist',
        auto_notify_new_purpose_label: 'Automatische Benachrichtigung [[TOK_0]], wenn ein neuer Zweck mit sensiblen Datenkategorien erstellt wird',
        auto_notify_cross_border_label: 'Automatische Benachrichtigung [[TOK_0]], wenn grenzüberschreitende Übertragung zur Verarbeitungsaktivität hinzugefügt wird',
        default_dpo_label: 'Standard [[TOK_0]]',
        default_dpo_placeholder: 'Wählen Sie den Standard [[TOK_0]]...',
        notification_channels_label: 'Benachrichtigungskanäle',
        channel_in_app: 'In-App',
        channel_email: 'Email',
        save_success: 'Einstellungen für Bewertungsauslöser gespeichert.',
        save_error: 'Die Einstellungen für den Bewertungsauslöser konnten nicht gespeichert werden.',
        fetch_error: 'Die Einstellungen für den Bewertungsauslöser konnten nicht geladen werden.',
        fetch_users_error: 'Benutzer konnten nicht geladen werden.',
        announce_loaded: 'Einstellungen für Bewertungsauslöser geladen',
        dpia_status: '[[TOK_0]] Status',
        dpia_linked: '[[TOK_0]] Verknüpft',
        dpia_required_no_dpia: '[[TOK_0]] Erforderlich – nicht erstellt',
        create_dpia: 'Erstellen Sie [[TOK_0]]',
        create_dpia_success: '[[TOK_0]] erstellt und mit Aktivität verknüpft.',
        create_dpia_error: '[[TOK_0]] für Aktivität konnte nicht erstellt werden.',
        view_dpia: 'Anzeigen [[TOK_0]]',
    },
    data_subjects: {
        title: 'Profile betroffener Personen',
        nav_title: 'Betroffene Personen',
        nav: {
            profiles: 'Profile',
        },
        create: 'Profil erstellen',
        edit: 'Profil bearbeiten',
        delete: 'Profil löschen',
        delete_confirm: 'Sind Sie sicher, dass Sie dieses Profil der betroffenen Person löschen möchten?',
        display_name: 'Anzeigename',
        email: 'Email',
        phone: 'Telefon',
        employee_id: 'Mitarbeiter-ID',
        student_id: 'Studentenausweis',
        notes: 'Notizen',
        external_refs: 'Externe Referenzen',
        cases_count: 'Fälle',
        workflows_count: 'Einwilligungsaufzeichnungen',
        last_activity: 'Letzte Aktivität',
        timeline: 'Zeitleiste',
        link_case: 'Link Case',
        link_workflow: 'Link Workflow',
        no_profiles: 'Es wurden keine Profile der betroffenen Personen gefunden.',
        search_placeholder: 'Suchen Sie nach Name, E-Mail, Telefon oder ID ...',
        create_success: 'Betroffenenprofil erstellt.',
        create_error: 'Das Profil der betroffenen Person konnte nicht erstellt werden.',
        update_success: 'Profil der betroffenen Person aktualisiert.',
        update_error: 'Das Profil der betroffenen Person konnte nicht aktualisiert werden.',
        delete_success: 'Betroffenenprofil gelöscht.',
        delete_error: 'Das Profil der betroffenen Person konnte nicht gelöscht werden.',
        link_case_success: 'Fall mit Profil verknüpft.',
        link_case_error: 'Fall konnte nicht mit Profil verknüpft werden.',
        link_workflow_success: 'Mit dem Profil verknüpfter Workflow.',
        link_workflow_error: 'Workflow konnte nicht mit Profil verknüpft werden.',
        load_error: 'Das Laden der Profile der betroffenen Personen ist fehlgeschlagen.',
        detail_load_error: 'Das Profil der betroffenen Person konnte nicht geladen werden.',
        timeline_load_error: 'Zeitleiste konnte nicht geladen werden.',
        tab_cases: 'DSR-Fälle',
        tab_consent: 'Einwilligungsaufzeichnungen',
        tab_timeline: 'Zeitleiste',
        tab_consent_workflows: 'Einwilligungsworkflows',
        tab_web_consent: '[[TOK_0]] Einwilligung',
        web_consent_empty: 'Für dieses Thema wurden keine [[TOK_0]] Einwilligungsdatensätze gefunden.',
        web_consent_load_error: '[[TOK_0]] Einwilligungsdatensätze konnten nicht geladen werden.',
        col_policy_version: 'Richtlinienversion',
        col_versions: 'Versionen',
        col_consent_version: 'Zustimmung',
        col_cookie_declaration_version: 'Cookie-Erklärung',
        col_purposes: 'Zwecke',
        purpose_granted: 'Zugegeben',
        purpose_denied: 'Abgelehnt',
        granted_domains: 'Zugegeben',
        denied_domains: 'Abgelehnt',
        col_action: 'Aktion',
        col_timestamp: 'Zeitstempel',
        col_domain: 'Domäne',
        no_cases: 'Keine verknüpften Fälle.',
        no_workflows: 'Keine verknüpften Einwilligungsworkflows.',
        no_timeline: 'Keine Timeline-Ereignisse.',
        case_id: 'Fall-ID',
        case_status: 'Status',
        case_type: 'Anfragetyp',
        case_created: 'Erstellt',
        workflow_id: 'Workflow-ID',
        workflow_type: 'Typ',
        workflow_status: 'Status',
        workflow_created: 'Erstellt',
        timeline_date: 'Datum',
        timeline_event: 'Veranstaltung',
        timeline_details: 'Einzelheiten',
        timeline_time: 'Zeit',
        timeline_type: 'Typ',
        timeline_summary: 'Zusammenfassung',
        type_case: 'DSR-Gehäuse',
        type_consent_workflow: 'Einwilligungsworkflow',
        profile_info: 'Profilinformationen',
        announce_loaded: 'Profile der betroffenen Personen geladen',
        announce_detail_loaded: 'Profil der betroffenen Person geladen',
        select_case: '— Fall auswählen —',
        select_workflow: '— Workflow auswählen —',
        no_cases_hint: 'Verknüpfen Sie Fälle, um sie hier zu sehen.',
        no_workflows_hint: 'Verknüpfen Sie Einwilligungs-Workflows, um sie hier zu sehen.',
    },
    flows: {
        map: {
            description_prefix: '{systems} Systeme · {flows} Datenflüsse · {crossBorder} grenzüberschreitend · {highRisk} hohes/kritisches Risiko',
            switch_to_list: 'Zur Listenansicht wechseln',
            switch_to_list_aria: 'Zur Tabellenansicht wechseln',
            svg_aria: 'Datenflusskarte: {systems} Systeme, {flows} Datenflüsse, {crossBorder} grenzüberschreitend',
            selected_system: 'Ausgewähltes System',
            drill_hint: 'Öffnen Sie den Reiter „Liste", um verknüpfte Datenflüsse, DSFAs und Dienstleisterzuordnungen für dieses System zu bearbeiten.',
        },
    },
    packages: {
        light: {
            name: 'Licht',
            description: 'Wesentliche Datenschutz-Compliance-Tools für kleine Teams',
        },
        standard: {
            name: 'Standard',
            description: 'Voll ausgestattete Compliance-Plattform für wachsende Organisationen',
        },
        enterprise_unlimited: {
            name: 'Enterprise Unlimited',
            description: 'Compliance auf Enterprise-Niveau mit Multi-Org-Unterstützung und dedizierten Diensten',
        },
    },
    forseti: {
        providerSettings: {
            title: 'Forseti [[TOK_0]] Anbietereinstellungen',
            subtitle: 'Konfigurieren Sie den Claude-Anbieter für den Forseti [[TOK_0]] Legal Advisor.',
            healthHeading: 'Gesundheit des Anbieters',
            statusLabel: 'Status',
            statusOk: 'Okay',
            statusFailed: 'Nicht verfügbar',
            providerLabel: 'Anbieter',
            providerClaudeApi: 'Claude [[TOK_0]]',
            providerCliRelay: 'Claude CLI-Relais',
            providerAesirManaged: 'Von Aesir verwaltete Token',
            lastCheckedLabel: 'Zuletzt überprüft',
            reasonLabel: 'Grund',
            refreshButton: 'Aktualisieren',
            apiKeyHeading: 'Claude [[TOK_0]]-Taste',
            apiKeyHint: 'Das Setzen einer [[TOK_0]]-Taste aktiviert den Claude-[[TOK_1]]-Modus. Lassen Sie die Option deaktiviert, um das lokale CLI-Relay zu verwenden (Entwickler-/selbstgehosteter Modus).',
            apiKeyLabel: '[[TOK_0]]-Taste',
            apiKeyMinLength: 'Mindestens 32 Zeichen. Im Ruhezustand verschlüsselt; nie wieder gezeigt.',
            apiKeyTooShort: 'Der Schlüssel [[TOK_0]] muss mindestens 32 Zeichen lang sein.',
            apiKeySaved: '[[TOK_0]] Schlüssel gespeichert. Erfrischende Gesundheit…',
            apiKeyCleared: '[[TOK_0]]-Taste gelöscht. Forseti verwendet jetzt das lokale CLI-Relay.',
            setKeyButton: 'Speichern Sie die Taste [[TOK_0]].',
            clearKeyButton: 'Taste [[TOK_0]] löschen (CLI-Relais verwenden)',
        },
        usage: {
            title: 'Nutzung',
            subtitle: 'Tokenverbrauch und Bucket-Status für diese Organisation.',
            bucketHeading: 'Monatlicher Token-Bucket',
            remainingLabel: 'Übrig',
            consumedLabel: 'Verbraucht',
            totalLabel: 'Insgesamt',
            unitsLabel: 'abrechenbare Einheiten',
            lastReconciledLabel: 'Zuletzt versöhnt',
            recentHeading: 'Aktuelle Aktivität',
            historyHeading: 'Letzte 12 Perioden',
            noActivity: 'In diesem Zeitraum noch keine Aktivität.',
            featureLabel: 'Funktion',
            whenLabel: 'Wann',
            periodLabel: 'Zeitraum',
            topUpButton: 'Fordern Sie ein Aufladepaket an',
            topUpHint: 'Wenden Sie sich an Ihren Account Manager, um ein Aufladepaket anzufordern.',
            buyMore: {
                buyButton: 'Weitere Einheiten kaufen',
                purchaseTitle: 'Weitere Abrechnungseinheiten kaufen',
                purchaseSubtitle: 'Wählen Sie ein Paket. Sie werden zur sicheren Stripe-Kasse weitergeleitet, und Ihre Rechnung erhalten Sie per E-Mail.',
                packageLabel: 'Paket',
                optionTemplate: '{name} — {units} {units_label} — {price}',
                packageSmall: 'Klein',
                packageMedium: 'Mittel',
                packageLarge: 'Groß',
                checkoutButton: 'Weiter zur Kasse',
                checkoutPending: 'Kasse wird geöffnet…',
                cancelButton: 'Abbrechen',
                purchaseError: 'Kasse konnte nicht gestartet werden. Bitte versuchen Sie es in Kürze erneut.',
                redeemTitle: 'Eine Rechnung einlösen',
                redeemSubtitle: 'Bereits bezahlt? Wählen Sie das gekaufte Paket aus und geben Sie die Rechnungsnummer aus Ihrer E-Mail ein, um die Einheiten hinzuzufügen.',
                invoiceLabel: 'Rechnungsnummer',
                invoicePlaceholder: 'JJVExxxX-0001',
                redeemButton: 'Einlösen',
                redeemPending: 'Wird eingelöst…',
                redeemSuccess: 'Einheiten wurden Ihrem Kontingent hinzugefügt.',
                redeemAlready: 'Diese Rechnung wurde bereits eingelöst.',
                errorNotFound: 'Es wurde keine Rechnung mit dieser Nummer gefunden. Überprüfen Sie die Rechnungsnummer und versuchen Sie es erneut.',
                errorNotPaid: 'Diese Rechnung ist noch nicht als bezahlt markiert.',
                errorOrgMismatch: 'Diese Rechnung wurde nicht für Ihre Organisation ausgestellt.',
                errorPackageMismatch: 'Diese Rechnung stimmt nicht mit dem ausgewählten Paket überein.',
                errorInvalidInvoice: 'Geben Sie eine gültige Rechnungsnummer ein.',
                errorGeneric: 'Einlösen fehlgeschlagen. Bitte versuchen Sie es in Kürze erneut.',
            },
            byFeatureHeading: 'Diesen Monat nach Feature',
            byFeatureEmpty: 'In diesem Zeitraum noch keine Feature-Aktivität.',
            featureColumn: 'Funktion',
            featureUnitsColumn: 'Einheiten',
            featureRunsColumn: 'Läuft',
            byUserHeading: 'Diesen Monat nach Benutzer (Administratoransicht)',
            byUserEmpty: 'In diesem Zeitraum noch keine Aktivität pro Benutzer.',
            userColumn: 'Benutzer',
            reconciliationLinkLabel: 'Bericht zur Abstimmungsdrift anzeigen',
            reconciliationLinkHint: 'Nur Aesir-interner Administrator.',
            featureLabels: {
                chat: 'Chatten',
                workflow: 'Workflow-Ausführung',
                tabular: 'Tabellarische Extraktion',
                redline: 'Redline-Rezension',
                title: 'Gesprächstitel',
                unknown: 'Andere',
            },
        },
        reconciliation: {
            title: 'Forseti-Quotenabstimmung',
            subtitle: 'Drift zwischen dem schnellen Kontingentzähler-Cache und dem maßgeblichen Abrechnungsbuch. Der Abgleicher wird alle 5 Minuten ausgeführt. Auf dieser Seite werden der letzte Lauf und der Verlauf angezeigt. Nur Aesir-interner Administrator.',
            backLink: 'Zurück zur Forseti-Nutzung',
            stubHeading: 'Die Versöhnungsgeschichte folgt in Kürze',
            stubBody: 'Die Abgleichs-Worker-Protokolle driften über den strukturierten Protokollkanal. Ein Back-End-Leseendpunkt, der die letzten 30 Abstimmungsläufe offenlegt, wird auf den Gültigkeitsbereich beschränkt (verschoben von Sprint 47.5.9.6 – siehe Arbeitsdatei). Sobald der Endpunkt gelandet ist, werden auf dieser Seite die Ausführungsverlaufstabelle und das P0-Drift-Banner angezeigt.',
            stubBackendOwner: 'Backend-Verzögerung: Behalten Sie die Abstimmungsausführungen in einer neuen Sammlung bei und fügen Sie die Route „GET /llm-relay/quota/reconciliation“ hinzu.',
            permissionDenied: 'Diese Seite ist auf Aesir-interne Administratoren beschränkt. Wenn Sie der Meinung sind, dass Sie Zugriff haben sollten, wenden Sie sich an Ihren [[TOK_0]]-Vertreter.',
        },
        projects: {
            title: 'Projekte',
            subtitle: 'Arbeitsbereiche für Dokumente, Gespräche, Arbeitsabläufe und Überprüfungen.',
            modeLabel: 'Ansicht',
            tabMine: 'Meine Projekte',
            tabShared: 'Mit mir geteilt',
            searchLabel: 'Projekte suchen',
            searchPlaceholder: 'Suchen…',
            newButton: 'Neues Projekt',
            colName: 'Name',
            colVisibility: 'Sichtbarkeit',
            colDocs: 'Dokumente',
            colMembers: 'Mitglieder',
            colUpdated: 'Aktualisiert',
            visibilityOwn: 'Nur besitzen',
            visibilityShared: 'Geteilt',
            emptyMine: 'Noch keine Projekte. Erstellen Sie eines, um loszulegen.',
            emptyShared: 'Es wurden keine Projekte mit Ihnen geteilt.',
            pageHint: 'Zeigt [[TOK_2]] von [[TOK_3]].',
            createTitle: 'Neues Projekt',
            createSubmit: 'Projekt erstellen',
            fieldName: 'Name',
            fieldDescription: 'Beschreibung (optional)',
            fieldCmNumber: 'Fall-/Angelegenheitsnummer (optional)',
            fieldVisibility: 'Sichtbarkeit',
            errorNameRequired: 'Name ist erforderlich.',
            errorSelectorRequired: 'Wählen Sie einen Benutzer oder eine Organisationsgruppe aus, die Sie hinzufügen möchten.',
            renameButton: 'Umbenennen',
            renamePrompt: 'Projekt umbenennen',
            deleteButton: 'Löschen',
            deleteConfirm: 'Dieses Projekt löschen? Es wird 30 Tage lang aufbewahrt, bevor es endgültig entfernt wird.',
            deleteFolderConfirm: 'Diesen Ordner löschen? Die darin enthaltenen Dokumente bleiben im Projekt und werden lediglich nicht abgelegt.',
            removeMemberConfirm: 'Dieses Mitglied entfernen?',
            foldersHeading: 'Ordner',
            foldersEmpty: 'Noch keine Ordner.',
            addFolderButton: 'Neuer Ordner',
            addFolderTitle: 'Neuer Ordner',
            documentsHeading: 'Dokumente',
            documentsEmpty: 'Noch keine Dokumente beigefügt.',
            colFilename: 'Dateiname',
            colAdded: 'Hinzugefügt',
            unattachButton: 'Trennen',
            membersHeading: 'Mitglieder',
            membersEmpty: 'Nur Eigentümer.',
            addMemberButton: 'Mitglied hinzufügen',
            addMemberTitle: 'Mitglied hinzufügen',
            addMemberSubmit: 'Mitglied hinzufügen',
            colMember: 'Mitglied',
            colRole: 'Rolle',
            selectorTypeLabel: 'Hinzufügen von',
            selectorUser: 'Benutzer-ID',
            selectorGroup: 'Organisationsgruppen-ID',
            fieldUserId: 'Benutzer',
            fieldGroupId: 'Org-Gruppe',
            fieldRole: 'Rolle',
            roleAdmin: 'Admin',
            roleEditor: 'Herausgeber',
            roleViewer: 'Zuschauer',
            notFound: 'Projekt nicht gefunden.',
            selectUserPlaceholder: 'Wählen Sie einen Benutzer aus…',
            selectGroupPlaceholder: 'Wählen Sie eine Organisationsgruppe aus…',
            noUsersAvailable: 'Keine Benutzer verfügbar.',
            noGroupsAvailable: 'Keine Organisationsgruppen verfügbar.',
            loadFailed: 'Optionen konnten nicht geladen werden.',
            deleteProjectTitle: 'Projekt löschen?',
            deleteFolderTitle: 'Ordner löschen?',
            removeMemberTitle: 'Mitglied entfernen?',
            removeMemberConfirmGeneric: 'Dieses Mitglied aus dem Projekt entfernen?',
            addDocumentButton: 'Dokument hinzufügen',
            addDocumentTitle: 'Dokument zum Projekt hinzufügen',
            fieldDocument: 'Dokument auswählen',
            selectDocPlaceholder: 'Nach einem Dokument suchen...',
            ownerLabel: 'Systemeigentümer',
        },
        chat: {
            sidebarLabel: 'Chats',
            overviewTitle: 'Forseti',
            overviewSubtitle: 'Ihr [[TOK_0]] Rechts- und Compliance-Berater – basierend auf Ihren Mieterdaten und Ihren installierten Regulierungspaketen.',
            personaSelectorLabel: 'Persona',
            personaHeading: 'Wählen Sie eine Person',
            startChatButton: 'Starten Sie einen neuen Chat',
            startingChat: 'Chat wird gestartet…',
            recentHeading: 'Aktuelle Chats',
            recentEmpty: 'Noch keine Chats – starten Sie oben einen.',
            untitledChat: 'Neuer Chat',
            messageListLabel: 'Gespräch',
            detailSubtitle: 'Persona: [[TOK_1]]',
            composeHeading: 'Senden Sie eine Nachricht',
            composeLabel: 'Nachricht Forseti',
            composeDisabledPlaceholder: 'Die Nachrichtenkomposition landet im nächsten Sprint (47.5.4b – SSE-Streaming + Tool-Call-Schleife).',
            composeDisabledHint: 'Schreibgeschützte Vorschau wird in 47.5.4a ausgeliefert. Streaming + Toolaufrufe landen in 47.5.4b.',
            switchPersonaHeading: 'Persona',
            presetPersona: 'Voreingestellte Persona',
            changePersona: 'Persona ändern',
            hidePersonaOptions: 'Personaoptionen ausblenden',
            starterHeading: 'Beginnen Sie mit einer dieser Aktionen',
            renameButton: 'Umbenennen',
            renamePrompt: 'Chat umbenennen',
            deleteButton: 'Löschen',
            deleteConfirm: 'Diesen Chat löschen? Es wird 30 Tage lang aufbewahrt, bevor es endgültig entfernt wird.',
            notFound: 'Chat nicht gefunden.',
            emptyChat: 'Noch keine Nachrichten – sagen Sie „Hallo“, um ein Gespräch zu beginnen.',
            roleUser: 'Du',
            roleAssistant: 'Forseti',
            roleSystem: 'System',
            thinkingLabel: 'Denken',
            toolCallPlaceholder: 'Werkzeugaufruf:',
            toolResultPlaceholder: 'Werkzeugergebnis ausgeblendet – vollständige Benutzeroberfläche landet in 47.5.4b.',
            docEditPlaceholder: 'Vorgeschlagene Dokumentänderungen (V[[TOK_1]]).',
            disclaimer: 'Forseti unterstützt Ihr Urteil – es ersetzt keinen zugelassenen Anwalt.',
            sendButton: 'Senden',
            sending: 'Senden…',
            composePlaceholder: 'Fragen Sie Forseti…',
            composingPlaceholder: 'Forseti antwortet…',
            streamingPlaceholder: 'Forseti tippt…',
            promptInjectionTitle: 'Forseti ließ einige Kontrolltoken fallen.',
            promptInjectionBody: 'Entfernte Muster: [[TOK_1]]. Forseti sieht nur Ihren Nachrichtentext.',
            promptInjectionInline: 'Forseti hat Kontrolltokens ([[TOK_1]]) aus Ihrer Nachricht gelöscht.',
            rateLimitTitle: 'Sie senden Nachrichten zu schnell.',
            rateLimitRetryAfter: 'Versuchen Sie es in [[TOK_1]]s noch einmal.',
            counselReviewTitle: 'Forseti ist hier unsicher.',
            counselReviewBody: 'Lassen Sie sich von einem zugelassenen Anwalt beraten, bevor Sie dieser Antwort folgen.',
            legalConclusionRefused: 'Forseti weigerte sich, ohne Begründung eine rechtliche Schlussfolgerung zu ziehen. Versuchen Sie es zuerst mit search_regulatory oder eskalieren Sie es an einen Anwalt.',
            toolCallDone: 'Erledigt.',
            toolCallArgsLabel: 'Argumente',
            toolCallResultLabel: 'Ergebnis',
            toolResultLogged: 'Tool-Ergebnis im Audit-Protokoll erfasst.',
            toolResultAria: 'Werkzeugergebnis',
            documentEditAria: 'Dokument bearbeiten',
            createTaskFromMessage: 'Erstellen Sie daraus eine Aufgabe',
            createTaskHeading: 'Erstellen Sie eine Aufgabe aus dieser Nachricht',
            createTaskTitleLabel: 'Titel',
            createTaskTitleRequired: 'Titel ist erforderlich.',
            createTaskDescriptionLabel: 'Beschreibung',
            createTaskAssigneeLabel: 'Bevollmächtigter',
            createTaskAssigneePlaceholder: 'Beauftragten auswählen…',
            createTaskAssigneeNone: '– nicht zugewiesen –',
            createTaskDueDateLabel: 'Fälligkeitsdatum',
            createTaskWorkflowLabel: 'Verknüpfter Workflow (optional)',
            createTaskWorkflowPlaceholder: 'Wählen Sie einen Workflow aus…',
            createTaskWorkflowNone: '– keine –',
            renameModalSubmit: 'Umbenennen',
            renameModalSaving: 'Sparen…',
            deleteConfirmTitle: 'Chat löschen?',
            createTaskSubmit: 'Aufgabe erstellen',
            createTaskSubmitting: 'Erstellen…',
            cancelButton: 'Abbrechen',
            autoRouteHintMessage: 'Diese Frage liegt eher im Steuerhaus von [[TOK_1]].',
            autoRouteSwitchButton: 'Wechseln Sie zu [[TOK_1]]',
            autoRouteSwitching: 'Wechseln…',
            handoffSuggestionMessage: 'Oder eröffnen Sie einen neuen Chat mit [[TOK_1]] und tragen Sie diese Frage weiter.',
            handoffSuggestionButton: 'Neuen Chat starten mit [[TOK_1]]',
            handoffSuggestionWorking: 'Eröffnung…',
            handoffSuggestionDismiss: 'Nicht jetzt',
            persona_display: {
                'forseti-generalist': 'Forseti',
                'forseti-compliance': 'Compliance-Spezialist',
                'forseti-legal': 'Rechtsberater',
                'forseti-dpo': 'DSB-Berater',
                'forseti-risk': 'Risikoanalyst',
                'forseti-auditor': 'Auditorenperspektive',
            },
            exportButton: 'PDF exportieren',
            exportRunning: 'Exportiert…',
            exportSuccess: 'Exportiert: {filename} (Datei-Browser öffnen).',
            citation: {
                verifyBadge: '[VERIFIZIEREN]',
                verifyAria: 'Zitat konnte nicht überprüft werden – überprüfen Sie es, bevor Sie sich darauf verlassen',
                popoverAria: 'Quelle für [[TOK_1]]',
                openSource: 'Open-Source-Seite',
            },
        },
        auditTrail: {
            forsetiBadge: 'Forseti',
            forsetiBadgeTooltip: '[[TOK_0]]-generiertes Ereignis aus dem Forseti-Prüfpfad.',
        },
        rowAction: {
            ask: 'Fragen Sie Forseti',
            tooltipOpen: 'Fragen Sie Forseti danach [[TOK_1]]',
            tooltipLocked: 'Dieses [[TOK_1]] ist gesperrt – Forseti kann Fragen beantworten, aber keine Änderungen vornehmen.',
        },
        advisorRunPanel: {
            title: 'Forseti – über diese Platte',
            heading: 'Forseti — [[TOK_1]]',
            summaryLabel: 'Zusammenfassung',
            suggestedPersona: 'Vorgeschlagene Person',
            askForseti: 'Fragen Sie Forseti',
            runWorkflow: 'Führen Sie einen Workflow aus',
            viewLineage: 'Audit-Herkunft anzeigen',
            createPdplEvidencePack: 'PDPL-Nachweispaket erstellen',
            prepareBreachDraft: 'Benachrichtigungsentwurf vorbereiten',
            primaryActions: {
                projectSummary: 'Projektdokument zusammenfassen',
                supplementSummary: 'Ergänzungsanfrage zusammenfassen',
                authoritySummary: 'Behördenanfrage zusammenfassen',
                rightsRequestResponse: 'DSR-Antwort entwerfen',
                dpiaQuickReview: 'DPIA-Schnellprüfung ausführen',
                taskControlWalkthrough: 'Kontrollnachweise durchgehen',
                vendorRiskNarrative: 'Lieferantenrisiko-Narrativ erstellen',
                incidentLetter: 'PDPL-Verstoßbrief entwerfen',
                ropaSufficiency: 'RoPA-Vollständigkeitsprüfung ausführen',
                vendorDpaReview: 'Lieferanten-DPA-Prüfung ausführen',
            },
            builtinWorkflowViews: {
                ropaSufficiency: {
                    title: 'RoPA Sufficiency Check',
                    notice: 'Runs the existing RoPA sufficiency workflow for this processing activity. The run may create draft follow-up tasks; operators still review and execute them.',
                },
                vendorDpaReview: {
                    title: 'Vendor DPA Review',
                    notice: 'Runs the existing Vendor DPA Review workflow for this vendor contract. The run may create draft follow-up tasks; operators still review every finding and task.',
                },
                vendorRiskNarrative: {
                    title: 'Vendor Risk Narrative',
                    notice: 'Runs the existing vendor risk narrative workflow for this vendor. Output remains draft evidence; the human risk owner reviews and approves it before use.',
                },
                incidentLetter: {
                    title: 'PDPL Breach Notification Letter',
                    notice: 'Runs the existing VN PDPL breach-notification letter workflow for this incident or playbook activation. Output remains draft only; formal regulator filing still requires human sign-off.',
                },
                projectSummary: {
                    title: 'Project Document Summary',
                    notice: 'Runs the existing uploaded-document summary workflow for this Forseti project. The workflow is read-only and does not create tasks, evidence, or record updates.',
                },
                supplementSummary: {
                    title: 'Supplement Request Summary',
                    notice: 'Runs the existing uploaded-document summary workflow for this supplement request. The workflow is read-only and does not create tasks, evidence, record updates, or filing decisions.',
                },
                authoritySummary: {
                    title: 'Authority Request Summary',
                    notice: 'Runs the existing uploaded-document summary workflow for this authority request. The workflow is read-only and does not create tasks, evidence, record updates, filing decisions, or authority-response drafts.',
                },
                rightsRequestResponse: {
                    title: 'DSR Response Draft',
                    notice: 'Runs the existing DSR response draft workflow for this rights request. Output remains draft only; sending and case updates still require the existing human-reviewed rights-request flow.',
                },
                dpiaQuickReview: {
                    title: 'DPIA Quick Review',
                    notice: 'Runs the existing DPIA Quick Review workflow for this DPIA. The run may create draft follow-up tasks; operators still review every finding and task.',
                },
                taskControlWalkthrough: {
                    title: 'Control Evidence Walkthrough',
                    notice: 'Runs the existing compliance-control walkthrough for this task. The workflow must retrieve regulatory anchors before citing them, does not issue legal conclusions or mark controls/evidence approved, and only creates draft evidence placeholders when the operator explicitly requests them.',
                },
            },
            breachDraftNotice: 'Forseti erstellt nur Entwurfsinhalte für das verknüpfte Mẫu số 08. Es entscheidet nicht über die Meldepflicht und reicht oder sendet das Formular nicht ein.',
            breachDraftReady: 'Mẫu số 08-Entwurf ist zur Prüfung bereit',
            breachDraftReviewBeforeSelecting: 'Vor der Auswahl prüfen',
            workflowHeading: 'Relevante Workflows',
            workflowLoading: 'Relevante Workflows werden geladen…',
            workflowEmpty: 'Für diesen Datensatz sind keine relevanten Workflows verfügbar.',
            workflowError: 'Relevante Workflows konnten nicht geladen werden.',
            selectWorkflow: '{title} auswählen',
            workflowSelected: 'Workflow ausgewählt. Der eingebettete Runner öffnet sich im nächsten Schritt.',
            workflowRunSelected: 'Ausgewählten Workflow ausführen',
            workflowStarting: 'Workflow wird gestartet…',
            workflowRunError: 'Dieser Workflow konnte nicht gestartet werden.',
            workflowQuotaExhausted: 'Ihr Forseti-Nutzungskontingent reicht nicht aus, um diesen Workflow zu starten.',
            workflowTopUp: 'Nutzung prüfen und eine Aufstockung anfordern',
            workflowCreateGuided: 'Geführten Workflow für diesen Datensatz erstellen',
            lineageHeading: 'Audit-Verlauf für diesen Datensatz',
            lineageLoading: 'Audit-Verlauf wird geladen…',
            lineageEmpty: 'Für diesen Datensatz sind keine Forseti-Verlaufsereignisse erfasst.',
            lineageError: 'Audit-Verlauf konnte nicht geladen werden.',
            retry: 'Wiederholen',
            chatContextLoading: 'Datensatzkontext wird geladen…',
            chatGuidance: {
                general: 'Forseti kann diesen Datensatz zusammenfassen, fehlende Informationen erkennen und Prüfschritte vorschlagen.',
                privacy: 'Forseti kann Datenschutzangaben prüfen, Pflichten aus installierten Regelwerken abgleichen und einen Entwurf zur menschlichen Prüfung vorbereiten.',
                compliance: 'Forseti kann Compliance-Lücken erkennen, Anforderungen mit installierten Quellen belegen und verantwortliche nächste Schritte vorschlagen.',
                legal: 'Forseti kann den Datensatz zusammenfassen, belegte Quellen auffinden und einen Entwurf zur anwaltlichen Prüfung vorbereiten.',
                risk: 'Forseti kann dokumentierte Risiken bewerten, fehlende Angaben kennzeichnen und angemessene Prüfschritte vorschlagen.',
                audit: 'Forseti kann Nachweislücken untersuchen, den Datensatz installierten Kontrollen zuordnen und auditfähige Folgemaßnahmen vorschlagen.',
            },
            starterPrompts: {
                identifyGaps: 'Welche Informationen oder Nachweise fehlen in diesem Datensatz?',
                reviewFrameworks: 'Welche Pflichten aus unseren installierten Regelwerken sollte ich für diesen Datensatz prüfen?',
                prepareDraft: 'Helfen Sie mir, einen Entwurf ausschließlich auf Grundlage dieses Datensatzes und belegter installierter Quellen zu erstellen.',
                nextSteps: 'Welche Prüfschritte sollte ich als Nächstes durchführen?',
                summarizeRecord: 'Fassen Sie diesen Datensatz zusammen und kennzeichnen Sie Punkte, die menschlich geprüft werden müssen.',
                assessRisk: 'Bewerten Sie die dokumentierten Risiken, erkennen Sie fehlende Angaben und schlagen Sie Prüfschritte vor.',
            },
            disclaimer: 'Forseti unterstützt Ihr Urteil – es ersetzt keinen zugelassenen Anwalt.',
            recordType: {
                project: 'Projekt',
                dpia: '[[TOK_0]]',
                dossier_filing: 'Dossiereinreichung',
                transfer_assessment: 'Grenzüberschreitende Übertragung',
                vendor: 'Anbieter',
                vendor_contract: 'Lieferantenvertrag',
                vendor_acceptance: 'Akzeptanz des Lieferantenrisikos',
                incident: 'Vorfall',
                incident_op: 'Einsatz bei Vorfällen',
                breach_notification: 'Benachrichtigung über Verstöße',
                authority_request: 'Anfrage der Behörde',
                supplement_request: 'Ergänzungsanfrage',
                rights_request: 'Rechteanfrage',
                contract: 'Vertrag',
                task: 'Aufgabe',
                data_mapping_activity: 'RoPA-Aktivität',
                compliance_rule: 'Compliance-Regel',
                program: 'Programm',
                governance_document: 'Governance-Dokument',
                remediation_plan: 'Sanierungsplan',
                cross_border_filing: 'Grenzüberschreitende Einreichung',
            },
        },
        autocomplete: {
            button_label: 'Bitten Sie Forseti, dies zu verfassen',
            drafting: 'Ausarbeitung…',
            hint_pick_activity: 'Wählen Sie eine verknüpfte Verarbeitungsaktivität aus, um Forseti Drafting zu aktivieren.',
            draft_origin_label: 'Forseti-Entwurf – Überprüfung pro Bereich',
            tokens_label: '≈ [[TOK_1]] Token aus Ihrem monatlichen Bucket',
            accept_selected: 'Ausgewählte akzeptieren',
            reject_all: 'Entwurf ablehnen',
            field_checkbox_label: 'Forseti-Entwurf für [[TOK_1]] anwenden',
            field_labels: {
                description: 'Beschreibung',
                purpose: 'Zweck',
                data_subjects: 'Betroffene Personen',
                data_types: 'Datentypen',
                necessity_justification: 'Notwendigkeit und Verhältnismäßigkeit',
                consultation_notes: 'Beratungshinweise',
                dpo_opinion: '[[TOK_0]] Meinung',
                system_ids: 'Vernetzte Systeme',
                vendor_ids: 'Verlinkte Anbieter',
            },
            error_generic: 'Forseti konnte dieses [[TOK_0]] nicht entwerfen. Versuchen Sie es erneut oder verfeinern Sie den Aktivitätsdatensatz.',
            variant_legend: 'Rahmenrahmen',
            variant_label_gdpr: '[[TOK_0]]',
            variant_label_pdpl: '[[TOK_0]]',
            variant_label_nis2: '[[TOK_0]]',
            variant_label_iso27001: 'ISO 27001',
            variant_label_soc2: 'SOC 2',
            conflict_banner: 'Achtung: [[TOK_1]] Framework-übergreifende Konflikte gelten für diese Variante. Überprüfen Sie es, bevor Sie es akzeptieren.',
        },
        tia: {
            button_label: 'Bitten Sie Forseti, diese TIA zu entwerfen',
            drafting: 'Ausarbeitung der TIA…',
            hint_pick_destination: 'Legen Sie das Zielland im Übertragungsdatensatz fest, bevor Forseti einen Entwurf erstellen kann.',
            draft_origin_label: 'Forseti TIA-Entwurf – Überprüfung pro Bereich',
            tokens_label: '≈ [[TOK_1]] Token aus Ihrem monatlichen Bucket',
            accept_selected: 'Ausgewählte akzeptieren',
            reject_all: 'Entwurf ablehnen',
            field_checkbox_label: 'Forseti-Entwurf für [[TOK_1]] anwenden',
            error_generic: 'Forseti konnte diese TIA nicht entwerfen. Versuchen Sie es erneut oder verfeinern Sie den Übertragungsdatensatz.',
            usage_details: 'KI-Nutzungsdetails',
            applied_status: 'Entwurf übernommen. Überprüfen Sie die ausgefüllten Felder und wählen Sie dann Aktualisieren.',
            recommended_updates_title: 'Empfohlene Datensatzaktualisierungen',
            mechanism_recommendation: 'Übermittlungsmechanismus: {value}',
            dpo_signoff_recommendation: 'DPO-Freigabe für diese sensible Übermittlung erforderlich.',
            review_date_warning: 'Legen Sie eine Überprüfungsfrist fest, bevor Sie diese sensible Übermittlung aktualisieren.',
            processing_activity_warning: 'Verknüpfen Sie mindestens eine Verarbeitungstätigkeit / einen ROPA-Datensatz, bevor Sie die TIA abschließen.',
            go_to_field: 'Zum Feld springen',
            adequacy_label: 'Zielregime',
            adequacy_status_adequacy_decision: 'Angemessenheitsbeschluss',
            adequacy_status_non_adequacy_with_sccs: 'Nichtadäquatheit – SCCs erforderlich',
            adequacy_status_derogation: 'Art. 49 Ausnahmeregelung',
            adequacy_status_transitional: 'Übergangs-/EWR-Abkürzung',
            adequacy_status_unknown: 'Unbekannt – Ziel festlegen',
            conflict_banner: 'Achtung: [[TOK_1]] Framework-übergreifende Konflikte gelten für dieses Übertragungsregime. Überprüfen Sie es, bevor Sie es akzeptieren.',
        },
        // Sprint 48.3.6 — shared draft output-guardrail labels (TIA + DPIA + all draft workflows).
        guardrails: {
            missing_facts_title: 'Fehlende erforderliche Angaben',
            missing_facts_hint: 'Forseti hat Angaben markiert, die nicht im Datensatz enthalten sind. Davon abhängige Felder sind nicht vorausgewählt — ergänzen Sie die Angaben oder akzeptieren Sie das Feld bewusst.',
            risk_label: 'Kalibriertes Risiko',
            risk_low: 'Niedrig',
            risk_medium: 'Mittel',
            risk_high: 'Hoch',
            jurisdiction_label: 'Auslöser der Rechtsordnung',
            jurisdiction_gdpr: 'DSGVO',
            jurisdiction_vn_pdpl: 'PDPL (Vietnam)',
            trigger_applicable: 'Anwendbar',
            trigger_not_applicable: 'Nicht ausgelöst',
            trigger_unknown: 'Unbekannt — Angabe fehlt',
            recipient_role_label: 'Rolle des Empfängers',
            recipient_role_controller: 'Verantwortlicher',
            recipient_role_processor: 'Auftragsverarbeiter',
            recipient_role_joint_controller: 'Gemeinsam Verantwortlicher',
            recipient_role_unknown: 'Unbekannt — nicht angegeben',
            opt_in_hint: 'Rechtliche Schlussfolgerung — nur auswählen, wenn Sie sie mit den vorliegenden Fakten akzeptieren.',
        },
        mcp: {
            pageTitle: 'MCP-Anschlussschlüssel',
            pageSubtitle: 'Geben Sie [[TOK_0]]-Schlüssel aus, damit externe Claude-Clients schreibgeschützte Forseti-Tools aufrufen können (Regulierungssuche, Dokumentlesen, Modulsuche). Phase 1 – schreibgeschützt. Schreibwerkzeuge landen in 48.3.0.',
            issueButton: 'Neuen Schlüssel ausstellen',
            issueModalTitle: 'Geben Sie den MCP-Schlüssel [[TOK_0]] aus',
            labelField: 'Etikett',
            labelHint: 'Eine kurze Beschreibung (z. B. „[[TOK_0]] Capability Lab – Regulierungsforschung“).',
            permittedToolsField: 'Zugelassene Werkzeuge',
            expiresAtField: 'Läuft ab (optional)',
            expiresAtHint: 'Lassen Sie das Feld leer, wenn es niemals abläuft.',
            submit: 'Ausgabeschlüssel',
            cancel: 'Abbrechen',
            keyDisplayedOnce: 'Kopieren Sie diesen Schlüssel jetzt – Sie können ihn NICHT noch einmal sehen. Speichern Sie es in Ihrem Secret Manager (1Password, AWS Secrets Manager, Vault usw.).',
            keyDisplayedOnceClose: 'Ich habe es kopiert – nah dran',
            colLabel: 'Etikett',
            colPrefix: 'Präfix',
            colStatus: 'Status',
            colTools: 'Werkzeuge',
            colCreatedAt: 'Erstellt',
            colLastUsed: 'Zuletzt verwendet',
            colCalls: 'Anrufe',
            colActions: 'Aktionen',
            statusActive: 'Aktiv',
            statusRevoked: 'Widerrufen',
            statusExpired: 'Abgelaufen',
            revokeAction: 'Widerrufen',
            rotateAction: 'Drehen',
            confirmRevokeTitle: 'Diesen MCP-Schlüssel widerrufen?',
            confirmRevokeBody: 'Externe Claude-Clients, die diesen Schlüssel verwenden, verlieren sofort den Zugriff. Dies kann nicht rückgängig gemacht werden.',
            confirmRevoke: 'Schlüssel widerrufen',
            rotatedTitle: 'Schlüssel gedreht',
            rotatedBody: 'Der neue Klartextschlüssel ist unten. Der alte Schlüssel funktioniert noch 5 Minuten lang, sodass alle Anrufe während des Flugs beendet werden.',
            emptyState: 'Es wurden noch keine MCP-Schlüssel ausgegeben.',
            errorIssue: 'Der MCP-Schlüssel konnte nicht ausgegeben werden.',
            errorList: 'MCP-Schlüssel konnten nicht geladen werden.',
            errorRevoke: 'Der Schlüssel konnte nicht widerrufen werden.',
            errorRotate: 'Der Schlüssel konnte nicht gedreht werden.',
            neverUsed: '—',
            neverExpires: 'Niemals',
        },
        memory: {
            pageTitle: 'Forseti-Erinnerung',
            pageSubtitle: 'Durchsuchen und kuratieren Sie den organisationsspezifischen Kontext, den Forseti in Gesprächen und Entscheidungen gesammelt hat. Kuratierte Einträge sind vor nächtlicher Aufbewahrung geschützt und bleiben für jede Person verfügbar.',
            filterCategory: 'Kategorie',
            filterAllCategories: 'Alle Kategorien',
            totalCount: '[[TOK_1]] Einträge',
            colAnchor: 'Anker',
            colCategory: 'Kategorie',
            colSource: 'Quelle',
            colContent: 'Inhalt',
            colCreatedAt: 'Erstellt',
            colActions: 'Aktionen',
            editButton: 'Bearbeiten',
            deleteButton: 'Löschen',
            promoteButton: 'Bewerben Sie sich als kuratiert',
            emptyState: 'Noch keine Erinnerungen – Forseti sammelt beim Chatten Kontext.',
            categories: {
                framework_interpretation: 'Rahmeninterpretation',
                process_preference: 'Prozesspräferenz',
                escalation_threshold: 'Eskalationsschwelle',
                decision_context: 'Entscheidungskontext',
                glossary_term: 'Glossarbegriff',
                auto_inferred: 'Automatisch abgeleitet',
            },
            sources: {
                admin_curated: 'Kuratiert',
                user_explicit: 'Explizit',
                auto: 'Abgeleitet',
            },
            deleteConfirmTitle: 'Diesen Speicher löschen?',
            deleteConfirmBody: 'Durch das Löschen wird dieser Anker aus jedem zukünftigen Forseti-Chat-Boot entfernt. Anker: [[TOK_1]]',
            deleteConfirmLabel: 'Löschen',
            deleteCancelLabel: 'Abbrechen',
            editModalTitle: 'Speicher bearbeiten',
            editAnchorLabel: 'Anker',
            editCategoryLabel: 'Kategorie',
            editContentLabel: 'Inhalt',
            editContentCount: '[[TOK_2]]/[[TOK_3]] Zeichen',
            editEmptyError: 'Der Inhalt darf nicht leer sein.',
            editTooLongError: 'Der Inhalt muss ≤1000 Zeichen lang sein.',
            editAutoPromoteHint: 'Durch das Speichern dieses automatisch abgeleiteten Speichers wird dieser als vom Benutzer bestätigt markiert und aus dem Aufbewahrungs-Sweep entfernt.',
            editCancelButton: 'Abbrechen',
            editSaveButton: 'Speichern',
            editSaving: 'Sparen…',
        },
        auditLineage: {
            title: 'Audit-Abstammung',
            subtitle: 'Verfolgen Sie jedes von [[TOK_0]] generierte Artefakt, das an einen Datensatz angehängt ist. Chats, Tool-Aufrufe, Aufgaben, Beweisentwürfe und Dokumentversionen.',
            filterForm: 'Filter',
            recordType: 'Datensatztyp',
            recordId: 'Datensatz-ID',
            dateStart: 'Von',
            dateEnd: 'Zu',
            search: 'Suchen',
            loading: 'Laden…',
            exportPdf: 'Exportieren [[TOK_0]]',
            exportCsv: 'Exportieren [[TOK_0]]',
            nodesHeading: 'Abstammungsknoten',
            colType: 'Typ',
            colLabel: 'Etikett',
            colOccurredAt: 'Geschehen um',
            colActor: 'Schauspieler',
            colId: 'Ausweis',
            noResults: 'Keine Berateraktivität für diesen Datensatz.',
            draftBadge: '[[TOK_0]]-generierter Entwurf',
            prev: 'Zurück',
            next: 'Als nächstes',
            viewToggleTable: 'Als Tabelle anzeigen',
            viewToggleGraph: 'Als Diagramm anzeigen',
            graphAriaLabel: 'Abstammungsdiagramm (visuell). Nutzen Sie die Tabellenansicht für unterstützende Technik.',
            graphLegendDraft: 'Beweisentwurf [[TOK_0]].',
            graphEmpty: 'Keine Knoten zum Diagramm.',
            paginationAriaLabel: 'Paginierung',
            exportSuccessTemplate: '[[TOK_2]]: [[TOK_3]]',
            exportErrorTemplate: 'Export fehlgeschlagen: [[TOK_1]]',
            recordTypes: {
                project: 'Projekt',
                dpia: '[[TOK_0]]',
                vendor: 'Anbieter',
                incident: 'Vorfall',
                incident_op: 'Einsatz bei Vorfällen',
                rights_request: 'Rechteanfrage',
                contract: 'Vertrag',
                task: 'Aufgabe',
                data_mapping_activity: 'Datenzuordnungsaktivität',
                compliance_rule: 'Compliance-Regel',
                program: 'Programm',
            },
            nodeTypes: {
                chat: 'Chatten',
                tool_call: 'Werkzeugaufruf',
                workflow_run: 'Workflow-Ausführung',
                task: 'Aufgabe',
                evidence: 'Beweise',
                document_version: 'Dokumentversion',
            },
        },
        integrityCenter: {
            verdicts: {
                ok: 'Okay',
                drifted: 'Driftete',
                hash_mismatch: 'Hash-Nichtübereinstimmung',
                merkle_mismatch: 'Merkle-Nichtübereinstimmung',
                source_missing: 'Quelle fehlt',
                not_found: 'Nicht gefunden',
                chain_unreachable: 'Kette nicht erreichbar',
                service_unreachable: 'Dienst nicht erreichbar',
                pending: 'Bis zur Verankerung',
            },
        },
        evidenceDraft: {
            draftBadge: '[[TOK_0]]-generierter ENTWURF',
            pendingReviewBadge: 'Ausstehende Überprüfung',
            approvedBadge: 'Genehmigt',
            rejectedBadge: 'Abgelehnt',
            moveToReviewButton: 'Zur Überprüfung als bereit markieren',
            approveButton: 'Genehmigen',
            rejectButton: 'Ablehnen',
            rejectReasonLabel: 'Ablehnungsgrund',
            humanSignoffBanner: 'Forseti unterstützt Ihr Urteil – es ersetzt keinen zugelassenen Anwalt. Von [[TOK_0]] generierte Beweise erfordern die Zustimmung eines Menschen, bevor sie als formelle Beweise gelten.',
            pageTitle: '[[TOK_0]] Beweisentwürfe',
            pageSubtitle: 'Überprüfen, genehmigen oder lehnen Sie von [[TOK_0]] generierte Beweise ab. Entwürfe müssen von einem Menschen genehmigt werden, bevor sie als formelle Beweise gelten.',
            filterAll: 'Alles umsetzbar',
            filterDrafts: 'Nur Entwürfe',
            filterPending: 'Ausstehende Überprüfung',
            filterApproved: 'Kürzlich genehmigt',
            filterRejected: 'Kürzlich abgelehnt',
            colId: 'Beweis-ID',
            colStatus: 'Status',
            colSource: 'Quelle',
            colCreatedAt: 'Erstellt',
            colActions: 'Aktionen',
            empty: 'Keine [[TOK_0]] Beweisentwürfe in diesem Status.',
            confirmApprove: 'Diesen von [[TOK_0]] generierten Beweis als formell genehmigen?',
            confirmReject: 'Lehnen Sie diesen Beweisentwurf ab. Dies kann nicht rückgängig gemacht werden.',
            reasonRequired: 'Es ist ein Ablehnungsgrund erforderlich.',
            rejectModalTitle: 'Beweisentwurf ablehnen',
            approveModalTitle: 'Beweisentwürfe genehmigen',
            operationFailed: 'Der Vorgang ist fehlgeschlagen. Bitte versuchen Sie es erneut.',
            moveToReviewSuccess: 'Als zur Überprüfung bereit markiert.',
            approveSuccess: 'Genehmigt.',
            rejectSuccess: 'Abgelehnt.',
            sourceLabelWorkflowRunTitle: 'Arbeitsablauf: [[TOK_1]]',
            sourceLabelWorkflowRunId: 'Workflow-Ausführung [[TOK_1]]',
            sourceLabelChatTitle: 'Chat: [[TOK_1]]',
            sourceLabelChatId: 'Forseti-Chat [[TOK_1]]',
            sourceLabelEmpty: '—',
            filtersAriaLabel: 'Filterstatus',
        },
        workflows: {
            pageTitle: 'KI-Workflows',
            pageSubtitle: 'Gespeicherte KI-Prompt-Vorlagen, die Aufgaben und Nachweisentwürfe erzeugen.',
            newWorkflow: 'Neuer Workflow',
            newWorkflowHeading: 'Neuer KI-Workflow',
            tabAll: 'Alle',
            tabBuiltin: 'Integriertes Paket',
            tabMine: 'Meine Workflows',
            tabDetail: 'Einzelheiten',
            tabLinkedTasks: 'Verknüpfte Aufgaben',
            builtinBadge: 'Integriert',
            builtinSubtitle: 'Integrierter Workflow.',
            userSubtitle: 'Benutzerdefinierter Workflow.',
            emptyHint: 'Noch keine Workflows.',
            loadTimeoutError: 'Workflows konnten nach 10 Sekunden nicht geladen werden. Erneut versuchen oder im Netzwerk-Tab des Browsers nach einer hängenden Anfrage suchen.',
            loadError: 'Workflows konnten nicht geladen werden.',
            hideError: 'Ausblenden fehlgeschlagen.',
            unhideError: 'Einblenden fehlgeschlagen.',
            retry: 'Wiederholen',
            producesTasks: 'Erzeugt Aufgaben',
            producesEvidence: 'Erzeugt Nachweisentwürfe',
            hideButton: 'Aus meiner Liste ausblenden',
            unhideButton: 'Einblenden',
            runButton: 'Ausführen',
            editButton: 'Bearbeiten',
            shareButton: 'Teilen',
            backToList: 'Zurück zur Liste',
            requireTitleAndPrompt: 'Titel und Prompt sind erforderlich.',
            fieldTitle: 'Titel',
            fieldDescription: 'Beschreibung',
            fieldType: 'Typ',
            fieldPersona: 'Persona-Affinität',
            fieldPractice: 'Praxis',
            fieldPrompt: 'Eingabeaufforderung (Markdown)',
            fieldProducesTasks: 'Erzeugt Aufgaben',
            fieldProducesEvidence: 'Erzeugt Nachweisentwürfe',
            fieldProjectId: 'Projekt (optional)',
            fieldAttachmentIds: 'Anhänge',
            fieldParentRecord: 'Übergeordneter Datensatz (optional)',
            fieldPersonaOverride: 'Persona-Überschreibung (optional)',
            typeAssistant: 'Assistent',
            typeTabular: 'Tabellarisch',
            personaNone: '— keine —',
            parentNone: '— keine —',
            parentIdPlaceholder: 'ID des übergeordneten Datensatzes',
            selectProjectPlaceholder: 'Projekt auswählen…',
            selectProjectFirst: 'Wählen Sie ein Projekt, um Anhänge auszuwählen.',
            selectAttachmentsPlaceholder: 'Dokumente auswählen…',
            noAttachmentsInProject: 'Dieses Projekt hat keine angehängten Dokumente.',
            selectParentRecordPlaceholder: 'Datensatz auswählen…',
            selectParentRecordFirst: 'Wählen Sie zuerst einen Datensatztyp.',
            noRecordsForType: 'Keine Datensätze dieses Typs verfügbar.',
            shareUserSelectorLabel: 'Empfänger (Benutzer)',
            shareGroupSelectorLabel: 'Empfänger (Organisationsgruppen)',
            selectUsersPlaceholder: 'Benutzer auswählen…',
            selectOrgGroupsPlaceholder: 'Organisationsgruppen auswählen…',
            loadingOptions: 'Lädt…',
            loadFailed: 'Optionen konnten nicht geladen werden.',
            parentRecordTypes: {
                dpia: 'DSFA',
                vendor: 'Lieferant',
                incident: 'Vorfall',
                rights_request: 'Rechtsantrag',
                contract: 'Vertrag',
                data_mapping_activity: 'RoPA-Aktivität',
                compliance_rule: 'Compliance-Regel',
                program: 'Programm',
            },
            cancelButton: 'Abbrechen',
            closeButton: 'Schließen',
            createButton: 'Erstellen',
            creating: 'Erstellt…',
            saveButton: 'Speichern',
            saving: 'Speichert…',
            shareWorkflowHeading: 'Workflow teilen',
            shareIntro: 'Teilen: {title}',
            shareUserIds: 'Benutzer-IDs (durch Leerzeichen oder Komma getrennt)',
            shareGroupIds: 'Organisationsgruppen-IDs (durch Leerzeichen oder Komma getrennt)',
            shareAllowEdit: 'Empfängern Bearbeitung erlauben',
            shareRequireRecipient: 'Geben Sie mindestens eine Benutzer- oder Gruppen-ID an.',
            shareSuccess: 'Geteilt.',
            sharing: 'Teilt…',
            runWorkflowHeading: 'Ausführen: {title}',
            runStarting: 'Startet…',
            runStatusLabel: 'Status: [[TOK_1]]',
            runProducedCounts: 'Aufgaben: {tasks} · Nachweisentwürfe: {evidence}',
            runPanelHeading: 'Workflow-Lauf',
            runPanelHeadingWithTitle: 'Workflow-Lauf: {title}',
            runViewTasks: 'Erstellte Aufgaben anzeigen',
            runLoadFailed: 'Der Workflow-Lauf konnte nicht geladen werden.',
            runStreamFailed: 'Die Verbindung zum Workflow-Fortschritt ist fehlgeschlagen.',
            runStatusValues: {
                pending: 'Ausstehend',
                running: 'Läuft',
                completed: 'Abgeschlossen',
                succeeded: 'Erfolgreich',
                failed: 'Fehlgeschlagen',
                cancelled: 'Abgebrochen',
            },
            runProgressStatus: 'Status: [[TOK_1]]',
            runProgressTaskCreated: 'Aufgabe erstellt.',
            runProgressEvidenceDrafted: 'Nachweisentwurf erstellt.',
            runProgressAttachmentGenerated: 'Anlage erstellt.',
            guidedWorkflowTitle: 'Geführter Workflow für {recordType}',
            guidedWorkflowDescription: 'Für Datensätze vom Typ {recordType} erstellt. Prüfen und bearbeiten Sie diesen Workflow vor dem Speichern.',
            guidedWorkflowPrompt: 'Prüfen Sie den bereitgestellten Datensatz vom Typ {recordType}, erkennen Sie fehlende Angaben und schlagen Sie belegte nächste Schritte zur menschlichen Prüfung vor.',
            costHint: 'Vorab-Kontingentprüfung erfolgt beim Absenden; Läufe über dem Kontingent geben 402 mit einem Aufstock-CTA zurück.',
            quotaExhausted: 'Token-Bucket niedrig. Vor erneutem Ausführen aufladen.',
            promptHeading: 'Prompt',
            editWorkflowHeading: 'Workflow bearbeiten',
            linkedTasksHint: 'Aufgaben, die durch diesen Workflow erstellt wurden, erscheinen in der nach dieser Workflow-ID gefilterten Aufgabenliste. Querverweise kommen in 47.5.8.',
            notFound: 'Workflow nicht gefunden.',
            schedules: {
                tabTitle: 'Zeitpläne',
                sectionHeading: 'Geplante Läufe',
                empty: 'Noch keine Zeitpläne. Erstellen Sie einen, um diesen Workflow automatisch auszuführen.',
                addButton: 'Zeitplan hinzufügen',
                addHeading: 'Workflow planen',
                editHeading: 'Zeitplan bearbeiten',
                fieldFrequency: 'Häufigkeit',
                fieldDayOfWeek: 'Wochentag',
                fieldDayOfMonth: 'Tag des Monats',
                fieldTime: 'Uhrzeit (UTC)',
                fieldTimezone: 'Zeitzone',
                fieldProject: 'Projekt (optional)',
                fieldAttachments: 'Standard-Anhänge',
                fieldPersonaOverride: 'Persona-Überschreibung (optional)',
                frequencyDaily: 'Täglich',
                frequencyWeekly: 'Wöchentlich',
                frequencyMonthly: 'Monatlich',
                weekdaySun: 'Sonntag',
                weekdayMon: 'Montag',
                weekdayTue: 'Dienstag',
                weekdayWed: 'Mittwoch',
                weekdayThu: 'Donnerstag',
                weekdayFri: 'Freitag',
                weekdaySat: 'Samstag',
                statusActive: 'Aktiv',
                statusPaused: 'Pausiert',
                nextRunLabel: 'Nächster Lauf',
                lastRunLabel: 'Letzter Lauf',
                pauseButton: 'Pausieren',
                resumeButton: 'Fortsetzen',
                deleteButton: 'Löschen',
                triggerButton: 'Jetzt ausführen',
                savingButton: 'Speichert…',
                saveButton: 'Speichern',
                triggered: 'Lauf gestartet — Lauf-Verlauf prüfen.',
            },
            branching: {
                helpHeading: 'Bedingte Prompt-Syntax',
                helpBody: 'Verwenden Sie {% if attachment.framework_code == "vn-pdpl" %}…{% endif %}, um den Prompt nach Kontext zu variieren. Erlaubte Variablen: attachment.framework_code, attachment.locale, project.name, project.tier, persona.slug, org.country, org.locale. Verschachtelte {% if %}-Blöcke werden nicht unterstützt.',
            },
        },
        crossFrameworkConflicts: {
            pageTitle: 'Frameworkübergreifende Konflikte',
            pageSubtitle: 'Kuratierter Katalog der Orte, an denen Ihre installierten Regulierungspakete auf widersprüchliche Weise interagieren. Forseti-Oberflächen; Der Mensch entscheidet.',
            noInstalledPacks: 'Für diese Organisation sind keine Regulierungspakete installiert. Installieren Sie mindestens zwei Pakete, um Konflikte zwischen Frameworks aufzudecken.',
            noConflicts: 'Keine Konflikte entsprechen den aktuellen Filtern.',
            allAcknowledged: 'Jeder sichtbare Konflikt wurde anerkannt. Schöne Arbeit.',
            columnSeverity: 'Schweregrad',
            columnTitle: 'Titel',
            columnFrameworks: 'Rahmenwerke',
            columnTopic: 'Thema',
            columnStatus: 'Status',
            filterFrameworkPlaceholder: 'Alle Frameworks',
            filterTopicPlaceholder: 'Alle Themen',
            filterSeverityPlaceholder: 'Alle Schweregrade',
            filterStatusPlaceholder: 'Alle Status',
            filterStatusAcknowledged: 'Anerkannt',
            filterStatusUnacknowledged: 'Unbestätigt',
            severityCritical: 'Kritisch',
            severityHigh: 'Hoch',
            severityMedium: 'Mittel',
            severityLow: 'Niedrig',
            statusAcknowledged: 'Anerkannt',
            statusInReview: 'Im Rückblick',
            statusResolved: 'Gelöst',
            statusWontFix: 'Lässt sich nicht beheben',
            statusUnacknowledged: 'Unbestätigt',
            drawerSummaryHeading: 'Zusammenfassung',
            drawerSideAHeading: 'Seite A',
            drawerSideBHeading: 'Seite B',
            drawerRequirementsLabel: 'Anforderungen zitiert',
            drawerSuggestedResolutionHeading: 'Vorgeschlagene Lösung',
            drawerLegalCounselBadge: 'Prüfung durch einen Rechtsbeistand erforderlich',
            drawerAckHeading: 'Danksagung',
            drawerAckStatusLabel: 'Status',
            drawerAckAssigneeLabel: 'Zugewiesen an',
            drawerAckDueDateLabel: 'Fälligkeitsdatum',
            drawerAckNotesLabel: 'Notizen',
            drawerAckButtonAcknowledge: 'Bestätigen',
            drawerAckButtonUpdate: 'Aktualisieren',
            drawerAckButtonUnacknowledge: 'Nicht bestätigen',
            searchPlaceholder: 'Titel oder Zusammenfassung suchen…',
            searchButton: 'Suchen',
            searchButtonAriaLabel: 'Führen Sie eine Konfliktsuche durch',
            exportSuccessTemplate: '[[TOK_2]]: [[TOK_1]]',
            exportSuccessTemplateXlsx: '[[TOK_2]]: [[TOK_1]]',
            exportErrorTemplate: 'Export fehlgeschlagen: [[TOK_1]]',
            exportAriaLabel: 'Exportkonflikte',
        },
        tabularReviews: {
            pageTitle: 'Tabellarische Reviews',
            pageSubtitle: 'Vergleichen Sie N Dokumente über M Attribute mit fundierten Zitaten.',
            newReview: 'Neuer Review',
            newReviewHeading: 'Neuer tabellarischer Review',
            emptyHint: 'Noch keine tabellarischen Reviews.',
            docsLabel: '{n} Dokumente',
            colsLabel: '{n} Spalten',
            detailSubtitle: '{docs} Dokumente · {cols} Spalten',
            addColumn: 'Spalte hinzufügen',
            addColumnHeading: 'Spalte hinzufügen',
            columnInfo: 'Prompt & Format anzeigen',
            columnInfoAria: 'Prompt und Format für Spalte {name} anzeigen',
            columnInfoPrompt: 'Prompt',
            columnInfoFormat: 'Rückgabeformat',
            columnInfoPresets: 'Zulässige Werte',
            columnInfoCitations: 'Zitate',
            columnInfoCitationsRequired: 'Erforderlich',
            removeColumn: 'Spalte entfernen',
            removeColumnAria: 'Spalte {name} entfernen',
            removeColumnConfirm: 'Spalte "{name}" entfernen? Ihre extrahierten Zellen werden gelöscht.',
            deleteReview: 'Löschen',
            deleteReviewAria: 'Überprüfung {title} löschen',
            deleteReviewConfirm: 'Überprüfung "{title}" löschen? Dadurch werden ihre Spalten, Zellen und Diskussionen dauerhaft entfernt.',
            runAll: 'Alle ausführen',
            running: 'Läuft…',
            cancel: 'Abbrechen',
            exportXlsx: 'Excel exportieren',
            exportCsv: 'CSV exportieren',
            exporting: 'Exportiert…',
            backToList: 'Zurück zur Liste',
            notFound: 'Tabellarischer Review nicht gefunden.',
            noDocuments: 'Hängen Sie Dokumente an, um den Review zu starten.',
            noColumns: 'Fügen Sie Spalten hinzu, um zu definieren, was extrahiert werden soll.',
            tableAriaLabel: 'Extraktionsraster',
            threadsCountAria: '{n} Diskussionsbeitrag/-beiträge',
            startDiscussionAria: 'Diskussion starten',
            docColumn: 'Dokument',
            statusPending: 'Ausstehend',
            statusRunning: 'Läuft…',
            statusFailed: 'Fehlgeschlagen: {msg}',
            statusCancelled: 'Abgebrochen',
            citationsCount: '{n} Zitat(e)',
            citationsView: 'Quellenstellen anzeigen',
            citationPage: 'Seite {n}',
            titleRequired: 'Titel ist erforderlich.',
            fieldTitle: 'Titel',
            fieldProjectId: 'Projekt (optional)',
            fieldAttachmentIds: 'Anhänge',
            fieldColumnName: 'Spaltenname',
            fieldColumnNameHelp: 'Ein kurzes, aussagekräftiges Label für diese Spalte im Extraktionsraster.',
            columnNamePlaceholder: 'z. B. Vertragsbeginn',
            fieldExtractionPrompt: 'Extraktions-Prompt',
            fieldExtractionPromptHelp: 'Beschreiben Sie die Informationen, die Sie extrahieren möchten. Formulieren Sie präzise, um bessere Ergebnisse zu erzielen.',
            columnPromptPlaceholder: 'Wonach soll Forseti in den Dokumenten suchen?',
            fieldReturnFormat: 'Rückgabeformat',
            fieldReturnFormatHelp: 'Steuert, wie die KI ihre Antwort formatiert (z. B. als Datum oder Zahl).',
            fieldPresets: 'Erlaubte Werte (einer pro Zeile)',
            fieldPresetsPlaceholder: 'ja\nnein\nteilweise',
            fieldCitationsRequired: 'Zitat erforderlich',
            formatShortText: 'Kurzer Text',
            formatLongText: 'Langer Text',
            formatEnum: 'Aufzählung',
            formatNumber: 'Zahl',
            formatDate: 'Datum',
            formatList: 'Liste',
            columnRequireFields: 'Name und Prompt sind erforderlich.',
            addColumnError: 'Spalte hinzufügen fehlgeschlagen.',
            cancelButton: 'Abbrechen',
            createButton: 'Erstellen',
            creating: 'Erstellt…',
            addButton: 'Hinzufügen',
            adding: 'Fügt hinzu…',
            runConfirmHeading: 'Extraktion ausführen',
            estimateBody: 'Geschätzt ~{units} abrechenbare Einheiten ({confidence} Konfidenz).',
            costHint: 'Vorab-Kontingentprüfung erfolgt bei Bestätigung; Läufe über dem Kontingent geben 402 mit einem Aufstock-CTA zurück.',
            quotaExhausted: 'Token-Bucket niedrig. Vor erneutem Ausführen aufladen.',
            starting: 'Startet…',
            confirmRun: 'Lauf bestätigen',
            charts: {
                title: 'Spalten-Diagramme',
                tabsAria: 'Diagramm-Spalten',
                enumAria: 'Verteilung der Enum-Werte',
                numberAria: 'Histogramm der Zahlenverteilung',
                dateAria: 'Datums-Zeitachse',
                enumEmpty: 'Keine abgeschlossenen Zellen.',
                numberEmpty: 'Keine numerischen Werte.',
                numberExcluded: '{n} Zelle(n) ausgeschlossen (leer / nicht-numerisch / nicht abgeschlossen).',
                dateEmpty: 'Keine Datumswerte.',
                dateExcluded: '{n} Zelle(n) ausgeschlossen.',
                unsupportedFormat: 'Nicht unterstütztes Spaltenformat.',
            },
            threads: {
                drawerTitle: 'Diskussion',
                loading: 'Lädt…',
                empty: 'Noch keine Beiträge. Starten Sie das Gespräch.',
                composerLabel: 'Neuer Kommentar',
                composerPlaceholder: 'Kommentar hinzufügen…',
                post: 'Senden',
                posting: 'Sendet…',
                edit: 'Bearbeiten',
                editLabel: 'Beitrag bearbeiten',
                delete: 'Löschen',
                save: 'Speichern',
                cancel: 'Abbrechen',
                close: 'Schließen',
                editedBadge: 'bearbeitet',
                loadError: 'Thread konnte nicht geladen werden',
                postError: 'Senden fehlgeschlagen',
                editError: 'Bearbeiten fehlgeschlagen',
                deleteError: 'Löschen fehlgeschlagen',
            },
            compare: {
                pageTitle: 'Reviews vergleichen',
                leftReviewLabel: 'Linker Review',
                rightReviewLabel: 'Rechter Review',
                pickReview: 'Wählen Sie einen Review zum Vergleich',
                noSharedDocuments: 'Diese Reviews teilen keine Dokumente — der Vergleich erfordert mindestens einen gemeinsamen Anhang.',
                sharedDocumentsHeading: 'Geteilte Dokumente',
                leftOnlyHeading: 'Spalten nur im linken Review',
                rightOnlyHeading: 'Spalten nur im rechten Review',
                differs: 'Abweichend',
                identical: 'Identisch',
                emptyValue: '—',
                compareButton: 'Vergleichen mit…',
                documentHeading: 'Dokument',
                errorMissingIds: 'Sowohl linke als auch rechte Review-IDs sind erforderlich.',
                errorComparisonFailed: 'Vergleich fehlgeschlagen.',
                errorLoadFailed: 'Reviews konnten nicht geladen werden.',
                pickerLoading: 'Lädt…',
                pickerNoOtherReviews: 'Keine anderen Reviews zum Vergleich verfügbar.',
                pickerCancel: 'Abbrechen',
            },
        },
        documentReview: {
            pageTitle: 'Dokumentenprüfung',
            pageSubtitle: 'Akzeptieren oder lehnen Sie die von [[TOK_0]] vorgeschlagenen Änderungen an diesem Dokument ab.',
            sidePanelLabel: '[[TOK_0]] Redlines',
            sidePanelHeading: '[[TOK_0]] Redlines',
            noPendingEdits: 'Keine ausstehenden Änderungen.',
            pendingCount: '[[TOK_1]] ausstehend',
            acceptAllButton: 'Akzeptiere alles',
            rejectAllButton: 'Alles ablehnen',
            acceptAllTitle: 'Alle ausstehenden Änderungen akzeptieren?',
            acceptAllConfirm: 'Dadurch werden [[TOK_1]] ausstehende Änderungen akzeptiert und eine oder mehrere neue Versionen erstellt. Weitermachen?',
            editsHeading: 'Änderungen',
            editsEmpty: 'Keine Änderungen zur Überprüfung.',
            versionsHeading: 'Versionsgeschichte',
            versionsEmpty: 'Noch keine Versionen.',
            editLabel: 'Bearbeiten',
            editLabelWithId: 'Bearbeiten #{id}',
            acceptButton: 'Akzeptiere',
            rejectButton: 'Ablehnen',
            accepting: 'Akzeptieren…',
            rejecting: 'Ablehnen…',
            diffDeletedAria: 'Gelöscht',
            diffInsertedAria: 'Eingefügt',
            statusPending: 'Ausstehend',
            statusAccepted: 'Akzeptiert',
            statusRejected: 'Abgelehnt',
            versionLabel: 'Version',
            versionAriaLabel: 'Version [[TOK_1]]',
            versionAriaLabelCurrent: 'Version [[TOK_2]] ([[TOK_3]])',
            versionCurrentTag: 'aktuell',
            versionSourceLabel: 'Quelle',
            versionCreatedLabel: 'Erstellt',
            versionModelLabel: 'Modell',
            sourceUpload: 'Hochladen',
            sourceUserUpload: 'Benutzer-Upload',
            sourceAssistantEdit: 'Bearbeitungsassistent',
            sourceUserAccept: 'Der Benutzer hat die Bearbeitung akzeptiert',
            sourceUserReject: 'Der Benutzer hat die Bearbeitung abgelehnt',
            sourceGenerated: 'Generiert',
        },
        documentReviewIndex: {
            sidebarLabel: 'Dokumenten-Review',
            pageTitle: 'Dokumenten-Review',
            pageSubtitle: 'Dokumente in Ihrer Organisation, die KI-vorgeschlagene Bearbeitungen zur Überprüfung haben oder Forseti-basierte Versionen.',
            colDocument: 'Dokument',
            colLinkedRecord: 'Verknüpfter Datensatz',
            colPendingEdits: 'Ausstehende Bearbeitungen',
            colLastActivity: 'Letzte Aktivität',
            colOpen: 'Öffnen',
            open: 'Öffnen',
            empty: 'Noch keine Dokumente unter Forseti-Review. Dokumente kommen in diese Warteschlange, wenn Forseti während eines Chats eine Bearbeitung vorschlägt, wenn ein KI-Workflow eine Redline erzeugt oder wenn Sie ein Dokument über die Schaltfläche oben zur Überprüfung senden.',
            loading: 'Lädt…',
            loadError: 'Dokumente unter Überprüfung konnten nicht geladen werden.',
            retryButton: 'Wiederholen',
            noLinkedRecord: '—',
            pendingZero: 'Keine',
            sendForReviewButton: 'Dokument zur Überprüfung senden',
            sendForReviewTitle: 'Dokument zur Überprüfung senden',
            sendForReviewSubtitle: 'Wählen Sie einen vorhandenen Anhang aus dieser Organisation oder laden Sie eine neue Datei hoch. Das Dokument wird zur Überprüfungswarteschlange hinzugefügt und Forseti wird einen Redline-Lauf darauf ausführen.',
            sendForReviewTabPick: 'Vorhandenes auswählen',
            sendForReviewTabUpload: 'Neues hochladen',
            sendForReviewPickerLabel: 'Anhänge suchen',
            sendForReviewPickerPlaceholder: 'Zum Suchen tippen…',
            sendForReviewPickerEmpty: 'Keine passenden Anhänge. Versuchen Sie eine andere Suche.',
            sendForReviewSubmit: 'Zur Überprüfung senden',
            sendForReviewCancel: 'Abbrechen',
            sendForReviewSubmitting: 'Sendet…',
            sendForReviewError: 'Dokument konnte nicht zur Überprüfung gesendet werden. Bitte erneut versuchen.',
            sendForReviewSuccess: 'Dokument zur Überprüfung gesendet.',
            sendForReviewAcceptedExt: 'Akzeptiert: {ext}.',
            sendForReviewMaxSize: 'Maximale Größe {mb} MB.',
        },
        chats: {
            exportError: 'Export fehlgeschlagen.',
        },
    },
    pdplEvidencePacks: {
        title: 'PDPL-Nachweispakete',
        subtitle: 'Kundengesteuerte Einreichung an MoPS A05',
        nav: { emailProviders: 'E-Mail-Anbieter' },
        providers: {
            pageTitle: 'E-Mail-Anbieter',
            pageSubtitle: 'Konfigurieren Sie den ausgehenden Mail-Anbieter Ihrer Organisation für die Übermittlung von PDPL-Nachweispaketen an MoPS A05.',
            architectureRuleHeading: 'Architekturregel (gesperrt)',
            architectureRuleBody: 'AesirX ist kein Absender für Nachweis-E-Mails. Jede Übermittlung nutzt einen Anbieter, der Ihrer Organisation gehört und von ihr kontrolliert wird. AesirX versendet niemals in Ihrem Namen.',
            empty: 'Bislang sind keine Anbieter konfiguriert.',
            createCta: 'Anbieter anlegen',
            statusPendingConsent: 'Zustimmung ausstehend',
            statusPendingConnectionCheck: 'Verbindungstest ausstehend',
            statusActive: 'Aktiv',
            statusConnectionCheckFailed: 'Verbindungstest fehlgeschlagen',
            statusDisabled: 'Deaktiviert',
            acceptConsentCta: 'Zustimmung erteilen',
            runConnectionCheckCta: 'Verbindungstest ausführen',
            disableCta: 'Deaktivieren',
            disableConfirm: 'Beim Deaktivieren dieses Anbieters werden Direktsendungen gestoppt, bis ein neuer Anbieter konfiguriert und die Zustimmung erneut bestätigt wurde. Fortfahren?',
            columnDisplayName: 'Name',
            columnFromAddress: 'Absenderadresse',
            columnStatus: 'Status',
            columnLastCheck: 'Letzter Test',
            columnActions: 'Aktionen',
            createModalTitle: 'Neuer SMTP-Anbieter',
            createDisplayNameLabel: 'Anzeigename',
            createFromAddressLabel: 'Absenderadresse',
            createReplyToLabel: 'Antwortadresse (optional)',
            createSmtpHostLabel: 'SMTP-Server',
            createSmtpPortLabel: 'SMTP-Port',
            createSmtpUsernameLabel: 'SMTP-Benutzername',
            createSmtpPasswordLabel: 'SMTP-Passwort',
            createSmtpEncryptionLabel: 'Verschlüsselung',
            createSmtpEncryptionStarttls: 'STARTTLS',
            createSmtpEncryptionTls: 'TLS (implizit)',
            createSmtpEncryptionNone: 'Keine',
            createOauthM365Tab: 'Microsoft 365',
            createOauthGoogleTab: 'Google Workspace',
            createOauthDisabledBadge: 'Bald verfügbar',
            createOauthDisabledHint: 'OAuth-Anbieter sind noch nicht aktiviert. Bitte verwenden Sie vorerst SMTP.',
            createSubmitCta: 'Anbieter anlegen',
            createCancelCta: 'Abbrechen',
            createErrorInvalidFromAddress: 'Die Absenderadresse muss ein gültiges Postfach sein.',
            createErrorDuplicateFromAddress: 'Es ist bereits ein anderer Anbieter mit dieser Absenderadresse eingerichtet.',
            createErrorGeneric: 'Der Anbieter konnte nicht angelegt werden. Bitte Formular prüfen und erneut versuchen.',
            consentModalTitle: 'Architekturregel bestätigen',
            consentLocaleToggleEn: 'Englisch',
            consentLocaleToggleVi: 'Vietnamesisch',
            consentAcknowledgeCta: 'Ich bestätige — Zustimmung erteilen',
            consentCancelCta: 'Abbrechen',
            consentErrorMismatch: 'Der Zustimmungstext wurde geändert und stimmt nicht mehr mit dem kanonischen Wortlaut überein. Bitte den Dialog erneut öffnen und einreichen.',
            testModalTitle: 'Verbindungstest',
            testRunningCta: 'Verbindung wird getestet…',
            testRunCta: 'Verbindungstest ausführen',
            testRetryCta: 'Verbindungstest wiederholen',
            testSuccessHeading: 'Verbindung erfolgreich',
            testSuccessBody: 'Authentifizierung gegen {host}:{port} in {latencyMs} ms. Der Anbieter ist bereit für Direktsendungen.',
            testFailureHeading: 'Verbindung fehlgeschlagen',
            testFailureBody: 'Der Test konnte nicht abgeschlossen werden. Bitte die Ursache unten prüfen und nach Behebung erneut versuchen.',
            testFailureReasonLabel: 'Fehlerursache',
            testCloseCta: 'Schließen',
            detailDrawerTitle: 'Anbieterdetails',
            detailDrawerHistoryHeading: 'Verlauf der Verbindungstests',
            detailDrawerConsentHeading: 'Zustimmungserklärung',
            detailDrawerNoHistory: 'Bislang keine Verbindungstests erfasst.',
            detailDrawerNoConsent: 'Zustimmung wurde noch nicht bestätigt.',
            outcomeSuccess: 'Erfolgreich',
            outcomeFailure: 'Fehlgeschlagen',
        },
        builder: {
            pageTitle: 'Nachweispaket zusammenstellen',
            pageSubtitle: 'Laden Sie die 6 Teil-Dateien hoch, wählen Sie den Pakettyp und stellen Sie das deterministische 8-teilige ZIP für die Einreichung zusammen.',
            packTypeLabel: 'Pakettyp',
            packTypeDpia: 'DPIA (Mẫu số 02a)',
            packTypeOtia: 'OTIA (Mẫu số 02b)',
            part01CoverLetter: 'Teil 01 — Anschreiben (PDF)',
            part02AuthorityForm: 'Teil 02 — Behördenformular (PDF)',
            part03Supporting: 'Teil 03 — Unterstützende Nachweise (≥1)',
            part04Safeguards: 'Teil 04 — Schutzmaßnahmen',
            part04SafeguardsRequiredOtia: '(für OTIA erforderlich)',
            part05PriorCorrespondence: 'Teil 05 — Frühere Korrespondenz (optional)',
            part06Signature: 'Teil 06 — Unterschriften- und Stempelnachweis (≥1)',
            uploadPickFile: 'Datei wählen',
            uploadPickFiles: 'Dateien wählen',
            uploadRemoveFile: 'Entfernen',
            requiredMissing: 'Erforderlicher Teil fehlt',
            assembleCta: 'Paket zusammenstellen',
            assembling: 'Stelle zusammen…',
            assembleSuccessHeading: 'Paket zusammengestellt',
            assembleSuccessSummary: '{fileCount} Dateien · {bytes} Byte · SHA-256 {shaPrefix}…',
            composeNextCta: 'E-Mail-Entwurf verfassen',
            warningsHeading: 'Validierungswarnungen',
            assembleError: 'Das Paket konnte nicht zusammengestellt werden. Bitte Eingaben prüfen und erneut versuchen.',
            forsetiAssistHeading: 'Forseti KI-Unterstützung (optional)',
            forsetiAssistHint: 'Führen Sie den PDPL Evidence Pack Assembly Advisor aus, um fehlende Teile aufzuzeigen, Anschreibensprosa zu entwerfen und Schutzlücken zu kennzeichnen. AesirX ist nicht der Absender — die KI berät nur; Sie genehmigen jedes Artefakt.',
            forsetiAssistCta: 'Forseti Workflow-Bibliothek öffnen',
            forsetiAiRunIdLabel: 'Verknüpfte Forseti KI-Lauf-ID (einfügen, um KI-Unterstützung zu erfassen)',
        },
        draft: {
            pageTitle: 'E-Mail-Entwurf',
            pageSubtitle: 'Verfassen und bearbeiten Sie den E-Mail-Entwurf. Direktversand folgt in einer späteren Version.',
            composeCta: 'Entwurf verfassen',
            composing: 'Verfasse…',
            noDraftYet: 'Noch kein Entwurf. Verfassen Sie einen, um zu beginnen.',
            localeToggleLabel: 'Sprache',
            localeEn: 'Englisch',
            localeVi: 'Vietnamesisch',
            subjectLabel: 'Betreff',
            bodyLabel: 'Inhalt',
            saveCta: 'Änderungen speichern',
            saving: 'Speichere…',
            saveError: 'Der Entwurf konnte nicht gespeichert werden. Bitte erneut versuchen.',
            manifestSummaryLabel: 'Manifest-Zusammenfassung',
            coverLetterLabel: 'Anschreiben (PDF)',
            coverLetterDownloadCta: 'PDF herunterladen',
            editHistoryHeading: 'Bearbeitungsverlauf',
            editHistoryEmpty: 'Noch keine Bearbeitungen.',
            editHistoryEntry: 'v{version} · {fields} · {when} · {who}',
            unofficialChannelHeading: 'NQ22 Hinweis zum inoffiziellen Kanal',
            uploadSentProofCta: 'Manuellen Versandnachweis hochladen',
            versionLabel: 'Version',
            statusDraft: 'Entwurf',
            statusEdited: 'Bearbeitet',
            statusFinalized: 'Abgeschlossen',
        },
        sentProof: {
            modalTitle: 'Manuellen Versandnachweis hochladen',
            architectureLockNote: 'AesirX ist nicht der Absender. Dieser Nachweis erfasst den manuellen Versand, den Sie über Ihr eigenes Mailprogramm durchgeführt haben.',
            fileLabel: 'Nachweisdatei (.eml, .png, .jpg)',
            envelopeFromLabel: 'Von',
            envelopeToLabel: 'An',
            envelopeSubjectLabel: 'Betreff (beim Versand)',
            envelopeSentAtLabel: 'Versandzeit',
            envelopeAttachmentShaLabel: 'Anhang SHA-256 (beim Versand)',
            uploadCta: 'Nachweis hochladen',
            uploading: 'Lade hoch…',
            uploadSuccess: 'Versandnachweis hochgeladen.',
            uploadErrorInvalidMime: 'Dateityp nicht erlaubt. Bitte .eml, .png, .jpg oder .jpeg verwenden.',
            uploadErrorGeneric: 'Der Nachweis konnte nicht hochgeladen werden. Bitte erneut versuchen.',
            existingProofsHeading: 'Erfasste Versandnachweise',
            existingProofsEmpty: 'Noch keine Versandnachweise erfasst.',
            proofEntry: '{when} · {filename}',
        },
        packDetail: {
            pageTitle: 'Nachweispaket',
            notFoundMessage: 'Paket nicht gefunden – es wurde möglicherweise entfernt oder der Link ist falsch.',
            manifestHeading: 'Manifest',
            dossierLabel: 'Vorgang',
            packShaLabel: 'Paket-SHA-256',
            fileCountLabel: 'Dateien',
            bytesLabel: 'Größe',
            composeDraftCta: 'Entwurf verfassen',
            sendComingSoonCta: 'Direktversand: bald verfügbar',
            sendComingSoonHint: 'Der Direktversand wird aktiv entwickelt. Nutzen Sie bis dahin „Manuellen Versandnachweis hochladen" auf der Entwurfsseite.',
            sendCta: 'Über konfigurierten Anbieter versenden',
            sendDisabledNoProviderHint: 'Konfigurieren Sie zunächst einen kundenseitig betriebenen E-Mail-Anbieter. AesirX versendet niemals in Ihrem Namen.',
            timelineHeading: 'Versandhistorie',
        },
        // Sprint 58.4.2 (Phase 25 / Sprint E2) — direct-send + timeline + authority response + hard-copy follow-up.
        send: {
            // Send dialog
            dialogTitle: 'Nachweispaket versenden',
            providerPickerLabel: 'Konfigurierter E-Mail-Anbieter',
            providerPickerHint: 'AesirX versendet niemals in Ihrem Namen. Wählen Sie unten einen Ihrer konfigurierten Anbieter aus.',
            providerPickerEmpty: 'Es sind keine aktiven Anbieter konfiguriert. Konfigurieren Sie zunächst einen auf der Seite E-Mail-Anbieter, bevor Sie versenden.',
            providerPickerEmptyCta: 'E-Mail-Anbieter öffnen',
            draftPickerLabel: 'E-Mail-Entwurf',
            draftPickerOption: '{locale} · v{version}',
            draftPickerEmpty: 'Für dieses Paket wurden noch keine Entwürfe verfasst. Verfassen Sie zunächst einen auf der Entwurfsseite.',
            recipientToLabel: 'An',
            recipientToHint: 'Eine oder mehrere E-Mail-Adressen, durch Kommas getrennt.',
            recipientCcLabel: 'Cc (komma-getrennt)',
            recipientCcHint: 'Optional. Kommagetrennte Liste von E-Mail-Adressen.',
            recipientBccLabel: 'Bcc (komma-getrennt)',
            recipientBccHint: 'Optional. Kommagetrennte Liste von E-Mail-Adressen.',
            consentReaffirmHeading: 'Einwilligung zum Anbieter erneut bestätigen',
            submitCta: 'Jetzt versenden',
            sending: 'Versand läuft…',
            cancelCta: 'Abbrechen',
            sendSuccess: 'Versand protokolliert. Das Paket wurde über Ihren konfigurierten Anbieter übermittelt.',
            sendErrorGeneric: 'Das Paket konnte nicht versendet werden. Bitte prüfen Sie den nachstehenden Fehler und versuchen Sie es erneut.',
            sendErrorAlreadyFinalized: 'Dieser Entwurf wurde bereits für einen erfolgreichen Versand verwendet. Verfassen Sie einen neuen Entwurf, bevor Sie erneut versenden.',
            sendErrorInvalidRecipients: 'Eine oder mehrere Empfängeradressen sind keine gültigen E-Mail-Postfächer.',
            // Timeline
            timelineEmpty: 'Bisher keine Versendungen protokolliert. Nutzen Sie oben „Über konfigurierten Anbieter versenden", um über Ihren kundenseitig betriebenen SMTP- / Microsoft 365- / Google Workspace-Anbieter zu übermitteln.',
            timelineProviderLabel: 'Über Ihren konfigurierten Anbieter versendet',
            timelineSentAtLabel: 'Versendet',
            timelineRecipientLabel: 'Empfänger',
            timelineOutcomeSent: 'Versendet',
            timelineOutcomeFailed: 'Fehlgeschlagen',
            timelineViewDetailsCta: 'Details anzeigen',
            // Authority-response chips
            authorityChipNone: 'Antwort ausstehend',
            authorityChipAcknowledgement: 'Eingangsbestätigung',
            authorityChipAcceptance: 'Annahme',
            authorityChipRejection: 'Ablehnung',
            authorityChipSupplementRequest: 'Aufforderung zur Ergänzung',
            authorityChipNoResponse: 'Keine Rückmeldung',
            // Hard-copy chips
            hardCopyChipNone: 'Keine postalische Nachreichung',
            hardCopyChipPending: 'Verschickt — Zustellung ausstehend',
            hardCopyChipDelivered: 'Zugestellt',
            // Drawer
            drawerTitle: 'Versandeintrag',
            drawerEnvelopeHeading: 'Umschlag',
            drawerEnvelopeFromLabel: 'Von',
            drawerEnvelopeToLabel: 'An',
            drawerEnvelopeCcLabel: 'Cc',
            drawerEnvelopeBccLabel: 'Bcc',
            drawerEnvelopeSubjectLabel: 'Betreff',
            drawerEnvelopeMessageIdLabel: 'Nachrichten-ID',
            drawerOutcomeHeading: 'Ergebnis',
            drawerSnapshotHeading: 'Momentaufnahme der Beweismittelkette',
            drawerSnapshotPackShaLabel: 'Paket-SHA-256 zum Versandzeitpunkt',
            drawerSnapshotDraftVersionLabel: 'Entwurfsversion zum Versandzeitpunkt',
            drawerSnapshotAttachmentLabel: 'Übermittelte ZIP',
            drawerSnapshotAttachmentDownloadCta: 'ZIP herunterladen',
            drawerAuthorityResponseHeading: 'Behördenantwort',
            drawerHardCopyHeading: 'Postalische Nachreichung',
            drawerSentByLabel: 'Versendet von',
            drawerSendIdLabel: 'Versandeintrags-ID',
            drawerSmtpResponseLabel: 'SMTP-Antwort',
            drawerFailureReasonLabel: 'Fehlerursache',
            drawerLatencyLabel: 'Latenz',
            drawerLatencyValue: '{ms} ms',
            drawerAcceptedLabel: 'Akzeptiert',
            drawerRejectedLabel: 'Abgelehnt',
            drawerCloseCta: 'Schließen',
            // Authority-response panel
            authorityRecordCta: 'Antwort erfassen',
            authorityReclassifyCta: 'Neu klassifizieren',
            authorityClassificationLabel: 'Klassifizierung',
            authorityReceivedAtLabel: 'Eingegangen am',
            authorityFreeTextLabel: 'Anmerkungen (optional)',
            authorityEvidenceLabel: 'Nachweisdatei (.eml / .pdf / .png / .jpg — optional)',
            authorityReasonLabel: 'Begründung der Neuklassifizierung',
            authorityHistoryHeading: 'Verlauf der Neuklassifizierungen',
            authorityHistoryEmpty: 'Keine Neuklassifizierungen erfasst.',
            authorityHistoryEntry: '{when} · {previous} → {next} · {who}{reason}',
            authoritySubmitCta: 'Antwort speichern',
            authoritySubmitting: 'Speichern läuft…',
            authorityErrorInvalidMime: 'Dateityp des Nachweises nicht zulässig. Verwenden Sie .eml, .pdf, .png oder .jpg.',
            authorityErrorGeneric: 'Die Antwort konnte nicht gespeichert werden. Bitte erneut versuchen.',
            authorityRecordedAtLabel: 'Erfasst am',
            authorityRecordedByLabel: 'Erfasst von',
            authorityEvidenceFilenameLabel: 'Nachweis',
            authorityEvidenceDownloadCta: 'Beweis herunterladen',
            // Hard-copy panel
            hardCopyRecordCta: 'Postalische Nachreichung protokollieren',
            hardCopyConfirmCta: 'Zustellung bestätigen',
            hardCopyEditNotesCta: 'Zustellnotizen bearbeiten',
            hardCopyPostedAtLabel: 'Verschickt am',
            hardCopyCourierLabel: 'Zustelldienst',
            hardCopyTrackingLabel: 'Sendungsnummer',
            hardCopyRecipientLabel: 'Empfänger laut Etikett',
            hardCopyReceiptLabel: 'Quittungsnachweis (.pdf / .png / .jpg — optional)',
            hardCopyReceiptDownloadCta: 'Quittung herunterladen',
            hardCopyDeliveredAtLabel: 'Zugestellt am',
            hardCopyDeliveryNotesLabel: 'Zustellnotizen (optional)',
            hardCopySubmitCta: 'Nachreichung speichern',
            hardCopySubmitting: 'Speichern läuft…',
            hardCopyErrorInvalidMime: 'Dateityp der Quittung nicht zulässig. Verwenden Sie .pdf, .png oder .jpg.',
            hardCopyErrorGeneric: 'Die Nachreichung konnte nicht gespeichert werden. Bitte erneut versuchen.',
        },
    },
};
//# sourceMappingURL=de.js.map